export const dummyReviews = [
  {
    reviewId: 1,
    gender: "Man",
    orientation: "Queer",
    title: "A review",
    body: "I like it here",
    rating: 4,
    tags: [],
    usefulCount: 7,
    onReviewVote: () => {},
  },
  {
    reviewId: 1,
    gender: "Man",
    orientation: "Queer",
    title: "A review",
    body: "I like it here",
    rating: 4,
    tags: [],
    usefulCount: 7,
    onReviewVote: () => {},
  },
  {
    reviewId: 1,
    title: "A review",
    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam neque massa, tempor eget hendrerit vel, placerat eu ipsum. Sed tincidunt quis magna mattis mattis. Cras scelerisque magna quis justo volutpat ornare. Cras luctus, nisl sed molestie tempus, dui ex feugiat massa, et luctus orci sapien et nunc. In quis nulla eget nunc tincidunt accumsan at consequat sapien. Sed at rutrum neque. Aliquam et venenatis libero, ac consequat lorem. Fusce commodo, nisi eu porttitor semper, nunc enim placerat mauris, ut convallis orci enim ut augue.\nUt condimentum sed ante sed rhoncus. Morbi dictum metus sed odio feugiat iaculis. Vestibulum vestibulum leo ut cursus consequat. Duis vitae eleifend nunc, vel vestibulum sapien. Maecenas nec volutpat nisi. Praesent accumsan ligula id enim egestas luctus. Cras in nulla convallis, venenatis erat sit amet, aliquam nibh.",
    rating: 4,
    tags: [],
    usefulCount: 7,
    onReviewVote: () => {},
  },
  {
    reviewId: 1,
    gender: "Woman",
    orientation: "Lesbian",
    title: "A review!",
    body: "I like it here ghsdjhkfhjsdk hfjks d hfjksd hfjksd fsd.\nfh sdjk hfjksd hfjksd hfjksdh fjksh djk f ghjkhf sdj\n\nf gsjdk frhjjksd hfj kshd fj k",
    rating: 4,
    tags: [{ label: "something" }, { label: "something else" }],
    usefulCount: 7,
    onReviewVote: () => {},
  },
];

export const dummySearchResults = [
  // {
  //   locationId: 99991,
  //   locationName: "Dogpatch Labs",
  //   locationAddress:
  //     "The Chq Building, Custom House Quay, North Wall, Dublin, Ireland",
  //   ratings: [
  //     { who: "Similar identities", rating: 5 },
  //     { who: "All perspectives", rating: 5 },
  //   ],
  //   lat: 53.349341274496226,
  //   lng: -6.247663691001983,
  //   isShaneLocation: true,
  //   isCertified: true,
  //   isPromoted: false,
  //   locationCategory: "Workshops & Training",
  //   mapboxId: "1235999",
  //   tags: [
  //     { label: "accessible" },
  //     { label: "gender-inclusive toilets" },
  //     { label: "lgbtq+ led" },
  //   ],
  //   locationDescription:
  //     "Innovation meets inclusivity at Dogpatch Labs, Ireland's leading startup hub committed to fostering a safe and supportive environment for LGBTQ+ entrepreneurs and communities.",
  // },
  {
    locationId: 99992,
    locationName: "StatrDraft",
    locationAddress: "Online only",
    ratings: [
      { who: "Similar identities", rating: 5 },
      { who: "All perspectives", rating: 5 },
    ],
    onlineAddress: "https://statrdraft.com/",
    isShaneLocation: true,
    isCertified: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "12359991",
    tags: [{ label: "trans friendly" }],
    locationDescription:
      "StatrDraft is a data-driven fantasy football platform offering exciting and engaging game modes like Head-to-Head and Draft Classic",
  },
  {
    locationId: 99993,
    locationName: "Hotel Arpoador",
    locationAddress: "Francisco Otaviano street, 177, Ipanema, Rio de Janeiro, RJ, Brazil",
    ratings: [
      { who: "Similar identities", rating: 5 },
      { who: "All perspectives", rating: 5 },
    ],
    lat: -22.987832425521596,
    lng: -43.19394680537953,
    isShaneLocation: true,
    isCertified: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "12359992",
    tags: [
      {label : 'trans friendly'}
    ],
    locationDescription : "Steps from Ipanema Beach, Hotel Arpoador offers stunning views, warm hospitality, and a commitment to inclusivity with LGBTQ+-friendly policies and practices."
  },
  {
    locationId: 1,
    locationName: "Feel Good Club",
    locationAddress: "26-28 Hilton St, Manchester M1 2EH",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.48172828548748,
    lng: -2.232473007288474,
    isShaneLocation: true,
    color: "blue",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "1235",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 2,
    locationName: "Queer Lit",
    locationAddress: "27 Great Ancoats St, Ancoats, Manchester M4 5AJ",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 53.484187980316236,
    lng: -2.2313792305806044,
    isShaneLocation: true,
    color: "green",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Bookstores & Stationery",
    mapboxId: "765432",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 3,
    locationName: "Psykyi",
    locationAddress: "Deadhouse MCR, Swan Bldg, 20 Swan St, Manchester M4 5JW",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.4854177222025,
    lng: -2.2336621655686812,
    isShaneLocation: true,
    color: "orange",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Hair, Beauty & Tattoos",
    mapboxId: "678",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 4,
    locationName: "Rebel Therapy",
    locationAddress: "43 Middle Hillgate, Stockport SK1 3DG",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.406585638807506,
    lng: -2.154525291005505,
    isShaneLocation: true,
    color: "lightblue",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Mental Health Services",
    mapboxId: "09876543",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 5,
    locationName: "TINY's Barbershop",
    locationAddress: "130 Northenden Rd, Sale M33 3HD",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.42042980996502,
    lng: -2.3060037008038186,
    isShaneLocation: true,
    color: "red",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Hair, Beauty & Tattoos",
    mapboxId: "3456789",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 6,
    locationName: "Northern Cocks Badsecondary1on Club",
    locationAddress: "Moss Side, Manchester M15 5NN",
    ratings: [
      { who: "Similar identities", rating: 3.0 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.46068442852317,
    lng: -2.2477964917370725,
    isShaneLocation: true,
    color: "black",
    isCertified: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "345678987654",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 7,
    locationName: "The Proud Place",
    locationAddress:
      "The Proud Place LGBT+ Community Centre, 49-51 Sidney St, Manchester M1 7HB",
    ratings: [
      { who: "Similar identities", rating: 3.9 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 53.471189888894244,
    lng: -2.2374466044957204,
    isShaneLocation: true,
    color: "purple",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Community Organizations",
    mapboxId: "987678654567",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: 8,
    locationName: "Holier Than Thou",
    locationAddress: "97 Oldham St, Manchester M4 1LW",
    ratings: [
      { who: "Similar identities", rating: 4.1 },
      { who: "All perspectives", rating: 4.5 },
    ],
    lat: 53.48365693547389,
    lng: -2.234314960318255,
    isShaneLocation: true,
    color: "pink",
    isCertified: false,
    isPromoted: false,
    locationCategory: "Hair, Beauty & Tattoos",
    mapboxId: "98767876576",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
  },
  {
    locationId: "item20001",
    locationName: "item20001",
    locationAddress: "item20001",
    ratings: null,
    lat: 53.01257826327792,
    lng: -6.499513133161013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2001",
    tags: [],
    locationDescription:
      " A woman runs towards the cake happily. The teacher writes the road quickly.",
  },
  {
    locationId: "item20002",
    locationName: "item20002",
    locationAddress: "item20002",
    ratings: null,
    lat: 58.6918761784207,
    lng: -0.3477367497225341,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2002",
    tags: [],
    locationDescription:
      " The student looks at the road gracefully. The teacher runs towards the horizon silently. A woman eats the road lazily. The teacher writes the horizon angrily. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item20003",
    locationName: "item20003",
    locationAddress: "item20003",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 0.96 },
    ],
    lat: 58.36340605934727,
    lng: -1.1785242130186067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2003",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription: " The teacher runs towards a tower happily.",
  },
  {
    locationId: "item20004",
    locationName: "item20004",
    locationAddress: "item20004",
    ratings: null,
    lat: 56.478151714703415,
    lng: 1.1819667526196298,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2004",
    tags: [],
    locationDescription:
      " A dog looks at a fence angrily. A dog writes the cake lazily. The cat looks at a fence silently. The man writes the road silently. The man looks at a fence silently.",
  },
  {
    locationId: "item20005",
    locationName: "item20005",
    locationAddress: "item20005",
    ratings: null,
    lat: 53.30386689506829,
    lng: 0.9868122703112903,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2005",
    tags: [],
    locationDescription:
      " A dog writes a fence quickly. A woman eats a tower silently. A dog runs towards a tower lazily. The student eats the road silently.",
  },
  {
    locationId: "item20006",
    locationName: "item20006",
    locationAddress: "item20006",
    ratings: [
      { who: "Similar identities", rating: 1.39 },
      { who: "All perspectives", rating: 3.32 },
    ],
    lat: 51.28344306085636,
    lng: 1.2698085186141395,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2006",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds the horizon happily. A dog looks at the road happily. The cat builds the cake happily. The cat writes a book lazily.",
  },
  {
    locationId: "item20007",
    locationName: "item20007",
    locationAddress: "item20007",
    ratings: [
      { who: "Similar identities", rating: 2.52 },
      { who: "All perspectives", rating: 4.72 },
    ],
    lat: 50.21788093495058,
    lng: -7.9910647775997585,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2007",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat builds the road gracefully. The student jumps over a fence gracefully. A dog eats the cake gracefully. The cat eats the cake angrily. A dog writes a tower quickly.",
  },
  {
    locationId: "item20008",
    locationName: "item20008",
    locationAddress: "item20008",
    ratings: null,
    lat: 53.704325506174,
    lng: -7.234086378975901,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2008",
    tags: [],
    locationDescription:
      " The man looks at the cake lazily. The teacher builds the horizon angrily. A dog looks at a tower quickly.",
  },
  {
    locationId: "item20009",
    locationName: "item20009",
    locationAddress: "item20009",
    ratings: null,
    lat: 54.23947793285893,
    lng: -2.4631256649292093,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2009",
    tags: [],
    locationDescription:
      " The man builds the road angrily. A woman eats the cake angrily.",
  },
  {
    locationId: "item20010",
    locationName: "item20010",
    locationAddress: "item20010",
    ratings: null,
    lat: 60.690089226045124,
    lng: -3.3429061904522452,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2010",
    tags: [],
    locationDescription:
      " A dog writes a tower angrily. The student looks at a tower quickly. A woman jumps over a tower silently. A dog looks at a tower happily. The man builds a fence gracefully.",
  },
  {
    locationId: "item20011",
    locationName: "item20011",
    locationAddress: "item20011",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 4.48 },
    ],
    lat: 58.17415243509135,
    lng: 1.5829135478538863,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2011",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat writes the cake gracefully. A dog writes the horizon gracefully. A dog jumps over a tower happily. The student jumps over a book lazily.",
  },
  {
    locationId: "item20012",
    locationName: "item20012",
    locationAddress: "item20012",
    ratings: null,
    lat: 55.94448469519678,
    lng: -5.11009026846878,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2012",
    tags: [],
    locationDescription: " A dog builds a fence quickly.",
  },
  {
    locationId: "item20013",
    locationName: "item20013",
    locationAddress: "item20013",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 50.94116792678909,
    lng: -6.959880423798827,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2013",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at the road lazily. A woman writes the horizon lazily. The man looks at the horizon angrily. The teacher runs towards a fence happily. The cat looks at the cake lazily.",
  },
  {
    locationId: "item20014",
    locationName: "item20014",
    locationAddress: "item20014",
    ratings: [
      { who: "Similar identities", rating: 1.67 },
      { who: "All perspectives", rating: 1.62 },
    ],
    lat: 54.55434684374669,
    lng: -7.46162038655253,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2014",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher jumps over the cake angrily. A dog eats a tower happily.",
  },
  {
    locationId: "item20015",
    locationName: "item20015",
    locationAddress: "item20015",
    ratings: null,
    lat: 56.44360114325285,
    lng: -2.3055618912459837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2015",
    tags: [],
    locationDescription:
      " The student looks at a tower lazily. The student writes the road silently.",
  },
  {
    locationId: "item20016",
    locationName: "item20016",
    locationAddress: "item20016",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 50.22444749934798,
    lng: -2.7279348198061397,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2016",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog jumps over a book silently. A dog eats a book lazily. The man eats the road happily. The student jumps over a tower gracefully.",
  },
  {
    locationId: "item20017",
    locationName: "item20017",
    locationAddress: "item20017",
    ratings: null,
    lat: 58.32099515913316,
    lng: -4.989763089691661,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2017",
    tags: [],
    locationDescription:
      " The student writes a tower gracefully. The man jumps over a tower silently. A dog looks at the road happily.",
  },
  {
    locationId: "item20018",
    locationName: "item20018",
    locationAddress: "item20018",
    ratings: null,
    lat: 54.28624105478446,
    lng: -3.595932983209531,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2018",
    tags: [],
    locationDescription:
      " A woman looks at the cake silently. A dog jumps over the horizon silently. A dog runs towards the road quickly.",
  },
  {
    locationId: "item20019",
    locationName: "item20019",
    locationAddress: "item20019",
    ratings: null,
    lat: 55.786052809133636,
    lng: 1.6324510279168702,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2019",
    tags: [],
    locationDescription:
      " A dog builds the horizon quickly. A woman builds the road lazily. The teacher jumps over the horizon lazily. The man builds a book lazily.",
  },
  {
    locationId: "item20020",
    locationName: "item20020",
    locationAddress: "item20020",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 2.76 },
    ],
    lat: 55.12765421515857,
    lng: 0.9076167750492772,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2020",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher jumps over the cake lazily. The teacher jumps over a tower angrily. The teacher eats the cake gracefully. The student runs towards a fence lazily. The student writes a tower happily.",
  },
  {
    locationId: "item20021",
    locationName: "item20021",
    locationAddress: "item20021",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 50.00051886725678,
    lng: -5.188422984884269,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2021",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog builds the road quickly. The cat looks at the road gracefully. A dog builds a tower silently.",
  },
  {
    locationId: "item20022",
    locationName: "item20022",
    locationAddress: "item20022",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 51.26391378306361,
    lng: 0.10256004957751053,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2022",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The cat looks at a book silently.",
  },
  {
    locationId: "item20023",
    locationName: "item20023",
    locationAddress: "item20023",
    ratings: null,
    lat: 55.52270743978354,
    lng: -3.332965525622117,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2023",
    tags: [],
    locationDescription:
      " The student runs towards a fence silently. The teacher writes a tower happily. The man writes a tower lazily.",
  },
  {
    locationId: "item20024",
    locationName: "item20024",
    locationAddress: "item20024",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 59.173381553560496,
    lng: -4.87717769434154,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2024",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a tower angrily. The man writes a book angrily. The cat writes the cake lazily. A dog eats a fence angrily.",
  },
  {
    locationId: "item20025",
    locationName: "item20025",
    locationAddress: "item20025",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 3.19 },
    ],
    lat: 57.72395653795689,
    lng: 0.1358334089298623,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2025",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats a tower happily. The man jumps over the cake happily. A dog runs towards a fence lazily. The teacher runs towards a fence gracefully. The cat looks at a tower silently.",
  },
  {
    locationId: "item20026",
    locationName: "item20026",
    locationAddress: "item20026",
    ratings: [
      { who: "Similar identities", rating: 3.07 },
      { who: "All perspectives", rating: 3.76 },
    ],
    lat: 55.18648909214015,
    lng: -5.522652859747749,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2026",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds the horizon silently. The student builds a book angrily. The teacher jumps over the horizon gracefully. The teacher runs towards the road silently.",
  },
  {
    locationId: "item20027",
    locationName: "item20027",
    locationAddress: "item20027",
    ratings: null,
    lat: 57.70344650531264,
    lng: -2.5235469739907215,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2027",
    tags: [],
    locationDescription:
      " A woman builds the horizon quickly. A woman runs towards the horizon lazily.",
  },
  {
    locationId: "item20028",
    locationName: "item20028",
    locationAddress: "item20028",
    ratings: null,
    lat: 59.332781343812364,
    lng: -1.6217766792563904,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2028",
    tags: [],
    locationDescription:
      " The cat builds a fence quickly. The cat jumps over the cake angrily.",
  },
  {
    locationId: "item20029",
    locationName: "item20029",
    locationAddress: "item20029",
    ratings: null,
    lat: 60.629557600456145,
    lng: -4.935986552120395,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2029",
    tags: [],
    locationDescription:
      " The student looks at the cake lazily. The man jumps over a fence quickly. The man jumps over a fence angrily. The cat jumps over a book silently. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item20030",
    locationName: "item20030",
    locationAddress: "item20030",
    ratings: [
      { who: "Similar identities", rating: 3.63 },
      { who: "All perspectives", rating: 3.69 },
    ],
    lat: 56.649232134229415,
    lng: -5.737220876925797,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2030",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds the horizon gracefully. A dog eats a tower lazily. The man runs towards a book gracefully. A woman eats the road silently.",
  },
  {
    locationId: "item20031",
    locationName: "item20031",
    locationAddress: "item20031",
    ratings: [
      { who: "Similar identities", rating: 1.69 },
      { who: "All perspectives", rating: 0.88 },
    ],
    lat: 50.103863967383994,
    lng: -4.321256189701286,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2031",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The student builds a tower angrily. A woman jumps over a fence lazily.",
  },
  {
    locationId: "item20032",
    locationName: "item20032",
    locationAddress: "item20032",
    ratings: null,
    lat: 52.947987256537424,
    lng: -1.138505718082068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2032",
    tags: [],
    locationDescription:
      " A dog jumps over a book gracefully. The teacher eats a book lazily. A woman looks at the road gracefully. The man builds a tower lazily. The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item20033",
    locationName: "item20033",
    locationAddress: "item20033",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 51.23958360171603,
    lng: -3.843123353337475,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2033",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man runs towards a book angrily. The cat looks at a fence lazily.",
  },
  {
    locationId: "item20034",
    locationName: "item20034",
    locationAddress: "item20034",
    ratings: null,
    lat: 52.83004510675202,
    lng: -0.2819766644136763,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2034",
    tags: [],
    locationDescription:
      " The teacher writes the cake quickly. The man runs towards a fence silently. A woman runs towards a book happily.",
  },
  {
    locationId: "item20035",
    locationName: "item20035",
    locationAddress: "item20035",
    ratings: [
      { who: "Similar identities", rating: 1.28 },
      { who: "All perspectives", rating: 1.89 },
    ],
    lat: 57.365381109451604,
    lng: -1.3165461587851777,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2035",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man jumps over a tower silently. The student eats the road happily. A dog jumps over a fence gracefully. The teacher eats a fence gracefully. The cat builds the road quickly.",
  },
  {
    locationId: "item20036",
    locationName: "item20036",
    locationAddress: "item20036",
    ratings: [
      { who: "Similar identities", rating: 5.0 },
      { who: "All perspectives", rating: 0.3 },
    ],
    lat: 59.311884906133216,
    lng: -6.614437834246406,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2036",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher writes the horizon gracefully. The cat jumps over the road angrily. A woman jumps over the horizon gracefully. The teacher looks at the cake quickly.",
  },
  {
    locationId: "item20037",
    locationName: "item20037",
    locationAddress: "item20037",
    ratings: null,
    lat: 54.43067266122661,
    lng: -2.388643779076503,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2037",
    tags: [],
    locationDescription:
      " A woman builds the road silently. The teacher jumps over a tower lazily.",
  },
  {
    locationId: "item20038",
    locationName: "item20038",
    locationAddress: "item20038",
    ratings: [
      { who: "Similar identities", rating: 5.0 },
      { who: "All perspectives", rating: 2.31 },
    ],
    lat: 50.39716060292828,
    lng: 0.07418691185243098,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2038",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " A dog jumps over a book quickly.",
  },
  {
    locationId: "item20039",
    locationName: "item20039",
    locationAddress: "item20039",
    ratings: [
      { who: "Similar identities", rating: 0.52 },
      { who: "All perspectives", rating: 4.34 },
    ],
    lat: 50.46636887871592,
    lng: -4.123758103050215,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2039",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher builds a tower angrily. The cat jumps over a book lazily.",
  },
  {
    locationId: "item20040",
    locationName: "item20040",
    locationAddress: "item20040",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 59.50993999677806,
    lng: 1.2923743289078669,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2040",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student eats the horizon silently. The teacher builds a tower lazily.",
  },
  {
    locationId: "item20041",
    locationName: "item20041",
    locationAddress: "item20041",
    ratings: [
      { who: "Similar identities", rating: 3.17 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 58.054931893154915,
    lng: -6.313775304374738,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2041",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over a tower silently. The teacher writes the horizon happily.",
  },
  {
    locationId: "item20042",
    locationName: "item20042",
    locationAddress: "item20042",
    ratings: [
      { who: "Similar identities", rating: 4.54 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 50.15357969706207,
    lng: -6.444257802302681,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2042",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats a tower angrily. The student looks at the cake lazily.",
  },
  {
    locationId: "item20043",
    locationName: "item20043",
    locationAddress: "item20043",
    ratings: null,
    lat: 60.26882338360008,
    lng: -2.9228710177669175,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2043",
    tags: [],
    locationDescription:
      " The teacher looks at a book silently. A dog jumps over a fence gracefully. A dog builds the horizon quickly. A dog runs towards the horizon silently.",
  },
  {
    locationId: "item20044",
    locationName: "item20044",
    locationAddress: "item20044",
    ratings: [
      { who: "Similar identities", rating: 0.23 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 60.07027810335227,
    lng: -6.373612757176291,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2044",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student builds the road silently. The teacher jumps over the horizon gracefully. The man builds the road silently. The cat builds a book happily. A dog builds a book lazily.",
  },
  {
    locationId: "item20045",
    locationName: "item20045",
    locationAddress: "item20045",
    ratings: null,
    lat: 56.15952856804106,
    lng: -2.341941693656132,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2045",
    tags: [],
    locationDescription:
      " The man writes a tower gracefully. A woman jumps over the road lazily. A woman eats a fence gracefully. A woman writes the cake silently. The student writes a fence lazily.",
  },
  {
    locationId: "item20046",
    locationName: "item20046",
    locationAddress: "item20046",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 3.69 },
    ],
    lat: 60.322086497137484,
    lng: 0.9577834256303586,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2046",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a book happily. The student writes the cake gracefully. The cat builds the road happily.",
  },
  {
    locationId: "item20047",
    locationName: "item20047",
    locationAddress: "item20047",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 4.13 },
    ],
    lat: 51.297083816383385,
    lng: 1.1569763272402067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2047",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a fence quickly. The man writes a tower quickly. The teacher eats a fence gracefully. A woman looks at a book silently. The man jumps over the road happily.",
  },
  {
    locationId: "item20048",
    locationName: "item20048",
    locationAddress: "item20048",
    ratings: null,
    lat: 60.08527779615197,
    lng: -3.185728241966089,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2048",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon gracefully. A dog eats a tower silently.",
  },
  {
    locationId: "item20049",
    locationName: "item20049",
    locationAddress: "item20049",
    ratings: null,
    lat: 55.02858834014279,
    lng: -7.820871334315067,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2049",
    tags: [],
    locationDescription:
      " A dog jumps over a book angrily. The cat builds a fence quickly. A dog looks at a tower silently. A woman builds the road happily. A woman builds a book angrily.",
  },
  {
    locationId: "item20050",
    locationName: "item20050",
    locationAddress: "item20050",
    ratings: [
      { who: "Similar identities", rating: 4.43 },
      { who: "All perspectives", rating: 3.48 },
    ],
    lat: 51.61727816948142,
    lng: 0.7286049683453957,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2050",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man eats the road quickly. The man eats a book lazily. A woman runs towards a book happily. The man eats a fence quickly. The man jumps over a book quickly.",
  },
  {
    locationId: "item20051",
    locationName: "item20051",
    locationAddress: "item20051",
    ratings: null,
    lat: 60.777225654806074,
    lng: -1.8267531629307276,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2051",
    tags: [],
    locationDescription:
      " The teacher builds a fence angrily. A woman builds a book gracefully. A woman jumps over a book lazily. A woman looks at a fence gracefully. The cat eats the horizon happily.",
  },
  {
    locationId: "item20052",
    locationName: "item20052",
    locationAddress: "item20052",
    ratings: [
      { who: "Similar identities", rating: 1.63 },
      { who: "All perspectives", rating: 2.19 },
    ],
    lat: 58.34909833541252,
    lng: -6.897362250773369,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2052",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards a book lazily. The man writes the cake lazily. A dog jumps over a fence silently. The student jumps over a book happily.",
  },
  {
    locationId: "item20053",
    locationName: "item20053",
    locationAddress: "item20053",
    ratings: null,
    lat: 52.159309140235955,
    lng: -3.104276998632039,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2053",
    tags: [],
    locationDescription: " The man jumps over the road silently.",
  },
  {
    locationId: "item20054",
    locationName: "item20054",
    locationAddress: "item20054",
    ratings: [
      { who: "Similar identities", rating: 2.01 },
      { who: "All perspectives", rating: 0.96 },
    ],
    lat: 56.79347474656124,
    lng: -3.546805910484795,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2054",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a tower happily. A woman jumps over a book happily.",
  },
  {
    locationId: "item20055",
    locationName: "item20055",
    locationAddress: "item20055",
    ratings: null,
    lat: 50.39862103627665,
    lng: -1.885266278474008,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2055",
    tags: [],
    locationDescription:
      " The cat builds a tower angrily. The teacher jumps over a book happily. The man looks at the cake quickly. The teacher builds the horizon lazily. A woman jumps over a book happily.",
  },
  {
    locationId: "item20056",
    locationName: "item20056",
    locationAddress: "item20056",
    ratings: null,
    lat: 57.74889818278034,
    lng: -2.244033757732125,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2056",
    tags: [],
    locationDescription:
      " A dog looks at the road angrily. A dog writes a fence gracefully.",
  },
  {
    locationId: "item20057",
    locationName: "item20057",
    locationAddress: "item20057",
    ratings: null,
    lat: 53.25309169394588,
    lng: 0.396996953764269,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2057",
    tags: [],
    locationDescription: " The teacher builds a book gracefully.",
  },
  {
    locationId: "item20058",
    locationName: "item20058",
    locationAddress: "item20058",
    ratings: [
      { who: "Similar identities", rating: 4.29 },
      { who: "All perspectives", rating: 4.63 },
    ],
    lat: 59.08838249983728,
    lng: 1.6031003574069604,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2058",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman jumps over the horizon silently. The student runs towards a tower angrily. A woman writes the horizon silently.",
  },
  {
    locationId: "item20059",
    locationName: "item20059",
    locationAddress: "item20059",
    ratings: null,
    lat: 51.288485366599204,
    lng: -1.7753164323725823,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2059",
    tags: [],
    locationDescription: " The man writes a fence lazily.",
  },
  {
    locationId: "item20060",
    locationName: "item20060",
    locationAddress: "item20060",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 60.146756830463914,
    lng: -0.6577195596851109,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2060",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher jumps over the road angrily. A woman builds the horizon quickly. A woman runs towards the horizon gracefully. A dog jumps over the cake silently.",
  },
  {
    locationId: "item20061",
    locationName: "item20061",
    locationAddress: "item20061",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 3.25 },
    ],
    lat: 59.01759672145607,
    lng: -1.6498695331228062,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2061",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog writes a fence happily.",
  },
  {
    locationId: "item20062",
    locationName: "item20062",
    locationAddress: "item20062",
    ratings: [
      { who: "Similar identities", rating: 4.73 },
      { who: "All perspectives", rating: 3.56 },
    ],
    lat: 49.992709958694306,
    lng: -5.39307886980176,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2062",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher builds a fence gracefully. The man looks at the horizon gracefully.",
  },
  {
    locationId: "item20063",
    locationName: "item20063",
    locationAddress: "item20063",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 52.0971174282572,
    lng: 0.9258903502495333,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2063",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes the horizon lazily. The student eats a book silently. The teacher runs towards a tower silently.",
  },
  {
    locationId: "item20064",
    locationName: "item20064",
    locationAddress: "item20064",
    ratings: null,
    lat: 56.205407853273215,
    lng: -8.373028060299653,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2064",
    tags: [],
    locationDescription:
      " A woman eats the cake lazily. The man runs towards the horizon angrily. A dog builds the cake lazily.",
  },
  {
    locationId: "item20065",
    locationName: "item20065",
    locationAddress: "item20065",
    ratings: [
      { who: "Similar identities", rating: 1.72 },
      { who: "All perspectives", rating: 2.36 },
    ],
    lat: 54.26147192001682,
    lng: -2.3618392814910356,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2065",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man builds the road lazily. A dog writes the road angrily.",
  },
  {
    locationId: "item20066",
    locationName: "item20066",
    locationAddress: "item20066",
    ratings: null,
    lat: 51.16134372643959,
    lng: 1.0030365707740234,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2066",
    tags: [],
    locationDescription:
      " The student writes a tower gracefully. A woman builds the horizon lazily. A woman writes a book angrily.",
  },
  {
    locationId: "item20067",
    locationName: "item20067",
    locationAddress: "item20067",
    ratings: [
      { who: "Similar identities", rating: 0.68 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 55.29755193127366,
    lng: -8.494951736207177,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2067",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student builds a fence lazily. A dog eats the horizon gracefully. The student writes the road silently.",
  },
  {
    locationId: "item20068",
    locationName: "item20068",
    locationAddress: "item20068",
    ratings: null,
    lat: 60.43317640902352,
    lng: -5.423725189698849,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2068",
    tags: [],
    locationDescription: " The student runs towards the road gracefully.",
  },
  {
    locationId: "item20069",
    locationName: "item20069",
    locationAddress: "item20069",
    ratings: null,
    lat: 55.61346760016714,
    lng: -7.9527600411465285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2069",
    tags: [],
    locationDescription: " A dog runs towards the horizon gracefully.",
  },
  {
    locationId: "item20070",
    locationName: "item20070",
    locationAddress: "item20070",
    ratings: [
      { who: "Similar identities", rating: 1.92 },
      { who: "All perspectives", rating: 1.82 },
    ],
    lat: 56.60100840231785,
    lng: 1.222621564682422,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2070",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog jumps over the cake lazily. A woman jumps over a tower lazily. A dog runs towards the cake gracefully. The man runs towards the horizon angrily. The teacher looks at the road silently.",
  },
  {
    locationId: "item20071",
    locationName: "item20071",
    locationAddress: "item20071",
    ratings: null,
    lat: 50.98290960187941,
    lng: -8.297284466111574,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2071",
    tags: [],
    locationDescription:
      " The teacher looks at a book quickly. The cat runs towards a book quickly. The man eats a tower happily. A woman writes the cake angrily.",
  },
  {
    locationId: "item20072",
    locationName: "item20072",
    locationAddress: "item20072",
    ratings: [
      { who: "Similar identities", rating: 4.75 },
      { who: "All perspectives", rating: 3.84 },
    ],
    lat: 51.92410567861094,
    lng: 0.15956303194446164,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2072",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student runs towards a fence quickly. A woman jumps over a tower angrily.",
  },
  {
    locationId: "item20073",
    locationName: "item20073",
    locationAddress: "item20073",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 55.14915461113896,
    lng: -3.6307162874662477,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2073",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes the horizon happily. The man writes the horizon quickly. The cat runs towards the road angrily.",
  },
  {
    locationId: "item20074",
    locationName: "item20074",
    locationAddress: "item20074",
    ratings: [
      { who: "Similar identities", rating: 4.63 },
      { who: "All perspectives", rating: 3.25 },
    ],
    lat: 57.537753582559965,
    lng: -1.5935113553325664,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2074",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher writes the horizon angrily. The student jumps over the horizon lazily. The student eats a fence lazily.",
  },
  {
    locationId: "item20075",
    locationName: "item20075",
    locationAddress: "item20075",
    ratings: null,
    lat: 59.815192360043056,
    lng: -2.1462244644013664,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2075",
    tags: [],
    locationDescription:
      " The cat looks at a fence quickly. The man eats the road quickly. A dog looks at a book angrily. The man runs towards the horizon silently. The teacher runs towards the road silently.",
  },
  {
    locationId: "item20076",
    locationName: "item20076",
    locationAddress: "item20076",
    ratings: null,
    lat: 50.70638453468952,
    lng: -2.086865948550729,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2076",
    tags: [],
    locationDescription:
      " The man builds the cake gracefully. The teacher writes the horizon lazily. The student builds the road lazily.",
  },
  {
    locationId: "item20077",
    locationName: "item20077",
    locationAddress: "item20077",
    ratings: null,
    lat: 58.45642193527028,
    lng: -4.0030159619809185,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2077",
    tags: [],
    locationDescription:
      " The man eats a tower silently. The student looks at a fence lazily. A dog builds a book quickly. The cat writes a fence happily. A woman runs towards a fence silently.",
  },
  {
    locationId: "item20078",
    locationName: "item20078",
    locationAddress: "item20078",
    ratings: null,
    lat: 51.129564269893876,
    lng: -2.273328647225071,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2078",
    tags: [],
    locationDescription:
      " The student looks at a book quickly. The cat jumps over the road lazily.",
  },
  {
    locationId: "item20079",
    locationName: "item20079",
    locationAddress: "item20079",
    ratings: null,
    lat: 57.65905143346229,
    lng: 1.3471216308402365,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2079",
    tags: [],
    locationDescription:
      " The man builds a tower happily. The cat builds a tower silently. A dog builds the horizon gracefully. A woman builds the cake gracefully. The man looks at the road silently.",
  },
  {
    locationId: "item20080",
    locationName: "item20080",
    locationAddress: "item20080",
    ratings: null,
    lat: 53.00780680751929,
    lng: -2.431943949865995,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2080",
    tags: [],
    locationDescription:
      " A woman builds a fence angrily. A woman runs towards the cake silently.",
  },
  {
    locationId: "item20081",
    locationName: "item20081",
    locationAddress: "item20081",
    ratings: null,
    lat: 56.15460698138923,
    lng: 0.2637475998770338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2081",
    tags: [],
    locationDescription:
      " The teacher looks at a book happily. A woman builds a fence silently.",
  },
  {
    locationId: "item20082",
    locationName: "item20082",
    locationAddress: "item20082",
    ratings: [
      { who: "Similar identities", rating: 4.43 },
      { who: "All perspectives", rating: 2.09 },
    ],
    lat: 56.63716256454454,
    lng: -6.3359195655198,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2082",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A woman eats a fence happily. The man looks at the road happily. A dog runs towards a book quickly. The cat builds the cake quickly.",
  },
  {
    locationId: "item20083",
    locationName: "item20083",
    locationAddress: "item20083",
    ratings: null,
    lat: 57.036841436092416,
    lng: -7.677423698378621,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2083",
    tags: [],
    locationDescription:
      " The teacher builds a tower quickly. The man builds the road silently.",
  },
  {
    locationId: "item20084",
    locationName: "item20084",
    locationAddress: "item20084",
    ratings: null,
    lat: 58.299881511798475,
    lng: -1.8314427967976048,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2084",
    tags: [],
    locationDescription:
      " The teacher jumps over a tower angrily. The cat jumps over a tower silently.",
  },
  {
    locationId: "item20085",
    locationName: "item20085",
    locationAddress: "item20085",
    ratings: null,
    lat: 59.55129543026474,
    lng: -2.886897004701442,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2085",
    tags: [],
    locationDescription: " The student looks at a fence angrily.",
  },
  {
    locationId: "item20086",
    locationName: "item20086",
    locationAddress: "item20086",
    ratings: null,
    lat: 60.65287589819535,
    lng: -4.17144159984285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2086",
    tags: [],
    locationDescription:
      " The man writes a tower angrily. The cat eats a tower gracefully. The cat runs towards the cake quickly. A woman jumps over a book angrily. The student writes a book angrily.",
  },
  {
    locationId: "item20087",
    locationName: "item20087",
    locationAddress: "item20087",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 0.84 },
    ],
    lat: 60.09924478492412,
    lng: -3.711204307845927,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2087",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog writes a book happily. A woman eats the horizon silently. The student runs towards the road happily. The student looks at a tower gracefully. A dog jumps over the horizon lazily.",
  },
  {
    locationId: "item20088",
    locationName: "item20088",
    locationAddress: "item20088",
    ratings: [
      { who: "Similar identities", rating: 0.47 },
      { who: "All perspectives", rating: 0.63 },
    ],
    lat: 53.06221431084982,
    lng: -7.3317669702481005,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2088",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at a fence angrily. The teacher eats a fence silently. A dog writes the cake lazily. A woman builds the road gracefully. A dog jumps over the cake angrily.",
  },
  {
    locationId: "item20089",
    locationName: "item20089",
    locationAddress: "item20089",
    ratings: null,
    lat: 51.47739464104938,
    lng: -5.354896359669651,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2089",
    tags: [],
    locationDescription:
      " The man builds the cake lazily. The cat eats a book quickly. The teacher looks at a book quickly. The student looks at a fence happily. The teacher looks at the horizon lazily.",
  },
  {
    locationId: "item20090",
    locationName: "item20090",
    locationAddress: "item20090",
    ratings: [
      { who: "Similar identities", rating: 1.05 },
      { who: "All perspectives", rating: 4.2 },
    ],
    lat: 53.65797982536325,
    lng: -4.062461669056201,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2090",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman jumps over a book happily.",
  },
  {
    locationId: "item20091",
    locationName: "item20091",
    locationAddress: "item20091",
    ratings: [
      { who: "Similar identities", rating: 4.33 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 59.62136911207754,
    lng: 0.28656821207655625,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2091",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at the horizon angrily. The teacher eats the cake gracefully. A woman writes the road silently.",
  },
  {
    locationId: "item20092",
    locationName: "item20092",
    locationAddress: "item20092",
    ratings: null,
    lat: 59.43056917847087,
    lng: 0.41221131388166654,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2092",
    tags: [],
    locationDescription:
      " The student eats the road gracefully. A woman runs towards a book lazily. The student eats the cake quickly. The man eats the road lazily. A woman jumps over the horizon angrily.",
  },
  {
    locationId: "item20093",
    locationName: "item20093",
    locationAddress: "item20093",
    ratings: null,
    lat: 59.29095994429616,
    lng: -8.240487716839171,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2093",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence happily. The cat jumps over the road gracefully. The teacher builds a tower happily.",
  },
  {
    locationId: "item20094",
    locationName: "item20094",
    locationAddress: "item20094",
    ratings: [
      { who: "Similar identities", rating: 0.85 },
      { who: "All perspectives", rating: 4.07 },
    ],
    lat: 52.30635341034253,
    lng: -8.022264426235216,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2094",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes a tower lazily. The student runs towards a fence angrily.",
  },
  {
    locationId: "item20095",
    locationName: "item20095",
    locationAddress: "item20095",
    ratings: null,
    lat: 59.54574623673133,
    lng: -0.2098157482549805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2095",
    tags: [],
    locationDescription:
      " The cat runs towards the road silently. A dog writes the cake gracefully. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item20096",
    locationName: "item20096",
    locationAddress: "item20096",
    ratings: [
      { who: "Similar identities", rating: 0.76 },
      { who: "All perspectives", rating: 3.47 },
    ],
    lat: 55.536326611440224,
    lng: -3.8534806342888803,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2096",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes a tower silently. A woman looks at a book lazily.",
  },
  {
    locationId: "item20097",
    locationName: "item20097",
    locationAddress: "item20097",
    ratings: null,
    lat: 50.82556062937088,
    lng: -6.72778440886722,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2097",
    tags: [],
    locationDescription:
      " The cat builds the horizon happily. The teacher writes a tower quickly.",
  },
  {
    locationId: "item20098",
    locationName: "item20098",
    locationAddress: "item20098",
    ratings: [
      { who: "Similar identities", rating: 4.16 },
      { who: "All perspectives", rating: 3.08 },
    ],
    lat: 52.477121862096304,
    lng: 0.9196681136071145,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2098",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The man writes a fence angrily. The man builds a fence quickly. A dog eats the horizon quickly. The man eats the road happily. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item20099",
    locationName: "item20099",
    locationAddress: "item20099",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 50.155388986413776,
    lng: -7.778297115126271,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2099",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman eats the horizon quickly. The cat builds a book happily. The cat runs towards the cake lazily. A dog jumps over a fence quickly. The cat runs towards a tower happily.",
  },
  {
    locationId: "item20100",
    locationName: "item20100",
    locationAddress: "item20100",
    ratings: [
      { who: "Similar identities", rating: 3.17 },
      { who: "All perspectives", rating: 0.25 },
    ],
    lat: 54.92289053630906,
    lng: -2.6332627526053543,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2100",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over the horizon lazily. The cat looks at a book angrily. A dog writes the horizon quickly. A dog looks at the road silently. The man builds a book gracefully.",
  },
  {
    locationId: "item20101",
    locationName: "item20101",
    locationAddress: "item20101",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 2.96 },
    ],
    lat: 53.07007286071466,
    lng: -4.713594876161741,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2101",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman looks at a fence quickly.",
  },
  {
    locationId: "item20102",
    locationName: "item20102",
    locationAddress: "item20102",
    ratings: [
      { who: "Similar identities", rating: 2.35 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 56.732580776426346,
    lng: -7.083187026560067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2102",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The cat builds the horizon angrily. The cat builds a fence gracefully. The student looks at a book happily. The man jumps over a book happily. The teacher builds a tower quickly.",
  },
  {
    locationId: "item20103",
    locationName: "item20103",
    locationAddress: "item20103",
    ratings: [
      { who: "Similar identities", rating: 0.87 },
      { who: "All perspectives", rating: 1.45 },
    ],
    lat: 57.5806822067184,
    lng: -7.362537218917752,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2103",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student jumps over a fence happily. A woman jumps over the cake silently.",
  },
  {
    locationId: "item20104",
    locationName: "item20104",
    locationAddress: "item20104",
    ratings: [
      { who: "Similar identities", rating: 0.7 },
      { who: "All perspectives", rating: 4.76 },
    ],
    lat: 52.944871707254066,
    lng: 1.726032850357571,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2104",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student writes the horizon quickly. The cat writes a fence gracefully. The cat builds a tower gracefully. A woman builds the horizon angrily. The student eats a tower silently.",
  },
  {
    locationId: "item20105",
    locationName: "item20105",
    locationAddress: "item20105",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 4.97 },
    ],
    lat: 53.69721482288844,
    lng: 0.8829035741136924,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2105",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man jumps over a fence happily. A dog builds a fence happily. The teacher runs towards a tower angrily. A dog runs towards a fence lazily. A woman looks at the horizon happily.",
  },
  {
    locationId: "item20106",
    locationName: "item20106",
    locationAddress: "item20106",
    ratings: null,
    lat: 59.22628950591261,
    lng: -0.3034245713955066,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2106",
    tags: [],
    locationDescription:
      " A dog eats the cake lazily. The man builds a fence angrily.",
  },
  {
    locationId: "item20107",
    locationName: "item20107",
    locationAddress: "item20107",
    ratings: [
      { who: "Similar identities", rating: 4.88 },
      { who: "All perspectives", rating: 3.42 },
    ],
    lat: 60.87206848208382,
    lng: -4.134255749953133,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2107",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher eats a book silently. The student eats the horizon gracefully. The cat looks at the road lazily.",
  },
  {
    locationId: "item20108",
    locationName: "item20108",
    locationAddress: "item20108",
    ratings: null,
    lat: 52.09028016127501,
    lng: -2.6674129272487246,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2108",
    tags: [],
    locationDescription:
      " The teacher jumps over a book quickly. The teacher jumps over the cake quickly. The cat runs towards a tower happily.",
  },
  {
    locationId: "item20109",
    locationName: "item20109",
    locationAddress: "item20109",
    ratings: [
      { who: "Similar identities", rating: 3.5 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 56.224861895644274,
    lng: -1.5002378525044486,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2109",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards a fence lazily. The teacher builds the road gracefully. The student looks at the road happily. The student writes the horizon gracefully.",
  },
  {
    locationId: "item20110",
    locationName: "item20110",
    locationAddress: "item20110",
    ratings: null,
    lat: 59.59234125960603,
    lng: -0.9563983869431398,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2110",
    tags: [],
    locationDescription:
      " A dog looks at a book quickly. The cat runs towards a fence silently. A dog eats the road silently. The teacher writes a book silently.",
  },
  {
    locationId: "item20111",
    locationName: "item20111",
    locationAddress: "item20111",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 56.22840209687478,
    lng: -6.064844651602124,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2111",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student builds a tower happily. A dog builds the horizon happily. A woman builds the horizon silently. A dog eats a tower lazily. The cat runs towards a fence lazily.",
  },
  {
    locationId: "item20112",
    locationName: "item20112",
    locationAddress: "item20112",
    ratings: [
      { who: "Similar identities", rating: 3.0 },
      { who: "All perspectives", rating: 4.54 },
    ],
    lat: 50.90373934673008,
    lng: -4.948242425330869,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2112",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher writes a book happily. The student writes the horizon lazily.",
  },
  {
    locationId: "item20113",
    locationName: "item20113",
    locationAddress: "item20113",
    ratings: null,
    lat: 59.68477151116359,
    lng: 0.6916713378748582,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2113",
    tags: [],
    locationDescription:
      " The student eats a fence lazily. A dog looks at the cake gracefully.",
  },
  {
    locationId: "item20114",
    locationName: "item20114",
    locationAddress: "item20114",
    ratings: [
      { who: "Similar identities", rating: 3.26 },
      { who: "All perspectives", rating: 2.87 },
    ],
    lat: 60.855048775937746,
    lng: -0.8760913213287767,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2114",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription: " The teacher eats a book angrily.",
  },
  {
    locationId: "item20115",
    locationName: "item20115",
    locationAddress: "item20115",
    ratings: null,
    lat: 51.37995761369042,
    lng: -7.054628310373382,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2115",
    tags: [],
    locationDescription:
      " The man builds a book lazily. The student jumps over the horizon lazily. The student jumps over a book happily. A woman looks at the cake angrily.",
  },
  {
    locationId: "item20116",
    locationName: "item20116",
    locationAddress: "item20116",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 4.33 },
    ],
    lat: 58.704219856971825,
    lng: -6.08889505532,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2116",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman looks at the cake lazily. The teacher eats a book happily. The cat looks at the horizon happily.",
  },
  {
    locationId: "item20117",
    locationName: "item20117",
    locationAddress: "item20117",
    ratings: null,
    lat: 60.71542354136631,
    lng: -3.0816480450828,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2117",
    tags: [],
    locationDescription:
      " A dog jumps over a fence gracefully. A woman runs towards a tower quickly.",
  },
  {
    locationId: "item20118",
    locationName: "item20118",
    locationAddress: "item20118",
    ratings: [
      { who: "Similar identities", rating: 0.21 },
      { who: "All perspectives", rating: 0.45 },
    ],
    lat: 60.49574628162016,
    lng: -6.965268473905532,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2118",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the horizon silently. The man looks at the horizon lazily. The man builds the road happily. A dog builds a book gracefully. A dog writes a book lazily.",
  },
  {
    locationId: "item20119",
    locationName: "item20119",
    locationAddress: "item20119",
    ratings: null,
    lat: 59.84953797353384,
    lng: -6.581538901719277,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2119",
    tags: [],
    locationDescription:
      " A dog jumps over the road angrily. A dog writes the cake quickly. The teacher writes a book silently.",
  },
  {
    locationId: "item20120",
    locationName: "item20120",
    locationAddress: "item20120",
    ratings: [
      { who: "Similar identities", rating: 3.93 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 53.91369516794013,
    lng: -1.7642933487032613,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2120",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " A woman eats the cake angrily.",
  },
  {
    locationId: "item20121",
    locationName: "item20121",
    locationAddress: "item20121",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 4.0 },
    ],
    lat: 56.80491046704899,
    lng: 1.1057249966550504,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2121",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over the road angrily. The cat builds a book gracefully. The teacher builds a tower quickly.",
  },
  {
    locationId: "item20122",
    locationName: "item20122",
    locationAddress: "item20122",
    ratings: null,
    lat: 50.54417084995074,
    lng: -4.822465322447997,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2122",
    tags: [],
    locationDescription: " A dog looks at a tower angrily.",
  },
  {
    locationId: "item20123",
    locationName: "item20123",
    locationAddress: "item20123",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 3.3 },
    ],
    lat: 57.83942916863488,
    lng: -3.1167613170435704,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2123",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student runs towards a tower quickly. The cat builds the road lazily. A woman runs towards a book lazily.",
  },
  {
    locationId: "item20124",
    locationName: "item20124",
    locationAddress: "item20124",
    ratings: null,
    lat: 51.003869385610365,
    lng: -1.0901532338085547,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2124",
    tags: [],
    locationDescription:
      " A woman runs towards a fence angrily. The student writes the road angrily. The teacher writes a book silently. The man jumps over the road angrily. A woman jumps over the road quickly.",
  },
  {
    locationId: "item20125",
    locationName: "item20125",
    locationAddress: "item20125",
    ratings: null,
    lat: 54.523289167070516,
    lng: -3.2550222906016115,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2125",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. A dog runs towards a book gracefully.",
  },
  {
    locationId: "item20126",
    locationName: "item20126",
    locationAddress: "item20126",
    ratings: null,
    lat: 51.64380997285359,
    lng: -1.9874724382256845,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2126",
    tags: [],
    locationDescription:
      " The cat runs towards the cake happily. The cat builds the horizon gracefully. The man builds a tower silently.",
  },
  {
    locationId: "item20127",
    locationName: "item20127",
    locationAddress: "item20127",
    ratings: null,
    lat: 54.84588185071905,
    lng: 0.7956096669979438,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2127",
    tags: [],
    locationDescription:
      " A woman eats a tower lazily. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item20128",
    locationName: "item20128",
    locationAddress: "item20128",
    ratings: null,
    lat: 58.26953539331512,
    lng: 1.7665607174529896,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2128",
    tags: [],
    locationDescription:
      " A dog builds a book gracefully. The man looks at a fence gracefully.",
  },
  {
    locationId: "item20129",
    locationName: "item20129",
    locationAddress: "item20129",
    ratings: null,
    lat: 60.356889873336314,
    lng: -5.306446054452671,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2129",
    tags: [],
    locationDescription:
      " The student eats the horizon silently. The student builds the cake lazily. The man runs towards a fence happily.",
  },
  {
    locationId: "item20130",
    locationName: "item20130",
    locationAddress: "item20130",
    ratings: [
      { who: "Similar identities", rating: 2.81 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 51.914859035528806,
    lng: -7.998604325494306,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2130",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards the cake happily. The cat builds the road angrily. The student builds the road happily.",
  },
  {
    locationId: "item20131",
    locationName: "item20131",
    locationAddress: "item20131",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 57.95669628218096,
    lng: -6.311242242643531,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2131",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A woman jumps over the cake gracefully. The teacher writes the horizon quickly. The man runs towards the road lazily. A dog jumps over the horizon angrily. The teacher jumps over a book lazily.",
  },
  {
    locationId: "item20132",
    locationName: "item20132",
    locationAddress: "item20132",
    ratings: null,
    lat: 57.22929487664001,
    lng: -1.8320694086588567,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2132",
    tags: [],
    locationDescription:
      " The cat jumps over the road gracefully. The student writes a tower happily. The cat writes a fence lazily. The cat builds the cake quickly. The cat writes a book happily.",
  },
  {
    locationId: "item20133",
    locationName: "item20133",
    locationAddress: "item20133",
    ratings: null,
    lat: 59.63072860904965,
    lng: -2.525904692702591,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2133",
    tags: [],
    locationDescription:
      " A woman writes the road happily. The student builds a fence lazily. The man looks at a fence gracefully. The student runs towards the cake silently.",
  },
  {
    locationId: "item20134",
    locationName: "item20134",
    locationAddress: "item20134",
    ratings: [
      { who: "Similar identities", rating: 4.5 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 51.76596090364604,
    lng: -1.9349553169869758,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2134",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " A woman eats a tower silently.",
  },
  {
    locationId: "item20135",
    locationName: "item20135",
    locationAddress: "item20135",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 56.28180296783127,
    lng: -4.569502922217421,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2135",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog writes a fence lazily. A woman looks at the cake silently. The student jumps over the horizon gracefully.",
  },
  {
    locationId: "item20136",
    locationName: "item20136",
    locationAddress: "item20136",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 2.25 },
    ],
    lat: 55.27861098365698,
    lng: -1.6898811641651337,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2136",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards a tower quickly. The teacher eats a tower quickly. A dog eats a book happily. A woman eats a fence quickly. The man jumps over the horizon silently.",
  },
  {
    locationId: "item20137",
    locationName: "item20137",
    locationAddress: "item20137",
    ratings: null,
    lat: 59.04959568566726,
    lng: -6.044925448027769,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2137",
    tags: [],
    locationDescription:
      " A woman jumps over the cake angrily. A woman builds a tower silently. The man looks at a book quickly. The teacher runs towards the horizon silently. The man looks at a tower quickly.",
  },
  {
    locationId: "item20138",
    locationName: "item20138",
    locationAddress: "item20138",
    ratings: [
      { who: "Similar identities", rating: 3.82 },
      { who: "All perspectives", rating: 0.27 },
    ],
    lat: 53.77102324020185,
    lng: -0.5522920139310177,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2138",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards the road gracefully. The man looks at a book lazily. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item20139",
    locationName: "item20139",
    locationAddress: "item20139",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 2.35 },
    ],
    lat: 50.84409581503169,
    lng: -3.7545865552121827,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2139",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman jumps over a fence happily.",
  },
  {
    locationId: "item20140",
    locationName: "item20140",
    locationAddress: "item20140",
    ratings: null,
    lat: 55.07459780640587,
    lng: -1.845274913207259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2140",
    tags: [],
    locationDescription: " A woman writes the horizon lazily.",
  },
  {
    locationId: "item20141",
    locationName: "item20141",
    locationAddress: "item20141",
    ratings: null,
    lat: 57.95572927547365,
    lng: 1.7819381164534605,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2141",
    tags: [],
    locationDescription:
      " A woman runs towards the cake lazily. A woman builds the road gracefully. A woman builds the cake angrily. A dog runs towards a tower lazily. A dog runs towards the road lazily.",
  },
  {
    locationId: "item20142",
    locationName: "item20142",
    locationAddress: "item20142",
    ratings: [
      { who: "Similar identities", rating: 2.7 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 55.898504639343976,
    lng: 1.3946756670211347,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2142",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher builds a tower quickly. A dog builds the road angrily. A woman builds a fence lazily. The student jumps over the horizon happily.",
  },
  {
    locationId: "item20143",
    locationName: "item20143",
    locationAddress: "item20143",
    ratings: null,
    lat: 54.87102132916969,
    lng: -2.5316120536857705,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2143",
    tags: [],
    locationDescription:
      " The man writes a tower quickly. The teacher looks at the horizon happily. The student builds the road silently.",
  },
  {
    locationId: "item20144",
    locationName: "item20144",
    locationAddress: "item20144",
    ratings: null,
    lat: 52.71395298620845,
    lng: -2.1472637042947236,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2144",
    tags: [],
    locationDescription:
      " A woman looks at the road quickly. A dog looks at the horizon quickly. The man writes a fence lazily.",
  },
  {
    locationId: "item20145",
    locationName: "item20145",
    locationAddress: "item20145",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 57.07658718308693,
    lng: -0.12316113899095882,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2145",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The student runs towards a tower angrily.",
  },
  {
    locationId: "item20146",
    locationName: "item20146",
    locationAddress: "item20146",
    ratings: null,
    lat: 50.93019042675536,
    lng: -4.302384330817822,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2146",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon lazily. A dog builds the road happily. A woman looks at the cake silently. The man eats the horizon angrily.",
  },
  {
    locationId: "item20147",
    locationName: "item20147",
    locationAddress: "item20147",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 1.7 },
    ],
    lat: 57.54103946838907,
    lng: -1.7635063772272304,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2147",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A dog builds a book angrily. The teacher runs towards a book lazily. A dog jumps over the horizon happily. The man jumps over the cake quickly.",
  },
  {
    locationId: "item20148",
    locationName: "item20148",
    locationAddress: "item20148",
    ratings: null,
    lat: 55.248442380220155,
    lng: 1.3625122512304682,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2148",
    tags: [],
    locationDescription: " The student builds a tower angrily.",
  },
  {
    locationId: "item20149",
    locationName: "item20149",
    locationAddress: "item20149",
    ratings: [
      { who: "Similar identities", rating: 2.24 },
      { who: "All perspectives", rating: 0.65 },
    ],
    lat: 58.47224838141386,
    lng: -6.956775301641494,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2149",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat runs towards a tower lazily.",
  },
  {
    locationId: "item20150",
    locationName: "item20150",
    locationAddress: "item20150",
    ratings: null,
    lat: 55.550886300925555,
    lng: -2.785785479478254,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2150",
    tags: [],
    locationDescription:
      " A dog builds the road happily. A woman jumps over a book gracefully. The student eats a fence silently.",
  },
  {
    locationId: "item20151",
    locationName: "item20151",
    locationAddress: "item20151",
    ratings: [
      { who: "Similar identities", rating: 4.6 },
      { who: "All perspectives", rating: 2.77 },
    ],
    lat: 60.445558208553116,
    lng: -7.30995874113336,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2151",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards a fence quickly. The cat writes a tower lazily. The student jumps over the road quickly. The student eats a tower gracefully.",
  },
  {
    locationId: "item20152",
    locationName: "item20152",
    locationAddress: "item20152",
    ratings: null,
    lat: 56.79353960897076,
    lng: -3.6087019188208416,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2152",
    tags: [],
    locationDescription:
      " The man jumps over a tower lazily. A dog writes the road lazily. The cat jumps over a book silently. The teacher runs towards a book happily.",
  },
  {
    locationId: "item20153",
    locationName: "item20153",
    locationAddress: "item20153",
    ratings: null,
    lat: 50.62993412333483,
    lng: -6.928379067249772,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2153",
    tags: [],
    locationDescription:
      " The student jumps over a tower silently. The cat runs towards a fence lazily. The cat eats a fence angrily. A dog writes a tower gracefully.",
  },
  {
    locationId: "item20154",
    locationName: "item20154",
    locationAddress: "item20154",
    ratings: [
      { who: "Similar identities", rating: 1.17 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 49.993311689296334,
    lng: -7.036520744771026,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2154",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog runs towards a tower quickly.",
  },
  {
    locationId: "item20155",
    locationName: "item20155",
    locationAddress: "item20155",
    ratings: null,
    lat: 57.541111831444454,
    lng: -1.546920935192687,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2155",
    tags: [],
    locationDescription:
      " The cat writes the cake gracefully. The student eats a tower angrily.",
  },
  {
    locationId: "item20156",
    locationName: "item20156",
    locationAddress: "item20156",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 57.683009658126856,
    lng: -2.4335748662721866,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2156",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the horizon happily. The teacher runs towards the road angrily.",
  },
  {
    locationId: "item20157",
    locationName: "item20157",
    locationAddress: "item20157",
    ratings: null,
    lat: 59.73054046915225,
    lng: -7.548086783689928,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2157",
    tags: [],
    locationDescription: " A dog eats a book silently.",
  },
  {
    locationId: "item20158",
    locationName: "item20158",
    locationAddress: "item20158",
    ratings: null,
    lat: 56.06094539910262,
    lng: -7.109468365912451,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2158",
    tags: [],
    locationDescription:
      " The man builds the road lazily. The student eats a book gracefully. A dog runs towards a fence silently. The cat jumps over a book quickly. The teacher runs towards a tower quickly.",
  },
  {
    locationId: "item20159",
    locationName: "item20159",
    locationAddress: "item20159",
    ratings: null,
    lat: 58.3815178588429,
    lng: -8.135394260422588,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2159",
    tags: [],
    locationDescription:
      " The student eats the cake silently. The teacher runs towards a tower gracefully. The teacher looks at the cake silently. A woman jumps over the horizon lazily. The man eats the road happily.",
  },
  {
    locationId: "item20160",
    locationName: "item20160",
    locationAddress: "item20160",
    ratings: null,
    lat: 52.91392734435118,
    lng: 0.9498527478050853,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2160",
    tags: [],
    locationDescription:
      " The teacher builds a tower quickly. The student writes the cake lazily. A dog builds the horizon happily. The man jumps over a fence gracefully. A woman writes the horizon lazily.",
  },
  {
    locationId: "item20161",
    locationName: "item20161",
    locationAddress: "item20161",
    ratings: null,
    lat: 50.64666907042987,
    lng: -6.815102908002286,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2161",
    tags: [],
    locationDescription: " The teacher runs towards a book angrily.",
  },
  {
    locationId: "item20162",
    locationName: "item20162",
    locationAddress: "item20162",
    ratings: [
      { who: "Similar identities", rating: 4.52 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 52.59101377823635,
    lng: -3.2851140939702477,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2162",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds a book lazily. The student runs towards a tower angrily. A woman runs towards the horizon silently. The teacher jumps over a fence happily.",
  },
  {
    locationId: "item20163",
    locationName: "item20163",
    locationAddress: "item20163",
    ratings: [
      { who: "Similar identities", rating: 2.98 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 54.907603764184145,
    lng: -4.438626649836439,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2163",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman builds a book quickly. A woman builds the horizon silently. The cat writes the cake lazily.",
  },
  {
    locationId: "item20164",
    locationName: "item20164",
    locationAddress: "item20164",
    ratings: [
      { who: "Similar identities", rating: 1.77 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 60.85612434736394,
    lng: -4.873516392490821,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2164",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher runs towards the horizon lazily. The cat eats a tower gracefully. The cat writes a fence quickly. A woman builds a book silently.",
  },
  {
    locationId: "item20165",
    locationName: "item20165",
    locationAddress: "item20165",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 0.2 },
    ],
    lat: 52.67723607730409,
    lng: 0.8332197009287299,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2165",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman runs towards the road silently.",
  },
  {
    locationId: "item20166",
    locationName: "item20166",
    locationAddress: "item20166",
    ratings: null,
    lat: 51.748610483836835,
    lng: -3.563800731091882,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2166",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon angrily. The cat builds the horizon silently. The student looks at a fence lazily.",
  },
  {
    locationId: "item20167",
    locationName: "item20167",
    locationAddress: "item20167",
    ratings: [
      { who: "Similar identities", rating: 4.94 },
      { who: "All perspectives", rating: 4.27 },
    ],
    lat: 51.119220816382374,
    lng: -1.6851984836970537,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2167",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes a tower lazily. The cat jumps over a tower lazily. The cat writes a fence happily.",
  },
  {
    locationId: "item20168",
    locationName: "item20168",
    locationAddress: "item20168",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 4.39 },
    ],
    lat: 50.14663419155194,
    lng: 1.364304754253574,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2168",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " A woman runs towards a fence gracefully.",
  },
  {
    locationId: "item20169",
    locationName: "item20169",
    locationAddress: "item20169",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 56.881384808703075,
    lng: -7.948132711876661,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2169",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man jumps over the road gracefully. The cat eats a book gracefully. A dog eats a fence silently. A woman runs towards a tower silently.",
  },
  {
    locationId: "item20170",
    locationName: "item20170",
    locationAddress: "item20170",
    ratings: [
      { who: "Similar identities", rating: 3.66 },
      { who: "All perspectives", rating: 1.88 },
    ],
    lat: 59.01953316761761,
    lng: -4.863811181460228,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2170",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats the road angrily. The cat runs towards the horizon angrily. The teacher writes a tower silently. The cat runs towards the road angrily.",
  },
  {
    locationId: "item20171",
    locationName: "item20171",
    locationAddress: "item20171",
    ratings: [
      { who: "Similar identities", rating: 2.32 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 54.959623782944334,
    lng: -4.50265479722227,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2171",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over a fence gracefully. The cat jumps over the road silently. A woman looks at a book quickly.",
  },
  {
    locationId: "item20172",
    locationName: "item20172",
    locationAddress: "item20172",
    ratings: [
      { who: "Similar identities", rating: 1.59 },
      { who: "All perspectives", rating: 4.55 },
    ],
    lat: 57.62702872047692,
    lng: -3.733641656123809,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2172",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a fence angrily. The teacher builds the horizon quickly.",
  },
  {
    locationId: "item20173",
    locationName: "item20173",
    locationAddress: "item20173",
    ratings: [
      { who: "Similar identities", rating: 1.97 },
      { who: "All perspectives", rating: 2.67 },
    ],
    lat: 60.83110824549864,
    lng: -6.447595384178957,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2173",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student looks at the horizon angrily. A woman looks at the road angrily. A dog looks at the horizon quickly. The cat runs towards the cake lazily.",
  },
  {
    locationId: "item20174",
    locationName: "item20174",
    locationAddress: "item20174",
    ratings: null,
    lat: 59.41600488188898,
    lng: -3.814135103084917,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2174",
    tags: [],
    locationDescription: " The cat eats the road quickly.",
  },
  {
    locationId: "item20175",
    locationName: "item20175",
    locationAddress: "item20175",
    ratings: [
      { who: "Similar identities", rating: 3.67 },
      { who: "All perspectives", rating: 0.25 },
    ],
    lat: 51.628719853304545,
    lng: 0.7553487647969082,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2175",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman eats a tower lazily. The cat runs towards a book lazily. A woman writes a book lazily.",
  },
  {
    locationId: "item20176",
    locationName: "item20176",
    locationAddress: "item20176",
    ratings: [
      { who: "Similar identities", rating: 0.52 },
      { who: "All perspectives", rating: 2.47 },
    ],
    lat: 54.95570178608886,
    lng: 1.5661979006816473,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2176",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat builds a book gracefully. The teacher looks at the horizon quickly. A dog eats the horizon happily. The student looks at the horizon gracefully. The student writes the road happily.",
  },
  {
    locationId: "item20177",
    locationName: "item20177",
    locationAddress: "item20177",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 0.41 },
    ],
    lat: 59.14515540037237,
    lng: -5.418150513343332,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2177",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the road happily. The cat eats the horizon silently. A dog runs towards a fence happily. A woman runs towards the road lazily.",
  },
  {
    locationId: "item20178",
    locationName: "item20178",
    locationAddress: "item20178",
    ratings: null,
    lat: 51.92892894192923,
    lng: -6.910096850035029,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2178",
    tags: [],
    locationDescription:
      " The cat looks at a fence lazily. The cat builds a fence lazily.",
  },
  {
    locationId: "item20179",
    locationName: "item20179",
    locationAddress: "item20179",
    ratings: null,
    lat: 59.650503226719835,
    lng: -5.681702296797307,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2179",
    tags: [],
    locationDescription:
      " The teacher looks at the road quickly. The teacher eats the horizon happily. The student writes a book gracefully. The cat eats a tower happily.",
  },
  {
    locationId: "item20180",
    locationName: "item20180",
    locationAddress: "item20180",
    ratings: [
      { who: "Similar identities", rating: 2.49 },
      { who: "All perspectives", rating: 0.63 },
    ],
    lat: 55.282809536592616,
    lng: -7.736614342929735,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2180",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at a book angrily. The student builds the horizon happily. The cat looks at a tower happily.",
  },
  {
    locationId: "item20181",
    locationName: "item20181",
    locationAddress: "item20181",
    ratings: [
      { who: "Similar identities", rating: 2.41 },
      { who: "All perspectives", rating: 3.62 },
    ],
    lat: 51.437522330818716,
    lng: -6.639750261353547,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2181",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over the horizon silently. The man looks at a fence lazily. The teacher builds a fence angrily. The cat writes the road angrily.",
  },
  {
    locationId: "item20182",
    locationName: "item20182",
    locationAddress: "item20182",
    ratings: [
      { who: "Similar identities", rating: 4.78 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 54.05583844715528,
    lng: -7.3285307535559125,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2182",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at the horizon angrily. A dog runs towards a book silently. The teacher looks at the cake lazily.",
  },
  {
    locationId: "item20183",
    locationName: "item20183",
    locationAddress: "item20183",
    ratings: null,
    lat: 49.93021697608648,
    lng: -2.6194171210683024,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2183",
    tags: [],
    locationDescription:
      " A woman runs towards a book silently. A woman looks at a fence angrily.",
  },
  {
    locationId: "item20184",
    locationName: "item20184",
    locationAddress: "item20184",
    ratings: null,
    lat: 58.04251377003086,
    lng: -1.042607617314328,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2184",
    tags: [],
    locationDescription:
      " The cat jumps over a tower lazily. The teacher builds the cake angrily.",
  },
  {
    locationId: "item20185",
    locationName: "item20185",
    locationAddress: "item20185",
    ratings: [
      { who: "Similar identities", rating: 2.42 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 59.19185627175429,
    lng: -7.363081286995088,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2185",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat builds the cake angrily. A woman eats a tower happily. The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item20186",
    locationName: "item20186",
    locationAddress: "item20186",
    ratings: null,
    lat: 50.15157711959431,
    lng: -4.1797648782468,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2186",
    tags: [],
    locationDescription:
      " The student eats the road lazily. The man eats the road silently.",
  },
  {
    locationId: "item20187",
    locationName: "item20187",
    locationAddress: "item20187",
    ratings: [
      { who: "Similar identities", rating: 2.5 },
      { who: "All perspectives", rating: 3.43 },
    ],
    lat: 56.33778325274913,
    lng: -2.6861516203265534,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2187",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription: " The student builds the road quickly.",
  },
  {
    locationId: "item20188",
    locationName: "item20188",
    locationAddress: "item20188",
    ratings: [
      { who: "Similar identities", rating: 1.81 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 56.53999127886094,
    lng: -0.38454628195840534,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2188",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription: " The man jumps over a tower happily.",
  },
  {
    locationId: "item20189",
    locationName: "item20189",
    locationAddress: "item20189",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 2.9 },
    ],
    lat: 54.28469406434352,
    lng: 0.32019485058281205,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2189",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman looks at a tower silently.",
  },
  {
    locationId: "item20190",
    locationName: "item20190",
    locationAddress: "item20190",
    ratings: [
      { who: "Similar identities", rating: 1.02 },
      { who: "All perspectives", rating: 4.01 },
    ],
    lat: 53.34705432276804,
    lng: -2.466593021488979,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2190",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman builds the cake happily. The cat looks at the cake happily. The man runs towards the cake lazily. A woman runs towards the horizon angrily. A dog writes a fence lazily.",
  },
  {
    locationId: "item20191",
    locationName: "item20191",
    locationAddress: "item20191",
    ratings: [
      { who: "Similar identities", rating: 0.22 },
      { who: "All perspectives", rating: 0.73 },
    ],
    lat: 58.88549535430087,
    lng: -7.784843397455927,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2191",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats the horizon lazily. The cat looks at a book angrily. A dog jumps over a tower angrily. The man eats a book lazily.",
  },
  {
    locationId: "item20192",
    locationName: "item20192",
    locationAddress: "item20192",
    ratings: null,
    lat: 56.153355405146975,
    lng: -2.1431756811785103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2192",
    tags: [],
    locationDescription:
      " The student looks at the road angrily. A dog builds the cake lazily. The man looks at a tower gracefully. A dog writes the cake happily.",
  },
  {
    locationId: "item20193",
    locationName: "item20193",
    locationAddress: "item20193",
    ratings: [
      { who: "Similar identities", rating: 1.25 },
      { who: "All perspectives", rating: 4.42 },
    ],
    lat: 50.9382635908031,
    lng: 0.06307092236979983,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2193",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog runs towards a book silently. The teacher jumps over the cake gracefully. A woman jumps over the road silently. The cat looks at a book quickly.",
  },
  {
    locationId: "item20194",
    locationName: "item20194",
    locationAddress: "item20194",
    ratings: null,
    lat: 57.63893228908884,
    lng: -2.7948214836041387,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2194",
    tags: [],
    locationDescription:
      " A dog looks at the horizon lazily. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item20195",
    locationName: "item20195",
    locationAddress: "item20195",
    ratings: null,
    lat: 53.119588502688714,
    lng: -7.872652847549302,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2195",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower lazily. A dog builds the road quickly. A dog writes a fence lazily. The cat writes a tower gracefully.",
  },
  {
    locationId: "item20196",
    locationName: "item20196",
    locationAddress: "item20196",
    ratings: [
      { who: "Similar identities", rating: 1.71 },
      { who: "All perspectives", rating: 1.54 },
    ],
    lat: 59.805143901188444,
    lng: -0.6970341100469568,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2196",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds a book lazily. A woman looks at the road angrily. The cat builds a tower happily. The student looks at the road silently. The teacher eats a tower silently.",
  },
  {
    locationId: "item20197",
    locationName: "item20197",
    locationAddress: "item20197",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 52.09429067260854,
    lng: -8.447342085926394,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2197",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes the cake happily. The teacher runs towards a fence angrily. The man eats the horizon silently.",
  },
  {
    locationId: "item20198",
    locationName: "item20198",
    locationAddress: "item20198",
    ratings: null,
    lat: 53.765430320315616,
    lng: 0.9190266841075818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2198",
    tags: [],
    locationDescription:
      " The teacher writes the road lazily. The student jumps over a tower happily. A woman eats a fence gracefully. A woman looks at a book gracefully. The student eats the road quickly.",
  },
  {
    locationId: "item20199",
    locationName: "item20199",
    locationAddress: "item20199",
    ratings: null,
    lat: 49.963672926808634,
    lng: 0.9279355618721841,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2199",
    tags: [],
    locationDescription:
      " The student looks at the road gracefully. The teacher writes the horizon silently. A dog runs towards the cake gracefully. The man jumps over a tower gracefully. A woman jumps over the horizon silently.",
  },
  {
    locationId: "item20200",
    locationName: "item20200",
    locationAddress: "item20200",
    ratings: [
      { who: "Similar identities", rating: 0.95 },
      { who: "All perspectives", rating: 4.38 },
    ],
    lat: 53.68636423138354,
    lng: -6.6951194984949005,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2200",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man builds a fence silently. A dog writes a fence lazily.",
  },
  {
    locationId: "item20201",
    locationName: "item20201",
    locationAddress: "item20201",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 60.140732777202345,
    lng: -4.586906283603,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2201",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman looks at a tower angrily. The cat writes a book silently. The student writes a tower gracefully.",
  },
  {
    locationId: "item20202",
    locationName: "item20202",
    locationAddress: "item20202",
    ratings: [
      { who: "Similar identities", rating: 3.26 },
      { who: "All perspectives", rating: 0.83 },
    ],
    lat: 50.65975423715901,
    lng: -6.945471346248885,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2202",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at a tower silently. The man runs towards a book quickly. The man runs towards the cake angrily.",
  },
  {
    locationId: "item20203",
    locationName: "item20203",
    locationAddress: "item20203",
    ratings: null,
    lat: 56.1119643568733,
    lng: -8.394713577493881,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2203",
    tags: [],
    locationDescription:
      " The teacher builds a fence quickly. The student eats a tower happily. A dog runs towards the cake happily. The cat builds a fence gracefully. The student eats the cake quickly.",
  },
  {
    locationId: "item20204",
    locationName: "item20204",
    locationAddress: "item20204",
    ratings: null,
    lat: 54.55729490390793,
    lng: -7.367419695964925,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2204",
    tags: [],
    locationDescription: " The teacher writes a tower happily.",
  },
  {
    locationId: "item20205",
    locationName: "item20205",
    locationAddress: "item20205",
    ratings: null,
    lat: 60.02532371170783,
    lng: -0.10730105262060619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2205",
    tags: [],
    locationDescription: " A dog jumps over a tower happily.",
  },
  {
    locationId: "item20206",
    locationName: "item20206",
    locationAddress: "item20206",
    ratings: [
      { who: "Similar identities", rating: 2.39 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 52.70644757793689,
    lng: -6.806371051158052,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2206",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " A woman builds a book silently.",
  },
  {
    locationId: "item20207",
    locationName: "item20207",
    locationAddress: "item20207",
    ratings: null,
    lat: 53.38749071722003,
    lng: -6.168748062609376,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2207",
    tags: [],
    locationDescription: " A dog jumps over the road angrily.",
  },
  {
    locationId: "item20208",
    locationName: "item20208",
    locationAddress: "item20208",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 59.89127684652078,
    lng: -4.710218089581165,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2208",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman builds the road lazily. The cat eats the cake gracefully.",
  },
  {
    locationId: "item20209",
    locationName: "item20209",
    locationAddress: "item20209",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 56.08037467432392,
    lng: 0.9143439233946591,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2209",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The teacher looks at a book gracefully. The teacher writes a tower gracefully. The man builds a fence lazily. The student builds a book silently.",
  },
  {
    locationId: "item20210",
    locationName: "item20210",
    locationAddress: "item20210",
    ratings: [
      { who: "Similar identities", rating: 2.72 },
      { who: "All perspectives", rating: 1.39 },
    ],
    lat: 57.066123088906906,
    lng: -3.1121276616934184,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2210",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The teacher looks at a fence silently. The cat builds the road lazily. A dog eats a book gracefully.",
  },
  {
    locationId: "item20211",
    locationName: "item20211",
    locationAddress: "item20211",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 3.4 },
    ],
    lat: 53.17553001608731,
    lng: -4.384383037141983,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2211",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " The student jumps over a fence angrily.",
  },
  {
    locationId: "item20212",
    locationName: "item20212",
    locationAddress: "item20212",
    ratings: [
      { who: "Similar identities", rating: 0.83 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 59.02267008244145,
    lng: 1.2111099123837104,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2212",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher looks at the cake silently. A dog writes the road gracefully. The student builds a tower gracefully. The cat builds a fence quickly. The student looks at a tower gracefully.",
  },
  {
    locationId: "item20213",
    locationName: "item20213",
    locationAddress: "item20213",
    ratings: null,
    lat: 52.09197613282149,
    lng: -8.419304239784752,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2213",
    tags: [],
    locationDescription:
      " The cat eats a fence quickly. The man eats the road angrily. The teacher builds a tower lazily.",
  },
  {
    locationId: "item20214",
    locationName: "item20214",
    locationAddress: "item20214",
    ratings: null,
    lat: 50.384767030950826,
    lng: -6.969371105812634,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2214",
    tags: [],
    locationDescription:
      " The man writes a fence happily. The man looks at a book silently.",
  },
  {
    locationId: "item20215",
    locationName: "item20215",
    locationAddress: "item20215",
    ratings: [
      { who: "Similar identities", rating: 4.46 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 58.11083394070101,
    lng: -3.8941945202968107,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2215",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man jumps over the road lazily. The man looks at a book angrily.",
  },
  {
    locationId: "item20216",
    locationName: "item20216",
    locationAddress: "item20216",
    ratings: [
      { who: "Similar identities", rating: 4.54 },
      { who: "All perspectives", rating: 2.45 },
    ],
    lat: 53.847248166690456,
    lng: -2.654917568046998,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2216",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " The student runs towards the horizon gracefully.",
  },
  {
    locationId: "item20217",
    locationName: "item20217",
    locationAddress: "item20217",
    ratings: [
      { who: "Similar identities", rating: 2.95 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 51.938074818442075,
    lng: -3.390607048400212,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2217",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The teacher runs towards a book silently. The cat runs towards a book happily. The teacher looks at the horizon lazily.",
  },
  {
    locationId: "item20218",
    locationName: "item20218",
    locationAddress: "item20218",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 2.54 },
    ],
    lat: 51.62600613632621,
    lng: 0.22861333260389927,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2218",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog builds the horizon angrily. A dog eats a book happily. The teacher builds the road quickly.",
  },
  {
    locationId: "item20219",
    locationName: "item20219",
    locationAddress: "item20219",
    ratings: null,
    lat: 54.0199398907219,
    lng: -8.141748407694543,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2219",
    tags: [],
    locationDescription:
      " The man looks at the cake happily. A woman builds a fence quickly.",
  },
  {
    locationId: "item20220",
    locationName: "item20220",
    locationAddress: "item20220",
    ratings: null,
    lat: 59.572783260501765,
    lng: -4.552314864905732,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2220",
    tags: [],
    locationDescription:
      " The man writes a book silently. A woman writes the horizon quickly. A woman writes a book gracefully. A woman jumps over a tower angrily. A dog looks at a book happily.",
  },
  {
    locationId: "item20221",
    locationName: "item20221",
    locationAddress: "item20221",
    ratings: null,
    lat: 52.81157870849945,
    lng: 0.7315811167856925,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2221",
    tags: [],
    locationDescription:
      " The man looks at a book silently. The teacher jumps over a book lazily. The teacher runs towards a fence silently.",
  },
  {
    locationId: "item20222",
    locationName: "item20222",
    locationAddress: "item20222",
    ratings: null,
    lat: 59.64744446107248,
    lng: -8.47168683931068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2222",
    tags: [],
    locationDescription:
      " The student writes a fence gracefully. A dog jumps over a fence quickly. A dog jumps over a tower gracefully.",
  },
  {
    locationId: "item20223",
    locationName: "item20223",
    locationAddress: "item20223",
    ratings: null,
    lat: 60.55581202472878,
    lng: -4.009949280172442,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2223",
    tags: [],
    locationDescription:
      " The student jumps over a fence angrily. A woman runs towards a book silently. The student writes the road lazily. The teacher eats the horizon happily.",
  },
  {
    locationId: "item20224",
    locationName: "item20224",
    locationAddress: "item20224",
    ratings: [
      { who: "Similar identities", rating: 0.3 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 54.87142830618669,
    lng: -0.709590234918581,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2224",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat looks at a book quickly. The man eats the cake gracefully.",
  },
  {
    locationId: "item20225",
    locationName: "item20225",
    locationAddress: "item20225",
    ratings: null,
    lat: 55.34948144075779,
    lng: -7.316478845216776,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2225",
    tags: [],
    locationDescription:
      " The teacher eats the cake happily. The student runs towards a fence happily. A woman jumps over the cake gracefully. The teacher looks at a tower lazily. The cat looks at the road happily.",
  },
  {
    locationId: "item20226",
    locationName: "item20226",
    locationAddress: "item20226",
    ratings: null,
    lat: 59.52531345223841,
    lng: -1.5316051234375667,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2226",
    tags: [],
    locationDescription:
      " A dog eats a book happily. A dog jumps over a fence gracefully. A woman looks at a tower gracefully.",
  },
  {
    locationId: "item20227",
    locationName: "item20227",
    locationAddress: "item20227",
    ratings: null,
    lat: 55.5427008139846,
    lng: 1.3008840097446637,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2227",
    tags: [],
    locationDescription:
      " The teacher eats a tower lazily. A dog runs towards a book happily. The teacher builds a tower lazily. A woman writes the road quickly. The cat runs towards the cake gracefully.",
  },
  {
    locationId: "item20228",
    locationName: "item20228",
    locationAddress: "item20228",
    ratings: [
      { who: "Similar identities", rating: 1.52 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 60.712332645575515,
    lng: -4.821351305062944,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2228",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman builds a fence lazily. A dog runs towards the road quickly. The cat eats the horizon happily. The cat runs towards the horizon angrily. The student writes a fence silently.",
  },
  {
    locationId: "item20229",
    locationName: "item20229",
    locationAddress: "item20229",
    ratings: [
      { who: "Similar identities", rating: 3.36 },
      { who: "All perspectives", rating: 0.2 },
    ],
    lat: 60.457668407111804,
    lng: -1.5221161288603575,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2229",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over a fence happily. A dog writes the horizon gracefully. The cat builds a fence gracefully.",
  },
  {
    locationId: "item20230",
    locationName: "item20230",
    locationAddress: "item20230",
    ratings: null,
    lat: 57.290159373229905,
    lng: -5.138567070298862,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2230",
    tags: [],
    locationDescription:
      " A woman runs towards the cake happily. A woman builds the road angrily. The student runs towards the road quickly. The cat runs towards the horizon angrily. The student runs towards the road quickly.",
  },
  {
    locationId: "item20231",
    locationName: "item20231",
    locationAddress: "item20231",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 2.19 },
    ],
    lat: 53.83688139605964,
    lng: -1.55195873141058,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2231",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher runs towards the horizon gracefully. The teacher runs towards a fence quickly. The teacher builds the horizon angrily.",
  },
  {
    locationId: "item20232",
    locationName: "item20232",
    locationAddress: "item20232",
    ratings: null,
    lat: 55.60562780267187,
    lng: -3.4050861055766655,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2232",
    tags: [],
    locationDescription: " The teacher runs towards the cake happily.",
  },
  {
    locationId: "item20233",
    locationName: "item20233",
    locationAddress: "item20233",
    ratings: [
      { who: "Similar identities", rating: 0.78 },
      { who: "All perspectives", rating: 3.29 },
    ],
    lat: 51.24615934177943,
    lng: -1.634608575634081,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2233",
    tags: [{ label: "accessible" }],
    locationDescription: " The teacher writes a tower angrily.",
  },
  {
    locationId: "item20234",
    locationName: "item20234",
    locationAddress: "item20234",
    ratings: null,
    lat: 58.28782746407917,
    lng: -0.983160515702524,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2234",
    tags: [],
    locationDescription: " The student runs towards the road lazily.",
  },
  {
    locationId: "item20235",
    locationName: "item20235",
    locationAddress: "item20235",
    ratings: [
      { who: "Similar identities", rating: 0.36 },
      { who: "All perspectives", rating: 4.22 },
    ],
    lat: 53.9015510522551,
    lng: -2.680846239785538,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2235",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student eats a fence silently. A woman writes a book lazily. The student looks at the road gracefully. The student runs towards a book happily. The student builds the road angrily.",
  },
  {
    locationId: "item20236",
    locationName: "item20236",
    locationAddress: "item20236",
    ratings: [
      { who: "Similar identities", rating: 0.67 },
      { who: "All perspectives", rating: 2.96 },
    ],
    lat: 53.45227944681184,
    lng: -1.0352583980923233,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2236",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man jumps over a fence silently. The cat builds a book lazily. The cat eats the road happily. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item20237",
    locationName: "item20237",
    locationAddress: "item20237",
    ratings: [
      { who: "Similar identities", rating: 0.27 },
      { who: "All perspectives", rating: 2.94 },
    ],
    lat: 56.28035960920015,
    lng: -5.824605933095213,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2237",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog eats the road angrily. The teacher writes a fence angrily. The cat looks at a tower lazily. The student writes the road happily. The cat writes a fence quickly.",
  },
  {
    locationId: "item20238",
    locationName: "item20238",
    locationAddress: "item20238",
    ratings: [
      { who: "Similar identities", rating: 4.59 },
      { who: "All perspectives", rating: 4.35 },
    ],
    lat: 53.24802509297093,
    lng: -6.115068716662085,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2238",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog jumps over a tower gracefully. A dog runs towards a fence gracefully. The student eats the cake lazily. The student eats a book angrily. The cat builds a fence lazily.",
  },
  {
    locationId: "item20239",
    locationName: "item20239",
    locationAddress: "item20239",
    ratings: [
      { who: "Similar identities", rating: 0.1 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 57.21372517870156,
    lng: -7.8595732798726665,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2239",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over the horizon quickly. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item20240",
    locationName: "item20240",
    locationAddress: "item20240",
    ratings: null,
    lat: 58.79011965388558,
    lng: -1.5086050315398563,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2240",
    tags: [],
    locationDescription:
      " A dog runs towards the road angrily. The cat builds the cake gracefully. The teacher builds a tower lazily. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item20241",
    locationName: "item20241",
    locationAddress: "item20241",
    ratings: null,
    lat: 59.82160094236335,
    lng: 1.5141769155991636,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2241",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake gracefully. The student writes a book silently.",
  },
  {
    locationId: "item20242",
    locationName: "item20242",
    locationAddress: "item20242",
    ratings: null,
    lat: 52.4762285060452,
    lng: -5.900032537580975,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2242",
    tags: [],
    locationDescription:
      " The man runs towards the cake quickly. The cat eats the horizon quickly. The man writes the horizon gracefully. The man eats the road happily. A woman looks at the horizon quickly.",
  },
  {
    locationId: "item20243",
    locationName: "item20243",
    locationAddress: "item20243",
    ratings: null,
    lat: 57.14217493630498,
    lng: 0.4394648173225981,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2243",
    tags: [],
    locationDescription:
      " The man looks at a book silently. The teacher runs towards a book gracefully. The cat eats a book angrily. A woman runs towards the road gracefully. A woman jumps over the horizon silently.",
  },
  {
    locationId: "item20244",
    locationName: "item20244",
    locationAddress: "item20244",
    ratings: [
      { who: "Similar identities", rating: 0.59 },
      { who: "All perspectives", rating: 3.19 },
    ],
    lat: 53.41655148382122,
    lng: -2.943858997781109,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2244",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes a fence angrily. A dog eats the cake silently. The teacher jumps over the cake quickly.",
  },
  {
    locationId: "item20245",
    locationName: "item20245",
    locationAddress: "item20245",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 3.99 },
    ],
    lat: 56.24089216589775,
    lng: -3.666701848184024,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2245",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The man eats the cake silently.",
  },
  {
    locationId: "item20246",
    locationName: "item20246",
    locationAddress: "item20246",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 3.77 },
    ],
    lat: 59.01368200734568,
    lng: -3.4142577565554797,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2246",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman runs towards a book angrily. The cat writes the horizon quickly.",
  },
  {
    locationId: "item20247",
    locationName: "item20247",
    locationAddress: "item20247",
    ratings: null,
    lat: 60.88213456065594,
    lng: -7.502979946670081,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2247",
    tags: [],
    locationDescription:
      " A dog jumps over a tower angrily. The student writes the road angrily. A dog builds the road lazily.",
  },
  {
    locationId: "item20248",
    locationName: "item20248",
    locationAddress: "item20248",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 57.31216164750506,
    lng: -6.561330401562479,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2248",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher eats the horizon silently. A woman builds the cake lazily.",
  },
  {
    locationId: "item20249",
    locationName: "item20249",
    locationAddress: "item20249",
    ratings: null,
    lat: 54.29172961597921,
    lng: -2.4497394539383803,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2249",
    tags: [],
    locationDescription:
      " The cat runs towards the road gracefully. The cat writes a book happily. The teacher eats a tower quickly.",
  },
  {
    locationId: "item20250",
    locationName: "item20250",
    locationAddress: "item20250",
    ratings: null,
    lat: 60.85532108541655,
    lng: -4.701834086524602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2250",
    tags: [],
    locationDescription:
      " A woman writes the cake happily. The teacher eats the horizon gracefully.",
  },
  {
    locationId: "item20251",
    locationName: "item20251",
    locationAddress: "item20251",
    ratings: null,
    lat: 60.746181650714284,
    lng: 0.47789376423329877,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2251",
    tags: [],
    locationDescription: " The teacher jumps over a fence silently.",
  },
  {
    locationId: "item20252",
    locationName: "item20252",
    locationAddress: "item20252",
    ratings: null,
    lat: 50.8320403849553,
    lng: -7.741111353071783,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2252",
    tags: [],
    locationDescription: " The student looks at the cake angrily.",
  },
  {
    locationId: "item20253",
    locationName: "item20253",
    locationAddress: "item20253",
    ratings: [
      { who: "Similar identities", rating: 4.97 },
      { who: "All perspectives", rating: 3.03 },
    ],
    lat: 52.13473738142575,
    lng: -3.8952222799825327,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2253",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A dog jumps over a fence quickly. The man writes a tower gracefully. The man jumps over the cake lazily. The teacher jumps over a fence quickly.",
  },
  {
    locationId: "item20254",
    locationName: "item20254",
    locationAddress: "item20254",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 0.36 },
    ],
    lat: 52.31358586718967,
    lng: -7.872269487605374,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2254",
    tags: [{ label: "child friendly" }],
    locationDescription: " The man builds a fence gracefully.",
  },
  {
    locationId: "item20255",
    locationName: "item20255",
    locationAddress: "item20255",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 54.373722789575275,
    lng: -5.225556129865912,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2255",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student runs towards the road silently. The teacher looks at the cake silently. The man builds a fence gracefully.",
  },
  {
    locationId: "item20256",
    locationName: "item20256",
    locationAddress: "item20256",
    ratings: [
      { who: "Similar identities", rating: 0.67 },
      { who: "All perspectives", rating: 1.88 },
    ],
    lat: 56.202207045116154,
    lng: -7.573186991768534,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2256",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards a tower quickly. A dog runs towards a tower lazily. A dog builds the horizon gracefully.",
  },
  {
    locationId: "item20257",
    locationName: "item20257",
    locationAddress: "item20257",
    ratings: null,
    lat: 59.1384238756422,
    lng: 0.723055024711833,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2257",
    tags: [],
    locationDescription:
      " The teacher eats the horizon angrily. A dog builds the cake lazily. The student runs towards the road silently.",
  },
  {
    locationId: "item20258",
    locationName: "item20258",
    locationAddress: "item20258",
    ratings: null,
    lat: 54.453878130595406,
    lng: 0.5837612307623203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2258",
    tags: [],
    locationDescription:
      " A woman runs towards a fence angrily. The man eats a tower gracefully. A dog builds a book lazily. The cat looks at a tower angrily. The teacher jumps over a book happily.",
  },
  {
    locationId: "item20259",
    locationName: "item20259",
    locationAddress: "item20259",
    ratings: null,
    lat: 50.95119129014929,
    lng: -4.097278581199341,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2259",
    tags: [],
    locationDescription:
      " The teacher looks at a tower happily. A dog eats the cake happily.",
  },
  {
    locationId: "item20260",
    locationName: "item20260",
    locationAddress: "item20260",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 4.86 },
    ],
    lat: 54.38617899850292,
    lng: -1.7812604693339962,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2260",
    tags: [{ label: "child friendly" }],
    locationDescription: " The teacher builds a tower quickly.",
  },
  {
    locationId: "item20261",
    locationName: "item20261",
    locationAddress: "item20261",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 3.82 },
    ],
    lat: 57.507990501496124,
    lng: 1.4081982536276971,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2261",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat looks at the horizon gracefully. The man writes a fence quickly. A woman eats the horizon angrily.",
  },
  {
    locationId: "item20262",
    locationName: "item20262",
    locationAddress: "item20262",
    ratings: null,
    lat: 59.298712434219155,
    lng: -1.7691519828145337,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2262",
    tags: [],
    locationDescription:
      " The cat jumps over a fence angrily. The student runs towards the horizon angrily. A dog eats a book silently. A dog builds the cake gracefully. A woman runs towards the road gracefully.",
  },
  {
    locationId: "item20263",
    locationName: "item20263",
    locationAddress: "item20263",
    ratings: null,
    lat: 56.26673203067672,
    lng: -5.860693767418831,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2263",
    tags: [],
    locationDescription:
      " The student runs towards the road lazily. A woman looks at the road quickly. The teacher eats the cake gracefully. The student eats the cake happily. The teacher eats a fence silently.",
  },
  {
    locationId: "item20264",
    locationName: "item20264",
    locationAddress: "item20264",
    ratings: [
      { who: "Similar identities", rating: 4.71 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 53.012574494995604,
    lng: -1.1748290853456416,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2264",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man builds the cake gracefully. The man eats the horizon gracefully.",
  },
  {
    locationId: "item20265",
    locationName: "item20265",
    locationAddress: "item20265",
    ratings: [
      { who: "Similar identities", rating: 3.11 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 53.64420182075363,
    lng: -3.0538950583331577,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2265",
    tags: [{ label: "accessible" }],
    locationDescription: " The teacher looks at the horizon quickly.",
  },
  {
    locationId: "item20266",
    locationName: "item20266",
    locationAddress: "item20266",
    ratings: null,
    lat: 51.50907164302242,
    lng: 0.28904105397668367,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2266",
    tags: [],
    locationDescription:
      " The man builds the road lazily. A woman builds the horizon quickly.",
  },
  {
    locationId: "item20267",
    locationName: "item20267",
    locationAddress: "item20267",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 2.26 },
    ],
    lat: 57.190637710467996,
    lng: 0.5106163653842835,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2267",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat writes a tower gracefully. The student builds a fence quickly. The teacher runs towards a book lazily.",
  },
  {
    locationId: "item20268",
    locationName: "item20268",
    locationAddress: "item20268",
    ratings: null,
    lat: 58.76154946366756,
    lng: -7.833314286976181,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2268",
    tags: [],
    locationDescription:
      " The cat writes a tower silently. A woman builds the road silently. The student eats the cake gracefully. The cat writes the road happily. A woman eats the cake angrily.",
  },
  {
    locationId: "item20269",
    locationName: "item20269",
    locationAddress: "item20269",
    ratings: null,
    lat: 58.70167786975851,
    lng: -6.02873499735048,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2269",
    tags: [],
    locationDescription:
      " The man builds the horizon lazily. The student eats a fence happily.",
  },
  {
    locationId: "item20270",
    locationName: "item20270",
    locationAddress: "item20270",
    ratings: null,
    lat: 50.928258439737505,
    lng: -3.173762205898792,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2270",
    tags: [],
    locationDescription:
      " A woman looks at the road happily. The teacher jumps over a fence quickly. The man writes a book lazily. The student looks at a book silently.",
  },
  {
    locationId: "item20271",
    locationName: "item20271",
    locationAddress: "item20271",
    ratings: [
      { who: "Similar identities", rating: 1.08 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 53.186081602504814,
    lng: -2.1381515874820014,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2271",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student writes the horizon silently. The student looks at the horizon gracefully. The cat looks at the road angrily. A dog builds a tower lazily.",
  },
  {
    locationId: "item20272",
    locationName: "item20272",
    locationAddress: "item20272",
    ratings: null,
    lat: 56.77198655016868,
    lng: -2.820506399456348,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2272",
    tags: [],
    locationDescription:
      " A woman builds a fence angrily. A dog eats a fence quickly. A woman jumps over a fence lazily. The man eats the road happily. The teacher looks at the horizon happily.",
  },
  {
    locationId: "item20273",
    locationName: "item20273",
    locationAddress: "item20273",
    ratings: null,
    lat: 59.288359854851706,
    lng: 0.2728033164760024,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2273",
    tags: [],
    locationDescription:
      " A woman writes the horizon angrily. A dog runs towards the cake happily. A dog builds a fence silently. The teacher builds a book lazily. A woman writes a book silently.",
  },
  {
    locationId: "item20274",
    locationName: "item20274",
    locationAddress: "item20274",
    ratings: null,
    lat: 55.02722371347153,
    lng: 0.25419889620104286,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2274",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon gracefully. The man looks at the road angrily. A dog looks at the cake silently. The cat runs towards a tower gracefully. The student looks at the road lazily.",
  },
  {
    locationId: "item20275",
    locationName: "item20275",
    locationAddress: "item20275",
    ratings: null,
    lat: 56.76851396198615,
    lng: -7.064623898781737,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2275",
    tags: [],
    locationDescription:
      " A dog jumps over a book silently. The man runs towards a tower happily. The man looks at a book angrily. The student writes the road quickly. A woman eats the cake lazily.",
  },
  {
    locationId: "item20276",
    locationName: "item20276",
    locationAddress: "item20276",
    ratings: null,
    lat: 52.141560082385745,
    lng: -6.589772951126658,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2276",
    tags: [],
    locationDescription:
      " A dog writes the horizon gracefully. A dog eats a book gracefully. The man eats a tower angrily. The teacher looks at a book angrily. The teacher builds a fence happily.",
  },
  {
    locationId: "item20277",
    locationName: "item20277",
    locationAddress: "item20277",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 0.02 },
    ],
    lat: 57.04694430925054,
    lng: -4.835528216986985,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2277",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher eats a fence quickly. The man runs towards the horizon angrily. A woman writes a fence happily.",
  },
  {
    locationId: "item20278",
    locationName: "item20278",
    locationAddress: "item20278",
    ratings: [
      { who: "Similar identities", rating: 1.98 },
      { who: "All perspectives", rating: 0.52 },
    ],
    lat: 50.16322421770384,
    lng: -1.348253285439422,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2278",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student jumps over a book silently. A dog writes the horizon gracefully. A dog writes a book lazily. A dog writes the cake lazily.",
  },
  {
    locationId: "item20279",
    locationName: "item20279",
    locationAddress: "item20279",
    ratings: null,
    lat: 52.696388711969554,
    lng: -5.9520917994411455,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2279",
    tags: [],
    locationDescription:
      " The cat builds a book quickly. A woman runs towards a tower silently.",
  },
  {
    locationId: "item20280",
    locationName: "item20280",
    locationAddress: "item20280",
    ratings: null,
    lat: 59.80831377490325,
    lng: -1.2794994717915058,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2280",
    tags: [],
    locationDescription:
      " A dog eats the cake happily. The cat runs towards the cake lazily.",
  },
  {
    locationId: "item20281",
    locationName: "item20281",
    locationAddress: "item20281",
    ratings: null,
    lat: 56.36759035203831,
    lng: -0.3965377576464544,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2281",
    tags: [],
    locationDescription:
      " The man jumps over the cake silently. The teacher writes a fence angrily. The man jumps over a fence silently. A dog writes the cake lazily.",
  },
  {
    locationId: "item20282",
    locationName: "item20282",
    locationAddress: "item20282",
    ratings: null,
    lat: 60.59703650140309,
    lng: 1.6020326124663562,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2282",
    tags: [],
    locationDescription:
      " The cat eats a tower happily. The teacher eats a fence silently. The man eats the horizon quickly.",
  },
  {
    locationId: "item20283",
    locationName: "item20283",
    locationAddress: "item20283",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 3.05 },
    ],
    lat: 54.765762461961515,
    lng: -2.5996837444950573,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2283",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man runs towards the horizon silently. A woman jumps over the cake silently. A dog writes the cake angrily.",
  },
  {
    locationId: "item20284",
    locationName: "item20284",
    locationAddress: "item20284",
    ratings: null,
    lat: 50.507824607109676,
    lng: 0.2727201640662038,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2284",
    tags: [],
    locationDescription: " A dog builds a fence happily.",
  },
  {
    locationId: "item20285",
    locationName: "item20285",
    locationAddress: "item20285",
    ratings: null,
    lat: 51.6171503869763,
    lng: -6.677110786961241,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2285",
    tags: [],
    locationDescription:
      " A dog writes the cake lazily. The man jumps over the road quickly.",
  },
  {
    locationId: "item20286",
    locationName: "item20286",
    locationAddress: "item20286",
    ratings: null,
    lat: 59.570731635401856,
    lng: -6.806477133206251,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2286",
    tags: [],
    locationDescription:
      " A woman writes the cake silently. A woman writes the road silently. A woman jumps over a tower happily.",
  },
  {
    locationId: "item20287",
    locationName: "item20287",
    locationAddress: "item20287",
    ratings: null,
    lat: 51.28748407784824,
    lng: -7.411633646792265,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2287",
    tags: [],
    locationDescription:
      " A dog looks at a tower angrily. The student jumps over a fence silently. The teacher runs towards the cake happily.",
  },
  {
    locationId: "item20288",
    locationName: "item20288",
    locationAddress: "item20288",
    ratings: null,
    lat: 52.5589953763142,
    lng: 0.0749683264804677,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2288",
    tags: [],
    locationDescription:
      " A woman jumps over a tower angrily. A woman eats the road happily. The teacher jumps over the road lazily. The teacher writes a book silently. The man eats a fence quickly.",
  },
  {
    locationId: "item20289",
    locationName: "item20289",
    locationAddress: "item20289",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 0.36 },
    ],
    lat: 54.789062396528564,
    lng: -3.3568813963264494,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2289",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats a fence angrily. The student jumps over a fence angrily. The cat writes the cake silently. The student looks at a fence silently.",
  },
  {
    locationId: "item20290",
    locationName: "item20290",
    locationAddress: "item20290",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 4.23 },
    ],
    lat: 58.421543102341346,
    lng: -8.523269515866575,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2290",
    tags: [{ label: "accessible" }],
    locationDescription: " The student runs towards the cake gracefully.",
  },
  {
    locationId: "item20291",
    locationName: "item20291",
    locationAddress: "item20291",
    ratings: [
      { who: "Similar identities", rating: 1.01 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 54.15329544401109,
    lng: -5.6056977917214486,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2291",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The cat jumps over the cake gracefully.",
  },
  {
    locationId: "item20292",
    locationName: "item20292",
    locationAddress: "item20292",
    ratings: [
      { who: "Similar identities", rating: 3.44 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 53.11461626723836,
    lng: 1.5812710396205478,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2292",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats a book lazily. A dog builds the horizon silently.",
  },
  {
    locationId: "item20293",
    locationName: "item20293",
    locationAddress: "item20293",
    ratings: [
      { who: "Similar identities", rating: 3.52 },
      { who: "All perspectives", rating: 1.18 },
    ],
    lat: 56.36796366238057,
    lng: -2.8362735723337336,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2293",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a book lazily. The teacher looks at the horizon gracefully. The man eats a book happily.",
  },
  {
    locationId: "item20294",
    locationName: "item20294",
    locationAddress: "item20294",
    ratings: [
      { who: "Similar identities", rating: 4.6 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 59.14441185638856,
    lng: 0.9607640276811278,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2294",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher jumps over a tower angrily.",
  },
  {
    locationId: "item20295",
    locationName: "item20295",
    locationAddress: "item20295",
    ratings: null,
    lat: 51.588594293546194,
    lng: -4.991653077572245,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2295",
    tags: [],
    locationDescription:
      " The man looks at the horizon lazily. The man looks at the horizon angrily. The student builds the cake gracefully.",
  },
  {
    locationId: "item20296",
    locationName: "item20296",
    locationAddress: "item20296",
    ratings: null,
    lat: 58.72807482031069,
    lng: 1.5464015344165443,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2296",
    tags: [],
    locationDescription:
      " The student eats a fence quickly. The man looks at the road silently. The man builds a book quickly. A woman runs towards the road lazily. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item20297",
    locationName: "item20297",
    locationAddress: "item20297",
    ratings: null,
    lat: 49.93429771522138,
    lng: -3.8547772936214146,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2297",
    tags: [],
    locationDescription:
      " A woman looks at the cake gracefully. A dog writes the road happily. The man builds a book angrily. The man runs towards a tower silently. A dog runs towards the road happily.",
  },
  {
    locationId: "item20298",
    locationName: "item20298",
    locationAddress: "item20298",
    ratings: [
      { who: "Similar identities", rating: 0.2 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 58.999761062465375,
    lng: -1.828393504169454,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2298",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat builds a tower silently. The teacher builds the cake angrily.",
  },
  {
    locationId: "item20299",
    locationName: "item20299",
    locationAddress: "item20299",
    ratings: null,
    lat: 60.58942779021931,
    lng: 0.25567115721763223,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2299",
    tags: [],
    locationDescription:
      " The teacher eats a fence angrily. The cat eats a tower silently.",
  },
  {
    locationId: "item20300",
    locationName: "item20300",
    locationAddress: "item20300",
    ratings: null,
    lat: 51.54646578106893,
    lng: 0.877986803826774,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2300",
    tags: [],
    locationDescription:
      " The man writes a tower happily. A dog jumps over a fence quickly. The cat looks at the cake lazily. A woman builds the horizon gracefully.",
  },
  {
    locationId: "item20301",
    locationName: "item20301",
    locationAddress: "item20301",
    ratings: [
      { who: "Similar identities", rating: 1.35 },
      { who: "All perspectives", rating: 2.43 },
    ],
    lat: 52.8029140847745,
    lng: -4.058911283684541,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2301",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A woman writes the horizon angrily. A woman looks at the road gracefully.",
  },
  {
    locationId: "item20302",
    locationName: "item20302",
    locationAddress: "item20302",
    ratings: null,
    lat: 60.29404226614351,
    lng: -1.3709389768683966,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2302",
    tags: [],
    locationDescription:
      " A dog builds a tower happily. The student builds a tower happily.",
  },
  {
    locationId: "item20303",
    locationName: "item20303",
    locationAddress: "item20303",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 0.31 },
    ],
    lat: 52.863822058990756,
    lng: -0.04379367921734101,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2303",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman builds a tower gracefully.",
  },
  {
    locationId: "item20304",
    locationName: "item20304",
    locationAddress: "item20304",
    ratings: null,
    lat: 59.96921797543233,
    lng: 0.6691278593640675,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2304",
    tags: [],
    locationDescription:
      " The cat looks at the horizon lazily. The man eats the horizon gracefully. A dog looks at a tower happily. A dog jumps over the cake happily. A dog writes the road silently.",
  },
  {
    locationId: "item20305",
    locationName: "item20305",
    locationAddress: "item20305",
    ratings: null,
    lat: 56.98296768495942,
    lng: -5.0423096706872235,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2305",
    tags: [],
    locationDescription:
      " The teacher eats a fence angrily. A woman jumps over a fence silently.",
  },
  {
    locationId: "item20306",
    locationName: "item20306",
    locationAddress: "item20306",
    ratings: [
      { who: "Similar identities", rating: 1.99 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 59.30047159131564,
    lng: 0.2642347971914205,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2306",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman eats the cake silently. The student looks at the road lazily. The cat writes a fence lazily. The student writes the horizon silently. The student eats a tower happily.",
  },
  {
    locationId: "item20307",
    locationName: "item20307",
    locationAddress: "item20307",
    ratings: null,
    lat: 52.46756243343115,
    lng: -6.958095355123495,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2307",
    tags: [],
    locationDescription:
      " A woman builds the road lazily. The teacher jumps over a book quickly. The teacher writes the cake angrily. The student builds a book gracefully.",
  },
  {
    locationId: "item20308",
    locationName: "item20308",
    locationAddress: "item20308",
    ratings: null,
    lat: 56.33840330041261,
    lng: -3.583194361883627,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2308",
    tags: [],
    locationDescription:
      " The man eats a book angrily. The man looks at the road lazily.",
  },
  {
    locationId: "item20309",
    locationName: "item20309",
    locationAddress: "item20309",
    ratings: null,
    lat: 56.13377211995851,
    lng: -0.9538631894235303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2309",
    tags: [],
    locationDescription:
      " A dog jumps over a fence lazily. A dog runs towards a tower angrily.",
  },
  {
    locationId: "item20310",
    locationName: "item20310",
    locationAddress: "item20310",
    ratings: null,
    lat: 53.10937711588933,
    lng: -2.537632162452076,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2310",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence silently. The man looks at the cake quickly.",
  },
  {
    locationId: "item20311",
    locationName: "item20311",
    locationAddress: "item20311",
    ratings: null,
    lat: 50.777787536629894,
    lng: -3.776276758735407,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2311",
    tags: [],
    locationDescription:
      " The student writes the horizon lazily. The student looks at a tower silently. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item20312",
    locationName: "item20312",
    locationAddress: "item20312",
    ratings: null,
    lat: 59.5125485309618,
    lng: -1.8931630478549168,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2312",
    tags: [],
    locationDescription: " The man jumps over a tower gracefully.",
  },
  {
    locationId: "item20313",
    locationName: "item20313",
    locationAddress: "item20313",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 54.830898634780205,
    lng: 1.4366076979709597,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2313",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards a fence happily. A dog looks at a fence lazily. The student runs towards a tower gracefully. A woman runs towards the road gracefully.",
  },
  {
    locationId: "item20314",
    locationName: "item20314",
    locationAddress: "item20314",
    ratings: null,
    lat: 60.7402615196174,
    lng: 1.5432229763551195,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2314",
    tags: [],
    locationDescription:
      " The cat looks at a book gracefully. A dog writes the horizon lazily.",
  },
  {
    locationId: "item20315",
    locationName: "item20315",
    locationAddress: "item20315",
    ratings: [
      { who: "Similar identities", rating: 1.76 },
      { who: "All perspectives", rating: 2.78 },
    ],
    lat: 58.47353113182243,
    lng: -7.889547560678718,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2315",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The teacher writes the horizon quickly.",
  },
  {
    locationId: "item20316",
    locationName: "item20316",
    locationAddress: "item20316",
    ratings: null,
    lat: 57.226719902569855,
    lng: 1.2060982867870287,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2316",
    tags: [],
    locationDescription: " The student jumps over a fence happily.",
  },
  {
    locationId: "item20317",
    locationName: "item20317",
    locationAddress: "item20317",
    ratings: [
      { who: "Similar identities", rating: 2.91 },
      { who: "All perspectives", rating: 3.45 },
    ],
    lat: 51.72209006142823,
    lng: -8.391491036063172,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2317",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog jumps over the road quickly.",
  },
  {
    locationId: "item20318",
    locationName: "item20318",
    locationAddress: "item20318",
    ratings: [
      { who: "Similar identities", rating: 3.36 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 54.96271419978049,
    lng: -8.027597399901746,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2318",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher runs towards the cake quickly. The man writes the cake happily. The man builds a book quickly. The man eats a fence lazily.",
  },
  {
    locationId: "item20319",
    locationName: "item20319",
    locationAddress: "item20319",
    ratings: null,
    lat: 54.729423323958414,
    lng: -4.478631472716023,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2319",
    tags: [],
    locationDescription: " The cat writes the road angrily.",
  },
  {
    locationId: "item20320",
    locationName: "item20320",
    locationAddress: "item20320",
    ratings: null,
    lat: 52.77854675142646,
    lng: -1.7607260342239135,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2320",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake angrily. The cat jumps over a tower gracefully. The man eats a tower quickly.",
  },
  {
    locationId: "item20321",
    locationName: "item20321",
    locationAddress: "item20321",
    ratings: null,
    lat: 51.43496959647185,
    lng: -7.40874360292376,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2321",
    tags: [],
    locationDescription:
      " The man builds the cake quickly. The student jumps over the road happily.",
  },
  {
    locationId: "item20322",
    locationName: "item20322",
    locationAddress: "item20322",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 2.46 },
    ],
    lat: 58.83479191674961,
    lng: -1.6101633634206873,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2322",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog eats a book lazily. The cat builds the road lazily. The cat builds a book silently. A woman builds a fence silently. A dog writes the cake angrily.",
  },
  {
    locationId: "item20323",
    locationName: "item20323",
    locationAddress: "item20323",
    ratings: null,
    lat: 51.55232251055497,
    lng: -4.794713395606393,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2323",
    tags: [],
    locationDescription:
      " The man builds a tower silently. A dog jumps over the horizon angrily. A woman jumps over the road gracefully. The student looks at a fence angrily.",
  },
  {
    locationId: "item20324",
    locationName: "item20324",
    locationAddress: "item20324",
    ratings: [
      { who: "Similar identities", rating: 3.47 },
      { who: "All perspectives", rating: 0.58 },
    ],
    lat: 59.97145882494675,
    lng: -0.9678152356909591,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2324",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man writes a tower angrily.",
  },
  {
    locationId: "item20325",
    locationName: "item20325",
    locationAddress: "item20325",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 50.965498961258575,
    lng: -7.752759507465469,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2325",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man jumps over a fence lazily. The student builds a book angrily. A woman builds a fence silently. The student runs towards the horizon angrily.",
  },
  {
    locationId: "item20326",
    locationName: "item20326",
    locationAddress: "item20326",
    ratings: [
      { who: "Similar identities", rating: 1.43 },
      { who: "All perspectives", rating: 2.15 },
    ],
    lat: 60.06720461827963,
    lng: -3.025833932170369,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2326",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat eats a fence lazily.",
  },
  {
    locationId: "item20327",
    locationName: "item20327",
    locationAddress: "item20327",
    ratings: null,
    lat: 59.66165981896023,
    lng: -0.44365360946131993,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2327",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon angrily. The man builds a book quickly.",
  },
  {
    locationId: "item20328",
    locationName: "item20328",
    locationAddress: "item20328",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 53.766316351386955,
    lng: -5.933158384847989,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2328",
    tags: [{ label: "accessible" }],
    locationDescription: " The man looks at a book gracefully.",
  },
  {
    locationId: "item20329",
    locationName: "item20329",
    locationAddress: "item20329",
    ratings: [
      { who: "Similar identities", rating: 1.57 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 60.17478856826997,
    lng: -7.881601496204822,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2329",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman eats the horizon gracefully. A woman jumps over the cake gracefully.",
  },
  {
    locationId: "item20330",
    locationName: "item20330",
    locationAddress: "item20330",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 3.27 },
    ],
    lat: 53.38499515360791,
    lng: 0.553838382860194,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2330",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes a tower gracefully. The cat runs towards a tower happily. The teacher looks at a fence lazily. A dog eats a tower silently. The man jumps over a tower gracefully.",
  },
  {
    locationId: "item20331",
    locationName: "item20331",
    locationAddress: "item20331",
    ratings: null,
    lat: 54.81807353195103,
    lng: -4.29512953705204,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2331",
    tags: [],
    locationDescription:
      " The teacher jumps over the road quickly. The cat runs towards a book lazily. The man jumps over a book gracefully. The cat builds a tower lazily. The teacher runs towards the horizon lazily.",
  },
  {
    locationId: "item20332",
    locationName: "item20332",
    locationAddress: "item20332",
    ratings: [
      { who: "Similar identities", rating: 0.87 },
      { who: "All perspectives", rating: 1.36 },
    ],
    lat: 52.6602638557061,
    lng: -8.45323086950601,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2332",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog builds a book angrily.",
  },
  {
    locationId: "item20333",
    locationName: "item20333",
    locationAddress: "item20333",
    ratings: null,
    lat: 57.96145228393671,
    lng: -2.5480354445253104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2333",
    tags: [],
    locationDescription:
      " A dog looks at a book gracefully. The student writes the road lazily.",
  },
  {
    locationId: "item20334",
    locationName: "item20334",
    locationAddress: "item20334",
    ratings: null,
    lat: 54.99764559434892,
    lng: 1.1908422868411623,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2334",
    tags: [],
    locationDescription:
      " A dog builds the cake gracefully. The teacher eats the cake angrily.",
  },
  {
    locationId: "item20335",
    locationName: "item20335",
    locationAddress: "item20335",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 3.81 },
    ],
    lat: 52.30119544177518,
    lng: 0.5964048090359597,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2335",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man writes a tower gracefully. The cat jumps over a fence silently. A woman builds the horizon gracefully. A woman runs towards the horizon gracefully.",
  },
  {
    locationId: "item20336",
    locationName: "item20336",
    locationAddress: "item20336",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 4.1 },
    ],
    lat: 53.59665923093368,
    lng: -4.660660832645573,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2336",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man runs towards the horizon happily. A dog eats the road silently.",
  },
  {
    locationId: "item20337",
    locationName: "item20337",
    locationAddress: "item20337",
    ratings: [
      { who: "Similar identities", rating: 3.26 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 51.79774425597244,
    lng: -6.102510046259863,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2337",
    tags: [{ label: "child friendly" }],
    locationDescription: " The student builds the road happily.",
  },
  {
    locationId: "item20338",
    locationName: "item20338",
    locationAddress: "item20338",
    ratings: null,
    lat: 55.04433019293106,
    lng: 0.5219151188726308,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2338",
    tags: [],
    locationDescription:
      " A dog jumps over the cake silently. A woman writes a tower gracefully.",
  },
  {
    locationId: "item20339",
    locationName: "item20339",
    locationAddress: "item20339",
    ratings: null,
    lat: 53.951650716866894,
    lng: -7.939158285425417,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2339",
    tags: [],
    locationDescription:
      " The teacher builds the cake lazily. The student jumps over a book quickly. The man jumps over the horizon quickly. A dog looks at the horizon happily. The man looks at a tower gracefully.",
  },
  {
    locationId: "item20340",
    locationName: "item20340",
    locationAddress: "item20340",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 3.36 },
    ],
    lat: 50.54137303520211,
    lng: 0.7250832612164793,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2340",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student builds the cake gracefully. The teacher jumps over the horizon gracefully.",
  },
  {
    locationId: "item20341",
    locationName: "item20341",
    locationAddress: "item20341",
    ratings: [
      { who: "Similar identities", rating: 4.44 },
      { who: "All perspectives", rating: 3.28 },
    ],
    lat: 51.46171217843097,
    lng: -4.277533909172018,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2341",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat looks at the road gracefully. A woman looks at a book silently. The student builds the horizon gracefully. A woman jumps over the cake lazily.",
  },
  {
    locationId: "item20342",
    locationName: "item20342",
    locationAddress: "item20342",
    ratings: null,
    lat: 60.57158699199304,
    lng: -5.3210310575864135,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2342",
    tags: [],
    locationDescription: " The student eats a fence gracefully.",
  },
  {
    locationId: "item20343",
    locationName: "item20343",
    locationAddress: "item20343",
    ratings: null,
    lat: 58.17885141720237,
    lng: -0.8820635021926497,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2343",
    tags: [],
    locationDescription:
      " The student runs towards a tower quickly. The cat runs towards the road lazily. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item20344",
    locationName: "item20344",
    locationAddress: "item20344",
    ratings: null,
    lat: 54.48360309124964,
    lng: -1.533885723703353,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2344",
    tags: [],
    locationDescription: " The student eats the road happily.",
  },
  {
    locationId: "item20345",
    locationName: "item20345",
    locationAddress: "item20345",
    ratings: null,
    lat: 50.882340609491145,
    lng: -8.50757740631364,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2345",
    tags: [],
    locationDescription:
      " A woman runs towards the cake lazily. The cat looks at the horizon happily.",
  },
  {
    locationId: "item20346",
    locationName: "item20346",
    locationAddress: "item20346",
    ratings: null,
    lat: 53.25356191029696,
    lng: -6.876350368600129,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2346",
    tags: [],
    locationDescription:
      " A dog builds a book quickly. The student eats a book lazily. A dog writes the cake angrily.",
  },
  {
    locationId: "item20347",
    locationName: "item20347",
    locationAddress: "item20347",
    ratings: null,
    lat: 50.00377485217491,
    lng: -6.162227942338206,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2347",
    tags: [],
    locationDescription:
      " A woman eats the cake happily. A woman writes the cake angrily. A woman looks at a fence lazily.",
  },
  {
    locationId: "item20348",
    locationName: "item20348",
    locationAddress: "item20348",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 55.585382790337384,
    lng: 1.5565325554806098,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2348",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher eats the road lazily. The teacher eats a book gracefully.",
  },
  {
    locationId: "item20349",
    locationName: "item20349",
    locationAddress: "item20349",
    ratings: null,
    lat: 52.45108738422508,
    lng: -3.0927243075969475,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2349",
    tags: [],
    locationDescription:
      " The student eats a fence gracefully. The cat builds the horizon quickly. The cat looks at a book silently. A dog runs towards the cake quickly. A woman looks at a fence happily.",
  },
  {
    locationId: "item20350",
    locationName: "item20350",
    locationAddress: "item20350",
    ratings: null,
    lat: 51.76176837819611,
    lng: -2.048999867200025,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2350",
    tags: [],
    locationDescription:
      " The student eats the horizon happily. A woman eats a tower quickly.",
  },
  {
    locationId: "item20351",
    locationName: "item20351",
    locationAddress: "item20351",
    ratings: null,
    lat: 52.37061088559539,
    lng: -7.79913797257305,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2351",
    tags: [],
    locationDescription:
      " The cat builds the cake silently. The teacher writes a fence angrily. The teacher writes the horizon happily. The student builds the horizon lazily.",
  },
  {
    locationId: "item20352",
    locationName: "item20352",
    locationAddress: "item20352",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 2.02 },
    ],
    lat: 53.69330676942091,
    lng: -0.44369902103182035,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2352",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The man eats the horizon happily.",
  },
  {
    locationId: "item20353",
    locationName: "item20353",
    locationAddress: "item20353",
    ratings: [
      { who: "Similar identities", rating: 2.75 },
      { who: "All perspectives", rating: 2.08 },
    ],
    lat: 52.795034132400616,
    lng: -1.503704379625562,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2353",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat looks at the road silently. The student eats the road gracefully. The student writes the horizon lazily.",
  },
  {
    locationId: "item20354",
    locationName: "item20354",
    locationAddress: "item20354",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 2.35 },
    ],
    lat: 53.79732402232149,
    lng: -5.2482280945982716,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2354",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher eats a book silently. The man jumps over the cake lazily. The cat runs towards the horizon quickly. The teacher eats the road quickly. A dog looks at a book lazily.",
  },
  {
    locationId: "item20355",
    locationName: "item20355",
    locationAddress: "item20355",
    ratings: null,
    lat: 60.29595205463144,
    lng: 1.1432139308993072,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2355",
    tags: [],
    locationDescription:
      " A dog eats the cake lazily. A dog builds the cake lazily. A woman jumps over the road angrily. The man writes the horizon gracefully.",
  },
  {
    locationId: "item20356",
    locationName: "item20356",
    locationAddress: "item20356",
    ratings: null,
    lat: 52.17807483572324,
    lng: -3.939433067689004,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2356",
    tags: [],
    locationDescription:
      " The student jumps over the road gracefully. The teacher jumps over a book gracefully. A dog runs towards a tower lazily.",
  },
  {
    locationId: "item20357",
    locationName: "item20357",
    locationAddress: "item20357",
    ratings: null,
    lat: 55.85634970328143,
    lng: -5.241603716282189,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2357",
    tags: [],
    locationDescription:
      " The man looks at a fence gracefully. The student eats the road happily. The man writes a book happily. The cat eats a tower angrily.",
  },
  {
    locationId: "item20358",
    locationName: "item20358",
    locationAddress: "item20358",
    ratings: null,
    lat: 51.90408252039873,
    lng: -3.4107593020925684,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2358",
    tags: [],
    locationDescription:
      " The teacher builds the road lazily. The student runs towards a fence quickly. The cat builds a tower quickly. The cat builds the road gracefully. The teacher jumps over the road silently.",
  },
  {
    locationId: "item20359",
    locationName: "item20359",
    locationAddress: "item20359",
    ratings: null,
    lat: 57.28467475365868,
    lng: -7.908429096894446,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2359",
    tags: [],
    locationDescription: " The man builds a tower happily.",
  },
  {
    locationId: "item20360",
    locationName: "item20360",
    locationAddress: "item20360",
    ratings: null,
    lat: 57.0585879768271,
    lng: -4.040023943620686,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2360",
    tags: [],
    locationDescription:
      " The teacher runs towards the road happily. The man runs towards a tower lazily. The student jumps over a tower lazily. A woman builds a tower silently. A dog eats a fence lazily.",
  },
  {
    locationId: "item20361",
    locationName: "item20361",
    locationAddress: "item20361",
    ratings: [
      { who: "Similar identities", rating: 4.13 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 51.54805373566667,
    lng: -0.5366079814835114,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2361",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat builds the horizon happily. The cat looks at a fence angrily. The man writes a fence silently. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item20362",
    locationName: "item20362",
    locationAddress: "item20362",
    ratings: [
      { who: "Similar identities", rating: 4.96 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 57.82590525175716,
    lng: -6.235191669508439,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2362",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at a tower angrily. The cat builds the horizon happily. The cat builds a book happily. The student eats a book gracefully. The student jumps over the cake gracefully.",
  },
  {
    locationId: "item20363",
    locationName: "item20363",
    locationAddress: "item20363",
    ratings: [
      { who: "Similar identities", rating: 4.32 },
      { who: "All perspectives", rating: 1.2 },
    ],
    lat: 55.72413893433563,
    lng: -1.3193890424690853,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2363",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The man writes a fence happily. The man writes the cake happily. The student runs towards a tower quickly. The student eats a tower angrily.",
  },
  {
    locationId: "item20364",
    locationName: "item20364",
    locationAddress: "item20364",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 1.07 },
    ],
    lat: 57.89587266597151,
    lng: -8.568365941961012,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2364",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student eats a book gracefully. The man jumps over the road happily. The student eats the road happily. The man builds a tower gracefully. The cat eats a book angrily.",
  },
  {
    locationId: "item20365",
    locationName: "item20365",
    locationAddress: "item20365",
    ratings: [
      { who: "Similar identities", rating: 1.94 },
      { who: "All perspectives", rating: 3.82 },
    ],
    lat: 56.8646445878796,
    lng: 0.4339272932374403,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2365",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The teacher builds a book happily. The man looks at a book gracefully. A woman writes a fence lazily.",
  },
  {
    locationId: "item20366",
    locationName: "item20366",
    locationAddress: "item20366",
    ratings: null,
    lat: 57.89371602232909,
    lng: -3.001013017533624,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2366",
    tags: [],
    locationDescription:
      " The student writes the cake quickly. The cat looks at the road quickly. The student eats a book angrily. A dog eats the cake silently. The cat builds a tower quickly.",
  },
  {
    locationId: "item20367",
    locationName: "item20367",
    locationAddress: "item20367",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 2.14 },
    ],
    lat: 58.537463638596456,
    lng: -1.6337801000137668,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2367",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes a book angrily. A woman runs towards the cake quickly. The teacher builds a fence quickly. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20368",
    locationName: "item20368",
    locationAddress: "item20368",
    ratings: [
      { who: "Similar identities", rating: 3.32 },
      { who: "All perspectives", rating: 2.47 },
    ],
    lat: 58.84782957278082,
    lng: -6.3806536742415325,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2368",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The man builds the cake quickly. The student writes the horizon silently. The student builds the road silently. The man jumps over the cake quickly.",
  },
  {
    locationId: "item20369",
    locationName: "item20369",
    locationAddress: "item20369",
    ratings: null,
    lat: 53.34642741588663,
    lng: -0.12291192434421028,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2369",
    tags: [],
    locationDescription: " The cat looks at the horizon gracefully.",
  },
  {
    locationId: "item20370",
    locationName: "item20370",
    locationAddress: "item20370",
    ratings: null,
    lat: 51.38597249718559,
    lng: -3.13135172920742,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2370",
    tags: [],
    locationDescription:
      " The man eats the cake happily. The cat writes a tower silently. The cat looks at a book gracefully. A dog builds a fence angrily.",
  },
  {
    locationId: "item20371",
    locationName: "item20371",
    locationAddress: "item20371",
    ratings: null,
    lat: 50.89041983933577,
    lng: -4.5556487459599415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2371",
    tags: [],
    locationDescription:
      " The student looks at the cake happily. The student writes a tower lazily. The man writes a book quickly.",
  },
  {
    locationId: "item20372",
    locationName: "item20372",
    locationAddress: "item20372",
    ratings: null,
    lat: 54.84031813597696,
    lng: -1.8635497507673966,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2372",
    tags: [],
    locationDescription:
      " The student writes a fence angrily. The cat eats the horizon angrily.",
  },
  {
    locationId: "item20373",
    locationName: "item20373",
    locationAddress: "item20373",
    ratings: [
      { who: "Similar identities", rating: 0.07 },
      { who: "All perspectives", rating: 4.87 },
    ],
    lat: 54.77097258238234,
    lng: -6.1408039502092695,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2373",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man eats the cake silently. The man jumps over a tower gracefully. A woman jumps over the road lazily. A woman writes the road angrily. The student eats the horizon quickly.",
  },
  {
    locationId: "item20374",
    locationName: "item20374",
    locationAddress: "item20374",
    ratings: null,
    lat: 59.3743581060549,
    lng: -8.50216956092362,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2374",
    tags: [],
    locationDescription:
      " The man builds the road silently. The teacher looks at a tower quickly.",
  },
  {
    locationId: "item20375",
    locationName: "item20375",
    locationAddress: "item20375",
    ratings: null,
    lat: 53.53562173582341,
    lng: -8.584775985527305,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2375",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. The student builds the cake happily. The student runs towards a fence quickly. A woman builds a fence lazily. The teacher builds the horizon gracefully.",
  },
  {
    locationId: "item20376",
    locationName: "item20376",
    locationAddress: "item20376",
    ratings: [
      { who: "Similar identities", rating: 3.62 },
      { who: "All perspectives", rating: 2.05 },
    ],
    lat: 55.80864436616916,
    lng: -6.124145229665693,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2376",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman looks at the cake silently. A dog writes a book silently. The man looks at the road quickly. A dog eats the cake happily. The man looks at the road happily.",
  },
  {
    locationId: "item20377",
    locationName: "item20377",
    locationAddress: "item20377",
    ratings: [
      { who: "Similar identities", rating: 2.81 },
      { who: "All perspectives", rating: 0.48 },
    ],
    lat: 55.38259881900784,
    lng: -6.630019602595058,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2377",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The cat looks at a tower angrily.",
  },
  {
    locationId: "item20378",
    locationName: "item20378",
    locationAddress: "item20378",
    ratings: null,
    lat: 50.65144297546854,
    lng: -8.09341748567434,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2378",
    tags: [],
    locationDescription: " The cat runs towards a fence angrily.",
  },
  {
    locationId: "item20379",
    locationName: "item20379",
    locationAddress: "item20379",
    ratings: null,
    lat: 55.648073220929916,
    lng: 0.6916655567205012,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2379",
    tags: [],
    locationDescription:
      " The cat runs towards the road silently. A dog writes a fence lazily.",
  },
  {
    locationId: "item20380",
    locationName: "item20380",
    locationAddress: "item20380",
    ratings: null,
    lat: 57.600670968887485,
    lng: -0.6008088053708045,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2380",
    tags: [],
    locationDescription: " The student writes the cake lazily.",
  },
  {
    locationId: "item20381",
    locationName: "item20381",
    locationAddress: "item20381",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 2.69 },
    ],
    lat: 57.08589995313584,
    lng: -7.659555992938352,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2381",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher builds the road gracefully. A woman eats a fence happily. The teacher builds the road lazily.",
  },
  {
    locationId: "item20382",
    locationName: "item20382",
    locationAddress: "item20382",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 2.44 },
    ],
    lat: 58.34748314936435,
    lng: 1.332781338511472,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2382",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman eats a book happily. The teacher eats a book angrily. A dog runs towards a tower silently. A woman runs towards the road silently.",
  },
  {
    locationId: "item20383",
    locationName: "item20383",
    locationAddress: "item20383",
    ratings: null,
    lat: 50.623491065267494,
    lng: -6.556479763201075,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2383",
    tags: [],
    locationDescription:
      " The teacher builds the road quickly. The man looks at a tower lazily. The man runs towards the road quickly.",
  },
  {
    locationId: "item20384",
    locationName: "item20384",
    locationAddress: "item20384",
    ratings: null,
    lat: 60.12496185515403,
    lng: -1.8082012765770887,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2384",
    tags: [],
    locationDescription:
      " The cat writes the road gracefully. A dog jumps over a book quickly. The man runs towards a book gracefully. The student jumps over the horizon quickly.",
  },
  {
    locationId: "item20385",
    locationName: "item20385",
    locationAddress: "item20385",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 54.35528507315716,
    lng: -7.495479784358224,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2385",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher eats the road lazily. A dog looks at the horizon silently. The man builds the road lazily. A dog eats the horizon happily.",
  },
  {
    locationId: "item20386",
    locationName: "item20386",
    locationAddress: "item20386",
    ratings: null,
    lat: 57.951243176347035,
    lng: 0.5452440833994352,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2386",
    tags: [],
    locationDescription:
      " A dog looks at a book silently. The teacher runs towards the road silently. A dog runs towards the road happily. The teacher builds the cake quickly. The student writes a fence gracefully.",
  },
  {
    locationId: "item20387",
    locationName: "item20387",
    locationAddress: "item20387",
    ratings: [
      { who: "Similar identities", rating: 0.61 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 54.66082691438269,
    lng: -8.02351137021975,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2387",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats the cake silently. The cat runs towards a tower gracefully.",
  },
  {
    locationId: "item20388",
    locationName: "item20388",
    locationAddress: "item20388",
    ratings: null,
    lat: 58.69215593867027,
    lng: -4.307283212118089,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2388",
    tags: [],
    locationDescription:
      " A woman writes the cake silently. A woman looks at the cake gracefully. The teacher writes a fence lazily.",
  },
  {
    locationId: "item20389",
    locationName: "item20389",
    locationAddress: "item20389",
    ratings: null,
    lat: 58.44585345596778,
    lng: 1.638299382885414,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2389",
    tags: [],
    locationDescription:
      " A dog eats a fence quickly. The teacher writes the horizon lazily. A dog writes a tower gracefully.",
  },
  {
    locationId: "item20390",
    locationName: "item20390",
    locationAddress: "item20390",
    ratings: null,
    lat: 54.35058709931644,
    lng: -6.52683942047952,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2390",
    tags: [],
    locationDescription:
      " The teacher writes the cake lazily. A woman writes a fence quickly. The student eats the cake happily. A dog builds a fence lazily. The cat writes the cake gracefully.",
  },
  {
    locationId: "item20391",
    locationName: "item20391",
    locationAddress: "item20391",
    ratings: [
      { who: "Similar identities", rating: 3.61 },
      { who: "All perspectives", rating: 0.71 },
    ],
    lat: 56.12280345803775,
    lng: -2.295202077130229,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2391",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman jumps over a fence angrily. A dog builds a tower angrily.",
  },
  {
    locationId: "item20392",
    locationName: "item20392",
    locationAddress: "item20392",
    ratings: null,
    lat: 56.2361135545961,
    lng: -5.7462561786748285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2392",
    tags: [],
    locationDescription:
      " A dog runs towards the cake quickly. The student jumps over the horizon happily. A dog writes the road quickly. A dog runs towards a book gracefully. The student builds the road silently.",
  },
  {
    locationId: "item20393",
    locationName: "item20393",
    locationAddress: "item20393",
    ratings: null,
    lat: 58.54418793557895,
    lng: 0.7652015139536612,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2393",
    tags: [],
    locationDescription:
      " A woman writes the road quickly. A woman writes the cake gracefully. The teacher eats a tower gracefully. A woman jumps over a book silently.",
  },
  {
    locationId: "item20394",
    locationName: "item20394",
    locationAddress: "item20394",
    ratings: null,
    lat: 59.69079478489623,
    lng: -5.046273605763409,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2394",
    tags: [],
    locationDescription:
      " The teacher writes a tower lazily. The student looks at a fence silently. The man looks at the road quickly. The cat builds a tower happily. A dog writes the road lazily.",
  },
  {
    locationId: "item20395",
    locationName: "item20395",
    locationAddress: "item20395",
    ratings: null,
    lat: 52.149478964730136,
    lng: 0.18849105398089527,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2395",
    tags: [],
    locationDescription:
      " A dog jumps over the cake quickly. The student writes the road quickly. A woman looks at a fence angrily. The student writes a fence lazily. The cat writes a fence silently.",
  },
  {
    locationId: "item20396",
    locationName: "item20396",
    locationAddress: "item20396",
    ratings: null,
    lat: 55.71782799815165,
    lng: -0.9720544362083725,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2396",
    tags: [],
    locationDescription:
      " The cat jumps over the road silently. The man builds a fence silently. A dog jumps over the horizon happily. The student runs towards the cake silently. The teacher eats the horizon gracefully.",
  },
  {
    locationId: "item20397",
    locationName: "item20397",
    locationAddress: "item20397",
    ratings: [
      { who: "Similar identities", rating: 2.5 },
      { who: "All perspectives", rating: 0.91 },
    ],
    lat: 52.082295936541215,
    lng: -6.8949239815515,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2397",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat builds a book happily. The man runs towards the cake lazily.",
  },
  {
    locationId: "item20398",
    locationName: "item20398",
    locationAddress: "item20398",
    ratings: [
      { who: "Similar identities", rating: 0.26 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 50.875664152287364,
    lng: -7.734485697899068,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2398",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman jumps over the horizon angrily.",
  },
  {
    locationId: "item20399",
    locationName: "item20399",
    locationAddress: "item20399",
    ratings: [
      { who: "Similar identities", rating: 3.26 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 59.840171431615744,
    lng: 1.3311172692469384,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2399",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards the cake happily. The cat jumps over the cake happily. The student builds the horizon gracefully. A dog jumps over a tower happily. A woman builds the cake lazily.",
  },
  {
    locationId: "item20400",
    locationName: "item20400",
    locationAddress: "item20400",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 57.125446641037726,
    lng: -5.405437002197303,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2400",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman eats a book happily. The teacher builds the road quickly. The teacher writes the horizon gracefully.",
  },
  {
    locationId: "item20401",
    locationName: "item20401",
    locationAddress: "item20401",
    ratings: null,
    lat: 57.23349190027955,
    lng: -7.120492490244063,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2401",
    tags: [],
    locationDescription: " A woman eats the horizon gracefully.",
  },
  {
    locationId: "item20402",
    locationName: "item20402",
    locationAddress: "item20402",
    ratings: null,
    lat: 57.382668141660076,
    lng: -2.959567091706411,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2402",
    tags: [],
    locationDescription:
      " The student runs towards a tower quickly. The student builds the horizon quickly. The cat looks at a tower happily. A woman eats a tower quickly.",
  },
  {
    locationId: "item20403",
    locationName: "item20403",
    locationAddress: "item20403",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 51.893873809661066,
    lng: -1.5547617393684892,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2403",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher runs towards the cake gracefully.",
  },
  {
    locationId: "item20404",
    locationName: "item20404",
    locationAddress: "item20404",
    ratings: null,
    lat: 60.10343736855016,
    lng: -2.4112811486184818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2404",
    tags: [],
    locationDescription: " A woman builds a tower angrily.",
  },
  {
    locationId: "item20405",
    locationName: "item20405",
    locationAddress: "item20405",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 1.19 },
    ],
    lat: 56.56702363539905,
    lng: -7.759891661994182,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2405",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman writes a fence quickly. The student builds the horizon happily.",
  },
  {
    locationId: "item20406",
    locationName: "item20406",
    locationAddress: "item20406",
    ratings: [
      { who: "Similar identities", rating: 4.83 },
      { who: "All perspectives", rating: 3.91 },
    ],
    lat: 51.39043329023871,
    lng: -4.72076012046497,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2406",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog looks at the cake lazily.",
  },
  {
    locationId: "item20407",
    locationName: "item20407",
    locationAddress: "item20407",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 2.12 },
    ],
    lat: 60.89849676603738,
    lng: -2.979453865538324,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2407",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at a fence angrily. The cat looks at the road angrily. The student writes a fence silently. The cat eats a fence lazily.",
  },
  {
    locationId: "item20408",
    locationName: "item20408",
    locationAddress: "item20408",
    ratings: null,
    lat: 60.33540339439467,
    lng: -6.198363627243294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2408",
    tags: [],
    locationDescription: " A woman eats a fence happily.",
  },
  {
    locationId: "item20409",
    locationName: "item20409",
    locationAddress: "item20409",
    ratings: null,
    lat: 59.425659217207965,
    lng: -6.738392103664612,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2409",
    tags: [],
    locationDescription:
      " The cat writes a book angrily. The student runs towards a book silently.",
  },
  {
    locationId: "item20410",
    locationName: "item20410",
    locationAddress: "item20410",
    ratings: [
      { who: "Similar identities", rating: 2.77 },
      { who: "All perspectives", rating: 3.95 },
    ],
    lat: 60.237817596740214,
    lng: -1.376517975980284,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2410",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The teacher eats a fence silently. The student builds a fence silently. The student writes the cake lazily. The teacher writes the horizon silently.",
  },
  {
    locationId: "item20411",
    locationName: "item20411",
    locationAddress: "item20411",
    ratings: null,
    lat: 55.2486939163305,
    lng: -4.018067455186351,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2411",
    tags: [],
    locationDescription:
      " A woman runs towards the road quickly. The cat writes the cake happily. The student builds the horizon happily. A dog looks at the road quickly.",
  },
  {
    locationId: "item20412",
    locationName: "item20412",
    locationAddress: "item20412",
    ratings: null,
    lat: 54.24865532470925,
    lng: -3.3999823695123412,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2412",
    tags: [],
    locationDescription:
      " The student jumps over a tower silently. The student runs towards the horizon happily. The student writes a book gracefully.",
  },
  {
    locationId: "item20413",
    locationName: "item20413",
    locationAddress: "item20413",
    ratings: [
      { who: "Similar identities", rating: 0.65 },
      { who: "All perspectives", rating: 2.48 },
    ],
    lat: 51.606078653135654,
    lng: -3.0018582084347374,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2413",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student builds the road happily. A woman runs towards the road quickly. The student jumps over a book gracefully.",
  },
  {
    locationId: "item20414",
    locationName: "item20414",
    locationAddress: "item20414",
    ratings: null,
    lat: 54.89473994710837,
    lng: -1.2547335757662283,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2414",
    tags: [],
    locationDescription:
      " A dog jumps over the cake lazily. The man looks at a tower gracefully. A dog eats a fence gracefully. The student eats the cake silently. The student eats the horizon gracefully.",
  },
  {
    locationId: "item20415",
    locationName: "item20415",
    locationAddress: "item20415",
    ratings: null,
    lat: 56.12892302726388,
    lng: -8.513735422730301,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2415",
    tags: [],
    locationDescription:
      " A woman writes the road angrily. A woman looks at a book gracefully. The teacher builds the horizon lazily. A woman writes the road happily. A dog builds a book gracefully.",
  },
  {
    locationId: "item20416",
    locationName: "item20416",
    locationAddress: "item20416",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 3.72 },
    ],
    lat: 52.843151984900516,
    lng: -1.470589481268438,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2416",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at the cake silently. A dog runs towards the road angrily. The student eats the horizon silently.",
  },
  {
    locationId: "item20417",
    locationName: "item20417",
    locationAddress: "item20417",
    ratings: null,
    lat: 54.80915300174345,
    lng: 1.639189188814088,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2417",
    tags: [],
    locationDescription:
      " The student looks at a tower gracefully. The man jumps over the cake lazily. The man builds a tower happily. A woman builds a book happily. The cat runs towards a book angrily.",
  },
  {
    locationId: "item20418",
    locationName: "item20418",
    locationAddress: "item20418",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 0.39 },
    ],
    lat: 59.45063464534204,
    lng: -4.47007899825261,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2418",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A woman writes a book silently. A woman eats the cake angrily.",
  },
  {
    locationId: "item20419",
    locationName: "item20419",
    locationAddress: "item20419",
    ratings: null,
    lat: 53.10703488296722,
    lng: 0.9103591202480867,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2419",
    tags: [],
    locationDescription: " A woman eats a tower gracefully.",
  },
  {
    locationId: "item20420",
    locationName: "item20420",
    locationAddress: "item20420",
    ratings: [
      { who: "Similar identities", rating: 3.46 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 58.30354975175425,
    lng: -1.7013469617906951,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2420",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over the cake silently. A dog eats a tower happily. The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item20421",
    locationName: "item20421",
    locationAddress: "item20421",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 58.76385044214405,
    lng: 1.1856613277765842,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2421",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds a fence angrily. The cat runs towards a tower silently.",
  },
  {
    locationId: "item20422",
    locationName: "item20422",
    locationAddress: "item20422",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 59.74932644095087,
    lng: -7.55375303791465,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2422",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes the road angrily. A dog looks at the cake angrily. A dog looks at a tower silently.",
  },
  {
    locationId: "item20423",
    locationName: "item20423",
    locationAddress: "item20423",
    ratings: null,
    lat: 54.319276044615016,
    lng: -3.645342808345495,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2423",
    tags: [],
    locationDescription:
      " The man runs towards the cake happily. The man builds the road gracefully. The cat builds a tower quickly.",
  },
  {
    locationId: "item20424",
    locationName: "item20424",
    locationAddress: "item20424",
    ratings: null,
    lat: 60.15004904057013,
    lng: -1.436204852206882,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2424",
    tags: [],
    locationDescription: " A woman runs towards the cake gracefully.",
  },
  {
    locationId: "item20425",
    locationName: "item20425",
    locationAddress: "item20425",
    ratings: null,
    lat: 58.005443923562595,
    lng: -5.649406021539567,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2425",
    tags: [],
    locationDescription:
      " The cat writes a tower angrily. The student runs towards the cake angrily. A woman jumps over the cake gracefully. A woman jumps over the horizon angrily.",
  },
  {
    locationId: "item20426",
    locationName: "item20426",
    locationAddress: "item20426",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 3.9 },
    ],
    lat: 50.24662138770922,
    lng: -7.995951531308151,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2426",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman runs towards the road lazily. The teacher looks at the horizon angrily.",
  },
  {
    locationId: "item20427",
    locationName: "item20427",
    locationAddress: "item20427",
    ratings: [
      { who: "Similar identities", rating: 2.16 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 60.65372143322474,
    lng: -3.9369808450622585,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2427",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat eats the road silently. The student eats the horizon happily. A woman writes a tower silently. A woman writes the road silently.",
  },
  {
    locationId: "item20428",
    locationName: "item20428",
    locationAddress: "item20428",
    ratings: [
      { who: "Similar identities", rating: 2.27 },
      { who: "All perspectives", rating: 0.34 },
    ],
    lat: 60.37258536955258,
    lng: -6.093136979500801,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2428",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student jumps over the horizon angrily. A dog jumps over a book angrily. The man looks at a tower angrily. A woman runs towards the horizon silently. The student builds a tower silently.",
  },
  {
    locationId: "item20429",
    locationName: "item20429",
    locationAddress: "item20429",
    ratings: null,
    lat: 60.278931911035976,
    lng: -6.2586195377271885,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2429",
    tags: [],
    locationDescription:
      " The man builds a book angrily. A dog builds a tower happily.",
  },
  {
    locationId: "item20430",
    locationName: "item20430",
    locationAddress: "item20430",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 1.63 },
    ],
    lat: 58.262101183842205,
    lng: -7.724112161964798,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2430",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher builds a fence angrily. The student writes the cake gracefully.",
  },
  {
    locationId: "item20431",
    locationName: "item20431",
    locationAddress: "item20431",
    ratings: null,
    lat: 58.50029989923176,
    lng: -3.949071647957833,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2431",
    tags: [],
    locationDescription:
      " A dog runs towards a book quickly. The student jumps over the cake gracefully.",
  },
  {
    locationId: "item20432",
    locationName: "item20432",
    locationAddress: "item20432",
    ratings: null,
    lat: 59.24337531023557,
    lng: -6.499941743405909,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2432",
    tags: [],
    locationDescription:
      " The student runs towards a fence angrily. The man builds the horizon angrily.",
  },
  {
    locationId: "item20433",
    locationName: "item20433",
    locationAddress: "item20433",
    ratings: [
      { who: "Similar identities", rating: 1.76 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 56.87660904574783,
    lng: -2.257164173174922,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2433",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item20434",
    locationName: "item20434",
    locationAddress: "item20434",
    ratings: null,
    lat: 53.9796200711632,
    lng: -0.8597162034316277,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2434",
    tags: [],
    locationDescription:
      " A woman looks at the cake gracefully. The teacher looks at the horizon quickly. A woman jumps over the road lazily. A woman eats a book happily.",
  },
  {
    locationId: "item20435",
    locationName: "item20435",
    locationAddress: "item20435",
    ratings: null,
    lat: 49.925184969478124,
    lng: -8.197103569862168,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2435",
    tags: [],
    locationDescription:
      " The teacher writes a tower lazily. The cat writes a tower angrily. A dog jumps over a fence quickly. A woman eats a fence gracefully.",
  },
  {
    locationId: "item20436",
    locationName: "item20436",
    locationAddress: "item20436",
    ratings: null,
    lat: 57.12615437943955,
    lng: -5.443496571079626,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2436",
    tags: [],
    locationDescription:
      " A dog jumps over a fence happily. The teacher eats a tower angrily.",
  },
  {
    locationId: "item20437",
    locationName: "item20437",
    locationAddress: "item20437",
    ratings: null,
    lat: 58.69796175217311,
    lng: -7.22736203614597,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2437",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower happily. The student builds the road angrily.",
  },
  {
    locationId: "item20438",
    locationName: "item20438",
    locationAddress: "item20438",
    ratings: [
      { who: "Similar identities", rating: 1.47 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 51.507180518291676,
    lng: -3.765963078712054,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2438",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat runs towards the cake quickly. A dog jumps over the road angrily. A dog builds a tower lazily. A woman builds a book silently.",
  },
  {
    locationId: "item20439",
    locationName: "item20439",
    locationAddress: "item20439",
    ratings: null,
    lat: 60.722166271102225,
    lng: 0.048923227275382786,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2439",
    tags: [],
    locationDescription:
      " The cat writes the cake gracefully. A woman builds the road angrily. The teacher builds a tower quickly. A dog builds a book happily.",
  },
  {
    locationId: "item20440",
    locationName: "item20440",
    locationAddress: "item20440",
    ratings: null,
    lat: 53.227108688557564,
    lng: -4.674451171579195,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2440",
    tags: [],
    locationDescription:
      " A dog writes a fence angrily. The cat writes a tower happily.",
  },
  {
    locationId: "item20441",
    locationName: "item20441",
    locationAddress: "item20441",
    ratings: [
      { who: "Similar identities", rating: 4.55 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 54.758907276281704,
    lng: -2.4321691050976346,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2441",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription: " The man builds the cake lazily.",
  },
  {
    locationId: "item20442",
    locationName: "item20442",
    locationAddress: "item20442",
    ratings: null,
    lat: 52.93303797617806,
    lng: 0.5002904319775183,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2442",
    tags: [],
    locationDescription:
      " The teacher builds a book gracefully. The cat runs towards the horizon silently. A woman writes a tower angrily. A woman looks at a tower angrily.",
  },
  {
    locationId: "item20443",
    locationName: "item20443",
    locationAddress: "item20443",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 1.46 },
    ],
    lat: 50.77930690778087,
    lng: 1.0907677898129702,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2443",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man builds a fence silently. The student writes the road silently. The teacher builds the road happily. The man jumps over a fence silently. The student jumps over the horizon angrily.",
  },
  {
    locationId: "item20444",
    locationName: "item20444",
    locationAddress: "item20444",
    ratings: null,
    lat: 57.62120932767835,
    lng: -4.631299024931206,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2444",
    tags: [],
    locationDescription: " A woman looks at a book happily.",
  },
  {
    locationId: "item20445",
    locationName: "item20445",
    locationAddress: "item20445",
    ratings: null,
    lat: 58.234529629351414,
    lng: -5.192088219755354,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2445",
    tags: [],
    locationDescription: " The man jumps over the horizon angrily.",
  },
  {
    locationId: "item20446",
    locationName: "item20446",
    locationAddress: "item20446",
    ratings: null,
    lat: 51.57684655647652,
    lng: -0.6375479530593298,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2446",
    tags: [],
    locationDescription:
      " The man runs towards a tower gracefully. The teacher looks at the road silently.",
  },
  {
    locationId: "item20447",
    locationName: "item20447",
    locationAddress: "item20447",
    ratings: [
      { who: "Similar identities", rating: 4.77 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 50.68079410535975,
    lng: -7.665088953159978,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2447",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over the road happily. A dog looks at a fence angrily. The cat builds the horizon happily.",
  },
  {
    locationId: "item20448",
    locationName: "item20448",
    locationAddress: "item20448",
    ratings: null,
    lat: 59.084870072533874,
    lng: -7.531175558426308,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2448",
    tags: [],
    locationDescription:
      " The student looks at the road happily. The man runs towards a tower quickly. The man runs towards a tower happily. A dog builds a fence quickly. The teacher writes the cake quickly.",
  },
  {
    locationId: "item20449",
    locationName: "item20449",
    locationAddress: "item20449",
    ratings: null,
    lat: 50.25163113303013,
    lng: -3.5603404422660043,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2449",
    tags: [],
    locationDescription:
      " The student builds a book lazily. The man writes the cake quickly. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item20450",
    locationName: "item20450",
    locationAddress: "item20450",
    ratings: [
      { who: "Similar identities", rating: 1.99 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 60.40519653330436,
    lng: -6.560244070112338,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2450",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The student eats a tower quickly.",
  },
  {
    locationId: "item20451",
    locationName: "item20451",
    locationAddress: "item20451",
    ratings: null,
    lat: 59.9186158665004,
    lng: -7.190732372232064,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2451",
    tags: [],
    locationDescription:
      " A dog eats a tower lazily. The man runs towards a tower silently. The student looks at a tower angrily. The teacher eats the cake quickly.",
  },
  {
    locationId: "item20452",
    locationName: "item20452",
    locationAddress: "item20452",
    ratings: null,
    lat: 56.534381727265114,
    lng: -3.449214260220878,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2452",
    tags: [],
    locationDescription: " A woman writes the cake silently.",
  },
  {
    locationId: "item20453",
    locationName: "item20453",
    locationAddress: "item20453",
    ratings: null,
    lat: 57.27064610890424,
    lng: -1.1450801131199189,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2453",
    tags: [],
    locationDescription:
      " The man writes a fence silently. The teacher writes a book silently. The cat jumps over the horizon silently. The teacher builds the road angrily.",
  },
  {
    locationId: "item20454",
    locationName: "item20454",
    locationAddress: "item20454",
    ratings: [
      { who: "Similar identities", rating: 0.55 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 52.87970578296243,
    lng: -5.194782917335392,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2454",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher runs towards the road quickly. The teacher builds a fence quickly.",
  },
  {
    locationId: "item20455",
    locationName: "item20455",
    locationAddress: "item20455",
    ratings: null,
    lat: 52.43126028757455,
    lng: -3.762256010680969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2455",
    tags: [],
    locationDescription:
      " The student jumps over the road happily. The cat eats the horizon silently. A dog builds the horizon gracefully. The cat runs towards a fence angrily. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item20456",
    locationName: "item20456",
    locationAddress: "item20456",
    ratings: [
      { who: "Similar identities", rating: 4.37 },
      { who: "All perspectives", rating: 0.32 },
    ],
    lat: 57.54306575364069,
    lng: -0.9404254336146511,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2456",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards a book silently. The man runs towards the horizon gracefully. The teacher jumps over a fence silently.",
  },
  {
    locationId: "item20457",
    locationName: "item20457",
    locationAddress: "item20457",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 2.61 },
    ],
    lat: 50.734816616864904,
    lng: -1.6714176594653294,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2457",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher jumps over the road lazily. The teacher jumps over a fence angrily.",
  },
  {
    locationId: "item20458",
    locationName: "item20458",
    locationAddress: "item20458",
    ratings: [
      { who: "Similar identities", rating: 4.69 },
      { who: "All perspectives", rating: 4.72 },
    ],
    lat: 53.10813492042789,
    lng: -2.378837455891629,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2458",
    tags: [{ label: "accessible" }],
    locationDescription: " A dog builds a tower quickly.",
  },
  {
    locationId: "item20459",
    locationName: "item20459",
    locationAddress: "item20459",
    ratings: [
      { who: "Similar identities", rating: 0.24 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 51.87037426265063,
    lng: -8.539122327130238,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2459",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man looks at the road lazily. The student looks at a fence angrily. The man jumps over the cake angrily.",
  },
  {
    locationId: "item20460",
    locationName: "item20460",
    locationAddress: "item20460",
    ratings: [
      { who: "Similar identities", rating: 0.85 },
      { who: "All perspectives", rating: 1.76 },
    ],
    lat: 57.876608201186706,
    lng: -3.82297307765265,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2460",
    tags: [{ label: "child friendly" }],
    locationDescription: " A woman jumps over the road happily.",
  },
  {
    locationId: "item20461",
    locationName: "item20461",
    locationAddress: "item20461",
    ratings: null,
    lat: 50.84206231055069,
    lng: -6.223019673083465,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2461",
    tags: [],
    locationDescription: " The student eats a tower quickly.",
  },
  {
    locationId: "item20462",
    locationName: "item20462",
    locationAddress: "item20462",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 0.19 },
    ],
    lat: 54.53947449626782,
    lng: -2.7166904303173967,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2462",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man eats the horizon silently. The man writes the horizon quickly. A dog runs towards a tower lazily. The man runs towards a book happily.",
  },
  {
    locationId: "item20463",
    locationName: "item20463",
    locationAddress: "item20463",
    ratings: null,
    lat: 51.43450267151741,
    lng: -7.032597920692089,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2463",
    tags: [],
    locationDescription: " A woman eats the horizon silently.",
  },
  {
    locationId: "item20464",
    locationName: "item20464",
    locationAddress: "item20464",
    ratings: [
      { who: "Similar identities", rating: 4.62 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 55.17937563509332,
    lng: -6.982442763855923,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2464",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog jumps over the horizon silently. The teacher writes a fence happily. The man writes a tower happily.",
  },
  {
    locationId: "item20465",
    locationName: "item20465",
    locationAddress: "item20465",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 0.85 },
    ],
    lat: 60.244866687298114,
    lng: -7.081198311397056,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2465",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher eats the road angrily. The cat runs towards the cake gracefully. A woman writes a fence gracefully.",
  },
  {
    locationId: "item20466",
    locationName: "item20466",
    locationAddress: "item20466",
    ratings: null,
    lat: 56.28353507980683,
    lng: -7.843019341831525,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2466",
    tags: [],
    locationDescription:
      " A woman writes the cake angrily. The man writes a fence silently. The man writes the cake lazily. A woman looks at the road happily.",
  },
  {
    locationId: "item20467",
    locationName: "item20467",
    locationAddress: "item20467",
    ratings: null,
    lat: 55.05118036393977,
    lng: -2.8693309938509124,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2467",
    tags: [],
    locationDescription:
      " A woman builds a book angrily. The student jumps over a book lazily.",
  },
  {
    locationId: "item20468",
    locationName: "item20468",
    locationAddress: "item20468",
    ratings: [
      { who: "Similar identities", rating: 4.65 },
      { who: "All perspectives", rating: 3.25 },
    ],
    lat: 57.104985603145174,
    lng: 1.474656273030007,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2468",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat looks at the road angrily.",
  },
  {
    locationId: "item20469",
    locationName: "item20469",
    locationAddress: "item20469",
    ratings: [
      { who: "Similar identities", rating: 1.86 },
      { who: "All perspectives", rating: 4.78 },
    ],
    lat: 50.629533112688435,
    lng: -6.936370323064533,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2469",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher looks at the road angrily. A woman runs towards a fence gracefully.",
  },
  {
    locationId: "item20470",
    locationName: "item20470",
    locationAddress: "item20470",
    ratings: null,
    lat: 60.36907620523684,
    lng: -2.1398255638248713,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2470",
    tags: [],
    locationDescription:
      " A woman eats a fence silently. The teacher runs towards a tower silently. A dog builds the road happily.",
  },
  {
    locationId: "item20471",
    locationName: "item20471",
    locationAddress: "item20471",
    ratings: null,
    lat: 57.8402637466784,
    lng: -5.472630195416475,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2471",
    tags: [],
    locationDescription:
      " The cat builds a book lazily. A woman writes a fence gracefully. A dog jumps over the horizon gracefully. A woman looks at the horizon lazily.",
  },
  {
    locationId: "item20472",
    locationName: "item20472",
    locationAddress: "item20472",
    ratings: [
      { who: "Similar identities", rating: 2.97 },
      { who: "All perspectives", rating: 1.61 },
    ],
    lat: 60.06199915962849,
    lng: -3.9645770083847562,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2472",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription: " The student runs towards the road gracefully.",
  },
  {
    locationId: "item20473",
    locationName: "item20473",
    locationAddress: "item20473",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 0.58 },
    ],
    lat: 58.229823554612686,
    lng: -7.02665162876054,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2473",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man runs towards a tower silently. The cat eats the road gracefully. The teacher writes a fence angrily.",
  },
  {
    locationId: "item20474",
    locationName: "item20474",
    locationAddress: "item20474",
    ratings: [
      { who: "Similar identities", rating: 2.24 },
      { who: "All perspectives", rating: 2.82 },
    ],
    lat: 50.66863541915728,
    lng: -5.318193137904496,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2474",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog writes the cake lazily. A dog jumps over a fence angrily. The teacher builds a fence lazily. A woman looks at a tower lazily.",
  },
  {
    locationId: "item20475",
    locationName: "item20475",
    locationAddress: "item20475",
    ratings: [
      { who: "Similar identities", rating: 2.83 },
      { who: "All perspectives", rating: 1.6 },
    ],
    lat: 58.35106351407365,
    lng: -5.466023491204254,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2475",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog looks at a book lazily. The man eats a tower happily. A woman runs towards a book happily.",
  },
  {
    locationId: "item20476",
    locationName: "item20476",
    locationAddress: "item20476",
    ratings: null,
    lat: 59.30925731625278,
    lng: -1.6078652705295697,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2476",
    tags: [],
    locationDescription:
      " The teacher writes a fence quickly. A dog eats a fence silently.",
  },
  {
    locationId: "item20477",
    locationName: "item20477",
    locationAddress: "item20477",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 52.68795509851031,
    lng: 0.5340678108096313,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2477",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a tower happily. The man builds the road gracefully. The student writes the horizon lazily. The man runs towards a fence silently. A woman eats the road lazily.",
  },
  {
    locationId: "item20478",
    locationName: "item20478",
    locationAddress: "item20478",
    ratings: null,
    lat: 60.409890599543054,
    lng: -7.3591074859472165,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2478",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake quickly. The teacher builds a tower angrily. A woman eats the road quickly. The cat jumps over a tower lazily. A dog runs towards a book silently.",
  },
  {
    locationId: "item20479",
    locationName: "item20479",
    locationAddress: "item20479",
    ratings: null,
    lat: 52.191203809234224,
    lng: -3.54640142349312,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2479",
    tags: [],
    locationDescription:
      " The cat jumps over the cake silently. A woman writes a tower silently.",
  },
  {
    locationId: "item20480",
    locationName: "item20480",
    locationAddress: "item20480",
    ratings: null,
    lat: 55.05531790225467,
    lng: -5.732031417010573,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2480",
    tags: [],
    locationDescription: " A woman writes the cake gracefully.",
  },
  {
    locationId: "item20481",
    locationName: "item20481",
    locationAddress: "item20481",
    ratings: [
      { who: "Similar identities", rating: 3.4 },
      { who: "All perspectives", rating: 2.64 },
    ],
    lat: 53.7634527941007,
    lng: -1.9774795928813065,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2481",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A dog jumps over the horizon lazily. The cat looks at the road silently.",
  },
  {
    locationId: "item20482",
    locationName: "item20482",
    locationAddress: "item20482",
    ratings: [
      { who: "Similar identities", rating: 0.73 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 54.235543629630655,
    lng: -1.2204967210974118,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2482",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a fence quickly. The cat eats the cake silently. A woman jumps over the road happily.",
  },
  {
    locationId: "item20483",
    locationName: "item20483",
    locationAddress: "item20483",
    ratings: [
      { who: "Similar identities", rating: 2.52 },
      { who: "All perspectives", rating: 2.36 },
    ],
    lat: 54.44848604012225,
    lng: 1.443105818219518,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2483",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " A woman eats a fence quickly.",
  },
  {
    locationId: "item20484",
    locationName: "item20484",
    locationAddress: "item20484",
    ratings: [
      { who: "Similar identities", rating: 1.63 },
      { who: "All perspectives", rating: 4.66 },
    ],
    lat: 51.90578346914632,
    lng: -3.2933231739146365,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2484",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man jumps over the road quickly. The cat jumps over the horizon lazily. The student runs towards a tower gracefully. The cat builds a book quickly. The student runs towards a book quickly.",
  },
  {
    locationId: "item20485",
    locationName: "item20485",
    locationAddress: "item20485",
    ratings: null,
    lat: 52.01333358600532,
    lng: -0.46542681279047216,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2485",
    tags: [],
    locationDescription: " A woman writes the horizon silently.",
  },
  {
    locationId: "item20486",
    locationName: "item20486",
    locationAddress: "item20486",
    ratings: null,
    lat: 55.89578649145126,
    lng: -6.721569330691124,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2486",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon gracefully. The student writes a fence happily. The student writes a fence angrily.",
  },
  {
    locationId: "item20487",
    locationName: "item20487",
    locationAddress: "item20487",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 2.0 },
    ],
    lat: 51.70285417478032,
    lng: 0.2523864371386022,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2487",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes a fence happily. The man builds a tower gracefully. The cat looks at the cake lazily. The man builds the horizon quickly. The cat writes the road angrily.",
  },
  {
    locationId: "item20488",
    locationName: "item20488",
    locationAddress: "item20488",
    ratings: null,
    lat: 56.39546841129299,
    lng: -1.9085680357582744,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2488",
    tags: [],
    locationDescription:
      " The man looks at the road happily. A woman builds the cake lazily. The student jumps over the horizon angrily.",
  },
  {
    locationId: "item20489",
    locationName: "item20489",
    locationAddress: "item20489",
    ratings: [
      { who: "Similar identities", rating: 4.75 },
      { who: "All perspectives", rating: 0.1 },
    ],
    lat: 53.10170503293252,
    lng: -2.711844449812771,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2489",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over the cake quickly. The teacher eats a tower angrily. The cat builds the cake lazily.",
  },
  {
    locationId: "item20490",
    locationName: "item20490",
    locationAddress: "item20490",
    ratings: null,
    lat: 59.15206473879568,
    lng: -2.050675119065261,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2490",
    tags: [],
    locationDescription: " A woman runs towards a fence happily.",
  },
  {
    locationId: "item20491",
    locationName: "item20491",
    locationAddress: "item20491",
    ratings: null,
    lat: 54.05584732334713,
    lng: 1.508318374855799,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2491",
    tags: [],
    locationDescription:
      " A dog looks at the horizon silently. A woman builds a tower happily. The student looks at a tower quickly. The student jumps over a book gracefully. The teacher jumps over a tower silently.",
  },
  {
    locationId: "item20492",
    locationName: "item20492",
    locationAddress: "item20492",
    ratings: [
      { who: "Similar identities", rating: 2.44 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 55.79606406471309,
    lng: 1.2197962193834506,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2492",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a book silently. A woman runs towards the road silently. The student jumps over the cake happily. A woman looks at the road silently.",
  },
  {
    locationId: "item20493",
    locationName: "item20493",
    locationAddress: "item20493",
    ratings: [
      { who: "Similar identities", rating: 2.42 },
      { who: "All perspectives", rating: 1.5 },
    ],
    lat: 52.03364004405144,
    lng: 0.5671285423738137,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2493",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat looks at the horizon angrily. The cat jumps over a book lazily.",
  },
  {
    locationId: "item20494",
    locationName: "item20494",
    locationAddress: "item20494",
    ratings: null,
    lat: 56.69682646847024,
    lng: -2.034678375073864,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2494",
    tags: [],
    locationDescription:
      " A woman eats a fence angrily. A dog runs towards a tower happily.",
  },
  {
    locationId: "item20495",
    locationName: "item20495",
    locationAddress: "item20495",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 50.07902042203956,
    lng: 0.7485242255105504,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2495",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog runs towards the cake lazily. The man eats the horizon silently. A woman writes the cake angrily. The man looks at the road silently. The student looks at a fence lazily.",
  },
  {
    locationId: "item20496",
    locationName: "item20496",
    locationAddress: "item20496",
    ratings: null,
    lat: 54.15119594352197,
    lng: 0.3326789148011997,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2496",
    tags: [],
    locationDescription: " A woman jumps over the horizon silently.",
  },
  {
    locationId: "item20497",
    locationName: "item20497",
    locationAddress: "item20497",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 58.01797374297455,
    lng: 0.21562784169982407,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2497",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man looks at a book gracefully. A woman eats the road quickly. A dog looks at a tower angrily. The man eats a book gracefully. The student runs towards a tower gracefully.",
  },
  {
    locationId: "item20498",
    locationName: "item20498",
    locationAddress: "item20498",
    ratings: null,
    lat: 55.796097241568354,
    lng: -2.8774864237564284,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2498",
    tags: [],
    locationDescription:
      " The teacher looks at a fence quickly. A dog writes a tower lazily. A dog writes a tower quickly. A dog builds the cake gracefully. The man writes a fence angrily.",
  },
  {
    locationId: "item20499",
    locationName: "item20499",
    locationAddress: "item20499",
    ratings: [
      { who: "Similar identities", rating: 4.4 },
      { who: "All perspectives", rating: 2.68 },
    ],
    lat: 59.65334369555541,
    lng: -2.455769169304043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2499",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over the cake lazily. A woman builds a tower quickly. The man looks at the road gracefully.",
  },
  {
    locationId: "item20500",
    locationName: "item20500",
    locationAddress: "item20500",
    ratings: null,
    lat: 57.607196117003404,
    lng: -8.419140483497346,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2500",
    tags: [],
    locationDescription:
      " The cat eats a fence quickly. The student runs towards a fence quickly. A woman looks at the road lazily.",
  },
  {
    locationId: "item20501",
    locationName: "item20501",
    locationAddress: "item20501",
    ratings: null,
    lat: 52.67595061464236,
    lng: -5.61533063493806,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2501",
    tags: [],
    locationDescription: " The cat eats the cake silently.",
  },
  {
    locationId: "item20502",
    locationName: "item20502",
    locationAddress: "item20502",
    ratings: null,
    lat: 50.83990328685989,
    lng: -3.363784709102511,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2502",
    tags: [],
    locationDescription:
      " The cat jumps over a fence angrily. The student writes the road angrily. A dog writes the cake angrily. A dog looks at the road silently. A woman eats the road quickly.",
  },
  {
    locationId: "item20503",
    locationName: "item20503",
    locationAddress: "item20503",
    ratings: [
      { who: "Similar identities", rating: 0.41 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 55.41617041252037,
    lng: -2.569476060425563,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2503",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man eats the cake lazily. The man eats the cake quickly. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item20504",
    locationName: "item20504",
    locationAddress: "item20504",
    ratings: [
      { who: "Similar identities", rating: 2.44 },
      { who: "All perspectives", rating: 0.65 },
    ],
    lat: 52.96645399278306,
    lng: -3.0987746305933124,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2504",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man looks at a tower quickly. A woman builds a fence angrily. A woman runs towards a book gracefully. The cat looks at a tower lazily.",
  },
  {
    locationId: "item20505",
    locationName: "item20505",
    locationAddress: "item20505",
    ratings: [
      { who: "Similar identities", rating: 4.56 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 56.469845477568924,
    lng: -5.744576440093708,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2505",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over the horizon lazily. The man looks at a fence silently. A woman writes the horizon angrily.",
  },
  {
    locationId: "item20506",
    locationName: "item20506",
    locationAddress: "item20506",
    ratings: null,
    lat: 59.94065644450342,
    lng: -4.0281138412883335,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2506",
    tags: [],
    locationDescription:
      " A dog writes a tower gracefully. The cat writes the cake angrily. The teacher runs towards the horizon gracefully. The man builds the road lazily.",
  },
  {
    locationId: "item20507",
    locationName: "item20507",
    locationAddress: "item20507",
    ratings: [
      { who: "Similar identities", rating: 3.37 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 52.301825403657716,
    lng: -1.4546274079376218,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2507",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher jumps over the cake angrily.",
  },
  {
    locationId: "item20508",
    locationName: "item20508",
    locationAddress: "item20508",
    ratings: null,
    lat: 54.479363012288836,
    lng: -0.0880750680639455,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2508",
    tags: [],
    locationDescription:
      " The student builds the horizon happily. The student jumps over a tower gracefully. The teacher builds the horizon happily. A woman eats the road lazily. A dog jumps over a fence gracefully.",
  },
  {
    locationId: "item20509",
    locationName: "item20509",
    locationAddress: "item20509",
    ratings: null,
    lat: 60.33617578205034,
    lng: -6.843990694925102,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2509",
    tags: [],
    locationDescription:
      " The cat jumps over a fence quickly. A woman eats a tower gracefully. The teacher jumps over a fence quickly.",
  },
  {
    locationId: "item20510",
    locationName: "item20510",
    locationAddress: "item20510",
    ratings: null,
    lat: 51.21639868538752,
    lng: 0.38850577565695055,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2510",
    tags: [],
    locationDescription:
      " The cat builds a fence angrily. A woman writes the cake quickly. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item20511",
    locationName: "item20511",
    locationAddress: "item20511",
    ratings: null,
    lat: 59.71736114012212,
    lng: -5.015640207572108,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2511",
    tags: [],
    locationDescription:
      " The student jumps over a fence lazily. A dog writes a book lazily. A woman looks at the cake silently. A dog looks at a fence happily.",
  },
  {
    locationId: "item20512",
    locationName: "item20512",
    locationAddress: "item20512",
    ratings: null,
    lat: 60.2991269378937,
    lng: -7.031178258410216,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2512",
    tags: [],
    locationDescription:
      " A woman looks at the horizon lazily. The student eats a book happily. The teacher jumps over a fence lazily. The man writes the horizon silently.",
  },
  {
    locationId: "item20513",
    locationName: "item20513",
    locationAddress: "item20513",
    ratings: null,
    lat: 58.28398322402463,
    lng: -3.8155025711139237,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2513",
    tags: [],
    locationDescription: " The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20514",
    locationName: "item20514",
    locationAddress: "item20514",
    ratings: null,
    lat: 53.682573571786655,
    lng: -2.664777777731155,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2514",
    tags: [],
    locationDescription:
      " The man looks at the horizon angrily. A woman builds a book quickly. A dog builds a book happily. The man builds a fence lazily.",
  },
  {
    locationId: "item20515",
    locationName: "item20515",
    locationAddress: "item20515",
    ratings: null,
    lat: 52.75013278347262,
    lng: -4.267223537189728,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2515",
    tags: [],
    locationDescription: " The teacher looks at a book silently.",
  },
  {
    locationId: "item20516",
    locationName: "item20516",
    locationAddress: "item20516",
    ratings: [
      { who: "Similar identities", rating: 3.57 },
      { who: "All perspectives", rating: 0.57 },
    ],
    lat: 50.88074392612878,
    lng: -8.450316208425996,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2516",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman runs towards a tower silently. The teacher jumps over a tower gracefully.",
  },
  {
    locationId: "item20517",
    locationName: "item20517",
    locationAddress: "item20517",
    ratings: null,
    lat: 59.60503027093707,
    lng: -4.1606467218833805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2517",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon quickly. A dog runs towards the cake happily. The teacher looks at a book lazily. The man eats a book gracefully.",
  },
  {
    locationId: "item20518",
    locationName: "item20518",
    locationAddress: "item20518",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 0.27 },
    ],
    lat: 60.446511068208665,
    lng: -3.3580311183018887,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2518",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog eats the road happily. A dog builds the cake happily. The cat eats a fence gracefully.",
  },
  {
    locationId: "item20519",
    locationName: "item20519",
    locationAddress: "item20519",
    ratings: [
      { who: "Similar identities", rating: 4.04 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 57.24099017785701,
    lng: 0.5986901285184398,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2519",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man writes a tower angrily. A woman writes a book happily. The cat eats a book gracefully. The teacher jumps over a fence silently.",
  },
  {
    locationId: "item20520",
    locationName: "item20520",
    locationAddress: "item20520",
    ratings: null,
    lat: 55.834549930747066,
    lng: 0.5969380697371172,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2520",
    tags: [],
    locationDescription:
      " The cat eats a tower quickly. The teacher jumps over a tower gracefully. The student eats the road quickly. A woman writes a book silently.",
  },
  {
    locationId: "item20521",
    locationName: "item20521",
    locationAddress: "item20521",
    ratings: [
      { who: "Similar identities", rating: 1.65 },
      { who: "All perspectives", rating: 1.47 },
    ],
    lat: 58.36533137162421,
    lng: 0.6953673954195736,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2521",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards the road happily. The cat looks at the horizon angrily. The cat runs towards a fence gracefully. The cat runs towards a book silently.",
  },
  {
    locationId: "item20522",
    locationName: "item20522",
    locationAddress: "item20522",
    ratings: [
      { who: "Similar identities", rating: 0.41 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 54.969154015486495,
    lng: -2.989200422281967,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2522",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man runs towards the horizon happily.",
  },
  {
    locationId: "item20523",
    locationName: "item20523",
    locationAddress: "item20523",
    ratings: [
      { who: "Similar identities", rating: 2.81 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 50.1928044633301,
    lng: -7.866171112934409,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2523",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat writes the road quickly. The teacher eats the horizon quickly. A woman runs towards a fence lazily. The cat runs towards a book quickly.",
  },
  {
    locationId: "item20524",
    locationName: "item20524",
    locationAddress: "item20524",
    ratings: [
      { who: "Similar identities", rating: 3.67 },
      { who: "All perspectives", rating: 3.09 },
    ],
    lat: 51.921024156637245,
    lng: -2.225347959180369,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2524",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog eats a book quickly. The student jumps over a tower gracefully. The teacher writes the road quickly. A woman eats a tower angrily.",
  },
  {
    locationId: "item20525",
    locationName: "item20525",
    locationAddress: "item20525",
    ratings: null,
    lat: 55.744596393990165,
    lng: -0.34596555038912236,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2525",
    tags: [],
    locationDescription:
      " A dog builds the cake gracefully. The man jumps over the cake happily. A dog looks at a tower happily.",
  },
  {
    locationId: "item20526",
    locationName: "item20526",
    locationAddress: "item20526",
    ratings: null,
    lat: 59.74441219842972,
    lng: 0.21166546885042514,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2526",
    tags: [],
    locationDescription:
      " The teacher looks at a fence gracefully. The man builds a fence silently.",
  },
  {
    locationId: "item20527",
    locationName: "item20527",
    locationAddress: "item20527",
    ratings: null,
    lat: 60.55071868329577,
    lng: -5.112190537081641,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2527",
    tags: [],
    locationDescription:
      " A dog builds the road quickly. The cat runs towards a book quickly. A woman looks at the cake silently. The man runs towards the horizon lazily. The teacher builds a tower quickly.",
  },
  {
    locationId: "item20528",
    locationName: "item20528",
    locationAddress: "item20528",
    ratings: null,
    lat: 58.479481891343816,
    lng: -1.5076264839612623,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2528",
    tags: [],
    locationDescription: " A dog looks at a book happily.",
  },
  {
    locationId: "item20529",
    locationName: "item20529",
    locationAddress: "item20529",
    ratings: [
      { who: "Similar identities", rating: 0.78 },
      { who: "All perspectives", rating: 4.59 },
    ],
    lat: 57.98283456098271,
    lng: -6.310359617697148,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2529",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a tower lazily. A woman runs towards the cake silently. The cat runs towards the road happily. The cat writes the cake lazily.",
  },
  {
    locationId: "item20530",
    locationName: "item20530",
    locationAddress: "item20530",
    ratings: null,
    lat: 57.02081575462542,
    lng: -1.673137973013473,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2530",
    tags: [],
    locationDescription: " The teacher looks at the cake silently.",
  },
  {
    locationId: "item20531",
    locationName: "item20531",
    locationAddress: "item20531",
    ratings: null,
    lat: 54.087005930803194,
    lng: 0.8626321754077448,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2531",
    tags: [],
    locationDescription:
      " A dog builds a book happily. The man writes a book angrily. The student runs towards a book lazily. The student writes a fence quickly.",
  },
  {
    locationId: "item20532",
    locationName: "item20532",
    locationAddress: "item20532",
    ratings: null,
    lat: 60.38294413654529,
    lng: 1.7070356454569673,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2532",
    tags: [],
    locationDescription:
      " A dog runs towards the road silently. A woman looks at a fence gracefully. The man eats a tower quickly. The student looks at a tower lazily.",
  },
  {
    locationId: "item20533",
    locationName: "item20533",
    locationAddress: "item20533",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 2.97 },
    ],
    lat: 58.39825380325787,
    lng: -5.802312717999221,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2533",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes a book quickly. The teacher jumps over the cake happily.",
  },
  {
    locationId: "item20534",
    locationName: "item20534",
    locationAddress: "item20534",
    ratings: null,
    lat: 60.334667270979374,
    lng: 0.19980106094949868,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2534",
    tags: [],
    locationDescription:
      " A woman jumps over a tower angrily. The man jumps over a book lazily. A dog runs towards a fence happily. A dog looks at the horizon gracefully. The cat runs towards the horizon lazily.",
  },
  {
    locationId: "item20535",
    locationName: "item20535",
    locationAddress: "item20535",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 4.66 },
    ],
    lat: 55.387870808580956,
    lng: -4.4195099621181,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2535",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man writes the horizon happily. The man jumps over the road silently. The cat eats the road quickly. The teacher runs towards a fence angrily. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item20536",
    locationName: "item20536",
    locationAddress: "item20536",
    ratings: null,
    lat: 56.83725792780289,
    lng: -6.275842362177334,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2536",
    tags: [],
    locationDescription:
      " The student builds a fence quickly. The student writes a tower lazily. The student looks at the horizon quickly.",
  },
  {
    locationId: "item20537",
    locationName: "item20537",
    locationAddress: "item20537",
    ratings: [
      { who: "Similar identities", rating: 3.71 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 57.00395602413159,
    lng: -3.440529219084545,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2537",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher eats the cake lazily.",
  },
  {
    locationId: "item20538",
    locationName: "item20538",
    locationAddress: "item20538",
    ratings: null,
    lat: 59.604880692427244,
    lng: -5.2677580762149745,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2538",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon gracefully. The cat builds the horizon angrily. The student runs towards the cake quickly. A woman runs towards a fence gracefully. A dog runs towards a book happily.",
  },
  {
    locationId: "item20539",
    locationName: "item20539",
    locationAddress: "item20539",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 60.783253286846644,
    lng: -7.890572478617351,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2539",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student builds a book lazily. The man eats a book gracefully. The cat writes the cake gracefully. The cat eats a tower angrily.",
  },
  {
    locationId: "item20540",
    locationName: "item20540",
    locationAddress: "item20540",
    ratings: [
      { who: "Similar identities", rating: 1.24 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 54.28487911148544,
    lng: -7.259729165540009,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2540",
    tags: [{ label: "child friendly" }],
    locationDescription: " The student runs towards the road gracefully.",
  },
  {
    locationId: "item20541",
    locationName: "item20541",
    locationAddress: "item20541",
    ratings: null,
    lat: 57.82173861036808,
    lng: -0.12527843901488644,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2541",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon angrily. The teacher runs towards the horizon gracefully. A dog looks at the cake gracefully. The cat looks at a fence lazily.",
  },
  {
    locationId: "item20542",
    locationName: "item20542",
    locationAddress: "item20542",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 1.6 },
    ],
    lat: 60.57079664479186,
    lng: 1.5389104515818808,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2542",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher builds a fence silently. The cat eats a tower quickly.",
  },
  {
    locationId: "item20543",
    locationName: "item20543",
    locationAddress: "item20543",
    ratings: null,
    lat: 56.23820951018228,
    lng: 0.5064382029072014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2543",
    tags: [],
    locationDescription: " The man jumps over a fence lazily.",
  },
  {
    locationId: "item20544",
    locationName: "item20544",
    locationAddress: "item20544",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 3.82 },
    ],
    lat: 59.88166934932259,
    lng: -8.388406910159066,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2544",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man writes the road gracefully.",
  },
  {
    locationId: "item20545",
    locationName: "item20545",
    locationAddress: "item20545",
    ratings: [
      { who: "Similar identities", rating: 3.69 },
      { who: "All perspectives", rating: 2.39 },
    ],
    lat: 51.38937264360957,
    lng: -4.042094673596909,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2545",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man builds the road happily. The cat jumps over the horizon lazily. The teacher looks at the road happily. The cat eats the road lazily. A dog runs towards a fence silently.",
  },
  {
    locationId: "item20546",
    locationName: "item20546",
    locationAddress: "item20546",
    ratings: [
      { who: "Similar identities", rating: 4.55 },
      { who: "All perspectives", rating: 3.67 },
    ],
    lat: 60.37627865182928,
    lng: -3.457604458858974,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2546",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at a fence gracefully. The cat eats a book gracefully. A dog jumps over the cake gracefully. A dog jumps over the horizon gracefully.",
  },
  {
    locationId: "item20547",
    locationName: "item20547",
    locationAddress: "item20547",
    ratings: null,
    lat: 55.06304752136497,
    lng: -3.8316876934539295,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2547",
    tags: [],
    locationDescription:
      " The teacher builds a fence lazily. The student writes a tower angrily. A dog writes a tower angrily. A dog runs towards the road silently. The man jumps over a book quickly.",
  },
  {
    locationId: "item20548",
    locationName: "item20548",
    locationAddress: "item20548",
    ratings: null,
    lat: 59.550972062343654,
    lng: -2.403915119490451,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2548",
    tags: [],
    locationDescription:
      " The man runs towards the horizon angrily. A dog eats a tower happily. The man writes a book silently.",
  },
  {
    locationId: "item20549",
    locationName: "item20549",
    locationAddress: "item20549",
    ratings: [
      { who: "Similar identities", rating: 0.9 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 60.036093359600684,
    lng: -1.058107246182539,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2549",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student eats a book angrily. The teacher writes a book silently.",
  },
  {
    locationId: "item20550",
    locationName: "item20550",
    locationAddress: "item20550",
    ratings: null,
    lat: 54.426953262121614,
    lng: -8.504588912179573,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2550",
    tags: [],
    locationDescription:
      " The man jumps over the horizon lazily. The man jumps over the cake quickly. The student eats a fence quickly. The cat runs towards the cake happily.",
  },
  {
    locationId: "item20551",
    locationName: "item20551",
    locationAddress: "item20551",
    ratings: null,
    lat: 60.07555034309376,
    lng: 1.464463741043133,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2551",
    tags: [],
    locationDescription:
      " The student looks at a tower silently. The teacher eats a fence happily. The student runs towards a tower happily.",
  },
  {
    locationId: "item20552",
    locationName: "item20552",
    locationAddress: "item20552",
    ratings: null,
    lat: 56.27401113178113,
    lng: -7.946520265868486,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2552",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon gracefully. A woman builds the road happily. The student eats a tower silently. The cat writes a fence quickly.",
  },
  {
    locationId: "item20553",
    locationName: "item20553",
    locationAddress: "item20553",
    ratings: null,
    lat: 51.74023364189733,
    lng: -4.52010000655637,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2553",
    tags: [],
    locationDescription:
      " A woman eats a book gracefully. A dog builds a tower silently.",
  },
  {
    locationId: "item20554",
    locationName: "item20554",
    locationAddress: "item20554",
    ratings: null,
    lat: 59.1011075690101,
    lng: -5.901460078691021,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2554",
    tags: [],
    locationDescription:
      " The cat runs towards a book angrily. A woman looks at the cake happily. The student runs towards the road lazily.",
  },
  {
    locationId: "item20555",
    locationName: "item20555",
    locationAddress: "item20555",
    ratings: null,
    lat: 59.261901769492745,
    lng: -4.886255568921302,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2555",
    tags: [],
    locationDescription: " The teacher runs towards the road gracefully.",
  },
  {
    locationId: "item20556",
    locationName: "item20556",
    locationAddress: "item20556",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 4.57 },
    ],
    lat: 52.091274664412715,
    lng: 0.46592741129476956,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2556",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man jumps over the horizon angrily. The cat runs towards the road quickly.",
  },
  {
    locationId: "item20557",
    locationName: "item20557",
    locationAddress: "item20557",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 3.68 },
    ],
    lat: 49.9122483362188,
    lng: -0.19278145057168317,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2557",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The student looks at the road gracefully.",
  },
  {
    locationId: "item20558",
    locationName: "item20558",
    locationAddress: "item20558",
    ratings: null,
    lat: 60.73728072770923,
    lng: -8.075457434447348,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2558",
    tags: [],
    locationDescription:
      " The cat eats a book happily. The teacher looks at the horizon happily.",
  },
  {
    locationId: "item20559",
    locationName: "item20559",
    locationAddress: "item20559",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 1.73 },
    ],
    lat: 50.60076630738912,
    lng: -1.3229340674158463,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2559",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over a book lazily. A woman looks at the road angrily. The student runs towards a book happily. A dog eats a book gracefully. The teacher runs towards the horizon angrily.",
  },
  {
    locationId: "item20560",
    locationName: "item20560",
    locationAddress: "item20560",
    ratings: null,
    lat: 57.07786403524867,
    lng: -6.2989001170322805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2560",
    tags: [],
    locationDescription: " The teacher builds the road gracefully.",
  },
  {
    locationId: "item20561",
    locationName: "item20561",
    locationAddress: "item20561",
    ratings: [
      { who: "Similar identities", rating: 1.34 },
      { who: "All perspectives", rating: 2.43 },
    ],
    lat: 56.25466738666823,
    lng: -4.16776417966574,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2561",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher looks at a tower silently. A dog writes a tower angrily. The cat builds a book silently. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item20562",
    locationName: "item20562",
    locationAddress: "item20562",
    ratings: [
      { who: "Similar identities", rating: 1.68 },
      { who: "All perspectives", rating: 1.2 },
    ],
    lat: 56.27748910732269,
    lng: -0.1167665263577291,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2562",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at a tower gracefully. The cat eats a book angrily. The man builds a fence happily. A woman eats the horizon gracefully.",
  },
  {
    locationId: "item20563",
    locationName: "item20563",
    locationAddress: "item20563",
    ratings: null,
    lat: 58.719778102510865,
    lng: -4.495957618523385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2563",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. A dog writes a book quickly.",
  },
  {
    locationId: "item20564",
    locationName: "item20564",
    locationAddress: "item20564",
    ratings: [
      { who: "Similar identities", rating: 2.41 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 56.56974607434393,
    lng: -1.1437064242151624,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2564",
    tags: [{ label: "child friendly" }],
    locationDescription: " The man runs towards a tower angrily.",
  },
  {
    locationId: "item20565",
    locationName: "item20565",
    locationAddress: "item20565",
    ratings: null,
    lat: 54.95041447690573,
    lng: -6.552276758283278,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2565",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake angrily. A dog eats a fence happily. A dog runs towards the road quickly. The man jumps over the horizon happily. The cat writes a tower gracefully.",
  },
  {
    locationId: "item20566",
    locationName: "item20566",
    locationAddress: "item20566",
    ratings: [
      { who: "Similar identities", rating: 3.94 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 50.618335616007606,
    lng: -6.418379611866255,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2566",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes a fence silently. The teacher builds a book silently. The teacher runs towards the cake quickly. The cat builds a tower happily. A woman jumps over the cake silently.",
  },
  {
    locationId: "item20567",
    locationName: "item20567",
    locationAddress: "item20567",
    ratings: null,
    lat: 53.79160899597916,
    lng: -8.385467020246294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2567",
    tags: [],
    locationDescription: " The man looks at a book lazily.",
  },
  {
    locationId: "item20568",
    locationName: "item20568",
    locationAddress: "item20568",
    ratings: null,
    lat: 56.127769520006225,
    lng: -4.595850371411051,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2568",
    tags: [],
    locationDescription: " The man writes a tower silently.",
  },
  {
    locationId: "item20569",
    locationName: "item20569",
    locationAddress: "item20569",
    ratings: null,
    lat: 55.88361118078632,
    lng: -1.241502416884984,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2569",
    tags: [],
    locationDescription:
      " The man writes the road lazily. A dog builds the horizon gracefully. The man writes a tower quickly.",
  },
  {
    locationId: "item20570",
    locationName: "item20570",
    locationAddress: "item20570",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 52.106804433713776,
    lng: 0.4211699856253137,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2570",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog eats the road lazily.",
  },
  {
    locationId: "item20571",
    locationName: "item20571",
    locationAddress: "item20571",
    ratings: null,
    lat: 59.30417355845805,
    lng: 0.779606343641909,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2571",
    tags: [],
    locationDescription:
      " A woman writes a fence angrily. The student builds the cake silently. The cat writes the horizon happily. The man builds the cake quickly.",
  },
  {
    locationId: "item20572",
    locationName: "item20572",
    locationAddress: "item20572",
    ratings: null,
    lat: 50.77161445927609,
    lng: -7.7476914693657015,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2572",
    tags: [],
    locationDescription: " The cat eats the cake angrily.",
  },
  {
    locationId: "item20573",
    locationName: "item20573",
    locationAddress: "item20573",
    ratings: [
      { who: "Similar identities", rating: 3.57 },
      { who: "All perspectives", rating: 1.79 },
    ],
    lat: 60.321470506109335,
    lng: 0.7303567325789988,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2573",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The man builds a tower lazily. A woman eats the road lazily. The teacher jumps over the road silently. A woman eats the road angrily.",
  },
  {
    locationId: "item20574",
    locationName: "item20574",
    locationAddress: "item20574",
    ratings: [
      { who: "Similar identities", rating: 1.28 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 50.58507490433743,
    lng: 0.16503950599268258,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2574",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat writes the cake gracefully. The teacher writes the road quickly. The teacher builds the cake happily. The cat writes a fence lazily. A woman looks at a fence gracefully.",
  },
  {
    locationId: "item20575",
    locationName: "item20575",
    locationAddress: "item20575",
    ratings: [
      { who: "Similar identities", rating: 3.15 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 54.60558669743786,
    lng: -1.984491985152414,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2575",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student runs towards a tower gracefully. A woman builds a tower gracefully. The student writes a tower quickly. The teacher writes the road quickly. A dog looks at the road lazily.",
  },
  {
    locationId: "item20576",
    locationName: "item20576",
    locationAddress: "item20576",
    ratings: [
      { who: "Similar identities", rating: 3.5 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 59.835666280143386,
    lng: -2.2762895976621866,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2576",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over the cake quickly. The student writes a tower quickly. The teacher writes the road happily. A dog runs towards the road silently.",
  },
  {
    locationId: "item20577",
    locationName: "item20577",
    locationAddress: "item20577",
    ratings: [
      { who: "Similar identities", rating: 0.19 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 55.696893900999505,
    lng: 0.9582890213993522,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2577",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man eats a tower quickly.",
  },
  {
    locationId: "item20578",
    locationName: "item20578",
    locationAddress: "item20578",
    ratings: [
      { who: "Similar identities", rating: 1.72 },
      { who: "All perspectives", rating: 2.49 },
    ],
    lat: 59.068579349070596,
    lng: -5.113244572347796,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2578",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats the road angrily. The man writes a fence lazily. The student writes a book gracefully. The teacher writes a tower lazily.",
  },
  {
    locationId: "item20579",
    locationName: "item20579",
    locationAddress: "item20579",
    ratings: null,
    lat: 54.52302391199527,
    lng: 0.22960035451785288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2579",
    tags: [],
    locationDescription: " A dog runs towards a tower lazily.",
  },
  {
    locationId: "item20580",
    locationName: "item20580",
    locationAddress: "item20580",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 3.79 },
    ],
    lat: 57.28619535788917,
    lng: -4.051396492123102,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2580",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man eats a fence angrily. The man builds the road happily.",
  },
  {
    locationId: "item20581",
    locationName: "item20581",
    locationAddress: "item20581",
    ratings: [
      { who: "Similar identities", rating: 2.83 },
      { who: "All perspectives", rating: 1.89 },
    ],
    lat: 50.02777215704952,
    lng: -3.6289711392488258,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2581",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards the horizon angrily. A dog jumps over a tower angrily. A dog jumps over the horizon silently. The teacher writes a fence angrily. The cat eats a book angrily.",
  },
  {
    locationId: "item20582",
    locationName: "item20582",
    locationAddress: "item20582",
    ratings: [
      { who: "Similar identities", rating: 2.4 },
      { who: "All perspectives", rating: 0.95 },
    ],
    lat: 54.45566604536084,
    lng: -8.374338743529346,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2582",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over the road lazily. A woman eats a tower silently. A woman writes a book happily. The teacher builds the cake quickly.",
  },
  {
    locationId: "item20583",
    locationName: "item20583",
    locationAddress: "item20583",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 3.48 },
    ],
    lat: 55.57529249879062,
    lng: -5.364208272147355,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2583",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over the horizon silently. The cat eats the cake lazily. A dog runs towards a fence silently. A woman jumps over the cake gracefully.",
  },
  {
    locationId: "item20584",
    locationName: "item20584",
    locationAddress: "item20584",
    ratings: null,
    lat: 57.189479933466004,
    lng: 0.41210593067136614,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2584",
    tags: [],
    locationDescription:
      " The teacher builds a tower lazily. The teacher runs towards the cake angrily. A woman eats a book lazily. The cat builds the road gracefully.",
  },
  {
    locationId: "item20585",
    locationName: "item20585",
    locationAddress: "item20585",
    ratings: null,
    lat: 50.8467144865278,
    lng: -7.736453468024108,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2585",
    tags: [],
    locationDescription:
      " A woman runs towards a tower quickly. The teacher writes a tower gracefully. The student runs towards the horizon silently. The teacher eats the horizon quickly.",
  },
  {
    locationId: "item20586",
    locationName: "item20586",
    locationAddress: "item20586",
    ratings: null,
    lat: 59.073974231243234,
    lng: -7.803435997381182,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2586",
    tags: [],
    locationDescription:
      " The student jumps over the road lazily. The student looks at the road lazily.",
  },
  {
    locationId: "item20587",
    locationName: "item20587",
    locationAddress: "item20587",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 57.680795378486415,
    lng: -4.572142188979655,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2587",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman eats a tower angrily. The student runs towards the cake quickly.",
  },
  {
    locationId: "item20588",
    locationName: "item20588",
    locationAddress: "item20588",
    ratings: [
      { who: "Similar identities", rating: 4.71 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 50.58430669207236,
    lng: -4.790925421034412,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2588",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man eats the horizon happily. The man looks at the cake gracefully.",
  },
  {
    locationId: "item20589",
    locationName: "item20589",
    locationAddress: "item20589",
    ratings: [
      { who: "Similar identities", rating: 4.35 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 58.63754735990438,
    lng: -7.994453702527347,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2589",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog eats the cake silently. A woman jumps over a tower gracefully.",
  },
  {
    locationId: "item20590",
    locationName: "item20590",
    locationAddress: "item20590",
    ratings: null,
    lat: 60.66671253792449,
    lng: -7.418049820625245,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2590",
    tags: [],
    locationDescription:
      " The man writes a tower angrily. The teacher writes the road lazily. The man builds a fence angrily. A woman jumps over the horizon quickly. A dog writes a book lazily.",
  },
  {
    locationId: "item20591",
    locationName: "item20591",
    locationAddress: "item20591",
    ratings: null,
    lat: 57.297784738206786,
    lng: -4.90808196471137,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2591",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon happily. The student eats a tower gracefully.",
  },
  {
    locationId: "item20592",
    locationName: "item20592",
    locationAddress: "item20592",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 56.66691425137946,
    lng: -2.2729453502234707,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2592",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student jumps over a tower silently. The man looks at the horizon happily. A dog builds the road silently. The man builds the road happily. The man writes a fence silently.",
  },
  {
    locationId: "item20593",
    locationName: "item20593",
    locationAddress: "item20593",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 52.98288595306921,
    lng: -5.453902540909905,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2593",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man runs towards a tower lazily. A dog jumps over a fence quickly. The cat looks at the horizon gracefully.",
  },
  {
    locationId: "item20594",
    locationName: "item20594",
    locationAddress: "item20594",
    ratings: null,
    lat: 53.42834834712598,
    lng: -2.272006058926096,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2594",
    tags: [],
    locationDescription:
      " The student builds the horizon happily. The cat eats the road gracefully. A dog looks at a fence lazily.",
  },
  {
    locationId: "item20595",
    locationName: "item20595",
    locationAddress: "item20595",
    ratings: [
      { who: "Similar identities", rating: 0.47 },
      { who: "All perspectives", rating: 2.44 },
    ],
    lat: 60.00440823059945,
    lng: -0.39346248481860435,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2595",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " The cat looks at the horizon happily.",
  },
  {
    locationId: "item20596",
    locationName: "item20596",
    locationAddress: "item20596",
    ratings: null,
    lat: 55.09779464986258,
    lng: -7.642484563301027,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2596",
    tags: [],
    locationDescription:
      " A woman builds a book gracefully. The man jumps over the cake quickly. A woman builds the road silently.",
  },
  {
    locationId: "item20597",
    locationName: "item20597",
    locationAddress: "item20597",
    ratings: null,
    lat: 55.04777760319776,
    lng: -7.264322675243302,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2597",
    tags: [],
    locationDescription:
      " A woman looks at the cake quickly. The teacher jumps over the cake quickly. The cat writes a book gracefully. The cat builds a tower silently. A woman builds the road angrily.",
  },
  {
    locationId: "item20598",
    locationName: "item20598",
    locationAddress: "item20598",
    ratings: [
      { who: "Similar identities", rating: 4.87 },
      { who: "All perspectives", rating: 3.3 },
    ],
    lat: 57.40583594357896,
    lng: -0.5106848042930139,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2598",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The student builds a book quickly. The teacher eats a fence lazily. A dog looks at a book happily. The cat builds a fence happily. The cat runs towards the road gracefully.",
  },
  {
    locationId: "item20599",
    locationName: "item20599",
    locationAddress: "item20599",
    ratings: null,
    lat: 56.034039187746394,
    lng: -2.2292053713666915,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2599",
    tags: [],
    locationDescription:
      " The student writes the road gracefully. The cat jumps over a fence silently. The student jumps over the cake angrily. A dog runs towards the horizon angrily.",
  },
  {
    locationId: "item20600",
    locationName: "item20600",
    locationAddress: "item20600",
    ratings: null,
    lat: 54.70170701242907,
    lng: -7.428463596328103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2600",
    tags: [],
    locationDescription: " A woman runs towards the horizon lazily.",
  },
  {
    locationId: "item20601",
    locationName: "item20601",
    locationAddress: "item20601",
    ratings: [
      { who: "Similar identities", rating: 0.24 },
      { who: "All perspectives", rating: 3.95 },
    ],
    lat: 54.39407449308634,
    lng: -6.158057073157652,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2601",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " The student eats the cake gracefully.",
  },
  {
    locationId: "item20602",
    locationName: "item20602",
    locationAddress: "item20602",
    ratings: null,
    lat: 55.277812552372495,
    lng: -2.0413061802435557,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2602",
    tags: [],
    locationDescription:
      " The teacher runs towards the road silently. A dog looks at the road gracefully. The teacher writes the cake angrily.",
  },
  {
    locationId: "item20603",
    locationName: "item20603",
    locationAddress: "item20603",
    ratings: [
      { who: "Similar identities", rating: 3.99 },
      { who: "All perspectives", rating: 2.95 },
    ],
    lat: 55.77869401526072,
    lng: 1.6005466560523747,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2603",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The student builds a fence quickly.",
  },
  {
    locationId: "item20604",
    locationName: "item20604",
    locationAddress: "item20604",
    ratings: null,
    lat: 53.72853238366659,
    lng: 1.7814707698112429,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2604",
    tags: [],
    locationDescription:
      " A woman writes the cake quickly. The man runs towards a tower silently. The cat jumps over the horizon silently.",
  },
  {
    locationId: "item20605",
    locationName: "item20605",
    locationAddress: "item20605",
    ratings: [
      { who: "Similar identities", rating: 1.79 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 57.726010087572995,
    lng: -8.322467917060196,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2605",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog writes a fence silently.",
  },
  {
    locationId: "item20606",
    locationName: "item20606",
    locationAddress: "item20606",
    ratings: null,
    lat: 59.04441420295802,
    lng: -5.898972037947949,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2606",
    tags: [],
    locationDescription: " The teacher jumps over the horizon quickly.",
  },
  {
    locationId: "item20607",
    locationName: "item20607",
    locationAddress: "item20607",
    ratings: null,
    lat: 54.750893171156974,
    lng: -2.517670248350628,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2607",
    tags: [],
    locationDescription:
      " The teacher jumps over a book happily. The student builds a fence happily. The teacher runs towards a tower lazily. The cat eats a fence lazily.",
  },
  {
    locationId: "item20608",
    locationName: "item20608",
    locationAddress: "item20608",
    ratings: null,
    lat: 57.466105084094956,
    lng: -3.940416037211083,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2608",
    tags: [],
    locationDescription: " A woman jumps over a book angrily.",
  },
  {
    locationId: "item20609",
    locationName: "item20609",
    locationAddress: "item20609",
    ratings: null,
    lat: 59.948647026391114,
    lng: -8.084153566904,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2609",
    tags: [],
    locationDescription:
      " The teacher builds the road lazily. The student jumps over the road angrily.",
  },
  {
    locationId: "item20610",
    locationName: "item20610",
    locationAddress: "item20610",
    ratings: null,
    lat: 59.2386338107583,
    lng: 0.40766875126061386,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2610",
    tags: [],
    locationDescription: " A dog eats the cake angrily.",
  },
  {
    locationId: "item20611",
    locationName: "item20611",
    locationAddress: "item20611",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 0.01 },
    ],
    lat: 60.19394956040232,
    lng: -0.4756047791250335,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2611",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man writes the road angrily. The cat looks at the cake angrily.",
  },
  {
    locationId: "item20612",
    locationName: "item20612",
    locationAddress: "item20612",
    ratings: null,
    lat: 52.64596142939842,
    lng: -8.330797649116835,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2612",
    tags: [],
    locationDescription: " The man runs towards the road lazily.",
  },
  {
    locationId: "item20613",
    locationName: "item20613",
    locationAddress: "item20613",
    ratings: [
      { who: "Similar identities", rating: 3.57 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 51.78969132840164,
    lng: -5.804037743410715,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2613",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student writes the cake quickly. The cat eats the cake angrily.",
  },
  {
    locationId: "item20614",
    locationName: "item20614",
    locationAddress: "item20614",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 4.29 },
    ],
    lat: 51.76169017812497,
    lng: 0.9592659198268976,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2614",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The man looks at a book lazily.",
  },
  {
    locationId: "item20615",
    locationName: "item20615",
    locationAddress: "item20615",
    ratings: [
      { who: "Similar identities", rating: 1.22 },
      { who: "All perspectives", rating: 4.26 },
    ],
    lat: 59.81357220413726,
    lng: -8.393443841970678,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2615",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " The teacher runs towards the road lazily.",
  },
  {
    locationId: "item20616",
    locationName: "item20616",
    locationAddress: "item20616",
    ratings: null,
    lat: 55.447868779531916,
    lng: -0.6527485569340046,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2616",
    tags: [],
    locationDescription:
      " The teacher writes a book gracefully. The cat eats the road angrily.",
  },
  {
    locationId: "item20617",
    locationName: "item20617",
    locationAddress: "item20617",
    ratings: null,
    lat: 52.831525039567275,
    lng: -5.8305590497163,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2617",
    tags: [],
    locationDescription:
      " The student builds the road quickly. A woman eats the road gracefully. The student writes the horizon quickly. A woman jumps over the road angrily.",
  },
  {
    locationId: "item20618",
    locationName: "item20618",
    locationAddress: "item20618",
    ratings: null,
    lat: 50.60782658764148,
    lng: -4.9829106215831445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2618",
    tags: [],
    locationDescription: " The teacher writes the road silently.",
  },
  {
    locationId: "item20619",
    locationName: "item20619",
    locationAddress: "item20619",
    ratings: [
      { who: "Similar identities", rating: 0.27 },
      { who: "All perspectives", rating: 2.44 },
    ],
    lat: 60.80906595066553,
    lng: 0.5779858663672766,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2619",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher looks at the road gracefully. A dog looks at a book quickly. The teacher looks at a fence lazily. The teacher runs towards the horizon silently. The cat builds the horizon gracefully.",
  },
  {
    locationId: "item20620",
    locationName: "item20620",
    locationAddress: "item20620",
    ratings: [
      { who: "Similar identities", rating: 0.9 },
      { who: "All perspectives", rating: 4.97 },
    ],
    lat: 53.309076749666765,
    lng: -4.995311297550547,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2620",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " The student writes a book quickly.",
  },
  {
    locationId: "item20621",
    locationName: "item20621",
    locationAddress: "item20621",
    ratings: null,
    lat: 56.21246504802113,
    lng: -2.1790547705877934,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2621",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon quickly. The teacher jumps over a book angrily. A dog builds a book angrily. The student writes the horizon gracefully. A dog builds a fence angrily.",
  },
  {
    locationId: "item20622",
    locationName: "item20622",
    locationAddress: "item20622",
    ratings: null,
    lat: 56.10740740349664,
    lng: 0.35026423741453705,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2622",
    tags: [],
    locationDescription:
      " A woman looks at a tower lazily. The teacher looks at the horizon quickly. The man runs towards a book gracefully. The cat eats a tower silently.",
  },
  {
    locationId: "item20623",
    locationName: "item20623",
    locationAddress: "item20623",
    ratings: null,
    lat: 54.618972419806795,
    lng: -7.639295976781778,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2623",
    tags: [],
    locationDescription:
      " The student jumps over the horizon gracefully. A woman looks at the cake quickly. The student runs towards the cake happily. A woman eats the road silently.",
  },
  {
    locationId: "item20624",
    locationName: "item20624",
    locationAddress: "item20624",
    ratings: null,
    lat: 59.56083589505995,
    lng: -5.748773247501491,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2624",
    tags: [],
    locationDescription:
      " A dog builds a book gracefully. The student jumps over the road lazily. The man writes a fence quickly.",
  },
  {
    locationId: "item20625",
    locationName: "item20625",
    locationAddress: "item20625",
    ratings: null,
    lat: 50.61148625834021,
    lng: -8.417902310192032,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2625",
    tags: [],
    locationDescription:
      " The student runs towards a tower angrily. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item20626",
    locationName: "item20626",
    locationAddress: "item20626",
    ratings: [
      { who: "Similar identities", rating: 4.83 },
      { who: "All perspectives", rating: 3.14 },
    ],
    lat: 59.71624637565312,
    lng: -4.487883226660628,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2626",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog looks at a fence silently. A woman builds the cake happily.",
  },
  {
    locationId: "item20627",
    locationName: "item20627",
    locationAddress: "item20627",
    ratings: [
      { who: "Similar identities", rating: 0.71 },
      { who: "All perspectives", rating: 0.98 },
    ],
    lat: 59.286537109138614,
    lng: 1.2618913888561902,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2627",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman builds the cake gracefully. The cat writes the cake gracefully. A woman builds a tower lazily. The man looks at the cake silently. A dog jumps over a tower happily.",
  },
  {
    locationId: "item20628",
    locationName: "item20628",
    locationAddress: "item20628",
    ratings: [
      { who: "Similar identities", rating: 2.39 },
      { who: "All perspectives", rating: 4.54 },
    ],
    lat: 55.48763659663448,
    lng: -2.463141172247205,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2628",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards the horizon angrily. A dog writes the horizon quickly. The student writes a fence silently. The teacher jumps over the cake quickly. A woman jumps over a book quickly.",
  },
  {
    locationId: "item20629",
    locationName: "item20629",
    locationAddress: "item20629",
    ratings: [
      { who: "Similar identities", rating: 1.58 },
      { who: "All perspectives", rating: 2.17 },
    ],
    lat: 53.502580324973295,
    lng: -7.806638142050234,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2629",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man looks at a book gracefully. The student looks at the road angrily.",
  },
  {
    locationId: "item20630",
    locationName: "item20630",
    locationAddress: "item20630",
    ratings: null,
    lat: 60.845692750588476,
    lng: -7.956404058193636,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2630",
    tags: [],
    locationDescription:
      " The cat builds a fence happily. The teacher builds a fence lazily. The student builds the horizon quickly.",
  },
  {
    locationId: "item20631",
    locationName: "item20631",
    locationAddress: "item20631",
    ratings: [
      { who: "Similar identities", rating: 1.32 },
      { who: "All perspectives", rating: 2.41 },
    ],
    lat: 51.48076949631941,
    lng: -4.970228017872317,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2631",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at a book silently. A woman looks at the cake silently. The man runs towards a tower gracefully. The teacher runs towards the cake gracefully.",
  },
  {
    locationId: "item20632",
    locationName: "item20632",
    locationAddress: "item20632",
    ratings: null,
    lat: 56.684933147890085,
    lng: -3.5586620359018397,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2632",
    tags: [],
    locationDescription:
      " The student jumps over a tower gracefully. The student looks at the horizon happily.",
  },
  {
    locationId: "item20633",
    locationName: "item20633",
    locationAddress: "item20633",
    ratings: [
      { who: "Similar identities", rating: 4.75 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 50.67949805604785,
    lng: -6.105264079194301,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2633",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The student writes the road lazily.",
  },
  {
    locationId: "item20634",
    locationName: "item20634",
    locationAddress: "item20634",
    ratings: null,
    lat: 53.993287209865564,
    lng: -7.249226680764246,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2634",
    tags: [],
    locationDescription:
      " The student builds a fence gracefully. A woman looks at a fence lazily. A woman builds a tower lazily. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item20635",
    locationName: "item20635",
    locationAddress: "item20635",
    ratings: [
      { who: "Similar identities", rating: 2.94 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 57.45810817904029,
    lng: -4.541140042326255,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2635",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man writes the road gracefully. A dog builds the cake gracefully. The man looks at the road gracefully. The student looks at the horizon angrily.",
  },
  {
    locationId: "item20636",
    locationName: "item20636",
    locationAddress: "item20636",
    ratings: null,
    lat: 58.99989978605585,
    lng: -8.594343584057674,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2636",
    tags: [],
    locationDescription:
      " The student looks at a tower angrily. The student jumps over a fence happily.",
  },
  {
    locationId: "item20637",
    locationName: "item20637",
    locationAddress: "item20637",
    ratings: [
      { who: "Similar identities", rating: 4.8 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 57.27747301630836,
    lng: -6.628938774651136,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2637",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman runs towards the road lazily. The man jumps over a tower quickly. The man builds the road silently. The man writes a fence angrily.",
  },
  {
    locationId: "item20638",
    locationName: "item20638",
    locationAddress: "item20638",
    ratings: null,
    lat: 53.78184954779255,
    lng: -6.086205154321023,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2638",
    tags: [],
    locationDescription:
      " A woman runs towards the cake silently. A woman builds a fence happily.",
  },
  {
    locationId: "item20639",
    locationName: "item20639",
    locationAddress: "item20639",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 0.53 },
    ],
    lat: 52.168980625493234,
    lng: -4.475300439199402,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2639",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds a tower silently. A woman builds the horizon happily. The cat writes the horizon gracefully. The cat looks at a tower gracefully. The teacher writes the road quickly.",
  },
  {
    locationId: "item20640",
    locationName: "item20640",
    locationAddress: "item20640",
    ratings: [
      { who: "Similar identities", rating: 2.63 },
      { who: "All perspectives", rating: 3.05 },
    ],
    lat: 55.631650338150465,
    lng: -8.438971305301745,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2640",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher builds a fence lazily. The student eats the horizon lazily. A dog builds the cake quickly. The student jumps over the road gracefully.",
  },
  {
    locationId: "item20641",
    locationName: "item20641",
    locationAddress: "item20641",
    ratings: null,
    lat: 60.843273641916085,
    lng: -6.172995413916178,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2641",
    tags: [],
    locationDescription:
      " A woman builds the road lazily. The teacher writes the horizon quickly. A woman jumps over the horizon happily. A dog jumps over a book silently.",
  },
  {
    locationId: "item20642",
    locationName: "item20642",
    locationAddress: "item20642",
    ratings: null,
    lat: 57.531151223124,
    lng: -3.256963521399209,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2642",
    tags: [],
    locationDescription: " A dog runs towards the cake angrily.",
  },
  {
    locationId: "item20643",
    locationName: "item20643",
    locationAddress: "item20643",
    ratings: null,
    lat: 52.36792962368614,
    lng: -5.070168650808602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2643",
    tags: [],
    locationDescription:
      " The student eats the road gracefully. The man runs towards a fence lazily.",
  },
  {
    locationId: "item20644",
    locationName: "item20644",
    locationAddress: "item20644",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 2.7 },
    ],
    lat: 56.943967182266164,
    lng: -0.06807329338644408,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2644",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog builds a book happily. A dog jumps over the cake quickly. A woman jumps over the cake angrily.",
  },
  {
    locationId: "item20645",
    locationName: "item20645",
    locationAddress: "item20645",
    ratings: null,
    lat: 53.14398502103272,
    lng: -8.362817768450288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2645",
    tags: [],
    locationDescription: " A woman looks at the cake silently.",
  },
  {
    locationId: "item20646",
    locationName: "item20646",
    locationAddress: "item20646",
    ratings: null,
    lat: 50.32487345547322,
    lng: -7.627443384780421,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2646",
    tags: [],
    locationDescription:
      " The man looks at the cake happily. A woman eats a book quickly.",
  },
  {
    locationId: "item20647",
    locationName: "item20647",
    locationAddress: "item20647",
    ratings: [
      { who: "Similar identities", rating: 2.7 },
      { who: "All perspectives", rating: 2.15 },
    ],
    lat: 53.35441836569049,
    lng: 0.4551642042346291,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2647",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A dog eats a book gracefully.",
  },
  {
    locationId: "item20648",
    locationName: "item20648",
    locationAddress: "item20648",
    ratings: [
      { who: "Similar identities", rating: 1.65 },
      { who: "All perspectives", rating: 0.7 },
    ],
    lat: 52.345729242260134,
    lng: -0.6499303385003845,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2648",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man jumps over the road happily. The student looks at a tower angrily. The cat runs towards a book gracefully.",
  },
  {
    locationId: "item20649",
    locationName: "item20649",
    locationAddress: "item20649",
    ratings: [
      { who: "Similar identities", rating: 1.63 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 53.577432908616856,
    lng: -6.165193675784607,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2649",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student jumps over a tower lazily. A dog writes a fence lazily. The cat writes the cake silently. The man jumps over a fence lazily.",
  },
  {
    locationId: "item20650",
    locationName: "item20650",
    locationAddress: "item20650",
    ratings: null,
    lat: 57.13771997594638,
    lng: -1.6361189137788843,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2650",
    tags: [],
    locationDescription:
      " The student eats a fence gracefully. The teacher runs towards the horizon angrily. The teacher writes the road happily. The teacher eats a tower quickly. A dog looks at a book angrily.",
  },
  {
    locationId: "item20651",
    locationName: "item20651",
    locationAddress: "item20651",
    ratings: null,
    lat: 54.669953478947875,
    lng: -5.988885495950827,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2651",
    tags: [],
    locationDescription:
      " The student runs towards a tower silently. A dog eats a tower gracefully. The man eats a tower quickly.",
  },
  {
    locationId: "item20652",
    locationName: "item20652",
    locationAddress: "item20652",
    ratings: [
      { who: "Similar identities", rating: 0.43 },
      { who: "All perspectives", rating: 2.36 },
    ],
    lat: 57.151404419225315,
    lng: -2.0546645354616384,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2652",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat jumps over a fence lazily. The student eats the cake happily. The man builds the road angrily. The cat builds the road quickly. A dog writes a fence quickly.",
  },
  {
    locationId: "item20653",
    locationName: "item20653",
    locationAddress: "item20653",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 4.39 },
    ],
    lat: 55.325468677337156,
    lng: -5.018126375296562,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2653",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher builds a tower quickly. The student writes a tower happily. A dog runs towards the cake silently.",
  },
  {
    locationId: "item20654",
    locationName: "item20654",
    locationAddress: "item20654",
    ratings: [
      { who: "Similar identities", rating: 2.58 },
      { who: "All perspectives", rating: 3.37 },
    ],
    lat: 57.50380454868795,
    lng: -2.849915634302053,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2654",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at the horizon lazily. The student looks at the road lazily. A dog builds the cake silently. A woman runs towards a fence quickly. A dog builds a book silently.",
  },
  {
    locationId: "item20655",
    locationName: "item20655",
    locationAddress: "item20655",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 0.72 },
    ],
    lat: 51.53995219627193,
    lng: -7.710606778710594,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2655",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man jumps over the road silently. A woman looks at a fence silently. The man eats a fence happily.",
  },
  {
    locationId: "item20656",
    locationName: "item20656",
    locationAddress: "item20656",
    ratings: null,
    lat: 59.251067340051804,
    lng: -2.4837194185028606,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2656",
    tags: [],
    locationDescription:
      " The cat builds a book gracefully. A woman eats the horizon lazily. The man builds a tower angrily. A woman jumps over the horizon happily. A woman looks at a fence lazily.",
  },
  {
    locationId: "item20657",
    locationName: "item20657",
    locationAddress: "item20657",
    ratings: null,
    lat: 50.32238856152843,
    lng: -5.441017251892948,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2657",
    tags: [],
    locationDescription: " The student writes the road quickly.",
  },
  {
    locationId: "item20658",
    locationName: "item20658",
    locationAddress: "item20658",
    ratings: null,
    lat: 51.9487113547205,
    lng: -7.91938377769835,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2658",
    tags: [],
    locationDescription:
      " The man looks at the horizon angrily. A woman builds the road silently.",
  },
  {
    locationId: "item20659",
    locationName: "item20659",
    locationAddress: "item20659",
    ratings: null,
    lat: 58.34475645060683,
    lng: -4.4212524911158315,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2659",
    tags: [],
    locationDescription:
      " A woman builds a tower silently. The cat writes a fence quickly. The student runs towards a fence happily.",
  },
  {
    locationId: "item20660",
    locationName: "item20660",
    locationAddress: "item20660",
    ratings: [
      { who: "Similar identities", rating: 1.21 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 55.75808455156403,
    lng: -7.678030809327762,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2660",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats the horizon quickly. The student runs towards the cake gracefully. The student writes a fence quickly. The man runs towards a book gracefully.",
  },
  {
    locationId: "item20661",
    locationName: "item20661",
    locationAddress: "item20661",
    ratings: null,
    lat: 54.55924076180991,
    lng: -7.256730003092587,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2661",
    tags: [],
    locationDescription: " A dog eats the horizon gracefully.",
  },
  {
    locationId: "item20662",
    locationName: "item20662",
    locationAddress: "item20662",
    ratings: null,
    lat: 50.46078432829222,
    lng: -1.1388886042359125,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2662",
    tags: [],
    locationDescription:
      " The student builds the cake quickly. The man looks at the horizon angrily. The teacher eats the horizon silently. The student writes a book quickly. The man jumps over a book lazily.",
  },
  {
    locationId: "item20663",
    locationName: "item20663",
    locationAddress: "item20663",
    ratings: null,
    lat: 52.58307684044542,
    lng: 0.0202601223696508,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2663",
    tags: [],
    locationDescription:
      " The cat eats a book lazily. The student eats the horizon quickly.",
  },
  {
    locationId: "item20664",
    locationName: "item20664",
    locationAddress: "item20664",
    ratings: null,
    lat: 54.36943675855534,
    lng: -8.53455765059605,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2664",
    tags: [],
    locationDescription:
      " The teacher looks at a fence angrily. The student looks at the cake quickly.",
  },
  {
    locationId: "item20665",
    locationName: "item20665",
    locationAddress: "item20665",
    ratings: null,
    lat: 58.934333072331825,
    lng: 1.347575751213629,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2665",
    tags: [],
    locationDescription:
      " A woman jumps over a fence lazily. The student runs towards the road quickly. A woman looks at a tower happily. The man runs towards the road quickly. The teacher writes the cake happily.",
  },
  {
    locationId: "item20666",
    locationName: "item20666",
    locationAddress: "item20666",
    ratings: [
      { who: "Similar identities", rating: 2.28 },
      { who: "All perspectives", rating: 0.39 },
    ],
    lat: 52.69481122595712,
    lng: -0.31498586985583543,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2666",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher looks at the horizon angrily.",
  },
  {
    locationId: "item20667",
    locationName: "item20667",
    locationAddress: "item20667",
    ratings: null,
    lat: 51.68708273647351,
    lng: 1.5211021489635606,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2667",
    tags: [],
    locationDescription:
      " A dog builds a fence gracefully. The cat looks at a fence happily. A woman builds a book gracefully. A dog jumps over a fence happily.",
  },
  {
    locationId: "item20668",
    locationName: "item20668",
    locationAddress: "item20668",
    ratings: [
      { who: "Similar identities", rating: 2.36 },
      { who: "All perspectives", rating: 0.95 },
    ],
    lat: 50.11847641810802,
    lng: -0.2750244073481305,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2668",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes a fence quickly. The man runs towards a fence angrily. A woman runs towards the cake angrily. A woman jumps over the road silently.",
  },
  {
    locationId: "item20669",
    locationName: "item20669",
    locationAddress: "item20669",
    ratings: null,
    lat: 50.55487892805616,
    lng: 0.045258408387699234,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2669",
    tags: [],
    locationDescription:
      " A dog eats the cake angrily. A woman eats the horizon angrily. The teacher writes a tower silently. A dog writes the road gracefully. A dog jumps over a book silently.",
  },
  {
    locationId: "item20670",
    locationName: "item20670",
    locationAddress: "item20670",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 50.887999773203624,
    lng: -1.3283856381698245,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2670",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student writes a book happily. The teacher builds the cake angrily. The student eats a tower quickly.",
  },
  {
    locationId: "item20671",
    locationName: "item20671",
    locationAddress: "item20671",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 0.71 },
    ],
    lat: 57.81053177489548,
    lng: -0.4728308066043141,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2671",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at a book quickly. The teacher builds a tower quickly. The student looks at a book silently. The man runs towards a book happily. A dog looks at a fence gracefully.",
  },
  {
    locationId: "item20672",
    locationName: "item20672",
    locationAddress: "item20672",
    ratings: [
      { who: "Similar identities", rating: 1.15 },
      { who: "All perspectives", rating: 3.15 },
    ],
    lat: 56.23455474573192,
    lng: -2.4953673133938414,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2672",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at a tower gracefully. The student builds a tower lazily. The student eats a tower gracefully. The teacher looks at the horizon quickly.",
  },
  {
    locationId: "item20673",
    locationName: "item20673",
    locationAddress: "item20673",
    ratings: null,
    lat: 53.33893726536776,
    lng: -3.6412676194896827,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2673",
    tags: [],
    locationDescription:
      " A dog jumps over a book happily. The student writes the road gracefully.",
  },
  {
    locationId: "item20674",
    locationName: "item20674",
    locationAddress: "item20674",
    ratings: null,
    lat: 60.3342771054721,
    lng: -0.7053647700395738,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2674",
    tags: [],
    locationDescription:
      " A dog runs towards the road quickly. The teacher writes a tower silently. The cat eats a fence angrily. The man runs towards a tower lazily. A dog writes the cake silently.",
  },
  {
    locationId: "item20675",
    locationName: "item20675",
    locationAddress: "item20675",
    ratings: [
      { who: "Similar identities", rating: 3.0 },
      { who: "All perspectives", rating: 4.78 },
    ],
    lat: 51.547432822012034,
    lng: -5.823544432909456,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2675",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards the cake lazily. The cat runs towards a fence silently. The man runs towards a fence gracefully. The man runs towards a book happily. The cat looks at the horizon angrily.",
  },
  {
    locationId: "item20676",
    locationName: "item20676",
    locationAddress: "item20676",
    ratings: null,
    lat: 52.354128775051436,
    lng: -0.18013981151758252,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2676",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. A woman eats the road silently. The man eats a tower lazily. A woman jumps over a fence happily. A dog eats the horizon happily.",
  },
  {
    locationId: "item20677",
    locationName: "item20677",
    locationAddress: "item20677",
    ratings: [
      { who: "Similar identities", rating: 2.72 },
      { who: "All perspectives", rating: 2.71 },
    ],
    lat: 52.446916707339,
    lng: 0.03377421916643186,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2677",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman jumps over the road quickly. The cat builds the horizon gracefully. The teacher builds the cake happily. The man eats the cake silently.",
  },
  {
    locationId: "item20678",
    locationName: "item20678",
    locationAddress: "item20678",
    ratings: null,
    lat: 49.99230252469194,
    lng: -2.347398408976474,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2678",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence happily. The teacher runs towards a book silently.",
  },
  {
    locationId: "item20679",
    locationName: "item20679",
    locationAddress: "item20679",
    ratings: [
      { who: "Similar identities", rating: 1.78 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 55.63104578169002,
    lng: -7.48316309491525,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2679",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The teacher runs towards the cake silently. A dog runs towards the cake quickly. A woman looks at a tower silently.",
  },
  {
    locationId: "item20680",
    locationName: "item20680",
    locationAddress: "item20680",
    ratings: [
      { who: "Similar identities", rating: 2.91 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 56.7435710009855,
    lng: -5.231786345787794,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2680",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man jumps over the road lazily. The cat builds the cake silently.",
  },
  {
    locationId: "item20681",
    locationName: "item20681",
    locationAddress: "item20681",
    ratings: [
      { who: "Similar identities", rating: 3.84 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 55.264916606286214,
    lng: -8.014605808918114,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2681",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat runs towards a tower angrily. The student writes a fence happily. The cat runs towards the cake lazily. The cat eats a fence happily. The teacher writes a fence gracefully.",
  },
  {
    locationId: "item20682",
    locationName: "item20682",
    locationAddress: "item20682",
    ratings: [
      { who: "Similar identities", rating: 4.54 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 55.80201040606462,
    lng: -7.609054024243594,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2682",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat builds the cake quickly. A woman builds a fence silently. The cat looks at the horizon lazily. The man builds the cake quickly.",
  },
  {
    locationId: "item20683",
    locationName: "item20683",
    locationAddress: "item20683",
    ratings: [
      { who: "Similar identities", rating: 3.35 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 60.224663506614256,
    lng: -4.451345247172027,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2683",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A woman eats the cake lazily. A woman runs towards the road angrily. The teacher eats a fence gracefully. The teacher writes a tower quickly.",
  },
  {
    locationId: "item20684",
    locationName: "item20684",
    locationAddress: "item20684",
    ratings: [
      { who: "Similar identities", rating: 3.71 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 55.47228512148182,
    lng: -2.303395917016947,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2684",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes a fence angrily. The teacher looks at a book angrily. The teacher looks at the cake silently.",
  },
  {
    locationId: "item20685",
    locationName: "item20685",
    locationAddress: "item20685",
    ratings: [
      { who: "Similar identities", rating: 3.97 },
      { who: "All perspectives", rating: 0.97 },
    ],
    lat: 50.94907126138144,
    lng: -0.2886703527346892,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2685",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man runs towards a tower quickly. A dog writes a tower lazily. The teacher writes a fence angrily.",
  },
  {
    locationId: "item20686",
    locationName: "item20686",
    locationAddress: "item20686",
    ratings: null,
    lat: 54.354706957270736,
    lng: -5.148132298071905,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2686",
    tags: [],
    locationDescription:
      " The teacher jumps over a book silently. The teacher jumps over a fence angrily. The teacher eats the road happily. The man looks at the cake quickly. A woman looks at a tower lazily.",
  },
  {
    locationId: "item20687",
    locationName: "item20687",
    locationAddress: "item20687",
    ratings: [
      { who: "Similar identities", rating: 0.25 },
      { who: "All perspectives", rating: 0.17 },
    ],
    lat: 55.79791622129599,
    lng: 0.5171695124379436,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2687",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher eats a fence angrily. A woman looks at a fence happily. A woman jumps over a tower angrily. The cat builds a fence angrily.",
  },
  {
    locationId: "item20688",
    locationName: "item20688",
    locationAddress: "item20688",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 51.8691913127034,
    lng: -2.4842848289102095,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2688",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman writes a book lazily. The man builds a fence lazily. A woman jumps over a fence lazily. The cat writes the horizon angrily. The cat writes the horizon angrily.",
  },
  {
    locationId: "item20689",
    locationName: "item20689",
    locationAddress: "item20689",
    ratings: [
      { who: "Similar identities", rating: 2.5 },
      { who: "All perspectives", rating: 2.0 },
    ],
    lat: 60.09741610797872,
    lng: -5.192886861060895,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2689",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat looks at the horizon lazily. A woman builds the cake happily. A woman builds a tower silently.",
  },
  {
    locationId: "item20690",
    locationName: "item20690",
    locationAddress: "item20690",
    ratings: null,
    lat: 57.587808308801,
    lng: -2.0295431769723598,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2690",
    tags: [],
    locationDescription: " A woman eats a tower gracefully.",
  },
  {
    locationId: "item20691",
    locationName: "item20691",
    locationAddress: "item20691",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 58.633016089051864,
    lng: -0.18728299670376103,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2691",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat writes a tower silently. A dog builds the cake gracefully. The student looks at the cake lazily. A woman eats the horizon happily. The student jumps over the cake quickly.",
  },
  {
    locationId: "item20692",
    locationName: "item20692",
    locationAddress: "item20692",
    ratings: [
      { who: "Similar identities", rating: 1.68 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 52.770431986229,
    lng: -1.0935562858801884,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2692",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman jumps over a book gracefully. A dog jumps over a book silently.",
  },
  {
    locationId: "item20693",
    locationName: "item20693",
    locationAddress: "item20693",
    ratings: null,
    lat: 53.35686951155387,
    lng: -6.986579227548276,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2693",
    tags: [],
    locationDescription:
      " The man jumps over a book quickly. The student eats a fence lazily. A dog builds the cake silently. A woman runs towards the road gracefully. A woman runs towards a fence silently.",
  },
  {
    locationId: "item20694",
    locationName: "item20694",
    locationAddress: "item20694",
    ratings: [
      { who: "Similar identities", rating: 0.98 },
      { who: "All perspectives", rating: 0.6 },
    ],
    lat: 51.20423079827411,
    lng: -5.933497591615589,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2694",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog writes the horizon gracefully. The student eats the cake happily.",
  },
  {
    locationId: "item20695",
    locationName: "item20695",
    locationAddress: "item20695",
    ratings: null,
    lat: 60.45943098568104,
    lng: -6.869945346923363,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2695",
    tags: [],
    locationDescription: " The man jumps over a book angrily.",
  },
  {
    locationId: "item20696",
    locationName: "item20696",
    locationAddress: "item20696",
    ratings: [
      { who: "Similar identities", rating: 3.54 },
      { who: "All perspectives", rating: 0.46 },
    ],
    lat: 54.08614078571985,
    lng: 0.8743657265998532,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2696",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman eats the horizon quickly. A dog jumps over the horizon happily. A dog looks at the road lazily. The cat builds a book happily.",
  },
  {
    locationId: "item20697",
    locationName: "item20697",
    locationAddress: "item20697",
    ratings: null,
    lat: 54.10449517544625,
    lng: -0.3846842467491811,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2697",
    tags: [],
    locationDescription:
      " A woman writes a fence gracefully. The cat looks at a tower angrily. The student builds a fence angrily.",
  },
  {
    locationId: "item20698",
    locationName: "item20698",
    locationAddress: "item20698",
    ratings: null,
    lat: 59.33312964078292,
    lng: -1.5179658724906844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2698",
    tags: [],
    locationDescription: " A woman runs towards a tower gracefully.",
  },
  {
    locationId: "item20699",
    locationName: "item20699",
    locationAddress: "item20699",
    ratings: null,
    lat: 55.90089574186198,
    lng: -8.077811547355164,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2699",
    tags: [],
    locationDescription:
      " A dog builds a book gracefully. A woman eats a fence lazily.",
  },
  {
    locationId: "item20700",
    locationName: "item20700",
    locationAddress: "item20700",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 0.07 },
    ],
    lat: 60.76260482703168,
    lng: -1.8444011387623735,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2700",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at the horizon quickly. The cat jumps over the road gracefully.",
  },
  {
    locationId: "item20701",
    locationName: "item20701",
    locationAddress: "item20701",
    ratings: null,
    lat: 50.04067379076275,
    lng: -4.82178432065339,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2701",
    tags: [],
    locationDescription:
      " The teacher builds the cake lazily. The teacher jumps over a book gracefully. A dog runs towards a book angrily.",
  },
  {
    locationId: "item20702",
    locationName: "item20702",
    locationAddress: "item20702",
    ratings: [
      { who: "Similar identities", rating: 1.1 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 59.28421127893523,
    lng: -6.890825803242706,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2702",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman eats a tower gracefully. A dog writes the cake angrily. The cat writes the horizon lazily. The cat eats a book lazily. The student writes the cake gracefully.",
  },
  {
    locationId: "item20703",
    locationName: "item20703",
    locationAddress: "item20703",
    ratings: null,
    lat: 51.65012534175247,
    lng: -1.9927814272456308,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2703",
    tags: [],
    locationDescription:
      " A dog eats a book gracefully. A woman looks at a book happily.",
  },
  {
    locationId: "item20704",
    locationName: "item20704",
    locationAddress: "item20704",
    ratings: [
      { who: "Similar identities", rating: 0.2 },
      { who: "All perspectives", rating: 1.76 },
    ],
    lat: 52.61943515608777,
    lng: 0.23207167989249022,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2704",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student looks at the road gracefully. A woman writes a fence silently. The man writes the cake happily.",
  },
  {
    locationId: "item20705",
    locationName: "item20705",
    locationAddress: "item20705",
    ratings: [
      { who: "Similar identities", rating: 3.73 },
      { who: "All perspectives", rating: 4.43 },
    ],
    lat: 51.8970046549218,
    lng: -8.154152502241494,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2705",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man looks at a book angrily. The cat builds a tower lazily. A woman builds the cake quickly.",
  },
  {
    locationId: "item20706",
    locationName: "item20706",
    locationAddress: "item20706",
    ratings: null,
    lat: 55.31824466286227,
    lng: 0.39542915075722185,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2706",
    tags: [],
    locationDescription:
      " The man jumps over a tower silently. The man eats the road silently. The cat writes the cake happily. The cat eats the horizon quickly. A dog looks at a fence silently.",
  },
  {
    locationId: "item20707",
    locationName: "item20707",
    locationAddress: "item20707",
    ratings: null,
    lat: 58.59616919708851,
    lng: -6.074892306225371,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2707",
    tags: [],
    locationDescription:
      " A woman jumps over the cake happily. The cat looks at a tower angrily. The teacher jumps over a fence quickly.",
  },
  {
    locationId: "item20708",
    locationName: "item20708",
    locationAddress: "item20708",
    ratings: [
      { who: "Similar identities", rating: 0.67 },
      { who: "All perspectives", rating: 4.52 },
    ],
    lat: 51.268899819660064,
    lng: -2.133218883783962,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2708",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat looks at the cake quickly. A dog eats a tower gracefully. A dog builds a fence happily. The man writes the cake quickly. A dog runs towards the horizon gracefully.",
  },
  {
    locationId: "item20709",
    locationName: "item20709",
    locationAddress: "item20709",
    ratings: null,
    lat: 57.268204746993646,
    lng: 0.3779183826941548,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2709",
    tags: [],
    locationDescription:
      " The man builds the road angrily. The man looks at a book lazily. The cat eats the cake lazily. The man runs towards a tower silently. The student looks at the horizon silently.",
  },
  {
    locationId: "item20710",
    locationName: "item20710",
    locationAddress: "item20710",
    ratings: null,
    lat: 59.22254185685604,
    lng: -0.7892510331930058,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2710",
    tags: [],
    locationDescription: " The student jumps over the horizon silently.",
  },
  {
    locationId: "item20711",
    locationName: "item20711",
    locationAddress: "item20711",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 53.711871866949316,
    lng: -2.365737987534584,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2711",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The student builds the cake lazily. The man jumps over the road happily. A dog builds a tower happily. The student writes the horizon silently.",
  },
  {
    locationId: "item20712",
    locationName: "item20712",
    locationAddress: "item20712",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 50.67114009404035,
    lng: -0.9195466763521285,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2712",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The cat eats a tower lazily. A woman builds the road happily. The student eats a tower quickly.",
  },
  {
    locationId: "item20713",
    locationName: "item20713",
    locationAddress: "item20713",
    ratings: null,
    lat: 52.988944038027356,
    lng: 0.8207926930762319,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2713",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake happily. A dog looks at the road happily. A dog runs towards the road lazily. The student looks at a fence quickly. A woman looks at the road lazily.",
  },
  {
    locationId: "item20714",
    locationName: "item20714",
    locationAddress: "item20714",
    ratings: null,
    lat: 60.14876499497565,
    lng: -6.72580128125883,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2714",
    tags: [],
    locationDescription:
      " The student jumps over the road angrily. A dog runs towards a tower angrily. The man eats the road lazily.",
  },
  {
    locationId: "item20715",
    locationName: "item20715",
    locationAddress: "item20715",
    ratings: null,
    lat: 51.29693595424943,
    lng: -2.7139216780376927,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2715",
    tags: [],
    locationDescription: " The student builds the cake silently.",
  },
  {
    locationId: "item20716",
    locationName: "item20716",
    locationAddress: "item20716",
    ratings: [
      { who: "Similar identities", rating: 2.02 },
      { who: "All perspectives", rating: 4.5 },
    ],
    lat: 51.622517947451165,
    lng: -1.3046153662495863,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2716",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The teacher writes the road angrily.",
  },
  {
    locationId: "item20717",
    locationName: "item20717",
    locationAddress: "item20717",
    ratings: null,
    lat: 53.0231161212629,
    lng: -7.42387338783492,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2717",
    tags: [],
    locationDescription: " A dog writes a tower gracefully.",
  },
  {
    locationId: "item20718",
    locationName: "item20718",
    locationAddress: "item20718",
    ratings: [
      { who: "Similar identities", rating: 2.76 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 60.83998430191423,
    lng: -4.976391331257148,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2718",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " A woman eats the cake gracefully.",
  },
  {
    locationId: "item20719",
    locationName: "item20719",
    locationAddress: "item20719",
    ratings: null,
    lat: 55.53555944356746,
    lng: -3.3520817290203535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2719",
    tags: [],
    locationDescription:
      " The cat jumps over the road gracefully. The cat looks at a tower silently.",
  },
  {
    locationId: "item20720",
    locationName: "item20720",
    locationAddress: "item20720",
    ratings: null,
    lat: 58.35982952582284,
    lng: -6.270266784923669,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2720",
    tags: [],
    locationDescription: " The student eats the horizon silently.",
  },
  {
    locationId: "item20721",
    locationName: "item20721",
    locationAddress: "item20721",
    ratings: [
      { who: "Similar identities", rating: 4.5 },
      { who: "All perspectives", rating: 4.58 },
    ],
    lat: 58.57538785056091,
    lng: -2.2832460695923,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2721",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes a book quickly. The man builds a tower gracefully. The man builds a book lazily. The teacher writes a tower gracefully.",
  },
  {
    locationId: "item20722",
    locationName: "item20722",
    locationAddress: "item20722",
    ratings: null,
    lat: 56.22426909400951,
    lng: -5.774035244733508,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2722",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower lazily. The man runs towards the horizon gracefully. A woman runs towards a fence gracefully. The teacher writes a tower silently.",
  },
  {
    locationId: "item20723",
    locationName: "item20723",
    locationAddress: "item20723",
    ratings: null,
    lat: 54.19302115058769,
    lng: -0.5709415680456651,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2723",
    tags: [],
    locationDescription:
      " The teacher eats a book happily. The man runs towards a tower gracefully. A dog writes the road quickly. The teacher jumps over the road happily.",
  },
  {
    locationId: "item20724",
    locationName: "item20724",
    locationAddress: "item20724",
    ratings: [
      { who: "Similar identities", rating: 1.5 },
      { who: "All perspectives", rating: 0.42 },
    ],
    lat: 51.0693648010345,
    lng: -4.148609532573659,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2724",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat writes a book silently. A woman builds the horizon lazily. A woman eats the horizon silently.",
  },
  {
    locationId: "item20725",
    locationName: "item20725",
    locationAddress: "item20725",
    ratings: [
      { who: "Similar identities", rating: 2.17 },
      { who: "All perspectives", rating: 0.53 },
    ],
    lat: 59.17352868203366,
    lng: -7.089919501098224,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2725",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a fence happily. The teacher runs towards the cake gracefully. The student runs towards the road happily. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item20726",
    locationName: "item20726",
    locationAddress: "item20726",
    ratings: [
      { who: "Similar identities", rating: 2.01 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 56.38365435839605,
    lng: -4.391491741806392,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2726",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat builds the cake gracefully. A woman looks at the horizon angrily.",
  },
  {
    locationId: "item20727",
    locationName: "item20727",
    locationAddress: "item20727",
    ratings: null,
    lat: 52.785422417155765,
    lng: 0.18497534783105252,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2727",
    tags: [],
    locationDescription: " A woman builds the road angrily.",
  },
  {
    locationId: "item20728",
    locationName: "item20728",
    locationAddress: "item20728",
    ratings: null,
    lat: 57.3131515508478,
    lng: -2.4458089057048733,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2728",
    tags: [],
    locationDescription:
      " The man looks at a tower gracefully. The teacher runs towards a tower gracefully. A woman jumps over the horizon gracefully. The man runs towards a fence silently.",
  },
  {
    locationId: "item20729",
    locationName: "item20729",
    locationAddress: "item20729",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 1.59 },
    ],
    lat: 57.66109262968729,
    lng: -8.033577714932626,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2729",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The cat eats a book happily.",
  },
  {
    locationId: "item20730",
    locationName: "item20730",
    locationAddress: "item20730",
    ratings: null,
    lat: 52.09688721970343,
    lng: 1.0655875647453517,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2730",
    tags: [],
    locationDescription: " The teacher eats the horizon gracefully.",
  },
  {
    locationId: "item20731",
    locationName: "item20731",
    locationAddress: "item20731",
    ratings: null,
    lat: 60.164443424349685,
    lng: -2.035098607833919,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2731",
    tags: [],
    locationDescription: " The man eats the cake lazily.",
  },
  {
    locationId: "item20732",
    locationName: "item20732",
    locationAddress: "item20732",
    ratings: [
      { who: "Similar identities", rating: 4.91 },
      { who: "All perspectives", rating: 3.38 },
    ],
    lat: 55.478509508901205,
    lng: -6.052958908895873,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2732",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes the horizon quickly. The man jumps over a tower silently. A woman jumps over the road quickly. A dog writes the road silently.",
  },
  {
    locationId: "item20733",
    locationName: "item20733",
    locationAddress: "item20733",
    ratings: [
      { who: "Similar identities", rating: 1.24 },
      { who: "All perspectives", rating: 3.92 },
    ],
    lat: 53.320290650844534,
    lng: -4.877711920092499,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2733",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats a fence lazily. The man jumps over the road gracefully. A dog looks at the cake quickly. The student eats the road quickly.",
  },
  {
    locationId: "item20734",
    locationName: "item20734",
    locationAddress: "item20734",
    ratings: null,
    lat: 57.12618889376161,
    lng: -1.1128523273584676,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2734",
    tags: [],
    locationDescription:
      " The man eats the road quickly. A dog jumps over the cake angrily.",
  },
  {
    locationId: "item20735",
    locationName: "item20735",
    locationAddress: "item20735",
    ratings: null,
    lat: 53.51328966375368,
    lng: 0.6401715331976021,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2735",
    tags: [],
    locationDescription:
      " A dog builds the road lazily. The teacher writes a fence lazily. The cat builds the horizon silently.",
  },
  {
    locationId: "item20736",
    locationName: "item20736",
    locationAddress: "item20736",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 1.1 },
    ],
    lat: 52.05989688452655,
    lng: -7.791003304992135,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2736",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a tower happily. A woman jumps over the horizon silently. The student jumps over a book happily. A dog writes the horizon lazily.",
  },
  {
    locationId: "item20737",
    locationName: "item20737",
    locationAddress: "item20737",
    ratings: null,
    lat: 52.053329320682145,
    lng: -6.617100973360003,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2737",
    tags: [],
    locationDescription: " The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item20738",
    locationName: "item20738",
    locationAddress: "item20738",
    ratings: null,
    lat: 56.40145283206493,
    lng: -6.590689355236909,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2738",
    tags: [],
    locationDescription:
      " A dog looks at a book lazily. The cat runs towards the road silently. The cat builds the road quickly. A woman looks at the road silently. A woman builds a book quickly.",
  },
  {
    locationId: "item20739",
    locationName: "item20739",
    locationAddress: "item20739",
    ratings: [
      { who: "Similar identities", rating: 1.38 },
      { who: "All perspectives", rating: 2.13 },
    ],
    lat: 60.67191389258689,
    lng: 1.547069457376228,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2739",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog runs towards a book quickly. A woman jumps over the cake gracefully. The cat builds a fence silently. The teacher writes the horizon silently. The cat eats a book silently.",
  },
  {
    locationId: "item20740",
    locationName: "item20740",
    locationAddress: "item20740",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 2.01 },
    ],
    lat: 59.92430581022063,
    lng: 1.176387843261729,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2740",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man builds the road silently. The man eats a tower gracefully. The man builds the cake lazily. The man jumps over the road silently. A dog eats the cake lazily.",
  },
  {
    locationId: "item20741",
    locationName: "item20741",
    locationAddress: "item20741",
    ratings: null,
    lat: 51.935143471229054,
    lng: -2.559698411520551,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2741",
    tags: [],
    locationDescription:
      " A woman runs towards a tower lazily. The student eats the cake gracefully. The teacher jumps over the road quickly.",
  },
  {
    locationId: "item20742",
    locationName: "item20742",
    locationAddress: "item20742",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 4.86 },
    ],
    lat: 60.01144544812432,
    lng: -7.591207173626538,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2742",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at a fence silently. The student eats a book gracefully. The student runs towards a tower gracefully. The man writes the cake quickly.",
  },
  {
    locationId: "item20743",
    locationName: "item20743",
    locationAddress: "item20743",
    ratings: null,
    lat: 54.767211799411555,
    lng: -7.609598661060678,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2743",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon silently. The teacher runs towards the road quickly.",
  },
  {
    locationId: "item20744",
    locationName: "item20744",
    locationAddress: "item20744",
    ratings: [
      { who: "Similar identities", rating: 3.77 },
      { who: "All perspectives", rating: 3.16 },
    ],
    lat: 60.44389014182106,
    lng: -7.576851943518125,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2744",
    tags: [{ label: "accessible" }],
    locationDescription: " The cat builds the cake happily.",
  },
  {
    locationId: "item20745",
    locationName: "item20745",
    locationAddress: "item20745",
    ratings: [
      { who: "Similar identities", rating: 4.27 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 58.07653437551055,
    lng: 1.3760446517171463,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2745",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes a fence gracefully. The cat writes a fence angrily. The man jumps over the horizon lazily. A woman builds a fence happily.",
  },
  {
    locationId: "item20746",
    locationName: "item20746",
    locationAddress: "item20746",
    ratings: null,
    lat: 56.23008653180369,
    lng: -1.6654106179957369,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2746",
    tags: [],
    locationDescription:
      " The man runs towards the horizon angrily. The student looks at the road angrily. The man runs towards a tower silently. A woman runs towards a fence silently.",
  },
  {
    locationId: "item20747",
    locationName: "item20747",
    locationAddress: "item20747",
    ratings: null,
    lat: 51.76296274339768,
    lng: -2.8606003059756,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2747",
    tags: [],
    locationDescription: " A woman jumps over a tower happily.",
  },
  {
    locationId: "item20748",
    locationName: "item20748",
    locationAddress: "item20748",
    ratings: null,
    lat: 57.24464769434205,
    lng: -7.051798532718322,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2748",
    tags: [],
    locationDescription: " The cat runs towards a tower quickly.",
  },
  {
    locationId: "item20749",
    locationName: "item20749",
    locationAddress: "item20749",
    ratings: [
      { who: "Similar identities", rating: 4.78 },
      { who: "All perspectives", rating: 2.48 },
    ],
    lat: 51.976127925398096,
    lng: -5.555260996736825,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2749",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher looks at a fence happily.",
  },
  {
    locationId: "item20750",
    locationName: "item20750",
    locationAddress: "item20750",
    ratings: [
      { who: "Similar identities", rating: 1.92 },
      { who: "All perspectives", rating: 0.54 },
    ],
    lat: 56.96551899939084,
    lng: -6.215447212864816,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2750",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards a book gracefully. The man eats the horizon angrily. A woman looks at the horizon quickly. A woman looks at a book quickly. A woman runs towards the cake silently.",
  },
  {
    locationId: "item20751",
    locationName: "item20751",
    locationAddress: "item20751",
    ratings: [
      { who: "Similar identities", rating: 3.11 },
      { who: "All perspectives", rating: 1.85 },
    ],
    lat: 52.10505493276812,
    lng: -6.981114122734879,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2751",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat writes the cake gracefully. The man writes the cake angrily. The student runs towards the cake happily.",
  },
  {
    locationId: "item20752",
    locationName: "item20752",
    locationAddress: "item20752",
    ratings: null,
    lat: 54.95089040255862,
    lng: -4.045741708324395,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2752",
    tags: [],
    locationDescription: " The man builds the cake quickly.",
  },
  {
    locationId: "item20753",
    locationName: "item20753",
    locationAddress: "item20753",
    ratings: [
      { who: "Similar identities", rating: 1.75 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 56.3418527958268,
    lng: -1.8848785951543574,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2753",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman looks at a tower silently. The student eats a fence gracefully.",
  },
  {
    locationId: "item20754",
    locationName: "item20754",
    locationAddress: "item20754",
    ratings: null,
    lat: 59.43536647764119,
    lng: -8.21629703037893,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2754",
    tags: [],
    locationDescription:
      " A woman jumps over the cake lazily. The teacher eats a tower lazily. The student eats the horizon gracefully. The man builds a tower silently. The student runs towards a book quickly.",
  },
  {
    locationId: "item20755",
    locationName: "item20755",
    locationAddress: "item20755",
    ratings: null,
    lat: 50.58690535373361,
    lng: -5.0335088283982365,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2755",
    tags: [],
    locationDescription:
      " The teacher builds a book angrily. The cat builds the road angrily.",
  },
  {
    locationId: "item20756",
    locationName: "item20756",
    locationAddress: "item20756",
    ratings: null,
    lat: 51.5419146374546,
    lng: -5.0449790451110745,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2756",
    tags: [],
    locationDescription: " A dog looks at the horizon silently.",
  },
  {
    locationId: "item20757",
    locationName: "item20757",
    locationAddress: "item20757",
    ratings: null,
    lat: 50.254402206332216,
    lng: 1.3854870144176363,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2757",
    tags: [],
    locationDescription:
      " A woman jumps over the cake lazily. The student jumps over a book lazily.",
  },
  {
    locationId: "item20758",
    locationName: "item20758",
    locationAddress: "item20758",
    ratings: null,
    lat: 56.948650552887976,
    lng: -0.1732787930045223,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2758",
    tags: [],
    locationDescription:
      " The cat jumps over a tower quickly. The cat builds the horizon happily. A woman jumps over a book lazily. The student runs towards a fence happily.",
  },
  {
    locationId: "item20759",
    locationName: "item20759",
    locationAddress: "item20759",
    ratings: null,
    lat: 55.67601474419053,
    lng: 1.7383597086974802,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2759",
    tags: [],
    locationDescription: " The teacher looks at the road lazily.",
  },
  {
    locationId: "item20760",
    locationName: "item20760",
    locationAddress: "item20760",
    ratings: [
      { who: "Similar identities", rating: 3.76 },
      { who: "All perspectives", rating: 0.02 },
    ],
    lat: 51.6414451876241,
    lng: -5.628632593779855,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2760",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The student runs towards the road gracefully.",
  },
  {
    locationId: "item20761",
    locationName: "item20761",
    locationAddress: "item20761",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 1.29 },
    ],
    lat: 51.50177079833186,
    lng: -5.757336383446104,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2761",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a fence lazily. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20762",
    locationName: "item20762",
    locationAddress: "item20762",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 55.61564063293617,
    lng: -4.684366233530395,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2762",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog eats the horizon happily.",
  },
  {
    locationId: "item20763",
    locationName: "item20763",
    locationAddress: "item20763",
    ratings: null,
    lat: 56.559228044062316,
    lng: -8.231578360916467,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2763",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake quickly. A dog runs towards a fence quickly. The student looks at the cake quickly.",
  },
  {
    locationId: "item20764",
    locationName: "item20764",
    locationAddress: "item20764",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 58.98720065519416,
    lng: -1.192416468979963,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2764",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman writes the road silently. The cat runs towards the cake gracefully. The man runs towards the road happily. The teacher writes the cake lazily.",
  },
  {
    locationId: "item20765",
    locationName: "item20765",
    locationAddress: "item20765",
    ratings: [
      { who: "Similar identities", rating: 4.3 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 54.802529296658896,
    lng: -3.518014170301277,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2765",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The man writes a fence happily.",
  },
  {
    locationId: "item20766",
    locationName: "item20766",
    locationAddress: "item20766",
    ratings: [
      { who: "Similar identities", rating: 2.29 },
      { who: "All perspectives", rating: 2.64 },
    ],
    lat: 60.638509765936455,
    lng: -7.53898118930745,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2766",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over a tower gracefully. The man eats a tower angrily. A woman builds a fence silently.",
  },
  {
    locationId: "item20767",
    locationName: "item20767",
    locationAddress: "item20767",
    ratings: [
      { who: "Similar identities", rating: 3.14 },
      { who: "All perspectives", rating: 4.09 },
    ],
    lat: 56.496057216260404,
    lng: -6.977933060031076,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2767",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " A woman looks at a tower lazily.",
  },
  {
    locationId: "item20768",
    locationName: "item20768",
    locationAddress: "item20768",
    ratings: null,
    lat: 53.349436135122474,
    lng: -3.9323011068187936,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2768",
    tags: [],
    locationDescription: " The man writes the horizon gracefully.",
  },
  {
    locationId: "item20769",
    locationName: "item20769",
    locationAddress: "item20769",
    ratings: null,
    lat: 50.468216217838595,
    lng: -2.1885660668978426,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2769",
    tags: [],
    locationDescription:
      " The student eats a book lazily. The cat jumps over a book happily.",
  },
  {
    locationId: "item20770",
    locationName: "item20770",
    locationAddress: "item20770",
    ratings: null,
    lat: 52.09446008840009,
    lng: -7.93363410381096,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2770",
    tags: [],
    locationDescription: " A woman writes the cake angrily.",
  },
  {
    locationId: "item20771",
    locationName: "item20771",
    locationAddress: "item20771",
    ratings: null,
    lat: 56.28648866527253,
    lng: -5.302309257688758,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2771",
    tags: [],
    locationDescription:
      " The man runs towards the road gracefully. The student runs towards the horizon gracefully. A dog eats the road silently. The man runs towards a book gracefully. The cat runs towards a fence happily.",
  },
  {
    locationId: "item20772",
    locationName: "item20772",
    locationAddress: "item20772",
    ratings: [
      { who: "Similar identities", rating: 1.7 },
      { who: "All perspectives", rating: 4.07 },
    ],
    lat: 57.90970963607847,
    lng: -4.046038008429021,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2772",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man builds a tower lazily. A dog runs towards the road silently. The student writes the horizon silently.",
  },
  {
    locationId: "item20773",
    locationName: "item20773",
    locationAddress: "item20773",
    ratings: [
      { who: "Similar identities", rating: 3.91 },
      { who: "All perspectives", rating: 3.95 },
    ],
    lat: 55.882175963770614,
    lng: -7.0449881404894334,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2773",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student looks at a fence angrily. The student jumps over the horizon gracefully. A dog looks at a tower lazily. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item20774",
    locationName: "item20774",
    locationAddress: "item20774",
    ratings: [
      { who: "Similar identities", rating: 0.79 },
      { who: "All perspectives", rating: 1.29 },
    ],
    lat: 49.92558232810178,
    lng: -5.6310878722919,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2774",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student jumps over the road gracefully. The teacher runs towards a tower gracefully. The teacher runs towards the road quickly. A dog runs towards a book lazily. The cat builds the road lazily.",
  },
  {
    locationId: "item20775",
    locationName: "item20775",
    locationAddress: "item20775",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 3.56 },
    ],
    lat: 56.6730831618813,
    lng: -6.013113954318159,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2775",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman jumps over the horizon angrily. The teacher eats the cake angrily. The student writes a fence silently. The man jumps over the cake quickly. The cat writes a book angrily.",
  },
  {
    locationId: "item20776",
    locationName: "item20776",
    locationAddress: "item20776",
    ratings: null,
    lat: 54.01275513153622,
    lng: -5.226387201201944,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2776",
    tags: [],
    locationDescription:
      " A woman looks at the horizon quickly. The man runs towards the horizon happily. The man eats a tower happily. The cat eats a tower happily. The cat eats the cake gracefully.",
  },
  {
    locationId: "item20777",
    locationName: "item20777",
    locationAddress: "item20777",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 3.08 },
    ],
    lat: 53.71300606358523,
    lng: -0.36556530187736236,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2777",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog writes a book gracefully. The cat builds the cake silently. The man looks at the road happily.",
  },
  {
    locationId: "item20778",
    locationName: "item20778",
    locationAddress: "item20778",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 1.51 },
    ],
    lat: 59.353441287567314,
    lng: -0.8465742654844659,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2778",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The man eats a book silently. A woman looks at a fence lazily.",
  },
  {
    locationId: "item20779",
    locationName: "item20779",
    locationAddress: "item20779",
    ratings: [
      { who: "Similar identities", rating: 2.6 },
      { who: "All perspectives", rating: 2.35 },
    ],
    lat: 55.99610618695638,
    lng: -8.240617895852706,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2779",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at the cake happily. A dog builds a tower lazily. A dog eats the cake quickly.",
  },
  {
    locationId: "item20780",
    locationName: "item20780",
    locationAddress: "item20780",
    ratings: null,
    lat: 58.67751625992801,
    lng: -0.6483883019276897,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2780",
    tags: [],
    locationDescription:
      " The student jumps over the road lazily. The student jumps over a tower quickly.",
  },
  {
    locationId: "item20781",
    locationName: "item20781",
    locationAddress: "item20781",
    ratings: null,
    lat: 55.26220880320615,
    lng: -3.072645208128086,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2781",
    tags: [],
    locationDescription:
      " A dog writes the horizon quickly. A dog writes the horizon gracefully.",
  },
  {
    locationId: "item20782",
    locationName: "item20782",
    locationAddress: "item20782",
    ratings: [
      { who: "Similar identities", rating: 3.13 },
      { who: "All perspectives", rating: 0.75 },
    ],
    lat: 50.109401858013086,
    lng: -7.513304133691637,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2782",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman writes the horizon happily. The man looks at a fence lazily. The cat runs towards a book angrily.",
  },
  {
    locationId: "item20783",
    locationName: "item20783",
    locationAddress: "item20783",
    ratings: null,
    lat: 58.70617997492845,
    lng: -3.703401137069804,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2783",
    tags: [],
    locationDescription:
      " The cat eats the horizon happily. The teacher jumps over a fence silently. The cat runs towards a fence happily. The cat runs towards the cake angrily.",
  },
  {
    locationId: "item20784",
    locationName: "item20784",
    locationAddress: "item20784",
    ratings: null,
    lat: 59.649212708486246,
    lng: -2.635690534537466,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2784",
    tags: [],
    locationDescription:
      " A dog looks at a tower lazily. The student jumps over a fence silently.",
  },
  {
    locationId: "item20785",
    locationName: "item20785",
    locationAddress: "item20785",
    ratings: [
      { who: "Similar identities", rating: 2.98 },
      { who: "All perspectives", rating: 3.75 },
    ],
    lat: 58.428895610837685,
    lng: -7.620482190752852,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2785",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards a book lazily. A woman eats the road gracefully.",
  },
  {
    locationId: "item20786",
    locationName: "item20786",
    locationAddress: "item20786",
    ratings: null,
    lat: 52.22998642181078,
    lng: 0.9570120105120186,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2786",
    tags: [],
    locationDescription:
      " The man jumps over the road happily. A dog runs towards a fence angrily. The cat looks at a book angrily.",
  },
  {
    locationId: "item20787",
    locationName: "item20787",
    locationAddress: "item20787",
    ratings: null,
    lat: 52.94521806160393,
    lng: -6.067209606486664,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2787",
    tags: [],
    locationDescription: " The cat looks at a fence silently.",
  },
  {
    locationId: "item20788",
    locationName: "item20788",
    locationAddress: "item20788",
    ratings: null,
    lat: 51.13900122194902,
    lng: -0.06412368006337132,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2788",
    tags: [],
    locationDescription: " The man builds a tower silently.",
  },
  {
    locationId: "item20789",
    locationName: "item20789",
    locationAddress: "item20789",
    ratings: [
      { who: "Similar identities", rating: 4.06 },
      { who: "All perspectives", rating: 3.16 },
    ],
    lat: 59.15717318571852,
    lng: -1.9439974656808872,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2789",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man runs towards the road gracefully. The teacher runs towards a tower quickly.",
  },
  {
    locationId: "item20790",
    locationName: "item20790",
    locationAddress: "item20790",
    ratings: [
      { who: "Similar identities", rating: 1.72 },
      { who: "All perspectives", rating: 4.23 },
    ],
    lat: 60.11677612780071,
    lng: -2.030089757518878,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2790",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man looks at the horizon happily.",
  },
  {
    locationId: "item20791",
    locationName: "item20791",
    locationAddress: "item20791",
    ratings: null,
    lat: 54.18320430550973,
    lng: -0.07774711027666825,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2791",
    tags: [],
    locationDescription: " A dog builds the horizon happily.",
  },
  {
    locationId: "item20792",
    locationName: "item20792",
    locationAddress: "item20792",
    ratings: null,
    lat: 52.84111034024901,
    lng: -7.921769722959192,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2792",
    tags: [],
    locationDescription:
      " The man runs towards the road gracefully. The man writes a fence silently.",
  },
  {
    locationId: "item20793",
    locationName: "item20793",
    locationAddress: "item20793",
    ratings: null,
    lat: 57.560179800844544,
    lng: -0.6554664394096426,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2793",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon happily. The student builds the cake angrily.",
  },
  {
    locationId: "item20794",
    locationName: "item20794",
    locationAddress: "item20794",
    ratings: [
      { who: "Similar identities", rating: 4.62 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 52.505079833466716,
    lng: -0.03635596394566498,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2794",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat runs towards a fence quickly.",
  },
  {
    locationId: "item20795",
    locationName: "item20795",
    locationAddress: "item20795",
    ratings: null,
    lat: 52.79148160544178,
    lng: -1.272392946850598,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2795",
    tags: [],
    locationDescription:
      " A dog jumps over a fence quickly. The student eats a tower silently. The man builds a book gracefully.",
  },
  {
    locationId: "item20796",
    locationName: "item20796",
    locationAddress: "item20796",
    ratings: [
      { who: "Similar identities", rating: 1.74 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 51.29869544132249,
    lng: -3.123380915042504,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2796",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at a fence gracefully. The cat runs towards a book quickly.",
  },
  {
    locationId: "item20797",
    locationName: "item20797",
    locationAddress: "item20797",
    ratings: null,
    lat: 55.67528494638524,
    lng: -0.968221015608826,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2797",
    tags: [],
    locationDescription:
      " The teacher eats a tower gracefully. The teacher runs towards the road silently. The cat looks at a fence quickly. A woman eats a fence quickly.",
  },
  {
    locationId: "item20798",
    locationName: "item20798",
    locationAddress: "item20798",
    ratings: [
      { who: "Similar identities", rating: 1.25 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 56.823434729137865,
    lng: -4.630742737139807,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2798",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat jumps over the horizon gracefully. The cat jumps over a fence angrily. The student runs towards a book quickly. The student runs towards a tower silently.",
  },
  {
    locationId: "item20799",
    locationName: "item20799",
    locationAddress: "item20799",
    ratings: null,
    lat: 50.81651486899518,
    lng: -4.794375897579609,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2799",
    tags: [],
    locationDescription:
      " The man writes the road happily. The cat looks at the road gracefully. The man looks at the horizon lazily. The student eats the horizon quickly.",
  },
  {
    locationId: "item20800",
    locationName: "item20800",
    locationAddress: "item20800",
    ratings: [
      { who: "Similar identities", rating: 2.88 },
      { who: "All perspectives", rating: 3.17 },
    ],
    lat: 53.61751488879541,
    lng: -1.6811420601464606,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2800",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds the cake gracefully. The cat runs towards the cake lazily. The student writes a book gracefully.",
  },
  {
    locationId: "item20801",
    locationName: "item20801",
    locationAddress: "item20801",
    ratings: [
      { who: "Similar identities", rating: 3.58 },
      { who: "All perspectives", rating: 3.91 },
    ],
    lat: 51.585948018568445,
    lng: -6.9873992862450365,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2801",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat builds a book lazily. A dog builds the cake angrily. The teacher builds the cake silently. A dog jumps over the road angrily.",
  },
  {
    locationId: "item20802",
    locationName: "item20802",
    locationAddress: "item20802",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 1.54 },
    ],
    lat: 54.98920825637399,
    lng: -6.874012172756972,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2802",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The cat builds the road quickly.",
  },
  {
    locationId: "item20803",
    locationName: "item20803",
    locationAddress: "item20803",
    ratings: [
      { who: "Similar identities", rating: 0.99 },
      { who: "All perspectives", rating: 0.85 },
    ],
    lat: 59.61747821090707,
    lng: 0.3874940463796932,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2803",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog jumps over a book silently. The teacher writes a tower gracefully.",
  },
  {
    locationId: "item20804",
    locationName: "item20804",
    locationAddress: "item20804",
    ratings: [
      { who: "Similar identities", rating: 1.15 },
      { who: "All perspectives", rating: 4.26 },
    ],
    lat: 55.120127191215154,
    lng: -4.285622462410818,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2804",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a book lazily. The student writes a tower lazily. The man eats a fence angrily. The student eats the horizon lazily. The man builds the cake happily.",
  },
  {
    locationId: "item20805",
    locationName: "item20805",
    locationAddress: "item20805",
    ratings: [
      { who: "Similar identities", rating: 1.08 },
      { who: "All perspectives", rating: 0.76 },
    ],
    lat: 53.05268672310941,
    lng: -1.9223898312446117,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2805",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The cat runs towards a fence gracefully.",
  },
  {
    locationId: "item20806",
    locationName: "item20806",
    locationAddress: "item20806",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 3.94 },
    ],
    lat: 58.26284452654031,
    lng: -4.656777781698267,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2806",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman runs towards a fence happily.",
  },
  {
    locationId: "item20807",
    locationName: "item20807",
    locationAddress: "item20807",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 3.93 },
    ],
    lat: 50.414497077731546,
    lng: -5.018730321504255,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2807",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man jumps over a fence silently.",
  },
  {
    locationId: "item20808",
    locationName: "item20808",
    locationAddress: "item20808",
    ratings: null,
    lat: 58.71335956218947,
    lng: -5.547803347478512,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2808",
    tags: [],
    locationDescription:
      " The cat runs towards a tower happily. The cat writes a fence lazily. The cat eats the cake quickly.",
  },
  {
    locationId: "item20809",
    locationName: "item20809",
    locationAddress: "item20809",
    ratings: null,
    lat: 53.55495685582532,
    lng: -2.4482125561527583,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2809",
    tags: [],
    locationDescription:
      " The teacher eats a fence quickly. The teacher writes a tower quickly.",
  },
  {
    locationId: "item20810",
    locationName: "item20810",
    locationAddress: "item20810",
    ratings: null,
    lat: 56.68490252252599,
    lng: -4.129867051984679,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2810",
    tags: [],
    locationDescription:
      " The teacher writes the road lazily. The teacher jumps over a tower quickly. A dog builds the horizon quickly.",
  },
  {
    locationId: "item20811",
    locationName: "item20811",
    locationAddress: "item20811",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 55.995240679243736,
    lng: -1.8134668036974668,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2811",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat eats the road lazily. The man builds a book lazily.",
  },
  {
    locationId: "item20812",
    locationName: "item20812",
    locationAddress: "item20812",
    ratings: [
      { who: "Similar identities", rating: 1.01 },
      { who: "All perspectives", rating: 2.97 },
    ],
    lat: 54.28111219170888,
    lng: -7.158316052430351,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2812",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The student looks at a fence lazily.",
  },
  {
    locationId: "item20813",
    locationName: "item20813",
    locationAddress: "item20813",
    ratings: null,
    lat: 53.29554016559842,
    lng: -6.807243626131643,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2813",
    tags: [],
    locationDescription:
      " The student looks at the cake gracefully. The man builds the road lazily. A dog writes the horizon angrily. The teacher runs towards a book angrily. The teacher runs towards a book quickly.",
  },
  {
    locationId: "item20814",
    locationName: "item20814",
    locationAddress: "item20814",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 55.13541087025848,
    lng: -7.0903903025075765,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2814",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The cat builds the road lazily. A woman jumps over a book silently. The teacher jumps over a book lazily. The teacher looks at the road angrily. A dog builds the road happily.",
  },
  {
    locationId: "item20815",
    locationName: "item20815",
    locationAddress: "item20815",
    ratings: [
      { who: "Similar identities", rating: 3.41 },
      { who: "All perspectives", rating: 2.41 },
    ],
    lat: 60.54050140332538,
    lng: -3.431111405334934,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2815",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at a book happily. A dog writes a tower silently. The man writes the road silently. A woman writes the horizon angrily. A dog runs towards the road silently.",
  },
  {
    locationId: "item20816",
    locationName: "item20816",
    locationAddress: "item20816",
    ratings: null,
    lat: 53.338382756482495,
    lng: -6.588124984042436,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2816",
    tags: [],
    locationDescription:
      " A woman eats the cake quickly. The cat jumps over the horizon gracefully. The man writes the road quickly. A woman looks at a book lazily.",
  },
  {
    locationId: "item20817",
    locationName: "item20817",
    locationAddress: "item20817",
    ratings: null,
    lat: 51.79961069611211,
    lng: -3.1458079853443772,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2817",
    tags: [],
    locationDescription:
      " A dog writes a book silently. The man eats a fence happily.",
  },
  {
    locationId: "item20818",
    locationName: "item20818",
    locationAddress: "item20818",
    ratings: null,
    lat: 53.15357760819281,
    lng: 0.2866820986229026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2818",
    tags: [],
    locationDescription:
      " The teacher writes a fence happily. A dog looks at a fence lazily. The cat builds a book silently. The man builds the road lazily.",
  },
  {
    locationId: "item20819",
    locationName: "item20819",
    locationAddress: "item20819",
    ratings: null,
    lat: 60.56046374173967,
    lng: -1.7081543452963226,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2819",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon silently. The student builds the road silently. The man builds a book angrily.",
  },
  {
    locationId: "item20820",
    locationName: "item20820",
    locationAddress: "item20820",
    ratings: [
      { who: "Similar identities", rating: 0.55 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 51.960631210575926,
    lng: -1.413128120613563,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2820",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman eats a book gracefully. A dog jumps over the road silently. The man runs towards the road silently. The cat eats a book gracefully. A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item20821",
    locationName: "item20821",
    locationAddress: "item20821",
    ratings: null,
    lat: 53.74810450586118,
    lng: 0.003476190191504358,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2821",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake angrily. A woman writes a fence lazily. The man eats a tower angrily. The man jumps over a fence gracefully. The man jumps over a book lazily.",
  },
  {
    locationId: "item20822",
    locationName: "item20822",
    locationAddress: "item20822",
    ratings: null,
    lat: 53.22363637512645,
    lng: -2.1024955125273266,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2822",
    tags: [],
    locationDescription:
      " The student looks at the horizon angrily. The teacher runs towards the cake angrily. A woman jumps over a fence silently. The cat builds a fence lazily. A dog builds a tower gracefully.",
  },
  {
    locationId: "item20823",
    locationName: "item20823",
    locationAddress: "item20823",
    ratings: null,
    lat: 58.67052936417546,
    lng: -2.0528169528549673,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2823",
    tags: [],
    locationDescription:
      " The cat writes the road gracefully. The cat runs towards a fence quickly. The man eats a book happily. A dog jumps over the road gracefully. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item20824",
    locationName: "item20824",
    locationAddress: "item20824",
    ratings: null,
    lat: 56.307892084079526,
    lng: -3.1296356940322996,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2824",
    tags: [],
    locationDescription:
      " The cat eats a fence angrily. A woman runs towards the cake lazily.",
  },
  {
    locationId: "item20825",
    locationName: "item20825",
    locationAddress: "item20825",
    ratings: null,
    lat: 58.29014989507874,
    lng: -6.861140221858409,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2825",
    tags: [],
    locationDescription:
      " A woman writes a tower lazily. A dog builds a fence happily. A dog runs towards the cake quickly. The teacher looks at the horizon lazily. The man writes the horizon happily.",
  },
  {
    locationId: "item20826",
    locationName: "item20826",
    locationAddress: "item20826",
    ratings: null,
    lat: 56.24954813448456,
    lng: -3.0530476424072104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2826",
    tags: [],
    locationDescription:
      " A dog runs towards a book gracefully. The teacher runs towards the horizon quickly.",
  },
  {
    locationId: "item20827",
    locationName: "item20827",
    locationAddress: "item20827",
    ratings: [
      { who: "Similar identities", rating: 2.99 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 54.833988320185256,
    lng: -7.200139580082198,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2827",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The teacher writes a tower silently.",
  },
  {
    locationId: "item20828",
    locationName: "item20828",
    locationAddress: "item20828",
    ratings: null,
    lat: 55.004949672013495,
    lng: -4.880515947657202,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2828",
    tags: [],
    locationDescription:
      " The man writes the road quickly. A woman eats the cake happily. The teacher eats the horizon gracefully. The man writes a tower silently.",
  },
  {
    locationId: "item20829",
    locationName: "item20829",
    locationAddress: "item20829",
    ratings: [
      { who: "Similar identities", rating: 0.58 },
      { who: "All perspectives", rating: 1.36 },
    ],
    lat: 59.15586810967976,
    lng: -7.834745743660045,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2829",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " A dog writes a tower gracefully.",
  },
  {
    locationId: "item20830",
    locationName: "item20830",
    locationAddress: "item20830",
    ratings: [
      { who: "Similar identities", rating: 3.42 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 57.32727391551145,
    lng: -4.996584338480513,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2830",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The student builds a tower silently.",
  },
  {
    locationId: "item20831",
    locationName: "item20831",
    locationAddress: "item20831",
    ratings: null,
    lat: 51.980464631867335,
    lng: -4.043568849977317,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2831",
    tags: [],
    locationDescription:
      " A dog eats the cake happily. A woman runs towards the horizon angrily. The student jumps over a book quickly. A woman builds the road gracefully. A woman runs towards a book gracefully.",
  },
  {
    locationId: "item20832",
    locationName: "item20832",
    locationAddress: "item20832",
    ratings: [
      { who: "Similar identities", rating: 0.98 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 53.4092512019905,
    lng: 0.7943690124899039,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2832",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes the road quickly. The student jumps over a book gracefully. A woman builds the horizon lazily.",
  },
  {
    locationId: "item20833",
    locationName: "item20833",
    locationAddress: "item20833",
    ratings: null,
    lat: 53.35520020822837,
    lng: -5.906737139648911,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2833",
    tags: [],
    locationDescription:
      " A woman builds the horizon lazily. The teacher jumps over the road happily. The student builds a fence lazily. A dog eats the horizon silently. The teacher runs towards the cake gracefully.",
  },
  {
    locationId: "item20834",
    locationName: "item20834",
    locationAddress: "item20834",
    ratings: [
      { who: "Similar identities", rating: 1.25 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 52.38028018068361,
    lng: -3.8166215247794835,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2834",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man writes the horizon angrily. The man eats the horizon silently. The man runs towards a tower happily. A dog eats a fence angrily.",
  },
  {
    locationId: "item20835",
    locationName: "item20835",
    locationAddress: "item20835",
    ratings: null,
    lat: 57.881418677276024,
    lng: -6.024106766809318,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2835",
    tags: [],
    locationDescription:
      " A woman writes a fence silently. The man builds a fence angrily.",
  },
  {
    locationId: "item20836",
    locationName: "item20836",
    locationAddress: "item20836",
    ratings: [
      { who: "Similar identities", rating: 2.99 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 56.434364633469926,
    lng: -3.3353565857842806,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2836",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat jumps over the horizon gracefully. The cat jumps over a fence quickly. The cat jumps over a tower silently. A woman writes a fence lazily. A woman runs towards a fence happily.",
  },
  {
    locationId: "item20837",
    locationName: "item20837",
    locationAddress: "item20837",
    ratings: null,
    lat: 50.462048027918065,
    lng: -4.48922872609625,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2837",
    tags: [],
    locationDescription:
      " A woman eats the cake gracefully. A woman builds the cake lazily. The cat runs towards a tower gracefully. A dog builds a fence lazily. The teacher runs towards a tower angrily.",
  },
  {
    locationId: "item20838",
    locationName: "item20838",
    locationAddress: "item20838",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 1.7 },
    ],
    lat: 54.677022916288344,
    lng: -6.075602601907474,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2838",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher looks at a tower lazily. A dog eats a tower silently.",
  },
  {
    locationId: "item20839",
    locationName: "item20839",
    locationAddress: "item20839",
    ratings: null,
    lat: 54.158318160542464,
    lng: -2.5154776552584206,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2839",
    tags: [],
    locationDescription:
      " The teacher jumps over a tower lazily. The teacher builds the cake quickly. The man builds a book gracefully.",
  },
  {
    locationId: "item20840",
    locationName: "item20840",
    locationAddress: "item20840",
    ratings: null,
    lat: 51.98492601377762,
    lng: -6.134744950650242,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2840",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence quickly. A dog builds the road gracefully.",
  },
  {
    locationId: "item20841",
    locationName: "item20841",
    locationAddress: "item20841",
    ratings: [
      { who: "Similar identities", rating: 0.03 },
      { who: "All perspectives", rating: 2.92 },
    ],
    lat: 57.23031452172945,
    lng: 0.2860676605580803,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2841",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The man builds a fence gracefully. The cat writes the cake happily. The teacher looks at the horizon angrily.",
  },
  {
    locationId: "item20842",
    locationName: "item20842",
    locationAddress: "item20842",
    ratings: null,
    lat: 50.81757159137627,
    lng: -1.2336972844027443,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2842",
    tags: [],
    locationDescription:
      " The man eats the horizon silently. A dog writes the road lazily. The man builds the horizon angrily. A woman jumps over a fence lazily. The student eats a book quickly.",
  },
  {
    locationId: "item20843",
    locationName: "item20843",
    locationAddress: "item20843",
    ratings: [
      { who: "Similar identities", rating: 0.41 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 50.675836776777395,
    lng: -6.2723733243971465,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2843",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student writes the horizon lazily. The cat writes a fence gracefully. A dog writes the cake silently. The student writes the cake gracefully. The man builds the cake gracefully.",
  },
  {
    locationId: "item20844",
    locationName: "item20844",
    locationAddress: "item20844",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 50.58389057633211,
    lng: -3.1697691955014875,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2844",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman looks at a tower angrily. A dog jumps over the road lazily. A woman looks at the horizon silently.",
  },
  {
    locationId: "item20845",
    locationName: "item20845",
    locationAddress: "item20845",
    ratings: [
      { who: "Similar identities", rating: 0.16 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 50.666754364180015,
    lng: -3.9881060932989723,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2845",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat runs towards the cake angrily. The cat runs towards a book gracefully. The cat eats the cake happily.",
  },
  {
    locationId: "item20846",
    locationName: "item20846",
    locationAddress: "item20846",
    ratings: null,
    lat: 57.549436694874004,
    lng: -5.515771539550306,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2846",
    tags: [],
    locationDescription:
      " The man runs towards the road gracefully. The student eats the cake silently. The teacher builds a tower lazily.",
  },
  {
    locationId: "item20847",
    locationName: "item20847",
    locationAddress: "item20847",
    ratings: null,
    lat: 51.850044619433156,
    lng: -7.002814252697998,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2847",
    tags: [],
    locationDescription:
      " The man writes the horizon gracefully. The teacher jumps over a fence gracefully. The student builds the horizon angrily. A woman builds a book happily. A dog builds the horizon quickly.",
  },
  {
    locationId: "item20848",
    locationName: "item20848",
    locationAddress: "item20848",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 51.19681775290392,
    lng: 1.0354156951332385,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2848",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A dog builds the road happily. The man builds the road quickly. The teacher jumps over the road lazily. A dog looks at a book silently.",
  },
  {
    locationId: "item20849",
    locationName: "item20849",
    locationAddress: "item20849",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 2.15 },
    ],
    lat: 57.14406510968857,
    lng: -7.234719437605431,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2849",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat eats a tower quickly. The student writes the horizon lazily. The student looks at a fence lazily. The man jumps over the road quickly.",
  },
  {
    locationId: "item20850",
    locationName: "item20850",
    locationAddress: "item20850",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 0.84 },
    ],
    lat: 55.644379182056625,
    lng: -2.4922078622794626,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2850",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes the horizon happily. A woman runs towards the cake happily.",
  },
  {
    locationId: "item20851",
    locationName: "item20851",
    locationAddress: "item20851",
    ratings: [
      { who: "Similar identities", rating: 3.91 },
      { who: "All perspectives", rating: 3.23 },
    ],
    lat: 55.50040450980039,
    lng: -1.6753673953451287,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2851",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes the cake angrily. The man runs towards the horizon happily. The cat builds a book silently. A woman runs towards the cake lazily. A dog jumps over a book lazily.",
  },
  {
    locationId: "item20852",
    locationName: "item20852",
    locationAddress: "item20852",
    ratings: [
      { who: "Similar identities", rating: 3.58 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 53.887144652815614,
    lng: -6.73665526807043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2852",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman looks at the horizon happily. A woman builds the horizon lazily. The student runs towards a book quickly.",
  },
  {
    locationId: "item20853",
    locationName: "item20853",
    locationAddress: "item20853",
    ratings: [
      { who: "Similar identities", rating: 1.05 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 57.84644330263035,
    lng: -4.735962773648447,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2853",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher builds the horizon silently. A woman eats the road angrily. A dog eats the road lazily. A dog builds a fence angrily.",
  },
  {
    locationId: "item20854",
    locationName: "item20854",
    locationAddress: "item20854",
    ratings: [
      { who: "Similar identities", rating: 0.8 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 55.11035155642241,
    lng: -5.135461153887542,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2854",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The cat runs towards a fence silently. The man runs towards the horizon silently. The student builds the road gracefully. A woman looks at the road quickly.",
  },
  {
    locationId: "item20855",
    locationName: "item20855",
    locationAddress: "item20855",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 1.1 },
    ],
    lat: 52.952105919015075,
    lng: -3.8373721426617733,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2855",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher builds a book lazily. The teacher runs towards the horizon lazily. The man looks at a tower angrily. The teacher builds the cake silently. The man jumps over a book happily.",
  },
  {
    locationId: "item20856",
    locationName: "item20856",
    locationAddress: "item20856",
    ratings: null,
    lat: 53.11871264825294,
    lng: -4.671634506854745,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2856",
    tags: [],
    locationDescription: " A dog writes the horizon happily.",
  },
  {
    locationId: "item20857",
    locationName: "item20857",
    locationAddress: "item20857",
    ratings: null,
    lat: 54.7516126974509,
    lng: -4.562144183404101,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2857",
    tags: [],
    locationDescription:
      " The cat eats a book lazily. The man builds the cake angrily. The student writes a tower gracefully. The student looks at a fence silently.",
  },
  {
    locationId: "item20858",
    locationName: "item20858",
    locationAddress: "item20858",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 3.09 },
    ],
    lat: 51.64685650827543,
    lng: -0.054895707766934976,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2858",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes a fence angrily. A woman looks at a tower silently. The student eats a book angrily. The student jumps over a book quickly. A dog jumps over a tower angrily.",
  },
  {
    locationId: "item20859",
    locationName: "item20859",
    locationAddress: "item20859",
    ratings: null,
    lat: 52.78962117817735,
    lng: -1.748667702585342,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2859",
    tags: [],
    locationDescription: " A dog looks at a book gracefully.",
  },
  {
    locationId: "item20860",
    locationName: "item20860",
    locationAddress: "item20860",
    ratings: null,
    lat: 59.77152376237921,
    lng: -7.935064551677495,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2860",
    tags: [],
    locationDescription:
      " The cat writes a tower happily. The cat eats the cake quickly.",
  },
  {
    locationId: "item20861",
    locationName: "item20861",
    locationAddress: "item20861",
    ratings: null,
    lat: 55.39231650931697,
    lng: -8.53718239737039,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2861",
    tags: [],
    locationDescription:
      " A woman looks at a fence gracefully. The student eats the road gracefully.",
  },
  {
    locationId: "item20862",
    locationName: "item20862",
    locationAddress: "item20862",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 59.88769113326418,
    lng: -5.642197526270094,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2862",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog writes the cake silently. The man looks at a tower angrily.",
  },
  {
    locationId: "item20863",
    locationName: "item20863",
    locationAddress: "item20863",
    ratings: null,
    lat: 55.76731258348496,
    lng: -6.618007426381158,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2863",
    tags: [],
    locationDescription:
      " The man jumps over the horizon happily. The cat looks at the road lazily. The cat looks at a fence happily. The man builds a fence happily.",
  },
  {
    locationId: "item20864",
    locationName: "item20864",
    locationAddress: "item20864",
    ratings: null,
    lat: 55.02411367980731,
    lng: -0.5682925166787403,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2864",
    tags: [],
    locationDescription:
      " A dog runs towards the road angrily. The student jumps over a tower silently. A woman looks at a tower happily. The man writes the cake silently. The man builds the cake happily.",
  },
  {
    locationId: "item20865",
    locationName: "item20865",
    locationAddress: "item20865",
    ratings: null,
    lat: 59.13924800903656,
    lng: -7.932881115264516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2865",
    tags: [],
    locationDescription:
      " The student runs towards a book gracefully. A dog looks at the road angrily. A woman looks at the cake quickly. A woman looks at a tower silently. The teacher eats a fence silently.",
  },
  {
    locationId: "item20866",
    locationName: "item20866",
    locationAddress: "item20866",
    ratings: null,
    lat: 54.194577389680745,
    lng: -7.650549934335062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2866",
    tags: [],
    locationDescription:
      " A dog runs towards a tower quickly. The man looks at the cake silently. A woman eats the horizon happily. The man looks at the road happily.",
  },
  {
    locationId: "item20867",
    locationName: "item20867",
    locationAddress: "item20867",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 53.80087758591456,
    lng: -0.05249969110209918,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2867",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat looks at a book angrily. A dog builds the horizon happily. The cat eats a fence happily. A woman runs towards a tower quickly. The man eats the cake quickly.",
  },
  {
    locationId: "item20868",
    locationName: "item20868",
    locationAddress: "item20868",
    ratings: null,
    lat: 54.62975189910455,
    lng: 0.12959330282256687,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2868",
    tags: [],
    locationDescription:
      " The teacher looks at a tower happily. The student eats a tower angrily. The teacher looks at a book happily. The teacher looks at a tower gracefully. The cat runs towards the cake gracefully.",
  },
  {
    locationId: "item20869",
    locationName: "item20869",
    locationAddress: "item20869",
    ratings: null,
    lat: 54.11814886803638,
    lng: -3.688549445590734,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2869",
    tags: [],
    locationDescription:
      " The student jumps over the road lazily. A dog jumps over the road lazily. A dog looks at the horizon gracefully. The teacher jumps over the cake gracefully.",
  },
  {
    locationId: "item20870",
    locationName: "item20870",
    locationAddress: "item20870",
    ratings: null,
    lat: 60.66431147936041,
    lng: -0.903346762630445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2870",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon happily. The student builds a fence happily.",
  },
  {
    locationId: "item20871",
    locationName: "item20871",
    locationAddress: "item20871",
    ratings: null,
    lat: 50.00498089075526,
    lng: 0.1665294768592549,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2871",
    tags: [],
    locationDescription:
      " The man looks at the cake quickly. A dog writes the road happily. A dog jumps over a book gracefully. The student runs towards a tower gracefully. The man eats a book angrily.",
  },
  {
    locationId: "item20872",
    locationName: "item20872",
    locationAddress: "item20872",
    ratings: null,
    lat: 59.61856411792846,
    lng: -4.89497126589381,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2872",
    tags: [],
    locationDescription:
      " The cat writes a tower happily. The man runs towards a book happily. The student looks at a fence angrily. A woman runs towards the road angrily. The student jumps over the road silently.",
  },
  {
    locationId: "item20873",
    locationName: "item20873",
    locationAddress: "item20873",
    ratings: [
      { who: "Similar identities", rating: 1.52 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 51.103193297115,
    lng: -2.8915184555783817,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2873",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student builds a book gracefully. The man jumps over a tower lazily. A woman writes a tower angrily.",
  },
  {
    locationId: "item20874",
    locationName: "item20874",
    locationAddress: "item20874",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 59.00879882775219,
    lng: -5.53402077825884,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2874",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats the cake quickly. The man writes the cake quickly. The cat builds a book gracefully. The teacher runs towards the horizon gracefully.",
  },
  {
    locationId: "item20875",
    locationName: "item20875",
    locationAddress: "item20875",
    ratings: [
      { who: "Similar identities", rating: 4.09 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 54.689036657752204,
    lng: -3.413722630133962,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2875",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The man jumps over a fence angrily. The teacher eats a book happily. The teacher writes a fence quickly. The man looks at the road gracefully. A dog runs towards a fence quickly.",
  },
  {
    locationId: "item20876",
    locationName: "item20876",
    locationAddress: "item20876",
    ratings: null,
    lat: 59.977360406531055,
    lng: -5.935396575476257,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2876",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon quickly. The man writes a book quickly. The cat writes the horizon angrily.",
  },
  {
    locationId: "item20877",
    locationName: "item20877",
    locationAddress: "item20877",
    ratings: [
      { who: "Similar identities", rating: 1.42 },
      { who: "All perspectives", rating: 2.78 },
    ],
    lat: 59.67642315759185,
    lng: -2.390787911168702,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2877",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher runs towards the horizon quickly.",
  },
  {
    locationId: "item20878",
    locationName: "item20878",
    locationAddress: "item20878",
    ratings: null,
    lat: 60.56810501188249,
    lng: 0.32999307195003347,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2878",
    tags: [],
    locationDescription:
      " The cat writes the horizon quickly. A woman builds the horizon lazily.",
  },
  {
    locationId: "item20879",
    locationName: "item20879",
    locationAddress: "item20879",
    ratings: null,
    lat: 55.13581916678317,
    lng: -8.263086007455662,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2879",
    tags: [],
    locationDescription: " The man writes a fence lazily.",
  },
  {
    locationId: "item20880",
    locationName: "item20880",
    locationAddress: "item20880",
    ratings: [
      { who: "Similar identities", rating: 2.9 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 58.347609691055325,
    lng: -7.702669859299274,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2880",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman builds a book quickly. The cat writes a fence quickly.",
  },
  {
    locationId: "item20881",
    locationName: "item20881",
    locationAddress: "item20881",
    ratings: null,
    lat: 53.019823498732585,
    lng: -3.2187042543339928,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2881",
    tags: [],
    locationDescription:
      " The teacher eats the cake silently. The cat runs towards the road angrily.",
  },
  {
    locationId: "item20882",
    locationName: "item20882",
    locationAddress: "item20882",
    ratings: null,
    lat: 59.961635546224024,
    lng: -6.428131018124274,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2882",
    tags: [],
    locationDescription: " The man builds a book lazily.",
  },
  {
    locationId: "item20883",
    locationName: "item20883",
    locationAddress: "item20883",
    ratings: [
      { who: "Similar identities", rating: 2.44 },
      { who: "All perspectives", rating: 4.97 },
    ],
    lat: 57.76767244513568,
    lng: -8.401610475655398,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2883",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat jumps over a tower silently. A dog writes a tower gracefully. The student runs towards a fence angrily. The student jumps over a book happily. The man eats a fence quickly.",
  },
  {
    locationId: "item20884",
    locationName: "item20884",
    locationAddress: "item20884",
    ratings: null,
    lat: 56.42841929971332,
    lng: -4.385228419042445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2884",
    tags: [],
    locationDescription:
      " A woman looks at the horizon lazily. The cat looks at the cake silently. The teacher builds a fence quickly. A dog jumps over a book happily. The teacher builds the horizon quickly.",
  },
  {
    locationId: "item20885",
    locationName: "item20885",
    locationAddress: "item20885",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 4.71 },
    ],
    lat: 56.23817934476825,
    lng: -3.083973519197891,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2885",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the cake angrily. The cat jumps over the cake gracefully.",
  },
  {
    locationId: "item20886",
    locationName: "item20886",
    locationAddress: "item20886",
    ratings: [
      { who: "Similar identities", rating: 2.67 },
      { who: "All perspectives", rating: 3.83 },
    ],
    lat: 58.52435514997374,
    lng: -7.853528868839883,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2886",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a book happily. The cat builds the road quickly. A woman runs towards the cake gracefully. The student writes the road quickly.",
  },
  {
    locationId: "item20887",
    locationName: "item20887",
    locationAddress: "item20887",
    ratings: [
      { who: "Similar identities", rating: 3.27 },
      { who: "All perspectives", rating: 1.81 },
    ],
    lat: 56.057796813992624,
    lng: 0.48217657048082607,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2887",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student writes the horizon quickly. A woman runs towards the road silently. A dog writes a tower happily. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20888",
    locationName: "item20888",
    locationAddress: "item20888",
    ratings: null,
    lat: 53.973950172343145,
    lng: -3.431116739238206,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2888",
    tags: [],
    locationDescription:
      " A woman jumps over the cake angrily. A woman runs towards the road quickly. The student writes a tower angrily.",
  },
  {
    locationId: "item20889",
    locationName: "item20889",
    locationAddress: "item20889",
    ratings: [
      { who: "Similar identities", rating: 4.6 },
      { who: "All perspectives", rating: 1.63 },
    ],
    lat: 50.21101568800416,
    lng: -5.036411869970415,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2889",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The student runs towards the road silently.",
  },
  {
    locationId: "item20890",
    locationName: "item20890",
    locationAddress: "item20890",
    ratings: [
      { who: "Similar identities", rating: 1.44 },
      { who: "All perspectives", rating: 3.42 },
    ],
    lat: 59.886432471610576,
    lng: -6.562995651525259,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2890",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a book quickly. The man eats the horizon angrily. The teacher builds the road silently. The teacher runs towards a tower angrily. The cat jumps over a tower lazily.",
  },
  {
    locationId: "item20891",
    locationName: "item20891",
    locationAddress: "item20891",
    ratings: null,
    lat: 60.605612236831895,
    lng: -7.603708883612622,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2891",
    tags: [],
    locationDescription:
      " The cat runs towards a tower happily. The man jumps over a fence happily.",
  },
  {
    locationId: "item20892",
    locationName: "item20892",
    locationAddress: "item20892",
    ratings: null,
    lat: 49.93559720667353,
    lng: -7.6079158353273595,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2892",
    tags: [],
    locationDescription: " A woman writes the road lazily.",
  },
  {
    locationId: "item20893",
    locationName: "item20893",
    locationAddress: "item20893",
    ratings: null,
    lat: 59.47620124890665,
    lng: -6.416068086513196,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2893",
    tags: [],
    locationDescription: " The teacher builds a tower lazily.",
  },
  {
    locationId: "item20894",
    locationName: "item20894",
    locationAddress: "item20894",
    ratings: null,
    lat: 51.14488536104686,
    lng: -5.016402790134778,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2894",
    tags: [],
    locationDescription:
      " The man jumps over a fence happily. The teacher runs towards the horizon lazily.",
  },
  {
    locationId: "item20895",
    locationName: "item20895",
    locationAddress: "item20895",
    ratings: null,
    lat: 50.10310312134301,
    lng: -6.95926829921124,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2895",
    tags: [],
    locationDescription:
      " The man writes a fence quickly. The cat looks at a fence lazily. A woman eats a fence gracefully. A woman looks at a tower quickly. The man eats the cake happily.",
  },
  {
    locationId: "item20896",
    locationName: "item20896",
    locationAddress: "item20896",
    ratings: [
      { who: "Similar identities", rating: 1.17 },
      { who: "All perspectives", rating: 0.65 },
    ],
    lat: 56.49554993147889,
    lng: -3.3777688947463664,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2896",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man builds the horizon angrily. A dog jumps over a fence lazily. The student runs towards a fence angrily.",
  },
  {
    locationId: "item20897",
    locationName: "item20897",
    locationAddress: "item20897",
    ratings: [
      { who: "Similar identities", rating: 0.8 },
      { who: "All perspectives", rating: 4.28 },
    ],
    lat: 56.58465164391671,
    lng: -1.012377607868311,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2897",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The man writes the cake angrily. The man writes a tower silently. The teacher eats a tower angrily.",
  },
  {
    locationId: "item20898",
    locationName: "item20898",
    locationAddress: "item20898",
    ratings: null,
    lat: 56.46988721701218,
    lng: 1.4945690278119415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2898",
    tags: [],
    locationDescription:
      " The man looks at a book silently. The teacher looks at a book silently. A woman looks at the cake angrily. The student eats the horizon gracefully. The student jumps over the cake happily.",
  },
  {
    locationId: "item20899",
    locationName: "item20899",
    locationAddress: "item20899",
    ratings: [
      { who: "Similar identities", rating: 3.32 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 56.68624568051867,
    lng: 0.9076684269993844,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2899",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes the road happily. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item20900",
    locationName: "item20900",
    locationAddress: "item20900",
    ratings: [
      { who: "Similar identities", rating: 2.54 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 51.54099861336484,
    lng: -2.206313269844773,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2900",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds a tower angrily. The man jumps over a fence angrily. A dog eats a tower quickly. The cat jumps over the horizon silently. The cat looks at a book silently.",
  },
  {
    locationId: "item20901",
    locationName: "item20901",
    locationAddress: "item20901",
    ratings: null,
    lat: 56.77400141441164,
    lng: -8.16350500501005,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2901",
    tags: [],
    locationDescription:
      " The student writes a book silently. The cat writes a tower angrily. The student looks at the cake happily. The student writes the horizon lazily. A dog looks at a fence happily.",
  },
  {
    locationId: "item20902",
    locationName: "item20902",
    locationAddress: "item20902",
    ratings: null,
    lat: 59.15387417879273,
    lng: 0.9880205701447338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2902",
    tags: [],
    locationDescription: " The man looks at a tower silently.",
  },
  {
    locationId: "item20903",
    locationName: "item20903",
    locationAddress: "item20903",
    ratings: [
      { who: "Similar identities", rating: 1.32 },
      { who: "All perspectives", rating: 2.49 },
    ],
    lat: 60.39880341648846,
    lng: -0.1835965463143463,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2903",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The man eats a book happily.",
  },
  {
    locationId: "item20904",
    locationName: "item20904",
    locationAddress: "item20904",
    ratings: null,
    lat: 55.80931935744503,
    lng: -2.9238472985041115,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2904",
    tags: [],
    locationDescription:
      " The teacher looks at the road lazily. The student builds the road happily.",
  },
  {
    locationId: "item20905",
    locationName: "item20905",
    locationAddress: "item20905",
    ratings: null,
    lat: 54.824587464856904,
    lng: -7.34153865241616,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2905",
    tags: [],
    locationDescription:
      " The student writes the road lazily. The man jumps over a fence angrily. The student jumps over the road happily. The cat looks at the horizon silently.",
  },
  {
    locationId: "item20906",
    locationName: "item20906",
    locationAddress: "item20906",
    ratings: null,
    lat: 54.07574971332365,
    lng: 1.258955601756849,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2906",
    tags: [],
    locationDescription:
      " The man looks at the road lazily. A dog writes the cake gracefully. The cat runs towards a tower silently.",
  },
  {
    locationId: "item20907",
    locationName: "item20907",
    locationAddress: "item20907",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 1.54 },
    ],
    lat: 51.98599812691389,
    lng: -0.15335899996682478,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2907",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes the cake silently. The cat looks at the cake quickly. The man eats the horizon lazily. The cat jumps over the road gracefully.",
  },
  {
    locationId: "item20908",
    locationName: "item20908",
    locationAddress: "item20908",
    ratings: null,
    lat: 60.082191305502775,
    lng: -7.035444143105279,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2908",
    tags: [],
    locationDescription:
      " The cat eats a book silently. The student jumps over a tower silently. The student jumps over a book lazily. The student runs towards a book lazily.",
  },
  {
    locationId: "item20909",
    locationName: "item20909",
    locationAddress: "item20909",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 51.54257804111085,
    lng: -1.7164372066081315,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2909",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The cat looks at a fence lazily.",
  },
  {
    locationId: "item20910",
    locationName: "item20910",
    locationAddress: "item20910",
    ratings: [
      { who: "Similar identities", rating: 2.93 },
      { who: "All perspectives", rating: 3.2 },
    ],
    lat: 49.93821463187236,
    lng: 0.20556686883287867,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2910",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog builds a tower lazily. A dog looks at the road angrily.",
  },
  {
    locationId: "item20911",
    locationName: "item20911",
    locationAddress: "item20911",
    ratings: [
      { who: "Similar identities", rating: 0.03 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 50.65421162008419,
    lng: -2.110286516614516,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2911",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog runs towards a fence gracefully. The teacher looks at a fence lazily. The cat jumps over a book happily.",
  },
  {
    locationId: "item20912",
    locationName: "item20912",
    locationAddress: "item20912",
    ratings: null,
    lat: 58.087016536463466,
    lng: -7.42086768448466,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2912",
    tags: [],
    locationDescription:
      " A dog builds the horizon happily. The man looks at the horizon silently. The man jumps over the horizon gracefully. A woman eats a book angrily.",
  },
  {
    locationId: "item20913",
    locationName: "item20913",
    locationAddress: "item20913",
    ratings: [
      { who: "Similar identities", rating: 0.69 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 53.396873451391386,
    lng: -5.698230842495558,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2913",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " A dog writes the horizon gracefully.",
  },
  {
    locationId: "item20914",
    locationName: "item20914",
    locationAddress: "item20914",
    ratings: [
      { who: "Similar identities", rating: 4.17 },
      { who: "All perspectives", rating: 2.05 },
    ],
    lat: 60.52282905124255,
    lng: -0.49552857762240343,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2914",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog writes a fence happily. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20915",
    locationName: "item20915",
    locationAddress: "item20915",
    ratings: [
      { who: "Similar identities", rating: 1.16 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 54.31509419743747,
    lng: -4.161765776258534,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2915",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat writes the cake happily. A dog builds a tower happily. A dog eats a tower quickly. The teacher jumps over a tower happily. The teacher eats the road angrily.",
  },
  {
    locationId: "item20916",
    locationName: "item20916",
    locationAddress: "item20916",
    ratings: null,
    lat: 53.23849555443241,
    lng: -6.736091612876415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2916",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake happily. The cat builds a book silently. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item20917",
    locationName: "item20917",
    locationAddress: "item20917",
    ratings: null,
    lat: 50.497834415545825,
    lng: -5.232038041636903,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2917",
    tags: [],
    locationDescription:
      " The student looks at the cake angrily. The student eats the cake gracefully. The student builds the cake quickly. The cat eats a book gracefully.",
  },
  {
    locationId: "item20918",
    locationName: "item20918",
    locationAddress: "item20918",
    ratings: [
      { who: "Similar identities", rating: 3.07 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 54.101727704470264,
    lng: -1.604036500996962,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2918",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards the cake happily. The teacher runs towards a tower silently. The man runs towards the road silently. A dog builds a book silently. A dog looks at the cake silently.",
  },
  {
    locationId: "item20919",
    locationName: "item20919",
    locationAddress: "item20919",
    ratings: null,
    lat: 59.36199892963108,
    lng: 0.20756217997972293,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2919",
    tags: [],
    locationDescription:
      " The student eats the road gracefully. The man jumps over the cake angrily.",
  },
  {
    locationId: "item20920",
    locationName: "item20920",
    locationAddress: "item20920",
    ratings: [
      { who: "Similar identities", rating: 3.58 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 57.23672569233086,
    lng: -7.732450444561439,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2920",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog writes the cake happily. The teacher runs towards a book happily. The cat eats the cake gracefully.",
  },
  {
    locationId: "item20921",
    locationName: "item20921",
    locationAddress: "item20921",
    ratings: null,
    lat: 49.90447023028569,
    lng: -7.635810160835545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2921",
    tags: [],
    locationDescription:
      " The cat runs towards the road quickly. A dog looks at the horizon silently. A woman builds the cake happily.",
  },
  {
    locationId: "item20922",
    locationName: "item20922",
    locationAddress: "item20922",
    ratings: null,
    lat: 53.327717630808706,
    lng: -0.0785789404735251,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2922",
    tags: [],
    locationDescription:
      " A dog eats the road happily. The teacher writes the road gracefully. The teacher runs towards the horizon quickly.",
  },
  {
    locationId: "item20923",
    locationName: "item20923",
    locationAddress: "item20923",
    ratings: null,
    lat: 52.729277401715144,
    lng: 1.7059796618850154,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2923",
    tags: [],
    locationDescription:
      " The teacher runs towards the road happily. The man writes a fence silently. The man writes a tower angrily. A dog runs towards a book lazily.",
  },
  {
    locationId: "item20924",
    locationName: "item20924",
    locationAddress: "item20924",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 59.60966605667008,
    lng: -0.9639786807508681,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2924",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats the cake silently. The student eats the cake gracefully. The man eats a book gracefully. The student runs towards a book angrily.",
  },
  {
    locationId: "item20925",
    locationName: "item20925",
    locationAddress: "item20925",
    ratings: null,
    lat: 51.903060114398684,
    lng: -2.7333762076967556,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2925",
    tags: [],
    locationDescription:
      " A dog jumps over the road angrily. The teacher runs towards a fence angrily.",
  },
  {
    locationId: "item20926",
    locationName: "item20926",
    locationAddress: "item20926",
    ratings: null,
    lat: 59.18290988396877,
    lng: 0.08256191591144457,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2926",
    tags: [],
    locationDescription: " A woman eats the horizon gracefully.",
  },
  {
    locationId: "item20927",
    locationName: "item20927",
    locationAddress: "item20927",
    ratings: [
      { who: "Similar identities", rating: 4.29 },
      { who: "All perspectives", rating: 4.05 },
    ],
    lat: 56.906661260188564,
    lng: -5.495767466547472,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2927",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman eats the cake silently. A woman writes the road quickly.",
  },
  {
    locationId: "item20928",
    locationName: "item20928",
    locationAddress: "item20928",
    ratings: [
      { who: "Similar identities", rating: 4.42 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 58.49957477069264,
    lng: -5.009384596735143,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2928",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds a book gracefully. A woman jumps over a fence lazily. The student looks at a fence quickly. A dog writes the cake gracefully.",
  },
  {
    locationId: "item20929",
    locationName: "item20929",
    locationAddress: "item20929",
    ratings: [
      { who: "Similar identities", rating: 3.69 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 54.723150068957466,
    lng: -4.230401504871104,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2929",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher jumps over a fence quickly. The student writes a tower quickly. A dog eats the road happily. The student writes a tower silently. A woman eats the horizon happily.",
  },
  {
    locationId: "item20930",
    locationName: "item20930",
    locationAddress: "item20930",
    ratings: null,
    lat: 57.78097966852989,
    lng: -1.020788294452081,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2930",
    tags: [],
    locationDescription:
      " The student jumps over a fence angrily. A woman looks at the road happily. A dog writes a fence gracefully.",
  },
  {
    locationId: "item20931",
    locationName: "item20931",
    locationAddress: "item20931",
    ratings: null,
    lat: 54.506298532063205,
    lng: -3.7968485022669434,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2931",
    tags: [],
    locationDescription:
      " A dog eats the road lazily. A dog writes the horizon angrily. The cat writes a book gracefully. The teacher builds the road gracefully.",
  },
  {
    locationId: "item20932",
    locationName: "item20932",
    locationAddress: "item20932",
    ratings: null,
    lat: 58.492250839130676,
    lng: -8.2302322680282,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2932",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake lazily. A woman looks at a book silently. A dog eats a tower happily. A dog writes the cake silently.",
  },
  {
    locationId: "item20933",
    locationName: "item20933",
    locationAddress: "item20933",
    ratings: null,
    lat: 58.32790174030024,
    lng: -2.288909635001475,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2933",
    tags: [],
    locationDescription:
      " A woman looks at the road happily. The teacher writes the cake quickly. The cat writes a fence silently. The teacher runs towards the horizon happily. The man eats a tower gracefully.",
  },
  {
    locationId: "item20934",
    locationName: "item20934",
    locationAddress: "item20934",
    ratings: null,
    lat: 51.85841109492304,
    lng: -2.2821723183203844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2934",
    tags: [],
    locationDescription:
      " The teacher runs towards the road angrily. A dog builds the cake lazily. The man runs towards the cake silently. A dog writes the road quickly.",
  },
  {
    locationId: "item20935",
    locationName: "item20935",
    locationAddress: "item20935",
    ratings: [
      { who: "Similar identities", rating: 1.64 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 59.42373571649376,
    lng: -7.396654488425046,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2935",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog runs towards a book angrily.",
  },
  {
    locationId: "item20936",
    locationName: "item20936",
    locationAddress: "item20936",
    ratings: [
      { who: "Similar identities", rating: 1.44 },
      { who: "All perspectives", rating: 0.74 },
    ],
    lat: 55.88507836957511,
    lng: -6.65457076774088,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2936",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher runs towards a book silently. The teacher jumps over a book happily.",
  },
  {
    locationId: "item20937",
    locationName: "item20937",
    locationAddress: "item20937",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 2.25 },
    ],
    lat: 50.730620693265166,
    lng: -5.542554163491808,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2937",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man writes a tower silently. The student builds a book lazily. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item20938",
    locationName: "item20938",
    locationAddress: "item20938",
    ratings: [
      { who: "Similar identities", rating: 0.6 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 60.65721885379335,
    lng: -2.9583774669989857,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2938",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the cake silently. The man runs towards a book happily. The student looks at a book happily.",
  },
  {
    locationId: "item20939",
    locationName: "item20939",
    locationAddress: "item20939",
    ratings: null,
    lat: 50.37671979676409,
    lng: -3.6628679075121626,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2939",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon lazily. A woman builds a fence quickly. The cat runs towards the cake angrily. The teacher runs towards a book gracefully. The teacher looks at the road quickly.",
  },
  {
    locationId: "item20940",
    locationName: "item20940",
    locationAddress: "item20940",
    ratings: [
      { who: "Similar identities", rating: 0.56 },
      { who: "All perspectives", rating: 1.7 },
    ],
    lat: 56.88318392806843,
    lng: -3.1669092009429045,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2940",
    tags: [{ label: "accessible" }],
    locationDescription: " The man builds a tower gracefully.",
  },
  {
    locationId: "item20941",
    locationName: "item20941",
    locationAddress: "item20941",
    ratings: null,
    lat: 58.9953643429771,
    lng: -4.954751891539846,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2941",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon silently. The teacher looks at the road lazily. The man runs towards a fence gracefully.",
  },
  {
    locationId: "item20942",
    locationName: "item20942",
    locationAddress: "item20942",
    ratings: null,
    lat: 59.835540508081266,
    lng: 0.5416545178591203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2942",
    tags: [],
    locationDescription:
      " The teacher builds the cake gracefully. The man builds a book lazily. A woman eats a fence gracefully. The man runs towards the road angrily.",
  },
  {
    locationId: "item20943",
    locationName: "item20943",
    locationAddress: "item20943",
    ratings: [
      { who: "Similar identities", rating: 2.86 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 53.69418188737198,
    lng: -2.134339557498749,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2943",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man builds a fence gracefully. A dog writes a fence quickly. A dog looks at the horizon happily.",
  },
  {
    locationId: "item20944",
    locationName: "item20944",
    locationAddress: "item20944",
    ratings: null,
    lat: 55.82651753185207,
    lng: -7.212778488812526,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2944",
    tags: [],
    locationDescription:
      " The man looks at the road gracefully. The cat jumps over the cake lazily. A woman runs towards a fence lazily. The man builds a book quickly. A dog looks at the road silently.",
  },
  {
    locationId: "item20945",
    locationName: "item20945",
    locationAddress: "item20945",
    ratings: null,
    lat: 56.922896853053096,
    lng: -0.33764780523969584,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2945",
    tags: [],
    locationDescription:
      " The cat builds a book angrily. A dog runs towards the cake silently. The student looks at the horizon gracefully. A dog jumps over the horizon silently.",
  },
  {
    locationId: "item20946",
    locationName: "item20946",
    locationAddress: "item20946",
    ratings: [
      { who: "Similar identities", rating: 0.51 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 57.80212080170375,
    lng: 0.2547686085130305,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2946",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards the cake lazily. The teacher builds the horizon silently. A woman looks at a tower lazily. The student writes a book gracefully.",
  },
  {
    locationId: "item20947",
    locationName: "item20947",
    locationAddress: "item20947",
    ratings: [
      { who: "Similar identities", rating: 3.84 },
      { who: "All perspectives", rating: 1.18 },
    ],
    lat: 54.36589648166557,
    lng: -1.3391426523204375,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2947",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat runs towards a tower lazily.",
  },
  {
    locationId: "item20948",
    locationName: "item20948",
    locationAddress: "item20948",
    ratings: null,
    lat: 54.55985035921087,
    lng: -7.989109088297959,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2948",
    tags: [],
    locationDescription:
      " The man writes a tower angrily. The student builds a fence gracefully.",
  },
  {
    locationId: "item20949",
    locationName: "item20949",
    locationAddress: "item20949",
    ratings: [
      { who: "Similar identities", rating: 0.26 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 52.95223554383897,
    lng: -0.6089260886867924,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2949",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards the cake happily. The man looks at a book silently. The man looks at a tower angrily.",
  },
  {
    locationId: "item20950",
    locationName: "item20950",
    locationAddress: "item20950",
    ratings: [
      { who: "Similar identities", rating: 0.5 },
      { who: "All perspectives", rating: 2.8 },
    ],
    lat: 56.34954607760896,
    lng: -8.12631501487318,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2950",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards a fence angrily. The cat builds a tower lazily. A woman builds a fence angrily. The teacher looks at a fence gracefully.",
  },
  {
    locationId: "item20951",
    locationName: "item20951",
    locationAddress: "item20951",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 2.6 },
    ],
    lat: 55.48225726451798,
    lng: -1.622159106749435,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2951",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " The cat runs towards the cake happily.",
  },
  {
    locationId: "item20952",
    locationName: "item20952",
    locationAddress: "item20952",
    ratings: null,
    lat: 53.468710335181015,
    lng: -3.5590679056188534,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2952",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon lazily. The student builds a book lazily. The teacher builds a fence lazily. A dog looks at a fence gracefully.",
  },
  {
    locationId: "item20953",
    locationName: "item20953",
    locationAddress: "item20953",
    ratings: null,
    lat: 60.81522812143978,
    lng: -4.554334104053491,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2953",
    tags: [],
    locationDescription:
      " The man jumps over the cake happily. A dog builds the cake gracefully.",
  },
  {
    locationId: "item20954",
    locationName: "item20954",
    locationAddress: "item20954",
    ratings: null,
    lat: 51.22675853769491,
    lng: 0.22028219006091554,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2954",
    tags: [],
    locationDescription:
      " The man jumps over the cake quickly. A woman runs towards the horizon angrily. The student looks at a fence lazily. A woman jumps over a tower silently. A dog jumps over the road happily.",
  },
  {
    locationId: "item20955",
    locationName: "item20955",
    locationAddress: "item20955",
    ratings: null,
    lat: 55.54629315265412,
    lng: -2.4343522123752193,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2955",
    tags: [],
    locationDescription:
      " A dog jumps over a tower happily. The student eats the road quickly. The cat runs towards the cake silently. The man writes a fence happily.",
  },
  {
    locationId: "item20956",
    locationName: "item20956",
    locationAddress: "item20956",
    ratings: null,
    lat: 53.368707918484844,
    lng: 1.260728181645689,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2956",
    tags: [],
    locationDescription:
      " The cat jumps over a tower lazily. A dog runs towards a book angrily. The man looks at a tower angrily. A dog jumps over a book lazily.",
  },
  {
    locationId: "item20957",
    locationName: "item20957",
    locationAddress: "item20957",
    ratings: null,
    lat: 59.25933754262761,
    lng: 0.3759011357780526,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2957",
    tags: [],
    locationDescription: " A woman runs towards a tower silently.",
  },
  {
    locationId: "item20958",
    locationName: "item20958",
    locationAddress: "item20958",
    ratings: [
      { who: "Similar identities", rating: 0.15 },
      { who: "All perspectives", rating: 1.51 },
    ],
    lat: 51.41792204090575,
    lng: -7.794508260171826,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2958",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher runs towards the horizon silently. The teacher eats the road quickly.",
  },
  {
    locationId: "item20959",
    locationName: "item20959",
    locationAddress: "item20959",
    ratings: null,
    lat: 60.224559520647794,
    lng: 1.1718714878116838,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2959",
    tags: [],
    locationDescription:
      " The cat writes the road silently. The man runs towards the horizon angrily. A dog looks at the horizon quickly. The cat writes a book silently.",
  },
  {
    locationId: "item20960",
    locationName: "item20960",
    locationAddress: "item20960",
    ratings: null,
    lat: 50.02826306087869,
    lng: -3.5059456663934565,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2960",
    tags: [],
    locationDescription: " The cat writes the cake silently.",
  },
  {
    locationId: "item20961",
    locationName: "item20961",
    locationAddress: "item20961",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 2.36 },
    ],
    lat: 58.65987906018587,
    lng: -7.631795744858371,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2961",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards the cake angrily. The man writes a book silently. The student builds the road angrily. The student runs towards a tower lazily. The student writes the road angrily.",
  },
  {
    locationId: "item20962",
    locationName: "item20962",
    locationAddress: "item20962",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 4.5 },
    ],
    lat: 52.4168519203749,
    lng: 1.7389472218079955,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2962",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman looks at the horizon gracefully. The cat runs towards a tower gracefully. The student builds a fence lazily. The cat runs towards a book lazily. A woman writes a book silently.",
  },
  {
    locationId: "item20963",
    locationName: "item20963",
    locationAddress: "item20963",
    ratings: [
      { who: "Similar identities", rating: 2.4 },
      { who: "All perspectives", rating: 2.55 },
    ],
    lat: 58.723019315227475,
    lng: -6.968458960916325,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2963",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The student jumps over a fence lazily.",
  },
  {
    locationId: "item20964",
    locationName: "item20964",
    locationAddress: "item20964",
    ratings: [
      { who: "Similar identities", rating: 4.41 },
      { who: "All perspectives", rating: 4.61 },
    ],
    lat: 54.226670213080766,
    lng: -6.118905708374983,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2964",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The student eats the cake happily.",
  },
  {
    locationId: "item20965",
    locationName: "item20965",
    locationAddress: "item20965",
    ratings: null,
    lat: 53.758912256079086,
    lng: 0.6928472762110367,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2965",
    tags: [],
    locationDescription:
      " The student looks at the cake gracefully. The man jumps over a tower lazily. The cat writes the horizon happily. The cat writes the road happily.",
  },
  {
    locationId: "item20966",
    locationName: "item20966",
    locationAddress: "item20966",
    ratings: null,
    lat: 52.74673968856467,
    lng: -3.0249412186728852,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2966",
    tags: [],
    locationDescription:
      " The teacher looks at the cake happily. The cat looks at the cake lazily. A dog runs towards a fence gracefully. The cat looks at a tower gracefully.",
  },
  {
    locationId: "item20967",
    locationName: "item20967",
    locationAddress: "item20967",
    ratings: null,
    lat: 50.35631064984412,
    lng: 1.0021768211964641,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2967",
    tags: [],
    locationDescription:
      " A woman runs towards the cake lazily. A woman looks at the horizon angrily. The student writes the road lazily.",
  },
  {
    locationId: "item20968",
    locationName: "item20968",
    locationAddress: "item20968",
    ratings: [
      { who: "Similar identities", rating: 0.44 },
      { who: "All perspectives", rating: 0.25 },
    ],
    lat: 57.30380645285272,
    lng: 1.2114331809054537,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2968",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The cat writes the horizon lazily. A dog eats the cake angrily. The cat looks at the horizon happily. The cat runs towards the horizon silently. A woman builds a book gracefully.",
  },
  {
    locationId: "item20969",
    locationName: "item20969",
    locationAddress: "item20969",
    ratings: null,
    lat: 58.36561460201974,
    lng: -8.267475470906655,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2969",
    tags: [],
    locationDescription:
      " A dog jumps over a fence silently. A woman looks at a fence silently.",
  },
  {
    locationId: "item20970",
    locationName: "item20970",
    locationAddress: "item20970",
    ratings: null,
    lat: 58.38173637647076,
    lng: 0.24651182476350364,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2970",
    tags: [],
    locationDescription:
      " The man writes a fence happily. The man jumps over a book quickly.",
  },
  {
    locationId: "item20971",
    locationName: "item20971",
    locationAddress: "item20971",
    ratings: null,
    lat: 50.46268269235428,
    lng: 1.3720080799282837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2971",
    tags: [],
    locationDescription: " A dog builds a fence silently.",
  },
  {
    locationId: "item20972",
    locationName: "item20972",
    locationAddress: "item20972",
    ratings: null,
    lat: 53.42334741351496,
    lng: 1.3819837388894562,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2972",
    tags: [],
    locationDescription:
      " A dog builds the road happily. A woman looks at the road silently. The cat eats a fence happily.",
  },
  {
    locationId: "item20973",
    locationName: "item20973",
    locationAddress: "item20973",
    ratings: [
      { who: "Similar identities", rating: 2.85 },
      { who: "All perspectives", rating: 1.86 },
    ],
    lat: 54.69677801587778,
    lng: -3.1507138129888066,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2973",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards the horizon quickly. The cat runs towards the horizon quickly. A dog eats the horizon quickly. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item20974",
    locationName: "item20974",
    locationAddress: "item20974",
    ratings: [
      { who: "Similar identities", rating: 2.97 },
      { who: "All perspectives", rating: 0.67 },
    ],
    lat: 52.96462695614689,
    lng: 1.440575348704927,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2974",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student runs towards the road angrily. The cat eats the horizon lazily. The man runs towards a tower angrily. The cat looks at a tower happily.",
  },
  {
    locationId: "item20975",
    locationName: "item20975",
    locationAddress: "item20975",
    ratings: null,
    lat: 50.0147058866567,
    lng: -6.266644369359154,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2975",
    tags: [],
    locationDescription:
      " A woman runs towards a fence gracefully. A dog eats a tower lazily.",
  },
  {
    locationId: "item20976",
    locationName: "item20976",
    locationAddress: "item20976",
    ratings: [
      { who: "Similar identities", rating: 3.95 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 55.473929576241815,
    lng: -1.3591451016789753,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2976",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription: " A dog builds a tower lazily.",
  },
  {
    locationId: "item20977",
    locationName: "item20977",
    locationAddress: "item20977",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 1.27 },
    ],
    lat: 52.96183516295125,
    lng: -1.644308113111812,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2977",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A dog runs towards a tower angrily.",
  },
  {
    locationId: "item20978",
    locationName: "item20978",
    locationAddress: "item20978",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 2.0 },
    ],
    lat: 59.604174884788364,
    lng: -7.588369967933278,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2978",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man jumps over the cake happily. A dog eats the horizon silently. The student looks at a tower happily.",
  },
  {
    locationId: "item20979",
    locationName: "item20979",
    locationAddress: "item20979",
    ratings: null,
    lat: 52.702277382007274,
    lng: -0.5847315583130523,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2979",
    tags: [],
    locationDescription: " A dog writes the horizon happily.",
  },
  {
    locationId: "item20980",
    locationName: "item20980",
    locationAddress: "item20980",
    ratings: [
      { who: "Similar identities", rating: 0.71 },
      { who: "All perspectives", rating: 4.39 },
    ],
    lat: 54.870142377227026,
    lng: -5.007858453229558,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2980",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The cat eats the horizon quickly.",
  },
  {
    locationId: "item20981",
    locationName: "item20981",
    locationAddress: "item20981",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 57.454823889419934,
    lng: -1.4841062280519512,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2981",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student builds the horizon angrily. The student eats the road silently. The cat eats the cake gracefully.",
  },
  {
    locationId: "item20982",
    locationName: "item20982",
    locationAddress: "item20982",
    ratings: null,
    lat: 52.8300360063425,
    lng: -8.55898074809294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2982",
    tags: [],
    locationDescription:
      " A woman runs towards the road happily. A dog writes a book silently. A woman runs towards a tower gracefully. The student eats the horizon gracefully.",
  },
  {
    locationId: "item20983",
    locationName: "item20983",
    locationAddress: "item20983",
    ratings: [
      { who: "Similar identities", rating: 2.75 },
      { who: "All perspectives", rating: 2.61 },
    ],
    lat: 52.463091025589065,
    lng: 0.8068948903196542,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2983",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The cat runs towards a book lazily. The man eats a fence angrily. The student runs towards a fence angrily. The teacher builds a tower angrily. The cat builds a book gracefully.",
  },
  {
    locationId: "item20984",
    locationName: "item20984",
    locationAddress: "item20984",
    ratings: null,
    lat: 50.594461155683184,
    lng: -6.164023812253162,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2984",
    tags: [],
    locationDescription: " The cat looks at the cake angrily.",
  },
  {
    locationId: "item20985",
    locationName: "item20985",
    locationAddress: "item20985",
    ratings: [
      { who: "Similar identities", rating: 2.26 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 53.3657760528715,
    lng: -0.0033863054437208717,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2985",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman looks at the road happily. The teacher writes a tower lazily.",
  },
  {
    locationId: "item20986",
    locationName: "item20986",
    locationAddress: "item20986",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 59.64021860556134,
    lng: -8.220413417910487,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2986",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a book angrily. A dog looks at the road angrily.",
  },
  {
    locationId: "item20987",
    locationName: "item20987",
    locationAddress: "item20987",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 59.51435601340678,
    lng: -5.708420219818899,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2987",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student writes the cake quickly. A woman looks at the cake lazily. The cat jumps over a tower angrily.",
  },
  {
    locationId: "item20988",
    locationName: "item20988",
    locationAddress: "item20988",
    ratings: null,
    lat: 55.8101855452016,
    lng: -5.146817100019531,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2988",
    tags: [],
    locationDescription:
      " The man runs towards a book gracefully. The teacher jumps over a book quickly. The student eats the road lazily. The man builds the road gracefully. The cat writes the cake silently.",
  },
  {
    locationId: "item20989",
    locationName: "item20989",
    locationAddress: "item20989",
    ratings: null,
    lat: 54.21202505221841,
    lng: -7.905835975491062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2989",
    tags: [],
    locationDescription:
      " The student jumps over the cake angrily. The student writes the road silently. The teacher writes a book angrily. The cat runs towards a book angrily. The student runs towards a tower quickly.",
  },
  {
    locationId: "item20990",
    locationName: "item20990",
    locationAddress: "item20990",
    ratings: null,
    lat: 59.08021996262695,
    lng: 0.05039869665261065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2990",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon angrily. A dog jumps over a fence angrily. A woman eats a fence lazily. A dog looks at the horizon lazily. The man runs towards the horizon lazily.",
  },
  {
    locationId: "item20991",
    locationName: "item20991",
    locationAddress: "item20991",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 0.37 },
    ],
    lat: 49.909835374218176,
    lng: -0.05206337981584852,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2991",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman writes a tower silently. A woman looks at the horizon silently.",
  },
  {
    locationId: "item20992",
    locationName: "item20992",
    locationAddress: "item20992",
    ratings: null,
    lat: 60.824510353534464,
    lng: 1.4496493467396547,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2992",
    tags: [],
    locationDescription: " The student writes a tower silently.",
  },
  {
    locationId: "item20993",
    locationName: "item20993",
    locationAddress: "item20993",
    ratings: null,
    lat: 50.79185916350429,
    lng: -2.3860625401836826,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2993",
    tags: [],
    locationDescription:
      " A dog jumps over a fence gracefully. A dog runs towards a book quickly. A dog jumps over a fence silently.",
  },
  {
    locationId: "item20994",
    locationName: "item20994",
    locationAddress: "item20994",
    ratings: null,
    lat: 54.49527444761401,
    lng: -1.8364110278797448,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2994",
    tags: [],
    locationDescription:
      " The teacher builds a book angrily. A woman runs towards a tower happily. The student writes a fence happily. A dog looks at the horizon happily.",
  },
  {
    locationId: "item20995",
    locationName: "item20995",
    locationAddress: "item20995",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 0.41 },
    ],
    lat: 53.29873617230746,
    lng: -6.019296519588119,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2995",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man builds a tower happily. A dog jumps over a book lazily. The cat eats a fence happily.",
  },
  {
    locationId: "item20996",
    locationName: "item20996",
    locationAddress: "item20996",
    ratings: null,
    lat: 58.36100059085112,
    lng: -0.9048090832278515,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2996",
    tags: [],
    locationDescription:
      " The teacher looks at a book angrily. A dog eats a tower silently. The student runs towards the cake lazily. A woman builds a fence quickly. The teacher jumps over the road happily.",
  },
  {
    locationId: "item20997",
    locationName: "item20997",
    locationAddress: "item20997",
    ratings: [
      { who: "Similar identities", rating: 0.06 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 56.41806965237034,
    lng: -2.3548617595614783,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2997",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher runs towards the horizon lazily. A woman jumps over the cake gracefully.",
  },
  {
    locationId: "item20998",
    locationName: "item20998",
    locationAddress: "item20998",
    ratings: null,
    lat: 52.87457174552951,
    lng: 0.14812155716091802,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2998",
    tags: [],
    locationDescription:
      " The man runs towards the cake angrily. A woman runs towards the road happily.",
  },
  {
    locationId: "item20999",
    locationName: "item20999",
    locationAddress: "item20999",
    ratings: null,
    lat: 50.546667738432056,
    lng: -6.0368852630993715,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2999",
    tags: [],
    locationDescription: " A dog builds a tower gracefully.",
  },
  {
    locationId: "item21000",
    locationName: "item21000",
    locationAddress: "item21000",
    ratings: [
      { who: "Similar identities", rating: 3.23 },
      { who: "All perspectives", rating: 2.25 },
    ],
    lat: 59.13526157137849,
    lng: 1.2693125050867327,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3000",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student jumps over the horizon quickly. The teacher runs towards the horizon happily. The man jumps over the cake angrily.",
  },
  {
    locationId: "item21001",
    locationName: "item21001",
    locationAddress: "item21001",
    ratings: null,
    lat: 59.010372001931444,
    lng: -6.349616810386975,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3001",
    tags: [],
    locationDescription: " The teacher builds the road lazily.",
  },
  {
    locationId: "item21002",
    locationName: "item21002",
    locationAddress: "item21002",
    ratings: null,
    lat: 57.21684360524891,
    lng: -3.346315573361471,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3002",
    tags: [],
    locationDescription: " The teacher writes the road quickly.",
  },
  {
    locationId: "item21003",
    locationName: "item21003",
    locationAddress: "item21003",
    ratings: null,
    lat: 50.766093388197454,
    lng: -6.221903365134175,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3003",
    tags: [],
    locationDescription:
      " The cat writes the road quickly. The teacher eats a tower angrily. The cat eats a tower happily.",
  },
  {
    locationId: "item21004",
    locationName: "item21004",
    locationAddress: "item21004",
    ratings: null,
    lat: 54.50744443512837,
    lng: -5.885460435081506,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3004",
    tags: [],
    locationDescription: " A woman runs towards the road lazily.",
  },
  {
    locationId: "item21005",
    locationName: "item21005",
    locationAddress: "item21005",
    ratings: null,
    lat: 50.77194858219692,
    lng: -2.1425134574933837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3005",
    tags: [],
    locationDescription:
      " The teacher looks at the cake quickly. The student builds the road silently.",
  },
  {
    locationId: "item21006",
    locationName: "item21006",
    locationAddress: "item21006",
    ratings: [
      { who: "Similar identities", rating: 1.86 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 56.9958418247128,
    lng: -4.725577569364483,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3006",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The student jumps over a fence quickly. The teacher builds the horizon gracefully. The man builds a tower lazily.",
  },
  {
    locationId: "item21007",
    locationName: "item21007",
    locationAddress: "item21007",
    ratings: null,
    lat: 60.59532937688217,
    lng: -4.730892507752635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3007",
    tags: [],
    locationDescription:
      " The cat writes a book quickly. A dog builds the road angrily. A woman looks at the cake gracefully. The cat builds a tower gracefully. The teacher eats the cake angrily.",
  },
  {
    locationId: "item21008",
    locationName: "item21008",
    locationAddress: "item21008",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 51.58536932643509,
    lng: -3.0787129767669645,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3008",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman builds a tower quickly. The teacher jumps over a book quickly.",
  },
  {
    locationId: "item21009",
    locationName: "item21009",
    locationAddress: "item21009",
    ratings: [
      { who: "Similar identities", rating: 3.33 },
      { who: "All perspectives", rating: 4.61 },
    ],
    lat: 52.04047787002416,
    lng: -2.1752871321498883,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3009",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man eats a book gracefully. The teacher builds a book gracefully.",
  },
  {
    locationId: "item21010",
    locationName: "item21010",
    locationAddress: "item21010",
    ratings: null,
    lat: 50.10502916948195,
    lng: -2.579618727170601,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3010",
    tags: [],
    locationDescription: " A dog writes the cake gracefully.",
  },
  {
    locationId: "item21011",
    locationName: "item21011",
    locationAddress: "item21011",
    ratings: [
      { who: "Similar identities", rating: 0.3 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 51.35183224157766,
    lng: -3.707464857241165,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3011",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at the road angrily. The cat jumps over a fence gracefully. The cat writes the road quickly. A dog jumps over the cake silently. The cat eats a book lazily.",
  },
  {
    locationId: "item21012",
    locationName: "item21012",
    locationAddress: "item21012",
    ratings: [
      { who: "Similar identities", rating: 2.33 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 50.30414392624694,
    lng: -1.234793978452493,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3012",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " A woman runs towards a fence angrily.",
  },
  {
    locationId: "item21013",
    locationName: "item21013",
    locationAddress: "item21013",
    ratings: null,
    lat: 51.52832571310809,
    lng: 1.3220955577750448,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3013",
    tags: [],
    locationDescription:
      " The cat looks at a tower silently. A woman builds a tower lazily. A dog runs towards a book silently. The man looks at a tower happily. A woman looks at the horizon angrily.",
  },
  {
    locationId: "item21014",
    locationName: "item21014",
    locationAddress: "item21014",
    ratings: null,
    lat: 55.91901089082717,
    lng: -0.620577941273722,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3014",
    tags: [],
    locationDescription:
      " The man runs towards a tower gracefully. The man eats the cake angrily. The teacher looks at the road quickly. The man runs towards a tower quickly. The student writes a tower lazily.",
  },
  {
    locationId: "item21015",
    locationName: "item21015",
    locationAddress: "item21015",
    ratings: null,
    lat: 50.09922358703599,
    lng: -8.009196170422616,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3015",
    tags: [],
    locationDescription:
      " The cat looks at the road happily. The teacher looks at a fence gracefully. The man writes a fence silently. The teacher jumps over the cake quickly.",
  },
  {
    locationId: "item21016",
    locationName: "item21016",
    locationAddress: "item21016",
    ratings: null,
    lat: 60.71167789927711,
    lng: -0.7769895539253033,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3016",
    tags: [],
    locationDescription: " A woman builds the horizon quickly.",
  },
  {
    locationId: "item21017",
    locationName: "item21017",
    locationAddress: "item21017",
    ratings: null,
    lat: 52.99291158090318,
    lng: -7.068036705451556,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3017",
    tags: [],
    locationDescription:
      " The cat looks at the cake angrily. The cat builds the cake lazily. The teacher writes a fence silently.",
  },
  {
    locationId: "item21018",
    locationName: "item21018",
    locationAddress: "item21018",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 58.98850312287924,
    lng: -7.012077393543864,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3018",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher runs towards a book lazily. A woman looks at the horizon angrily. A woman writes the cake angrily. The teacher runs towards the cake silently. The student runs towards a book happily.",
  },
  {
    locationId: "item21019",
    locationName: "item21019",
    locationAddress: "item21019",
    ratings: [
      { who: "Similar identities", rating: 3.35 },
      { who: "All perspectives", rating: 3.86 },
    ],
    lat: 54.421521083410894,
    lng: -3.7004082442489628,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3019",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " A dog eats a fence angrily.",
  },
  {
    locationId: "item21020",
    locationName: "item21020",
    locationAddress: "item21020",
    ratings: null,
    lat: 55.31737719551015,
    lng: 1.2588973368383876,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3020",
    tags: [],
    locationDescription:
      " The cat builds a book silently. A woman runs towards a book silently. The cat looks at the horizon silently. The cat jumps over a fence silently.",
  },
  {
    locationId: "item21021",
    locationName: "item21021",
    locationAddress: "item21021",
    ratings: null,
    lat: 58.807247759441765,
    lng: -6.714715711719783,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3021",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon gracefully. The student jumps over the cake gracefully. The teacher writes a book gracefully. The student looks at the road happily. The teacher writes a fence silently.",
  },
  {
    locationId: "item21022",
    locationName: "item21022",
    locationAddress: "item21022",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 2.06 },
    ],
    lat: 53.11978559925725,
    lng: -1.652849405998242,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3022",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man writes a book silently. The teacher builds the road quickly. A dog runs towards a fence happily. The man writes the cake quickly. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item21023",
    locationName: "item21023",
    locationAddress: "item21023",
    ratings: [
      { who: "Similar identities", rating: 0.66 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 52.21818443217671,
    lng: -4.923976106817416,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3023",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The man builds the road gracefully.",
  },
  {
    locationId: "item21024",
    locationName: "item21024",
    locationAddress: "item21024",
    ratings: [
      { who: "Similar identities", rating: 3.01 },
      { who: "All perspectives", rating: 3.67 },
    ],
    lat: 52.99659644457555,
    lng: 1.1637010706722286,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3024",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog jumps over the road angrily. The man runs towards a book quickly. A dog looks at a tower happily. A dog runs towards a fence gracefully. The student jumps over the cake happily.",
  },
  {
    locationId: "item21025",
    locationName: "item21025",
    locationAddress: "item21025",
    ratings: [
      { who: "Similar identities", rating: 3.94 },
      { who: "All perspectives", rating: 3.83 },
    ],
    lat: 53.78585279113354,
    lng: -4.93389174740427,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3025",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a fence lazily. The cat eats a tower gracefully. The teacher builds a fence angrily. The teacher jumps over a fence quickly. The cat builds a book gracefully.",
  },
  {
    locationId: "item21026",
    locationName: "item21026",
    locationAddress: "item21026",
    ratings: [
      { who: "Similar identities", rating: 3.5 },
      { who: "All perspectives", rating: 3.28 },
    ],
    lat: 55.262100237899745,
    lng: -8.33326817558901,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3026",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man runs towards a fence happily.",
  },
  {
    locationId: "item21027",
    locationName: "item21027",
    locationAddress: "item21027",
    ratings: null,
    lat: 55.001479976982175,
    lng: -4.848388964800803,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3027",
    tags: [],
    locationDescription:
      " A woman looks at a fence silently. The student builds a fence lazily. The man eats a tower gracefully.",
  },
  {
    locationId: "item21028",
    locationName: "item21028",
    locationAddress: "item21028",
    ratings: null,
    lat: 51.22670642221123,
    lng: -1.8382527828938189,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3028",
    tags: [],
    locationDescription:
      " A dog writes a tower lazily. The man writes the road silently. The student jumps over a tower quickly. The student jumps over a fence lazily.",
  },
  {
    locationId: "item21029",
    locationName: "item21029",
    locationAddress: "item21029",
    ratings: null,
    lat: 57.282675330707114,
    lng: -2.9411158514984974,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3029",
    tags: [],
    locationDescription: " The student writes a book lazily.",
  },
  {
    locationId: "item21030",
    locationName: "item21030",
    locationAddress: "item21030",
    ratings: null,
    lat: 53.07086976315493,
    lng: -4.144537075209581,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3030",
    tags: [],
    locationDescription:
      " The cat jumps over a book angrily. A woman eats a tower angrily. The man jumps over a fence gracefully. A woman looks at a fence lazily.",
  },
  {
    locationId: "item21031",
    locationName: "item21031",
    locationAddress: "item21031",
    ratings: null,
    lat: 52.21602158901872,
    lng: -7.4286805657943455,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3031",
    tags: [],
    locationDescription:
      " A dog writes a tower gracefully. A dog looks at the cake lazily.",
  },
  {
    locationId: "item21032",
    locationName: "item21032",
    locationAddress: "item21032",
    ratings: [
      { who: "Similar identities", rating: 0.19 },
      { who: "All perspectives", rating: 3.63 },
    ],
    lat: 54.09363178980071,
    lng: -6.001284557671969,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3032",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman writes a fence silently.",
  },
  {
    locationId: "item21033",
    locationName: "item21033",
    locationAddress: "item21033",
    ratings: [
      { who: "Similar identities", rating: 4.97 },
      { who: "All perspectives", rating: 4.12 },
    ],
    lat: 51.05110053010288,
    lng: -6.932165624972448,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3033",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman runs towards the road lazily.",
  },
  {
    locationId: "item21034",
    locationName: "item21034",
    locationAddress: "item21034",
    ratings: null,
    lat: 57.45497749536026,
    lng: -5.368782944827838,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3034",
    tags: [],
    locationDescription:
      " The man jumps over a tower lazily. The teacher eats the horizon gracefully. The student eats the horizon lazily. The teacher builds the horizon silently.",
  },
  {
    locationId: "item21035",
    locationName: "item21035",
    locationAddress: "item21035",
    ratings: [
      { who: "Similar identities", rating: 1.12 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 56.138165683938894,
    lng: 0.33589173840045383,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3035",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher eats the road gracefully. The man eats a tower lazily. A woman writes a fence happily. The man runs towards the cake lazily. The man runs towards the road quickly.",
  },
  {
    locationId: "item21036",
    locationName: "item21036",
    locationAddress: "item21036",
    ratings: [
      { who: "Similar identities", rating: 2.64 },
      { who: "All perspectives", rating: 1.78 },
    ],
    lat: 59.72353216072828,
    lng: -3.7357487882260285,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3036",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The student jumps over the cake happily.",
  },
  {
    locationId: "item21037",
    locationName: "item21037",
    locationAddress: "item21037",
    ratings: null,
    lat: 54.40891540880592,
    lng: 0.9768570832777623,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3037",
    tags: [],
    locationDescription:
      " A woman writes the road happily. The cat builds a tower lazily. The teacher looks at the horizon angrily. The student writes the cake silently.",
  },
  {
    locationId: "item21038",
    locationName: "item21038",
    locationAddress: "item21038",
    ratings: null,
    lat: 57.381203659586156,
    lng: -7.987590556567885,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3038",
    tags: [],
    locationDescription:
      " A woman jumps over the cake quickly. A woman writes a book quickly. A dog looks at the road silently. A dog jumps over the horizon angrily.",
  },
  {
    locationId: "item21039",
    locationName: "item21039",
    locationAddress: "item21039",
    ratings: null,
    lat: 56.20086778078013,
    lng: 0.08971645749309509,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3039",
    tags: [],
    locationDescription:
      " A woman writes a book angrily. A dog eats a book angrily. A dog eats a book silently. A dog runs towards a book gracefully.",
  },
  {
    locationId: "item21040",
    locationName: "item21040",
    locationAddress: "item21040",
    ratings: [
      { who: "Similar identities", rating: 0.29 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 54.8650586364329,
    lng: -5.665897939699516,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item3040",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat writes a tower gracefully. The student builds the road gracefully.",
  },
  {
    locationId: "item21041",
    locationName: "item21041",
    locationAddress: "item21041",
    ratings: [
      { who: "Similar identities", rating: 2.77 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 57.65710477399947,
    lng: -1.3853201457641777,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3041",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher builds the horizon happily. A dog looks at the road lazily. A dog jumps over the cake lazily. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item21042",
    locationName: "item21042",
    locationAddress: "item21042",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 0.04 },
    ],
    lat: 57.24708895532498,
    lng: -2.472142124552504,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3042",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman jumps over the cake angrily. A dog looks at the cake silently. The cat looks at the horizon quickly. The cat jumps over the cake gracefully. A woman looks at a book quickly.",
  },
  {
    locationId: "item21043",
    locationName: "item21043",
    locationAddress: "item21043",
    ratings: null,
    lat: 50.2904919441151,
    lng: -2.5302178974838716,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3043",
    tags: [],
    locationDescription:
      " A woman runs towards a book gracefully. A dog looks at the road angrily. A dog runs towards the road gracefully. The teacher eats the cake silently. A woman writes the horizon angrily.",
  },
  {
    locationId: "item21044",
    locationName: "item21044",
    locationAddress: "item21044",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 0.52 },
    ],
    lat: 54.33251669529074,
    lng: -7.053604493080066,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3044",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds the horizon silently. The student jumps over a fence quickly.",
  },
  {
    locationId: "item21045",
    locationName: "item21045",
    locationAddress: "item21045",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 2.08 },
    ],
    lat: 53.337512250249326,
    lng: 1.1463747520020693,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3045",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription: " A dog writes the horizon silently.",
  },
  {
    locationId: "item21046",
    locationName: "item21046",
    locationAddress: "item21046",
    ratings: [
      { who: "Similar identities", rating: 4.87 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 51.77082856522208,
    lng: -0.471859157785957,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3046",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher builds a tower gracefully. The teacher eats a book gracefully. A woman runs towards a tower gracefully. The cat builds a tower silently. The student runs towards a fence quickly.",
  },
  {
    locationId: "item21047",
    locationName: "item21047",
    locationAddress: "item21047",
    ratings: null,
    lat: 59.26289551122392,
    lng: -0.01199634927004567,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3047",
    tags: [],
    locationDescription:
      " A woman builds a tower gracefully. A woman runs towards a fence gracefully. The student builds a fence happily. The cat eats the cake happily.",
  },
  {
    locationId: "item21048",
    locationName: "item21048",
    locationAddress: "item21048",
    ratings: null,
    lat: 53.723416260110454,
    lng: -5.584712643185387,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3048",
    tags: [],
    locationDescription:
      " The cat builds the horizon lazily. The cat runs towards a book angrily. The teacher runs towards the road lazily. The cat writes the road lazily.",
  },
  {
    locationId: "item21049",
    locationName: "item21049",
    locationAddress: "item21049",
    ratings: [
      { who: "Similar identities", rating: 4.76 },
      { who: "All perspectives", rating: 1.82 },
    ],
    lat: 50.729847652992305,
    lng: -2.9569751918164364,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3049",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man eats a tower quickly. A woman builds the horizon lazily. A woman runs towards a fence silently. The teacher builds a book quickly. The teacher runs towards a fence lazily.",
  },
  {
    locationId: "item21050",
    locationName: "item21050",
    locationAddress: "item21050",
    ratings: null,
    lat: 57.1015099464554,
    lng: -1.8014356868479782,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3050",
    tags: [],
    locationDescription:
      " The man jumps over a tower silently. The student jumps over the cake angrily. A dog eats the cake lazily.",
  },
  {
    locationId: "item21051",
    locationName: "item21051",
    locationAddress: "item21051",
    ratings: [
      { who: "Similar identities", rating: 0.29 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 50.346659223986144,
    lng: -4.28600792343145,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3051",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat runs towards the horizon happily. A woman runs towards the cake quickly. A dog jumps over the cake happily. A woman writes the cake lazily.",
  },
  {
    locationId: "item21052",
    locationName: "item21052",
    locationAddress: "item21052",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 4.71 },
    ],
    lat: 50.93008059221276,
    lng: -2.3989417179777552,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3052",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student builds the road angrily. A woman jumps over a book quickly. The cat writes a book quickly. A dog builds the horizon happily.",
  },
  {
    locationId: "item21053",
    locationName: "item21053",
    locationAddress: "item21053",
    ratings: null,
    lat: 55.69687982848191,
    lng: -6.57618815785635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3053",
    tags: [],
    locationDescription:
      " The cat builds a tower silently. The cat jumps over a tower quickly. A woman jumps over the cake lazily.",
  },
  {
    locationId: "item21054",
    locationName: "item21054",
    locationAddress: "item21054",
    ratings: [
      { who: "Similar identities", rating: 0.54 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 51.39893166235495,
    lng: -0.4240217519499794,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3054",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman writes a fence quickly.",
  },
  {
    locationId: "item21055",
    locationName: "item21055",
    locationAddress: "item21055",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 1.76 },
    ],
    lat: 60.04836437778376,
    lng: -0.7647682053418885,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3055",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student builds a tower silently. The cat jumps over the road lazily.",
  },
  {
    locationId: "item21056",
    locationName: "item21056",
    locationAddress: "item21056",
    ratings: [
      { who: "Similar identities", rating: 2.91 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 59.192821527024535,
    lng: -8.538435631131495,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3056",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man runs towards the cake happily. A dog eats the road gracefully. The cat runs towards the horizon angrily.",
  },
  {
    locationId: "item21057",
    locationName: "item21057",
    locationAddress: "item21057",
    ratings: null,
    lat: 51.196622557300266,
    lng: -0.3973438968855927,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3057",
    tags: [],
    locationDescription:
      " A woman builds a tower angrily. The cat builds the road gracefully. A dog looks at a tower lazily. The man runs towards the road lazily.",
  },
  {
    locationId: "item21058",
    locationName: "item21058",
    locationAddress: "item21058",
    ratings: null,
    lat: 53.21666192706045,
    lng: -2.3170364480057453,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3058",
    tags: [],
    locationDescription: " The man jumps over a tower gracefully.",
  },
  {
    locationId: "item21059",
    locationName: "item21059",
    locationAddress: "item21059",
    ratings: null,
    lat: 58.63318361726334,
    lng: -7.693966000270735,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3059",
    tags: [],
    locationDescription: " A dog runs towards the horizon happily.",
  },
  {
    locationId: "item21060",
    locationName: "item21060",
    locationAddress: "item21060",
    ratings: null,
    lat: 53.945040615566356,
    lng: 1.6629244606554927,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3060",
    tags: [],
    locationDescription:
      " The student eats a book gracefully. The teacher looks at the road silently. The teacher builds a tower lazily. The man runs towards the horizon happily.",
  },
  {
    locationId: "item21061",
    locationName: "item21061",
    locationAddress: "item21061",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 2.31 },
    ],
    lat: 51.61689568592657,
    lng: -3.598416560160425,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3061",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog jumps over the horizon silently. The teacher jumps over a fence angrily.",
  },
  {
    locationId: "item21062",
    locationName: "item21062",
    locationAddress: "item21062",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 58.203889939337714,
    lng: -4.48830380273248,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3062",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat looks at a book quickly. A dog builds the cake silently.",
  },
  {
    locationId: "item21063",
    locationName: "item21063",
    locationAddress: "item21063",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 58.320463919833806,
    lng: -8.270679065606215,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3063",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A dog writes the horizon gracefully. The man writes the cake quickly.",
  },
  {
    locationId: "item21064",
    locationName: "item21064",
    locationAddress: "item21064",
    ratings: [
      { who: "Similar identities", rating: 2.32 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 58.26537474408349,
    lng: -2.889938788325699,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3064",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man runs towards the road silently. The cat jumps over the cake lazily. The man writes a fence happily. A woman jumps over a book quickly. The cat runs towards the cake lazily.",
  },
  {
    locationId: "item21065",
    locationName: "item21065",
    locationAddress: "item21065",
    ratings: null,
    lat: 51.87791849725868,
    lng: -2.2409569505013964,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3065",
    tags: [],
    locationDescription: " A woman looks at the cake angrily.",
  },
  {
    locationId: "item21066",
    locationName: "item21066",
    locationAddress: "item21066",
    ratings: [
      { who: "Similar identities", rating: 4.39 },
      { who: "All perspectives", rating: 0.04 },
    ],
    lat: 51.18779119790253,
    lng: -8.502280480966597,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3066",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " The man jumps over the horizon lazily.",
  },
  {
    locationId: "item21067",
    locationName: "item21067",
    locationAddress: "item21067",
    ratings: [
      { who: "Similar identities", rating: 4.61 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 52.95325073561406,
    lng: -8.14406680650074,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3067",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds the road angrily. A woman jumps over a book lazily. The teacher writes a tower happily.",
  },
  {
    locationId: "item21068",
    locationName: "item21068",
    locationAddress: "item21068",
    ratings: null,
    lat: 60.605534235252705,
    lng: -4.601849660518701,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3068",
    tags: [],
    locationDescription: " The teacher jumps over the road angrily.",
  },
  {
    locationId: "item21069",
    locationName: "item21069",
    locationAddress: "item21069",
    ratings: null,
    lat: 59.23882772026291,
    lng: -5.046686858997191,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3069",
    tags: [],
    locationDescription:
      " The man builds a book gracefully. The man looks at the horizon gracefully. The student jumps over the road silently. The man builds the cake angrily. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item21070",
    locationName: "item21070",
    locationAddress: "item21070",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 54.001158155059215,
    lng: 0.4500966352728817,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3070",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The student looks at a tower lazily. The student eats the road lazily.",
  },
  {
    locationId: "item21071",
    locationName: "item21071",
    locationAddress: "item21071",
    ratings: [
      { who: "Similar identities", rating: 0.58 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 50.14671397744834,
    lng: 0.9361096794791095,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3071",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher looks at the road happily. The student writes a book lazily. A woman builds the cake gracefully. The cat eats a fence happily. The student builds a tower quickly.",
  },
  {
    locationId: "item21072",
    locationName: "item21072",
    locationAddress: "item21072",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 57.18729082508983,
    lng: -0.6960465304255683,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3072",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats the horizon gracefully. A dog builds the cake lazily. The cat writes a fence gracefully. A woman jumps over the cake angrily. The cat runs towards the cake gracefully.",
  },
  {
    locationId: "item21073",
    locationName: "item21073",
    locationAddress: "item21073",
    ratings: null,
    lat: 50.9024646336757,
    lng: -6.220541447234947,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3073",
    tags: [],
    locationDescription:
      " The student eats a book lazily. The teacher writes a fence happily. A woman looks at a tower happily. A woman writes a tower quickly.",
  },
  {
    locationId: "item21074",
    locationName: "item21074",
    locationAddress: "item21074",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 1.9 },
    ],
    lat: 55.17436781822124,
    lng: -6.904280679128602,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3074",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription: " The cat writes a fence quickly.",
  },
  {
    locationId: "item21075",
    locationName: "item21075",
    locationAddress: "item21075",
    ratings: null,
    lat: 52.13922769075626,
    lng: 1.3864546387136212,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3075",
    tags: [],
    locationDescription:
      " A woman runs towards a fence angrily. The student jumps over the cake gracefully. A woman runs towards the road silently. The man writes the cake lazily. A woman jumps over the road happily.",
  },
  {
    locationId: "item21076",
    locationName: "item21076",
    locationAddress: "item21076",
    ratings: null,
    lat: 52.67611612477718,
    lng: -1.948282342905351,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3076",
    tags: [],
    locationDescription:
      " A dog runs towards a book lazily. The student builds a tower gracefully. The teacher runs towards a fence happily. A dog eats a book happily.",
  },
  {
    locationId: "item21077",
    locationName: "item21077",
    locationAddress: "item21077",
    ratings: null,
    lat: 53.15724195280792,
    lng: -8.271772578198684,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3077",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. The teacher jumps over a tower happily. A dog runs towards the horizon happily.",
  },
  {
    locationId: "item21078",
    locationName: "item21078",
    locationAddress: "item21078",
    ratings: [
      { who: "Similar identities", rating: 4.85 },
      { who: "All perspectives", rating: 4.05 },
    ],
    lat: 60.37784472075576,
    lng: 0.22475438962279704,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3078",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man eats a tower lazily. The cat looks at the cake gracefully. A dog jumps over the horizon happily.",
  },
  {
    locationId: "item21079",
    locationName: "item21079",
    locationAddress: "item21079",
    ratings: [
      { who: "Similar identities", rating: 1.6 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 59.77195991435876,
    lng: 0.3105817486038518,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3079",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat eats a tower quickly. The cat jumps over the cake angrily. A dog looks at a book silently. The teacher eats a tower angrily. The man eats the horizon gracefully.",
  },
  {
    locationId: "item21080",
    locationName: "item21080",
    locationAddress: "item21080",
    ratings: null,
    lat: 55.18148259459394,
    lng: -0.31067295736447065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3080",
    tags: [],
    locationDescription:
      " The student eats a fence gracefully. The student writes the horizon quickly. A woman builds the road lazily. The cat jumps over the road angrily. The student runs towards the cake lazily.",
  },
  {
    locationId: "item21081",
    locationName: "item21081",
    locationAddress: "item21081",
    ratings: null,
    lat: 52.966934707603116,
    lng: -5.9341509702614506,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3081",
    tags: [],
    locationDescription:
      " The student builds the cake gracefully. A dog looks at a book happily. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item21082",
    locationName: "item21082",
    locationAddress: "item21082",
    ratings: null,
    lat: 54.54272206210194,
    lng: -5.840633882635978,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3082",
    tags: [],
    locationDescription:
      " A dog jumps over the road happily. The cat writes the horizon angrily. The teacher eats the horizon gracefully. The student looks at a tower angrily. The student builds the horizon silently.",
  },
  {
    locationId: "item21083",
    locationName: "item21083",
    locationAddress: "item21083",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 4.0 },
    ],
    lat: 59.6429643266774,
    lng: -0.8216420122298151,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3083",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog eats a book quickly. A woman builds a fence silently. The cat builds the horizon lazily. A woman builds a tower angrily.",
  },
  {
    locationId: "item21084",
    locationName: "item21084",
    locationAddress: "item21084",
    ratings: [
      { who: "Similar identities", rating: 1.46 },
      { who: "All perspectives", rating: 2.13 },
    ],
    lat: 60.158714205402305,
    lng: 0.7960727598701371,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3084",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher builds a book quickly. The man writes the horizon angrily. A woman runs towards a fence happily. The man runs towards the cake angrily.",
  },
  {
    locationId: "item21085",
    locationName: "item21085",
    locationAddress: "item21085",
    ratings: null,
    lat: 54.80649149076067,
    lng: -3.260865100822711,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3085",
    tags: [],
    locationDescription:
      " A dog looks at a fence lazily. A dog looks at a tower happily. A woman eats the cake silently.",
  },
  {
    locationId: "item21086",
    locationName: "item21086",
    locationAddress: "item21086",
    ratings: null,
    lat: 53.316433878697325,
    lng: -2.5917689911602944,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3086",
    tags: [],
    locationDescription:
      " A dog writes the horizon silently. The teacher looks at a fence silently. A dog builds the horizon gracefully. A woman writes the road gracefully. A woman looks at a tower lazily.",
  },
  {
    locationId: "item21087",
    locationName: "item21087",
    locationAddress: "item21087",
    ratings: [
      { who: "Similar identities", rating: 1.45 },
      { who: "All perspectives", rating: 2.9 },
    ],
    lat: 60.341906869742836,
    lng: -3.559484813331176,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3087",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog eats a tower silently. The teacher writes the cake lazily. The teacher eats the horizon silently.",
  },
  {
    locationId: "item21088",
    locationName: "item21088",
    locationAddress: "item21088",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 4.63 },
    ],
    lat: 55.97184272437932,
    lng: -5.384789762535208,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3088",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A dog builds a book happily.",
  },
  {
    locationId: "item21089",
    locationName: "item21089",
    locationAddress: "item21089",
    ratings: null,
    lat: 51.208997984740705,
    lng: 0.028685148825090323,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3089",
    tags: [],
    locationDescription:
      " A woman looks at a book angrily. The man runs towards a tower quickly. A dog looks at the road gracefully. The cat builds the cake quickly. A woman runs towards the road angrily.",
  },
  {
    locationId: "item21090",
    locationName: "item21090",
    locationAddress: "item21090",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 53.78566800837059,
    lng: -8.557193426055811,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3090",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a book lazily. The cat looks at a fence gracefully.",
  },
  {
    locationId: "item21091",
    locationName: "item21091",
    locationAddress: "item21091",
    ratings: null,
    lat: 59.519925838600464,
    lng: -0.4055445639592907,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3091",
    tags: [],
    locationDescription:
      " A dog writes a fence happily. The student looks at the cake quickly.",
  },
  {
    locationId: "item21092",
    locationName: "item21092",
    locationAddress: "item21092",
    ratings: null,
    lat: 51.75819472301438,
    lng: 1.4499230899447486,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3092",
    tags: [],
    locationDescription: " A dog runs towards the road happily.",
  },
  {
    locationId: "item21093",
    locationName: "item21093",
    locationAddress: "item21093",
    ratings: null,
    lat: 59.85909265504797,
    lng: 0.4510262572915362,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3093",
    tags: [],
    locationDescription:
      " The man writes the cake quickly. The cat builds a book happily.",
  },
  {
    locationId: "item21094",
    locationName: "item21094",
    locationAddress: "item21094",
    ratings: null,
    lat: 56.07815612219876,
    lng: 0.1438344179101243,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3094",
    tags: [],
    locationDescription:
      " The teacher eats a book silently. The cat looks at a fence lazily.",
  },
  {
    locationId: "item21095",
    locationName: "item21095",
    locationAddress: "item21095",
    ratings: null,
    lat: 57.78547557778526,
    lng: 1.2706145546751593,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3095",
    tags: [],
    locationDescription:
      " The man builds a book angrily. The cat jumps over the cake gracefully. The cat looks at the horizon angrily. The student looks at the cake gracefully.",
  },
  {
    locationId: "item21096",
    locationName: "item21096",
    locationAddress: "item21096",
    ratings: null,
    lat: 58.10878818513736,
    lng: -7.163159112767689,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3096",
    tags: [],
    locationDescription: " A dog builds a tower happily.",
  },
  {
    locationId: "item21097",
    locationName: "item21097",
    locationAddress: "item21097",
    ratings: null,
    lat: 59.028193867621454,
    lng: -6.698072053465289,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3097",
    tags: [],
    locationDescription:
      " The teacher builds the road silently. The cat jumps over the road silently. The man eats a book happily. A dog eats the cake silently.",
  },
  {
    locationId: "item21098",
    locationName: "item21098",
    locationAddress: "item21098",
    ratings: [
      { who: "Similar identities", rating: 3.79 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 54.97313146432989,
    lng: -6.6335355433085255,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3098",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat jumps over a fence quickly.",
  },
  {
    locationId: "item21099",
    locationName: "item21099",
    locationAddress: "item21099",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 50.035859026323486,
    lng: -5.2472335991518975,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3099",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat builds the cake gracefully. A woman jumps over a tower gracefully.",
  },
  {
    locationId: "item21100",
    locationName: "item21100",
    locationAddress: "item21100",
    ratings: null,
    lat: 52.07372961599009,
    lng: -8.043735164473201,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3100",
    tags: [],
    locationDescription:
      " The man builds a tower quickly. The man eats a fence gracefully.",
  },
  {
    locationId: "item21101",
    locationName: "item21101",
    locationAddress: "item21101",
    ratings: [
      { who: "Similar identities", rating: 2.08 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 54.408859152986835,
    lng: 0.978448488468942,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3101",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at a tower gracefully. A dog builds the horizon angrily. A dog runs towards the horizon quickly. A dog writes a book silently. The student jumps over a tower angrily.",
  },
  {
    locationId: "item21102",
    locationName: "item21102",
    locationAddress: "item21102",
    ratings: null,
    lat: 59.43481123181151,
    lng: -4.293200290287693,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3102",
    tags: [],
    locationDescription: " The teacher writes the horizon quickly.",
  },
  {
    locationId: "item21103",
    locationName: "item21103",
    locationAddress: "item21103",
    ratings: [
      { who: "Similar identities", rating: 3.3 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 55.461729119573356,
    lng: -0.2067161924213181,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3103",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog writes a tower silently. A woman writes a fence angrily. The student writes the cake angrily.",
  },
  {
    locationId: "item21104",
    locationName: "item21104",
    locationAddress: "item21104",
    ratings: [
      { who: "Similar identities", rating: 0.66 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 57.62339968280691,
    lng: -4.561151723777572,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3104",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat builds the road silently.",
  },
  {
    locationId: "item21105",
    locationName: "item21105",
    locationAddress: "item21105",
    ratings: null,
    lat: 55.77894610874154,
    lng: -1.1769237343172714,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3105",
    tags: [],
    locationDescription:
      " A dog eats the cake quickly. A dog looks at the road silently. A dog eats the road lazily. The student eats a tower angrily.",
  },
  {
    locationId: "item21106",
    locationName: "item21106",
    locationAddress: "item21106",
    ratings: [
      { who: "Similar identities", rating: 2.35 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 53.34546414948868,
    lng: -5.392901995263288,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3106",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds the horizon quickly. The teacher eats a tower silently.",
  },
  {
    locationId: "item21107",
    locationName: "item21107",
    locationAddress: "item21107",
    ratings: [
      { who: "Similar identities", rating: 2.61 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 59.457349860404946,
    lng: -3.8724129318137637,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item3107",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student looks at the horizon angrily. A dog looks at a tower angrily.",
  },
  {
    locationId: "item21108",
    locationName: "item21108",
    locationAddress: "item21108",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 53.1133631154764,
    lng: -1.5218147030257017,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3108",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog eats the cake angrily. A dog looks at a book silently. A dog jumps over a tower quickly.",
  },
  {
    locationId: "item21109",
    locationName: "item21109",
    locationAddress: "item21109",
    ratings: [
      { who: "Similar identities", rating: 3.74 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 52.971356092292034,
    lng: -1.5297186984092441,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3109",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item21110",
    locationName: "item21110",
    locationAddress: "item21110",
    ratings: null,
    lat: 58.972372247472215,
    lng: -0.35150684392477594,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3110",
    tags: [],
    locationDescription:
      " The student builds the horizon lazily. A dog runs towards the horizon lazily. The teacher looks at a fence happily. The man builds the horizon quickly. The student writes a book silently.",
  },
  {
    locationId: "item21111",
    locationName: "item21111",
    locationAddress: "item21111",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 2.85 },
    ],
    lat: 56.677971796208226,
    lng: -7.79210536159691,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3111",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog eats the horizon quickly. The student writes the cake angrily. The cat looks at the horizon quickly. A dog eats a fence quickly. A dog eats a book quickly.",
  },
  {
    locationId: "item21112",
    locationName: "item21112",
    locationAddress: "item21112",
    ratings: null,
    lat: 53.1843699303455,
    lng: -0.20295586146035305,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3112",
    tags: [],
    locationDescription:
      " The student jumps over a tower quickly. A dog looks at a tower lazily. A dog builds a fence quickly.",
  },
  {
    locationId: "item21113",
    locationName: "item21113",
    locationAddress: "item21113",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 50.514101311887075,
    lng: -7.162095630014454,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3113",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher builds the cake happily. The student looks at the horizon lazily. The man eats a book happily. The teacher eats the horizon lazily.",
  },
  {
    locationId: "item21114",
    locationName: "item21114",
    locationAddress: "item21114",
    ratings: null,
    lat: 52.79655219617497,
    lng: -3.450488319886536,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3114",
    tags: [],
    locationDescription:
      " The cat builds a tower lazily. A woman builds a book quickly.",
  },
  {
    locationId: "item21115",
    locationName: "item21115",
    locationAddress: "item21115",
    ratings: null,
    lat: 60.64761546320159,
    lng: 1.1527183794731588,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3115",
    tags: [],
    locationDescription:
      " The student runs towards the road quickly. The student builds a tower silently. A woman looks at the road gracefully.",
  },
  {
    locationId: "item21116",
    locationName: "item21116",
    locationAddress: "item21116",
    ratings: null,
    lat: 58.88067395441007,
    lng: -1.7976565466779144,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3116",
    tags: [],
    locationDescription:
      " A dog eats a book quickly. The student builds the road gracefully. The cat eats a fence gracefully.",
  },
  {
    locationId: "item21117",
    locationName: "item21117",
    locationAddress: "item21117",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 4.86 },
    ],
    lat: 58.94796956742335,
    lng: -4.800645116478238,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3117",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man writes a book silently. A woman builds a book gracefully. The man jumps over the cake angrily. The student runs towards the cake silently. The cat builds a book gracefully.",
  },
  {
    locationId: "item21118",
    locationName: "item21118",
    locationAddress: "item21118",
    ratings: [
      { who: "Similar identities", rating: 4.92 },
      { who: "All perspectives", rating: 1.23 },
    ],
    lat: 57.52836274570182,
    lng: 0.05613956637530748,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3118",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes a fence happily. A woman eats the road angrily. The student runs towards the cake gracefully.",
  },
  {
    locationId: "item21119",
    locationName: "item21119",
    locationAddress: "item21119",
    ratings: null,
    lat: 57.74322493980827,
    lng: -0.735844423320648,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3119",
    tags: [],
    locationDescription:
      " The cat builds a tower happily. The man jumps over the horizon lazily. The cat runs towards the cake quickly. A dog eats a tower lazily. The student eats a book lazily.",
  },
  {
    locationId: "item21120",
    locationName: "item21120",
    locationAddress: "item21120",
    ratings: null,
    lat: 51.45354809780543,
    lng: -0.7178377708253239,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3120",
    tags: [],
    locationDescription:
      " A dog runs towards the cake happily. A woman jumps over the horizon happily. The teacher writes a tower gracefully. A woman runs towards a tower lazily. The cat eats a book gracefully.",
  },
  {
    locationId: "item21121",
    locationName: "item21121",
    locationAddress: "item21121",
    ratings: null,
    lat: 55.79733372239713,
    lng: 0.6656226445578461,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3121",
    tags: [],
    locationDescription:
      " The cat writes the cake happily. The teacher writes a fence silently. The student looks at the cake gracefully.",
  },
  {
    locationId: "item21122",
    locationName: "item21122",
    locationAddress: "item21122",
    ratings: null,
    lat: 57.62332202958933,
    lng: -7.915430862489604,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3122",
    tags: [],
    locationDescription:
      " The student jumps over a fence quickly. The teacher looks at the road silently. The cat builds the road angrily. A woman eats the cake angrily.",
  },
  {
    locationId: "item21123",
    locationName: "item21123",
    locationAddress: "item21123",
    ratings: null,
    lat: 57.32049995255033,
    lng: -5.089256172628989,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3123",
    tags: [],
    locationDescription:
      " The cat jumps over a tower happily. The student eats the cake gracefully. The teacher eats the road happily. A woman looks at a book lazily.",
  },
  {
    locationId: "item21124",
    locationName: "item21124",
    locationAddress: "item21124",
    ratings: null,
    lat: 49.9434427800722,
    lng: -7.66476801996156,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3124",
    tags: [],
    locationDescription:
      " The student writes the road silently. A woman jumps over a tower angrily. The student runs towards the horizon lazily.",
  },
  {
    locationId: "item21125",
    locationName: "item21125",
    locationAddress: "item21125",
    ratings: null,
    lat: 58.14077363998308,
    lng: -5.89978315068011,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3125",
    tags: [],
    locationDescription:
      " The student eats a tower gracefully. The teacher writes the horizon lazily. The cat eats the horizon lazily. The teacher jumps over a fence angrily. The man builds a fence silently.",
  },
  {
    locationId: "item21126",
    locationName: "item21126",
    locationAddress: "item21126",
    ratings: [
      { who: "Similar identities", rating: 1.53 },
      { who: "All perspectives", rating: 0.36 },
    ],
    lat: 54.78539591637274,
    lng: -6.339730050717314,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3126",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat runs towards the horizon gracefully. The cat eats a book lazily.",
  },
  {
    locationId: "item21127",
    locationName: "item21127",
    locationAddress: "item21127",
    ratings: [
      { who: "Similar identities", rating: 1.67 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 54.879324632353246,
    lng: 1.7181363400051435,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3127",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The student writes the horizon angrily. The teacher writes the cake happily. The cat writes the horizon happily. The man runs towards a book gracefully.",
  },
  {
    locationId: "item21128",
    locationName: "item21128",
    locationAddress: "item21128",
    ratings: [
      { who: "Similar identities", rating: 4.16 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 54.60632994130062,
    lng: -0.38937210181729043,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3128",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog runs towards a tower gracefully. The cat builds the horizon quickly. The man builds the road gracefully. A woman eats the horizon lazily.",
  },
  {
    locationId: "item21129",
    locationName: "item21129",
    locationAddress: "item21129",
    ratings: [
      { who: "Similar identities", rating: 4.4 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 55.42839679810474,
    lng: -0.8158430633476392,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3129",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at a tower angrily. The student writes the cake silently.",
  },
  {
    locationId: "item21130",
    locationName: "item21130",
    locationAddress: "item21130",
    ratings: [
      { who: "Similar identities", rating: 3.09 },
      { who: "All perspectives", rating: 4.67 },
    ],
    lat: 55.847545807584886,
    lng: -6.95521578028927,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3130",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The cat looks at a fence quickly. A dog eats the cake lazily.",
  },
  {
    locationId: "item21131",
    locationName: "item21131",
    locationAddress: "item21131",
    ratings: null,
    lat: 58.286517268448634,
    lng: -8.064248985336425,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3131",
    tags: [],
    locationDescription:
      " A dog eats a fence happily. The cat runs towards a fence quickly.",
  },
  {
    locationId: "item21132",
    locationName: "item21132",
    locationAddress: "item21132",
    ratings: null,
    lat: 52.05034487645366,
    lng: -0.8120104643553487,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3132",
    tags: [],
    locationDescription: " A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item21133",
    locationName: "item21133",
    locationAddress: "item21133",
    ratings: null,
    lat: 60.30659046971443,
    lng: 0.8011151261119718,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3133",
    tags: [],
    locationDescription:
      " A dog eats a fence lazily. The man looks at a book angrily. The cat runs towards the horizon lazily. The student jumps over a tower angrily.",
  },
  {
    locationId: "item21134",
    locationName: "item21134",
    locationAddress: "item21134",
    ratings: null,
    lat: 57.72421512916766,
    lng: -2.121108665954713,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3134",
    tags: [],
    locationDescription:
      " The student jumps over a tower gracefully. The man writes the road quickly.",
  },
  {
    locationId: "item21135",
    locationName: "item21135",
    locationAddress: "item21135",
    ratings: [
      { who: "Similar identities", rating: 4.84 },
      { who: "All perspectives", rating: 2.54 },
    ],
    lat: 55.943644328949325,
    lng: 1.6047395429837827,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3135",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes a tower angrily. The man looks at the road gracefully. The student looks at a book lazily. The man looks at a fence gracefully.",
  },
  {
    locationId: "item21136",
    locationName: "item21136",
    locationAddress: "item21136",
    ratings: [
      { who: "Similar identities", rating: 3.4 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 50.597432306215225,
    lng: -5.254870486066322,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3136",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The student eats a book angrily.",
  },
  {
    locationId: "item21137",
    locationName: "item21137",
    locationAddress: "item21137",
    ratings: null,
    lat: 56.04979490744019,
    lng: 0.9673052721728119,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3137",
    tags: [],
    locationDescription:
      " The student eats the road angrily. A dog writes the cake gracefully. The cat looks at a book quickly.",
  },
  {
    locationId: "item21138",
    locationName: "item21138",
    locationAddress: "item21138",
    ratings: null,
    lat: 59.78059897076012,
    lng: -3.4065119240272113,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3138",
    tags: [],
    locationDescription:
      " The man builds the horizon gracefully. The student runs towards the road angrily.",
  },
  {
    locationId: "item21139",
    locationName: "item21139",
    locationAddress: "item21139",
    ratings: null,
    lat: 55.19600202873063,
    lng: -3.7917147350343665,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3139",
    tags: [],
    locationDescription:
      " The student builds a fence gracefully. The cat eats the road angrily.",
  },
  {
    locationId: "item21140",
    locationName: "item21140",
    locationAddress: "item21140",
    ratings: null,
    lat: 52.84495552392142,
    lng: -8.364915946408669,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3140",
    tags: [],
    locationDescription:
      " A woman runs towards a tower silently. The teacher jumps over a tower quickly. The student runs towards a book happily.",
  },
  {
    locationId: "item21141",
    locationName: "item21141",
    locationAddress: "item21141",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 57.533396036407375,
    lng: 0.1222019932256142,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3141",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A dog runs towards a tower gracefully. The teacher jumps over a book silently. A dog runs towards a fence silently.",
  },
  {
    locationId: "item21142",
    locationName: "item21142",
    locationAddress: "item21142",
    ratings: null,
    lat: 59.1715912736336,
    lng: -8.205073441860764,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3142",
    tags: [],
    locationDescription:
      " The student looks at the horizon happily. A dog jumps over a fence lazily. The cat looks at a book happily.",
  },
  {
    locationId: "item21143",
    locationName: "item21143",
    locationAddress: "item21143",
    ratings: [
      { who: "Similar identities", rating: 2.72 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 58.33804383238863,
    lng: -4.43808788950672,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3143",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat eats the road lazily. A dog builds a fence gracefully. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item21144",
    locationName: "item21144",
    locationAddress: "item21144",
    ratings: null,
    lat: 55.07448441285328,
    lng: -6.041997931815104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3144",
    tags: [],
    locationDescription:
      " The cat eats a fence gracefully. The teacher looks at a book quickly.",
  },
  {
    locationId: "item21145",
    locationName: "item21145",
    locationAddress: "item21145",
    ratings: [
      { who: "Similar identities", rating: 4.08 },
      { who: "All perspectives", rating: 1.46 },
    ],
    lat: 50.07704635822654,
    lng: -2.442871035579233,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3145",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the cake quickly. The student looks at a book quickly. A dog jumps over a book quickly. The student jumps over a tower silently.",
  },
  {
    locationId: "item21146",
    locationName: "item21146",
    locationAddress: "item21146",
    ratings: [
      { who: "Similar identities", rating: 4.58 },
      { who: "All perspectives", rating: 1.9 },
    ],
    lat: 55.05827449859464,
    lng: 0.6616002942899648,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3146",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a tower gracefully. The teacher looks at the road happily. The student runs towards a tower angrily. A dog runs towards the horizon silently.",
  },
  {
    locationId: "item21147",
    locationName: "item21147",
    locationAddress: "item21147",
    ratings: null,
    lat: 54.28453502760017,
    lng: -4.187440585523916,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3147",
    tags: [],
    locationDescription:
      " The student runs towards a book angrily. The teacher looks at the cake lazily. The man writes a fence silently. A dog looks at the cake lazily. A woman runs towards the road lazily.",
  },
  {
    locationId: "item21148",
    locationName: "item21148",
    locationAddress: "item21148",
    ratings: [
      { who: "Similar identities", rating: 4.51 },
      { who: "All perspectives", rating: 2.07 },
    ],
    lat: 53.194834006361134,
    lng: -7.741931122877978,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3148",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The cat looks at the cake happily.",
  },
  {
    locationId: "item21149",
    locationName: "item21149",
    locationAddress: "item21149",
    ratings: [
      { who: "Similar identities", rating: 2.58 },
      { who: "All perspectives", rating: 1.61 },
    ],
    lat: 52.69949651084502,
    lng: 0.8893616288712778,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3149",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man writes the cake gracefully. The student looks at a tower quickly. The cat writes the horizon quickly. The teacher writes the cake lazily.",
  },
  {
    locationId: "item21150",
    locationName: "item21150",
    locationAddress: "item21150",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 4.11 },
    ],
    lat: 59.087942332699726,
    lng: -8.237405445552541,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3150",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man runs towards the horizon silently. The teacher writes a book angrily.",
  },
  {
    locationId: "item21151",
    locationName: "item21151",
    locationAddress: "item21151",
    ratings: null,
    lat: 54.660817124467236,
    lng: -7.828446594877813,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3151",
    tags: [],
    locationDescription:
      " The student jumps over a fence happily. The cat builds the road gracefully. A dog looks at a book angrily. A dog writes a book lazily. The man runs towards a book happily.",
  },
  {
    locationId: "item21152",
    locationName: "item21152",
    locationAddress: "item21152",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 4.13 },
    ],
    lat: 51.16708635038541,
    lng: -4.219261291607821,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3152",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man builds the cake lazily. The man builds a fence happily. The teacher runs towards a tower happily.",
  },
  {
    locationId: "item21153",
    locationName: "item21153",
    locationAddress: "item21153",
    ratings: null,
    lat: 51.50895718722424,
    lng: -2.9521952180175655,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3153",
    tags: [],
    locationDescription: " A dog jumps over a book quickly.",
  },
  {
    locationId: "item21154",
    locationName: "item21154",
    locationAddress: "item21154",
    ratings: null,
    lat: 52.85575035405309,
    lng: 0.12526263703428953,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3154",
    tags: [],
    locationDescription:
      " A dog writes a tower angrily. The cat eats a tower lazily. The man writes a tower silently.",
  },
  {
    locationId: "item21155",
    locationName: "item21155",
    locationAddress: "item21155",
    ratings: null,
    lat: 52.40805439613355,
    lng: -7.876316985647882,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3155",
    tags: [],
    locationDescription:
      " The student writes a fence gracefully. The cat eats a fence happily. A woman looks at the road lazily. A dog eats a fence lazily.",
  },
  {
    locationId: "item21156",
    locationName: "item21156",
    locationAddress: "item21156",
    ratings: null,
    lat: 58.31640451484196,
    lng: 0.8404181699860338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3156",
    tags: [],
    locationDescription: " A woman eats a fence gracefully.",
  },
  {
    locationId: "item21157",
    locationName: "item21157",
    locationAddress: "item21157",
    ratings: null,
    lat: 57.07563112295276,
    lng: -1.3098972312211492,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3157",
    tags: [],
    locationDescription:
      " The teacher builds a tower silently. The man runs towards a tower happily. The student writes a fence gracefully.",
  },
  {
    locationId: "item21158",
    locationName: "item21158",
    locationAddress: "item21158",
    ratings: [
      { who: "Similar identities", rating: 0.21 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 53.62301769485327,
    lng: -4.038205760196055,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3158",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes the cake happily. A woman runs towards a tower gracefully.",
  },
  {
    locationId: "item21159",
    locationName: "item21159",
    locationAddress: "item21159",
    ratings: null,
    lat: 57.54830308361381,
    lng: -1.101659900095325,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3159",
    tags: [],
    locationDescription:
      " The cat looks at a tower lazily. A dog eats the cake quickly. A woman writes a fence gracefully. A dog writes the cake lazily.",
  },
  {
    locationId: "item21160",
    locationName: "item21160",
    locationAddress: "item21160",
    ratings: null,
    lat: 56.05184512887754,
    lng: -0.2548064946487507,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3160",
    tags: [],
    locationDescription:
      " A dog runs towards the cake quickly. A woman builds the cake gracefully. A woman jumps over the road lazily. The student builds the cake quickly. The student builds the cake lazily.",
  },
  {
    locationId: "item21161",
    locationName: "item21161",
    locationAddress: "item21161",
    ratings: [
      { who: "Similar identities", rating: 2.76 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 54.960923355483146,
    lng: -0.4408334808540957,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3161",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog jumps over a book lazily. The man builds a tower silently. The man runs towards the cake silently. The student jumps over the horizon happily. A woman builds the cake gracefully.",
  },
  {
    locationId: "item21162",
    locationName: "item21162",
    locationAddress: "item21162",
    ratings: null,
    lat: 57.532763785065804,
    lng: -4.357783929919256,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3162",
    tags: [],
    locationDescription:
      " The cat builds a book angrily. The cat jumps over a fence angrily.",
  },
  {
    locationId: "item21163",
    locationName: "item21163",
    locationAddress: "item21163",
    ratings: [
      { who: "Similar identities", rating: 0.29 },
      { who: "All perspectives", rating: 1.99 },
    ],
    lat: 59.08880342180827,
    lng: -3.212127459810082,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3163",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes the horizon happily. The student eats the horizon angrily. The man eats a tower quickly. The student looks at the horizon happily.",
  },
  {
    locationId: "item21164",
    locationName: "item21164",
    locationAddress: "item21164",
    ratings: null,
    lat: 56.56463850996699,
    lng: -5.954870977777491,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3164",
    tags: [],
    locationDescription:
      " A dog eats a tower quickly. The student jumps over a tower lazily. The man looks at the cake quickly. A dog builds a fence silently.",
  },
  {
    locationId: "item21165",
    locationName: "item21165",
    locationAddress: "item21165",
    ratings: null,
    lat: 54.534847681000905,
    lng: 1.2243925358064747,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3165",
    tags: [],
    locationDescription: " The cat runs towards the horizon angrily.",
  },
  {
    locationId: "item21166",
    locationName: "item21166",
    locationAddress: "item21166",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 58.66119941693277,
    lng: -2.2353638896306958,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3166",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The man builds the horizon gracefully.",
  },
  {
    locationId: "item21167",
    locationName: "item21167",
    locationAddress: "item21167",
    ratings: [
      { who: "Similar identities", rating: 4.05 },
      { who: "All perspectives", rating: 3.68 },
    ],
    lat: 56.937710456187034,
    lng: -0.14976567260676,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3167",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog builds the horizon quickly. The man looks at a book quickly. The cat looks at the horizon angrily. The student builds the horizon lazily. The student writes the horizon quickly.",
  },
  {
    locationId: "item21168",
    locationName: "item21168",
    locationAddress: "item21168",
    ratings: [
      { who: "Similar identities", rating: 4.71 },
      { who: "All perspectives", rating: 0.1 },
    ],
    lat: 57.58231399396021,
    lng: -7.076537276877864,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3168",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man jumps over the cake angrily. The man writes a fence happily. A dog eats a tower angrily. The teacher writes a fence gracefully. A dog writes a tower lazily.",
  },
  {
    locationId: "item21169",
    locationName: "item21169",
    locationAddress: "item21169",
    ratings: null,
    lat: 57.94752910944644,
    lng: -0.03641463433729619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3169",
    tags: [],
    locationDescription:
      " The teacher writes the cake gracefully. The cat looks at a tower lazily. The cat jumps over the road gracefully.",
  },
  {
    locationId: "item21170",
    locationName: "item21170",
    locationAddress: "item21170",
    ratings: [
      { who: "Similar identities", rating: 3.59 },
      { who: "All perspectives", rating: 4.3 },
    ],
    lat: 57.34955729518418,
    lng: -4.797228832688842,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3170",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes a book angrily. The teacher eats the road happily. The man looks at a fence gracefully. The cat eats a tower quickly. The teacher eats the horizon angrily.",
  },
  {
    locationId: "item21171",
    locationName: "item21171",
    locationAddress: "item21171",
    ratings: [
      { who: "Similar identities", rating: 4.86 },
      { who: "All perspectives", rating: 1.27 },
    ],
    lat: 55.32491848416202,
    lng: -3.859162408992522,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3171",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the road quickly. A dog writes a book gracefully.",
  },
  {
    locationId: "item21172",
    locationName: "item21172",
    locationAddress: "item21172",
    ratings: null,
    lat: 56.36113053630906,
    lng: -6.46355796541755,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3172",
    tags: [],
    locationDescription:
      " The cat looks at the horizon happily. A woman looks at the cake happily. The student writes the road angrily. A woman jumps over the horizon happily. A woman writes a fence happily.",
  },
  {
    locationId: "item21173",
    locationName: "item21173",
    locationAddress: "item21173",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 2.63 },
    ],
    lat: 50.408221019697706,
    lng: -5.052513211910851,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3173",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student eats a tower happily. A woman writes a book silently. The cat jumps over a tower quickly. The man jumps over the cake quickly. The man jumps over a fence angrily.",
  },
  {
    locationId: "item21174",
    locationName: "item21174",
    locationAddress: "item21174",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 1.69 },
    ],
    lat: 51.85879427515293,
    lng: -8.283743041882675,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3174",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat jumps over a fence angrily.",
  },
  {
    locationId: "item21175",
    locationName: "item21175",
    locationAddress: "item21175",
    ratings: null,
    lat: 52.88153917294977,
    lng: -0.8236129699963568,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3175",
    tags: [],
    locationDescription:
      " A dog looks at the cake silently. The teacher writes a fence silently. The teacher writes a tower silently.",
  },
  {
    locationId: "item21176",
    locationName: "item21176",
    locationAddress: "item21176",
    ratings: null,
    lat: 55.7862966078866,
    lng: -4.58208258442422,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3176",
    tags: [],
    locationDescription:
      " The cat writes a book silently. The man writes the cake happily. The man looks at the cake quickly.",
  },
  {
    locationId: "item21177",
    locationName: "item21177",
    locationAddress: "item21177",
    ratings: null,
    lat: 50.28712061129007,
    lng: -5.43397013707204,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3177",
    tags: [],
    locationDescription:
      " A dog writes a book lazily. The cat jumps over a book gracefully. A woman runs towards the horizon angrily. The teacher looks at the horizon gracefully. A woman eats the cake lazily.",
  },
  {
    locationId: "item21178",
    locationName: "item21178",
    locationAddress: "item21178",
    ratings: null,
    lat: 58.620919590334275,
    lng: -4.481750128397804,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3178",
    tags: [],
    locationDescription:
      " A dog looks at the horizon happily. The cat builds a book silently. A woman looks at the cake happily. A dog writes a book gracefully. A dog writes the horizon lazily.",
  },
  {
    locationId: "item21179",
    locationName: "item21179",
    locationAddress: "item21179",
    ratings: null,
    lat: 57.40238629026181,
    lng: -5.677686721225205,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3179",
    tags: [],
    locationDescription:
      " A dog runs towards a book quickly. The teacher jumps over a book angrily. The student writes a tower silently. The student builds the road angrily. The cat builds the horizon lazily.",
  },
  {
    locationId: "item21180",
    locationName: "item21180",
    locationAddress: "item21180",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 50.1781017679567,
    lng: 0.39637564049643004,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3180",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man writes the cake gracefully. The man jumps over a fence quickly.",
  },
  {
    locationId: "item21181",
    locationName: "item21181",
    locationAddress: "item21181",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 0.5 },
    ],
    lat: 50.29770769956651,
    lng: -1.159060201372288,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3181",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The man runs towards the road gracefully.",
  },
  {
    locationId: "item21182",
    locationName: "item21182",
    locationAddress: "item21182",
    ratings: null,
    lat: 59.513790347214695,
    lng: -7.860667739688038,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3182",
    tags: [],
    locationDescription:
      " The man eats the horizon gracefully. A woman builds a fence silently. A woman builds a book angrily.",
  },
  {
    locationId: "item21183",
    locationName: "item21183",
    locationAddress: "item21183",
    ratings: [
      { who: "Similar identities", rating: 0.88 },
      { who: "All perspectives", rating: 1.02 },
    ],
    lat: 59.35082657202524,
    lng: -5.383771443444353,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3183",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats a book happily. A woman builds a tower angrily.",
  },
  {
    locationId: "item21184",
    locationName: "item21184",
    locationAddress: "item21184",
    ratings: null,
    lat: 50.709930551355995,
    lng: -3.9464446474238706,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3184",
    tags: [],
    locationDescription: " A dog builds the cake silently.",
  },
  {
    locationId: "item21185",
    locationName: "item21185",
    locationAddress: "item21185",
    ratings: [
      { who: "Similar identities", rating: 4.93 },
      { who: "All perspectives", rating: 0.97 },
    ],
    lat: 52.01768995448187,
    lng: -0.38224399046980473,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3185",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat jumps over a tower quickly.",
  },
  {
    locationId: "item21186",
    locationName: "item21186",
    locationAddress: "item21186",
    ratings: null,
    lat: 58.192345945883204,
    lng: -4.94208281614177,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3186",
    tags: [],
    locationDescription:
      " The man runs towards the horizon gracefully. The teacher eats a fence happily. A dog jumps over a book lazily. The cat runs towards a fence angrily. The cat looks at a book happily.",
  },
  {
    locationId: "item21187",
    locationName: "item21187",
    locationAddress: "item21187",
    ratings: null,
    lat: 58.46676887287652,
    lng: -2.5107732633798516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3187",
    tags: [],
    locationDescription:
      " A dog jumps over the road quickly. The man builds a tower gracefully.",
  },
  {
    locationId: "item21188",
    locationName: "item21188",
    locationAddress: "item21188",
    ratings: null,
    lat: 50.974340182590474,
    lng: -5.933019605410264,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3188",
    tags: [],
    locationDescription:
      " The teacher eats a book quickly. The teacher eats a book quickly. A dog looks at the cake silently. A woman writes a book silently.",
  },
  {
    locationId: "item21189",
    locationName: "item21189",
    locationAddress: "item21189",
    ratings: null,
    lat: 60.44832075482979,
    lng: -1.672048287841858,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3189",
    tags: [],
    locationDescription: " The cat eats a book angrily.",
  },
  {
    locationId: "item21190",
    locationName: "item21190",
    locationAddress: "item21190",
    ratings: [
      { who: "Similar identities", rating: 0.51 },
      { who: "All perspectives", rating: 0.35 },
    ],
    lat: 55.017818549489185,
    lng: -2.029854218035932,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3190",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman writes the road lazily. The student eats the cake happily. The student looks at a book gracefully. A woman runs towards a tower quickly.",
  },
  {
    locationId: "item21191",
    locationName: "item21191",
    locationAddress: "item21191",
    ratings: [
      { who: "Similar identities", rating: 2.67 },
      { who: "All perspectives", rating: 3.71 },
    ],
    lat: 51.685653777204394,
    lng: -2.4165012240302746,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3191",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog eats a tower silently. A dog looks at a book lazily. A woman eats a fence happily. A dog runs towards the horizon lazily.",
  },
  {
    locationId: "item21192",
    locationName: "item21192",
    locationAddress: "item21192",
    ratings: [
      { who: "Similar identities", rating: 1.26 },
      { who: "All perspectives", rating: 3.91 },
    ],
    lat: 58.42001940291328,
    lng: -0.9857264941870367,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3192",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman builds a tower lazily.",
  },
  {
    locationId: "item21193",
    locationName: "item21193",
    locationAddress: "item21193",
    ratings: null,
    lat: 54.1107304383796,
    lng: -2.7597619009627428,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3193",
    tags: [],
    locationDescription: " The teacher eats a fence quickly.",
  },
  {
    locationId: "item21194",
    locationName: "item21194",
    locationAddress: "item21194",
    ratings: [
      { who: "Similar identities", rating: 1.05 },
      { who: "All perspectives", rating: 1.38 },
    ],
    lat: 57.53656831759029,
    lng: -2.770893748845298,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3194",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man builds the road quickly. A dog looks at the horizon gracefully. A woman builds a tower gracefully.",
  },
  {
    locationId: "item21195",
    locationName: "item21195",
    locationAddress: "item21195",
    ratings: null,
    lat: 51.17020748432674,
    lng: -0.3614848697714983,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3195",
    tags: [],
    locationDescription:
      " The cat builds a fence gracefully. The teacher runs towards the road lazily. A woman builds the horizon quickly. A woman builds a book lazily. A woman builds the cake quickly.",
  },
  {
    locationId: "item21196",
    locationName: "item21196",
    locationAddress: "item21196",
    ratings: [
      { who: "Similar identities", rating: 0.24 },
      { who: "All perspectives", rating: 0.82 },
    ],
    lat: 52.71315830696253,
    lng: -5.069929599042592,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3196",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog looks at a tower quickly. A dog looks at the horizon silently. The cat writes a tower lazily. The man looks at a book quickly.",
  },
  {
    locationId: "item21197",
    locationName: "item21197",
    locationAddress: "item21197",
    ratings: null,
    lat: 56.086123681921556,
    lng: -5.3078350001958805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3197",
    tags: [],
    locationDescription:
      " The student jumps over a fence happily. A woman eats the road lazily. The cat builds the horizon happily.",
  },
  {
    locationId: "item21198",
    locationName: "item21198",
    locationAddress: "item21198",
    ratings: null,
    lat: 57.266559292763034,
    lng: -7.063651575098224,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3198",
    tags: [],
    locationDescription:
      " The teacher jumps over the road angrily. The student writes the cake lazily. The student jumps over a fence silently. The cat jumps over a book silently.",
  },
  {
    locationId: "item21199",
    locationName: "item21199",
    locationAddress: "item21199",
    ratings: [
      { who: "Similar identities", rating: 4.51 },
      { who: "All perspectives", rating: 4.27 },
    ],
    lat: 58.930467076284096,
    lng: -0.7098234989569807,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3199",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over a fence quickly. The teacher jumps over a book angrily. A dog jumps over a tower quickly.",
  },
  {
    locationId: "item21200",
    locationName: "item21200",
    locationAddress: "item21200",
    ratings: null,
    lat: 58.992614163287804,
    lng: -1.6984366053618034,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3200",
    tags: [],
    locationDescription:
      " The teacher looks at a tower angrily. A dog jumps over a book quickly.",
  },
  {
    locationId: "item21201",
    locationName: "item21201",
    locationAddress: "item21201",
    ratings: null,
    lat: 58.47630293836583,
    lng: 0.18074585580361102,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3201",
    tags: [],
    locationDescription:
      " The man writes the cake silently. The student runs towards a tower silently.",
  },
  {
    locationId: "item21202",
    locationName: "item21202",
    locationAddress: "item21202",
    ratings: [
      { who: "Similar identities", rating: 1.8 },
      { who: "All perspectives", rating: 2.55 },
    ],
    lat: 59.504184784494086,
    lng: -4.627743237256814,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3202",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher builds a book angrily. A dog runs towards a fence happily. The teacher eats the road quickly. The student looks at the road happily. The student builds the road angrily.",
  },
  {
    locationId: "item21203",
    locationName: "item21203",
    locationAddress: "item21203",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 4.27 },
    ],
    lat: 52.14152236883757,
    lng: -0.3766998335898126,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3203",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher looks at a book quickly. The cat jumps over a book silently.",
  },
  {
    locationId: "item21204",
    locationName: "item21204",
    locationAddress: "item21204",
    ratings: null,
    lat: 50.791237673869894,
    lng: -5.498104015040173,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3204",
    tags: [],
    locationDescription: " A dog builds a fence lazily.",
  },
  {
    locationId: "item21205",
    locationName: "item21205",
    locationAddress: "item21205",
    ratings: null,
    lat: 54.05875724181623,
    lng: -5.700751327653309,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3205",
    tags: [],
    locationDescription:
      " A dog runs towards the cake lazily. The student builds the cake silently.",
  },
  {
    locationId: "item21206",
    locationName: "item21206",
    locationAddress: "item21206",
    ratings: null,
    lat: 55.72486952421654,
    lng: -8.07953484497405,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3206",
    tags: [],
    locationDescription:
      " A dog writes the horizon silently. A woman jumps over a book gracefully. The cat runs towards the cake gracefully. The man writes the horizon happily. The man writes a fence quickly.",
  },
  {
    locationId: "item21207",
    locationName: "item21207",
    locationAddress: "item21207",
    ratings: null,
    lat: 50.43723443539927,
    lng: -2.4330590658147964,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3207",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. The man runs towards a book quickly. The man jumps over the road silently. A dog writes a tower lazily.",
  },
  {
    locationId: "item21208",
    locationName: "item21208",
    locationAddress: "item21208",
    ratings: [
      { who: "Similar identities", rating: 3.39 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 55.79338529634566,
    lng: -3.290786584412553,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3208",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man builds the cake lazily. The man writes the road happily. A dog looks at the cake gracefully. A dog eats the horizon silently. A dog builds a tower silently.",
  },
  {
    locationId: "item21209",
    locationName: "item21209",
    locationAddress: "item21209",
    ratings: null,
    lat: 55.77796559166826,
    lng: -6.162018004286441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3209",
    tags: [],
    locationDescription:
      " The man runs towards a book quickly. The man writes a book angrily. The cat jumps over the cake gracefully. The teacher writes the road happily. The man writes a fence happily.",
  },
  {
    locationId: "item21210",
    locationName: "item21210",
    locationAddress: "item21210",
    ratings: null,
    lat: 53.91692965937523,
    lng: -6.595011988056459,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3210",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower lazily. A woman writes the cake happily. The teacher eats a tower happily.",
  },
  {
    locationId: "item21211",
    locationName: "item21211",
    locationAddress: "item21211",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 55.66363249961809,
    lng: 1.5763308030050744,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3211",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A woman eats a book quickly. A woman jumps over the road happily. A dog jumps over the road gracefully. The cat jumps over the horizon happily. The student runs towards the horizon silently.",
  },
  {
    locationId: "item21212",
    locationName: "item21212",
    locationAddress: "item21212",
    ratings: null,
    lat: 53.10517013766132,
    lng: 1.791851275394814,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3212",
    tags: [],
    locationDescription:
      " The cat looks at a fence quickly. The man builds the cake lazily. The man runs towards the road gracefully. A woman jumps over the horizon lazily.",
  },
  {
    locationId: "item21213",
    locationName: "item21213",
    locationAddress: "item21213",
    ratings: null,
    lat: 54.06516912549061,
    lng: -7.773821495271268,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3213",
    tags: [],
    locationDescription:
      " The man builds the horizon quickly. A dog looks at a book happily.",
  },
  {
    locationId: "item21214",
    locationName: "item21214",
    locationAddress: "item21214",
    ratings: null,
    lat: 52.58492052413048,
    lng: -5.847810484679281,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3214",
    tags: [],
    locationDescription:
      " The teacher eats the horizon angrily. A dog runs towards a book quickly. The teacher runs towards a fence quickly. The student eats a tower angrily.",
  },
  {
    locationId: "item21215",
    locationName: "item21215",
    locationAddress: "item21215",
    ratings: null,
    lat: 52.6590707590132,
    lng: -4.867736506261563,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3215",
    tags: [],
    locationDescription:
      " A dog runs towards the road lazily. The teacher writes a book happily.",
  },
  {
    locationId: "item21216",
    locationName: "item21216",
    locationAddress: "item21216",
    ratings: [
      { who: "Similar identities", rating: 2.98 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 56.25273163841631,
    lng: 1.3242033050204682,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3216",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat builds a book silently.",
  },
  {
    locationId: "item21217",
    locationName: "item21217",
    locationAddress: "item21217",
    ratings: null,
    lat: 57.01309202182862,
    lng: -6.180599905945673,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3217",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon lazily. A dog looks at a tower angrily.",
  },
  {
    locationId: "item21218",
    locationName: "item21218",
    locationAddress: "item21218",
    ratings: [
      { who: "Similar identities", rating: 4.65 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 60.1666385334954,
    lng: -5.965570603771796,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3218",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat builds the cake quickly. The teacher builds a fence silently. The cat eats the cake gracefully. A dog builds a tower gracefully. The cat looks at the road angrily.",
  },
  {
    locationId: "item21219",
    locationName: "item21219",
    locationAddress: "item21219",
    ratings: null,
    lat: 57.55510541445707,
    lng: -5.889858662142693,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3219",
    tags: [],
    locationDescription:
      " A woman jumps over a book lazily. The teacher builds a book silently.",
  },
  {
    locationId: "item21220",
    locationName: "item21220",
    locationAddress: "item21220",
    ratings: [
      { who: "Similar identities", rating: 3.83 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 52.43281781614518,
    lng: 1.6587939337069795,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3220",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat jumps over the cake angrily. The cat builds the cake silently. The cat runs towards the road angrily. A dog runs towards a book lazily. The teacher builds a book gracefully.",
  },
  {
    locationId: "item21221",
    locationName: "item21221",
    locationAddress: "item21221",
    ratings: null,
    lat: 56.721488577662214,
    lng: -7.678507051325987,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3221",
    tags: [],
    locationDescription:
      " The teacher looks at a fence quickly. The teacher runs towards the horizon gracefully. The teacher builds the cake gracefully. A dog eats the cake angrily. The student runs towards the horizon lazily.",
  },
  {
    locationId: "item21222",
    locationName: "item21222",
    locationAddress: "item21222",
    ratings: null,
    lat: 57.431503508971616,
    lng: -5.752148218269876,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3222",
    tags: [],
    locationDescription:
      " The man eats the horizon happily. The teacher writes the cake gracefully.",
  },
  {
    locationId: "item21223",
    locationName: "item21223",
    locationAddress: "item21223",
    ratings: [
      { who: "Similar identities", rating: 1.38 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 59.3726527569944,
    lng: -6.736879711654725,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3223",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student eats a tower gracefully. The man looks at a book lazily.",
  },
  {
    locationId: "item21224",
    locationName: "item21224",
    locationAddress: "item21224",
    ratings: null,
    lat: 56.94692327020037,
    lng: -5.950137472130191,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3224",
    tags: [],
    locationDescription:
      " The student builds a book angrily. A dog jumps over the road happily. The man looks at a fence quickly. The man writes the horizon quickly. The teacher eats a tower silently.",
  },
  {
    locationId: "item21225",
    locationName: "item21225",
    locationAddress: "item21225",
    ratings: null,
    lat: 52.193694108996844,
    lng: -5.46002221776769,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3225",
    tags: [],
    locationDescription:
      " The cat runs towards a fence gracefully. The teacher looks at a fence lazily. The teacher runs towards a fence quickly.",
  },
  {
    locationId: "item21226",
    locationName: "item21226",
    locationAddress: "item21226",
    ratings: null,
    lat: 52.52453312834579,
    lng: 0.2544779188506894,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3226",
    tags: [],
    locationDescription:
      " A dog eats the road silently. The teacher looks at a book gracefully. A woman jumps over a tower quickly. The student builds a book happily.",
  },
  {
    locationId: "item21227",
    locationName: "item21227",
    locationAddress: "item21227",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 56.852300699132286,
    lng: -0.30478549073037264,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3227",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats a book lazily. A dog writes a book quickly.",
  },
  {
    locationId: "item21228",
    locationName: "item21228",
    locationAddress: "item21228",
    ratings: [
      { who: "Similar identities", rating: 4.37 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 54.767110818861255,
    lng: -1.822316653328599,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3228",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The student writes a book gracefully. The cat eats a fence gracefully. A woman looks at a book lazily. A woman jumps over a fence lazily. The student jumps over a fence silently.",
  },
  {
    locationId: "item21229",
    locationName: "item21229",
    locationAddress: "item21229",
    ratings: [
      { who: "Similar identities", rating: 4.91 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 51.180538875039844,
    lng: -7.059270722561064,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3229",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at a book silently. A dog eats the horizon angrily. The cat builds a tower lazily.",
  },
  {
    locationId: "item21230",
    locationName: "item21230",
    locationAddress: "item21230",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 3.43 },
    ],
    lat: 50.223908545318125,
    lng: -7.831967434876934,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3230",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man jumps over the road silently. A woman jumps over the cake gracefully. The teacher looks at a book lazily. The teacher writes the cake gracefully. The teacher eats the road silently.",
  },
  {
    locationId: "item21231",
    locationName: "item21231",
    locationAddress: "item21231",
    ratings: null,
    lat: 58.38824946790164,
    lng: -5.77843168842265,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3231",
    tags: [],
    locationDescription:
      " The cat jumps over the cake quickly. The student looks at a fence silently. The student looks at the cake quickly. The man writes a tower lazily.",
  },
  {
    locationId: "item21232",
    locationName: "item21232",
    locationAddress: "item21232",
    ratings: null,
    lat: 53.346716141081096,
    lng: -8.516678467383798,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3232",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon lazily. A dog writes the horizon gracefully. The student writes the road gracefully. The student looks at the cake gracefully. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item21233",
    locationName: "item21233",
    locationAddress: "item21233",
    ratings: null,
    lat: 58.1274078953431,
    lng: -5.553114418449855,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3233",
    tags: [],
    locationDescription:
      " A woman builds a book quickly. A dog eats a fence angrily. The cat builds the cake silently.",
  },
  {
    locationId: "item21234",
    locationName: "item21234",
    locationAddress: "item21234",
    ratings: null,
    lat: 55.212202732503656,
    lng: -8.214930215386072,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3234",
    tags: [],
    locationDescription:
      " The student writes the road quickly. The teacher writes the cake gracefully. The teacher looks at the horizon silently.",
  },
  {
    locationId: "item21235",
    locationName: "item21235",
    locationAddress: "item21235",
    ratings: null,
    lat: 56.22954800498609,
    lng: -1.1509129398553668,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3235",
    tags: [],
    locationDescription:
      " The man builds the horizon happily. The cat runs towards a tower happily.",
  },
  {
    locationId: "item21236",
    locationName: "item21236",
    locationAddress: "item21236",
    ratings: null,
    lat: 57.60447854514004,
    lng: -7.932371735630728,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3236",
    tags: [],
    locationDescription:
      " The cat writes a tower silently. The teacher builds a fence gracefully. The student runs towards a fence gracefully. The cat jumps over a book lazily. A woman builds the horizon angrily.",
  },
  {
    locationId: "item21237",
    locationName: "item21237",
    locationAddress: "item21237",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 1.68 },
    ],
    lat: 53.29625075655295,
    lng: 0.21589165753373862,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3237",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat jumps over the cake gracefully. A woman builds a fence angrily. A woman writes a book gracefully. A dog eats the horizon quickly. The man looks at a book silently.",
  },
  {
    locationId: "item21238",
    locationName: "item21238",
    locationAddress: "item21238",
    ratings: null,
    lat: 57.82143034227507,
    lng: -3.204052461910994,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3238",
    tags: [],
    locationDescription: " The cat looks at the road angrily.",
  },
  {
    locationId: "item21239",
    locationName: "item21239",
    locationAddress: "item21239",
    ratings: null,
    lat: 57.84492715306424,
    lng: -7.473575066622591,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3239",
    tags: [],
    locationDescription: " The teacher eats a book angrily.",
  },
  {
    locationId: "item21240",
    locationName: "item21240",
    locationAddress: "item21240",
    ratings: null,
    lat: 49.93908735647581,
    lng: -4.181750319591841,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3240",
    tags: [],
    locationDescription: " The man eats a fence silently.",
  },
  {
    locationId: "item21241",
    locationName: "item21241",
    locationAddress: "item21241",
    ratings: [
      { who: "Similar identities", rating: 1.9 },
      { who: "All perspectives", rating: 2.7 },
    ],
    lat: 55.31708110506075,
    lng: -6.858190108769819,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3241",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher eats a fence angrily. A dog eats the cake silently.",
  },
  {
    locationId: "item21242",
    locationName: "item21242",
    locationAddress: "item21242",
    ratings: null,
    lat: 52.0131101582211,
    lng: -7.3460883217517,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3242",
    tags: [],
    locationDescription:
      " A woman jumps over the road quickly. The teacher jumps over a fence gracefully. A woman jumps over the road quickly. The cat builds the horizon angrily.",
  },
  {
    locationId: "item21243",
    locationName: "item21243",
    locationAddress: "item21243",
    ratings: [
      { who: "Similar identities", rating: 4.83 },
      { who: "All perspectives", rating: 2.96 },
    ],
    lat: 53.83656594309562,
    lng: 1.6164594859621708,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3243",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog runs towards the horizon gracefully. A woman eats a book silently. A woman builds the cake quickly. The student runs towards a tower angrily. The man builds the road lazily.",
  },
  {
    locationId: "item21244",
    locationName: "item21244",
    locationAddress: "item21244",
    ratings: null,
    lat: 57.33998743107587,
    lng: -4.681429397615149,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3244",
    tags: [],
    locationDescription: " The cat builds a fence quickly.",
  },
  {
    locationId: "item21245",
    locationName: "item21245",
    locationAddress: "item21245",
    ratings: null,
    lat: 51.96578846942213,
    lng: -5.185569024954104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3245",
    tags: [],
    locationDescription:
      " A dog builds the horizon happily. The man runs towards a book gracefully. The cat builds a tower silently.",
  },
  {
    locationId: "item21246",
    locationName: "item21246",
    locationAddress: "item21246",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 4.74 },
    ],
    lat: 57.282497054805795,
    lng: -4.565067197373231,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3246",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman runs towards a fence quickly. A woman runs towards a book silently. A woman jumps over the cake happily. The cat eats a book silently. The cat writes a book quickly.",
  },
  {
    locationId: "item21247",
    locationName: "item21247",
    locationAddress: "item21247",
    ratings: null,
    lat: 57.324052571722596,
    lng: -3.494168069904795,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3247",
    tags: [],
    locationDescription:
      " The cat eats a book quickly. The man eats a fence gracefully. The man looks at a tower angrily. The cat runs towards a book happily. A woman writes the cake happily.",
  },
  {
    locationId: "item21248",
    locationName: "item21248",
    locationAddress: "item21248",
    ratings: [
      { who: "Similar identities", rating: 3.17 },
      { who: "All perspectives", rating: 2.28 },
    ],
    lat: 51.88622802592436,
    lng: -4.874482548777381,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3248",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man eats the horizon quickly. The student runs towards a fence gracefully. The cat eats the cake silently. The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item21249",
    locationName: "item21249",
    locationAddress: "item21249",
    ratings: null,
    lat: 60.27982245320655,
    lng: 0.8256457555946923,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3249",
    tags: [],
    locationDescription:
      " The student looks at the horizon quickly. The man eats the horizon happily. A dog runs towards a fence happily.",
  },
  {
    locationId: "item21250",
    locationName: "item21250",
    locationAddress: "item21250",
    ratings: [
      { who: "Similar identities", rating: 2.71 },
      { who: "All perspectives", rating: 0.63 },
    ],
    lat: 50.87371920648205,
    lng: 0.08707811475588656,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3250",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The teacher looks at a tower lazily. A dog eats the cake quickly. The cat builds a tower quickly.",
  },
  {
    locationId: "item21251",
    locationName: "item21251",
    locationAddress: "item21251",
    ratings: [
      { who: "Similar identities", rating: 3.87 },
      { who: "All perspectives", rating: 2.0 },
    ],
    lat: 54.04186148841367,
    lng: -3.442625869261458,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3251",
    tags: [{ label: "accessible" }],
    locationDescription: " The student writes the road lazily.",
  },
  {
    locationId: "item21252",
    locationName: "item21252",
    locationAddress: "item21252",
    ratings: null,
    lat: 53.17613831951187,
    lng: -7.531641305265945,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3252",
    tags: [],
    locationDescription:
      " The cat builds a tower silently. The man looks at a tower gracefully. The teacher eats the cake gracefully. The student jumps over the horizon angrily.",
  },
  {
    locationId: "item21253",
    locationName: "item21253",
    locationAddress: "item21253",
    ratings: [
      { who: "Similar identities", rating: 3.16 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 53.71959592248827,
    lng: -8.194545315075827,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3253",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards a fence silently. The teacher runs towards a book quickly. The student runs towards the cake happily. A woman builds the horizon silently. A dog looks at the cake angrily.",
  },
  {
    locationId: "item21254",
    locationName: "item21254",
    locationAddress: "item21254",
    ratings: [
      { who: "Similar identities", rating: 3.99 },
      { who: "All perspectives", rating: 4.97 },
    ],
    lat: 52.80831108758494,
    lng: -7.135565339364872,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3254",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards the cake angrily. The teacher builds a book happily. The teacher jumps over the cake happily.",
  },
  {
    locationId: "item21255",
    locationName: "item21255",
    locationAddress: "item21255",
    ratings: [
      { who: "Similar identities", rating: 1.73 },
      { who: "All perspectives", rating: 3.63 },
    ],
    lat: 57.861510505349614,
    lng: 1.0946537620516672,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3255",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The man writes the horizon angrily.",
  },
  {
    locationId: "item21256",
    locationName: "item21256",
    locationAddress: "item21256",
    ratings: null,
    lat: 51.7084405514643,
    lng: 0.6938480225393668,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3256",
    tags: [],
    locationDescription:
      " The student runs towards the cake angrily. The cat builds a fence angrily. The teacher looks at the horizon quickly.",
  },
  {
    locationId: "item21257",
    locationName: "item21257",
    locationAddress: "item21257",
    ratings: [
      { who: "Similar identities", rating: 1.46 },
      { who: "All perspectives", rating: 0.32 },
    ],
    lat: 52.40853443163948,
    lng: -7.9683560260602055,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3257",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at the horizon quickly. The student jumps over the cake lazily. A woman builds a tower gracefully.",
  },
  {
    locationId: "item21258",
    locationName: "item21258",
    locationAddress: "item21258",
    ratings: null,
    lat: 54.450108388779874,
    lng: -6.471189542877694,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3258",
    tags: [],
    locationDescription: " The man runs towards the horizon silently.",
  },
  {
    locationId: "item21259",
    locationName: "item21259",
    locationAddress: "item21259",
    ratings: null,
    lat: 60.63971140789264,
    lng: -4.624402204994863,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3259",
    tags: [],
    locationDescription:
      " The cat writes a fence quickly. The cat jumps over a fence angrily. A woman looks at a book lazily. The teacher writes the horizon silently.",
  },
  {
    locationId: "item21260",
    locationName: "item21260",
    locationAddress: "item21260",
    ratings: [
      { who: "Similar identities", rating: 0.14 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 59.62306296672038,
    lng: -3.5295555488231027,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3260",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes the cake lazily. The student builds a fence silently. A woman looks at a tower lazily.",
  },
  {
    locationId: "item21261",
    locationName: "item21261",
    locationAddress: "item21261",
    ratings: null,
    lat: 54.84318968787534,
    lng: -5.211687661729259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3261",
    tags: [],
    locationDescription:
      " The man looks at a tower silently. The man looks at the cake gracefully. A dog runs towards the horizon angrily.",
  },
  {
    locationId: "item21262",
    locationName: "item21262",
    locationAddress: "item21262",
    ratings: null,
    lat: 50.43468431008662,
    lng: -1.222842085762828,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3262",
    tags: [],
    locationDescription:
      " The man writes the horizon angrily. A woman writes the cake happily. The cat looks at a tower quickly. The cat looks at a tower gracefully.",
  },
  {
    locationId: "item21263",
    locationName: "item21263",
    locationAddress: "item21263",
    ratings: [
      { who: "Similar identities", rating: 4.48 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 55.03084437087633,
    lng: -1.6697883227342114,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3263",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher looks at a fence lazily. A dog builds the cake silently. The cat eats the horizon quickly. The teacher runs towards a tower angrily.",
  },
  {
    locationId: "item21264",
    locationName: "item21264",
    locationAddress: "item21264",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 60.681782088720624,
    lng: -5.819689027299099,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3264",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student writes the horizon gracefully. A woman runs towards the horizon lazily. The cat runs towards a fence gracefully. The student runs towards the cake angrily. A dog looks at a fence angrily.",
  },
  {
    locationId: "item21265",
    locationName: "item21265",
    locationAddress: "item21265",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 2.22 },
    ],
    lat: 52.4160589090279,
    lng: 1.4965163794666125,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3265",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman builds a fence happily. The cat builds the cake quickly. The cat writes the cake silently.",
  },
  {
    locationId: "item21266",
    locationName: "item21266",
    locationAddress: "item21266",
    ratings: null,
    lat: 60.55894235620845,
    lng: -7.79456960973922,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3266",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake gracefully. A woman writes a fence quickly. A dog runs towards a fence gracefully. The teacher builds a fence happily. A woman builds the cake silently.",
  },
  {
    locationId: "item21267",
    locationName: "item21267",
    locationAddress: "item21267",
    ratings: null,
    lat: 59.76067298794277,
    lng: -6.5407130274077785,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3267",
    tags: [],
    locationDescription: " A dog looks at a fence quickly.",
  },
  {
    locationId: "item21268",
    locationName: "item21268",
    locationAddress: "item21268",
    ratings: [
      { who: "Similar identities", rating: 4.99 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 60.08957665835626,
    lng: -0.9705388328097317,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3268",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student looks at a tower happily. A dog looks at a book gracefully. The man looks at the cake happily. A dog eats a book lazily. The man eats a tower lazily.",
  },
  {
    locationId: "item21269",
    locationName: "item21269",
    locationAddress: "item21269",
    ratings: null,
    lat: 56.35491280145088,
    lng: -7.841099355916038,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3269",
    tags: [],
    locationDescription:
      " The man looks at a fence happily. The man runs towards a fence happily.",
  },
  {
    locationId: "item21270",
    locationName: "item21270",
    locationAddress: "item21270",
    ratings: [
      { who: "Similar identities", rating: 3.33 },
      { who: "All perspectives", rating: 3.11 },
    ],
    lat: 54.01959328597618,
    lng: -3.082264840052569,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3270",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " The cat looks at a tower silently.",
  },
  {
    locationId: "item21271",
    locationName: "item21271",
    locationAddress: "item21271",
    ratings: null,
    lat: 51.55861248157865,
    lng: -3.523114313183398,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3271",
    tags: [],
    locationDescription:
      " The student writes the horizon angrily. The student builds a fence happily.",
  },
  {
    locationId: "item21272",
    locationName: "item21272",
    locationAddress: "item21272",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 52.56578475104627,
    lng: -1.4686896613345386,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3272",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog builds the cake happily.",
  },
  {
    locationId: "item21273",
    locationName: "item21273",
    locationAddress: "item21273",
    ratings: [
      { who: "Similar identities", rating: 3.54 },
      { who: "All perspectives", rating: 4.07 },
    ],
    lat: 58.021703486772275,
    lng: -3.350705145885869,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3273",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat runs towards the horizon happily. The teacher jumps over the road silently. The student eats a fence quickly. A dog writes the road quickly. The student runs towards a tower happily.",
  },
  {
    locationId: "item21274",
    locationName: "item21274",
    locationAddress: "item21274",
    ratings: null,
    lat: 55.69369495358859,
    lng: -0.6470262755236096,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3274",
    tags: [],
    locationDescription:
      " The student writes a fence lazily. The student jumps over the horizon lazily. A woman writes the road gracefully. A woman runs towards the cake gracefully.",
  },
  {
    locationId: "item21275",
    locationName: "item21275",
    locationAddress: "item21275",
    ratings: null,
    lat: 54.03981023574366,
    lng: -0.03709619147898735,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3275",
    tags: [],
    locationDescription:
      " A dog runs towards a book happily. The cat eats the road lazily. The student runs towards a book angrily. A dog builds a fence gracefully. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item21276",
    locationName: "item21276",
    locationAddress: "item21276",
    ratings: null,
    lat: 57.907466023499396,
    lng: -4.73911980424231,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3276",
    tags: [],
    locationDescription:
      " A dog writes a tower gracefully. A dog eats the road lazily. A woman eats a fence silently.",
  },
  {
    locationId: "item21277",
    locationName: "item21277",
    locationAddress: "item21277",
    ratings: null,
    lat: 58.53638537887665,
    lng: -6.756459950785192,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3277",
    tags: [],
    locationDescription:
      " The cat runs towards the road happily. The student looks at the road angrily. The man looks at the horizon silently. The teacher looks at a book happily. The man writes a fence angrily.",
  },
  {
    locationId: "item21278",
    locationName: "item21278",
    locationAddress: "item21278",
    ratings: null,
    lat: 59.83819863210249,
    lng: -4.9953599729906895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3278",
    tags: [],
    locationDescription:
      " The student looks at the road angrily. The student builds the horizon lazily.",
  },
  {
    locationId: "item21279",
    locationName: "item21279",
    locationAddress: "item21279",
    ratings: null,
    lat: 56.42631802205104,
    lng: -4.92558199601081,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3279",
    tags: [],
    locationDescription:
      " The teacher eats a fence gracefully. The teacher eats a tower quickly. The man jumps over a book happily. A dog writes the cake silently. A dog looks at the horizon angrily.",
  },
  {
    locationId: "item21280",
    locationName: "item21280",
    locationAddress: "item21280",
    ratings: [
      { who: "Similar identities", rating: 3.62 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 54.127074213930754,
    lng: -0.8256940966478936,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3280",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man runs towards the road gracefully. The cat looks at the horizon lazily.",
  },
  {
    locationId: "item21281",
    locationName: "item21281",
    locationAddress: "item21281",
    ratings: null,
    lat: 54.800018677538326,
    lng: 1.2626333111949375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3281",
    tags: [],
    locationDescription:
      " The man jumps over a book happily. The cat jumps over a tower happily. A woman writes a book quickly.",
  },
  {
    locationId: "item21282",
    locationName: "item21282",
    locationAddress: "item21282",
    ratings: null,
    lat: 50.86962733423202,
    lng: -5.987732491406119,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3282",
    tags: [],
    locationDescription: " The student eats a tower angrily.",
  },
  {
    locationId: "item21283",
    locationName: "item21283",
    locationAddress: "item21283",
    ratings: null,
    lat: 55.80739257825674,
    lng: -6.029894550863741,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3283",
    tags: [],
    locationDescription: " A woman runs towards a fence angrily.",
  },
  {
    locationId: "item21284",
    locationName: "item21284",
    locationAddress: "item21284",
    ratings: null,
    lat: 52.6232322427398,
    lng: -0.9454581925816568,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3284",
    tags: [],
    locationDescription: " A dog runs towards a fence gracefully.",
  },
  {
    locationId: "item21285",
    locationName: "item21285",
    locationAddress: "item21285",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 58.656391673490106,
    lng: -6.797259481992566,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3285",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student eats a book happily. The student runs towards the horizon happily.",
  },
  {
    locationId: "item21286",
    locationName: "item21286",
    locationAddress: "item21286",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 4.35 },
    ],
    lat: 57.969244485722975,
    lng: -8.446776427597671,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3286",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards the horizon angrily. A woman writes the horizon angrily. The man looks at a book quickly.",
  },
  {
    locationId: "item21287",
    locationName: "item21287",
    locationAddress: "item21287",
    ratings: [
      { who: "Similar identities", rating: 3.74 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 52.067845559878805,
    lng: -4.279159200454331,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3287",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student eats a tower silently. The teacher builds a book angrily.",
  },
  {
    locationId: "item21288",
    locationName: "item21288",
    locationAddress: "item21288",
    ratings: null,
    lat: 50.28550895048998,
    lng: -1.1750735970471844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3288",
    tags: [],
    locationDescription:
      " A dog looks at a fence lazily. A dog eats the cake lazily. A woman builds a tower quickly.",
  },
  {
    locationId: "item21289",
    locationName: "item21289",
    locationAddress: "item21289",
    ratings: null,
    lat: 49.901374894673566,
    lng: 1.5775939543827775,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3289",
    tags: [],
    locationDescription: " The student eats the cake lazily.",
  },
  {
    locationId: "item21290",
    locationName: "item21290",
    locationAddress: "item21290",
    ratings: [
      { who: "Similar identities", rating: 1.81 },
      { who: "All perspectives", rating: 1.74 },
    ],
    lat: 58.19596140761199,
    lng: -3.442407898722432,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3290",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds a tower silently. The teacher runs towards the cake lazily. A woman runs towards a tower happily. The man looks at a fence silently.",
  },
  {
    locationId: "item21291",
    locationName: "item21291",
    locationAddress: "item21291",
    ratings: [
      { who: "Similar identities", rating: 4.65 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 57.178308626378495,
    lng: -8.267758458444924,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3291",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " A dog writes the road gracefully.",
  },
  {
    locationId: "item21292",
    locationName: "item21292",
    locationAddress: "item21292",
    ratings: null,
    lat: 54.616998583078804,
    lng: -1.6075778642914065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3292",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon angrily. The man eats the road quickly. The man writes a fence happily. The student writes a tower lazily. A dog eats the horizon lazily.",
  },
  {
    locationId: "item21293",
    locationName: "item21293",
    locationAddress: "item21293",
    ratings: [
      { who: "Similar identities", rating: 3.77 },
      { who: "All perspectives", rating: 0.37 },
    ],
    lat: 60.84563788148922,
    lng: -6.478221490862317,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3293",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats a book gracefully. The cat looks at a fence happily. The man jumps over the cake silently. A dog builds a tower happily.",
  },
  {
    locationId: "item21294",
    locationName: "item21294",
    locationAddress: "item21294",
    ratings: null,
    lat: 57.99610318004375,
    lng: -2.889991867571794,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3294",
    tags: [],
    locationDescription:
      " The man runs towards the cake gracefully. A dog builds the horizon lazily. The student writes a book gracefully. A dog eats the cake silently. The student runs towards a tower happily.",
  },
  {
    locationId: "item21295",
    locationName: "item21295",
    locationAddress: "item21295",
    ratings: null,
    lat: 56.97774668333978,
    lng: -8.415026512091057,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3295",
    tags: [],
    locationDescription: " A dog builds the road lazily.",
  },
  {
    locationId: "item21296",
    locationName: "item21296",
    locationAddress: "item21296",
    ratings: null,
    lat: 50.17512361944149,
    lng: 1.0492608501757932,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3296",
    tags: [],
    locationDescription:
      " A dog eats a book silently. The man looks at a book gracefully.",
  },
  {
    locationId: "item21297",
    locationName: "item21297",
    locationAddress: "item21297",
    ratings: [
      { who: "Similar identities", rating: 4.75 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 52.171616339821234,
    lng: -2.6803026439211637,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3297",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats the horizon quickly. The student jumps over a fence angrily.",
  },
  {
    locationId: "item21298",
    locationName: "item21298",
    locationAddress: "item21298",
    ratings: null,
    lat: 51.02172283224711,
    lng: 1.2844639088726346,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3298",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon lazily. The cat eats the cake angrily. The teacher builds the horizon silently. A woman builds the cake angrily.",
  },
  {
    locationId: "item21299",
    locationName: "item21299",
    locationAddress: "item21299",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 4.68 },
    ],
    lat: 50.31672663776984,
    lng: -5.8659885794487625,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3299",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The man builds the cake quickly.",
  },
  {
    locationId: "item21300",
    locationName: "item21300",
    locationAddress: "item21300",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 53.20331720384376,
    lng: -0.5022067733407205,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3300",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The teacher looks at the cake silently. The cat looks at a book angrily. A dog eats a tower lazily. The man writes a book silently.",
  },
  {
    locationId: "item21301",
    locationName: "item21301",
    locationAddress: "item21301",
    ratings: [
      { who: "Similar identities", rating: 1.62 },
      { who: "All perspectives", rating: 3.72 },
    ],
    lat: 50.077427506704346,
    lng: -5.834975673210647,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3301",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats a book angrily. A woman writes a tower lazily. The teacher eats the horizon gracefully. A dog eats a fence angrily.",
  },
  {
    locationId: "item21302",
    locationName: "item21302",
    locationAddress: "item21302",
    ratings: null,
    lat: 55.02666559281753,
    lng: -0.035383705899009854,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3302",
    tags: [],
    locationDescription: " The cat eats a book silently.",
  },
  {
    locationId: "item21303",
    locationName: "item21303",
    locationAddress: "item21303",
    ratings: null,
    lat: 59.584265400054875,
    lng: -5.602636356709915,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3303",
    tags: [],
    locationDescription:
      " The teacher builds the cake angrily. The teacher looks at a fence happily.",
  },
  {
    locationId: "item21304",
    locationName: "item21304",
    locationAddress: "item21304",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 3.99 },
    ],
    lat: 59.782423602992665,
    lng: -3.0567389261296336,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3304",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes a tower happily. The student jumps over a tower gracefully. A dog jumps over the cake lazily.",
  },
  {
    locationId: "item21305",
    locationName: "item21305",
    locationAddress: "item21305",
    ratings: [
      { who: "Similar identities", rating: 2.29 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 55.67682740571386,
    lng: -1.6218982346083424,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3305",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes a fence lazily. The cat eats a tower lazily. A dog builds the road happily. The man writes the road happily. The teacher jumps over the road silently.",
  },
  {
    locationId: "item21306",
    locationName: "item21306",
    locationAddress: "item21306",
    ratings: null,
    lat: 53.55258039674181,
    lng: -0.29402869347013727,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3306",
    tags: [],
    locationDescription:
      " The teacher builds a tower gracefully. The teacher eats a book angrily. The cat eats a fence gracefully.",
  },
  {
    locationId: "item21307",
    locationName: "item21307",
    locationAddress: "item21307",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 54.114082917457736,
    lng: -2.9038477862981216,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3307",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes a fence lazily. A dog eats a book happily.",
  },
  {
    locationId: "item21308",
    locationName: "item21308",
    locationAddress: "item21308",
    ratings: null,
    lat: 51.73236078271166,
    lng: -3.870315443875679,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3308",
    tags: [],
    locationDescription:
      " A woman writes a book gracefully. The student eats the cake lazily. The man looks at a fence gracefully.",
  },
  {
    locationId: "item21309",
    locationName: "item21309",
    locationAddress: "item21309",
    ratings: null,
    lat: 55.496623943522856,
    lng: -2.320696249504195,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3309",
    tags: [],
    locationDescription: " A woman eats a tower angrily.",
  },
  {
    locationId: "item21310",
    locationName: "item21310",
    locationAddress: "item21310",
    ratings: null,
    lat: 59.30628173512602,
    lng: -0.9592848867945145,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3310",
    tags: [],
    locationDescription:
      " The student looks at a fence lazily. A dog jumps over the cake gracefully.",
  },
  {
    locationId: "item21311",
    locationName: "item21311",
    locationAddress: "item21311",
    ratings: null,
    lat: 50.71065941364096,
    lng: -5.088981252438043,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3311",
    tags: [],
    locationDescription:
      " The teacher jumps over the road angrily. The cat looks at a tower angrily.",
  },
  {
    locationId: "item21312",
    locationName: "item21312",
    locationAddress: "item21312",
    ratings: [
      { who: "Similar identities", rating: 3.09 },
      { who: "All perspectives", rating: 4.7 },
    ],
    lat: 51.733315480131964,
    lng: -1.3299885978291934,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3312",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog jumps over the cake silently. The man jumps over a book gracefully. The teacher runs towards a tower lazily. A woman looks at a book gracefully. The man runs towards a tower angrily.",
  },
  {
    locationId: "item21313",
    locationName: "item21313",
    locationAddress: "item21313",
    ratings: [
      { who: "Similar identities", rating: 0.31 },
      { who: "All perspectives", rating: 0.65 },
    ],
    lat: 54.45928546993764,
    lng: -5.505148753290914,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3313",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman looks at a book silently. The cat looks at a book happily. The cat writes the horizon silently. The student eats the horizon gracefully. The student builds a fence lazily.",
  },
  {
    locationId: "item21314",
    locationName: "item21314",
    locationAddress: "item21314",
    ratings: [
      { who: "Similar identities", rating: 2.53 },
      { who: "All perspectives", rating: 0.86 },
    ],
    lat: 50.89755040856538,
    lng: -7.776341934321465,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3314",
    tags: [{ label: "child friendly" }],
    locationDescription: " The cat jumps over the horizon silently.",
  },
  {
    locationId: "item21315",
    locationName: "item21315",
    locationAddress: "item21315",
    ratings: null,
    lat: 52.16229964145605,
    lng: -8.027550456479187,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3315",
    tags: [],
    locationDescription:
      " The cat looks at a fence silently. A woman jumps over the horizon angrily. The teacher runs towards the horizon happily. The teacher writes the horizon gracefully. The teacher eats a book gracefully.",
  },
  {
    locationId: "item21316",
    locationName: "item21316",
    locationAddress: "item21316",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 54.49146283437046,
    lng: -4.831503933732283,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3316",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman eats a tower lazily. The student runs towards a fence lazily.",
  },
  {
    locationId: "item21317",
    locationName: "item21317",
    locationAddress: "item21317",
    ratings: [
      { who: "Similar identities", rating: 1.9 },
      { who: "All perspectives", rating: 2.12 },
    ],
    lat: 50.404038333530686,
    lng: -2.434954849585157,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3317",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student runs towards the cake lazily. A dog writes a tower lazily. The cat eats a book silently. The man runs towards a book quickly.",
  },
  {
    locationId: "item21318",
    locationName: "item21318",
    locationAddress: "item21318",
    ratings: null,
    lat: 56.476597027749825,
    lng: -2.069711707086743,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3318",
    tags: [],
    locationDescription:
      " The teacher writes a book silently. The teacher jumps over a fence angrily. The student builds a tower gracefully. The teacher jumps over a fence lazily. A dog writes a fence lazily.",
  },
  {
    locationId: "item21319",
    locationName: "item21319",
    locationAddress: "item21319",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 53.49474574067396,
    lng: -5.21419424043011,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3319",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at the horizon gracefully. The student builds the cake silently. The teacher looks at the road angrily. The teacher looks at the cake quickly. A woman runs towards a book gracefully.",
  },
  {
    locationId: "item21320",
    locationName: "item21320",
    locationAddress: "item21320",
    ratings: [
      { who: "Similar identities", rating: 4.54 },
      { who: "All perspectives", rating: 0.7 },
    ],
    lat: 53.25007233926199,
    lng: -6.5477552690548215,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3320",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man jumps over a fence happily.",
  },
  {
    locationId: "item21321",
    locationName: "item21321",
    locationAddress: "item21321",
    ratings: null,
    lat: 56.945233478640006,
    lng: -6.628769012306743,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3321",
    tags: [],
    locationDescription:
      " A dog eats the road silently. A dog eats the road quickly. The teacher eats a fence lazily.",
  },
  {
    locationId: "item21322",
    locationName: "item21322",
    locationAddress: "item21322",
    ratings: [
      { who: "Similar identities", rating: 2.1 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 59.1073790971427,
    lng: -8.287844491059095,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3322",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat jumps over the cake lazily. A dog writes a fence gracefully.",
  },
  {
    locationId: "item21323",
    locationName: "item21323",
    locationAddress: "item21323",
    ratings: [
      { who: "Similar identities", rating: 3.64 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 49.956322961560176,
    lng: -2.438612767489259,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3323",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over a tower silently. The cat runs towards a tower angrily. The student looks at a fence happily. The man eats a book lazily.",
  },
  {
    locationId: "item21324",
    locationName: "item21324",
    locationAddress: "item21324",
    ratings: [
      { who: "Similar identities", rating: 2.54 },
      { who: "All perspectives", rating: 3.89 },
    ],
    lat: 53.691503446288095,
    lng: -6.0601210365717035,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3324",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The student looks at the horizon gracefully. The teacher jumps over the horizon lazily. A dog jumps over a book happily.",
  },
  {
    locationId: "item21325",
    locationName: "item21325",
    locationAddress: "item21325",
    ratings: null,
    lat: 59.95909175816279,
    lng: -8.16364112473441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3325",
    tags: [],
    locationDescription:
      " The student eats the cake gracefully. The man runs towards a tower lazily. The teacher builds a tower lazily.",
  },
  {
    locationId: "item21326",
    locationName: "item21326",
    locationAddress: "item21326",
    ratings: [
      { who: "Similar identities", rating: 2.85 },
      { who: "All perspectives", rating: 0.39 },
    ],
    lat: 53.16348657162663,
    lng: -5.322923705245275,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3326",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A woman looks at the cake gracefully. The student eats a tower quickly. The student jumps over a tower gracefully.",
  },
  {
    locationId: "item21327",
    locationName: "item21327",
    locationAddress: "item21327",
    ratings: null,
    lat: 53.53778350776751,
    lng: -8.109281273037473,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3327",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon happily. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item21328",
    locationName: "item21328",
    locationAddress: "item21328",
    ratings: null,
    lat: 50.06521468552748,
    lng: -5.353059050413167,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3328",
    tags: [],
    locationDescription: " A woman jumps over the horizon silently.",
  },
  {
    locationId: "item21329",
    locationName: "item21329",
    locationAddress: "item21329",
    ratings: null,
    lat: 50.72172188181013,
    lng: -7.331652716209408,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3329",
    tags: [],
    locationDescription: " The cat runs towards the cake lazily.",
  },
  {
    locationId: "item21330",
    locationName: "item21330",
    locationAddress: "item21330",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 3.16 },
    ],
    lat: 57.115707799167026,
    lng: 0.3114258738138638,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3330",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The man jumps over a fence gracefully. The teacher looks at the horizon gracefully. The cat writes a book gracefully. A dog jumps over the horizon gracefully. A dog builds a fence gracefully.",
  },
  {
    locationId: "item21331",
    locationName: "item21331",
    locationAddress: "item21331",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 55.23893116845826,
    lng: -7.841426324606637,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3331",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student builds a book quickly. A dog eats the road quickly.",
  },
  {
    locationId: "item21332",
    locationName: "item21332",
    locationAddress: "item21332",
    ratings: [
      { who: "Similar identities", rating: 1.42 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 56.88254262993492,
    lng: -1.6535083782303115,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3332",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman builds the road lazily. A woman eats a tower happily.",
  },
  {
    locationId: "item21333",
    locationName: "item21333",
    locationAddress: "item21333",
    ratings: [
      { who: "Similar identities", rating: 0.64 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 51.56797601757013,
    lng: -0.5145410132928419,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3333",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman eats the cake silently. A woman runs towards the road quickly.",
  },
  {
    locationId: "item21334",
    locationName: "item21334",
    locationAddress: "item21334",
    ratings: [
      { who: "Similar identities", rating: 1.41 },
      { who: "All perspectives", rating: 0.24 },
    ],
    lat: 59.99059104423908,
    lng: -0.7824695873723728,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3334",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman eats a fence gracefully. The student writes the cake happily. The teacher jumps over the cake happily. A dog runs towards the road quickly.",
  },
  {
    locationId: "item21335",
    locationName: "item21335",
    locationAddress: "item21335",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 4.48 },
    ],
    lat: 50.45751170727207,
    lng: -1.4214682322281664,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3335",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student looks at a tower quickly. A dog builds the cake lazily.",
  },
  {
    locationId: "item21336",
    locationName: "item21336",
    locationAddress: "item21336",
    ratings: null,
    lat: 59.58928836114106,
    lng: -2.7585532291894506,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3336",
    tags: [],
    locationDescription:
      " The teacher writes a tower angrily. The student builds a tower angrily. The man jumps over the road happily. A dog eats a book gracefully.",
  },
  {
    locationId: "item21337",
    locationName: "item21337",
    locationAddress: "item21337",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 58.41295353870362,
    lng: -2.650751946239243,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3337",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher runs towards the road silently. The teacher jumps over a book angrily. A woman looks at the cake happily.",
  },
  {
    locationId: "item21338",
    locationName: "item21338",
    locationAddress: "item21338",
    ratings: null,
    lat: 56.53623687951083,
    lng: -3.515219166018216,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3338",
    tags: [],
    locationDescription:
      " The student looks at the road silently. A dog builds a tower angrily. A dog looks at the horizon silently. A woman eats the horizon angrily.",
  },
  {
    locationId: "item21339",
    locationName: "item21339",
    locationAddress: "item21339",
    ratings: null,
    lat: 55.99097597908853,
    lng: -6.24117497767358,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3339",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon happily. The teacher jumps over a book angrily. The cat eats the road happily. A woman eats the road lazily.",
  },
  {
    locationId: "item21340",
    locationName: "item21340",
    locationAddress: "item21340",
    ratings: null,
    lat: 53.624878829964686,
    lng: -7.080126513643526,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3340",
    tags: [],
    locationDescription:
      " The cat looks at the cake happily. A dog writes a fence happily. The cat eats the cake silently. The student writes the cake gracefully.",
  },
  {
    locationId: "item21341",
    locationName: "item21341",
    locationAddress: "item21341",
    ratings: null,
    lat: 60.888537237661254,
    lng: -1.1994282120500088,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3341",
    tags: [],
    locationDescription:
      " A dog builds the cake happily. The man runs towards the horizon happily. A woman writes a fence gracefully. The man eats a fence angrily.",
  },
  {
    locationId: "item21342",
    locationName: "item21342",
    locationAddress: "item21342",
    ratings: [
      { who: "Similar identities", rating: 4.83 },
      { who: "All perspectives", rating: 1.63 },
    ],
    lat: 57.86207874141902,
    lng: -0.7732828745658233,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3342",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat eats the road lazily. A dog runs towards the road gracefully. A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item21343",
    locationName: "item21343",
    locationAddress: "item21343",
    ratings: [
      { who: "Similar identities", rating: 1.84 },
      { who: "All perspectives", rating: 1.25 },
    ],
    lat: 55.999240490892525,
    lng: -1.1552329168108448,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3343",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at a tower happily. The man builds the cake gracefully.",
  },
  {
    locationId: "item21344",
    locationName: "item21344",
    locationAddress: "item21344",
    ratings: null,
    lat: 52.29718260989462,
    lng: -3.484806293710559,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3344",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon lazily. The man runs towards a tower silently. The student jumps over the road angrily.",
  },
  {
    locationId: "item21345",
    locationName: "item21345",
    locationAddress: "item21345",
    ratings: [
      { who: "Similar identities", rating: 3.79 },
      { who: "All perspectives", rating: 2.11 },
    ],
    lat: 57.0773157572415,
    lng: -8.279151596583109,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3345",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over the road angrily. A woman builds a book angrily. The student eats a book gracefully. The student builds the horizon silently. A woman eats the road quickly.",
  },
  {
    locationId: "item21346",
    locationName: "item21346",
    locationAddress: "item21346",
    ratings: null,
    lat: 54.18835978411961,
    lng: -2.7622793260363148,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3346",
    tags: [],
    locationDescription: " A woman writes a book silently.",
  },
  {
    locationId: "item21347",
    locationName: "item21347",
    locationAddress: "item21347",
    ratings: [
      { who: "Similar identities", rating: 1.42 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 55.56612250175671,
    lng: -4.888749542451892,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3347",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman writes the horizon angrily. The student runs towards a tower angrily. A woman jumps over the horizon silently.",
  },
  {
    locationId: "item21348",
    locationName: "item21348",
    locationAddress: "item21348",
    ratings: [
      { who: "Similar identities", rating: 0.85 },
      { who: "All perspectives", rating: 1.54 },
    ],
    lat: 55.99235584787635,
    lng: 1.193958208925185,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3348",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over the horizon angrily. The student eats the cake lazily. A woman looks at a book gracefully. A dog eats a tower silently. A woman looks at the horizon silently.",
  },
  {
    locationId: "item21349",
    locationName: "item21349",
    locationAddress: "item21349",
    ratings: [
      { who: "Similar identities", rating: 4.91 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 59.049681629707315,
    lng: -0.930136855521642,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3349",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The cat eats the cake happily. A woman looks at the cake gracefully. The man runs towards the horizon lazily. The man runs towards the cake silently.",
  },
  {
    locationId: "item21350",
    locationName: "item21350",
    locationAddress: "item21350",
    ratings: null,
    lat: 53.294396966426085,
    lng: -1.197439108510082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3350",
    tags: [],
    locationDescription: " The teacher eats the cake gracefully.",
  },
  {
    locationId: "item21351",
    locationName: "item21351",
    locationAddress: "item21351",
    ratings: [
      { who: "Similar identities", rating: 0.78 },
      { who: "All perspectives", rating: 3.77 },
    ],
    lat: 53.96118054877541,
    lng: -7.644516271970691,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3351",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman jumps over a fence quickly. The cat builds a fence gracefully. The man eats the road happily.",
  },
  {
    locationId: "item21352",
    locationName: "item21352",
    locationAddress: "item21352",
    ratings: [
      { who: "Similar identities", rating: 1.92 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 59.8907154990718,
    lng: -1.9361660616896206,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3352",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher builds the road lazily. The student looks at the horizon lazily. The teacher looks at a tower happily.",
  },
  {
    locationId: "item21353",
    locationName: "item21353",
    locationAddress: "item21353",
    ratings: [
      { who: "Similar identities", rating: 4.85 },
      { who: "All perspectives", rating: 1.86 },
    ],
    lat: 52.5485943687209,
    lng: -6.409285338487814,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3353",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man builds the road gracefully. The cat builds the cake happily.",
  },
  {
    locationId: "item21354",
    locationName: "item21354",
    locationAddress: "item21354",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 3.86 },
    ],
    lat: 50.4459718173844,
    lng: -6.310053257421749,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3354",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher builds the horizon silently. The student runs towards a tower gracefully. A dog eats a fence quickly. The man builds a fence quickly.",
  },
  {
    locationId: "item21355",
    locationName: "item21355",
    locationAddress: "item21355",
    ratings: null,
    lat: 59.668958815098755,
    lng: -5.581329688019359,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3355",
    tags: [],
    locationDescription:
      " The teacher writes the horizon quickly. The cat builds the horizon quickly. The student looks at the road silently. A woman builds the horizon quickly. The teacher runs towards the horizon happily.",
  },
  {
    locationId: "item21356",
    locationName: "item21356",
    locationAddress: "item21356",
    ratings: [
      { who: "Similar identities", rating: 0.88 },
      { who: "All perspectives", rating: 2.64 },
    ],
    lat: 52.490685994634525,
    lng: -2.188245354964841,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3356",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man writes the cake angrily. The student builds a book gracefully.",
  },
  {
    locationId: "item21357",
    locationName: "item21357",
    locationAddress: "item21357",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 2.19 },
    ],
    lat: 52.421206748407826,
    lng: -3.286230691370175,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3357",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman builds a tower angrily. A dog looks at the cake gracefully. The man jumps over a fence gracefully. The teacher runs towards the horizon gracefully. A woman jumps over a fence gracefully.",
  },
  {
    locationId: "item21358",
    locationName: "item21358",
    locationAddress: "item21358",
    ratings: [
      { who: "Similar identities", rating: 1.97 },
      { who: "All perspectives", rating: 0.87 },
    ],
    lat: 58.54929440861397,
    lng: -6.611778661803308,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3358",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " The student jumps over the horizon happily.",
  },
  {
    locationId: "item21359",
    locationName: "item21359",
    locationAddress: "item21359",
    ratings: [
      { who: "Similar identities", rating: 4.73 },
      { who: "All perspectives", rating: 4.99 },
    ],
    lat: 54.941349629160754,
    lng: 1.5507415106589342,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3359",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student runs towards the cake quickly. The student jumps over a tower quickly. The teacher builds the road lazily.",
  },
  {
    locationId: "item21360",
    locationName: "item21360",
    locationAddress: "item21360",
    ratings: [
      { who: "Similar identities", rating: 3.9 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 55.46013667705419,
    lng: -5.921084930663331,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3360",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student builds a fence happily. A woman builds the road happily.",
  },
  {
    locationId: "item21361",
    locationName: "item21361",
    locationAddress: "item21361",
    ratings: [
      { who: "Similar identities", rating: 0.98 },
      { who: "All perspectives", rating: 4.62 },
    ],
    lat: 50.64059766517178,
    lng: -7.192362698443293,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3361",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The teacher jumps over a fence gracefully. A dog builds a fence angrily.",
  },
  {
    locationId: "item21362",
    locationName: "item21362",
    locationAddress: "item21362",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 59.999276420429304,
    lng: 1.6156434077972452,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3362",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat eats a fence lazily. A woman eats a fence lazily. The student jumps over a fence gracefully. A dog looks at a fence quickly. A dog builds a tower silently.",
  },
  {
    locationId: "item21363",
    locationName: "item21363",
    locationAddress: "item21363",
    ratings: [
      { who: "Similar identities", rating: 0.11 },
      { who: "All perspectives", rating: 3.06 },
    ],
    lat: 55.46549147111326,
    lng: -4.007116518370581,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3363",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The student runs towards the horizon silently. The cat runs towards a fence quickly. The man jumps over the horizon happily.",
  },
  {
    locationId: "item21364",
    locationName: "item21364",
    locationAddress: "item21364",
    ratings: [
      { who: "Similar identities", rating: 4.52 },
      { who: "All perspectives", rating: 3.95 },
    ],
    lat: 56.603584795191864,
    lng: -6.253687199376845,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3364",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman builds a fence angrily. A dog looks at a fence silently. The teacher runs towards a book lazily.",
  },
  {
    locationId: "item21365",
    locationName: "item21365",
    locationAddress: "item21365",
    ratings: null,
    lat: 53.35155432822601,
    lng: -3.182958401589919,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3365",
    tags: [],
    locationDescription:
      " The cat looks at a book silently. The man writes a fence silently.",
  },
  {
    locationId: "item21366",
    locationName: "item21366",
    locationAddress: "item21366",
    ratings: null,
    lat: 54.077862630156304,
    lng: -0.8502848546168895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3366",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon quickly. A woman eats a book gracefully. A dog eats a tower happily. The teacher runs towards the road angrily. A woman runs towards the cake quickly.",
  },
  {
    locationId: "item21367",
    locationName: "item21367",
    locationAddress: "item21367",
    ratings: [
      { who: "Similar identities", rating: 1.54 },
      { who: "All perspectives", rating: 2.52 },
    ],
    lat: 50.52163905892601,
    lng: -3.697699653947149,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3367",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student builds a tower silently. The man jumps over the horizon happily. The man writes the horizon lazily. The teacher eats the cake quickly. The man runs towards the horizon lazily.",
  },
  {
    locationId: "item21368",
    locationName: "item21368",
    locationAddress: "item21368",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 2.92 },
    ],
    lat: 59.96513885332543,
    lng: 1.0213590683327443,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3368",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes a tower quickly. The student builds the road gracefully.",
  },
  {
    locationId: "item21369",
    locationName: "item21369",
    locationAddress: "item21369",
    ratings: [
      { who: "Similar identities", rating: 4.44 },
      { who: "All perspectives", rating: 0.3 },
    ],
    lat: 59.57304105914879,
    lng: -0.3215430489345614,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3369",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat jumps over a fence lazily. The student looks at the horizon lazily. The student jumps over a fence angrily. The man writes the horizon gracefully. The cat builds a book quickly.",
  },
  {
    locationId: "item21370",
    locationName: "item21370",
    locationAddress: "item21370",
    ratings: [
      { who: "Similar identities", rating: 4.33 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 52.03474547614232,
    lng: -4.561967366830346,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3370",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog builds the horizon happily. The teacher runs towards a fence gracefully.",
  },
  {
    locationId: "item21371",
    locationName: "item21371",
    locationAddress: "item21371",
    ratings: [
      { who: "Similar identities", rating: 1.6 },
      { who: "All perspectives", rating: 3.91 },
    ],
    lat: 54.49324896558684,
    lng: -1.0218359469805485,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3371",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats a fence angrily. The man looks at a tower silently. The student looks at a tower quickly. The student writes the road happily. The man looks at the cake quickly.",
  },
  {
    locationId: "item21372",
    locationName: "item21372",
    locationAddress: "item21372",
    ratings: [
      { who: "Similar identities", rating: 0.5 },
      { who: "All perspectives", rating: 3.55 },
    ],
    lat: 60.73181153706386,
    lng: -2.047360333450582,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3372",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over the cake gracefully. A woman builds a book quickly.",
  },
  {
    locationId: "item21373",
    locationName: "item21373",
    locationAddress: "item21373",
    ratings: null,
    lat: 52.241087081996085,
    lng: -5.816563474588602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3373",
    tags: [],
    locationDescription:
      " A woman looks at the cake quickly. The teacher runs towards the cake angrily. The teacher runs towards the road quickly. The cat builds the road angrily.",
  },
  {
    locationId: "item21374",
    locationName: "item21374",
    locationAddress: "item21374",
    ratings: [
      { who: "Similar identities", rating: 0.77 },
      { who: "All perspectives", rating: 1.25 },
    ],
    lat: 53.329890953893106,
    lng: -8.56832720903037,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3374",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat builds a book quickly. A woman builds a book lazily. A woman runs towards a book lazily.",
  },
  {
    locationId: "item21375",
    locationName: "item21375",
    locationAddress: "item21375",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 2.67 },
    ],
    lat: 50.91192073630064,
    lng: -2.77132538755955,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3375",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man looks at the road gracefully.",
  },
  {
    locationId: "item21376",
    locationName: "item21376",
    locationAddress: "item21376",
    ratings: null,
    lat: 54.517409631793214,
    lng: -5.252813397608062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3376",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon angrily. A woman runs towards the horizon lazily. The man writes the road silently. The student jumps over a fence silently. The man writes a tower happily.",
  },
  {
    locationId: "item21377",
    locationName: "item21377",
    locationAddress: "item21377",
    ratings: null,
    lat: 59.33705480191071,
    lng: -3.269099678427204,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3377",
    tags: [],
    locationDescription:
      " The man writes a book gracefully. The cat runs towards the horizon gracefully. The student runs towards a fence gracefully. The teacher runs towards a book gracefully. A woman runs towards a book lazily.",
  },
  {
    locationId: "item21378",
    locationName: "item21378",
    locationAddress: "item21378",
    ratings: [
      { who: "Similar identities", rating: 1.72 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 51.87308501107807,
    lng: -5.464006806678558,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3378",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The teacher writes the cake gracefully. The student builds a tower happily.",
  },
  {
    locationId: "item21379",
    locationName: "item21379",
    locationAddress: "item21379",
    ratings: null,
    lat: 53.24889220833865,
    lng: -5.4190768399539575,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3379",
    tags: [],
    locationDescription:
      " The student writes the horizon gracefully. The cat runs towards the road lazily.",
  },
  {
    locationId: "item21380",
    locationName: "item21380",
    locationAddress: "item21380",
    ratings: [
      { who: "Similar identities", rating: 0.43 },
      { who: "All perspectives", rating: 2.65 },
    ],
    lat: 53.56220663260063,
    lng: -0.42710558394422016,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3380",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog builds a tower lazily. The man looks at a book gracefully. The man builds the road angrily. A woman jumps over a book silently. A woman writes a book gracefully.",
  },
  {
    locationId: "item21381",
    locationName: "item21381",
    locationAddress: "item21381",
    ratings: null,
    lat: 56.69270821492174,
    lng: -4.5719647754990715,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3381",
    tags: [],
    locationDescription: " The man looks at the cake quickly.",
  },
  {
    locationId: "item21382",
    locationName: "item21382",
    locationAddress: "item21382",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 3.57 },
    ],
    lat: 51.72611399604209,
    lng: -1.2098736477007375,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3382",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman looks at the road silently. The student looks at the road gracefully. The cat jumps over a fence quickly. The man runs towards a fence angrily. The cat eats the cake gracefully.",
  },
  {
    locationId: "item21383",
    locationName: "item21383",
    locationAddress: "item21383",
    ratings: [
      { who: "Similar identities", rating: 4.39 },
      { who: "All perspectives", rating: 3.31 },
    ],
    lat: 59.31855333438743,
    lng: 0.32729388398089476,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3383",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog looks at a tower quickly. The student writes the horizon lazily. The teacher looks at a fence silently.",
  },
  {
    locationId: "item21384",
    locationName: "item21384",
    locationAddress: "item21384",
    ratings: null,
    lat: 60.46516664790527,
    lng: -3.7270029674904626,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3384",
    tags: [],
    locationDescription:
      " The student builds a fence lazily. A woman writes a fence happily. A dog runs towards a fence lazily.",
  },
  {
    locationId: "item21385",
    locationName: "item21385",
    locationAddress: "item21385",
    ratings: [
      { who: "Similar identities", rating: 0.78 },
      { who: "All perspectives", rating: 4.58 },
    ],
    lat: 54.84566416288962,
    lng: -6.335508550278628,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3385",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds a book silently. The student builds a tower silently. A woman jumps over a tower lazily. The teacher jumps over a fence quickly. A dog looks at the horizon lazily.",
  },
  {
    locationId: "item21386",
    locationName: "item21386",
    locationAddress: "item21386",
    ratings: null,
    lat: 55.70886452419668,
    lng: -2.274083690306062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3386",
    tags: [],
    locationDescription:
      " A woman jumps over a fence happily. The teacher eats the cake lazily. The teacher eats the horizon happily. The man eats the road quickly.",
  },
  {
    locationId: "item21387",
    locationName: "item21387",
    locationAddress: "item21387",
    ratings: [
      { who: "Similar identities", rating: 1.84 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 58.714311438462545,
    lng: -4.101708218351291,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3387",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man runs towards the cake gracefully. A dog builds the cake silently. The student eats a fence quickly. The teacher runs towards the cake silently.",
  },
  {
    locationId: "item21388",
    locationName: "item21388",
    locationAddress: "item21388",
    ratings: null,
    lat: 50.923522516446006,
    lng: -3.2364118265322874,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3388",
    tags: [],
    locationDescription:
      " A woman builds a tower angrily. The man writes a fence happily.",
  },
  {
    locationId: "item21389",
    locationName: "item21389",
    locationAddress: "item21389",
    ratings: null,
    lat: 60.19332566766253,
    lng: -0.8420764556426157,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3389",
    tags: [],
    locationDescription:
      " The man writes a book gracefully. The cat writes a book quickly.",
  },
  {
    locationId: "item21390",
    locationName: "item21390",
    locationAddress: "item21390",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 2.81 },
    ],
    lat: 53.39590680382202,
    lng: -3.929891958238512,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3390",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over the road quickly. The man writes the horizon happily. The teacher runs towards the cake happily. A woman eats the road quickly.",
  },
  {
    locationId: "item21391",
    locationName: "item21391",
    locationAddress: "item21391",
    ratings: null,
    lat: 52.44198463331176,
    lng: -7.95585706797035,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3391",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon lazily. The teacher builds the cake quickly. A dog builds a book silently.",
  },
  {
    locationId: "item21392",
    locationName: "item21392",
    locationAddress: "item21392",
    ratings: [
      { who: "Similar identities", rating: 2.23 },
      { who: "All perspectives", rating: 0.75 },
    ],
    lat: 57.07838991692816,
    lng: -8.12328119838374,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3392",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat writes a book gracefully. The student jumps over a fence lazily.",
  },
  {
    locationId: "item21393",
    locationName: "item21393",
    locationAddress: "item21393",
    ratings: [
      { who: "Similar identities", rating: 3.11 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 50.65880825363366,
    lng: -1.3377145470767484,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3393",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog writes the road gracefully. The student looks at the horizon angrily. The cat jumps over the cake quickly. A woman jumps over a fence quickly.",
  },
  {
    locationId: "item21394",
    locationName: "item21394",
    locationAddress: "item21394",
    ratings: [
      { who: "Similar identities", rating: 2.02 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 54.4542996769755,
    lng: -5.711779053089767,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3394",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat builds a fence silently. A woman builds a book quickly. The man eats a book gracefully.",
  },
  {
    locationId: "item21395",
    locationName: "item21395",
    locationAddress: "item21395",
    ratings: null,
    lat: 60.38888914257592,
    lng: -7.004658741352232,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3395",
    tags: [],
    locationDescription:
      " The student builds the horizon gracefully. The teacher builds a tower silently. The teacher runs towards the road quickly. The man jumps over the cake angrily.",
  },
  {
    locationId: "item21396",
    locationName: "item21396",
    locationAddress: "item21396",
    ratings: null,
    lat: 55.16606913490995,
    lng: -2.8099848508642955,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3396",
    tags: [],
    locationDescription:
      " A dog eats a tower silently. The teacher builds the cake angrily. A woman jumps over a fence quickly. The cat writes the road angrily. A woman looks at a book silently.",
  },
  {
    locationId: "item21397",
    locationName: "item21397",
    locationAddress: "item21397",
    ratings: null,
    lat: 58.987561131891184,
    lng: -3.668153724807394,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3397",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. The student eats a fence angrily. The student runs towards a book gracefully.",
  },
  {
    locationId: "item21398",
    locationName: "item21398",
    locationAddress: "item21398",
    ratings: null,
    lat: 51.10083564913009,
    lng: 0.9847498331266404,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3398",
    tags: [],
    locationDescription: " A woman writes the horizon quickly.",
  },
  {
    locationId: "item21399",
    locationName: "item21399",
    locationAddress: "item21399",
    ratings: [
      { who: "Similar identities", rating: 0.28 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 53.756680006027885,
    lng: -2.326377397211754,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3399",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The teacher builds a book angrily.",
  },
  {
    locationId: "item21400",
    locationName: "item21400",
    locationAddress: "item21400",
    ratings: null,
    lat: 59.55631928124957,
    lng: 1.5727643205813866,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3400",
    tags: [],
    locationDescription:
      " The student writes a tower lazily. The man writes a book silently. The cat jumps over the road happily. The cat writes a tower angrily. The cat looks at the cake quickly.",
  },
  {
    locationId: "item21401",
    locationName: "item21401",
    locationAddress: "item21401",
    ratings: null,
    lat: 56.395432950387296,
    lng: -4.325304312173834,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3401",
    tags: [],
    locationDescription: " A dog eats a fence happily.",
  },
  {
    locationId: "item21402",
    locationName: "item21402",
    locationAddress: "item21402",
    ratings: null,
    lat: 51.58612402802865,
    lng: -0.9417923522212419,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3402",
    tags: [],
    locationDescription:
      " A dog eats a book quickly. The student writes a fence quickly. The student eats the horizon silently.",
  },
  {
    locationId: "item21403",
    locationName: "item21403",
    locationAddress: "item21403",
    ratings: null,
    lat: 57.50050033082244,
    lng: -8.043430157446727,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3403",
    tags: [],
    locationDescription: " The cat runs towards a fence silently.",
  },
  {
    locationId: "item21404",
    locationName: "item21404",
    locationAddress: "item21404",
    ratings: null,
    lat: 50.23186761573474,
    lng: 0.8280503758553195,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3404",
    tags: [],
    locationDescription:
      " The cat eats a fence silently. A dog builds the road silently. A dog jumps over a tower quickly. A woman writes a book gracefully.",
  },
  {
    locationId: "item21405",
    locationName: "item21405",
    locationAddress: "item21405",
    ratings: [
      { who: "Similar identities", rating: 3.97 },
      { who: "All perspectives", rating: 4.52 },
    ],
    lat: 53.389656615020655,
    lng: -7.148310115157015,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3405",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat runs towards a fence angrily. The student jumps over the road lazily. The man eats the cake silently. The teacher eats a book quickly. A woman eats a book lazily.",
  },
  {
    locationId: "item21406",
    locationName: "item21406",
    locationAddress: "item21406",
    ratings: [
      { who: "Similar identities", rating: 1.3 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 53.83339829557454,
    lng: -7.999001391261581,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3406",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman writes the cake quickly. The student jumps over the horizon lazily. The man runs towards a tower angrily.",
  },
  {
    locationId: "item21407",
    locationName: "item21407",
    locationAddress: "item21407",
    ratings: [
      { who: "Similar identities", rating: 1.1 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 55.34749149321967,
    lng: -8.356443401321975,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3407",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A dog runs towards a fence quickly. The student writes the horizon angrily.",
  },
  {
    locationId: "item21408",
    locationName: "item21408",
    locationAddress: "item21408",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 59.791322702920866,
    lng: 1.6937175661133743,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3408",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher runs towards a fence happily. A woman jumps over the cake lazily.",
  },
  {
    locationId: "item21409",
    locationName: "item21409",
    locationAddress: "item21409",
    ratings: null,
    lat: 58.187957572101716,
    lng: -1.852836172340969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3409",
    tags: [],
    locationDescription:
      " A dog writes a book angrily. The man writes the road silently.",
  },
  {
    locationId: "item21410",
    locationName: "item21410",
    locationAddress: "item21410",
    ratings: null,
    lat: 56.84283036245644,
    lng: -5.618271561097005,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3410",
    tags: [],
    locationDescription:
      " The man jumps over the horizon happily. The man looks at the cake silently. A dog runs towards the horizon quickly.",
  },
  {
    locationId: "item21411",
    locationName: "item21411",
    locationAddress: "item21411",
    ratings: null,
    lat: 58.19558934727138,
    lng: -4.045155433000906,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3411",
    tags: [],
    locationDescription:
      " The cat writes the road silently. A dog eats the road angrily. The man builds a book gracefully.",
  },
  {
    locationId: "item21412",
    locationName: "item21412",
    locationAddress: "item21412",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 3.86 },
    ],
    lat: 59.93526884645881,
    lng: 0.9822162158087764,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3412",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog eats the cake happily. The cat writes a fence lazily. A dog eats a tower happily. A woman runs towards a book silently. A woman jumps over a fence quickly.",
  },
  {
    locationId: "item21413",
    locationName: "item21413",
    locationAddress: "item21413",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 59.68554697265837,
    lng: -0.40131213524177056,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3413",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man writes a book gracefully.",
  },
  {
    locationId: "item21414",
    locationName: "item21414",
    locationAddress: "item21414",
    ratings: null,
    lat: 50.68488677989959,
    lng: 0.4667792912009787,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3414",
    tags: [],
    locationDescription:
      " The student runs towards a tower gracefully. The student looks at the cake gracefully. A dog jumps over a fence quickly. A dog eats a tower happily. The man jumps over a book lazily.",
  },
  {
    locationId: "item21415",
    locationName: "item21415",
    locationAddress: "item21415",
    ratings: [
      { who: "Similar identities", rating: 3.56 },
      { who: "All perspectives", rating: 0.07 },
    ],
    lat: 57.610562939898664,
    lng: -6.571742207778833,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3415",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student runs towards the horizon silently. The student jumps over the horizon quickly. A woman jumps over the horizon happily.",
  },
  {
    locationId: "item21416",
    locationName: "item21416",
    locationAddress: "item21416",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 58.01914545251468,
    lng: 1.7266147166364245,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3416",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at the horizon quickly. The man looks at a fence happily. The student eats a book lazily. The student eats a book gracefully. A dog jumps over the horizon angrily.",
  },
  {
    locationId: "item21417",
    locationName: "item21417",
    locationAddress: "item21417",
    ratings: null,
    lat: 54.436929398232884,
    lng: -2.200179406958603,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3417",
    tags: [],
    locationDescription:
      " A dog looks at the cake quickly. A woman looks at a tower quickly. A woman runs towards a tower lazily. A dog writes the horizon angrily. A woman writes the horizon quickly.",
  },
  {
    locationId: "item21418",
    locationName: "item21418",
    locationAddress: "item21418",
    ratings: null,
    lat: 60.056836050400996,
    lng: -3.950242048124065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3418",
    tags: [],
    locationDescription:
      " The teacher looks at the road lazily. The cat looks at a tower happily. A woman writes a fence angrily. The cat eats a fence gracefully.",
  },
  {
    locationId: "item21419",
    locationName: "item21419",
    locationAddress: "item21419",
    ratings: null,
    lat: 60.77342244854962,
    lng: -3.2905681814114285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3419",
    tags: [],
    locationDescription: " A dog eats a fence quickly.",
  },
  {
    locationId: "item21420",
    locationName: "item21420",
    locationAddress: "item21420",
    ratings: [
      { who: "Similar identities", rating: 1.44 },
      { who: "All perspectives", rating: 0.18 },
    ],
    lat: 54.24575856333834,
    lng: -4.8435353281298505,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3420",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man runs towards the cake silently. The student writes a tower lazily. The man writes a tower angrily. A dog looks at the horizon angrily. The cat looks at a fence silently.",
  },
  {
    locationId: "item21421",
    locationName: "item21421",
    locationAddress: "item21421",
    ratings: [
      { who: "Similar identities", rating: 0.13 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 58.846294660643544,
    lng: -4.312221778725329,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3421",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog writes the road lazily. The cat writes the road quickly. A woman runs towards the cake quickly. The cat builds a fence silently.",
  },
  {
    locationId: "item21422",
    locationName: "item21422",
    locationAddress: "item21422",
    ratings: null,
    lat: 52.87612518421619,
    lng: 1.755605239411624,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3422",
    tags: [],
    locationDescription:
      " A dog looks at the cake quickly. The student jumps over a tower gracefully. The man looks at a book angrily. The teacher writes a tower happily.",
  },
  {
    locationId: "item21423",
    locationName: "item21423",
    locationAddress: "item21423",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 56.69764807662718,
    lng: -0.5954218162680842,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3423",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes a book silently. The man writes the road gracefully. A woman runs towards a book happily. The cat builds the cake gracefully.",
  },
  {
    locationId: "item21424",
    locationName: "item21424",
    locationAddress: "item21424",
    ratings: null,
    lat: 59.05580978656242,
    lng: -4.268657304032256,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3424",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon silently. A woman jumps over a book gracefully. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item21425",
    locationName: "item21425",
    locationAddress: "item21425",
    ratings: null,
    lat: 53.631618926387176,
    lng: 1.3135139634927047,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3425",
    tags: [],
    locationDescription:
      " The teacher writes the horizon gracefully. A woman eats a book angrily. A woman looks at the horizon gracefully. The man jumps over the horizon lazily. A dog builds a tower silently.",
  },
  {
    locationId: "item21426",
    locationName: "item21426",
    locationAddress: "item21426",
    ratings: null,
    lat: 57.944993729403784,
    lng: -1.1802642513612494,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3426",
    tags: [],
    locationDescription:
      " A dog runs towards the road lazily. A woman jumps over a fence quickly. The student builds the horizon angrily. The teacher writes a book gracefully. The man looks at a book lazily.",
  },
  {
    locationId: "item21427",
    locationName: "item21427",
    locationAddress: "item21427",
    ratings: null,
    lat: 58.27207841177951,
    lng: -7.339062223485823,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3427",
    tags: [],
    locationDescription: " The man runs towards a book angrily.",
  },
  {
    locationId: "item21428",
    locationName: "item21428",
    locationAddress: "item21428",
    ratings: [
      { who: "Similar identities", rating: 3.58 },
      { who: "All perspectives", rating: 3.08 },
    ],
    lat: 60.35507196049,
    lng: -3.498693776206034,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3428",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student runs towards the road angrily. The man jumps over a tower quickly. The cat eats a book gracefully. A woman looks at the cake happily. The cat looks at a book angrily.",
  },
  {
    locationId: "item21429",
    locationName: "item21429",
    locationAddress: "item21429",
    ratings: [
      { who: "Similar identities", rating: 4.37 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 52.08261785136601,
    lng: -7.806944791486813,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3429",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat builds the horizon gracefully.",
  },
  {
    locationId: "item21430",
    locationName: "item21430",
    locationAddress: "item21430",
    ratings: null,
    lat: 52.876273356486564,
    lng: -3.5107874340205365,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3430",
    tags: [],
    locationDescription: " A dog jumps over a book happily.",
  },
  {
    locationId: "item21431",
    locationName: "item21431",
    locationAddress: "item21431",
    ratings: null,
    lat: 57.66159370783321,
    lng: -3.1959709743159026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3431",
    tags: [],
    locationDescription: " A woman writes the cake angrily.",
  },
  {
    locationId: "item21432",
    locationName: "item21432",
    locationAddress: "item21432",
    ratings: [
      { who: "Similar identities", rating: 1.89 },
      { who: "All perspectives", rating: 4.14 },
    ],
    lat: 60.878629522720495,
    lng: 0.2770179428845747,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3432",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat looks at the cake silently. A woman eats a tower lazily.",
  },
  {
    locationId: "item21433",
    locationName: "item21433",
    locationAddress: "item21433",
    ratings: null,
    lat: 60.44129287136539,
    lng: -0.07873382489665914,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3433",
    tags: [],
    locationDescription:
      " A dog builds the horizon quickly. A dog runs towards the road angrily.",
  },
  {
    locationId: "item21434",
    locationName: "item21434",
    locationAddress: "item21434",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 59.2900153356838,
    lng: -3.516229458312589,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3434",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over the cake silently. The man runs towards a tower lazily. The teacher jumps over a fence lazily. A dog builds a book gracefully. A woman eats a tower quickly.",
  },
  {
    locationId: "item21435",
    locationName: "item21435",
    locationAddress: "item21435",
    ratings: null,
    lat: 50.77586606530179,
    lng: -8.38099619040899,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3435",
    tags: [],
    locationDescription:
      " The man eats a tower silently. The man runs towards the horizon silently. A dog looks at the horizon lazily. The cat builds the cake happily. The cat writes a book quickly.",
  },
  {
    locationId: "item21436",
    locationName: "item21436",
    locationAddress: "item21436",
    ratings: [
      { who: "Similar identities", rating: 2.77 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 59.46363728052914,
    lng: 0.3870912220575118,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3436",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher looks at the horizon angrily. The student runs towards the road gracefully. The cat writes the horizon lazily. The student runs towards a fence lazily.",
  },
  {
    locationId: "item21437",
    locationName: "item21437",
    locationAddress: "item21437",
    ratings: [
      { who: "Similar identities", rating: 3.33 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 60.283024340287355,
    lng: -5.189132958534123,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3437",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A dog writes a book lazily. The teacher runs towards a tower silently.",
  },
  {
    locationId: "item21438",
    locationName: "item21438",
    locationAddress: "item21438",
    ratings: [
      { who: "Similar identities", rating: 2.77 },
      { who: "All perspectives", rating: 4.22 },
    ],
    lat: 52.382194938101065,
    lng: -5.52229915599524,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3438",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog runs towards the horizon quickly. The student looks at the road angrily. The man runs towards a book lazily.",
  },
  {
    locationId: "item21439",
    locationName: "item21439",
    locationAddress: "item21439",
    ratings: null,
    lat: 51.153423328195586,
    lng: 1.3120988538421958,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3439",
    tags: [],
    locationDescription:
      " The student looks at the road quickly. A dog jumps over a tower happily. A woman eats a book gracefully. A dog eats a fence angrily. The teacher eats the cake quickly.",
  },
  {
    locationId: "item21440",
    locationName: "item21440",
    locationAddress: "item21440",
    ratings: [
      { who: "Similar identities", rating: 3.68 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 54.749856631980435,
    lng: -7.041946812689043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3440",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The student writes the road quickly. The teacher looks at the horizon quickly. The man runs towards the road happily.",
  },
  {
    locationId: "item21441",
    locationName: "item21441",
    locationAddress: "item21441",
    ratings: null,
    lat: 50.75910903184369,
    lng: -7.617791614821952,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3441",
    tags: [],
    locationDescription:
      " A dog writes the road angrily. The cat writes a tower gracefully. The student runs towards the cake quickly.",
  },
  {
    locationId: "item21442",
    locationName: "item21442",
    locationAddress: "item21442",
    ratings: [
      { who: "Similar identities", rating: 1.35 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 59.27931429705389,
    lng: -1.46937023533956,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3442",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A dog runs towards the road lazily. The student eats a fence silently. The man looks at a tower lazily. The teacher writes a book silently. The teacher runs towards the cake quickly.",
  },
  {
    locationId: "item21443",
    locationName: "item21443",
    locationAddress: "item21443",
    ratings: null,
    lat: 58.19975398350616,
    lng: -4.2267126271818505,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3443",
    tags: [],
    locationDescription:
      " The teacher looks at a book lazily. A dog writes a book happily.",
  },
  {
    locationId: "item21444",
    locationName: "item21444",
    locationAddress: "item21444",
    ratings: null,
    lat: 50.76572065929004,
    lng: -6.270978458685676,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3444",
    tags: [],
    locationDescription:
      " The student eats the horizon lazily. A woman looks at the cake gracefully. A woman writes the cake silently.",
  },
  {
    locationId: "item21445",
    locationName: "item21445",
    locationAddress: "item21445",
    ratings: null,
    lat: 53.32161768692353,
    lng: -4.442436705043743,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3445",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon lazily. A dog builds the road gracefully.",
  },
  {
    locationId: "item21446",
    locationName: "item21446",
    locationAddress: "item21446",
    ratings: null,
    lat: 50.5924162335848,
    lng: -7.144823961551189,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3446",
    tags: [],
    locationDescription:
      " A dog looks at a book gracefully. The cat eats a tower silently. The cat looks at a fence lazily. A dog writes a book silently. The student writes a book lazily.",
  },
  {
    locationId: "item21447",
    locationName: "item21447",
    locationAddress: "item21447",
    ratings: [
      { who: "Similar identities", rating: 4.03 },
      { who: "All perspectives", rating: 0.98 },
    ],
    lat: 50.10156149291973,
    lng: -4.025660256242731,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3447",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The cat builds a tower happily.",
  },
  {
    locationId: "item21448",
    locationName: "item21448",
    locationAddress: "item21448",
    ratings: null,
    lat: 52.406195553730186,
    lng: -3.1843277356428796,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3448",
    tags: [],
    locationDescription:
      " The man builds the horizon angrily. The cat eats a tower gracefully.",
  },
  {
    locationId: "item21449",
    locationName: "item21449",
    locationAddress: "item21449",
    ratings: null,
    lat: 60.56326003805373,
    lng: -4.176350086373081,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3449",
    tags: [],
    locationDescription:
      " The man builds a book silently. A dog builds the horizon angrily. The teacher looks at a fence quickly. The student runs towards a book happily. The cat jumps over the horizon happily.",
  },
  {
    locationId: "item21450",
    locationName: "item21450",
    locationAddress: "item21450",
    ratings: null,
    lat: 54.334522131620304,
    lng: -2.532459234879142,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3450",
    tags: [],
    locationDescription:
      " A dog builds the road quickly. The student runs towards a tower silently. The cat builds a book gracefully. The teacher looks at a book angrily.",
  },
  {
    locationId: "item21451",
    locationName: "item21451",
    locationAddress: "item21451",
    ratings: null,
    lat: 53.45263965613118,
    lng: -2.0092383468050894,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3451",
    tags: [],
    locationDescription:
      " The man writes the horizon gracefully. The teacher looks at a fence lazily. A woman runs towards a tower silently. The man runs towards a fence angrily. The man writes the horizon lazily.",
  },
  {
    locationId: "item21452",
    locationName: "item21452",
    locationAddress: "item21452",
    ratings: null,
    lat: 52.310585413889065,
    lng: -2.9103685388592098,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3452",
    tags: [],
    locationDescription:
      " The cat jumps over the cake quickly. The man eats the cake lazily. A woman runs towards the cake quickly.",
  },
  {
    locationId: "item21453",
    locationName: "item21453",
    locationAddress: "item21453",
    ratings: [
      { who: "Similar identities", rating: 3.13 },
      { who: "All perspectives", rating: 1.96 },
    ],
    lat: 56.688928052019726,
    lng: -6.2003285435862745,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3453",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The man writes a tower angrily.",
  },
  {
    locationId: "item21454",
    locationName: "item21454",
    locationAddress: "item21454",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 51.313600705328405,
    lng: -5.034795101125777,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3454",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog jumps over a book angrily. The student runs towards a fence lazily. The student looks at a book quickly.",
  },
  {
    locationId: "item21455",
    locationName: "item21455",
    locationAddress: "item21455",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 55.70569944850378,
    lng: -3.1309039086482047,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3455",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog writes the cake gracefully. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item21456",
    locationName: "item21456",
    locationAddress: "item21456",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 1.08 },
    ],
    lat: 55.10704880744333,
    lng: 0.5692307165963673,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3456",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man writes a book angrily. The man writes a tower silently.",
  },
  {
    locationId: "item21457",
    locationName: "item21457",
    locationAddress: "item21457",
    ratings: null,
    lat: 58.10313997740453,
    lng: -8.247007047369546,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3457",
    tags: [],
    locationDescription:
      " A dog eats the horizon gracefully. A woman eats the horizon happily. The student looks at the cake angrily. The teacher runs towards the horizon silently.",
  },
  {
    locationId: "item21458",
    locationName: "item21458",
    locationAddress: "item21458",
    ratings: null,
    lat: 57.757921471790354,
    lng: 1.7075769585209155,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3458",
    tags: [],
    locationDescription:
      " The man builds the road silently. The student eats the road happily.",
  },
  {
    locationId: "item21459",
    locationName: "item21459",
    locationAddress: "item21459",
    ratings: [
      { who: "Similar identities", rating: 1.01 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 54.267224157413125,
    lng: -1.1957926695459324,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3459",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man writes the horizon quickly. The man jumps over the cake lazily.",
  },
  {
    locationId: "item21460",
    locationName: "item21460",
    locationAddress: "item21460",
    ratings: [
      { who: "Similar identities", rating: 0.18 },
      { who: "All perspectives", rating: 2.87 },
    ],
    lat: 54.10286480952138,
    lng: -2.4856340064940667,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3460",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats a book gracefully. The teacher runs towards the road quickly. A dog runs towards the road silently. A dog jumps over the horizon gracefully. The teacher builds a book happily.",
  },
  {
    locationId: "item21461",
    locationName: "item21461",
    locationAddress: "item21461",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 2.18 },
    ],
    lat: 51.16619897326959,
    lng: 1.6789545465252882,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item3461",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a fence quickly. The cat builds the horizon happily. A dog jumps over a tower lazily. A woman looks at a fence quickly.",
  },
  {
    locationId: "item21462",
    locationName: "item21462",
    locationAddress: "item21462",
    ratings: null,
    lat: 60.30750806957296,
    lng: -3.65057291201893,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3462",
    tags: [],
    locationDescription:
      " The cat runs towards a tower angrily. A dog builds a tower silently. A dog builds the cake quickly. The cat jumps over a book angrily.",
  },
  {
    locationId: "item21463",
    locationName: "item21463",
    locationAddress: "item21463",
    ratings: [
      { who: "Similar identities", rating: 1.58 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 58.78989150780225,
    lng: 0.07239792447772686,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3463",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man runs towards the road happily. The cat looks at the road lazily.",
  },
  {
    locationId: "item21464",
    locationName: "item21464",
    locationAddress: "item21464",
    ratings: null,
    lat: 59.049914611159544,
    lng: 1.4399781126761972,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3464",
    tags: [],
    locationDescription: " The student runs towards the horizon lazily.",
  },
  {
    locationId: "item21465",
    locationName: "item21465",
    locationAddress: "item21465",
    ratings: null,
    lat: 54.16770005818674,
    lng: -2.0884418596272445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3465",
    tags: [],
    locationDescription:
      " The student looks at the horizon silently. A woman builds the road gracefully.",
  },
  {
    locationId: "item21466",
    locationName: "item21466",
    locationAddress: "item21466",
    ratings: null,
    lat: 52.8613665102294,
    lng: -5.096279869748484,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3466",
    tags: [],
    locationDescription:
      " A dog looks at the horizon silently. The student writes the cake happily.",
  },
  {
    locationId: "item21467",
    locationName: "item21467",
    locationAddress: "item21467",
    ratings: null,
    lat: 60.005024127675284,
    lng: -5.715329850214422,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3467",
    tags: [],
    locationDescription:
      " A woman eats the road quickly. A dog looks at a tower quickly. A woman looks at a book lazily.",
  },
  {
    locationId: "item21468",
    locationName: "item21468",
    locationAddress: "item21468",
    ratings: [
      { who: "Similar identities", rating: 2.82 },
      { who: "All perspectives", rating: 1.71 },
    ],
    lat: 51.16848913620891,
    lng: -8.258642448716042,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3468",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student runs towards a book silently. The man runs towards a book angrily.",
  },
  {
    locationId: "item21469",
    locationName: "item21469",
    locationAddress: "item21469",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 1.3 },
    ],
    lat: 55.74579251536666,
    lng: -8.599467338743523,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3469",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over a book lazily. The teacher jumps over the road silently. The man looks at the horizon lazily.",
  },
  {
    locationId: "item21470",
    locationName: "item21470",
    locationAddress: "item21470",
    ratings: null,
    lat: 60.37921179043747,
    lng: -4.292005101256559,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3470",
    tags: [],
    locationDescription:
      " The student builds a tower happily. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item21471",
    locationName: "item21471",
    locationAddress: "item21471",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 2.26 },
    ],
    lat: 54.796385261308444,
    lng: -3.652866802868296,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3471",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man builds a tower quickly. The cat eats a tower lazily.",
  },
  {
    locationId: "item21472",
    locationName: "item21472",
    locationAddress: "item21472",
    ratings: null,
    lat: 52.35898814029537,
    lng: -7.548417110009749,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3472",
    tags: [],
    locationDescription:
      " The teacher builds a tower silently. The teacher builds the cake silently. A dog runs towards the road happily. The man eats the horizon angrily.",
  },
  {
    locationId: "item21473",
    locationName: "item21473",
    locationAddress: "item21473",
    ratings: null,
    lat: 50.83058694791382,
    lng: -7.870261282469059,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3473",
    tags: [],
    locationDescription:
      " The cat looks at a tower silently. The man writes a fence happily.",
  },
  {
    locationId: "item21474",
    locationName: "item21474",
    locationAddress: "item21474",
    ratings: null,
    lat: 56.79639395892119,
    lng: -3.205738286196259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3474",
    tags: [],
    locationDescription:
      " A dog looks at a fence quickly. A dog runs towards a fence happily. A dog looks at a tower lazily.",
  },
  {
    locationId: "item21475",
    locationName: "item21475",
    locationAddress: "item21475",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 55.07361914120058,
    lng: 0.44972587275475284,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3475",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student runs towards a fence gracefully. The man eats the horizon quickly. The teacher writes the road quickly. The cat jumps over a book gracefully.",
  },
  {
    locationId: "item21476",
    locationName: "item21476",
    locationAddress: "item21476",
    ratings: null,
    lat: 57.91078826892861,
    lng: -6.093223569462065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3476",
    tags: [],
    locationDescription:
      " A dog looks at a book quickly. The man jumps over the horizon happily. The man writes the road happily.",
  },
  {
    locationId: "item21477",
    locationName: "item21477",
    locationAddress: "item21477",
    ratings: [
      { who: "Similar identities", rating: 2.56 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 52.68376553803944,
    lng: -8.10303612715555,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3477",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man runs towards a book gracefully. A dog writes the horizon lazily. The student eats the horizon silently. The man runs towards the cake silently. A dog writes the road lazily.",
  },
  {
    locationId: "item21478",
    locationName: "item21478",
    locationAddress: "item21478",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 0.73 },
    ],
    lat: 58.09466292671806,
    lng: -1.030437187059504,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3478",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes the horizon gracefully. A woman eats a fence gracefully.",
  },
  {
    locationId: "item21479",
    locationName: "item21479",
    locationAddress: "item21479",
    ratings: null,
    lat: 55.725110147458345,
    lng: -7.136100769234318,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3479",
    tags: [],
    locationDescription:
      " The cat writes the horizon gracefully. The teacher eats the road quickly. The teacher looks at the horizon angrily.",
  },
  {
    locationId: "item21480",
    locationName: "item21480",
    locationAddress: "item21480",
    ratings: null,
    lat: 56.16235689210704,
    lng: -3.4368311012398554,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3480",
    tags: [],
    locationDescription:
      " The man jumps over the horizon gracefully. The man looks at the road quickly. A woman eats a tower angrily.",
  },
  {
    locationId: "item21481",
    locationName: "item21481",
    locationAddress: "item21481",
    ratings: null,
    lat: 55.689163644547904,
    lng: -7.765832104296362,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3481",
    tags: [],
    locationDescription:
      " The cat writes a book silently. The student looks at a fence lazily. The student looks at a tower gracefully.",
  },
  {
    locationId: "item21482",
    locationName: "item21482",
    locationAddress: "item21482",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 3.85 },
    ],
    lat: 59.64062947990434,
    lng: -2.274430884665991,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3482",
    tags: [{ label: "accessible" }],
    locationDescription: " The student jumps over a fence gracefully.",
  },
  {
    locationId: "item21483",
    locationName: "item21483",
    locationAddress: "item21483",
    ratings: null,
    lat: 58.3264126831353,
    lng: -7.526174824093515,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3483",
    tags: [],
    locationDescription: " The student jumps over the horizon happily.",
  },
  {
    locationId: "item21484",
    locationName: "item21484",
    locationAddress: "item21484",
    ratings: null,
    lat: 56.217768608208544,
    lng: -0.20709188129035105,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3484",
    tags: [],
    locationDescription:
      " A woman writes a book lazily. The teacher jumps over a book gracefully. A woman eats a tower gracefully.",
  },
  {
    locationId: "item21485",
    locationName: "item21485",
    locationAddress: "item21485",
    ratings: null,
    lat: 56.45080385171534,
    lng: -2.406448969182918,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3485",
    tags: [],
    locationDescription: " The man eats the cake quickly.",
  },
  {
    locationId: "item21486",
    locationName: "item21486",
    locationAddress: "item21486",
    ratings: [
      { who: "Similar identities", rating: 4.67 },
      { who: "All perspectives", rating: 3.76 },
    ],
    lat: 52.193273114806274,
    lng: 0.7273018507098978,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3486",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a book quickly. The teacher looks at a fence lazily. The man runs towards the cake lazily.",
  },
  {
    locationId: "item21487",
    locationName: "item21487",
    locationAddress: "item21487",
    ratings: null,
    lat: 54.72472379086819,
    lng: 0.7770179830980126,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3487",
    tags: [],
    locationDescription:
      " The cat runs towards a book happily. The student builds the road happily.",
  },
  {
    locationId: "item21488",
    locationName: "item21488",
    locationAddress: "item21488",
    ratings: [
      { who: "Similar identities", rating: 1.55 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 59.88225669398815,
    lng: -6.431525633303318,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3488",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats a fence lazily. The man looks at a fence angrily. The man looks at a book quickly.",
  },
  {
    locationId: "item21489",
    locationName: "item21489",
    locationAddress: "item21489",
    ratings: null,
    lat: 51.41117614296224,
    lng: -3.7870449689828947,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3489",
    tags: [],
    locationDescription: " The teacher writes a book happily.",
  },
  {
    locationId: "item21490",
    locationName: "item21490",
    locationAddress: "item21490",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 3.56 },
    ],
    lat: 58.00072725293301,
    lng: -7.163131484502214,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3490",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes a fence lazily. A dog builds a fence angrily. A woman jumps over the road lazily. A woman runs towards the road quickly.",
  },
  {
    locationId: "item21491",
    locationName: "item21491",
    locationAddress: "item21491",
    ratings: [
      { who: "Similar identities", rating: 4.96 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 50.634211468932484,
    lng: -7.192845237937001,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3491",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards the road angrily. The student jumps over the cake quickly.",
  },
  {
    locationId: "item21492",
    locationName: "item21492",
    locationAddress: "item21492",
    ratings: null,
    lat: 54.288691222741704,
    lng: 0.8538073010175218,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3492",
    tags: [],
    locationDescription:
      " The man looks at the road happily. The man runs towards a book gracefully. The man builds a fence happily.",
  },
  {
    locationId: "item21493",
    locationName: "item21493",
    locationAddress: "item21493",
    ratings: null,
    lat: 56.02820409156189,
    lng: -2.014409794066178,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3493",
    tags: [],
    locationDescription:
      " A woman builds a tower happily. The teacher eats the horizon angrily. The cat runs towards the road lazily. A woman jumps over a book gracefully. The cat jumps over a fence quickly.",
  },
  {
    locationId: "item21494",
    locationName: "item21494",
    locationAddress: "item21494",
    ratings: null,
    lat: 59.388262086918125,
    lng: -6.096199328936191,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3494",
    tags: [],
    locationDescription: " The student runs towards the road happily.",
  },
  {
    locationId: "item21495",
    locationName: "item21495",
    locationAddress: "item21495",
    ratings: null,
    lat: 56.635162463132005,
    lng: 1.5882934058041034,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3495",
    tags: [],
    locationDescription:
      " The man eats the road lazily. The student jumps over the road silently. The student builds the cake angrily.",
  },
  {
    locationId: "item21496",
    locationName: "item21496",
    locationAddress: "item21496",
    ratings: null,
    lat: 55.13845742397615,
    lng: -5.053517904527485,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3496",
    tags: [],
    locationDescription:
      " A woman jumps over a tower lazily. The man eats the cake quickly. A dog builds the road lazily.",
  },
  {
    locationId: "item21497",
    locationName: "item21497",
    locationAddress: "item21497",
    ratings: null,
    lat: 57.10971621062147,
    lng: -7.754398738264871,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3497",
    tags: [],
    locationDescription:
      " A dog looks at the road angrily. The cat looks at a tower angrily. A dog eats a tower happily. The student looks at the road angrily.",
  },
  {
    locationId: "item21498",
    locationName: "item21498",
    locationAddress: "item21498",
    ratings: null,
    lat: 53.234281572551424,
    lng: -7.098089800384155,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3498",
    tags: [],
    locationDescription:
      " The cat runs towards the cake lazily. A woman eats the road gracefully. The man jumps over the road lazily. A woman writes the road lazily.",
  },
  {
    locationId: "item21499",
    locationName: "item21499",
    locationAddress: "item21499",
    ratings: null,
    lat: 58.54448238945707,
    lng: -5.042703938938329,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3499",
    tags: [],
    locationDescription:
      " A dog builds the road lazily. The cat eats the cake gracefully. The cat builds a fence lazily. The student writes the road quickly. A dog builds the road quickly.",
  },
  {
    locationId: "item21500",
    locationName: "item21500",
    locationAddress: "item21500",
    ratings: null,
    lat: 52.49913535225769,
    lng: -6.426340828833954,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3500",
    tags: [],
    locationDescription:
      " The man looks at the horizon angrily. A dog builds the cake quickly.",
  },
  {
    locationId: "item21501",
    locationName: "item21501",
    locationAddress: "item21501",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 2.04 },
    ],
    lat: 49.96987679212287,
    lng: -0.5751057453324044,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3501",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog runs towards the road happily.",
  },
  {
    locationId: "item21502",
    locationName: "item21502",
    locationAddress: "item21502",
    ratings: null,
    lat: 51.77923093139514,
    lng: -3.66466399014008,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3502",
    tags: [],
    locationDescription:
      " The student looks at a book gracefully. The man eats the cake quickly.",
  },
  {
    locationId: "item21503",
    locationName: "item21503",
    locationAddress: "item21503",
    ratings: [
      { who: "Similar identities", rating: 0.11 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 58.679158360776455,
    lng: 0.4085827558324162,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3503",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher eats a tower angrily. A woman writes a book angrily. A woman eats the horizon quickly. A dog runs towards a tower quickly.",
  },
  {
    locationId: "item21504",
    locationName: "item21504",
    locationAddress: "item21504",
    ratings: [
      { who: "Similar identities", rating: 0.11 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 56.23830153056958,
    lng: -7.979545407236055,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3504",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog builds a tower gracefully. A dog jumps over the cake lazily. A dog jumps over the horizon angrily.",
  },
  {
    locationId: "item21505",
    locationName: "item21505",
    locationAddress: "item21505",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 4.11 },
    ],
    lat: 49.91991197611713,
    lng: -3.153570834532748,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3505",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The man looks at a tower silently.",
  },
  {
    locationId: "item21506",
    locationName: "item21506",
    locationAddress: "item21506",
    ratings: [
      { who: "Similar identities", rating: 0.03 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 51.78150129486112,
    lng: -4.106668905562966,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3506",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman jumps over a book happily. The teacher runs towards a book happily. The cat writes the road gracefully.",
  },
  {
    locationId: "item21507",
    locationName: "item21507",
    locationAddress: "item21507",
    ratings: null,
    lat: 54.75529781417303,
    lng: -5.284902860677356,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3507",
    tags: [],
    locationDescription: " The student builds a fence happily.",
  },
  {
    locationId: "item21508",
    locationName: "item21508",
    locationAddress: "item21508",
    ratings: null,
    lat: 53.62412512667657,
    lng: -1.9037855670786357,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3508",
    tags: [],
    locationDescription:
      " The cat jumps over a book angrily. The teacher writes a fence quickly.",
  },
  {
    locationId: "item21509",
    locationName: "item21509",
    locationAddress: "item21509",
    ratings: null,
    lat: 55.09486269483201,
    lng: -7.917946499474727,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3509",
    tags: [],
    locationDescription:
      " The cat eats a book angrily. The teacher builds the road quickly.",
  },
  {
    locationId: "item21510",
    locationName: "item21510",
    locationAddress: "item21510",
    ratings: null,
    lat: 60.83305414157785,
    lng: -4.809490848191285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3510",
    tags: [],
    locationDescription:
      " The teacher builds a book gracefully. A dog writes a tower gracefully. The student eats the road gracefully. A dog looks at the horizon quickly. A dog eats a fence quickly.",
  },
  {
    locationId: "item21511",
    locationName: "item21511",
    locationAddress: "item21511",
    ratings: null,
    lat: 52.75696206644831,
    lng: -4.081749789132954,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3511",
    tags: [],
    locationDescription:
      " A dog looks at the horizon lazily. The cat writes a tower lazily. The man eats a tower angrily. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item21512",
    locationName: "item21512",
    locationAddress: "item21512",
    ratings: [
      { who: "Similar identities", rating: 2.94 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 60.03206575555138,
    lng: -4.978752743093612,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3512",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman builds a book quickly. The teacher runs towards a fence gracefully. The man runs towards a tower lazily. A woman looks at the road silently. The teacher eats the horizon angrily.",
  },
  {
    locationId: "item21513",
    locationName: "item21513",
    locationAddress: "item21513",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 3.33 },
    ],
    lat: 51.83127061846516,
    lng: -6.349002782879949,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3513",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat jumps over the horizon gracefully. The teacher builds a fence happily. The cat looks at the road silently.",
  },
  {
    locationId: "item21514",
    locationName: "item21514",
    locationAddress: "item21514",
    ratings: null,
    lat: 52.18793285754012,
    lng: -1.9317878357602014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3514",
    tags: [],
    locationDescription:
      " The man looks at a book angrily. A woman looks at the road lazily. A dog eats the cake gracefully. The man writes the horizon gracefully.",
  },
  {
    locationId: "item21515",
    locationName: "item21515",
    locationAddress: "item21515",
    ratings: [
      { who: "Similar identities", rating: 4.84 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 54.43841327058858,
    lng: -8.367530213309923,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3515",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The teacher eats the cake angrily. The student runs towards the road lazily. The student eats a fence gracefully.",
  },
  {
    locationId: "item21516",
    locationName: "item21516",
    locationAddress: "item21516",
    ratings: null,
    lat: 55.80171441857464,
    lng: -5.381999905431387,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3516",
    tags: [],
    locationDescription:
      " A woman jumps over a fence happily. The teacher looks at the cake quickly. A woman writes the cake quickly. A woman runs towards the horizon silently.",
  },
  {
    locationId: "item21517",
    locationName: "item21517",
    locationAddress: "item21517",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 55.64912790879908,
    lng: 1.2503418989124206,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3517",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The student looks at the horizon gracefully.",
  },
  {
    locationId: "item21518",
    locationName: "item21518",
    locationAddress: "item21518",
    ratings: [
      { who: "Similar identities", rating: 4.35 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 55.99728211666436,
    lng: -7.850914053697407,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3518",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman runs towards a book silently. A dog eats a book quickly. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item21519",
    locationName: "item21519",
    locationAddress: "item21519",
    ratings: [
      { who: "Similar identities", rating: 0.39 },
      { who: "All perspectives", rating: 2.68 },
    ],
    lat: 51.641680662661635,
    lng: -3.9980632836062826,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3519",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The student eats a book quickly.",
  },
  {
    locationId: "item21520",
    locationName: "item21520",
    locationAddress: "item21520",
    ratings: null,
    lat: 55.78167467551737,
    lng: -3.9754724558695065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3520",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence silently. A dog runs towards a fence quickly.",
  },
  {
    locationId: "item21521",
    locationName: "item21521",
    locationAddress: "item21521",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 50.72567512229445,
    lng: 0.16859501244252684,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3521",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at the horizon gracefully. The teacher builds the road gracefully.",
  },
  {
    locationId: "item21522",
    locationName: "item21522",
    locationAddress: "item21522",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 4.25 },
    ],
    lat: 59.287386209570954,
    lng: -1.897015415055697,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3522",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards a tower silently. A woman eats the cake gracefully. A woman jumps over the road angrily. The teacher looks at a tower silently.",
  },
  {
    locationId: "item21523",
    locationName: "item21523",
    locationAddress: "item21523",
    ratings: null,
    lat: 59.18787355277703,
    lng: -0.9000492382102259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3523",
    tags: [],
    locationDescription:
      " The man runs towards the horizon lazily. The man jumps over a tower gracefully. The cat writes the road silently. A dog jumps over a book lazily.",
  },
  {
    locationId: "item21524",
    locationName: "item21524",
    locationAddress: "item21524",
    ratings: [
      { who: "Similar identities", rating: 2.41 },
      { who: "All perspectives", rating: 3.75 },
    ],
    lat: 51.46099214816886,
    lng: -5.727405011028934,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3524",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man runs towards the horizon gracefully. A woman jumps over a tower happily.",
  },
  {
    locationId: "item21525",
    locationName: "item21525",
    locationAddress: "item21525",
    ratings: [
      { who: "Similar identities", rating: 1.36 },
      { who: "All perspectives", rating: 1.73 },
    ],
    lat: 57.302037512567516,
    lng: -4.896760784873143,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3525",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The teacher runs towards a fence quickly.",
  },
  {
    locationId: "item21526",
    locationName: "item21526",
    locationAddress: "item21526",
    ratings: null,
    lat: 59.53916067675134,
    lng: -7.402060302902889,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3526",
    tags: [],
    locationDescription:
      " The cat runs towards a fence lazily. The teacher writes a tower lazily. The student writes a book quickly. The cat runs towards a fence angrily.",
  },
  {
    locationId: "item21527",
    locationName: "item21527",
    locationAddress: "item21527",
    ratings: null,
    lat: 54.2532015625646,
    lng: 0.05869165286989109,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3527",
    tags: [],
    locationDescription:
      " The teacher builds the horizon silently. The cat builds the cake silently. A woman eats the road happily. The student looks at the road angrily.",
  },
  {
    locationId: "item21528",
    locationName: "item21528",
    locationAddress: "item21528",
    ratings: null,
    lat: 54.46266952357052,
    lng: -0.8749745244687706,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3528",
    tags: [],
    locationDescription:
      " A dog runs towards a book silently. A dog runs towards a book quickly. The man eats a book lazily. The student looks at a fence gracefully. The man jumps over the cake quickly.",
  },
  {
    locationId: "item21529",
    locationName: "item21529",
    locationAddress: "item21529",
    ratings: [
      { who: "Similar identities", rating: 1.17 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 51.665719381512424,
    lng: -4.723688558619754,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3529",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat jumps over the cake happily. A dog eats the road gracefully. The teacher builds the cake silently. The student builds the cake silently.",
  },
  {
    locationId: "item21530",
    locationName: "item21530",
    locationAddress: "item21530",
    ratings: null,
    lat: 53.00877279375544,
    lng: 1.4331867958909381,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3530",
    tags: [],
    locationDescription:
      " The student runs towards a fence angrily. The teacher eats the road silently. A woman jumps over a tower happily. The cat looks at the road silently.",
  },
  {
    locationId: "item21531",
    locationName: "item21531",
    locationAddress: "item21531",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 2.68 },
    ],
    lat: 50.08941217736177,
    lng: -8.402047178709314,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3531",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman writes a book angrily. The student looks at the road quickly. The cat eats a fence gracefully.",
  },
  {
    locationId: "item21532",
    locationName: "item21532",
    locationAddress: "item21532",
    ratings: null,
    lat: 56.852362101905754,
    lng: -0.8583407727546675,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3532",
    tags: [],
    locationDescription:
      " The cat looks at a tower angrily. The teacher builds the horizon silently. A woman looks at a book silently. The cat eats a book happily. The teacher jumps over a book angrily.",
  },
  {
    locationId: "item21533",
    locationName: "item21533",
    locationAddress: "item21533",
    ratings: null,
    lat: 58.41453111948421,
    lng: -8.377102745766106,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3533",
    tags: [],
    locationDescription:
      " The cat builds the road quickly. The student builds a book quickly. The cat builds the cake gracefully. The man looks at a tower angrily.",
  },
  {
    locationId: "item21534",
    locationName: "item21534",
    locationAddress: "item21534",
    ratings: [
      { who: "Similar identities", rating: 0.1 },
      { who: "All perspectives", rating: 4.52 },
    ],
    lat: 56.8652585743834,
    lng: -1.2470219763035342,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3534",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man builds the cake angrily. The man looks at a book silently.",
  },
  {
    locationId: "item21535",
    locationName: "item21535",
    locationAddress: "item21535",
    ratings: null,
    lat: 51.787502232567306,
    lng: -7.235126083641777,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3535",
    tags: [],
    locationDescription:
      " The teacher writes the cake quickly. A woman looks at the cake lazily. The cat builds the road happily. The teacher eats the road happily. The student writes a fence lazily.",
  },
  {
    locationId: "item21536",
    locationName: "item21536",
    locationAddress: "item21536",
    ratings: null,
    lat: 49.92709493064103,
    lng: -8.289443800535912,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3536",
    tags: [],
    locationDescription: " The student writes a book happily.",
  },
  {
    locationId: "item21537",
    locationName: "item21537",
    locationAddress: "item21537",
    ratings: [
      { who: "Similar identities", rating: 0.45 },
      { who: "All perspectives", rating: 4.87 },
    ],
    lat: 59.87295489758104,
    lng: -8.132522839274188,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3537",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher eats a tower quickly.",
  },
  {
    locationId: "item21538",
    locationName: "item21538",
    locationAddress: "item21538",
    ratings: null,
    lat: 51.6035913816002,
    lng: -1.4537217902873607,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3538",
    tags: [],
    locationDescription:
      " A woman jumps over the road lazily. The student writes a book gracefully. The teacher jumps over a book lazily. A dog builds the cake silently.",
  },
  {
    locationId: "item21539",
    locationName: "item21539",
    locationAddress: "item21539",
    ratings: [
      { who: "Similar identities", rating: 1.09 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 59.38548038229786,
    lng: -0.28512579134588734,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3539",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog jumps over a tower angrily. The teacher writes a fence lazily. A dog jumps over a book quickly.",
  },
  {
    locationId: "item21540",
    locationName: "item21540",
    locationAddress: "item21540",
    ratings: null,
    lat: 51.18098720423722,
    lng: -4.4246351876881835,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3540",
    tags: [],
    locationDescription:
      " The man builds a fence angrily. A dog jumps over a tower gracefully. The man runs towards the cake angrily.",
  },
  {
    locationId: "item21541",
    locationName: "item21541",
    locationAddress: "item21541",
    ratings: [
      { who: "Similar identities", rating: 0.51 },
      { who: "All perspectives", rating: 2.25 },
    ],
    lat: 53.57100087165956,
    lng: -3.0174660946789693,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3541",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a tower gracefully. A woman builds a fence lazily. The cat eats the cake happily. The student looks at the road angrily.",
  },
  {
    locationId: "item21542",
    locationName: "item21542",
    locationAddress: "item21542",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 57.35530239328165,
    lng: -2.246382432456632,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3542",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher runs towards a tower happily. The cat jumps over a tower gracefully. A dog looks at the cake silently.",
  },
  {
    locationId: "item21543",
    locationName: "item21543",
    locationAddress: "item21543",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 2.23 },
    ],
    lat: 60.61525437466601,
    lng: -1.7656262392854574,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3543",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards a tower silently. The man builds the road angrily.",
  },
  {
    locationId: "item21544",
    locationName: "item21544",
    locationAddress: "item21544",
    ratings: null,
    lat: 53.74169622094004,
    lng: -6.7186736883568035,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3544",
    tags: [],
    locationDescription:
      " The student eats a book silently. The man jumps over the road silently.",
  },
  {
    locationId: "item21545",
    locationName: "item21545",
    locationAddress: "item21545",
    ratings: null,
    lat: 53.64409211859793,
    lng: -1.1816543207782395,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3545",
    tags: [],
    locationDescription:
      " A woman runs towards a book lazily. The student writes a tower happily. A woman runs towards a tower quickly. The student jumps over a book happily.",
  },
  {
    locationId: "item21546",
    locationName: "item21546",
    locationAddress: "item21546",
    ratings: null,
    lat: 53.88498466328803,
    lng: -0.6809000454070642,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3546",
    tags: [],
    locationDescription:
      " The student looks at a fence angrily. The man builds a tower lazily. The cat writes a book angrily. The student jumps over a book gracefully.",
  },
  {
    locationId: "item21547",
    locationName: "item21547",
    locationAddress: "item21547",
    ratings: null,
    lat: 59.792175940465846,
    lng: -4.128394367684589,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3547",
    tags: [],
    locationDescription:
      " The teacher builds a tower lazily. The teacher runs towards a tower quickly. The student eats the road gracefully.",
  },
  {
    locationId: "item21548",
    locationName: "item21548",
    locationAddress: "item21548",
    ratings: null,
    lat: 51.17974664057773,
    lng: -2.7609235197043267,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3548",
    tags: [],
    locationDescription:
      " The cat jumps over a book happily. The teacher looks at the cake silently. A dog eats the cake happily. The student looks at the cake happily.",
  },
  {
    locationId: "item21549",
    locationName: "item21549",
    locationAddress: "item21549",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 60.34538648490234,
    lng: -7.196525788295103,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3549",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at the cake gracefully. The student writes the cake quickly.",
  },
  {
    locationId: "item21550",
    locationName: "item21550",
    locationAddress: "item21550",
    ratings: null,
    lat: 50.716908128639076,
    lng: -6.822324136104751,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3550",
    tags: [],
    locationDescription:
      " The student writes a fence silently. The cat builds a tower quickly.",
  },
  {
    locationId: "item21551",
    locationName: "item21551",
    locationAddress: "item21551",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 0.08 },
    ],
    lat: 59.601946858299065,
    lng: -1.3952377638080966,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3551",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student jumps over a fence happily. The teacher eats the cake quickly. A dog builds a book angrily. The cat eats the horizon gracefully. A woman runs towards a fence lazily.",
  },
  {
    locationId: "item21552",
    locationName: "item21552",
    locationAddress: "item21552",
    ratings: null,
    lat: 50.70014953643409,
    lng: -3.7634445091167352,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3552",
    tags: [],
    locationDescription:
      " The cat jumps over the road happily. The man runs towards the road angrily. A woman builds the horizon angrily.",
  },
  {
    locationId: "item21553",
    locationName: "item21553",
    locationAddress: "item21553",
    ratings: null,
    lat: 58.07586968124933,
    lng: -1.9377891778576837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3553",
    tags: [],
    locationDescription:
      " The man runs towards the horizon lazily. The man eats a fence happily. The teacher builds the horizon gracefully. A woman jumps over the road angrily.",
  },
  {
    locationId: "item21554",
    locationName: "item21554",
    locationAddress: "item21554",
    ratings: null,
    lat: 55.46014700599675,
    lng: -5.586645562187693,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3554",
    tags: [],
    locationDescription:
      " A woman jumps over the cake happily. The teacher runs towards the road gracefully. A dog jumps over the horizon happily. The student jumps over the road lazily.",
  },
  {
    locationId: "item21555",
    locationName: "item21555",
    locationAddress: "item21555",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 51.56927467041092,
    lng: -6.949865736884669,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3555",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The man looks at the cake happily.",
  },
  {
    locationId: "item21556",
    locationName: "item21556",
    locationAddress: "item21556",
    ratings: [
      { who: "Similar identities", rating: 4.83 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 59.031826793185225,
    lng: -3.4360868931197572,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3556",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A dog writes the cake silently. The teacher jumps over the road happily.",
  },
  {
    locationId: "item21557",
    locationName: "item21557",
    locationAddress: "item21557",
    ratings: [
      { who: "Similar identities", rating: 2.24 },
      { who: "All perspectives", rating: 2.98 },
    ],
    lat: 57.82745653697574,
    lng: -5.933572229349599,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3557",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man builds the cake happily. The student eats the horizon lazily.",
  },
  {
    locationId: "item21558",
    locationName: "item21558",
    locationAddress: "item21558",
    ratings: null,
    lat: 55.15404418709889,
    lng: -6.7719596118370635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3558",
    tags: [],
    locationDescription:
      " The student writes a tower angrily. The man jumps over the cake angrily.",
  },
  {
    locationId: "item21559",
    locationName: "item21559",
    locationAddress: "item21559",
    ratings: [
      { who: "Similar identities", rating: 0.23 },
      { who: "All perspectives", rating: 3.92 },
    ],
    lat: 60.43189504514882,
    lng: -2.0738413090578165,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3559",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student writes a fence silently. The teacher builds the horizon silently.",
  },
  {
    locationId: "item21560",
    locationName: "item21560",
    locationAddress: "item21560",
    ratings: null,
    lat: 57.800597341905075,
    lng: -1.6882430701810218,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3560",
    tags: [],
    locationDescription:
      " The man eats the road gracefully. The man eats the road angrily. The man runs towards a book lazily. A dog eats a book silently.",
  },
  {
    locationId: "item21561",
    locationName: "item21561",
    locationAddress: "item21561",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 1.69 },
    ],
    lat: 50.3259543506157,
    lng: -6.587357993604435,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3561",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man builds the road silently. The teacher looks at the cake angrily. The teacher looks at a fence happily. A dog looks at the road happily. A woman eats the horizon quickly.",
  },
  {
    locationId: "item21562",
    locationName: "item21562",
    locationAddress: "item21562",
    ratings: null,
    lat: 58.933297025207544,
    lng: 0.28531270845950374,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3562",
    tags: [],
    locationDescription:
      " The teacher looks at the cake happily. A woman runs towards a book happily. A dog builds the cake happily.",
  },
  {
    locationId: "item21563",
    locationName: "item21563",
    locationAddress: "item21563",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 50.44195954653182,
    lng: -1.581143649893086,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3563",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards the horizon happily. A dog eats the road happily. A woman looks at the cake angrily. The teacher runs towards the cake happily.",
  },
  {
    locationId: "item21564",
    locationName: "item21564",
    locationAddress: "item21564",
    ratings: null,
    lat: 52.22172239366385,
    lng: -5.25644162359788,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3564",
    tags: [],
    locationDescription:
      " The man looks at a tower quickly. A dog jumps over the road happily. A woman writes the horizon happily. The cat writes a tower silently.",
  },
  {
    locationId: "item21565",
    locationName: "item21565",
    locationAddress: "item21565",
    ratings: null,
    lat: 60.431288415016844,
    lng: -3.4400107882156163,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3565",
    tags: [],
    locationDescription:
      " A woman builds the horizon angrily. The man runs towards the cake silently. A woman eats the horizon happily.",
  },
  {
    locationId: "item21566",
    locationName: "item21566",
    locationAddress: "item21566",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 2.03 },
    ],
    lat: 58.80674835454748,
    lng: 0.22642345901452465,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3566",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription: " A woman builds a book angrily.",
  },
  {
    locationId: "item21567",
    locationName: "item21567",
    locationAddress: "item21567",
    ratings: [
      { who: "Similar identities", rating: 1.37 },
      { who: "All perspectives", rating: 2.18 },
    ],
    lat: 52.74286654762275,
    lng: -3.813460699774275,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3567",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher builds a fence gracefully. A dog jumps over a book silently. A dog runs towards the road happily.",
  },
  {
    locationId: "item21568",
    locationName: "item21568",
    locationAddress: "item21568",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 52.54161828399469,
    lng: -8.598994201226237,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3568",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards a book gracefully. A dog runs towards a tower silently. The man looks at a book happily. The man builds the road lazily.",
  },
  {
    locationId: "item21569",
    locationName: "item21569",
    locationAddress: "item21569",
    ratings: [
      { who: "Similar identities", rating: 1.55 },
      { who: "All perspectives", rating: 3.41 },
    ],
    lat: 57.15001118824813,
    lng: -6.20559687238876,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3569",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog eats a fence lazily. The teacher builds the cake silently. The student looks at a fence angrily. The cat eats a book happily.",
  },
  {
    locationId: "item21570",
    locationName: "item21570",
    locationAddress: "item21570",
    ratings: null,
    lat: 52.72801523503421,
    lng: -3.8484316063428423,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3570",
    tags: [],
    locationDescription:
      " The cat builds a fence quickly. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item21571",
    locationName: "item21571",
    locationAddress: "item21571",
    ratings: [
      { who: "Similar identities", rating: 0.01 },
      { who: "All perspectives", rating: 2.23 },
    ],
    lat: 51.48582880860661,
    lng: -4.310499876256675,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3571",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the road lazily. The teacher eats the road lazily. A dog writes a book silently. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item21572",
    locationName: "item21572",
    locationAddress: "item21572",
    ratings: null,
    lat: 55.897133899138296,
    lng: 1.2791657569389088,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3572",
    tags: [],
    locationDescription:
      " The cat looks at a tower gracefully. A woman looks at the horizon quickly. A dog looks at the horizon happily. A dog runs towards the road silently.",
  },
  {
    locationId: "item21573",
    locationName: "item21573",
    locationAddress: "item21573",
    ratings: [
      { who: "Similar identities", rating: 3.3 },
      { who: "All perspectives", rating: 3.45 },
    ],
    lat: 54.425911929748054,
    lng: -3.070553836148715,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3573",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats a fence silently. The man builds the cake lazily. A woman looks at the cake lazily. The teacher runs towards a fence quickly.",
  },
  {
    locationId: "item21574",
    locationName: "item21574",
    locationAddress: "item21574",
    ratings: null,
    lat: 53.55741645783411,
    lng: -4.528162126650828,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3574",
    tags: [],
    locationDescription: " The man writes the horizon quickly.",
  },
  {
    locationId: "item21575",
    locationName: "item21575",
    locationAddress: "item21575",
    ratings: null,
    lat: 57.73448339570309,
    lng: -2.2799024969265895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3575",
    tags: [],
    locationDescription:
      " The man jumps over the road silently. The teacher looks at the horizon silently. The cat writes the horizon lazily. The man builds the cake quickly. The student builds a book quickly.",
  },
  {
    locationId: "item21576",
    locationName: "item21576",
    locationAddress: "item21576",
    ratings: null,
    lat: 52.21179374466228,
    lng: 0.12835813717551225,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3576",
    tags: [],
    locationDescription:
      " A woman looks at the cake lazily. The teacher eats the cake lazily. The cat looks at a book gracefully.",
  },
  {
    locationId: "item21577",
    locationName: "item21577",
    locationAddress: "item21577",
    ratings: [
      { who: "Similar identities", rating: 0.63 },
      { who: "All perspectives", rating: 0.98 },
    ],
    lat: 57.685331990541336,
    lng: -5.506130899830948,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3577",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds the cake silently. The man builds the cake angrily.",
  },
  {
    locationId: "item21578",
    locationName: "item21578",
    locationAddress: "item21578",
    ratings: null,
    lat: 60.851403282900584,
    lng: -5.5944967214411285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3578",
    tags: [],
    locationDescription:
      " The teacher jumps over a book gracefully. A woman writes a book gracefully. A dog eats a tower lazily. The teacher eats a book angrily. The man writes a fence angrily.",
  },
  {
    locationId: "item21579",
    locationName: "item21579",
    locationAddress: "item21579",
    ratings: [
      { who: "Similar identities", rating: 4.08 },
      { who: "All perspectives", rating: 0.73 },
    ],
    lat: 57.95352831675355,
    lng: 1.218420630085653,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3579",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man jumps over the horizon gracefully. A dog writes a fence happily. The cat builds the road quickly. A woman builds a fence lazily.",
  },
  {
    locationId: "item21580",
    locationName: "item21580",
    locationAddress: "item21580",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 3.58 },
    ],
    lat: 52.86029455993083,
    lng: -0.03786944516596691,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3580",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student builds the horizon lazily. The cat eats the cake quickly.",
  },
  {
    locationId: "item21581",
    locationName: "item21581",
    locationAddress: "item21581",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 2.09 },
    ],
    lat: 58.46265491495666,
    lng: -6.898829375251076,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3581",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards a fence angrily. The student jumps over a fence gracefully. A dog jumps over the horizon lazily. The man builds the road gracefully.",
  },
  {
    locationId: "item21582",
    locationName: "item21582",
    locationAddress: "item21582",
    ratings: null,
    lat: 51.347202173911974,
    lng: -5.306639856235385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3582",
    tags: [],
    locationDescription:
      " The cat jumps over the road happily. The teacher looks at a book angrily.",
  },
  {
    locationId: "item21583",
    locationName: "item21583",
    locationAddress: "item21583",
    ratings: null,
    lat: 57.975572307977345,
    lng: -2.8561389522689016,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3583",
    tags: [],
    locationDescription:
      " A dog jumps over the cake happily. The cat eats a tower quickly.",
  },
  {
    locationId: "item21584",
    locationName: "item21584",
    locationAddress: "item21584",
    ratings: null,
    lat: 53.02975299176614,
    lng: 1.6401576180358148,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3584",
    tags: [],
    locationDescription: " The cat looks at a book lazily.",
  },
  {
    locationId: "item21585",
    locationName: "item21585",
    locationAddress: "item21585",
    ratings: [
      { who: "Similar identities", rating: 3.61 },
      { who: "All perspectives", rating: 3.43 },
    ],
    lat: 59.501346664161936,
    lng: -7.864380350455375,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3585",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes the horizon quickly. A woman writes the cake lazily.",
  },
  {
    locationId: "item21586",
    locationName: "item21586",
    locationAddress: "item21586",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 0.01 },
    ],
    lat: 56.514034935965626,
    lng: -2.0716762746227246,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3586",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at a tower silently. A dog writes a book angrily.",
  },
  {
    locationId: "item21587",
    locationName: "item21587",
    locationAddress: "item21587",
    ratings: [
      { who: "Similar identities", rating: 0.5 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 55.60336976673707,
    lng: -0.7285070625119445,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3587",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man runs towards the cake quickly. A dog writes a tower angrily. The teacher eats a tower quickly. The student jumps over the road happily. A dog eats the road gracefully.",
  },
  {
    locationId: "item21588",
    locationName: "item21588",
    locationAddress: "item21588",
    ratings: null,
    lat: 52.731535614394936,
    lng: 1.240017815061531,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3588",
    tags: [],
    locationDescription: " The man builds a tower lazily.",
  },
  {
    locationId: "item21589",
    locationName: "item21589",
    locationAddress: "item21589",
    ratings: [
      { who: "Similar identities", rating: 3.04 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 52.374711590901605,
    lng: 1.6862949037468962,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3589",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman writes the cake quickly. The cat looks at the cake lazily. The man eats the cake gracefully.",
  },
  {
    locationId: "item21590",
    locationName: "item21590",
    locationAddress: "item21590",
    ratings: null,
    lat: 52.17950937148988,
    lng: 0.7633316182354086,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3590",
    tags: [],
    locationDescription:
      " The student eats the horizon happily. A dog looks at the road lazily.",
  },
  {
    locationId: "item21591",
    locationName: "item21591",
    locationAddress: "item21591",
    ratings: null,
    lat: 52.049911847654826,
    lng: -3.004609367705646,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3591",
    tags: [],
    locationDescription:
      " The teacher eats a book angrily. The teacher jumps over the cake angrily. The teacher writes a tower angrily. A woman builds the cake angrily. A woman looks at the horizon gracefully.",
  },
  {
    locationId: "item21592",
    locationName: "item21592",
    locationAddress: "item21592",
    ratings: null,
    lat: 56.63005886330734,
    lng: -1.1291577557644015,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3592",
    tags: [],
    locationDescription:
      " The cat looks at the cake gracefully. A woman jumps over the horizon gracefully. A dog builds the horizon angrily. The cat runs towards the cake angrily. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item21593",
    locationName: "item21593",
    locationAddress: "item21593",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 3.83 },
    ],
    lat: 55.384545178218076,
    lng: -3.169896980736876,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3593",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes the horizon quickly. A woman looks at a fence happily.",
  },
  {
    locationId: "item21594",
    locationName: "item21594",
    locationAddress: "item21594",
    ratings: null,
    lat: 59.52539960533403,
    lng: -2.4756004815537214,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3594",
    tags: [],
    locationDescription:
      " A dog looks at a book silently. A woman builds the cake angrily.",
  },
  {
    locationId: "item21595",
    locationName: "item21595",
    locationAddress: "item21595",
    ratings: null,
    lat: 53.282379202785876,
    lng: -1.282483536817809,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3595",
    tags: [],
    locationDescription: " A dog looks at the horizon gracefully.",
  },
  {
    locationId: "item21596",
    locationName: "item21596",
    locationAddress: "item21596",
    ratings: [
      { who: "Similar identities", rating: 2.71 },
      { who: "All perspectives", rating: 3.42 },
    ],
    lat: 53.1170130277462,
    lng: -0.8675265208376048,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3596",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds a book quickly. The man runs towards the cake angrily. The man jumps over a book happily. The cat looks at the cake happily. The man jumps over a book gracefully.",
  },
  {
    locationId: "item21597",
    locationName: "item21597",
    locationAddress: "item21597",
    ratings: null,
    lat: 51.716109908837595,
    lng: -6.859578876831805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3597",
    tags: [],
    locationDescription:
      " The cat runs towards the cake happily. A woman writes a book lazily. The cat eats the road quickly.",
  },
  {
    locationId: "item21598",
    locationName: "item21598",
    locationAddress: "item21598",
    ratings: null,
    lat: 55.79324298738461,
    lng: -8.113326286558467,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3598",
    tags: [],
    locationDescription: " The teacher looks at the horizon silently.",
  },
  {
    locationId: "item21599",
    locationName: "item21599",
    locationAddress: "item21599",
    ratings: null,
    lat: 53.60881205275628,
    lng: 0.9306623708399311,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3599",
    tags: [],
    locationDescription: " The student writes the road silently.",
  },
  {
    locationId: "item21600",
    locationName: "item21600",
    locationAddress: "item21600",
    ratings: [
      { who: "Similar identities", rating: 0.53 },
      { who: "All perspectives", rating: 3.66 },
    ],
    lat: 50.64951538444676,
    lng: 1.454981369106921,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3600",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man jumps over the road lazily. The man looks at a book gracefully.",
  },
  {
    locationId: "item21601",
    locationName: "item21601",
    locationAddress: "item21601",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 60.23483492933347,
    lng: -5.927439115244262,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3601",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student eats a book lazily. The student writes the horizon gracefully. The cat runs towards a tower angrily. The student jumps over a book quickly. The cat writes a tower happily.",
  },
  {
    locationId: "item21602",
    locationName: "item21602",
    locationAddress: "item21602",
    ratings: null,
    lat: 58.64622196914424,
    lng: -2.366816877062318,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3602",
    tags: [],
    locationDescription:
      " The teacher builds a tower gracefully. A dog writes the road quickly.",
  },
  {
    locationId: "item21603",
    locationName: "item21603",
    locationAddress: "item21603",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 3.27 },
    ],
    lat: 55.97113960675023,
    lng: -4.11727024916493,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3603",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat eats the cake gracefully. The cat runs towards a tower silently. The cat jumps over the cake lazily. A woman jumps over a fence happily. A woman runs towards the cake quickly.",
  },
  {
    locationId: "item21604",
    locationName: "item21604",
    locationAddress: "item21604",
    ratings: null,
    lat: 57.054210839977124,
    lng: 1.7823592995130522,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3604",
    tags: [],
    locationDescription:
      " The man writes a book quickly. The man jumps over a tower gracefully. The student builds the cake gracefully. The man jumps over the road gracefully. A dog jumps over a tower gracefully.",
  },
  {
    locationId: "item21605",
    locationName: "item21605",
    locationAddress: "item21605",
    ratings: null,
    lat: 57.345301823016676,
    lng: -5.640424527734694,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3605",
    tags: [],
    locationDescription:
      " The man looks at a book angrily. The teacher eats the cake angrily.",
  },
  {
    locationId: "item21606",
    locationName: "item21606",
    locationAddress: "item21606",
    ratings: null,
    lat: 53.02039803106587,
    lng: -4.710367179519237,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3606",
    tags: [],
    locationDescription:
      " The man jumps over a fence happily. A dog writes a fence lazily. The man looks at a book gracefully. The teacher eats a fence happily. The teacher runs towards a tower lazily.",
  },
  {
    locationId: "item21607",
    locationName: "item21607",
    locationAddress: "item21607",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 4.95 },
    ],
    lat: 53.158289200495396,
    lng: -7.264161138201111,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3607",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat builds the horizon happily. The teacher eats the cake angrily.",
  },
  {
    locationId: "item21608",
    locationName: "item21608",
    locationAddress: "item21608",
    ratings: null,
    lat: 52.605108874083555,
    lng: -0.002940958201993027,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3608",
    tags: [],
    locationDescription:
      " The student writes the road lazily. The man builds a book angrily. A woman builds a tower angrily. A dog writes a fence silently. The cat jumps over a book happily.",
  },
  {
    locationId: "item21609",
    locationName: "item21609",
    locationAddress: "item21609",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 2.31 },
    ],
    lat: 51.98606201932186,
    lng: -2.8090519744619185,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3609",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman eats the road gracefully. The teacher builds a fence quickly.",
  },
  {
    locationId: "item21610",
    locationName: "item21610",
    locationAddress: "item21610",
    ratings: null,
    lat: 50.920755799863045,
    lng: -5.958309401956943,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3610",
    tags: [],
    locationDescription:
      " The cat builds a book angrily. The teacher runs towards the cake quickly. The teacher looks at a tower happily.",
  },
  {
    locationId: "item21611",
    locationName: "item21611",
    locationAddress: "item21611",
    ratings: [
      { who: "Similar identities", rating: 0.41 },
      { who: "All perspectives", rating: 1.1 },
    ],
    lat: 51.5923312845574,
    lng: -2.5135510195020467,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3611",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The cat runs towards a book angrily.",
  },
  {
    locationId: "item21612",
    locationName: "item21612",
    locationAddress: "item21612",
    ratings: null,
    lat: 60.59949440395661,
    lng: -3.435931900285337,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3612",
    tags: [],
    locationDescription:
      " A woman looks at the road quickly. The student builds the cake lazily. The man eats a tower gracefully. A woman eats the road lazily.",
  },
  {
    locationId: "item21613",
    locationName: "item21613",
    locationAddress: "item21613",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 4.04 },
    ],
    lat: 60.48633575931758,
    lng: -3.276934352983573,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3613",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The teacher runs towards a tower lazily. The student runs towards the horizon quickly. A dog writes the road quickly.",
  },
  {
    locationId: "item21614",
    locationName: "item21614",
    locationAddress: "item21614",
    ratings: [
      { who: "Similar identities", rating: 2.16 },
      { who: "All perspectives", rating: 3.93 },
    ],
    lat: 56.25168201726098,
    lng: -8.256941099241654,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3614",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman builds a book gracefully. The teacher eats the road angrily. A dog writes the road angrily. The man builds a book angrily. A dog eats a fence gracefully.",
  },
  {
    locationId: "item21615",
    locationName: "item21615",
    locationAddress: "item21615",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 2.04 },
    ],
    lat: 52.38802977135165,
    lng: -0.5454373049919692,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3615",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a fence happily. The student writes the cake happily.",
  },
  {
    locationId: "item21616",
    locationName: "item21616",
    locationAddress: "item21616",
    ratings: null,
    lat: 51.10043976193506,
    lng: -2.170615809988135,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3616",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence angrily. The man jumps over the cake silently. The teacher builds the cake happily. The man runs towards the horizon silently.",
  },
  {
    locationId: "item21617",
    locationName: "item21617",
    locationAddress: "item21617",
    ratings: [
      { who: "Similar identities", rating: 3.87 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 53.592912953280035,
    lng: -5.839788256397956,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3617",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The teacher looks at the road quickly.",
  },
  {
    locationId: "item21618",
    locationName: "item21618",
    locationAddress: "item21618",
    ratings: [
      { who: "Similar identities", rating: 4.36 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 51.54163485844461,
    lng: 0.6634855440568828,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3618",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards the horizon happily. The man looks at the horizon lazily.",
  },
  {
    locationId: "item21619",
    locationName: "item21619",
    locationAddress: "item21619",
    ratings: [
      { who: "Similar identities", rating: 3.14 },
      { who: "All perspectives", rating: 1.61 },
    ],
    lat: 53.55773497978116,
    lng: -5.279318666374213,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3619",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog runs towards a book lazily. The man runs towards the horizon quickly. The student looks at a fence happily. A woman jumps over the cake gracefully. A woman looks at the road happily.",
  },
  {
    locationId: "item21620",
    locationName: "item21620",
    locationAddress: "item21620",
    ratings: null,
    lat: 53.38693438084211,
    lng: -6.572649109950795,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3620",
    tags: [],
    locationDescription:
      " The student eats the cake angrily. The teacher writes a tower silently. A woman builds the cake quickly.",
  },
  {
    locationId: "item21621",
    locationName: "item21621",
    locationAddress: "item21621",
    ratings: null,
    lat: 59.725910405165585,
    lng: -3.498393444813983,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3621",
    tags: [],
    locationDescription:
      " The student jumps over the cake angrily. A dog runs towards the horizon angrily. A dog eats a tower gracefully. A dog eats the cake silently.",
  },
  {
    locationId: "item21622",
    locationName: "item21622",
    locationAddress: "item21622",
    ratings: null,
    lat: 53.8938075318501,
    lng: -3.324886450254877,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3622",
    tags: [],
    locationDescription:
      " The student runs towards the cake gracefully. A woman runs towards a book happily. The cat eats a tower silently. The teacher eats a book happily.",
  },
  {
    locationId: "item21623",
    locationName: "item21623",
    locationAddress: "item21623",
    ratings: [
      { who: "Similar identities", rating: 3.16 },
      { who: "All perspectives", rating: 4.71 },
    ],
    lat: 52.470124227944716,
    lng: 1.4319039251795829,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3623",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The student builds the cake lazily. The man looks at the horizon lazily. A woman eats a tower angrily. The man writes a book gracefully. A dog builds the road happily.",
  },
  {
    locationId: "item21624",
    locationName: "item21624",
    locationAddress: "item21624",
    ratings: null,
    lat: 55.285554414504794,
    lng: -6.6641412784113845,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3624",
    tags: [],
    locationDescription:
      " The teacher builds a tower angrily. The teacher writes the horizon happily. A woman runs towards the cake silently. A woman eats the horizon happily. The teacher runs towards the road gracefully.",
  },
  {
    locationId: "item21625",
    locationName: "item21625",
    locationAddress: "item21625",
    ratings: null,
    lat: 55.27094342528534,
    lng: -2.2843516129978774,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3625",
    tags: [],
    locationDescription:
      " The cat writes the road gracefully. The teacher eats the road silently. The student looks at a fence quickly. The cat builds a book lazily.",
  },
  {
    locationId: "item21626",
    locationName: "item21626",
    locationAddress: "item21626",
    ratings: [
      { who: "Similar identities", rating: 2.64 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 54.20692322827895,
    lng: 0.24137110477391666,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3626",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man builds the road silently.",
  },
  {
    locationId: "item21627",
    locationName: "item21627",
    locationAddress: "item21627",
    ratings: [
      { who: "Similar identities", rating: 2.28 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 57.1640129725842,
    lng: -0.7225365073337615,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3627",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher eats a tower angrily. The man writes a tower gracefully. The cat looks at a fence silently. The teacher eats a book gracefully.",
  },
  {
    locationId: "item21628",
    locationName: "item21628",
    locationAddress: "item21628",
    ratings: null,
    lat: 53.1714376775613,
    lng: -6.0177744767955925,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3628",
    tags: [],
    locationDescription:
      " The man builds the horizon silently. The teacher looks at a tower lazily.",
  },
  {
    locationId: "item21629",
    locationName: "item21629",
    locationAddress: "item21629",
    ratings: null,
    lat: 57.08643667386925,
    lng: -4.075392895787067,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3629",
    tags: [],
    locationDescription:
      " The student writes a book silently. The teacher jumps over a book lazily. The man runs towards the road silently. The student eats a book angrily. A woman jumps over a book lazily.",
  },
  {
    locationId: "item21630",
    locationName: "item21630",
    locationAddress: "item21630",
    ratings: null,
    lat: 58.31823414952191,
    lng: -3.4939722240166713,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3630",
    tags: [],
    locationDescription: " The cat eats a fence angrily.",
  },
  {
    locationId: "item21631",
    locationName: "item21631",
    locationAddress: "item21631",
    ratings: [
      { who: "Similar identities", rating: 1.33 },
      { who: "All perspectives", rating: 0.45 },
    ],
    lat: 56.079443324067554,
    lng: -2.0417729006601864,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3631",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher looks at a book silently. A dog runs towards a fence silently.",
  },
  {
    locationId: "item21632",
    locationName: "item21632",
    locationAddress: "item21632",
    ratings: null,
    lat: 52.56326878815127,
    lng: -8.5315975567571,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3632",
    tags: [],
    locationDescription:
      " A dog looks at the road quickly. The cat runs towards a fence lazily. A woman looks at the horizon lazily. A dog runs towards a tower gracefully. The student writes a tower angrily.",
  },
  {
    locationId: "item21633",
    locationName: "item21633",
    locationAddress: "item21633",
    ratings: null,
    lat: 55.91189032540012,
    lng: -5.776343393460131,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3633",
    tags: [],
    locationDescription: " The student eats the horizon happily.",
  },
  {
    locationId: "item21634",
    locationName: "item21634",
    locationAddress: "item21634",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 56.36811437825517,
    lng: 0.43748484451492864,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item3634",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " The student eats a fence happily.",
  },
  {
    locationId: "item21635",
    locationName: "item21635",
    locationAddress: "item21635",
    ratings: null,
    lat: 56.78037017369905,
    lng: -7.461763352134518,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3635",
    tags: [],
    locationDescription:
      " The teacher looks at a tower lazily. The cat jumps over a book happily. The cat eats the cake angrily.",
  },
  {
    locationId: "item21636",
    locationName: "item21636",
    locationAddress: "item21636",
    ratings: null,
    lat: 57.04983589613565,
    lng: -7.74331846263444,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3636",
    tags: [],
    locationDescription:
      " A woman writes a tower quickly. A woman looks at a book quickly. The man runs towards the road angrily. A dog looks at a book silently.",
  },
  {
    locationId: "item21637",
    locationName: "item21637",
    locationAddress: "item21637",
    ratings: null,
    lat: 60.20479935087329,
    lng: -5.672257262798182,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3637",
    tags: [],
    locationDescription:
      " The teacher eats a tower quickly. A dog builds a book lazily. The student looks at a fence angrily.",
  },
  {
    locationId: "item21638",
    locationName: "item21638",
    locationAddress: "item21638",
    ratings: null,
    lat: 57.834616719084195,
    lng: -7.702431355508448,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3638",
    tags: [],
    locationDescription:
      " The teacher writes the horizon gracefully. A woman jumps over the road quickly. A dog builds a book silently.",
  },
  {
    locationId: "item21639",
    locationName: "item21639",
    locationAddress: "item21639",
    ratings: [
      { who: "Similar identities", rating: 2.9 },
      { who: "All perspectives", rating: 3.97 },
    ],
    lat: 51.64469511576459,
    lng: -3.278340768303809,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3639",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat writes a tower quickly. The teacher looks at the horizon quickly. The man builds a book angrily.",
  },
  {
    locationId: "item21640",
    locationName: "item21640",
    locationAddress: "item21640",
    ratings: [
      { who: "Similar identities", rating: 4.05 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 58.80230852429737,
    lng: -6.3352950810860955,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3640",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student eats a fence gracefully. A dog builds a fence angrily. The student looks at a tower silently.",
  },
  {
    locationId: "item21641",
    locationName: "item21641",
    locationAddress: "item21641",
    ratings: [
      { who: "Similar identities", rating: 4.95 },
      { who: "All perspectives", rating: 3.37 },
    ],
    lat: 56.40648940119769,
    lng: -1.1153403048371757,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3641",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over a book happily. The student eats a tower happily. The teacher looks at a tower happily. The man jumps over a fence angrily. The teacher jumps over the road lazily.",
  },
  {
    locationId: "item21642",
    locationName: "item21642",
    locationAddress: "item21642",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 57.960002532825385,
    lng: -0.6846696816206181,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3642",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man builds a book gracefully. The man eats a book lazily. A woman looks at the horizon quickly. A woman runs towards a fence gracefully.",
  },
  {
    locationId: "item21643",
    locationName: "item21643",
    locationAddress: "item21643",
    ratings: null,
    lat: 56.96374035340109,
    lng: -2.001957610565209,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3643",
    tags: [],
    locationDescription: " The student eats a book quickly.",
  },
  {
    locationId: "item21644",
    locationName: "item21644",
    locationAddress: "item21644",
    ratings: null,
    lat: 50.70267900156231,
    lng: -0.7211569901703481,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3644",
    tags: [],
    locationDescription:
      " A dog runs towards the cake lazily. The cat looks at a tower gracefully. The man looks at a tower gracefully. The teacher jumps over the cake angrily. A dog builds the horizon angrily.",
  },
  {
    locationId: "item21645",
    locationName: "item21645",
    locationAddress: "item21645",
    ratings: null,
    lat: 51.51247630357391,
    lng: -5.933157387820159,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3645",
    tags: [],
    locationDescription: " The cat eats a book lazily.",
  },
  {
    locationId: "item21646",
    locationName: "item21646",
    locationAddress: "item21646",
    ratings: null,
    lat: 52.769534846697496,
    lng: -5.094697581756672,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3646",
    tags: [],
    locationDescription:
      " The student writes a book gracefully. A woman jumps over a tower lazily. A dog runs towards a tower angrily. The cat looks at a fence lazily. A dog writes the horizon silently.",
  },
  {
    locationId: "item21647",
    locationName: "item21647",
    locationAddress: "item21647",
    ratings: [
      { who: "Similar identities", rating: 2.64 },
      { who: "All perspectives", rating: 0.86 },
    ],
    lat: 55.35427087766284,
    lng: -6.030190514913352,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3647",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher jumps over a tower angrily. A woman jumps over a tower lazily. A dog runs towards the horizon angrily.",
  },
  {
    locationId: "item21648",
    locationName: "item21648",
    locationAddress: "item21648",
    ratings: null,
    lat: 51.46537492388739,
    lng: -5.601619702414132,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3648",
    tags: [],
    locationDescription:
      " The cat looks at the cake gracefully. The teacher runs towards the horizon gracefully. The student writes a tower lazily. The teacher builds the road gracefully. The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item21649",
    locationName: "item21649",
    locationAddress: "item21649",
    ratings: null,
    lat: 57.326063682431396,
    lng: -0.9437073695794895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3649",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence gracefully. A dog jumps over the cake happily.",
  },
  {
    locationId: "item21650",
    locationName: "item21650",
    locationAddress: "item21650",
    ratings: null,
    lat: 50.45603393101972,
    lng: -2.4953704130924974,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3650",
    tags: [],
    locationDescription: " The cat runs towards the cake lazily.",
  },
  {
    locationId: "item21651",
    locationName: "item21651",
    locationAddress: "item21651",
    ratings: null,
    lat: 60.13792462594637,
    lng: -1.946618792548267,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3651",
    tags: [],
    locationDescription: " A woman builds a tower lazily.",
  },
  {
    locationId: "item21652",
    locationName: "item21652",
    locationAddress: "item21652",
    ratings: null,
    lat: 56.09404890711751,
    lng: -5.106237780640644,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3652",
    tags: [],
    locationDescription:
      " The cat builds a tower quickly. The cat runs towards the cake gracefully. The teacher writes a book gracefully.",
  },
  {
    locationId: "item21653",
    locationName: "item21653",
    locationAddress: "item21653",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 55.96478200879068,
    lng: -4.600044358867244,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3653",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The student builds the cake angrily. The student runs towards a fence gracefully. A dog eats the road angrily. The cat eats a book happily.",
  },
  {
    locationId: "item21654",
    locationName: "item21654",
    locationAddress: "item21654",
    ratings: null,
    lat: 50.42059610038668,
    lng: -5.981400597799158,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3654",
    tags: [],
    locationDescription:
      " The teacher eats a fence gracefully. A woman runs towards a tower happily.",
  },
  {
    locationId: "item21655",
    locationName: "item21655",
    locationAddress: "item21655",
    ratings: null,
    lat: 60.690422262785816,
    lng: -7.044194203737586,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3655",
    tags: [],
    locationDescription: " A dog builds the cake lazily.",
  },
  {
    locationId: "item21656",
    locationName: "item21656",
    locationAddress: "item21656",
    ratings: null,
    lat: 53.334604545929025,
    lng: -3.683561393356844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3656",
    tags: [],
    locationDescription: " The teacher eats a tower happily.",
  },
  {
    locationId: "item21657",
    locationName: "item21657",
    locationAddress: "item21657",
    ratings: [
      { who: "Similar identities", rating: 4.05 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 56.1727638393923,
    lng: -7.102913414104081,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3657",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a book gracefully. The teacher builds the road lazily.",
  },
  {
    locationId: "item21658",
    locationName: "item21658",
    locationAddress: "item21658",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 55.62648070234566,
    lng: -1.8470990077406126,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3658",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at the road happily. The cat looks at the cake angrily.",
  },
  {
    locationId: "item21659",
    locationName: "item21659",
    locationAddress: "item21659",
    ratings: null,
    lat: 52.383340372119505,
    lng: -3.863320662387954,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3659",
    tags: [],
    locationDescription:
      " The man builds the cake happily. A woman looks at a book lazily.",
  },
  {
    locationId: "item21660",
    locationName: "item21660",
    locationAddress: "item21660",
    ratings: [
      { who: "Similar identities", rating: 2.35 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 51.14938614921375,
    lng: 1.2553680218504422,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3660",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher jumps over the road lazily.",
  },
  {
    locationId: "item21661",
    locationName: "item21661",
    locationAddress: "item21661",
    ratings: [
      { who: "Similar identities", rating: 2.05 },
      { who: "All perspectives", rating: 4.41 },
    ],
    lat: 60.20328174897493,
    lng: -6.8087463846982175,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3661",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at the horizon angrily. The student jumps over the horizon happily.",
  },
  {
    locationId: "item21662",
    locationName: "item21662",
    locationAddress: "item21662",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 60.558391907051416,
    lng: 0.18885297233184062,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3662",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes the cake gracefully. A dog writes a tower lazily.",
  },
  {
    locationId: "item21663",
    locationName: "item21663",
    locationAddress: "item21663",
    ratings: null,
    lat: 50.673142829550684,
    lng: -2.6582724080927793,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3663",
    tags: [],
    locationDescription: " A dog writes a book silently.",
  },
  {
    locationId: "item21664",
    locationName: "item21664",
    locationAddress: "item21664",
    ratings: null,
    lat: 59.98014227670934,
    lng: -1.9401701313108664,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3664",
    tags: [],
    locationDescription:
      " A woman looks at a tower happily. The student runs towards the road happily. The cat writes a tower happily. The student builds a tower silently. The man jumps over the horizon angrily.",
  },
  {
    locationId: "item21665",
    locationName: "item21665",
    locationAddress: "item21665",
    ratings: null,
    lat: 51.91898305624255,
    lng: -7.365223184049918,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3665",
    tags: [],
    locationDescription:
      " The student eats the road angrily. The cat jumps over a book happily. The man jumps over the road gracefully. The teacher writes the horizon silently.",
  },
  {
    locationId: "item21666",
    locationName: "item21666",
    locationAddress: "item21666",
    ratings: null,
    lat: 55.27746747752115,
    lng: -1.3368534892974449,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3666",
    tags: [],
    locationDescription:
      " A woman looks at the horizon lazily. The teacher runs towards the horizon silently. The teacher looks at the road angrily.",
  },
  {
    locationId: "item21667",
    locationName: "item21667",
    locationAddress: "item21667",
    ratings: null,
    lat: 58.11343417501309,
    lng: -6.728099870030218,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3667",
    tags: [],
    locationDescription:
      " A dog writes a tower angrily. A dog builds a tower lazily. The man writes a book lazily. The man looks at a book gracefully. The teacher looks at a fence lazily.",
  },
  {
    locationId: "item21668",
    locationName: "item21668",
    locationAddress: "item21668",
    ratings: null,
    lat: 59.34461502544079,
    lng: 1.1701990986219535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3668",
    tags: [],
    locationDescription:
      " The student jumps over a tower angrily. A woman writes the cake lazily. A woman runs towards a tower happily. The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item21669",
    locationName: "item21669",
    locationAddress: "item21669",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 0.26 },
    ],
    lat: 50.90418539825062,
    lng: -1.9092721750493977,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3669",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog builds a fence lazily. The teacher jumps over a book angrily. The student builds a fence lazily. The teacher writes the road gracefully. The man builds a tower gracefully.",
  },
  {
    locationId: "item21670",
    locationName: "item21670",
    locationAddress: "item21670",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 3.64 },
    ],
    lat: 58.709897638856965,
    lng: -5.494182470716812,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3670",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The student jumps over a fence gracefully. The student looks at the road gracefully. The man jumps over a fence lazily. A woman jumps over the horizon quickly.",
  },
  {
    locationId: "item21671",
    locationName: "item21671",
    locationAddress: "item21671",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 60.62987226982317,
    lng: 0.36132930744328107,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3671",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats a book quickly. The man eats a book silently. A woman writes a fence quickly. A dog looks at the road quickly. The student writes the road quickly.",
  },
  {
    locationId: "item21672",
    locationName: "item21672",
    locationAddress: "item21672",
    ratings: [
      { who: "Similar identities", rating: 0.6 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 59.431201277692885,
    lng: -6.782725926324252,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3672",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards a book lazily. A woman eats a fence lazily. A woman runs towards a tower happily. A woman writes the horizon angrily. The man jumps over a fence quickly.",
  },
  {
    locationId: "item21673",
    locationName: "item21673",
    locationAddress: "item21673",
    ratings: [
      { who: "Similar identities", rating: 3.25 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 58.83921313031804,
    lng: -6.476458076736762,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3673",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at a tower gracefully. A dog jumps over the horizon gracefully. A woman eats the road angrily. The man writes a fence gracefully.",
  },
  {
    locationId: "item21674",
    locationName: "item21674",
    locationAddress: "item21674",
    ratings: null,
    lat: 50.566982680596,
    lng: -7.3327532453166215,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3674",
    tags: [],
    locationDescription:
      " The student runs towards the cake lazily. A dog writes the road silently. The man runs towards the cake lazily.",
  },
  {
    locationId: "item21675",
    locationName: "item21675",
    locationAddress: "item21675",
    ratings: null,
    lat: 60.40117258380694,
    lng: -7.426100390033054,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3675",
    tags: [],
    locationDescription: " The student writes the horizon lazily.",
  },
  {
    locationId: "item21676",
    locationName: "item21676",
    locationAddress: "item21676",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 58.30195575948056,
    lng: -0.24346897859610905,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3676",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man eats a fence lazily. The teacher jumps over a book happily. The student jumps over a tower gracefully. The teacher builds a book quickly. The student eats a fence happily.",
  },
  {
    locationId: "item21677",
    locationName: "item21677",
    locationAddress: "item21677",
    ratings: null,
    lat: 59.25109243573375,
    lng: 0.04402972452940723,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3677",
    tags: [],
    locationDescription: " The man eats the horizon gracefully.",
  },
  {
    locationId: "item21678",
    locationName: "item21678",
    locationAddress: "item21678",
    ratings: null,
    lat: 56.31426364396913,
    lng: -5.477355703931226,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3678",
    tags: [],
    locationDescription:
      " The man jumps over the cake lazily. The student eats the cake angrily. A dog looks at the horizon angrily. The teacher looks at a fence gracefully. The man jumps over the road silently.",
  },
  {
    locationId: "item21679",
    locationName: "item21679",
    locationAddress: "item21679",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 4.39 },
    ],
    lat: 57.138737821706954,
    lng: 0.2915407250706501,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3679",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds the road angrily. The cat eats a fence angrily. A dog writes a fence lazily. The teacher jumps over the cake lazily.",
  },
  {
    locationId: "item21680",
    locationName: "item21680",
    locationAddress: "item21680",
    ratings: [
      { who: "Similar identities", rating: 1.89 },
      { who: "All perspectives", rating: 4.27 },
    ],
    lat: 57.89044421788418,
    lng: -7.44298934284632,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3680",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher jumps over a tower happily. The student runs towards the cake angrily.",
  },
  {
    locationId: "item21681",
    locationName: "item21681",
    locationAddress: "item21681",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 2.02 },
    ],
    lat: 54.72864558071282,
    lng: -7.476853840002004,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3681",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The cat runs towards the horizon angrily.",
  },
  {
    locationId: "item21682",
    locationName: "item21682",
    locationAddress: "item21682",
    ratings: null,
    lat: 54.47298114112988,
    lng: -5.065371364471792,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3682",
    tags: [],
    locationDescription:
      " The man eats a fence lazily. The man eats the horizon lazily. The student builds a tower quickly. A dog runs towards a fence gracefully.",
  },
  {
    locationId: "item21683",
    locationName: "item21683",
    locationAddress: "item21683",
    ratings: null,
    lat: 55.330025565314635,
    lng: -7.706316046035535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3683",
    tags: [],
    locationDescription:
      " The teacher runs towards the road happily. The man runs towards the horizon angrily.",
  },
  {
    locationId: "item21684",
    locationName: "item21684",
    locationAddress: "item21684",
    ratings: [
      { who: "Similar identities", rating: 0.13 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 60.69772140462757,
    lng: -6.4055558452258285,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3684",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The man jumps over a book happily.",
  },
  {
    locationId: "item21685",
    locationName: "item21685",
    locationAddress: "item21685",
    ratings: [
      { who: "Similar identities", rating: 4.05 },
      { who: "All perspectives", rating: 2.55 },
    ],
    lat: 55.84120323779163,
    lng: -5.523054679198326,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3685",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog eats the cake happily. The student runs towards a tower silently. The teacher jumps over a book lazily. The student writes a book happily. A dog builds the cake quickly.",
  },
  {
    locationId: "item21686",
    locationName: "item21686",
    locationAddress: "item21686",
    ratings: null,
    lat: 52.893156511921504,
    lng: 1.0838069122433502,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3686",
    tags: [],
    locationDescription:
      " A woman jumps over the cake silently. A dog jumps over a book happily.",
  },
  {
    locationId: "item21687",
    locationName: "item21687",
    locationAddress: "item21687",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 3.2 },
    ],
    lat: 55.15702285537645,
    lng: -4.66638873286192,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3687",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man jumps over a tower gracefully. The teacher looks at a tower quickly. A woman eats a book angrily.",
  },
  {
    locationId: "item21688",
    locationName: "item21688",
    locationAddress: "item21688",
    ratings: null,
    lat: 51.22150367304931,
    lng: 1.42942274387139,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3688",
    tags: [],
    locationDescription:
      " The man builds the road gracefully. The man builds a fence lazily. A dog jumps over a fence angrily. The teacher eats the cake angrily. The man writes a book silently.",
  },
  {
    locationId: "item21689",
    locationName: "item21689",
    locationAddress: "item21689",
    ratings: [
      { who: "Similar identities", rating: 1.8 },
      { who: "All perspectives", rating: 3.64 },
    ],
    lat: 53.29315578339122,
    lng: 1.1791574681255632,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3689",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription: " A woman runs towards a book lazily.",
  },
  {
    locationId: "item21690",
    locationName: "item21690",
    locationAddress: "item21690",
    ratings: null,
    lat: 58.0030372626771,
    lng: -3.807550434117818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3690",
    tags: [],
    locationDescription:
      " A woman jumps over a tower lazily. The teacher looks at the road happily. A woman eats a book quickly. The teacher runs towards a fence quickly. The cat writes the cake angrily.",
  },
  {
    locationId: "item21691",
    locationName: "item21691",
    locationAddress: "item21691",
    ratings: [
      { who: "Similar identities", rating: 0.06 },
      { who: "All perspectives", rating: 0.89 },
    ],
    lat: 50.55975909057565,
    lng: -5.163963554507751,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3691",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man builds the horizon angrily. The cat runs towards a tower lazily. The teacher jumps over the road silently.",
  },
  {
    locationId: "item21692",
    locationName: "item21692",
    locationAddress: "item21692",
    ratings: null,
    lat: 55.06636796417257,
    lng: -2.1869258073275084,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3692",
    tags: [],
    locationDescription: " The teacher runs towards a fence silently.",
  },
  {
    locationId: "item21693",
    locationName: "item21693",
    locationAddress: "item21693",
    ratings: null,
    lat: 54.59222360841706,
    lng: -1.0321697781489663,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3693",
    tags: [],
    locationDescription:
      " A woman writes a book angrily. The man runs towards a tower lazily.",
  },
  {
    locationId: "item21694",
    locationName: "item21694",
    locationAddress: "item21694",
    ratings: [
      { who: "Similar identities", rating: 0.86 },
      { who: "All perspectives", rating: 4.18 },
    ],
    lat: 55.562603186023274,
    lng: -4.855193676643569,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3694",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds a fence gracefully. The man builds the road lazily.",
  },
  {
    locationId: "item21695",
    locationName: "item21695",
    locationAddress: "item21695",
    ratings: null,
    lat: 58.22758103813561,
    lng: -1.1716039778032714,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3695",
    tags: [],
    locationDescription:
      " The man jumps over a book quickly. A woman runs towards the horizon silently.",
  },
  {
    locationId: "item21696",
    locationName: "item21696",
    locationAddress: "item21696",
    ratings: null,
    lat: 60.06308406474582,
    lng: -6.805421401798818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3696",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence angrily. A dog builds a book quickly. The man writes the horizon lazily.",
  },
  {
    locationId: "item21697",
    locationName: "item21697",
    locationAddress: "item21697",
    ratings: null,
    lat: 52.643582367466635,
    lng: -7.867880478875632,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3697",
    tags: [],
    locationDescription:
      " The cat eats the cake angrily. The man builds a tower quickly. The cat runs towards a tower gracefully. A woman eats a book gracefully. The cat eats a tower lazily.",
  },
  {
    locationId: "item21698",
    locationName: "item21698",
    locationAddress: "item21698",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 0.45 },
    ],
    lat: 55.92088821701812,
    lng: 0.6169896403023589,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3698",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes a tower gracefully. The cat writes the cake happily. The student builds the horizon angrily. The teacher builds a fence silently. The cat looks at a tower silently.",
  },
  {
    locationId: "item21699",
    locationName: "item21699",
    locationAddress: "item21699",
    ratings: null,
    lat: 55.736939529325284,
    lng: -0.5811328251188694,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3699",
    tags: [],
    locationDescription:
      " The cat looks at the cake silently. The cat builds a fence quickly. The student writes the horizon silently.",
  },
  {
    locationId: "item21700",
    locationName: "item21700",
    locationAddress: "item21700",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 0.53 },
    ],
    lat: 58.17911680680988,
    lng: -3.526145289052498,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3700",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man builds the cake happily. The cat builds the horizon gracefully. The man runs towards a tower lazily. A dog eats the horizon angrily.",
  },
  {
    locationId: "item21701",
    locationName: "item21701",
    locationAddress: "item21701",
    ratings: null,
    lat: 56.68437967375941,
    lng: 0.06995273404019464,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3701",
    tags: [],
    locationDescription:
      " The student jumps over a tower angrily. The cat eats the road silently.",
  },
  {
    locationId: "item21702",
    locationName: "item21702",
    locationAddress: "item21702",
    ratings: null,
    lat: 52.60614121268699,
    lng: -5.025753302074458,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3702",
    tags: [],
    locationDescription:
      " The student builds a book quickly. A woman eats a fence happily. The student looks at a fence quickly. The cat eats a fence quickly.",
  },
  {
    locationId: "item21703",
    locationName: "item21703",
    locationAddress: "item21703",
    ratings: [
      { who: "Similar identities", rating: 1.13 },
      { who: "All perspectives", rating: 4.26 },
    ],
    lat: 56.886904641052105,
    lng: -6.045175793730401,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3703",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The man runs towards a tower quickly. The cat looks at the cake lazily. The cat eats a book gracefully. A dog writes the road quickly.",
  },
  {
    locationId: "item21704",
    locationName: "item21704",
    locationAddress: "item21704",
    ratings: [
      { who: "Similar identities", rating: 1.14 },
      { who: "All perspectives", rating: 0.43 },
    ],
    lat: 55.09819554472642,
    lng: -8.28519330870238,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3704",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman writes a tower lazily. The cat eats the cake happily. A woman writes a tower quickly. The student writes the road happily.",
  },
  {
    locationId: "item21705",
    locationName: "item21705",
    locationAddress: "item21705",
    ratings: null,
    lat: 54.72767204149199,
    lng: -7.139951481604476,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3705",
    tags: [],
    locationDescription:
      " The man looks at the road lazily. The teacher builds the cake gracefully.",
  },
  {
    locationId: "item21706",
    locationName: "item21706",
    locationAddress: "item21706",
    ratings: null,
    lat: 51.498172643318455,
    lng: -6.732123275715683,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3706",
    tags: [],
    locationDescription:
      " The teacher looks at a book quickly. The teacher eats a tower silently. A dog writes the cake gracefully.",
  },
  {
    locationId: "item21707",
    locationName: "item21707",
    locationAddress: "item21707",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 2.59 },
    ],
    lat: 50.16789193788211,
    lng: -5.559608771818691,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3707",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat writes a book quickly. The man writes a book gracefully.",
  },
  {
    locationId: "item21708",
    locationName: "item21708",
    locationAddress: "item21708",
    ratings: null,
    lat: 55.432284071296216,
    lng: -3.6448902097682794,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3708",
    tags: [],
    locationDescription:
      " The man runs towards a tower gracefully. A dog jumps over the road gracefully.",
  },
  {
    locationId: "item21709",
    locationName: "item21709",
    locationAddress: "item21709",
    ratings: [
      { who: "Similar identities", rating: 1.18 },
      { who: "All perspectives", rating: 0.51 },
    ],
    lat: 55.59778775402789,
    lng: 1.6366568361153355,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3709",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds a fence happily. The man looks at a tower angrily. The student writes a tower angrily.",
  },
  {
    locationId: "item21710",
    locationName: "item21710",
    locationAddress: "item21710",
    ratings: [
      { who: "Similar identities", rating: 0.35 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 54.265854291160245,
    lng: 0.6501643401574171,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3710",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at the road lazily. A woman jumps over the road angrily.",
  },
  {
    locationId: "item21711",
    locationName: "item21711",
    locationAddress: "item21711",
    ratings: [
      { who: "Similar identities", rating: 1.73 },
      { who: "All perspectives", rating: 3.09 },
    ],
    lat: 60.86199742900313,
    lng: -7.03533637522588,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3711",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat looks at a fence gracefully. The man builds the cake silently. A dog eats a book quickly. The student writes a fence angrily.",
  },
  {
    locationId: "item21712",
    locationName: "item21712",
    locationAddress: "item21712",
    ratings: null,
    lat: 50.43709516277359,
    lng: -5.780278858051343,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3712",
    tags: [],
    locationDescription:
      " The student builds the road gracefully. The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item21713",
    locationName: "item21713",
    locationAddress: "item21713",
    ratings: null,
    lat: 56.478913840641866,
    lng: -2.1182531482133617,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3713",
    tags: [],
    locationDescription:
      " The cat writes a fence happily. The student builds the horizon gracefully.",
  },
  {
    locationId: "item21714",
    locationName: "item21714",
    locationAddress: "item21714",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 49.999304689479736,
    lng: -0.04032482034492091,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3714",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats a book gracefully. The cat runs towards a book quickly. A dog eats a book angrily. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item21715",
    locationName: "item21715",
    locationAddress: "item21715",
    ratings: [
      { who: "Similar identities", rating: 0.8 },
      { who: "All perspectives", rating: 3.55 },
    ],
    lat: 53.86978977168902,
    lng: -8.101882781165552,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3715",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man writes the cake silently. The cat eats the horizon happily. The man builds the horizon quickly. The man writes a fence silently.",
  },
  {
    locationId: "item21716",
    locationName: "item21716",
    locationAddress: "item21716",
    ratings: [
      { who: "Similar identities", rating: 2.63 },
      { who: "All perspectives", rating: 4.35 },
    ],
    lat: 58.608970489825595,
    lng: -0.7788891644497635,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3716",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The teacher eats the cake angrily.",
  },
  {
    locationId: "item21717",
    locationName: "item21717",
    locationAddress: "item21717",
    ratings: [
      { who: "Similar identities", rating: 3.58 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 56.49055106993387,
    lng: 1.5149658877274028,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3717",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman builds a tower happily. The man looks at the horizon silently. A woman runs towards a tower lazily. The man looks at a book angrily. The man writes the cake quickly.",
  },
  {
    locationId: "item21718",
    locationName: "item21718",
    locationAddress: "item21718",
    ratings: [
      { who: "Similar identities", rating: 1.94 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 51.84038503237145,
    lng: -5.461088734580031,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3718",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at the cake gracefully. The man jumps over a fence silently. The cat jumps over the cake lazily. The man jumps over a fence gracefully.",
  },
  {
    locationId: "item21719",
    locationName: "item21719",
    locationAddress: "item21719",
    ratings: [
      { who: "Similar identities", rating: 2.33 },
      { who: "All perspectives", rating: 4.42 },
    ],
    lat: 54.5316192929585,
    lng: -7.028702520129608,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3719",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student runs towards the road gracefully. The teacher runs towards a tower angrily. The student looks at a tower quickly. The student writes a tower silently. A dog jumps over the road gracefully.",
  },
  {
    locationId: "item21720",
    locationName: "item21720",
    locationAddress: "item21720",
    ratings: [
      { who: "Similar identities", rating: 0.07 },
      { who: "All perspectives", rating: 3.81 },
    ],
    lat: 59.97294428113905,
    lng: 0.038048158132831134,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3720",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher runs towards the cake silently.",
  },
  {
    locationId: "item21721",
    locationName: "item21721",
    locationAddress: "item21721",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 0.71 },
    ],
    lat: 56.20493979631766,
    lng: -2.5625906616894802,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3721",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher looks at the cake quickly.",
  },
  {
    locationId: "item21722",
    locationName: "item21722",
    locationAddress: "item21722",
    ratings: null,
    lat: 58.55546586133734,
    lng: -6.388123752370782,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3722",
    tags: [],
    locationDescription: " The teacher looks at the cake quickly.",
  },
  {
    locationId: "item21723",
    locationName: "item21723",
    locationAddress: "item21723",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 3.23 },
    ],
    lat: 55.37331993544785,
    lng: -4.463480938619063,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3723",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man runs towards the road gracefully.",
  },
  {
    locationId: "item21724",
    locationName: "item21724",
    locationAddress: "item21724",
    ratings: null,
    lat: 55.17669161163611,
    lng: 0.39205492432540545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3724",
    tags: [],
    locationDescription:
      " A dog eats a fence silently. A woman runs towards a fence silently. The man eats a book happily. The teacher builds a fence gracefully. The man writes the cake quickly.",
  },
  {
    locationId: "item21725",
    locationName: "item21725",
    locationAddress: "item21725",
    ratings: null,
    lat: 58.49765760259065,
    lng: 1.2139726563868294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3725",
    tags: [],
    locationDescription:
      " The man writes a book happily. The cat builds a fence happily. The teacher writes the horizon gracefully. A dog writes the road happily.",
  },
  {
    locationId: "item21726",
    locationName: "item21726",
    locationAddress: "item21726",
    ratings: null,
    lat: 58.11147492683524,
    lng: 0.14840616298521248,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3726",
    tags: [],
    locationDescription:
      " The student runs towards the road happily. The man writes a fence gracefully. The man eats a tower gracefully.",
  },
  {
    locationId: "item21727",
    locationName: "item21727",
    locationAddress: "item21727",
    ratings: [
      { who: "Similar identities", rating: 2.7 },
      { who: "All perspectives", rating: 3.31 },
    ],
    lat: 57.71718998925827,
    lng: -3.6155639804219675,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3727",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog looks at the road quickly. The cat builds a fence quickly.",
  },
  {
    locationId: "item21728",
    locationName: "item21728",
    locationAddress: "item21728",
    ratings: [
      { who: "Similar identities", rating: 1.0 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 51.85748629259273,
    lng: -8.436617686369292,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3728",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog runs towards the horizon lazily. The teacher runs towards the horizon angrily. The man runs towards the road happily.",
  },
  {
    locationId: "item21729",
    locationName: "item21729",
    locationAddress: "item21729",
    ratings: [
      { who: "Similar identities", rating: 0.07 },
      { who: "All perspectives", rating: 1.5 },
    ],
    lat: 51.77339504567946,
    lng: -6.397404681200161,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3729",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student runs towards the horizon angrily. The student builds the horizon silently. The cat eats a book quickly. A woman runs towards a book lazily.",
  },
  {
    locationId: "item21730",
    locationName: "item21730",
    locationAddress: "item21730",
    ratings: null,
    lat: 53.7766730559837,
    lng: -4.897222027790887,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3730",
    tags: [],
    locationDescription:
      " The man jumps over the horizon silently. The teacher looks at the horizon lazily.",
  },
  {
    locationId: "item21731",
    locationName: "item21731",
    locationAddress: "item21731",
    ratings: null,
    lat: 56.9048253908761,
    lng: -6.949678078040267,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3731",
    tags: [],
    locationDescription:
      " The man writes the road angrily. A woman eats a fence happily. The cat runs towards the road silently.",
  },
  {
    locationId: "item21732",
    locationName: "item21732",
    locationAddress: "item21732",
    ratings: [
      { who: "Similar identities", rating: 4.48 },
      { who: "All perspectives", rating: 3.38 },
    ],
    lat: 59.6104300492873,
    lng: -4.728816679508276,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3732",
    tags: [{ label: "accessible" }],
    locationDescription: " A woman writes the road angrily.",
  },
  {
    locationId: "item21733",
    locationName: "item21733",
    locationAddress: "item21733",
    ratings: null,
    lat: 59.4470204216274,
    lng: -1.8636988021556347,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3733",
    tags: [],
    locationDescription:
      " A dog runs towards a book lazily. A woman builds the cake gracefully.",
  },
  {
    locationId: "item21734",
    locationName: "item21734",
    locationAddress: "item21734",
    ratings: null,
    lat: 52.12441853239959,
    lng: -2.453327370396642,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3734",
    tags: [],
    locationDescription:
      " The cat looks at a fence quickly. A woman eats a tower angrily.",
  },
  {
    locationId: "item21735",
    locationName: "item21735",
    locationAddress: "item21735",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 4.41 },
    ],
    lat: 57.202954275149246,
    lng: -7.932768521861714,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3735",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man eats a tower angrily.",
  },
  {
    locationId: "item21736",
    locationName: "item21736",
    locationAddress: "item21736",
    ratings: null,
    lat: 53.07791246197545,
    lng: -3.8654972698899623,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3736",
    tags: [],
    locationDescription:
      " The student eats a book happily. The cat builds the road silently. The man eats a book quickly. A woman jumps over a book gracefully. The cat eats a book gracefully.",
  },
  {
    locationId: "item21737",
    locationName: "item21737",
    locationAddress: "item21737",
    ratings: [
      { who: "Similar identities", rating: 1.65 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 53.72863257923641,
    lng: -5.548662382164032,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3737",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A woman eats a tower lazily. The cat looks at the horizon happily. The student looks at the cake gracefully. A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item21738",
    locationName: "item21738",
    locationAddress: "item21738",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 55.2327028539819,
    lng: 1.6429608515082013,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3738",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds the road happily. The teacher writes the horizon silently. A dog looks at the cake happily. The teacher runs towards the horizon happily.",
  },
  {
    locationId: "item21739",
    locationName: "item21739",
    locationAddress: "item21739",
    ratings: [
      { who: "Similar identities", rating: 0.37 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 56.32532198457727,
    lng: -7.902486267373187,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3739",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog eats a book silently. The student jumps over the road silently. A dog eats a book happily. The cat runs towards a book angrily. A dog looks at a fence lazily.",
  },
  {
    locationId: "item21740",
    locationName: "item21740",
    locationAddress: "item21740",
    ratings: [
      { who: "Similar identities", rating: 1.42 },
      { who: "All perspectives", rating: 2.8 },
    ],
    lat: 59.13272751262218,
    lng: -0.3980224523182798,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3740",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog jumps over a book silently.",
  },
  {
    locationId: "item21741",
    locationName: "item21741",
    locationAddress: "item21741",
    ratings: null,
    lat: 54.32219240940794,
    lng: -4.049009114382173,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3741",
    tags: [],
    locationDescription:
      " A dog builds the horizon gracefully. The man jumps over a book lazily. A dog writes a book quickly. The cat runs towards the horizon angrily. A dog looks at the horizon angrily.",
  },
  {
    locationId: "item21742",
    locationName: "item21742",
    locationAddress: "item21742",
    ratings: null,
    lat: 56.35072797930923,
    lng: -1.6626431441592358,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3742",
    tags: [],
    locationDescription:
      " The teacher builds the horizon quickly. The cat jumps over the horizon happily. The student looks at a fence lazily.",
  },
  {
    locationId: "item21743",
    locationName: "item21743",
    locationAddress: "item21743",
    ratings: null,
    lat: 58.91010332968991,
    lng: -2.1185534011053013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3743",
    tags: [],
    locationDescription:
      " A woman looks at a book angrily. The teacher runs towards the road lazily. A woman runs towards a fence silently. A dog jumps over a tower silently. The student builds a fence gracefully.",
  },
  {
    locationId: "item21744",
    locationName: "item21744",
    locationAddress: "item21744",
    ratings: [
      { who: "Similar identities", rating: 3.37 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 60.38578173033089,
    lng: -2.718627303323717,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3744",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats the horizon gracefully. The teacher writes the road quickly. The cat looks at a fence quickly.",
  },
  {
    locationId: "item21745",
    locationName: "item21745",
    locationAddress: "item21745",
    ratings: [
      { who: "Similar identities", rating: 1.83 },
      { who: "All perspectives", rating: 2.07 },
    ],
    lat: 58.376582461732724,
    lng: -4.111671189976079,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3745",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The student runs towards the road happily. The cat builds the cake silently. A woman looks at the cake happily.",
  },
  {
    locationId: "item21746",
    locationName: "item21746",
    locationAddress: "item21746",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 4.96 },
    ],
    lat: 53.742341211097504,
    lng: -3.3008029115753885,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3746",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes a tower happily. The man eats a fence lazily.",
  },
  {
    locationId: "item21747",
    locationName: "item21747",
    locationAddress: "item21747",
    ratings: null,
    lat: 51.92401225637497,
    lng: -5.173953837887973,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3747",
    tags: [],
    locationDescription:
      " The man runs towards a tower angrily. The cat looks at the horizon gracefully. The man eats the horizon happily. The student eats a book happily. A dog runs towards the cake gracefully.",
  },
  {
    locationId: "item21748",
    locationName: "item21748",
    locationAddress: "item21748",
    ratings: null,
    lat: 52.1233392844309,
    lng: -4.421520758379777,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3748",
    tags: [],
    locationDescription:
      " A woman eats a tower angrily. The cat builds a book angrily. The cat writes the road happily. The cat looks at a tower quickly. The man builds a tower happily.",
  },
  {
    locationId: "item21749",
    locationName: "item21749",
    locationAddress: "item21749",
    ratings: [
      { who: "Similar identities", rating: 3.46 },
      { who: "All perspectives", rating: 2.06 },
    ],
    lat: 57.05819096339694,
    lng: -6.380496914287162,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3749",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog looks at a tower gracefully. A dog eats a tower gracefully. The teacher jumps over the horizon angrily.",
  },
  {
    locationId: "item21750",
    locationName: "item21750",
    locationAddress: "item21750",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 3.91 },
    ],
    lat: 52.015223166308296,
    lng: -3.3458862266131266,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3750",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A woman eats the cake happily.",
  },
  {
    locationId: "item21751",
    locationName: "item21751",
    locationAddress: "item21751",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 1.69 },
    ],
    lat: 55.2756835797836,
    lng: -6.919959641906497,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3751",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher builds the road angrily. The teacher looks at the horizon lazily. The cat writes a tower quickly. A woman looks at a tower gracefully.",
  },
  {
    locationId: "item21752",
    locationName: "item21752",
    locationAddress: "item21752",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 0.23 },
    ],
    lat: 53.31555463154559,
    lng: -0.8622911138155791,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3752",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman jumps over a fence angrily. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item21753",
    locationName: "item21753",
    locationAddress: "item21753",
    ratings: null,
    lat: 54.51450317460525,
    lng: -2.6564558736900006,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3753",
    tags: [],
    locationDescription:
      " A woman looks at the road quickly. A dog writes the road happily.",
  },
  {
    locationId: "item21754",
    locationName: "item21754",
    locationAddress: "item21754",
    ratings: null,
    lat: 51.31737960241875,
    lng: -0.23513162978559699,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3754",
    tags: [],
    locationDescription:
      " The student looks at the horizon happily. The student writes the road happily. A dog writes the cake quickly. A woman looks at a book happily.",
  },
  {
    locationId: "item21755",
    locationName: "item21755",
    locationAddress: "item21755",
    ratings: [
      { who: "Similar identities", rating: 0.97 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 55.857139747321185,
    lng: -4.996174325634632,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3755",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at the cake quickly. A woman eats a fence angrily. A dog jumps over a fence gracefully.",
  },
  {
    locationId: "item21756",
    locationName: "item21756",
    locationAddress: "item21756",
    ratings: [
      { who: "Similar identities", rating: 2.81 },
      { who: "All perspectives", rating: 2.58 },
    ],
    lat: 56.34338749939329,
    lng: 1.599106930573603,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3756",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds a tower happily. The student jumps over a fence angrily.",
  },
  {
    locationId: "item21757",
    locationName: "item21757",
    locationAddress: "item21757",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 52.77540515253525,
    lng: -7.643495412812284,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3757",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The cat jumps over the road quickly.",
  },
  {
    locationId: "item21758",
    locationName: "item21758",
    locationAddress: "item21758",
    ratings: null,
    lat: 59.08259390429382,
    lng: -6.158815056053395,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3758",
    tags: [],
    locationDescription:
      " A dog runs towards the cake gracefully. A woman runs towards a fence gracefully.",
  },
  {
    locationId: "item21759",
    locationName: "item21759",
    locationAddress: "item21759",
    ratings: [
      { who: "Similar identities", rating: 2.28 },
      { who: "All perspectives", rating: 2.52 },
    ],
    lat: 51.583347480789826,
    lng: -4.032428018374082,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3759",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman jumps over the horizon quickly. The man writes a tower quickly. The man looks at the road silently. The teacher looks at the horizon happily. The student builds a fence happily.",
  },
  {
    locationId: "item21760",
    locationName: "item21760",
    locationAddress: "item21760",
    ratings: null,
    lat: 51.569856708678394,
    lng: -5.287886838676151,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3760",
    tags: [],
    locationDescription: " The teacher looks at the road silently.",
  },
  {
    locationId: "item21761",
    locationName: "item21761",
    locationAddress: "item21761",
    ratings: null,
    lat: 50.74504974273042,
    lng: -1.2100576905660603,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3761",
    tags: [],
    locationDescription: " The teacher looks at the cake quickly.",
  },
  {
    locationId: "item21762",
    locationName: "item21762",
    locationAddress: "item21762",
    ratings: null,
    lat: 51.39527606093644,
    lng: -2.136583965298068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3762",
    tags: [],
    locationDescription:
      " A dog writes a book angrily. The student jumps over the horizon quickly. The student runs towards a tower gracefully. A dog builds the road quickly.",
  },
  {
    locationId: "item21763",
    locationName: "item21763",
    locationAddress: "item21763",
    ratings: null,
    lat: 57.161591554631414,
    lng: -4.685683515967616,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3763",
    tags: [],
    locationDescription:
      " The student eats a tower angrily. A woman writes a fence quickly. A dog runs towards the road lazily. The teacher builds the cake quickly. The student eats a book angrily.",
  },
  {
    locationId: "item21764",
    locationName: "item21764",
    locationAddress: "item21764",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 2.15 },
    ],
    lat: 53.585800752822614,
    lng: -4.2174051476650565,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3764",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a tower gracefully. The man writes the road angrily. The student writes a tower quickly. The cat writes a tower quickly. The cat writes the road gracefully.",
  },
  {
    locationId: "item21765",
    locationName: "item21765",
    locationAddress: "item21765",
    ratings: null,
    lat: 58.63859525073242,
    lng: -3.535751336410568,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3765",
    tags: [],
    locationDescription:
      " The man eats a book gracefully. A dog jumps over a fence gracefully. The teacher looks at the road quickly. A dog eats the road gracefully.",
  },
  {
    locationId: "item21766",
    locationName: "item21766",
    locationAddress: "item21766",
    ratings: null,
    lat: 57.684934116563426,
    lng: -1.3503272191055204,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3766",
    tags: [],
    locationDescription:
      " The student jumps over a book silently. The student jumps over the horizon gracefully.",
  },
  {
    locationId: "item21767",
    locationName: "item21767",
    locationAddress: "item21767",
    ratings: null,
    lat: 55.265431253378246,
    lng: -0.6998858112379089,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3767",
    tags: [],
    locationDescription:
      " The man runs towards the cake happily. The student builds the horizon quickly.",
  },
  {
    locationId: "item21768",
    locationName: "item21768",
    locationAddress: "item21768",
    ratings: [
      { who: "Similar identities", rating: 4.92 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 53.34942156463662,
    lng: -4.2149615657740815,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3768",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over a fence angrily. The man jumps over the horizon quickly. A dog jumps over the cake quickly. The cat writes the road gracefully. The cat eats the cake lazily.",
  },
  {
    locationId: "item21769",
    locationName: "item21769",
    locationAddress: "item21769",
    ratings: null,
    lat: 56.07196141390787,
    lng: 1.5538127614495831,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3769",
    tags: [],
    locationDescription:
      " The cat eats the cake angrily. A woman runs towards a tower quickly. A woman looks at a fence happily. The teacher runs towards a book quickly. The cat eats the horizon silently.",
  },
  {
    locationId: "item21770",
    locationName: "item21770",
    locationAddress: "item21770",
    ratings: [
      { who: "Similar identities", rating: 2.11 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 55.362724477762576,
    lng: 0.17853742361216085,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3770",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman looks at the road happily. A woman runs towards the cake quickly. A woman jumps over the cake angrily. The student jumps over the cake quickly. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item21771",
    locationName: "item21771",
    locationAddress: "item21771",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 2.22 },
    ],
    lat: 56.65875954161474,
    lng: 0.8712752160929771,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3771",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat jumps over the cake angrily. A woman writes a fence quickly. The teacher eats the cake lazily. The cat builds the cake lazily.",
  },
  {
    locationId: "item21772",
    locationName: "item21772",
    locationAddress: "item21772",
    ratings: null,
    lat: 52.44796101145897,
    lng: -8.260069179608346,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3772",
    tags: [],
    locationDescription:
      " A dog looks at the cake happily. A dog writes a book gracefully. A woman eats a tower angrily.",
  },
  {
    locationId: "item21773",
    locationName: "item21773",
    locationAddress: "item21773",
    ratings: null,
    lat: 60.225875266049904,
    lng: -6.0093871227381115,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3773",
    tags: [],
    locationDescription:
      " A dog eats the cake quickly. A woman eats the horizon lazily. The teacher builds the cake silently. The man writes the cake gracefully.",
  },
  {
    locationId: "item21774",
    locationName: "item21774",
    locationAddress: "item21774",
    ratings: null,
    lat: 51.39237370793406,
    lng: -5.6575309588267535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3774",
    tags: [],
    locationDescription: " The cat looks at a book quickly.",
  },
  {
    locationId: "item21775",
    locationName: "item21775",
    locationAddress: "item21775",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 56.484412814857734,
    lng: -0.26114240432445257,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item3775",
    tags: [{ label: "accessible" }],
    locationDescription: " A woman builds a book happily.",
  },
  {
    locationId: "item21776",
    locationName: "item21776",
    locationAddress: "item21776",
    ratings: [
      { who: "Similar identities", rating: 4.41 },
      { who: "All perspectives", rating: 2.1 },
    ],
    lat: 58.92357992473375,
    lng: -6.4282033416992075,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3776",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats a book gracefully. A dog jumps over a tower quickly. A dog writes a fence angrily. The teacher runs towards a book lazily.",
  },
  {
    locationId: "item21777",
    locationName: "item21777",
    locationAddress: "item21777",
    ratings: null,
    lat: 60.76125188905124,
    lng: -8.212509084925738,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3777",
    tags: [],
    locationDescription: " The student builds a fence angrily.",
  },
  {
    locationId: "item21778",
    locationName: "item21778",
    locationAddress: "item21778",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 54.52834505868593,
    lng: -2.874099427911025,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3778",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student builds a book quickly. A dog runs towards the cake angrily. A woman writes a fence lazily. The cat jumps over the road gracefully. The cat jumps over a fence angrily.",
  },
  {
    locationId: "item21779",
    locationName: "item21779",
    locationAddress: "item21779",
    ratings: [
      { who: "Similar identities", rating: 0.13 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 56.66069090268351,
    lng: -5.833533847077561,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3779",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A dog eats a tower angrily.",
  },
  {
    locationId: "item21780",
    locationName: "item21780",
    locationAddress: "item21780",
    ratings: null,
    lat: 52.103058425990085,
    lng: -1.298679202663127,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3780",
    tags: [],
    locationDescription:
      " The student builds the cake silently. The student writes the cake gracefully. A dog runs towards a tower silently.",
  },
  {
    locationId: "item21781",
    locationName: "item21781",
    locationAddress: "item21781",
    ratings: [
      { who: "Similar identities", rating: 2.11 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 52.93660201600179,
    lng: 0.8899401064817258,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3781",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds a tower lazily. The cat jumps over the cake lazily. The man writes the road happily.",
  },
  {
    locationId: "item21782",
    locationName: "item21782",
    locationAddress: "item21782",
    ratings: [
      { who: "Similar identities", rating: 1.29 },
      { who: "All perspectives", rating: 2.87 },
    ],
    lat: 55.65885093939046,
    lng: -5.287724738194116,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3782",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student jumps over a fence happily. The man eats the road silently. The student builds a tower gracefully. The student eats the road happily.",
  },
  {
    locationId: "item21783",
    locationName: "item21783",
    locationAddress: "item21783",
    ratings: null,
    lat: 59.931854728868394,
    lng: 0.8610191470908113,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3783",
    tags: [],
    locationDescription:
      " A dog runs towards the road silently. A dog writes the horizon gracefully. A woman looks at a book silently. A dog runs towards a book quickly. A woman jumps over a tower happily.",
  },
  {
    locationId: "item21784",
    locationName: "item21784",
    locationAddress: "item21784",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 3.61 },
    ],
    lat: 52.378487581077046,
    lng: -5.521121857695723,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3784",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a tower gracefully. The teacher looks at a tower silently. The cat jumps over the road quickly. A woman runs towards the cake happily.",
  },
  {
    locationId: "item21785",
    locationName: "item21785",
    locationAddress: "item21785",
    ratings: [
      { who: "Similar identities", rating: 0.7 },
      { who: "All perspectives", rating: 0.67 },
    ],
    lat: 60.588001557681984,
    lng: -0.7142846728025063,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3785",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The student jumps over the road silently.",
  },
  {
    locationId: "item21786",
    locationName: "item21786",
    locationAddress: "item21786",
    ratings: null,
    lat: 54.483102641998634,
    lng: -8.084799418157303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3786",
    tags: [],
    locationDescription:
      " The cat builds a book gracefully. A dog writes a book silently. The cat writes a tower silently.",
  },
  {
    locationId: "item21787",
    locationName: "item21787",
    locationAddress: "item21787",
    ratings: [
      { who: "Similar identities", rating: 3.17 },
      { who: "All perspectives", rating: 0.42 },
    ],
    lat: 52.44534577222633,
    lng: -4.3042853207672485,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3787",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man writes a fence happily. The cat builds a book silently. The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item21788",
    locationName: "item21788",
    locationAddress: "item21788",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 51.21571614616798,
    lng: -7.6529652755795015,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3788",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The man looks at the road quickly. The man eats a tower happily. The student looks at the road quickly. A woman eats a book silently. The student builds a tower happily.",
  },
  {
    locationId: "item21789",
    locationName: "item21789",
    locationAddress: "item21789",
    ratings: null,
    lat: 58.588876719281906,
    lng: -6.361050918206362,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3789",
    tags: [],
    locationDescription:
      " A dog eats a fence lazily. The student looks at a book angrily.",
  },
  {
    locationId: "item21790",
    locationName: "item21790",
    locationAddress: "item21790",
    ratings: null,
    lat: 57.860371842261245,
    lng: -7.77615378251296,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3790",
    tags: [],
    locationDescription:
      " The student eats a tower quickly. A dog jumps over the road lazily. The teacher looks at the horizon angrily. A woman writes the road lazily.",
  },
  {
    locationId: "item21791",
    locationName: "item21791",
    locationAddress: "item21791",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 0.34 },
    ],
    lat: 54.07667333526625,
    lng: -0.28664626395591597,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3791",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The cat writes a tower gracefully. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item21792",
    locationName: "item21792",
    locationAddress: "item21792",
    ratings: [
      { who: "Similar identities", rating: 3.16 },
      { who: "All perspectives", rating: 1.97 },
    ],
    lat: 56.62221215422702,
    lng: -0.3044480419926128,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3792",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student runs towards the road happily. The cat writes a fence gracefully.",
  },
  {
    locationId: "item21793",
    locationName: "item21793",
    locationAddress: "item21793",
    ratings: [
      { who: "Similar identities", rating: 3.83 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 52.065990556328344,
    lng: -1.4000095027791701,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3793",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man jumps over a fence happily. The student jumps over a fence lazily. The cat writes a book quickly. The student runs towards a book happily.",
  },
  {
    locationId: "item21794",
    locationName: "item21794",
    locationAddress: "item21794",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 3.49 },
    ],
    lat: 56.35752707701132,
    lng: -4.718375952413092,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3794",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes a tower happily. The teacher jumps over a fence happily. A woman jumps over a fence angrily. A woman looks at the cake angrily. A woman builds a fence lazily.",
  },
  {
    locationId: "item21795",
    locationName: "item21795",
    locationAddress: "item21795",
    ratings: [
      { who: "Similar identities", rating: 3.87 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 51.87783665442493,
    lng: -6.460701701096165,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3795",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The teacher builds a fence lazily.",
  },
  {
    locationId: "item21796",
    locationName: "item21796",
    locationAddress: "item21796",
    ratings: [
      { who: "Similar identities", rating: 2.36 },
      { who: "All perspectives", rating: 0.42 },
    ],
    lat: 60.68312882222894,
    lng: 1.7932276582858808,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3796",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes a tower angrily. The man eats the road angrily. The student runs towards a tower angrily. The cat builds a book happily.",
  },
  {
    locationId: "item21797",
    locationName: "item21797",
    locationAddress: "item21797",
    ratings: null,
    lat: 60.25466502845833,
    lng: -0.4297673531323678,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3797",
    tags: [],
    locationDescription:
      " The cat runs towards a book lazily. The teacher builds the horizon angrily. A dog looks at the cake angrily. The teacher jumps over the cake quickly.",
  },
  {
    locationId: "item21798",
    locationName: "item21798",
    locationAddress: "item21798",
    ratings: null,
    lat: 50.29654550097786,
    lng: -2.1528682879341803,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3798",
    tags: [],
    locationDescription:
      " The cat writes a tower quickly. The student builds a fence lazily. The teacher jumps over a book quickly.",
  },
  {
    locationId: "item21799",
    locationName: "item21799",
    locationAddress: "item21799",
    ratings: [
      { who: "Similar identities", rating: 4.1 },
      { who: "All perspectives", rating: 4.0 },
    ],
    lat: 50.187818947148294,
    lng: -0.1478240741978727,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3799",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog looks at the road silently. A dog jumps over the horizon lazily. The man jumps over a book happily. A woman looks at a book gracefully.",
  },
  {
    locationId: "item21800",
    locationName: "item21800",
    locationAddress: "item21800",
    ratings: [
      { who: "Similar identities", rating: 1.26 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 57.920416173556724,
    lng: -4.303979403220114,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3800",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A woman writes the road gracefully.",
  },
  {
    locationId: "item21801",
    locationName: "item21801",
    locationAddress: "item21801",
    ratings: [
      { who: "Similar identities", rating: 2.23 },
      { who: "All perspectives", rating: 3.62 },
    ],
    lat: 50.907544723647256,
    lng: -6.302595505522122,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3801",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the road angrily. A woman eats the cake silently. The teacher runs towards a fence angrily.",
  },
  {
    locationId: "item21802",
    locationName: "item21802",
    locationAddress: "item21802",
    ratings: null,
    lat: 59.93046844041555,
    lng: -4.362655190967414,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3802",
    tags: [],
    locationDescription:
      " A dog writes a fence gracefully. The teacher jumps over a fence quickly. The teacher builds a book happily. The student eats the road quickly. A dog looks at the horizon lazily.",
  },
  {
    locationId: "item21803",
    locationName: "item21803",
    locationAddress: "item21803",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 0.76 },
    ],
    lat: 58.033999102822975,
    lng: -2.279259703409064,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3803",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The man eats the road happily.",
  },
  {
    locationId: "item21804",
    locationName: "item21804",
    locationAddress: "item21804",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 56.12884440270166,
    lng: 1.5905162307328577,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3804",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman runs towards a tower quickly. The student builds a tower gracefully. The student writes a fence quickly.",
  },
  {
    locationId: "item21805",
    locationName: "item21805",
    locationAddress: "item21805",
    ratings: [
      { who: "Similar identities", rating: 4.6 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 57.86175869561892,
    lng: -6.033147484869447,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3805",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The teacher writes the horizon angrily. A dog runs towards the cake happily. The man builds a tower gracefully. The teacher builds the cake lazily.",
  },
  {
    locationId: "item21806",
    locationName: "item21806",
    locationAddress: "item21806",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 2.2 },
    ],
    lat: 53.472897889656416,
    lng: -4.226190794557769,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3806",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a fence silently. The student eats the horizon quickly. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item21807",
    locationName: "item21807",
    locationAddress: "item21807",
    ratings: null,
    lat: 50.2181338185065,
    lng: -7.373639008293836,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3807",
    tags: [],
    locationDescription: " The cat eats the road silently.",
  },
  {
    locationId: "item21808",
    locationName: "item21808",
    locationAddress: "item21808",
    ratings: null,
    lat: 60.865658621266604,
    lng: -1.5138048010259553,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3808",
    tags: [],
    locationDescription:
      " A dog writes the road angrily. The teacher writes the road quickly. The teacher runs towards the road lazily. The man builds a tower lazily.",
  },
  {
    locationId: "item21809",
    locationName: "item21809",
    locationAddress: "item21809",
    ratings: null,
    lat: 50.99869963079336,
    lng: 1.7723677816536405,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3809",
    tags: [],
    locationDescription: " The man jumps over the road happily.",
  },
  {
    locationId: "item21810",
    locationName: "item21810",
    locationAddress: "item21810",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 0.99 },
    ],
    lat: 59.8154720771497,
    lng: -4.51160571650032,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3810",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The man writes the road gracefully. The teacher builds the horizon lazily. A woman runs towards a book gracefully. The student eats the horizon angrily. The student looks at a tower gracefully.",
  },
  {
    locationId: "item21811",
    locationName: "item21811",
    locationAddress: "item21811",
    ratings: null,
    lat: 50.927551534888195,
    lng: -4.579607131001697,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3811",
    tags: [],
    locationDescription:
      " The teacher writes a book lazily. A dog builds the road angrily. The student runs towards the cake angrily. The student jumps over a fence silently.",
  },
  {
    locationId: "item21812",
    locationName: "item21812",
    locationAddress: "item21812",
    ratings: [
      { who: "Similar identities", rating: 3.57 },
      { who: "All perspectives", rating: 4.65 },
    ],
    lat: 57.98442047319144,
    lng: -5.885640992461399,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3812",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog jumps over a book lazily.",
  },
  {
    locationId: "item21813",
    locationName: "item21813",
    locationAddress: "item21813",
    ratings: null,
    lat: 58.256167534816235,
    lng: -0.01504688438016899,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3813",
    tags: [],
    locationDescription:
      " A woman writes the horizon happily. The cat runs towards a book silently. A woman runs towards a book angrily. The student eats the road gracefully.",
  },
  {
    locationId: "item21814",
    locationName: "item21814",
    locationAddress: "item21814",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 60.61912613618172,
    lng: -0.6656462897024413,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3814",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher eats the cake gracefully. A dog eats a fence angrily.",
  },
  {
    locationId: "item21815",
    locationName: "item21815",
    locationAddress: "item21815",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 3.59 },
    ],
    lat: 59.466464416786735,
    lng: -3.4468141004586474,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3815",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a book gracefully. The man looks at a fence silently. A woman writes the cake silently. The teacher looks at the cake happily.",
  },
  {
    locationId: "item21816",
    locationName: "item21816",
    locationAddress: "item21816",
    ratings: [
      { who: "Similar identities", rating: 0.91 },
      { who: "All perspectives", rating: 4.63 },
    ],
    lat: 59.76794628051554,
    lng: -6.848354691892503,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3816",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student runs towards a book lazily. The student writes the road happily. The student jumps over the cake gracefully.",
  },
  {
    locationId: "item21817",
    locationName: "item21817",
    locationAddress: "item21817",
    ratings: null,
    lat: 53.75535068503784,
    lng: -0.6876601791936876,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3817",
    tags: [],
    locationDescription: " A woman jumps over a book silently.",
  },
  {
    locationId: "item21818",
    locationName: "item21818",
    locationAddress: "item21818",
    ratings: null,
    lat: 57.69172457053113,
    lng: -2.0492882408450344,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3818",
    tags: [],
    locationDescription:
      " A woman builds a book silently. The student builds the road gracefully. The teacher builds the road quickly. The teacher writes a book lazily.",
  },
  {
    locationId: "item21819",
    locationName: "item21819",
    locationAddress: "item21819",
    ratings: null,
    lat: 59.939594822614374,
    lng: 1.1393944493308261,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3819",
    tags: [],
    locationDescription:
      " The cat runs towards a fence silently. The cat eats a book happily.",
  },
  {
    locationId: "item21820",
    locationName: "item21820",
    locationAddress: "item21820",
    ratings: null,
    lat: 52.15486815758232,
    lng: 0.09970715307580313,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3820",
    tags: [],
    locationDescription:
      " A dog jumps over the cake silently. The cat runs towards a fence silently.",
  },
  {
    locationId: "item21821",
    locationName: "item21821",
    locationAddress: "item21821",
    ratings: [
      { who: "Similar identities", rating: 1.14 },
      { who: "All perspectives", rating: 0.86 },
    ],
    lat: 53.23507564376796,
    lng: -5.222757668837543,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3821",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man writes a fence silently. A dog eats the horizon angrily. The cat builds a book lazily. The man jumps over a fence silently.",
  },
  {
    locationId: "item21822",
    locationName: "item21822",
    locationAddress: "item21822",
    ratings: null,
    lat: 56.80049667019868,
    lng: -6.858700433346832,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3822",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon silently. The student runs towards the cake silently.",
  },
  {
    locationId: "item21823",
    locationName: "item21823",
    locationAddress: "item21823",
    ratings: [
      { who: "Similar identities", rating: 3.92 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 50.433096389211336,
    lng: -5.909087598995603,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3823",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards a book gracefully. The cat builds a tower gracefully. The man looks at a book gracefully. A dog runs towards a book lazily. A woman runs towards the horizon angrily.",
  },
  {
    locationId: "item21824",
    locationName: "item21824",
    locationAddress: "item21824",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 4.76 },
    ],
    lat: 55.781999492099075,
    lng: -8.289461419312808,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3824",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The cat eats a tower happily. The student jumps over the horizon gracefully.",
  },
  {
    locationId: "item21825",
    locationName: "item21825",
    locationAddress: "item21825",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 59.246556843970495,
    lng: -4.884793362619099,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3825",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student builds the road gracefully. A dog looks at the road silently. The cat eats a book lazily. The student jumps over the road quickly. A dog jumps over the road gracefully.",
  },
  {
    locationId: "item21826",
    locationName: "item21826",
    locationAddress: "item21826",
    ratings: [
      { who: "Similar identities", rating: 1.78 },
      { who: "All perspectives", rating: 2.48 },
    ],
    lat: 56.23028061576454,
    lng: -1.6895177188902952,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3826",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards the horizon silently. A woman eats the road gracefully.",
  },
  {
    locationId: "item21827",
    locationName: "item21827",
    locationAddress: "item21827",
    ratings: [
      { who: "Similar identities", rating: 4.97 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 56.83636268135062,
    lng: -7.73925529726668,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3827",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher jumps over the road quickly. The teacher builds a book angrily. A woman runs towards the horizon lazily. The man looks at a fence angrily. A dog builds the road happily.",
  },
  {
    locationId: "item21828",
    locationName: "item21828",
    locationAddress: "item21828",
    ratings: [
      { who: "Similar identities", rating: 4.49 },
      { who: "All perspectives", rating: 4.34 },
    ],
    lat: 53.28612627743835,
    lng: -0.8148345387902971,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3828",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman runs towards the road happily. The man eats the cake silently. A woman builds a fence quickly.",
  },
  {
    locationId: "item21829",
    locationName: "item21829",
    locationAddress: "item21829",
    ratings: [
      { who: "Similar identities", rating: 1.46 },
      { who: "All perspectives", rating: 0.25 },
    ],
    lat: 60.69786282632393,
    lng: 0.42828359359819146,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3829",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards a book lazily. The man writes the road quickly. The man jumps over a tower gracefully.",
  },
  {
    locationId: "item21830",
    locationName: "item21830",
    locationAddress: "item21830",
    ratings: [
      { who: "Similar identities", rating: 1.21 },
      { who: "All perspectives", rating: 4.85 },
    ],
    lat: 50.386714831603136,
    lng: 1.2633022784500003,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3830",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds the road lazily. A dog writes the horizon quickly. The teacher eats a book quickly.",
  },
  {
    locationId: "item21831",
    locationName: "item21831",
    locationAddress: "item21831",
    ratings: null,
    lat: 57.982438928606854,
    lng: -5.056729049079966,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3831",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon quickly. The man looks at the horizon lazily.",
  },
  {
    locationId: "item21832",
    locationName: "item21832",
    locationAddress: "item21832",
    ratings: [
      { who: "Similar identities", rating: 3.23 },
      { who: "All perspectives", rating: 0.9 },
    ],
    lat: 50.050435381027235,
    lng: -6.567782411281903,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3832",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes the road angrily. A dog builds a fence lazily. The teacher builds the horizon happily.",
  },
  {
    locationId: "item21833",
    locationName: "item21833",
    locationAddress: "item21833",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 2.02 },
    ],
    lat: 60.3433352646077,
    lng: -6.876365423403226,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3833",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student looks at the road gracefully. A woman builds a fence gracefully.",
  },
  {
    locationId: "item21834",
    locationName: "item21834",
    locationAddress: "item21834",
    ratings: [
      { who: "Similar identities", rating: 1.15 },
      { who: "All perspectives", rating: 4.15 },
    ],
    lat: 56.139871215320426,
    lng: 0.13326356193617173,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item3834",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The student eats a fence silently. The student looks at a tower quickly. The cat writes the horizon happily.",
  },
  {
    locationId: "item21835",
    locationName: "item21835",
    locationAddress: "item21835",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 58.84076795602234,
    lng: -2.6663010210120586,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3835",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A woman runs towards the horizon lazily. The student looks at the cake angrily. A dog writes the horizon gracefully. A woman looks at a fence happily. The teacher jumps over a fence angrily.",
  },
  {
    locationId: "item21836",
    locationName: "item21836",
    locationAddress: "item21836",
    ratings: null,
    lat: 57.32869813768112,
    lng: -6.655608658732466,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3836",
    tags: [],
    locationDescription:
      " The teacher writes a book angrily. The student jumps over the cake angrily. A woman eats a tower angrily.",
  },
  {
    locationId: "item21837",
    locationName: "item21837",
    locationAddress: "item21837",
    ratings: [
      { who: "Similar identities", rating: 2.6 },
      { who: "All perspectives", rating: 0.68 },
    ],
    lat: 50.94410577065341,
    lng: 0.2503180295958458,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3837",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man runs towards a book angrily.",
  },
  {
    locationId: "item21838",
    locationName: "item21838",
    locationAddress: "item21838",
    ratings: null,
    lat: 58.54317048707249,
    lng: -6.009400788400283,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3838",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon gracefully. The teacher jumps over the cake angrily. The student writes the road happily. The cat eats a fence quickly.",
  },
  {
    locationId: "item21839",
    locationName: "item21839",
    locationAddress: "item21839",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 4.31 },
    ],
    lat: 57.25168994918077,
    lng: 0.5013442656811318,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3839",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat jumps over the cake quickly. The teacher eats a fence lazily. The student jumps over the cake happily. The teacher looks at the horizon happily. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item21840",
    locationName: "item21840",
    locationAddress: "item21840",
    ratings: [
      { who: "Similar identities", rating: 4.27 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 51.66968715527041,
    lng: -1.9764812082185275,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3840",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student jumps over the cake gracefully. The teacher builds a book silently. The teacher runs towards the road happily.",
  },
  {
    locationId: "item21841",
    locationName: "item21841",
    locationAddress: "item21841",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 0.61 },
    ],
    lat: 55.26735185989138,
    lng: -2.9546969221250166,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3841",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The student writes the cake gracefully. The cat builds the cake quickly.",
  },
  {
    locationId: "item21842",
    locationName: "item21842",
    locationAddress: "item21842",
    ratings: null,
    lat: 54.170059921047894,
    lng: -0.42758871976903556,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3842",
    tags: [],
    locationDescription:
      " The teacher runs towards the road lazily. The student writes a fence lazily.",
  },
  {
    locationId: "item21843",
    locationName: "item21843",
    locationAddress: "item21843",
    ratings: [
      { who: "Similar identities", rating: 1.78 },
      { who: "All perspectives", rating: 2.35 },
    ],
    lat: 52.416096371220846,
    lng: -6.586976547238327,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3843",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats the horizon angrily. A woman jumps over a fence quickly.",
  },
  {
    locationId: "item21844",
    locationName: "item21844",
    locationAddress: "item21844",
    ratings: null,
    lat: 60.36232896819827,
    lng: 1.2126461721888404,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3844",
    tags: [],
    locationDescription:
      " The man eats a tower lazily. The student writes a tower gracefully. The man eats a book gracefully.",
  },
  {
    locationId: "item21845",
    locationName: "item21845",
    locationAddress: "item21845",
    ratings: null,
    lat: 51.47321354792312,
    lng: -7.88862749388243,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3845",
    tags: [],
    locationDescription:
      " The cat looks at the road lazily. The student jumps over the horizon lazily. The teacher eats a fence quickly. The cat eats the cake angrily. A dog eats the road lazily.",
  },
  {
    locationId: "item21846",
    locationName: "item21846",
    locationAddress: "item21846",
    ratings: null,
    lat: 58.565685209948136,
    lng: -5.923293989764298,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3846",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon silently. The cat looks at a book lazily. The man writes the road silently.",
  },
  {
    locationId: "item21847",
    locationName: "item21847",
    locationAddress: "item21847",
    ratings: null,
    lat: 57.222010386102724,
    lng: -0.3342982675102597,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3847",
    tags: [],
    locationDescription:
      " The man writes a tower lazily. The man builds a book silently. The student writes a fence gracefully. The man eats a tower lazily. The student runs towards the horizon silently.",
  },
  {
    locationId: "item21848",
    locationName: "item21848",
    locationAddress: "item21848",
    ratings: null,
    lat: 58.35244546983744,
    lng: 0.879303887169689,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3848",
    tags: [],
    locationDescription: " The man jumps over a book gracefully.",
  },
  {
    locationId: "item21849",
    locationName: "item21849",
    locationAddress: "item21849",
    ratings: [
      { who: "Similar identities", rating: 2.32 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 51.15234892588448,
    lng: -4.2947165079858305,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3849",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The man runs towards a fence angrily. The teacher runs towards a book angrily.",
  },
  {
    locationId: "item21850",
    locationName: "item21850",
    locationAddress: "item21850",
    ratings: [
      { who: "Similar identities", rating: 1.09 },
      { who: "All perspectives", rating: 4.21 },
    ],
    lat: 59.555242000487745,
    lng: -7.604543178804876,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3850",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman writes a fence happily. The student writes a fence lazily. A dog writes a fence gracefully.",
  },
  {
    locationId: "item21851",
    locationName: "item21851",
    locationAddress: "item21851",
    ratings: [
      { who: "Similar identities", rating: 0.83 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 55.340066762988826,
    lng: -6.688295050375897,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3851",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat eats the horizon angrily. The cat builds the road silently.",
  },
  {
    locationId: "item21852",
    locationName: "item21852",
    locationAddress: "item21852",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 1.31 },
    ],
    lat: 59.53590096108711,
    lng: 1.0558242069157036,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3852",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man builds a fence silently.",
  },
  {
    locationId: "item21853",
    locationName: "item21853",
    locationAddress: "item21853",
    ratings: null,
    lat: 51.31863323019006,
    lng: 0.9076561625162931,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3853",
    tags: [],
    locationDescription:
      " A woman eats the cake lazily. The student eats the road silently. The student eats a fence angrily. A woman jumps over the cake happily. The man looks at a book quickly.",
  },
  {
    locationId: "item21854",
    locationName: "item21854",
    locationAddress: "item21854",
    ratings: null,
    lat: 53.513277441625505,
    lng: -4.01285884983056,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3854",
    tags: [],
    locationDescription:
      " The student writes a book happily. The cat eats the cake lazily. The cat runs towards a tower gracefully. A dog jumps over a book angrily. The man eats the cake silently.",
  },
  {
    locationId: "item21855",
    locationName: "item21855",
    locationAddress: "item21855",
    ratings: null,
    lat: 56.442217633995874,
    lng: -3.1916355702988577,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3855",
    tags: [],
    locationDescription:
      " The teacher looks at a tower lazily. A woman looks at the cake happily. The cat writes a fence angrily.",
  },
  {
    locationId: "item21856",
    locationName: "item21856",
    locationAddress: "item21856",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 4.95 },
    ],
    lat: 60.08110516732869,
    lng: -7.772823325627214,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3856",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at a fence silently. The student runs towards the horizon happily. The student runs towards a book quickly. The cat builds the horizon silently. The teacher eats the road silently.",
  },
  {
    locationId: "item21857",
    locationName: "item21857",
    locationAddress: "item21857",
    ratings: null,
    lat: 55.786765085044976,
    lng: -6.664221548356947,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3857",
    tags: [],
    locationDescription:
      " The student writes the cake silently. A dog builds the road lazily.",
  },
  {
    locationId: "item21858",
    locationName: "item21858",
    locationAddress: "item21858",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 0.67 },
    ],
    lat: 50.5626375553196,
    lng: -3.2634995670522606,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3858",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog writes a tower angrily. The student eats the cake angrily.",
  },
  {
    locationId: "item21859",
    locationName: "item21859",
    locationAddress: "item21859",
    ratings: null,
    lat: 54.745557062862716,
    lng: -6.01668123976761,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3859",
    tags: [],
    locationDescription:
      " The cat runs towards the road lazily. The man eats a tower gracefully.",
  },
  {
    locationId: "item21860",
    locationName: "item21860",
    locationAddress: "item21860",
    ratings: [
      { who: "Similar identities", rating: 2.42 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 51.714452586246914,
    lng: -8.024958574575523,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3860",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A woman writes a tower happily.",
  },
  {
    locationId: "item21861",
    locationName: "item21861",
    locationAddress: "item21861",
    ratings: null,
    lat: 52.14422421581955,
    lng: -6.031729295486071,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3861",
    tags: [],
    locationDescription:
      " The man builds the road lazily. The student runs towards the horizon angrily. The teacher looks at a book happily.",
  },
  {
    locationId: "item21862",
    locationName: "item21862",
    locationAddress: "item21862",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 57.668239616459495,
    lng: -3.7842013947052484,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3862",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The cat builds the horizon angrily.",
  },
  {
    locationId: "item21863",
    locationName: "item21863",
    locationAddress: "item21863",
    ratings: null,
    lat: 57.43525069383046,
    lng: -4.4593126897571045,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3863",
    tags: [],
    locationDescription:
      " A woman runs towards a book happily. The cat jumps over a book silently. The man writes a tower silently. A woman jumps over a book gracefully. The teacher writes a tower angrily.",
  },
  {
    locationId: "item21864",
    locationName: "item21864",
    locationAddress: "item21864",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 55.6107271994798,
    lng: 0.568861106113765,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3864",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over a book lazily. A woman jumps over the road gracefully. A dog eats the cake angrily. The teacher runs towards the cake gracefully.",
  },
  {
    locationId: "item21865",
    locationName: "item21865",
    locationAddress: "item21865",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 56.142313584319794,
    lng: -1.8217507634411856,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3865",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat jumps over a fence lazily. The teacher jumps over the road happily. A woman jumps over a tower gracefully.",
  },
  {
    locationId: "item21866",
    locationName: "item21866",
    locationAddress: "item21866",
    ratings: null,
    lat: 55.42146355954429,
    lng: -2.6105190953868203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3866",
    tags: [],
    locationDescription:
      " The student looks at the cake quickly. The student builds the cake angrily.",
  },
  {
    locationId: "item21867",
    locationName: "item21867",
    locationAddress: "item21867",
    ratings: [
      { who: "Similar identities", rating: 4.13 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 55.00865526436246,
    lng: 0.38444981459473304,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3867",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman eats a tower lazily.",
  },
  {
    locationId: "item21868",
    locationName: "item21868",
    locationAddress: "item21868",
    ratings: [
      { who: "Similar identities", rating: 0.9 },
      { who: "All perspectives", rating: 3.17 },
    ],
    lat: 56.544459322628065,
    lng: -1.1097442510285571,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3868",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes the road silently. The man writes a book angrily. The student eats the cake happily. The student writes the road angrily. The cat builds the cake happily.",
  },
  {
    locationId: "item21869",
    locationName: "item21869",
    locationAddress: "item21869",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 4.59 },
    ],
    lat: 58.95374624709497,
    lng: -7.964099852980102,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3869",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at the cake quickly. A woman eats a fence gracefully. The student looks at a fence gracefully.",
  },
  {
    locationId: "item21870",
    locationName: "item21870",
    locationAddress: "item21870",
    ratings: null,
    lat: 55.81452600963026,
    lng: -2.2371516929348987,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3870",
    tags: [],
    locationDescription:
      " The cat eats a fence silently. The student builds the road gracefully. The cat runs towards the road quickly. The student looks at the road angrily.",
  },
  {
    locationId: "item21871",
    locationName: "item21871",
    locationAddress: "item21871",
    ratings: null,
    lat: 55.43230115577873,
    lng: -1.2869938383289368,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3871",
    tags: [],
    locationDescription: " The student looks at a fence silently.",
  },
  {
    locationId: "item21872",
    locationName: "item21872",
    locationAddress: "item21872",
    ratings: null,
    lat: 52.11817457558944,
    lng: -1.5376097534285647,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3872",
    tags: [],
    locationDescription:
      " The cat eats a book happily. The cat looks at a book silently. A dog jumps over a fence silently. The teacher runs towards the road angrily. A dog jumps over a tower happily.",
  },
  {
    locationId: "item21873",
    locationName: "item21873",
    locationAddress: "item21873",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 60.4873478846372,
    lng: -1.278682080170813,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3873",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The student eats the road angrily.",
  },
  {
    locationId: "item21874",
    locationName: "item21874",
    locationAddress: "item21874",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 59.26052470587781,
    lng: 1.7617504794139478,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3874",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The teacher looks at a tower happily. The student writes the horizon gracefully.",
  },
  {
    locationId: "item21875",
    locationName: "item21875",
    locationAddress: "item21875",
    ratings: null,
    lat: 50.82012364218887,
    lng: -2.4038086722940886,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3875",
    tags: [],
    locationDescription:
      " A woman eats the cake quickly. The man jumps over the road silently. The man runs towards the road angrily. A dog writes a tower gracefully. The cat runs towards the road silently.",
  },
  {
    locationId: "item21876",
    locationName: "item21876",
    locationAddress: "item21876",
    ratings: [
      { who: "Similar identities", rating: 4.96 },
      { who: "All perspectives", rating: 2.07 },
    ],
    lat: 54.520924740517316,
    lng: -6.360676371009255,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3876",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman eats the cake lazily.",
  },
  {
    locationId: "item21877",
    locationName: "item21877",
    locationAddress: "item21877",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 51.53787521541571,
    lng: -4.998923093606798,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3877",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman runs towards a tower silently. The teacher eats a book lazily. The teacher looks at the cake quickly.",
  },
  {
    locationId: "item21878",
    locationName: "item21878",
    locationAddress: "item21878",
    ratings: null,
    lat: 54.32258643299601,
    lng: -3.9950979660618717,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3878",
    tags: [],
    locationDescription: " The student writes the road lazily.",
  },
  {
    locationId: "item21879",
    locationName: "item21879",
    locationAddress: "item21879",
    ratings: null,
    lat: 54.63686584578943,
    lng: -0.8618314909733336,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3879",
    tags: [],
    locationDescription:
      " The teacher writes a tower happily. A dog writes the road lazily. The teacher writes a fence angrily. The cat looks at a fence happily. The student builds the road lazily.",
  },
  {
    locationId: "item21880",
    locationName: "item21880",
    locationAddress: "item21880",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 56.332020734343885,
    lng: -5.236549958131059,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3880",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat jumps over a tower silently. The student writes the horizon gracefully. The student looks at the horizon happily.",
  },
  {
    locationId: "item21881",
    locationName: "item21881",
    locationAddress: "item21881",
    ratings: [
      { who: "Similar identities", rating: 1.63 },
      { who: "All perspectives", rating: 2.8 },
    ],
    lat: 53.05916120853779,
    lng: -0.6731795535447977,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3881",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats the horizon quickly. The cat runs towards a book lazily. The cat jumps over a fence quickly. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item21882",
    locationName: "item21882",
    locationAddress: "item21882",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 55.00962150432955,
    lng: -5.543132168060227,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3882",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The man jumps over the horizon lazily. The man jumps over the cake gracefully. The student writes a book lazily.",
  },
  {
    locationId: "item21883",
    locationName: "item21883",
    locationAddress: "item21883",
    ratings: [
      { who: "Similar identities", rating: 1.84 },
      { who: "All perspectives", rating: 4.53 },
    ],
    lat: 56.914467057031175,
    lng: -1.432694392211232,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3883",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The man builds a tower lazily. The man jumps over the horizon quickly. The man runs towards a tower silently.",
  },
  {
    locationId: "item21884",
    locationName: "item21884",
    locationAddress: "item21884",
    ratings: [
      { who: "Similar identities", rating: 3.05 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 51.18812854351763,
    lng: 1.3737979362399937,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3884",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The teacher jumps over a tower happily.",
  },
  {
    locationId: "item21885",
    locationName: "item21885",
    locationAddress: "item21885",
    ratings: [
      { who: "Similar identities", rating: 3.23 },
      { who: "All perspectives", rating: 3.86 },
    ],
    lat: 57.070628929930194,
    lng: -7.794177521251206,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3885",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman writes the horizon happily.",
  },
  {
    locationId: "item21886",
    locationName: "item21886",
    locationAddress: "item21886",
    ratings: null,
    lat: 52.421363072321924,
    lng: 0.548622715774604,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3886",
    tags: [],
    locationDescription:
      " A dog writes a fence silently. The cat looks at the road angrily.",
  },
  {
    locationId: "item21887",
    locationName: "item21887",
    locationAddress: "item21887",
    ratings: null,
    lat: 51.8470824355599,
    lng: -0.974863662420832,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3887",
    tags: [],
    locationDescription: " The man looks at a book lazily.",
  },
  {
    locationId: "item21888",
    locationName: "item21888",
    locationAddress: "item21888",
    ratings: null,
    lat: 53.93064678132572,
    lng: -8.49725598231873,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3888",
    tags: [],
    locationDescription:
      " The student builds a book angrily. The student builds the road happily.",
  },
  {
    locationId: "item21889",
    locationName: "item21889",
    locationAddress: "item21889",
    ratings: null,
    lat: 60.5718091068353,
    lng: -3.8056788292136385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3889",
    tags: [],
    locationDescription: " The teacher writes a fence happily.",
  },
  {
    locationId: "item21890",
    locationName: "item21890",
    locationAddress: "item21890",
    ratings: null,
    lat: 50.65793308335293,
    lng: -6.155513853593758,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3890",
    tags: [],
    locationDescription:
      " The student eats a book lazily. A dog eats the road angrily. The teacher looks at the cake lazily. The teacher eats the cake quickly. The cat writes the road gracefully.",
  },
  {
    locationId: "item21891",
    locationName: "item21891",
    locationAddress: "item21891",
    ratings: null,
    lat: 52.51713061811523,
    lng: 0.6735320457946816,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3891",
    tags: [],
    locationDescription:
      " A woman looks at a tower quickly. A dog looks at a fence angrily. A dog builds the road silently. The student looks at the road gracefully.",
  },
  {
    locationId: "item21892",
    locationName: "item21892",
    locationAddress: "item21892",
    ratings: [
      { who: "Similar identities", rating: 4.73 },
      { who: "All perspectives", rating: 4.95 },
    ],
    lat: 58.182869626142455,
    lng: -4.681315556498817,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3892",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher eats the road gracefully. A woman runs towards a tower lazily. The student builds the horizon angrily.",
  },
  {
    locationId: "item21893",
    locationName: "item21893",
    locationAddress: "item21893",
    ratings: null,
    lat: 51.983758359861014,
    lng: -0.3909554206295969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3893",
    tags: [],
    locationDescription:
      " The teacher eats the road lazily. A dog jumps over a book angrily. The cat eats a fence lazily. The cat looks at a book happily. The cat jumps over the cake gracefully.",
  },
  {
    locationId: "item21894",
    locationName: "item21894",
    locationAddress: "item21894",
    ratings: null,
    lat: 57.13748532469191,
    lng: -3.6137659566746265,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3894",
    tags: [],
    locationDescription:
      " A woman runs towards the cake gracefully. The student runs towards the road angrily.",
  },
  {
    locationId: "item21895",
    locationName: "item21895",
    locationAddress: "item21895",
    ratings: [
      { who: "Similar identities", rating: 1.21 },
      { who: "All perspectives", rating: 4.44 },
    ],
    lat: 59.75070004057352,
    lng: -7.058882939775531,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item3895",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher builds the horizon happily. The teacher writes the horizon happily. The man looks at the cake lazily.",
  },
  {
    locationId: "item21896",
    locationName: "item21896",
    locationAddress: "item21896",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 4.27 },
    ],
    lat: 59.20220966871198,
    lng: -8.05739094919149,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3896",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds the cake quickly. The teacher jumps over the cake silently. The student jumps over a tower silently.",
  },
  {
    locationId: "item21897",
    locationName: "item21897",
    locationAddress: "item21897",
    ratings: null,
    lat: 60.19758652628655,
    lng: -1.6244083310931918,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3897",
    tags: [],
    locationDescription: " The teacher jumps over the road lazily.",
  },
  {
    locationId: "item21898",
    locationName: "item21898",
    locationAddress: "item21898",
    ratings: null,
    lat: 51.85016122573765,
    lng: -7.018173154713345,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3898",
    tags: [],
    locationDescription:
      " A dog builds the road angrily. The student jumps over a book quickly. The man runs towards the road silently. A dog builds the cake happily.",
  },
  {
    locationId: "item21899",
    locationName: "item21899",
    locationAddress: "item21899",
    ratings: [
      { who: "Similar identities", rating: 0.36 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 53.2315747758679,
    lng: -7.22010846076541,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3899",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man eats a tower silently. The teacher runs towards a book happily. The cat eats the road silently. The teacher builds a fence angrily. The cat jumps over the road quickly.",
  },
  {
    locationId: "item21900",
    locationName: "item21900",
    locationAddress: "item21900",
    ratings: null,
    lat: 52.16845627462122,
    lng: 0.8768098110269573,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3900",
    tags: [],
    locationDescription:
      " The teacher eats the cake lazily. The man builds the horizon silently.",
  },
  {
    locationId: "item21901",
    locationName: "item21901",
    locationAddress: "item21901",
    ratings: null,
    lat: 53.93031345730576,
    lng: -2.508421763491567,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3901",
    tags: [],
    locationDescription:
      " The man builds the cake quickly. The cat builds a book angrily. The cat writes the cake silently. The man writes a fence quickly. A dog jumps over a fence lazily.",
  },
  {
    locationId: "item21902",
    locationName: "item21902",
    locationAddress: "item21902",
    ratings: null,
    lat: 51.47209257907721,
    lng: -4.596782313492824,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3902",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower happily. A dog writes a tower angrily. A dog jumps over a book happily.",
  },
  {
    locationId: "item21903",
    locationName: "item21903",
    locationAddress: "item21903",
    ratings: [
      { who: "Similar identities", rating: 4.94 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 56.62204052383623,
    lng: 0.3318320195803395,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item3903",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman runs towards the road happily. A dog builds the cake lazily. The man builds the cake silently. The teacher looks at the road angrily. The teacher writes a book silently.",
  },
  {
    locationId: "item21904",
    locationName: "item21904",
    locationAddress: "item21904",
    ratings: null,
    lat: 58.66158465129637,
    lng: -5.35855839160104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3904",
    tags: [],
    locationDescription:
      " The student writes the road quickly. A woman builds the horizon angrily. A dog writes the road gracefully. A woman looks at a fence angrily. A dog writes the road silently.",
  },
  {
    locationId: "item21905",
    locationName: "item21905",
    locationAddress: "item21905",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 57.121426268119826,
    lng: -1.712180410453965,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3905",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The cat runs towards the horizon lazily. The student jumps over the cake quickly.",
  },
  {
    locationId: "item21906",
    locationName: "item21906",
    locationAddress: "item21906",
    ratings: [
      { who: "Similar identities", rating: 0.59 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 54.62826705080518,
    lng: -1.1863064444489027,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3906",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes the road quickly. The cat eats the road angrily.",
  },
  {
    locationId: "item21907",
    locationName: "item21907",
    locationAddress: "item21907",
    ratings: [
      { who: "Similar identities", rating: 0.42 },
      { who: "All perspectives", rating: 3.4 },
    ],
    lat: 51.288399697881545,
    lng: 1.121022856772532,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3907",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man jumps over the road silently. The student writes the horizon lazily. The man builds a fence lazily. A woman looks at a fence angrily.",
  },
  {
    locationId: "item21908",
    locationName: "item21908",
    locationAddress: "item21908",
    ratings: [
      { who: "Similar identities", rating: 2.56 },
      { who: "All perspectives", rating: 4.04 },
    ],
    lat: 54.95770541254271,
    lng: -2.692772441253637,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3908",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student writes a tower gracefully. The man builds the cake silently. The man looks at a fence silently.",
  },
  {
    locationId: "item21909",
    locationName: "item21909",
    locationAddress: "item21909",
    ratings: null,
    lat: 52.17776042151944,
    lng: -6.662218500377718,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3909",
    tags: [],
    locationDescription:
      " The student writes the road silently. The cat looks at the horizon happily. A woman eats a fence angrily.",
  },
  {
    locationId: "item21910",
    locationName: "item21910",
    locationAddress: "item21910",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 56.9353408694207,
    lng: -2.0640923222311116,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item3910",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over the horizon silently. A dog writes a fence happily. The man builds a tower quickly. A woman writes a book angrily. A dog builds the road silently.",
  },
  {
    locationId: "item21911",
    locationName: "item21911",
    locationAddress: "item21911",
    ratings: [
      { who: "Similar identities", rating: 1.21 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 56.78628125329477,
    lng: -4.293234151565914,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3911",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats a fence silently. The student writes a tower silently. The teacher eats the horizon silently. The man runs towards a fence angrily.",
  },
  {
    locationId: "item21912",
    locationName: "item21912",
    locationAddress: "item21912",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 54.94298348476348,
    lng: 0.020108180701891243,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3912",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman jumps over the cake angrily. A dog eats a fence quickly. The teacher writes a fence silently. The student builds the road silently.",
  },
  {
    locationId: "item21913",
    locationName: "item21913",
    locationAddress: "item21913",
    ratings: null,
    lat: 55.92976609803742,
    lng: -2.6516251988258306,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3913",
    tags: [],
    locationDescription:
      " A woman looks at the cake quickly. The teacher runs towards the cake happily. A woman builds a book lazily. A dog eats the cake angrily. A dog builds a fence gracefully.",
  },
  {
    locationId: "item21914",
    locationName: "item21914",
    locationAddress: "item21914",
    ratings: [
      { who: "Similar identities", rating: 3.88 },
      { who: "All perspectives", rating: 0.22 },
    ],
    lat: 58.01308086747729,
    lng: -5.5601529188369705,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3914",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The man eats the cake angrily.",
  },
  {
    locationId: "item21915",
    locationName: "item21915",
    locationAddress: "item21915",
    ratings: null,
    lat: 59.80584938066043,
    lng: -8.478073926631145,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3915",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence silently. The man looks at a tower happily. The teacher jumps over the horizon silently. The teacher eats a book angrily.",
  },
  {
    locationId: "item21916",
    locationName: "item21916",
    locationAddress: "item21916",
    ratings: null,
    lat: 51.81638507669574,
    lng: -3.4231431736467846,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3916",
    tags: [],
    locationDescription:
      " The teacher writes the horizon gracefully. The man runs towards a tower lazily.",
  },
  {
    locationId: "item21917",
    locationName: "item21917",
    locationAddress: "item21917",
    ratings: null,
    lat: 57.30063091828917,
    lng: -5.684225215484516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3917",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon angrily. The student eats the road quickly. The teacher looks at the road quickly. The student runs towards the horizon quickly.",
  },
  {
    locationId: "item21918",
    locationName: "item21918",
    locationAddress: "item21918",
    ratings: [
      { who: "Similar identities", rating: 4.04 },
      { who: "All perspectives", rating: 0.12 },
    ],
    lat: 58.02683395601826,
    lng: -5.851732637292823,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3918",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog runs towards the cake gracefully. The teacher eats the road gracefully. A woman builds the road gracefully. A dog builds a fence gracefully. The cat writes a book lazily.",
  },
  {
    locationId: "item21919",
    locationName: "item21919",
    locationAddress: "item21919",
    ratings: [
      { who: "Similar identities", rating: 1.3 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 52.05549182237632,
    lng: -7.266110208739457,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3919",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat runs towards a book happily.",
  },
  {
    locationId: "item21920",
    locationName: "item21920",
    locationAddress: "item21920",
    ratings: null,
    lat: 60.10427647919579,
    lng: -0.24328876765210516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3920",
    tags: [],
    locationDescription: " The student writes the cake angrily.",
  },
  {
    locationId: "item21921",
    locationName: "item21921",
    locationAddress: "item21921",
    ratings: null,
    lat: 55.1925529902878,
    lng: -0.986061535444537,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3921",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon happily. The man builds a tower lazily.",
  },
  {
    locationId: "item21922",
    locationName: "item21922",
    locationAddress: "item21922",
    ratings: [
      { who: "Similar identities", rating: 1.9 },
      { who: "All perspectives", rating: 0.6 },
    ],
    lat: 58.73307284539049,
    lng: -2.245297621177831,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3922",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats the horizon gracefully. A dog eats a fence quickly. The man eats the horizon quickly. The student runs towards a tower happily.",
  },
  {
    locationId: "item21923",
    locationName: "item21923",
    locationAddress: "item21923",
    ratings: null,
    lat: 53.844009725591725,
    lng: -4.615582223838365,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3923",
    tags: [],
    locationDescription:
      " The student eats a book angrily. A dog looks at a tower silently. The student jumps over the cake angrily.",
  },
  {
    locationId: "item21924",
    locationName: "item21924",
    locationAddress: "item21924",
    ratings: null,
    lat: 53.50214876234835,
    lng: -5.788959824003673,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3924",
    tags: [],
    locationDescription: " The man looks at a tower angrily.",
  },
  {
    locationId: "item21925",
    locationName: "item21925",
    locationAddress: "item21925",
    ratings: [
      { who: "Similar identities", rating: 4.18 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 54.28524132528929,
    lng: -3.740701808104375,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item3925",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at a fence silently. The man writes the cake happily. A woman looks at the road happily. A dog writes a book lazily.",
  },
  {
    locationId: "item21926",
    locationName: "item21926",
    locationAddress: "item21926",
    ratings: null,
    lat: 52.53579218264934,
    lng: -7.037542826816035,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3926",
    tags: [],
    locationDescription:
      " A woman eats a tower quickly. The cat runs towards the cake gracefully. The man writes the cake quickly. A dog runs towards a book lazily.",
  },
  {
    locationId: "item21927",
    locationName: "item21927",
    locationAddress: "item21927",
    ratings: null,
    lat: 50.68790090671558,
    lng: 1.6672003840583614,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3927",
    tags: [],
    locationDescription:
      " The teacher builds the horizon angrily. The cat eats the road gracefully. A dog writes the cake lazily.",
  },
  {
    locationId: "item21928",
    locationName: "item21928",
    locationAddress: "item21928",
    ratings: null,
    lat: 55.157125336210655,
    lng: -7.787504223731516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3928",
    tags: [],
    locationDescription:
      " The student jumps over a fence quickly. The teacher eats a book silently. A dog runs towards the cake gracefully. A woman looks at the cake happily. The teacher looks at the cake quickly.",
  },
  {
    locationId: "item21929",
    locationName: "item21929",
    locationAddress: "item21929",
    ratings: [
      { who: "Similar identities", rating: 1.64 },
      { who: "All perspectives", rating: 0.42 },
    ],
    lat: 53.76461783795642,
    lng: -5.5213962356656,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3929",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman looks at the road quickly.",
  },
  {
    locationId: "item21930",
    locationName: "item21930",
    locationAddress: "item21930",
    ratings: [
      { who: "Similar identities", rating: 1.91 },
      { who: "All perspectives", rating: 2.38 },
    ],
    lat: 59.29423855404961,
    lng: -5.7456076792136725,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3930",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription: " The cat looks at the cake happily.",
  },
  {
    locationId: "item21931",
    locationName: "item21931",
    locationAddress: "item21931",
    ratings: null,
    lat: 57.65395746377913,
    lng: 0.6796287851431817,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3931",
    tags: [],
    locationDescription: " The teacher eats a fence angrily.",
  },
  {
    locationId: "item21932",
    locationName: "item21932",
    locationAddress: "item21932",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 1.31 },
    ],
    lat: 50.13406069324571,
    lng: -3.3000108385810165,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3932",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student builds the horizon quickly. The man jumps over a book silently. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item21933",
    locationName: "item21933",
    locationAddress: "item21933",
    ratings: [
      { who: "Similar identities", rating: 0.18 },
      { who: "All perspectives", rating: 3.36 },
    ],
    lat: 54.280113291726664,
    lng: -6.517699747402993,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3933",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student builds a tower angrily. The cat eats the cake gracefully.",
  },
  {
    locationId: "item21934",
    locationName: "item21934",
    locationAddress: "item21934",
    ratings: [
      { who: "Similar identities", rating: 4.86 },
      { who: "All perspectives", rating: 1.71 },
    ],
    lat: 56.67402557986887,
    lng: -3.0458370967789143,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item3934",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards the cake quickly. The man looks at the cake angrily. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item21935",
    locationName: "item21935",
    locationAddress: "item21935",
    ratings: null,
    lat: 52.74288985163652,
    lng: -5.16293514451665,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3935",
    tags: [],
    locationDescription: " A woman runs towards a fence silently.",
  },
  {
    locationId: "item21936",
    locationName: "item21936",
    locationAddress: "item21936",
    ratings: null,
    lat: 57.08382966030492,
    lng: 0.6772386821015921,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3936",
    tags: [],
    locationDescription:
      " A woman jumps over a fence silently. The teacher looks at the horizon angrily. The cat runs towards a book gracefully. A woman eats a tower gracefully.",
  },
  {
    locationId: "item21937",
    locationName: "item21937",
    locationAddress: "item21937",
    ratings: null,
    lat: 50.509390243682496,
    lng: -7.653348478169259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3937",
    tags: [],
    locationDescription:
      " The man runs towards the horizon gracefully. The student jumps over a book gracefully. The teacher runs towards the horizon happily. The cat jumps over the road silently.",
  },
  {
    locationId: "item21938",
    locationName: "item21938",
    locationAddress: "item21938",
    ratings: null,
    lat: 60.57631341182594,
    lng: -5.662417948184237,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3938",
    tags: [],
    locationDescription:
      " The cat builds the cake happily. The man eats the horizon lazily. The student eats the horizon lazily.",
  },
  {
    locationId: "item21939",
    locationName: "item21939",
    locationAddress: "item21939",
    ratings: null,
    lat: 56.8114761251072,
    lng: -7.079030681198328,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3939",
    tags: [],
    locationDescription:
      " The student builds a fence happily. The student runs towards the horizon silently. The student runs towards a book quickly.",
  },
  {
    locationId: "item21940",
    locationName: "item21940",
    locationAddress: "item21940",
    ratings: null,
    lat: 55.328697738585916,
    lng: -8.502720750923793,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3940",
    tags: [],
    locationDescription:
      " A dog writes a fence angrily. A woman builds the cake happily. A woman writes a tower quickly. A woman writes a book angrily. The teacher looks at the horizon gracefully.",
  },
  {
    locationId: "item21941",
    locationName: "item21941",
    locationAddress: "item21941",
    ratings: null,
    lat: 58.93303778791498,
    lng: -4.49725421070441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3941",
    tags: [],
    locationDescription:
      " A woman writes a fence gracefully. The teacher runs towards the horizon happily. The cat eats the road angrily.",
  },
  {
    locationId: "item21942",
    locationName: "item21942",
    locationAddress: "item21942",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 0.68 },
    ],
    lat: 52.215550151376036,
    lng: -3.0885825118476964,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3942",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over the horizon gracefully. The teacher runs towards the cake quickly. The student looks at the cake angrily. A woman looks at the road gracefully.",
  },
  {
    locationId: "item21943",
    locationName: "item21943",
    locationAddress: "item21943",
    ratings: [
      { who: "Similar identities", rating: 3.07 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 52.31658826021612,
    lng: -2.5900885098391013,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3943",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes a book quickly. A dog eats the road happily.",
  },
  {
    locationId: "item21944",
    locationName: "item21944",
    locationAddress: "item21944",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 0.58 },
    ],
    lat: 60.45024379615033,
    lng: -3.3721693104054005,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3944",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man builds a fence gracefully. The man jumps over the cake quickly. The student builds a fence lazily. The man runs towards the road angrily. The teacher jumps over a tower silently.",
  },
  {
    locationId: "item21945",
    locationName: "item21945",
    locationAddress: "item21945",
    ratings: null,
    lat: 54.84633710545097,
    lng: 0.10982950297297123,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3945",
    tags: [],
    locationDescription: " The student looks at the horizon silently.",
  },
  {
    locationId: "item21946",
    locationName: "item21946",
    locationAddress: "item21946",
    ratings: [
      { who: "Similar identities", rating: 2.04 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 58.33067207678864,
    lng: -5.958872238100668,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3946",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student runs towards the horizon lazily. A woman runs towards a book happily.",
  },
  {
    locationId: "item21947",
    locationName: "item21947",
    locationAddress: "item21947",
    ratings: [
      { who: "Similar identities", rating: 0.14 },
      { who: "All perspectives", rating: 0.23 },
    ],
    lat: 52.654242443765185,
    lng: -8.41062702172322,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3947",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at the cake silently. The student runs towards the cake silently.",
  },
  {
    locationId: "item21948",
    locationName: "item21948",
    locationAddress: "item21948",
    ratings: [
      { who: "Similar identities", rating: 1.36 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 51.431957041135846,
    lng: -5.615819558053353,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3948",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat writes the cake quickly. The student writes a book quickly.",
  },
  {
    locationId: "item21949",
    locationName: "item21949",
    locationAddress: "item21949",
    ratings: null,
    lat: 59.35870910755756,
    lng: -4.346912200135373,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3949",
    tags: [],
    locationDescription:
      " The teacher looks at a book silently. The teacher looks at the road happily.",
  },
  {
    locationId: "item21950",
    locationName: "item21950",
    locationAddress: "item21950",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 55.89139959908589,
    lng: -4.987530835466044,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3950",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over the cake silently. The student runs towards a fence quickly. The teacher jumps over a tower silently.",
  },
  {
    locationId: "item21951",
    locationName: "item21951",
    locationAddress: "item21951",
    ratings: null,
    lat: 57.462834606560875,
    lng: -2.5476360527209536,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3951",
    tags: [],
    locationDescription:
      " The teacher looks at the cake lazily. The cat jumps over the horizon quickly. The student runs towards a book happily. A woman runs towards a fence angrily. The student looks at a book lazily.",
  },
  {
    locationId: "item21952",
    locationName: "item21952",
    locationAddress: "item21952",
    ratings: null,
    lat: 51.92637468250795,
    lng: -2.623814027383898,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3952",
    tags: [],
    locationDescription:
      " A dog runs towards the cake angrily. A woman writes a fence silently. The man eats the cake happily. The teacher runs towards a fence angrily. The man runs towards a fence happily.",
  },
  {
    locationId: "item21953",
    locationName: "item21953",
    locationAddress: "item21953",
    ratings: null,
    lat: 59.44751502442653,
    lng: -3.2064036070542663,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3953",
    tags: [],
    locationDescription:
      " The man runs towards a fence angrily. The student jumps over a book gracefully. The man eats a fence silently. The man runs towards the road happily. The student looks at a book silently.",
  },
  {
    locationId: "item21954",
    locationName: "item21954",
    locationAddress: "item21954",
    ratings: [
      { who: "Similar identities", rating: 2.15 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 50.40707385160571,
    lng: 0.7580345661536185,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3954",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds a tower lazily. A dog eats the horizon gracefully.",
  },
  {
    locationId: "item21955",
    locationName: "item21955",
    locationAddress: "item21955",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 57.671630373552766,
    lng: -6.017405727570752,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3955",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over the horizon silently. The student runs towards the road angrily.",
  },
  {
    locationId: "item21956",
    locationName: "item21956",
    locationAddress: "item21956",
    ratings: null,
    lat: 54.67142242684274,
    lng: -1.70345321750223,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3956",
    tags: [],
    locationDescription:
      " The student looks at a tower happily. The teacher looks at the horizon happily. The student looks at the cake happily. A dog eats a book angrily. A woman looks at a fence silently.",
  },
  {
    locationId: "item21957",
    locationName: "item21957",
    locationAddress: "item21957",
    ratings: [
      { who: "Similar identities", rating: 1.98 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 59.853212467318514,
    lng: -6.621685143827066,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3957",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher eats a tower happily. The student builds a book gracefully. A woman eats a tower angrily. A dog jumps over a tower gracefully. The man looks at a tower gracefully.",
  },
  {
    locationId: "item21958",
    locationName: "item21958",
    locationAddress: "item21958",
    ratings: [
      { who: "Similar identities", rating: 1.45 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 55.986133493187154,
    lng: -0.8986258849765525,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3958",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog runs towards a fence happily.",
  },
  {
    locationId: "item21959",
    locationName: "item21959",
    locationAddress: "item21959",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 52.1110229189096,
    lng: 1.3476980486581986,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3959",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher runs towards a tower silently. The cat runs towards a tower happily. The cat looks at the cake quickly. The man writes a fence quickly.",
  },
  {
    locationId: "item21960",
    locationName: "item21960",
    locationAddress: "item21960",
    ratings: null,
    lat: 58.59216244438366,
    lng: -4.638493835956227,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3960",
    tags: [],
    locationDescription:
      " The student jumps over a fence gracefully. The student runs towards a fence silently. A woman looks at the horizon gracefully. The teacher eats the horizon gracefully. The man builds a book angrily.",
  },
  {
    locationId: "item21961",
    locationName: "item21961",
    locationAddress: "item21961",
    ratings: null,
    lat: 60.81389338686576,
    lng: -2.312846708645788,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3961",
    tags: [],
    locationDescription:
      " A woman builds the road lazily. The cat looks at a book happily. The student eats a tower gracefully.",
  },
  {
    locationId: "item21962",
    locationName: "item21962",
    locationAddress: "item21962",
    ratings: null,
    lat: 53.525582673877736,
    lng: -3.6111464507152995,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3962",
    tags: [],
    locationDescription:
      " The cat eats the cake lazily. A dog eats the cake quickly. A dog eats the road gracefully. The student jumps over a fence silently.",
  },
  {
    locationId: "item21963",
    locationName: "item21963",
    locationAddress: "item21963",
    ratings: null,
    lat: 51.912963841717705,
    lng: -2.7939965500499637,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3963",
    tags: [],
    locationDescription:
      " The man eats a book silently. The cat jumps over the cake gracefully.",
  },
  {
    locationId: "item21964",
    locationName: "item21964",
    locationAddress: "item21964",
    ratings: null,
    lat: 52.520447625677086,
    lng: -8.067712466857138,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3964",
    tags: [],
    locationDescription:
      " The student runs towards a tower quickly. The man builds a tower silently.",
  },
  {
    locationId: "item21965",
    locationName: "item21965",
    locationAddress: "item21965",
    ratings: null,
    lat: 56.91814748552692,
    lng: -1.7874472513522264,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3965",
    tags: [],
    locationDescription:
      " The student builds a book gracefully. The student eats a fence gracefully.",
  },
  {
    locationId: "item21966",
    locationName: "item21966",
    locationAddress: "item21966",
    ratings: null,
    lat: 53.78243996969648,
    lng: -7.850218576829826,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3966",
    tags: [],
    locationDescription:
      " The teacher builds the cake happily. A woman builds the road angrily.",
  },
  {
    locationId: "item21967",
    locationName: "item21967",
    locationAddress: "item21967",
    ratings: [
      { who: "Similar identities", rating: 3.54 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 58.374474347298566,
    lng: -4.175785123519612,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item3967",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over a tower lazily. A woman looks at a tower angrily. The man runs towards a tower quickly. The man runs towards the road happily.",
  },
  {
    locationId: "item21968",
    locationName: "item21968",
    locationAddress: "item21968",
    ratings: [
      { who: "Similar identities", rating: 1.55 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 50.320294121999716,
    lng: -5.083050438970428,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3968",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat looks at the horizon silently. The man eats the cake gracefully.",
  },
  {
    locationId: "item21969",
    locationName: "item21969",
    locationAddress: "item21969",
    ratings: [
      { who: "Similar identities", rating: 4.37 },
      { who: "All perspectives", rating: 3.46 },
    ],
    lat: 50.91414913620823,
    lng: -2.3429442150462627,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3969",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman builds a book quickly. The man runs towards the cake angrily. The teacher builds the road lazily.",
  },
  {
    locationId: "item21970",
    locationName: "item21970",
    locationAddress: "item21970",
    ratings: [
      { who: "Similar identities", rating: 0.45 },
      { who: "All perspectives", rating: 0.34 },
    ],
    lat: 50.78014939437832,
    lng: -6.0925116137221735,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3970",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher runs towards a tower gracefully. A dog builds a book gracefully. The man looks at a tower lazily. The cat runs towards the road angrily.",
  },
  {
    locationId: "item21971",
    locationName: "item21971",
    locationAddress: "item21971",
    ratings: null,
    lat: 51.8218117733262,
    lng: -2.6739861817343415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3971",
    tags: [],
    locationDescription: " The student runs towards a tower angrily.",
  },
  {
    locationId: "item21972",
    locationName: "item21972",
    locationAddress: "item21972",
    ratings: null,
    lat: 55.96745931523843,
    lng: -8.174635223868389,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3972",
    tags: [],
    locationDescription:
      " A woman writes the horizon gracefully. The man eats the cake gracefully. The man eats the horizon lazily.",
  },
  {
    locationId: "item21973",
    locationName: "item21973",
    locationAddress: "item21973",
    ratings: [
      { who: "Similar identities", rating: 0.01 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 56.38246923897267,
    lng: -1.1395685826004662,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3973",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat builds the horizon silently. The student eats a tower silently.",
  },
  {
    locationId: "item21974",
    locationName: "item21974",
    locationAddress: "item21974",
    ratings: [
      { who: "Similar identities", rating: 1.66 },
      { who: "All perspectives", rating: 1.41 },
    ],
    lat: 57.35330568265199,
    lng: -7.616645114655165,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item3974",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman builds a tower lazily. The teacher eats the cake angrily. The student runs towards a tower angrily. The cat jumps over a tower gracefully. The student eats a tower happily.",
  },
  {
    locationId: "item21975",
    locationName: "item21975",
    locationAddress: "item21975",
    ratings: null,
    lat: 57.89759617857152,
    lng: -5.968594402822732,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3975",
    tags: [],
    locationDescription: " The man looks at the road silently.",
  },
  {
    locationId: "item21976",
    locationName: "item21976",
    locationAddress: "item21976",
    ratings: null,
    lat: 59.293995183816016,
    lng: 1.019812919610981,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3976",
    tags: [],
    locationDescription:
      " The cat builds a book happily. The cat runs towards the horizon silently. The teacher builds the road angrily. The cat builds a book happily. A woman runs towards the road angrily.",
  },
  {
    locationId: "item21977",
    locationName: "item21977",
    locationAddress: "item21977",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 3.99 },
    ],
    lat: 54.72801695799069,
    lng: -5.851863553786455,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3977",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription: " The cat runs towards a book gracefully.",
  },
  {
    locationId: "item21978",
    locationName: "item21978",
    locationAddress: "item21978",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 56.31633089709667,
    lng: 1.4649158357389833,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3978",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats a tower angrily. A woman runs towards the horizon gracefully. The teacher runs towards a fence gracefully. A dog runs towards a book silently.",
  },
  {
    locationId: "item21979",
    locationName: "item21979",
    locationAddress: "item21979",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 3.9 },
    ],
    lat: 50.86698650747883,
    lng: -3.8581182342276987,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item3979",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes the cake gracefully. The man looks at the road angrily. A woman jumps over a book gracefully. A woman looks at a fence lazily. The man looks at the cake silently.",
  },
  {
    locationId: "item21980",
    locationName: "item21980",
    locationAddress: "item21980",
    ratings: null,
    lat: 59.891333148255896,
    lng: -0.19873331405261752,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item3980",
    tags: [],
    locationDescription:
      " The cat looks at a tower silently. The cat eats a tower lazily. The student writes a tower gracefully. The man writes a fence gracefully. The student jumps over the cake happily.",
  },
  {
    locationId: "item21981",
    locationName: "item21981",
    locationAddress: "item21981",
    ratings: null,
    lat: 52.8594646065037,
    lng: -0.8769486033078584,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3981",
    tags: [],
    locationDescription:
      " The teacher looks at the road lazily. The man eats a fence gracefully.",
  },
  {
    locationId: "item21982",
    locationName: "item21982",
    locationAddress: "item21982",
    ratings: null,
    lat: 56.48951060780337,
    lng: -2.7579206003414756,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item3982",
    tags: [],
    locationDescription:
      " The cat writes the horizon silently. The student builds a book gracefully. A dog writes a fence lazily.",
  },
  {
    locationId: "item21983",
    locationName: "item21983",
    locationAddress: "item21983",
    ratings: [
      { who: "Similar identities", rating: 1.5 },
      { who: "All perspectives", rating: 1.53 },
    ],
    lat: 50.61853458126345,
    lng: -7.634533367567979,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3983",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat eats the horizon lazily. The student builds a tower happily. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item21984",
    locationName: "item21984",
    locationAddress: "item21984",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 58.532396072202395,
    lng: -0.8863500222834286,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3984",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man writes the cake silently. The man eats a tower gracefully. The man runs towards a book lazily.",
  },
  {
    locationId: "item21985",
    locationName: "item21985",
    locationAddress: "item21985",
    ratings: [
      { who: "Similar identities", rating: 2.27 },
      { who: "All perspectives", rating: 0.83 },
    ],
    lat: 60.091165485961824,
    lng: -3.1034141882405972,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3985",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " The man jumps over a fence quickly.",
  },
  {
    locationId: "item21986",
    locationName: "item21986",
    locationAddress: "item21986",
    ratings: null,
    lat: 52.66138866352486,
    lng: 1.541582705104803,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3986",
    tags: [],
    locationDescription:
      " The teacher writes the road quickly. The cat builds a book quickly. The teacher looks at the cake gracefully.",
  },
  {
    locationId: "item21987",
    locationName: "item21987",
    locationAddress: "item21987",
    ratings: null,
    lat: 53.2518323539571,
    lng: -7.691893223461929,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3987",
    tags: [],
    locationDescription:
      " A woman jumps over a book silently. The man eats the road lazily. A dog writes a tower lazily.",
  },
  {
    locationId: "item21988",
    locationName: "item21988",
    locationAddress: "item21988",
    ratings: null,
    lat: 51.43661058237845,
    lng: 1.6690574324777092,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item3988",
    tags: [],
    locationDescription:
      " The cat writes a tower gracefully. The student eats the road gracefully.",
  },
  {
    locationId: "item21989",
    locationName: "item21989",
    locationAddress: "item21989",
    ratings: [
      { who: "Similar identities", rating: 0.92 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 56.35763226603107,
    lng: -3.239347079723278,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item3989",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over the road happily. The man looks at the horizon angrily.",
  },
  {
    locationId: "item21990",
    locationName: "item21990",
    locationAddress: "item21990",
    ratings: null,
    lat: 55.33700776159876,
    lng: -4.6196731323642535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item3990",
    tags: [],
    locationDescription:
      " The man jumps over the horizon silently. The teacher builds the road happily.",
  },
  {
    locationId: "item21991",
    locationName: "item21991",
    locationAddress: "item21991",
    ratings: null,
    lat: 55.41724198124665,
    lng: -4.320863976084699,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3991",
    tags: [],
    locationDescription:
      " A woman looks at a book happily. A dog jumps over the road silently. A woman jumps over the horizon silently. The student runs towards a book angrily.",
  },
  {
    locationId: "item21992",
    locationName: "item21992",
    locationAddress: "item21992",
    ratings: [
      { who: "Similar identities", rating: 1.15 },
      { who: "All perspectives", rating: 2.07 },
    ],
    lat: 58.28959545242195,
    lng: -0.08612893124177745,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item3992",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher builds the horizon lazily. The student eats the cake gracefully. The cat jumps over a fence angrily. A woman builds a fence angrily. A woman runs towards a fence happily.",
  },
  {
    locationId: "item21993",
    locationName: "item21993",
    locationAddress: "item21993",
    ratings: [
      { who: "Similar identities", rating: 1.18 },
      { who: "All perspectives", rating: 0.24 },
    ],
    lat: 57.71437177261477,
    lng: -8.329741443440803,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item3993",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The cat writes a tower gracefully. The teacher writes a book happily. The man builds the cake angrily.",
  },
  {
    locationId: "item21994",
    locationName: "item21994",
    locationAddress: "item21994",
    ratings: null,
    lat: 51.68668834435324,
    lng: -0.4060147809274728,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item3994",
    tags: [],
    locationDescription:
      " A woman builds a book gracefully. A dog runs towards the horizon quickly. The teacher looks at the horizon lazily. The man runs towards a fence lazily.",
  },
  {
    locationId: "item21995",
    locationName: "item21995",
    locationAddress: "item21995",
    ratings: null,
    lat: 60.678064014325585,
    lng: -5.683872437206164,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item3995",
    tags: [],
    locationDescription:
      " A woman runs towards the road silently. The cat eats the road quickly. A dog eats a book happily.",
  },
  {
    locationId: "item21996",
    locationName: "item21996",
    locationAddress: "item21996",
    ratings: null,
    lat: 51.35679287192809,
    lng: -2.1636892698888133,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item3996",
    tags: [],
    locationDescription:
      " A woman eats a tower angrily. The teacher writes a fence angrily. A dog jumps over a fence quickly. A woman jumps over a tower gracefully. The student builds a tower lazily.",
  },
  {
    locationId: "item21997",
    locationName: "item21997",
    locationAddress: "item21997",
    ratings: [
      { who: "Similar identities", rating: 1.36 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 50.32207202255137,
    lng: 1.7832575206571466,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3997",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The student jumps over a fence quickly.",
  },
  {
    locationId: "item21998",
    locationName: "item21998",
    locationAddress: "item21998",
    ratings: [
      { who: "Similar identities", rating: 2.26 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 57.74858359848893,
    lng: -5.0300265646413225,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3998",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher runs towards the road silently. The man builds the road gracefully. A dog looks at a book silently. The teacher builds the cake angrily.",
  },
  {
    locationId: "item21999",
    locationName: "item21999",
    locationAddress: "item21999",
    ratings: null,
    lat: 54.9302304719397,
    lng: -7.526654248978904,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item3999",
    tags: [],
    locationDescription:
      " The man jumps over the road silently. The student writes the cake happily. The cat builds a book silently. A dog builds a book gracefully.",
  },
  {
    locationId: "item22000",
    locationName: "item22000",
    locationAddress: "item22000",
    ratings: [
      { who: "Similar identities", rating: 4.99 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 57.58748040077826,
    lng: -6.783573200686819,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4000",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a tower angrily. A woman eats the horizon silently. A dog jumps over the road angrily. The man runs towards a book happily.",
  },
  {
    locationId: "item22001",
    locationName: "item22001",
    locationAddress: "item22001",
    ratings: [
      { who: "Similar identities", rating: 3.11 },
      { who: "All perspectives", rating: 3.7 },
    ],
    lat: 60.349300810379496,
    lng: -8.317847417548558,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4001",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman writes the road lazily. A woman jumps over a book quickly. A woman eats a book lazily. The student writes a book silently. The teacher looks at a tower silently.",
  },
  {
    locationId: "item22002",
    locationName: "item22002",
    locationAddress: "item22002",
    ratings: null,
    lat: 60.33593343644556,
    lng: -0.17737898303890454,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4002",
    tags: [],
    locationDescription:
      " The cat builds the horizon happily. The teacher looks at a tower quickly. The student writes a book lazily. The cat eats the road happily. The teacher writes the horizon lazily.",
  },
  {
    locationId: "item22003",
    locationName: "item22003",
    locationAddress: "item22003",
    ratings: null,
    lat: 56.78187858039692,
    lng: -4.653278140886688,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4003",
    tags: [],
    locationDescription:
      " The cat writes the cake silently. A dog jumps over the cake angrily. A dog jumps over the horizon happily. The student builds the horizon lazily.",
  },
  {
    locationId: "item22004",
    locationName: "item22004",
    locationAddress: "item22004",
    ratings: [
      { who: "Similar identities", rating: 0.15 },
      { who: "All perspectives", rating: 3.47 },
    ],
    lat: 50.00038897487086,
    lng: -0.4295005751774106,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4004",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats the horizon gracefully. The teacher looks at a tower gracefully. The man looks at a book happily. The man writes a tower silently. The teacher writes the road angrily.",
  },
  {
    locationId: "item22005",
    locationName: "item22005",
    locationAddress: "item22005",
    ratings: [
      { who: "Similar identities", rating: 1.0 },
      { who: "All perspectives", rating: 4.15 },
    ],
    lat: 50.99878863606436,
    lng: -8.47019424762979,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4005",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a book lazily. A woman runs towards the road happily. The cat runs towards a tower lazily. The man jumps over the road happily.",
  },
  {
    locationId: "item22006",
    locationName: "item22006",
    locationAddress: "item22006",
    ratings: [
      { who: "Similar identities", rating: 0.57 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 57.4220762456443,
    lng: -0.19027928183152376,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4006",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student runs towards a fence gracefully. The man writes the horizon quickly. The cat eats the road happily. The man runs towards the horizon gracefully.",
  },
  {
    locationId: "item22007",
    locationName: "item22007",
    locationAddress: "item22007",
    ratings: [
      { who: "Similar identities", rating: 2.31 },
      { who: "All perspectives", rating: 1.36 },
    ],
    lat: 54.20014735021349,
    lng: 0.008350755698852907,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4007",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at a tower gracefully. A woman eats a book lazily. The man jumps over the horizon lazily. A dog eats a book lazily.",
  },
  {
    locationId: "item22008",
    locationName: "item22008",
    locationAddress: "item22008",
    ratings: null,
    lat: 56.26340611163917,
    lng: -7.6695907144169535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4008",
    tags: [],
    locationDescription:
      " The man runs towards the road gracefully. The teacher jumps over the cake gracefully. The cat jumps over a fence lazily. The teacher builds a book angrily.",
  },
  {
    locationId: "item22009",
    locationName: "item22009",
    locationAddress: "item22009",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 1.16 },
    ],
    lat: 59.60620162726323,
    lng: -3.3358329666814726,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4009",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman eats a tower happily. A dog builds a tower happily.",
  },
  {
    locationId: "item22010",
    locationName: "item22010",
    locationAddress: "item22010",
    ratings: [
      { who: "Similar identities", rating: 0.58 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 50.26572020615471,
    lng: 0.5738437947481181,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4010",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes the cake gracefully. The student writes a tower quickly. A dog eats the horizon silently.",
  },
  {
    locationId: "item22011",
    locationName: "item22011",
    locationAddress: "item22011",
    ratings: null,
    lat: 58.65696992316135,
    lng: -0.31831894817748996,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4011",
    tags: [],
    locationDescription: " A dog jumps over a book lazily.",
  },
  {
    locationId: "item22012",
    locationName: "item22012",
    locationAddress: "item22012",
    ratings: [
      { who: "Similar identities", rating: 3.95 },
      { who: "All perspectives", rating: 3.72 },
    ],
    lat: 50.49087812416142,
    lng: -4.07652112948319,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4012",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes a tower happily. The student looks at a book gracefully. The teacher eats a fence silently. The cat looks at the cake lazily.",
  },
  {
    locationId: "item22013",
    locationName: "item22013",
    locationAddress: "item22013",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 53.94106553678191,
    lng: -7.942969016462752,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4013",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher writes a tower gracefully. The cat runs towards a fence happily. A dog eats the horizon lazily. A woman jumps over a tower quickly.",
  },
  {
    locationId: "item22014",
    locationName: "item22014",
    locationAddress: "item22014",
    ratings: [
      { who: "Similar identities", rating: 2.26 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 57.36531005732451,
    lng: -1.251562038429376,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4014",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a tower angrily. The student jumps over the cake angrily.",
  },
  {
    locationId: "item22015",
    locationName: "item22015",
    locationAddress: "item22015",
    ratings: [
      { who: "Similar identities", rating: 3.46 },
      { who: "All perspectives", rating: 0.6 },
    ],
    lat: 53.972719264939656,
    lng: -0.8590691521894085,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4015",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher writes the road angrily. A dog runs towards the cake gracefully. The cat builds a tower happily.",
  },
  {
    locationId: "item22016",
    locationName: "item22016",
    locationAddress: "item22016",
    ratings: null,
    lat: 50.679014165154506,
    lng: -7.624583470372076,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4016",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower angrily. A dog eats the horizon happily. A dog looks at the horizon happily. The teacher looks at a book angrily. A dog builds a tower happily.",
  },
  {
    locationId: "item22017",
    locationName: "item22017",
    locationAddress: "item22017",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 3.67 },
    ],
    lat: 53.13876338743701,
    lng: -3.567035316906943,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4017",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher runs towards the road gracefully. The cat looks at a book quickly. A dog runs towards a fence quickly.",
  },
  {
    locationId: "item22018",
    locationName: "item22018",
    locationAddress: "item22018",
    ratings: null,
    lat: 50.33921729114004,
    lng: 0.08744698385044813,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4018",
    tags: [],
    locationDescription: " The man jumps over the horizon silently.",
  },
  {
    locationId: "item22019",
    locationName: "item22019",
    locationAddress: "item22019",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 1.71 },
    ],
    lat: 60.79255919233254,
    lng: -7.738151683919037,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4019",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog builds the cake gracefully. The teacher runs towards the road quickly. The man runs towards a tower happily.",
  },
  {
    locationId: "item22020",
    locationName: "item22020",
    locationAddress: "item22020",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 3.96 },
    ],
    lat: 59.48837516470801,
    lng: -3.4800672343193,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4020",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog eats the horizon angrily. A woman runs towards the cake gracefully. The cat writes a book gracefully.",
  },
  {
    locationId: "item22021",
    locationName: "item22021",
    locationAddress: "item22021",
    ratings: null,
    lat: 52.48482001564663,
    lng: -0.06074294125329516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4021",
    tags: [],
    locationDescription:
      " A woman looks at the horizon angrily. The man eats the cake quickly. The man looks at a book lazily. The man writes a tower gracefully.",
  },
  {
    locationId: "item22022",
    locationName: "item22022",
    locationAddress: "item22022",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 59.07955705231924,
    lng: 0.16205519299477622,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4022",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The student builds the horizon lazily.",
  },
  {
    locationId: "item22023",
    locationName: "item22023",
    locationAddress: "item22023",
    ratings: null,
    lat: 54.52584848175532,
    lng: -7.47145966541338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4023",
    tags: [],
    locationDescription:
      " The student runs towards a fence gracefully. A dog looks at the cake gracefully. The student builds a book lazily. The student runs towards the cake lazily.",
  },
  {
    locationId: "item22024",
    locationName: "item22024",
    locationAddress: "item22024",
    ratings: null,
    lat: 54.09499644764648,
    lng: -3.1468512021640853,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4024",
    tags: [],
    locationDescription:
      " A woman builds a tower happily. The man writes a fence gracefully. A dog builds the cake happily. The man looks at a fence happily.",
  },
  {
    locationId: "item22025",
    locationName: "item22025",
    locationAddress: "item22025",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 2.55 },
    ],
    lat: 52.51471105724539,
    lng: -7.161762690920436,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4025",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a fence lazily. A dog writes the horizon gracefully.",
  },
  {
    locationId: "item22026",
    locationName: "item22026",
    locationAddress: "item22026",
    ratings: null,
    lat: 53.88095348104078,
    lng: -8.316486904649109,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4026",
    tags: [],
    locationDescription:
      " The cat builds a fence gracefully. The teacher builds the cake lazily. A dog runs towards a book gracefully. A woman runs towards a book lazily. The cat eats the road angrily.",
  },
  {
    locationId: "item22027",
    locationName: "item22027",
    locationAddress: "item22027",
    ratings: [
      { who: "Similar identities", rating: 3.4 },
      { who: "All perspectives", rating: 1.19 },
    ],
    lat: 60.04218153522588,
    lng: -3.215412748011132,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4027",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man eats a fence happily. The man runs towards a tower angrily. The man looks at the cake happily.",
  },
  {
    locationId: "item22028",
    locationName: "item22028",
    locationAddress: "item22028",
    ratings: null,
    lat: 57.16489075852502,
    lng: -4.808624835184343,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4028",
    tags: [],
    locationDescription: " The man eats the horizon gracefully.",
  },
  {
    locationId: "item22029",
    locationName: "item22029",
    locationAddress: "item22029",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 0.18 },
    ],
    lat: 58.03660107422706,
    lng: -4.438261720137297,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4029",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man jumps over the cake quickly. The cat writes a fence lazily.",
  },
  {
    locationId: "item22030",
    locationName: "item22030",
    locationAddress: "item22030",
    ratings: null,
    lat: 55.65419962642099,
    lng: -0.6170920112748206,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4030",
    tags: [],
    locationDescription:
      " The man jumps over the horizon happily. The man looks at a book quickly.",
  },
  {
    locationId: "item22031",
    locationName: "item22031",
    locationAddress: "item22031",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 3.41 },
    ],
    lat: 59.01060365609368,
    lng: -0.11484917057443234,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4031",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes a book silently. The student builds the horizon quickly. The student eats the road angrily.",
  },
  {
    locationId: "item22032",
    locationName: "item22032",
    locationAddress: "item22032",
    ratings: [
      { who: "Similar identities", rating: 3.99 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 59.323934873148744,
    lng: -7.417793731008235,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4032",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man eats the cake gracefully. The student builds the cake quickly. The student writes the cake angrily. A dog jumps over a book silently.",
  },
  {
    locationId: "item22033",
    locationName: "item22033",
    locationAddress: "item22033",
    ratings: null,
    lat: 52.386395264061456,
    lng: -4.948580913893749,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4033",
    tags: [],
    locationDescription:
      " The man jumps over a tower lazily. A woman runs towards a book lazily. The cat eats the horizon quickly.",
  },
  {
    locationId: "item22034",
    locationName: "item22034",
    locationAddress: "item22034",
    ratings: null,
    lat: 56.85588303677026,
    lng: -1.0312058667000956,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4034",
    tags: [],
    locationDescription:
      " A woman writes the horizon happily. A dog builds a tower angrily. A dog writes a tower gracefully.",
  },
  {
    locationId: "item22035",
    locationName: "item22035",
    locationAddress: "item22035",
    ratings: null,
    lat: 52.63550986172874,
    lng: -8.464641278324748,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4035",
    tags: [],
    locationDescription: " A dog builds a book quickly.",
  },
  {
    locationId: "item22036",
    locationName: "item22036",
    locationAddress: "item22036",
    ratings: null,
    lat: 52.79864568187732,
    lng: 1.0721063307080065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4036",
    tags: [],
    locationDescription:
      " The student writes a book gracefully. The student jumps over a tower quickly. The cat looks at a fence silently. The teacher builds a tower angrily.",
  },
  {
    locationId: "item22037",
    locationName: "item22037",
    locationAddress: "item22037",
    ratings: [
      { who: "Similar identities", rating: 1.32 },
      { who: "All perspectives", rating: 4.73 },
    ],
    lat: 56.076687321547574,
    lng: -2.59936831516874,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4037",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man runs towards a tower quickly.",
  },
  {
    locationId: "item22038",
    locationName: "item22038",
    locationAddress: "item22038",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 60.05161576971802,
    lng: -8.45105727419359,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4038",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher eats a tower happily. The student writes the cake lazily. The teacher looks at the road angrily. A woman builds a tower happily. The cat writes a book happily.",
  },
  {
    locationId: "item22039",
    locationName: "item22039",
    locationAddress: "item22039",
    ratings: null,
    lat: 54.149711874383236,
    lng: -3.2908782591892463,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4039",
    tags: [],
    locationDescription:
      " A woman writes a fence quickly. The cat looks at a fence happily. The student looks at the horizon lazily.",
  },
  {
    locationId: "item22040",
    locationName: "item22040",
    locationAddress: "item22040",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 1.92 },
    ],
    lat: 59.300461808988786,
    lng: -3.8121806807997594,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4040",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman jumps over the road quickly. The cat writes a fence gracefully.",
  },
  {
    locationId: "item22041",
    locationName: "item22041",
    locationAddress: "item22041",
    ratings: null,
    lat: 53.03057385326923,
    lng: 0.14059901800269792,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4041",
    tags: [],
    locationDescription:
      " A dog looks at the cake angrily. The teacher looks at a book silently.",
  },
  {
    locationId: "item22042",
    locationName: "item22042",
    locationAddress: "item22042",
    ratings: [
      { who: "Similar identities", rating: 2.98 },
      { who: "All perspectives", rating: 3.46 },
    ],
    lat: 50.257888494151366,
    lng: -8.590279705331522,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4042",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " The student builds the road lazily.",
  },
  {
    locationId: "item22043",
    locationName: "item22043",
    locationAddress: "item22043",
    ratings: [
      { who: "Similar identities", rating: 3.69 },
      { who: "All perspectives", rating: 0.41 },
    ],
    lat: 54.37076728648524,
    lng: -0.3894512312064453,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4043",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A dog looks at a book lazily.",
  },
  {
    locationId: "item22044",
    locationName: "item22044",
    locationAddress: "item22044",
    ratings: [
      { who: "Similar identities", rating: 1.57 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 55.75818203283115,
    lng: 0.059737290060514425,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4044",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over the road silently. A dog writes a fence angrily. The teacher looks at a tower happily. The teacher eats a book happily. The man runs towards a book lazily.",
  },
  {
    locationId: "item22045",
    locationName: "item22045",
    locationAddress: "item22045",
    ratings: null,
    lat: 59.37632011716591,
    lng: -7.268693111470603,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4045",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon quickly. The cat eats the cake silently. The cat looks at a fence gracefully.",
  },
  {
    locationId: "item22046",
    locationName: "item22046",
    locationAddress: "item22046",
    ratings: null,
    lat: 57.66390045872471,
    lng: -5.568430569194542,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4046",
    tags: [],
    locationDescription:
      " The student looks at a book lazily. A woman writes a tower angrily. The teacher runs towards a tower lazily. The teacher runs towards a tower angrily. A dog runs towards a tower lazily.",
  },
  {
    locationId: "item22047",
    locationName: "item22047",
    locationAddress: "item22047",
    ratings: null,
    lat: 58.074061859640274,
    lng: -1.6440559860817512,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4047",
    tags: [],
    locationDescription:
      " A dog jumps over a tower gracefully. The teacher looks at a fence silently. The man eats the road lazily. A dog builds a book angrily. The student eats the road quickly.",
  },
  {
    locationId: "item22048",
    locationName: "item22048",
    locationAddress: "item22048",
    ratings: null,
    lat: 54.60875086899287,
    lng: -0.23186723786948882,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4048",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence happily. A dog writes a fence lazily. The man eats a book lazily. A dog writes the cake gracefully. The cat looks at the horizon silently.",
  },
  {
    locationId: "item22049",
    locationName: "item22049",
    locationAddress: "item22049",
    ratings: null,
    lat: 54.9438770078269,
    lng: -1.7826956403445466,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4049",
    tags: [],
    locationDescription: " A dog writes the road silently.",
  },
  {
    locationId: "item22050",
    locationName: "item22050",
    locationAddress: "item22050",
    ratings: null,
    lat: 53.50394458582993,
    lng: -7.06494339692246,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4050",
    tags: [],
    locationDescription:
      " A dog jumps over the road angrily. A dog runs towards the horizon gracefully.",
  },
  {
    locationId: "item22051",
    locationName: "item22051",
    locationAddress: "item22051",
    ratings: null,
    lat: 59.66660137998571,
    lng: -7.6086414178059965,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4051",
    tags: [],
    locationDescription:
      " A woman looks at the horizon angrily. The student looks at a tower gracefully. The cat jumps over the cake happily. The student looks at a fence silently. The man writes the horizon gracefully.",
  },
  {
    locationId: "item22052",
    locationName: "item22052",
    locationAddress: "item22052",
    ratings: null,
    lat: 51.59242768827817,
    lng: -1.0389696970485627,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4052",
    tags: [],
    locationDescription:
      " The teacher eats a tower lazily. A dog writes the horizon quickly. The student builds the road gracefully. A woman writes the cake silently.",
  },
  {
    locationId: "item22053",
    locationName: "item22053",
    locationAddress: "item22053",
    ratings: null,
    lat: 56.433598350227605,
    lng: -1.7196796226434587,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4053",
    tags: [],
    locationDescription:
      " The student looks at a tower angrily. The teacher writes a book gracefully.",
  },
  {
    locationId: "item22054",
    locationName: "item22054",
    locationAddress: "item22054",
    ratings: [
      { who: "Similar identities", rating: 0.7 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 58.096072932462974,
    lng: -3.9427528820180404,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4054",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " A dog writes a tower happily.",
  },
  {
    locationId: "item22055",
    locationName: "item22055",
    locationAddress: "item22055",
    ratings: [
      { who: "Similar identities", rating: 1.95 },
      { who: "All perspectives", rating: 3.06 },
    ],
    lat: 55.13001559058357,
    lng: -2.5543229898747892,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4055",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher jumps over the horizon gracefully. The teacher runs towards a book happily. The cat writes a tower angrily. A dog looks at the horizon gracefully. The student eats a fence gracefully.",
  },
  {
    locationId: "item22056",
    locationName: "item22056",
    locationAddress: "item22056",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 3.37 },
    ],
    lat: 59.5610977059401,
    lng: -2.2619103497367794,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4056",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher jumps over a book silently. The cat jumps over the road silently. The man eats a book angrily. The cat jumps over the cake happily.",
  },
  {
    locationId: "item22057",
    locationName: "item22057",
    locationAddress: "item22057",
    ratings: null,
    lat: 50.543379967539124,
    lng: -8.29339248304569,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4057",
    tags: [],
    locationDescription:
      " A dog writes a tower silently. A dog eats the horizon happily.",
  },
  {
    locationId: "item22058",
    locationName: "item22058",
    locationAddress: "item22058",
    ratings: [
      { who: "Similar identities", rating: 4.62 },
      { who: "All perspectives", rating: 2.24 },
    ],
    lat: 51.24724662489598,
    lng: -6.162316657825777,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4058",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat jumps over a fence lazily. A dog jumps over the horizon angrily. The cat runs towards the horizon quickly. A dog jumps over a tower angrily.",
  },
  {
    locationId: "item22059",
    locationName: "item22059",
    locationAddress: "item22059",
    ratings: [
      { who: "Similar identities", rating: 4.99 },
      { who: "All perspectives", rating: 0.48 },
    ],
    lat: 54.59845895878043,
    lng: -2.1399261672741225,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4059",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes the road happily. A dog looks at a fence angrily. The student eats the cake angrily. The cat runs towards the cake angrily. The student builds a book silently.",
  },
  {
    locationId: "item22060",
    locationName: "item22060",
    locationAddress: "item22060",
    ratings: null,
    lat: 60.77723233436008,
    lng: -5.131175245134621,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4060",
    tags: [],
    locationDescription:
      " A dog runs towards a tower quickly. The teacher eats a tower happily. The student looks at the horizon lazily. A dog eats the horizon happily.",
  },
  {
    locationId: "item22061",
    locationName: "item22061",
    locationAddress: "item22061",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 55.23395395666971,
    lng: 0.057617794350443674,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4061",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at a fence quickly. A dog looks at a fence angrily. The man eats the road silently.",
  },
  {
    locationId: "item22062",
    locationName: "item22062",
    locationAddress: "item22062",
    ratings: [
      { who: "Similar identities", rating: 2.94 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 53.546695834125515,
    lng: -1.8397350766789744,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4062",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man jumps over a book happily. A dog runs towards the cake angrily. The man builds the horizon quickly.",
  },
  {
    locationId: "item22063",
    locationName: "item22063",
    locationAddress: "item22063",
    ratings: null,
    lat: 56.8398555821611,
    lng: -3.709088941139311,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4063",
    tags: [],
    locationDescription:
      " The man eats a book lazily. The teacher jumps over a tower angrily. A dog writes the horizon lazily.",
  },
  {
    locationId: "item22064",
    locationName: "item22064",
    locationAddress: "item22064",
    ratings: null,
    lat: 53.27394678421104,
    lng: -5.201438428216491,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4064",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon silently. The student writes the road silently. A woman jumps over a book quickly.",
  },
  {
    locationId: "item22065",
    locationName: "item22065",
    locationAddress: "item22065",
    ratings: null,
    lat: 57.459212038161745,
    lng: 0.02701994966809984,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4065",
    tags: [],
    locationDescription:
      " The student looks at the road quickly. A dog eats a fence happily.",
  },
  {
    locationId: "item22066",
    locationName: "item22066",
    locationAddress: "item22066",
    ratings: null,
    lat: 55.21879445092805,
    lng: -4.974375505928458,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4066",
    tags: [],
    locationDescription:
      " The man eats the horizon quickly. The student builds the road happily.",
  },
  {
    locationId: "item22067",
    locationName: "item22067",
    locationAddress: "item22067",
    ratings: null,
    lat: 52.07804917088659,
    lng: -7.551654637523226,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4067",
    tags: [],
    locationDescription:
      " A dog jumps over a fence lazily. The man jumps over the horizon lazily. The man writes the cake angrily. The man eats a fence lazily. The student looks at the road lazily.",
  },
  {
    locationId: "item22068",
    locationName: "item22068",
    locationAddress: "item22068",
    ratings: null,
    lat: 53.15363781661213,
    lng: -1.622364637092434,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4068",
    tags: [],
    locationDescription:
      " The man builds the road silently. The man runs towards the horizon quickly. A dog jumps over the cake gracefully.",
  },
  {
    locationId: "item22069",
    locationName: "item22069",
    locationAddress: "item22069",
    ratings: null,
    lat: 53.87653526697182,
    lng: 1.2723688900526007,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4069",
    tags: [],
    locationDescription:
      " The man writes the horizon lazily. A dog looks at the road happily. The teacher jumps over a tower lazily. A dog writes the cake quickly. The student builds the horizon angrily.",
  },
  {
    locationId: "item22070",
    locationName: "item22070",
    locationAddress: "item22070",
    ratings: null,
    lat: 52.930758662046614,
    lng: -0.9168888298560329,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4070",
    tags: [],
    locationDescription: " The cat looks at a book angrily.",
  },
  {
    locationId: "item22071",
    locationName: "item22071",
    locationAddress: "item22071",
    ratings: null,
    lat: 59.458009407442056,
    lng: 1.362474278043294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4071",
    tags: [],
    locationDescription:
      " A dog builds a book angrily. The man builds the road silently. The cat jumps over a tower silently. The teacher jumps over a fence silently. A woman eats the road quickly.",
  },
  {
    locationId: "item22072",
    locationName: "item22072",
    locationAddress: "item22072",
    ratings: [
      { who: "Similar identities", rating: 0.62 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 53.67894657442252,
    lng: 1.466459814595778,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4072",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " The teacher builds the cake silently.",
  },
  {
    locationId: "item22073",
    locationName: "item22073",
    locationAddress: "item22073",
    ratings: null,
    lat: 60.35736455353272,
    lng: -5.1209537902592945,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4073",
    tags: [],
    locationDescription:
      " The student looks at the horizon happily. A woman looks at the road silently. A woman eats the cake quickly.",
  },
  {
    locationId: "item22074",
    locationName: "item22074",
    locationAddress: "item22074",
    ratings: null,
    lat: 57.372804486208885,
    lng: -5.865415296315789,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4074",
    tags: [],
    locationDescription:
      " The teacher builds the cake silently. A woman jumps over the cake angrily.",
  },
  {
    locationId: "item22075",
    locationName: "item22075",
    locationAddress: "item22075",
    ratings: [
      { who: "Similar identities", rating: 3.0 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 52.193363165125746,
    lng: -3.09983033943157,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4075",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman writes a book happily.",
  },
  {
    locationId: "item22076",
    locationName: "item22076",
    locationAddress: "item22076",
    ratings: null,
    lat: 58.84155968382239,
    lng: -5.126841313324366,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4076",
    tags: [],
    locationDescription:
      " The teacher builds the horizon quickly. A dog runs towards a tower angrily. The student jumps over the road silently. The student runs towards a tower happily. The teacher eats a book happily.",
  },
  {
    locationId: "item22077",
    locationName: "item22077",
    locationAddress: "item22077",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 55.858345054433705,
    lng: 0.4563593325855049,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4077",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The man eats a tower happily. The man jumps over a book happily.",
  },
  {
    locationId: "item22078",
    locationName: "item22078",
    locationAddress: "item22078",
    ratings: null,
    lat: 52.878490384928206,
    lng: -8.109896804503837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4078",
    tags: [],
    locationDescription:
      " The teacher eats the road gracefully. The cat jumps over a book quickly. The man looks at the horizon happily.",
  },
  {
    locationId: "item22079",
    locationName: "item22079",
    locationAddress: "item22079",
    ratings: null,
    lat: 50.94821235772077,
    lng: -4.817210949800587,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4079",
    tags: [],
    locationDescription:
      " The cat eats the horizon quickly. A woman builds a fence gracefully. A woman writes the horizon angrily. The man looks at the cake happily.",
  },
  {
    locationId: "item22080",
    locationName: "item22080",
    locationAddress: "item22080",
    ratings: null,
    lat: 54.317352579106014,
    lng: -3.038704209657964,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4080",
    tags: [],
    locationDescription:
      " The man writes the cake happily. A woman builds a fence quickly.",
  },
  {
    locationId: "item22081",
    locationName: "item22081",
    locationAddress: "item22081",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 0.89 },
    ],
    lat: 57.39719281309269,
    lng: -6.130215916976823,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4081",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student writes a fence quickly. The student runs towards a tower lazily. A dog eats the horizon silently. The teacher looks at a fence silently. A dog writes the road angrily.",
  },
  {
    locationId: "item22082",
    locationName: "item22082",
    locationAddress: "item22082",
    ratings: null,
    lat: 54.188210428152644,
    lng: 1.5548593030587643,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4082",
    tags: [],
    locationDescription: " A dog jumps over the cake silently.",
  },
  {
    locationId: "item22083",
    locationName: "item22083",
    locationAddress: "item22083",
    ratings: null,
    lat: 50.54698475905512,
    lng: 0.427155035323068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4083",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake silently. A dog looks at the road silently. A woman writes the horizon happily. The man builds a tower silently.",
  },
  {
    locationId: "item22084",
    locationName: "item22084",
    locationAddress: "item22084",
    ratings: null,
    lat: 52.539206883632694,
    lng: -1.0499417457436042,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4084",
    tags: [],
    locationDescription:
      " The teacher eats a tower angrily. A woman writes a book angrily.",
  },
  {
    locationId: "item22085",
    locationName: "item22085",
    locationAddress: "item22085",
    ratings: null,
    lat: 54.11371237332898,
    lng: 1.5603280797025505,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4085",
    tags: [],
    locationDescription:
      " The student runs towards the horizon lazily. A dog jumps over the cake gracefully. A dog looks at the cake lazily.",
  },
  {
    locationId: "item22086",
    locationName: "item22086",
    locationAddress: "item22086",
    ratings: [
      { who: "Similar identities", rating: 0.71 },
      { who: "All perspectives", rating: 0.87 },
    ],
    lat: 52.117673789844034,
    lng: 0.2504675957474767,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4086",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes a book angrily. The cat builds a book angrily. A dog writes the road angrily. The cat runs towards a book gracefully. The student looks at a book quickly.",
  },
  {
    locationId: "item22087",
    locationName: "item22087",
    locationAddress: "item22087",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 59.17945735599825,
    lng: -7.210173591715192,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4087",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student eats the horizon quickly. A woman runs towards the road silently. The teacher writes a fence lazily.",
  },
  {
    locationId: "item22088",
    locationName: "item22088",
    locationAddress: "item22088",
    ratings: null,
    lat: 53.19974121105792,
    lng: -7.847728429170794,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4088",
    tags: [],
    locationDescription:
      " The student looks at the cake quickly. A dog writes the road angrily. The student runs towards the cake happily. The man runs towards a tower gracefully. The student jumps over the cake angrily.",
  },
  {
    locationId: "item22089",
    locationName: "item22089",
    locationAddress: "item22089",
    ratings: null,
    lat: 53.453803130700095,
    lng: 1.5318205676664078,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4089",
    tags: [],
    locationDescription:
      " A woman runs towards the cake lazily. The cat builds the cake gracefully. The teacher runs towards a book silently. The student writes a book lazily. The teacher runs towards a fence silently.",
  },
  {
    locationId: "item22090",
    locationName: "item22090",
    locationAddress: "item22090",
    ratings: [
      { who: "Similar identities", rating: 4.61 },
      { who: "All perspectives", rating: 1.91 },
    ],
    lat: 52.008434289676714,
    lng: -7.842693111834816,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4090",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher runs towards the cake quickly. A woman eats the road quickly. The man runs towards the road gracefully. The student looks at the cake happily.",
  },
  {
    locationId: "item22091",
    locationName: "item22091",
    locationAddress: "item22091",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 59.61928384246286,
    lng: -2.318392113465455,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4091",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat eats the horizon angrily. The cat eats a book gracefully. The cat runs towards the cake lazily.",
  },
  {
    locationId: "item22092",
    locationName: "item22092",
    locationAddress: "item22092",
    ratings: null,
    lat: 58.912142734526654,
    lng: -1.1983919942512813,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4092",
    tags: [],
    locationDescription:
      " The cat builds the horizon quickly. The teacher runs towards the cake angrily. The cat builds a fence lazily. The student looks at a tower gracefully. The teacher runs towards a fence silently.",
  },
  {
    locationId: "item22093",
    locationName: "item22093",
    locationAddress: "item22093",
    ratings: [
      { who: "Similar identities", rating: 2.91 },
      { who: "All perspectives", rating: 0.64 },
    ],
    lat: 51.32329126978783,
    lng: 0.02899348770251997,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4093",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man writes the cake gracefully. A dog runs towards a fence gracefully. The teacher looks at the road angrily.",
  },
  {
    locationId: "item22094",
    locationName: "item22094",
    locationAddress: "item22094",
    ratings: [
      { who: "Similar identities", rating: 3.38 },
      { who: "All perspectives", rating: 3.4 },
    ],
    lat: 56.228507890955946,
    lng: -4.068413624403024,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4094",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The cat writes the horizon happily. The student builds the horizon angrily. The man writes the horizon happily.",
  },
  {
    locationId: "item22095",
    locationName: "item22095",
    locationAddress: "item22095",
    ratings: null,
    lat: 58.857755794055635,
    lng: -5.156458737232356,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4095",
    tags: [],
    locationDescription: " The teacher builds the cake angrily.",
  },
  {
    locationId: "item22096",
    locationName: "item22096",
    locationAddress: "item22096",
    ratings: null,
    lat: 54.75448396126244,
    lng: -7.883603628201137,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4096",
    tags: [],
    locationDescription:
      " A woman runs towards a fence gracefully. A woman eats the horizon happily.",
  },
  {
    locationId: "item22097",
    locationName: "item22097",
    locationAddress: "item22097",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 58.52322304481777,
    lng: -0.9838440751077817,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4097",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog builds a tower quickly.",
  },
  {
    locationId: "item22098",
    locationName: "item22098",
    locationAddress: "item22098",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 60.87560118071471,
    lng: 0.5905430039341102,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4098",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man runs towards the horizon quickly. A dog jumps over a fence quickly. A dog looks at the horizon angrily.",
  },
  {
    locationId: "item22099",
    locationName: "item22099",
    locationAddress: "item22099",
    ratings: null,
    lat: 50.7735695059034,
    lng: -3.407833829681109,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4099",
    tags: [],
    locationDescription:
      " The teacher runs towards a book quickly. The man looks at the cake lazily. The man looks at the horizon gracefully. The teacher builds a tower lazily.",
  },
  {
    locationId: "item22100",
    locationName: "item22100",
    locationAddress: "item22100",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 2.67 },
    ],
    lat: 51.88081139160874,
    lng: -8.528765978664131,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4100",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription: " A dog runs towards a tower gracefully.",
  },
  {
    locationId: "item22101",
    locationName: "item22101",
    locationAddress: "item22101",
    ratings: null,
    lat: 59.255468003064166,
    lng: -5.5112046016391245,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4101",
    tags: [],
    locationDescription:
      " The cat jumps over a fence lazily. The cat builds a book lazily. The man writes a book happily.",
  },
  {
    locationId: "item22102",
    locationName: "item22102",
    locationAddress: "item22102",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 52.74552745373985,
    lng: -3.026310947654946,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4102",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The man writes a tower gracefully. The teacher eats the road silently. The student looks at the road angrily.",
  },
  {
    locationId: "item22103",
    locationName: "item22103",
    locationAddress: "item22103",
    ratings: null,
    lat: 56.15401848276833,
    lng: -6.776264858784002,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4103",
    tags: [],
    locationDescription: " A woman jumps over the horizon silently.",
  },
  {
    locationId: "item22104",
    locationName: "item22104",
    locationAddress: "item22104",
    ratings: null,
    lat: 58.4756197394982,
    lng: -4.300858124817862,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4104",
    tags: [],
    locationDescription: " The student runs towards a tower silently.",
  },
  {
    locationId: "item22105",
    locationName: "item22105",
    locationAddress: "item22105",
    ratings: [
      { who: "Similar identities", rating: 4.59 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 52.61829046500746,
    lng: -3.767093793000166,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4105",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student builds the horizon silently. The student eats the road silently. A dog jumps over the horizon gracefully. The man jumps over the road lazily. The cat jumps over the cake angrily.",
  },
  {
    locationId: "item22106",
    locationName: "item22106",
    locationAddress: "item22106",
    ratings: null,
    lat: 59.01501379238968,
    lng: -1.1116285685382845,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4106",
    tags: [],
    locationDescription: " A dog eats the horizon angrily.",
  },
  {
    locationId: "item22107",
    locationName: "item22107",
    locationAddress: "item22107",
    ratings: null,
    lat: 58.150053330092305,
    lng: 1.112956277688717,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4107",
    tags: [],
    locationDescription:
      " The student runs towards the horizon quickly. A dog runs towards a tower happily. The teacher builds a book gracefully. The cat runs towards a tower silently. The teacher writes the cake quickly.",
  },
  {
    locationId: "item22108",
    locationName: "item22108",
    locationAddress: "item22108",
    ratings: null,
    lat: 57.77806478058098,
    lng: 1.059786357435975,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4108",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon silently. The man eats a tower silently. The cat looks at a book happily. The student looks at a fence happily.",
  },
  {
    locationId: "item22109",
    locationName: "item22109",
    locationAddress: "item22109",
    ratings: null,
    lat: 54.08261061256197,
    lng: -2.626893415657632,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4109",
    tags: [],
    locationDescription:
      " The cat runs towards a book quickly. The student builds the cake silently. The teacher eats a fence quickly. The cat builds the cake quickly.",
  },
  {
    locationId: "item22110",
    locationName: "item22110",
    locationAddress: "item22110",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 54.225719675300226,
    lng: -3.978713035460676,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4110",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man runs towards the horizon angrily. The teacher runs towards a book quickly. A woman runs towards a book gracefully. The man runs towards a book gracefully. A dog runs towards a tower happily.",
  },
  {
    locationId: "item22111",
    locationName: "item22111",
    locationAddress: "item22111",
    ratings: [
      { who: "Similar identities", rating: 3.93 },
      { who: "All perspectives", rating: 2.35 },
    ],
    lat: 52.129970570797624,
    lng: -3.2693753419477805,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4111",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The teacher writes the road angrily. The teacher looks at the road gracefully. A dog looks at a fence silently.",
  },
  {
    locationId: "item22112",
    locationName: "item22112",
    locationAddress: "item22112",
    ratings: [
      { who: "Similar identities", rating: 1.75 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 54.02088587993097,
    lng: -5.026300341683941,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4112",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man builds a tower angrily. A woman runs towards a tower quickly. The man runs towards a book happily.",
  },
  {
    locationId: "item22113",
    locationName: "item22113",
    locationAddress: "item22113",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 4.31 },
    ],
    lat: 55.601971648135134,
    lng: 0.9034666826350168,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4113",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at a book gracefully. A dog writes the cake happily. A woman eats the cake happily. The student writes a fence quickly.",
  },
  {
    locationId: "item22114",
    locationName: "item22114",
    locationAddress: "item22114",
    ratings: [
      { who: "Similar identities", rating: 1.64 },
      { who: "All perspectives", rating: 0.21 },
    ],
    lat: 52.72438681244309,
    lng: -2.691888452251658,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4114",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats a fence lazily. The teacher runs towards the cake happily.",
  },
  {
    locationId: "item22115",
    locationName: "item22115",
    locationAddress: "item22115",
    ratings: [
      { who: "Similar identities", rating: 1.02 },
      { who: "All perspectives", rating: 3.66 },
    ],
    lat: 50.34458988992761,
    lng: 1.5031945152466974,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item4115",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher eats a tower happily. A dog jumps over the cake angrily. A dog jumps over a fence quickly. The student runs towards the cake gracefully. The teacher runs towards a tower silently.",
  },
  {
    locationId: "item22116",
    locationName: "item22116",
    locationAddress: "item22116",
    ratings: null,
    lat: 57.8836504077676,
    lng: -8.57131098368358,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4116",
    tags: [],
    locationDescription:
      " The man writes a fence happily. A woman looks at the cake happily. A dog looks at the cake gracefully. The teacher jumps over the horizon gracefully.",
  },
  {
    locationId: "item22117",
    locationName: "item22117",
    locationAddress: "item22117",
    ratings: [
      { who: "Similar identities", rating: 0.34 },
      { who: "All perspectives", rating: 1.81 },
    ],
    lat: 53.659968748512824,
    lng: -2.909034811276306,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4117",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man writes a tower gracefully. The student eats a book happily.",
  },
  {
    locationId: "item22118",
    locationName: "item22118",
    locationAddress: "item22118",
    ratings: [
      { who: "Similar identities", rating: 3.59 },
      { who: "All perspectives", rating: 3.98 },
    ],
    lat: 54.22326479606068,
    lng: -5.470591178728971,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4118",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at a tower angrily. A woman builds a fence gracefully.",
  },
  {
    locationId: "item22119",
    locationName: "item22119",
    locationAddress: "item22119",
    ratings: null,
    lat: 53.516233274545016,
    lng: -6.699648910001412,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4119",
    tags: [],
    locationDescription: " The cat looks at the horizon quickly.",
  },
  {
    locationId: "item22120",
    locationName: "item22120",
    locationAddress: "item22120",
    ratings: [
      { who: "Similar identities", rating: 1.18 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 58.19512597513818,
    lng: -5.27497590168128,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4120",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The cat looks at a fence angrily.",
  },
  {
    locationId: "item22121",
    locationName: "item22121",
    locationAddress: "item22121",
    ratings: null,
    lat: 58.259065701027836,
    lng: 1.781269992548868,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4121",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon angrily. A woman builds a book gracefully. A woman eats a tower happily. A dog eats a tower quickly.",
  },
  {
    locationId: "item22122",
    locationName: "item22122",
    locationAddress: "item22122",
    ratings: null,
    lat: 53.0032292164138,
    lng: -5.2501288584239925,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4122",
    tags: [],
    locationDescription:
      " A woman builds a fence lazily. The teacher eats a book angrily.",
  },
  {
    locationId: "item22123",
    locationName: "item22123",
    locationAddress: "item22123",
    ratings: null,
    lat: 54.830530304941334,
    lng: -8.259224611702702,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4123",
    tags: [],
    locationDescription:
      " The man looks at the cake quickly. The teacher eats a fence lazily. The teacher eats the road angrily. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item22124",
    locationName: "item22124",
    locationAddress: "item22124",
    ratings: null,
    lat: 56.386313390945176,
    lng: -5.0725987321080686,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4124",
    tags: [],
    locationDescription:
      " The man runs towards the road silently. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item22125",
    locationName: "item22125",
    locationAddress: "item22125",
    ratings: [
      { who: "Similar identities", rating: 4.69 },
      { who: "All perspectives", rating: 1.79 },
    ],
    lat: 53.02550362667509,
    lng: -1.7431989427732661,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4125",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds a fence angrily. The cat writes a tower quickly. A woman eats a fence quickly.",
  },
  {
    locationId: "item22126",
    locationName: "item22126",
    locationAddress: "item22126",
    ratings: null,
    lat: 56.38086491331127,
    lng: -6.197954923218361,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4126",
    tags: [],
    locationDescription:
      " The student runs towards the road happily. The teacher builds the cake silently. The student eats a book quickly.",
  },
  {
    locationId: "item22127",
    locationName: "item22127",
    locationAddress: "item22127",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 4.87 },
    ],
    lat: 51.78626387067349,
    lng: -5.014008667642843,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4127",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher writes the horizon happily. The man jumps over the cake silently. The cat eats the road silently.",
  },
  {
    locationId: "item22128",
    locationName: "item22128",
    locationAddress: "item22128",
    ratings: [
      { who: "Similar identities", rating: 3.15 },
      { who: "All perspectives", rating: 4.84 },
    ],
    lat: 59.63870199098813,
    lng: -3.737843489080574,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4128",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog writes the road gracefully.",
  },
  {
    locationId: "item22129",
    locationName: "item22129",
    locationAddress: "item22129",
    ratings: null,
    lat: 56.53940747319029,
    lng: -7.400441472917704,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4129",
    tags: [],
    locationDescription: " The cat writes the horizon quickly.",
  },
  {
    locationId: "item22130",
    locationName: "item22130",
    locationAddress: "item22130",
    ratings: null,
    lat: 53.62091928590656,
    lng: -2.1539627971345565,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4130",
    tags: [],
    locationDescription:
      " A woman eats a book silently. The student looks at a book gracefully. A dog looks at the cake quickly. The man builds a book gracefully.",
  },
  {
    locationId: "item22131",
    locationName: "item22131",
    locationAddress: "item22131",
    ratings: null,
    lat: 50.46972936520582,
    lng: -1.5584931307103762,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4131",
    tags: [],
    locationDescription:
      " A woman eats the road quickly. The man runs towards a tower silently.",
  },
  {
    locationId: "item22132",
    locationName: "item22132",
    locationAddress: "item22132",
    ratings: null,
    lat: 50.11049874381144,
    lng: -1.749985317466603,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4132",
    tags: [],
    locationDescription:
      " A dog builds a fence silently. The cat jumps over a fence angrily. The student runs towards a fence lazily.",
  },
  {
    locationId: "item22133",
    locationName: "item22133",
    locationAddress: "item22133",
    ratings: null,
    lat: 55.48056900595035,
    lng: -2.439700861467644,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4133",
    tags: [],
    locationDescription:
      " The teacher eats the horizon silently. The man eats the road happily.",
  },
  {
    locationId: "item22134",
    locationName: "item22134",
    locationAddress: "item22134",
    ratings: null,
    lat: 54.75733829188613,
    lng: -5.8416942632964375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4134",
    tags: [],
    locationDescription:
      " The man builds the road lazily. The student eats the road silently. The teacher builds the road angrily. A dog builds the road silently.",
  },
  {
    locationId: "item22135",
    locationName: "item22135",
    locationAddress: "item22135",
    ratings: null,
    lat: 60.17709457142591,
    lng: -2.4312878170548515,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4135",
    tags: [],
    locationDescription:
      " The man jumps over the horizon lazily. The man builds a book silently. The student writes a tower quickly. The teacher runs towards a book lazily.",
  },
  {
    locationId: "item22136",
    locationName: "item22136",
    locationAddress: "item22136",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 50.90993940657057,
    lng: -1.0340739010201787,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4136",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student eats the cake silently. A woman runs towards the horizon quickly. The student looks at the horizon silently. The man builds the horizon happily. The cat builds a tower angrily.",
  },
  {
    locationId: "item22137",
    locationName: "item22137",
    locationAddress: "item22137",
    ratings: null,
    lat: 55.705504773182724,
    lng: -7.102146113872733,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4137",
    tags: [],
    locationDescription: " The student writes a book lazily.",
  },
  {
    locationId: "item22138",
    locationName: "item22138",
    locationAddress: "item22138",
    ratings: null,
    lat: 53.30955197214643,
    lng: -2.917688290540064,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4138",
    tags: [],
    locationDescription:
      " The man runs towards the road quickly. The student builds a fence angrily.",
  },
  {
    locationId: "item22139",
    locationName: "item22139",
    locationAddress: "item22139",
    ratings: null,
    lat: 55.36151478222818,
    lng: 0.6229431802808563,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4139",
    tags: [],
    locationDescription: " The teacher eats a book silently.",
  },
  {
    locationId: "item22140",
    locationName: "item22140",
    locationAddress: "item22140",
    ratings: [
      { who: "Similar identities", rating: 1.35 },
      { who: "All perspectives", rating: 3.71 },
    ],
    lat: 58.622389012777504,
    lng: -3.659684616673653,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4140",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher jumps over a book gracefully.",
  },
  {
    locationId: "item22141",
    locationName: "item22141",
    locationAddress: "item22141",
    ratings: null,
    lat: 50.90312987328595,
    lng: -1.409452923662844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4141",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake quickly. The student jumps over a tower angrily. The cat eats a fence quickly. A dog writes a book quickly.",
  },
  {
    locationId: "item22142",
    locationName: "item22142",
    locationAddress: "item22142",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 0.1 },
    ],
    lat: 59.19047368784002,
    lng: 1.1004823280783018,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4142",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student eats a book gracefully. The teacher looks at a fence happily. The cat runs towards the horizon gracefully. The teacher looks at the horizon happily.",
  },
  {
    locationId: "item22143",
    locationName: "item22143",
    locationAddress: "item22143",
    ratings: null,
    lat: 57.40339692031723,
    lng: -5.3664993455633265,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4143",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon silently. The teacher writes a fence quickly. A dog jumps over the road angrily. The man eats a fence gracefully. The man jumps over a tower angrily.",
  },
  {
    locationId: "item22144",
    locationName: "item22144",
    locationAddress: "item22144",
    ratings: null,
    lat: 56.21107460644682,
    lng: -6.366574936553603,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4144",
    tags: [],
    locationDescription:
      " The man looks at a book gracefully. The teacher jumps over the cake happily. The cat looks at a fence silently. The teacher builds a fence lazily. A woman looks at the road angrily.",
  },
  {
    locationId: "item22145",
    locationName: "item22145",
    locationAddress: "item22145",
    ratings: null,
    lat: 60.23726864154621,
    lng: -2.2373220355862866,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4145",
    tags: [],
    locationDescription:
      " The student runs towards the road gracefully. The student eats a book gracefully. A woman eats the cake angrily. The man eats the horizon silently. The man runs towards the road happily.",
  },
  {
    locationId: "item22146",
    locationName: "item22146",
    locationAddress: "item22146",
    ratings: null,
    lat: 57.4053227550346,
    lng: -4.334233995989021,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4146",
    tags: [],
    locationDescription: " The man jumps over a tower angrily.",
  },
  {
    locationId: "item22147",
    locationName: "item22147",
    locationAddress: "item22147",
    ratings: [
      { who: "Similar identities", rating: 1.97 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 52.81213109080864,
    lng: -1.4376435429205277,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4147",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A dog eats a fence angrily.",
  },
  {
    locationId: "item22148",
    locationName: "item22148",
    locationAddress: "item22148",
    ratings: null,
    lat: 53.92730989292404,
    lng: -2.6558855396225374,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4148",
    tags: [],
    locationDescription: " The teacher builds a tower angrily.",
  },
  {
    locationId: "item22149",
    locationName: "item22149",
    locationAddress: "item22149",
    ratings: null,
    lat: 54.12677243957792,
    lng: -1.8457752803566505,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4149",
    tags: [],
    locationDescription:
      " A woman looks at the horizon gracefully. A woman eats the horizon angrily.",
  },
  {
    locationId: "item22150",
    locationName: "item22150",
    locationAddress: "item22150",
    ratings: null,
    lat: 50.73609318544184,
    lng: -0.7579232041816235,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4150",
    tags: [],
    locationDescription:
      " The teacher eats the road gracefully. The teacher writes a fence lazily. The cat builds a fence gracefully. The cat builds the cake happily.",
  },
  {
    locationId: "item22151",
    locationName: "item22151",
    locationAddress: "item22151",
    ratings: [
      { who: "Similar identities", rating: 3.39 },
      { who: "All perspectives", rating: 2.52 },
    ],
    lat: 52.47652973162286,
    lng: -4.87744392203556,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4151",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat runs towards the horizon gracefully. The teacher runs towards a tower silently. The cat eats the horizon silently.",
  },
  {
    locationId: "item22152",
    locationName: "item22152",
    locationAddress: "item22152",
    ratings: null,
    lat: 51.03227186539206,
    lng: 0.1230096437487429,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4152",
    tags: [],
    locationDescription:
      " The cat looks at the road angrily. The student jumps over the road silently. The cat jumps over the road lazily. A dog runs towards a fence angrily.",
  },
  {
    locationId: "item22153",
    locationName: "item22153",
    locationAddress: "item22153",
    ratings: null,
    lat: 53.783083879039346,
    lng: -1.7859146014736247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4153",
    tags: [],
    locationDescription:
      " The man runs towards a book quickly. A dog jumps over a book lazily. The student writes a tower silently. The man builds a fence gracefully.",
  },
  {
    locationId: "item22154",
    locationName: "item22154",
    locationAddress: "item22154",
    ratings: null,
    lat: 59.189816573587166,
    lng: -7.908074274256283,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4154",
    tags: [],
    locationDescription: " The teacher runs towards the road quickly.",
  },
  {
    locationId: "item22155",
    locationName: "item22155",
    locationAddress: "item22155",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 52.527288292606826,
    lng: -7.273358540243869,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4155",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a fence silently. A dog runs towards the cake silently.",
  },
  {
    locationId: "item22156",
    locationName: "item22156",
    locationAddress: "item22156",
    ratings: [
      { who: "Similar identities", rating: 1.28 },
      { who: "All perspectives", rating: 1.47 },
    ],
    lat: 59.53900514417722,
    lng: 0.30434443914333187,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4156",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " A woman runs towards a tower lazily.",
  },
  {
    locationId: "item22157",
    locationName: "item22157",
    locationAddress: "item22157",
    ratings: [
      { who: "Similar identities", rating: 2.53 },
      { who: "All perspectives", rating: 1.3 },
    ],
    lat: 50.17805094401128,
    lng: -7.141680466878983,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4157",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat runs towards a book angrily. A woman writes the horizon happily. A dog jumps over the horizon happily.",
  },
  {
    locationId: "item22158",
    locationName: "item22158",
    locationAddress: "item22158",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 54.67985630495059,
    lng: -0.05920270898534241,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4158",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The teacher looks at a fence angrily. A dog eats a book quickly. A dog eats a tower quickly. A woman builds a tower angrily.",
  },
  {
    locationId: "item22159",
    locationName: "item22159",
    locationAddress: "item22159",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 54.62397730716573,
    lng: -1.2726846982534985,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4159",
    tags: [{ label: "child friendly" }],
    locationDescription: " A dog writes a book angrily.",
  },
  {
    locationId: "item22160",
    locationName: "item22160",
    locationAddress: "item22160",
    ratings: null,
    lat: 58.59439718450622,
    lng: 1.7618889865232994,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4160",
    tags: [],
    locationDescription:
      " The cat looks at a fence quickly. The teacher eats the horizon gracefully. The teacher runs towards the horizon happily.",
  },
  {
    locationId: "item22161",
    locationName: "item22161",
    locationAddress: "item22161",
    ratings: [
      { who: "Similar identities", rating: 0.6 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 55.486258540483405,
    lng: 1.5999306155976711,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4161",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man jumps over the horizon lazily. A woman writes a tower angrily. A dog eats a book gracefully. A woman looks at the cake silently. The cat writes the cake angrily.",
  },
  {
    locationId: "item22162",
    locationName: "item22162",
    locationAddress: "item22162",
    ratings: [
      { who: "Similar identities", rating: 0.01 },
      { who: "All perspectives", rating: 1.4 },
    ],
    lat: 56.49554504111434,
    lng: -2.322439315901791,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4162",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The cat looks at the road angrily.",
  },
  {
    locationId: "item22163",
    locationName: "item22163",
    locationAddress: "item22163",
    ratings: null,
    lat: 58.57495031046087,
    lng: -0.6345868883701149,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4163",
    tags: [],
    locationDescription: " A dog writes a tower happily.",
  },
  {
    locationId: "item22164",
    locationName: "item22164",
    locationAddress: "item22164",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 57.12439811160736,
    lng: -4.31674888577391,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4164",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over the horizon gracefully. The teacher builds the horizon quickly. The student jumps over the road silently. The student builds the cake silently.",
  },
  {
    locationId: "item22165",
    locationName: "item22165",
    locationAddress: "item22165",
    ratings: [
      { who: "Similar identities", rating: 1.29 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 59.44644119430022,
    lng: -5.512463168539684,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4165",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The teacher builds a fence quickly.",
  },
  {
    locationId: "item22166",
    locationName: "item22166",
    locationAddress: "item22166",
    ratings: null,
    lat: 53.353683294339724,
    lng: -8.34325298065432,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4166",
    tags: [],
    locationDescription: " The man jumps over a book silently.",
  },
  {
    locationId: "item22167",
    locationName: "item22167",
    locationAddress: "item22167",
    ratings: [
      { who: "Similar identities", rating: 2.29 },
      { who: "All perspectives", rating: 0.88 },
    ],
    lat: 51.22446593224157,
    lng: -3.2585052325221566,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4167",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The student runs towards a fence quickly.",
  },
  {
    locationId: "item22168",
    locationName: "item22168",
    locationAddress: "item22168",
    ratings: null,
    lat: 57.781124444991,
    lng: -0.7463515984236082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4168",
    tags: [],
    locationDescription: " The teacher eats the cake angrily.",
  },
  {
    locationId: "item22169",
    locationName: "item22169",
    locationAddress: "item22169",
    ratings: null,
    lat: 50.468493571446395,
    lng: -4.387746887546031,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4169",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon gracefully. The student writes the cake happily. A dog builds a book gracefully. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item22170",
    locationName: "item22170",
    locationAddress: "item22170",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 0.96 },
    ],
    lat: 50.337253299783534,
    lng: 1.6727237840432885,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4170",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man writes a book gracefully. The cat runs towards the horizon gracefully. The man runs towards a tower angrily. The man jumps over a fence happily. A woman looks at the cake quickly.",
  },
  {
    locationId: "item22171",
    locationName: "item22171",
    locationAddress: "item22171",
    ratings: null,
    lat: 60.42066774196661,
    lng: -6.289191631754228,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4171",
    tags: [],
    locationDescription: " A dog looks at a tower angrily.",
  },
  {
    locationId: "item22172",
    locationName: "item22172",
    locationAddress: "item22172",
    ratings: null,
    lat: 52.45761515022425,
    lng: -1.3433281713150818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4172",
    tags: [],
    locationDescription:
      " The student writes a fence gracefully. The cat builds a fence quickly.",
  },
  {
    locationId: "item22173",
    locationName: "item22173",
    locationAddress: "item22173",
    ratings: null,
    lat: 55.98549326430795,
    lng: -1.6331879394828288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4173",
    tags: [],
    locationDescription:
      " The man runs towards the horizon gracefully. The cat looks at the horizon quickly. A dog looks at the road gracefully.",
  },
  {
    locationId: "item22174",
    locationName: "item22174",
    locationAddress: "item22174",
    ratings: [
      { who: "Similar identities", rating: 2.32 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 53.02245247201711,
    lng: -7.445833718923324,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4174",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at the road quickly. The student runs towards the road happily.",
  },
  {
    locationId: "item22175",
    locationName: "item22175",
    locationAddress: "item22175",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 4.76 },
    ],
    lat: 56.84775809320765,
    lng: -3.386050397538373,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4175",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes a fence quickly. The cat looks at a book quickly. A woman eats a fence quickly. The man runs towards a tower angrily.",
  },
  {
    locationId: "item22176",
    locationName: "item22176",
    locationAddress: "item22176",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 4.72 },
    ],
    lat: 52.709008818805835,
    lng: -5.80836297816107,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4176",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes a book lazily. A woman builds a book silently.",
  },
  {
    locationId: "item22177",
    locationName: "item22177",
    locationAddress: "item22177",
    ratings: [
      { who: "Similar identities", rating: 1.66 },
      { who: "All perspectives", rating: 2.82 },
    ],
    lat: 53.54964097412667,
    lng: -1.8217812957956303,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4177",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat writes the road lazily.",
  },
  {
    locationId: "item22178",
    locationName: "item22178",
    locationAddress: "item22178",
    ratings: null,
    lat: 53.93858625559815,
    lng: -6.744969509076679,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4178",
    tags: [],
    locationDescription:
      " The teacher writes the road angrily. The cat jumps over the horizon lazily. The man builds the cake angrily.",
  },
  {
    locationId: "item22179",
    locationName: "item22179",
    locationAddress: "item22179",
    ratings: null,
    lat: 56.74382647954667,
    lng: 0.5676345464842534,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4179",
    tags: [],
    locationDescription:
      " The student writes a book lazily. The student jumps over the horizon gracefully.",
  },
  {
    locationId: "item22180",
    locationName: "item22180",
    locationAddress: "item22180",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 50.60425673748556,
    lng: -3.626631379225997,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4180",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog eats a tower lazily. A woman looks at the road gracefully. A woman jumps over the horizon angrily. The cat looks at a book gracefully.",
  },
  {
    locationId: "item22181",
    locationName: "item22181",
    locationAddress: "item22181",
    ratings: null,
    lat: 51.2386599327808,
    lng: -6.873800260975837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4181",
    tags: [],
    locationDescription: " The teacher jumps over the road gracefully.",
  },
  {
    locationId: "item22182",
    locationName: "item22182",
    locationAddress: "item22182",
    ratings: null,
    lat: 55.89732285045756,
    lng: -4.873018300266681,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4182",
    tags: [],
    locationDescription:
      " A woman builds a fence lazily. The teacher eats a tower angrily.",
  },
  {
    locationId: "item22183",
    locationName: "item22183",
    locationAddress: "item22183",
    ratings: null,
    lat: 52.12363264322905,
    lng: -0.13394095673473316,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4183",
    tags: [],
    locationDescription: " The student writes the road angrily.",
  },
  {
    locationId: "item22184",
    locationName: "item22184",
    locationAddress: "item22184",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 1.56 },
    ],
    lat: 50.98992783075971,
    lng: 0.26668359407659104,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4184",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog eats a book lazily.",
  },
  {
    locationId: "item22185",
    locationName: "item22185",
    locationAddress: "item22185",
    ratings: [
      { who: "Similar identities", rating: 4.73 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 50.86557070464084,
    lng: -3.804129234946048,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4185",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man writes the horizon quickly. The man runs towards the horizon angrily.",
  },
  {
    locationId: "item22186",
    locationName: "item22186",
    locationAddress: "item22186",
    ratings: null,
    lat: 55.77791090491368,
    lng: 1.4073644403064716,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4186",
    tags: [],
    locationDescription:
      " A woman writes the road angrily. A dog runs towards a book happily. The man looks at the cake lazily.",
  },
  {
    locationId: "item22187",
    locationName: "item22187",
    locationAddress: "item22187",
    ratings: null,
    lat: 59.730349812947196,
    lng: -0.9045941707596539,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4187",
    tags: [],
    locationDescription:
      " A dog jumps over a book quickly. A woman looks at a fence gracefully. The teacher runs towards the road gracefully.",
  },
  {
    locationId: "item22188",
    locationName: "item22188",
    locationAddress: "item22188",
    ratings: [
      { who: "Similar identities", rating: 3.82 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 52.10257179030567,
    lng: -6.0818311310196815,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4188",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher eats a book silently. A dog runs towards a book happily. A dog looks at a tower quickly. The cat runs towards a fence lazily.",
  },
  {
    locationId: "item22189",
    locationName: "item22189",
    locationAddress: "item22189",
    ratings: [
      { who: "Similar identities", rating: 4.15 },
      { who: "All perspectives", rating: 0.31 },
    ],
    lat: 54.01069166065131,
    lng: -6.443857659107293,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4189",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman eats the horizon gracefully.",
  },
  {
    locationId: "item22190",
    locationName: "item22190",
    locationAddress: "item22190",
    ratings: null,
    lat: 58.341960769878796,
    lng: -5.012178975289432,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4190",
    tags: [],
    locationDescription:
      " A woman builds a book quickly. The man jumps over the horizon angrily. A dog runs towards a book angrily. The cat builds a tower angrily.",
  },
  {
    locationId: "item22191",
    locationName: "item22191",
    locationAddress: "item22191",
    ratings: null,
    lat: 52.048989102075,
    lng: 1.5372073208462993,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4191",
    tags: [],
    locationDescription:
      " The teacher runs towards the road gracefully. The teacher runs towards a fence quickly. The man writes the horizon angrily. The teacher writes a tower silently. A woman writes the horizon quickly.",
  },
  {
    locationId: "item22192",
    locationName: "item22192",
    locationAddress: "item22192",
    ratings: null,
    lat: 56.68133619071324,
    lng: -2.5419000770592817,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4192",
    tags: [],
    locationDescription:
      " The cat jumps over the cake gracefully. The teacher jumps over the road quickly.",
  },
  {
    locationId: "item22193",
    locationName: "item22193",
    locationAddress: "item22193",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 58.67302437290191,
    lng: -7.55658852123888,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4193",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman runs towards a tower quickly. The cat runs towards a fence happily.",
  },
  {
    locationId: "item22194",
    locationName: "item22194",
    locationAddress: "item22194",
    ratings: null,
    lat: 51.66617045789709,
    lng: 1.2856537878789247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4194",
    tags: [],
    locationDescription: " The teacher runs towards the cake lazily.",
  },
  {
    locationId: "item22195",
    locationName: "item22195",
    locationAddress: "item22195",
    ratings: [
      { who: "Similar identities", rating: 3.46 },
      { who: "All perspectives", rating: 2.82 },
    ],
    lat: 58.579532734023395,
    lng: -5.573302074497913,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4195",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The student runs towards a fence gracefully. A woman eats the horizon happily. The student jumps over the road silently. The man builds a tower happily.",
  },
  {
    locationId: "item22196",
    locationName: "item22196",
    locationAddress: "item22196",
    ratings: [
      { who: "Similar identities", rating: 0.26 },
      { who: "All perspectives", rating: 3.84 },
    ],
    lat: 53.95557248386114,
    lng: -0.478320840157183,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4196",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat runs towards the road happily. A woman builds the cake angrily. A dog eats the horizon happily. A woman looks at the horizon lazily. The man eats a fence lazily.",
  },
  {
    locationId: "item22197",
    locationName: "item22197",
    locationAddress: "item22197",
    ratings: [
      { who: "Similar identities", rating: 3.65 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 50.81808499261014,
    lng: 1.0325996679423444,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4197",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student jumps over a tower lazily. The man writes a fence happily. The student builds the horizon quickly.",
  },
  {
    locationId: "item22198",
    locationName: "item22198",
    locationAddress: "item22198",
    ratings: [
      { who: "Similar identities", rating: 0.63 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 55.51104009012822,
    lng: -5.394617966656156,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4198",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man writes the cake gracefully.",
  },
  {
    locationId: "item22199",
    locationName: "item22199",
    locationAddress: "item22199",
    ratings: null,
    lat: 54.9869819798947,
    lng: 0.9802839654754631,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4199",
    tags: [],
    locationDescription:
      " A dog eats the horizon angrily. The student builds a tower silently. The cat eats a fence silently.",
  },
  {
    locationId: "item22200",
    locationName: "item22200",
    locationAddress: "item22200",
    ratings: null,
    lat: 58.899954758913445,
    lng: 0.23868198212191594,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4200",
    tags: [],
    locationDescription:
      " A dog eats the cake gracefully. The teacher runs towards the road silently. The teacher builds the road quickly. The cat builds a book gracefully.",
  },
  {
    locationId: "item22201",
    locationName: "item22201",
    locationAddress: "item22201",
    ratings: [
      { who: "Similar identities", rating: 1.03 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 56.749733059705605,
    lng: -5.964215471114375,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4201",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man runs towards the road silently. A dog eats the cake silently.",
  },
  {
    locationId: "item22202",
    locationName: "item22202",
    locationAddress: "item22202",
    ratings: [
      { who: "Similar identities", rating: 0.58 },
      { who: "All perspectives", rating: 3.12 },
    ],
    lat: 55.4296570779634,
    lng: -3.400649761729915,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4202",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A woman looks at the cake angrily. The cat eats the road happily. The student jumps over a tower quickly.",
  },
  {
    locationId: "item22203",
    locationName: "item22203",
    locationAddress: "item22203",
    ratings: null,
    lat: 56.746041744511466,
    lng: -1.439785540875258,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4203",
    tags: [],
    locationDescription:
      " The cat eats the horizon quickly. The student builds the road quickly. The man builds a book gracefully. The man looks at the cake lazily.",
  },
  {
    locationId: "item22204",
    locationName: "item22204",
    locationAddress: "item22204",
    ratings: null,
    lat: 59.98553553837425,
    lng: -6.348522142640519,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4204",
    tags: [],
    locationDescription:
      " A dog builds a book silently. The teacher builds a book quickly. The cat looks at a fence happily. The student writes a book silently.",
  },
  {
    locationId: "item22205",
    locationName: "item22205",
    locationAddress: "item22205",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 2.54 },
    ],
    lat: 52.95028883880494,
    lng: -1.097536317975342,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4205",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards the horizon gracefully. The man eats a book angrily.",
  },
  {
    locationId: "item22206",
    locationName: "item22206",
    locationAddress: "item22206",
    ratings: null,
    lat: 57.84822989574542,
    lng: -8.5984140888649,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4206",
    tags: [],
    locationDescription:
      " The man looks at a book silently. The teacher writes a tower angrily. The man looks at a book gracefully.",
  },
  {
    locationId: "item22207",
    locationName: "item22207",
    locationAddress: "item22207",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 56.73119158110221,
    lng: -7.773092345712152,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4207",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The teacher runs towards a tower gracefully.",
  },
  {
    locationId: "item22208",
    locationName: "item22208",
    locationAddress: "item22208",
    ratings: null,
    lat: 59.49455502209452,
    lng: -0.905497898210939,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4208",
    tags: [],
    locationDescription:
      " The teacher writes the road lazily. The cat runs towards the cake silently. The teacher jumps over the road quickly. The student looks at a book silently.",
  },
  {
    locationId: "item22209",
    locationName: "item22209",
    locationAddress: "item22209",
    ratings: null,
    lat: 53.51954573867309,
    lng: -3.7908068284571126,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4209",
    tags: [],
    locationDescription:
      " The man runs towards the cake lazily. A woman jumps over the horizon lazily.",
  },
  {
    locationId: "item22210",
    locationName: "item22210",
    locationAddress: "item22210",
    ratings: null,
    lat: 55.516915578863674,
    lng: 0.27368264039142964,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4210",
    tags: [],
    locationDescription:
      " The man writes a book angrily. A woman builds the cake quickly. A dog writes a tower lazily.",
  },
  {
    locationId: "item22211",
    locationName: "item22211",
    locationAddress: "item22211",
    ratings: [
      { who: "Similar identities", rating: 0.69 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 59.64368868742027,
    lng: -0.8411153553576103,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4211",
    tags: [{ label: "accessible" }],
    locationDescription: " The man runs towards a fence quickly.",
  },
  {
    locationId: "item22212",
    locationName: "item22212",
    locationAddress: "item22212",
    ratings: [
      { who: "Similar identities", rating: 0.27 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 53.91702784074502,
    lng: 1.451956243780991,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4212",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A woman runs towards the road lazily.",
  },
  {
    locationId: "item22213",
    locationName: "item22213",
    locationAddress: "item22213",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 1.59 },
    ],
    lat: 51.686333800239765,
    lng: -3.6821211404672933,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4213",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher writes the horizon happily. A woman runs towards a book angrily. The student builds a fence lazily. A dog writes a book angrily. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item22214",
    locationName: "item22214",
    locationAddress: "item22214",
    ratings: [
      { who: "Similar identities", rating: 1.01 },
      { who: "All perspectives", rating: 2.05 },
    ],
    lat: 58.299537656469525,
    lng: -3.872667932324495,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4214",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at the horizon angrily. The teacher jumps over a book silently. The man runs towards the road silently. A woman looks at the horizon gracefully. The student runs towards a fence gracefully.",
  },
  {
    locationId: "item22215",
    locationName: "item22215",
    locationAddress: "item22215",
    ratings: [
      { who: "Similar identities", rating: 4.13 },
      { who: "All perspectives", rating: 1.92 },
    ],
    lat: 58.26324145636684,
    lng: 1.0351190798126915,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4215",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog builds the cake gracefully. A dog jumps over a book lazily. The teacher jumps over a fence quickly.",
  },
  {
    locationId: "item22216",
    locationName: "item22216",
    locationAddress: "item22216",
    ratings: [
      { who: "Similar identities", rating: 0.63 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 57.498446492758475,
    lng: 0.9326207983421195,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4216",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman builds a fence lazily. A woman runs towards a book lazily. A dog jumps over the road lazily. The student jumps over a fence angrily. The teacher jumps over the cake lazily.",
  },
  {
    locationId: "item22217",
    locationName: "item22217",
    locationAddress: "item22217",
    ratings: null,
    lat: 60.269863275586445,
    lng: -5.518728797042025,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4217",
    tags: [],
    locationDescription: " The teacher looks at the cake gracefully.",
  },
  {
    locationId: "item22218",
    locationName: "item22218",
    locationAddress: "item22218",
    ratings: null,
    lat: 56.02853360365567,
    lng: -1.753346575549969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4218",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake happily. A dog builds a tower happily. The teacher jumps over the road lazily.",
  },
  {
    locationId: "item22219",
    locationName: "item22219",
    locationAddress: "item22219",
    ratings: null,
    lat: 53.81846919925092,
    lng: -4.030412534425692,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4219",
    tags: [],
    locationDescription:
      " The teacher builds a book angrily. The cat runs towards a tower gracefully. The man runs towards the road happily.",
  },
  {
    locationId: "item22220",
    locationName: "item22220",
    locationAddress: "item22220",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 4.74 },
    ],
    lat: 50.85417825060153,
    lng: -5.7722785929675196,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4220",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog eats a tower silently. The student jumps over the road angrily.",
  },
  {
    locationId: "item22221",
    locationName: "item22221",
    locationAddress: "item22221",
    ratings: [
      { who: "Similar identities", rating: 2.06 },
      { who: "All perspectives", rating: 2.82 },
    ],
    lat: 49.93853516526832,
    lng: 0.8627112377562387,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4221",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat builds a tower quickly. The cat builds the cake quickly. The teacher builds a tower angrily.",
  },
  {
    locationId: "item22222",
    locationName: "item22222",
    locationAddress: "item22222",
    ratings: null,
    lat: 51.29707950101031,
    lng: -6.626648577318135,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4222",
    tags: [],
    locationDescription:
      " A dog eats the horizon gracefully. The teacher eats the road lazily. The man eats a tower gracefully. The man eats a book lazily.",
  },
  {
    locationId: "item22223",
    locationName: "item22223",
    locationAddress: "item22223",
    ratings: null,
    lat: 50.130401327622224,
    lng: -0.08547697201148452,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4223",
    tags: [],
    locationDescription:
      " The cat looks at the road silently. The man looks at a book quickly. The student writes a fence quickly.",
  },
  {
    locationId: "item22224",
    locationName: "item22224",
    locationAddress: "item22224",
    ratings: null,
    lat: 53.09010168759319,
    lng: -8.4404597615153,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4224",
    tags: [],
    locationDescription:
      " The teacher builds the horizon gracefully. The cat builds the cake angrily. The cat jumps over a tower gracefully. The teacher jumps over the cake gracefully.",
  },
  {
    locationId: "item22225",
    locationName: "item22225",
    locationAddress: "item22225",
    ratings: null,
    lat: 51.50220851150337,
    lng: -5.196517119033421,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4225",
    tags: [],
    locationDescription:
      " The man eats the road angrily. The cat eats a fence quickly. The cat eats a tower quickly.",
  },
  {
    locationId: "item22226",
    locationName: "item22226",
    locationAddress: "item22226",
    ratings: null,
    lat: 50.48321241464098,
    lng: -7.723883521713757,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4226",
    tags: [],
    locationDescription:
      " A woman builds a fence happily. A woman jumps over the horizon happily. The man runs towards a tower quickly. The teacher runs towards a book gracefully. The cat writes the cake angrily.",
  },
  {
    locationId: "item22227",
    locationName: "item22227",
    locationAddress: "item22227",
    ratings: [
      { who: "Similar identities", rating: 4.96 },
      { who: "All perspectives", rating: 3.96 },
    ],
    lat: 56.48768901909152,
    lng: 1.607118739697734,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4227",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat eats a tower silently. A woman writes the cake angrily. The teacher runs towards the cake quickly.",
  },
  {
    locationId: "item22228",
    locationName: "item22228",
    locationAddress: "item22228",
    ratings: [
      { who: "Similar identities", rating: 2.88 },
      { who: "All perspectives", rating: 0.37 },
    ],
    lat: 55.35246020328957,
    lng: -7.165940879872461,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4228",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man jumps over a tower angrily. A dog eats a book silently. The man builds a book lazily. The cat jumps over a book happily. A woman builds the cake silently.",
  },
  {
    locationId: "item22229",
    locationName: "item22229",
    locationAddress: "item22229",
    ratings: [
      { who: "Similar identities", rating: 2.33 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 50.40419307317489,
    lng: -2.3436864317099353,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4229",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The man eats a tower angrily.",
  },
  {
    locationId: "item22230",
    locationName: "item22230",
    locationAddress: "item22230",
    ratings: null,
    lat: 58.77805942553066,
    lng: -7.008252027103426,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4230",
    tags: [],
    locationDescription:
      " The cat jumps over a book silently. A dog runs towards a tower silently.",
  },
  {
    locationId: "item22231",
    locationName: "item22231",
    locationAddress: "item22231",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 60.19234298754861,
    lng: 1.5400290159930048,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4231",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher eats a fence lazily. A dog writes the cake lazily. The man jumps over the road silently.",
  },
  {
    locationId: "item22232",
    locationName: "item22232",
    locationAddress: "item22232",
    ratings: null,
    lat: 58.81631648086662,
    lng: -8.149736842109697,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4232",
    tags: [],
    locationDescription:
      " A dog eats the horizon happily. A woman runs towards the cake angrily. The cat looks at the horizon gracefully.",
  },
  {
    locationId: "item22233",
    locationName: "item22233",
    locationAddress: "item22233",
    ratings: null,
    lat: 59.18250989094301,
    lng: -4.201399442132694,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4233",
    tags: [],
    locationDescription: " The student eats the road angrily.",
  },
  {
    locationId: "item22234",
    locationName: "item22234",
    locationAddress: "item22234",
    ratings: null,
    lat: 53.625734664267014,
    lng: -0.13503392526252078,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4234",
    tags: [],
    locationDescription:
      " A dog looks at a book silently. The teacher looks at the horizon lazily. A dog writes a fence quickly. The cat looks at a book quickly. A woman runs towards a fence gracefully.",
  },
  {
    locationId: "item22235",
    locationName: "item22235",
    locationAddress: "item22235",
    ratings: [
      { who: "Similar identities", rating: 3.02 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 56.64538887897831,
    lng: -1.1983109009720376,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4235",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes the road silently. The student jumps over a fence lazily. A woman writes the cake gracefully.",
  },
  {
    locationId: "item22236",
    locationName: "item22236",
    locationAddress: "item22236",
    ratings: null,
    lat: 58.22135274539083,
    lng: -8.516463952241146,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4236",
    tags: [],
    locationDescription:
      " The cat runs towards the cake gracefully. A dog runs towards a tower quickly. A woman writes the cake quickly. The man looks at a fence angrily. A dog looks at the road silently.",
  },
  {
    locationId: "item22237",
    locationName: "item22237",
    locationAddress: "item22237",
    ratings: [
      { who: "Similar identities", rating: 4.99 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 52.15688736235919,
    lng: -3.9696033860111006,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4237",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The teacher jumps over the horizon angrily.",
  },
  {
    locationId: "item22238",
    locationName: "item22238",
    locationAddress: "item22238",
    ratings: [
      { who: "Similar identities", rating: 0.54 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 56.160237746251624,
    lng: -2.8203386476832746,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4238",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat writes a tower lazily. The teacher jumps over the cake happily.",
  },
  {
    locationId: "item22239",
    locationName: "item22239",
    locationAddress: "item22239",
    ratings: [
      { who: "Similar identities", rating: 2.67 },
      { who: "All perspectives", rating: 1.29 },
    ],
    lat: 56.83313373894826,
    lng: -0.4406590170769249,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4239",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher writes a tower happily. The man runs towards a book gracefully. The teacher writes the cake angrily.",
  },
  {
    locationId: "item22240",
    locationName: "item22240",
    locationAddress: "item22240",
    ratings: [
      { who: "Similar identities", rating: 4.48 },
      { who: "All perspectives", rating: 1.95 },
    ],
    lat: 53.89377610410995,
    lng: -7.9786261921190365,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4240",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards a fence lazily. The man eats a tower gracefully. The man runs towards a fence angrily. The teacher builds a tower angrily. A woman looks at the road quickly.",
  },
  {
    locationId: "item22241",
    locationName: "item22241",
    locationAddress: "item22241",
    ratings: [
      { who: "Similar identities", rating: 3.65 },
      { who: "All perspectives", rating: 4.22 },
    ],
    lat: 53.19989846708269,
    lng: -7.935156904741921,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4241",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes the horizon quickly. A dog looks at the horizon quickly.",
  },
  {
    locationId: "item22242",
    locationName: "item22242",
    locationAddress: "item22242",
    ratings: [
      { who: "Similar identities", rating: 1.25 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 50.961528435952374,
    lng: -1.7568404962244548,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4242",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats a book silently. The teacher builds the road quickly.",
  },
  {
    locationId: "item22243",
    locationName: "item22243",
    locationAddress: "item22243",
    ratings: [
      { who: "Similar identities", rating: 4.52 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 51.51709115289763,
    lng: -4.734408293686881,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4243",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat writes a tower angrily. A dog writes a fence silently.",
  },
  {
    locationId: "item22244",
    locationName: "item22244",
    locationAddress: "item22244",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 1.5 },
    ],
    lat: 54.51083046138231,
    lng: -5.903188489723622,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4244",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog runs towards the road angrily. A woman runs towards a tower quickly.",
  },
  {
    locationId: "item22245",
    locationName: "item22245",
    locationAddress: "item22245",
    ratings: null,
    lat: 53.961103363955345,
    lng: -5.704293735590232,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4245",
    tags: [],
    locationDescription: " The man runs towards the road lazily.",
  },
  {
    locationId: "item22246",
    locationName: "item22246",
    locationAddress: "item22246",
    ratings: [
      { who: "Similar identities", rating: 4.19 },
      { who: "All perspectives", rating: 1.31 },
    ],
    lat: 60.37881971724125,
    lng: 0.4462132857379526,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4246",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over a fence gracefully. A woman looks at a tower happily.",
  },
  {
    locationId: "item22247",
    locationName: "item22247",
    locationAddress: "item22247",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 1.8 },
    ],
    lat: 56.50497571090193,
    lng: -3.5895018937130674,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4247",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the horizon quickly. The teacher eats the road angrily. The teacher builds the road happily. The cat eats the horizon silently.",
  },
  {
    locationId: "item22248",
    locationName: "item22248",
    locationAddress: "item22248",
    ratings: null,
    lat: 53.112786968735826,
    lng: -6.218947900882332,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4248",
    tags: [],
    locationDescription:
      " The man runs towards the horizon angrily. The student jumps over the horizon lazily. The student eats the horizon silently. The cat writes the cake happily. The teacher jumps over a book gracefully.",
  },
  {
    locationId: "item22249",
    locationName: "item22249",
    locationAddress: "item22249",
    ratings: [
      { who: "Similar identities", rating: 3.24 },
      { who: "All perspectives", rating: 3.35 },
    ],
    lat: 60.397023613064384,
    lng: -3.1231449435539664,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4249",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes the horizon quickly. A woman eats the horizon angrily.",
  },
  {
    locationId: "item22250",
    locationName: "item22250",
    locationAddress: "item22250",
    ratings: null,
    lat: 50.824882946590265,
    lng: -3.2996335069358222,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4250",
    tags: [],
    locationDescription: " The teacher writes a fence quickly.",
  },
  {
    locationId: "item22251",
    locationName: "item22251",
    locationAddress: "item22251",
    ratings: null,
    lat: 57.26323133420028,
    lng: -4.061710203485333,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4251",
    tags: [],
    locationDescription:
      " The student jumps over the road lazily. A woman writes the road gracefully.",
  },
  {
    locationId: "item22252",
    locationName: "item22252",
    locationAddress: "item22252",
    ratings: null,
    lat: 57.68720289940674,
    lng: -3.9268197660914286,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4252",
    tags: [],
    locationDescription:
      " A dog looks at the road gracefully. The cat writes the horizon angrily.",
  },
  {
    locationId: "item22253",
    locationName: "item22253",
    locationAddress: "item22253",
    ratings: null,
    lat: 56.65112642584957,
    lng: -6.227119221812046,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4253",
    tags: [],
    locationDescription: " The cat jumps over the cake quickly.",
  },
  {
    locationId: "item22254",
    locationName: "item22254",
    locationAddress: "item22254",
    ratings: [
      { who: "Similar identities", rating: 3.94 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 52.71854810126079,
    lng: 1.5248606770961697,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4254",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat runs towards a fence quickly. A woman builds a tower angrily. A dog builds a fence gracefully. The teacher eats a book quickly.",
  },
  {
    locationId: "item22255",
    locationName: "item22255",
    locationAddress: "item22255",
    ratings: null,
    lat: 53.14298219842391,
    lng: -6.484640380268169,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4255",
    tags: [],
    locationDescription:
      " A dog eats the road quickly. The student writes the cake angrily. A woman runs towards the road silently.",
  },
  {
    locationId: "item22256",
    locationName: "item22256",
    locationAddress: "item22256",
    ratings: null,
    lat: 51.45553331079893,
    lng: -5.397624656142255,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4256",
    tags: [],
    locationDescription:
      " The man runs towards the horizon silently. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item22257",
    locationName: "item22257",
    locationAddress: "item22257",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 0.86 },
    ],
    lat: 54.927630812887045,
    lng: -3.601158628034189,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4257",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat builds the horizon silently. The teacher eats a fence angrily. The teacher writes the horizon lazily. The man runs towards the horizon lazily. A woman builds the cake happily.",
  },
  {
    locationId: "item22258",
    locationName: "item22258",
    locationAddress: "item22258",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 50.61622148883768,
    lng: -4.881765773834815,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4258",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over the horizon angrily. The man jumps over the horizon angrily. The man eats a book lazily.",
  },
  {
    locationId: "item22259",
    locationName: "item22259",
    locationAddress: "item22259",
    ratings: null,
    lat: 57.28639722728454,
    lng: 1.1428302078852504,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4259",
    tags: [],
    locationDescription: " A woman looks at a book happily.",
  },
  {
    locationId: "item22260",
    locationName: "item22260",
    locationAddress: "item22260",
    ratings: null,
    lat: 55.83987653300781,
    lng: 0.3572146171236543,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4260",
    tags: [],
    locationDescription: " The student jumps over the road lazily.",
  },
  {
    locationId: "item22261",
    locationName: "item22261",
    locationAddress: "item22261",
    ratings: null,
    lat: 50.34254610712646,
    lng: -2.139113168524423,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4261",
    tags: [],
    locationDescription:
      " A woman jumps over a fence silently. The student jumps over the road gracefully. The student looks at the cake silently.",
  },
  {
    locationId: "item22262",
    locationName: "item22262",
    locationAddress: "item22262",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 1.51 },
    ],
    lat: 50.67241684893373,
    lng: -3.1740145996838454,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4262",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at a book silently. The teacher runs towards a tower gracefully. A woman looks at a fence quickly. The teacher writes a fence quickly. A dog runs towards the horizon silently.",
  },
  {
    locationId: "item22263",
    locationName: "item22263",
    locationAddress: "item22263",
    ratings: null,
    lat: 53.95002007850556,
    lng: -1.6495373924262093,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4263",
    tags: [],
    locationDescription:
      " A dog builds the road lazily. A dog jumps over a book lazily. The man eats a fence lazily. The man eats a book silently. The student builds a tower lazily.",
  },
  {
    locationId: "item22264",
    locationName: "item22264",
    locationAddress: "item22264",
    ratings: [
      { who: "Similar identities", rating: 3.88 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 54.77074814637227,
    lng: -7.367448055588772,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4264",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards the cake gracefully. The teacher builds a book quickly. The teacher writes a tower silently.",
  },
  {
    locationId: "item22265",
    locationName: "item22265",
    locationAddress: "item22265",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 53.98843220915721,
    lng: 0.0726939277414047,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4265",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The cat eats the horizon happily.",
  },
  {
    locationId: "item22266",
    locationName: "item22266",
    locationAddress: "item22266",
    ratings: null,
    lat: 57.984854743370434,
    lng: -7.86637320307841,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4266",
    tags: [],
    locationDescription:
      " A dog builds the cake gracefully. The cat looks at a book gracefully. The student looks at the cake angrily.",
  },
  {
    locationId: "item22267",
    locationName: "item22267",
    locationAddress: "item22267",
    ratings: [
      { who: "Similar identities", rating: 2.23 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 55.93783858455825,
    lng: -0.8377286289198294,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4267",
    tags: [{ label: "child friendly" }],
    locationDescription: " A dog looks at the cake angrily.",
  },
  {
    locationId: "item22268",
    locationName: "item22268",
    locationAddress: "item22268",
    ratings: null,
    lat: 54.88362593707635,
    lng: -1.071902899593014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4268",
    tags: [],
    locationDescription:
      " A woman writes the cake gracefully. A dog runs towards a book silently. The student looks at the road angrily.",
  },
  {
    locationId: "item22269",
    locationName: "item22269",
    locationAddress: "item22269",
    ratings: null,
    lat: 56.383308131637506,
    lng: -8.458181280281103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4269",
    tags: [],
    locationDescription:
      " A dog builds a fence happily. The student eats a book gracefully. The man builds a book gracefully. A woman jumps over the horizon quickly. A dog runs towards a tower gracefully.",
  },
  {
    locationId: "item22270",
    locationName: "item22270",
    locationAddress: "item22270",
    ratings: null,
    lat: 53.97331575934959,
    lng: -1.670740471403584,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4270",
    tags: [],
    locationDescription:
      " The cat eats a fence silently. The student jumps over a fence quickly.",
  },
  {
    locationId: "item22271",
    locationName: "item22271",
    locationAddress: "item22271",
    ratings: [
      { who: "Similar identities", rating: 2.4 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 59.91198684118035,
    lng: 0.11338428482355312,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4271",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the horizon silently. A dog builds a tower quickly. The student writes the cake silently. A dog looks at the road angrily. The student runs towards the horizon happily.",
  },
  {
    locationId: "item22272",
    locationName: "item22272",
    locationAddress: "item22272",
    ratings: [
      { who: "Similar identities", rating: 2.92 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 51.80475930295001,
    lng: -7.3335413247728045,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4272",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " The man runs towards the horizon lazily.",
  },
  {
    locationId: "item22273",
    locationName: "item22273",
    locationAddress: "item22273",
    ratings: null,
    lat: 57.987201252777744,
    lng: 0.0808319154453141,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4273",
    tags: [],
    locationDescription:
      " A woman eats a tower gracefully. The man runs towards the horizon lazily. The man looks at the horizon lazily. The man looks at a fence happily.",
  },
  {
    locationId: "item22274",
    locationName: "item22274",
    locationAddress: "item22274",
    ratings: null,
    lat: 52.613780341924,
    lng: 0.392796462865034,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4274",
    tags: [],
    locationDescription:
      " The teacher looks at a tower happily. The man eats a tower angrily.",
  },
  {
    locationId: "item22275",
    locationName: "item22275",
    locationAddress: "item22275",
    ratings: [
      { who: "Similar identities", rating: 1.6 },
      { who: "All perspectives", rating: 1.51 },
    ],
    lat: 53.42754592234081,
    lng: -6.499732883333111,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4275",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at the cake angrily. The cat builds the cake happily. The student runs towards a fence silently.",
  },
  {
    locationId: "item22276",
    locationName: "item22276",
    locationAddress: "item22276",
    ratings: null,
    lat: 60.63932274478343,
    lng: -3.1730142817779283,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4276",
    tags: [],
    locationDescription:
      " The teacher builds a fence gracefully. The cat builds a fence lazily.",
  },
  {
    locationId: "item22277",
    locationName: "item22277",
    locationAddress: "item22277",
    ratings: [
      { who: "Similar identities", rating: 2.06 },
      { who: "All perspectives", rating: 2.24 },
    ],
    lat: 55.78999936220941,
    lng: 1.0817920057519181,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4277",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription: " A woman looks at a tower gracefully.",
  },
  {
    locationId: "item22278",
    locationName: "item22278",
    locationAddress: "item22278",
    ratings: null,
    lat: 52.101461822493626,
    lng: -0.436690737943751,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4278",
    tags: [],
    locationDescription: " A woman builds a tower gracefully.",
  },
  {
    locationId: "item22279",
    locationName: "item22279",
    locationAddress: "item22279",
    ratings: null,
    lat: 55.09035864231694,
    lng: -5.845005768271042,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4279",
    tags: [],
    locationDescription:
      " The teacher runs towards a book angrily. The cat writes the horizon quickly. The man looks at the horizon lazily. The cat writes the horizon lazily. The cat writes the road gracefully.",
  },
  {
    locationId: "item22280",
    locationName: "item22280",
    locationAddress: "item22280",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 1.35 },
    ],
    lat: 55.5442002372337,
    lng: -7.596389710918203,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4280",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman looks at a book quickly. A dog eats a book gracefully. The man jumps over a book lazily. The cat builds the horizon quickly. The student builds a fence gracefully.",
  },
  {
    locationId: "item22281",
    locationName: "item22281",
    locationAddress: "item22281",
    ratings: null,
    lat: 54.69893054310273,
    lng: -7.844456590327756,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4281",
    tags: [],
    locationDescription:
      " A dog builds a fence happily. The student eats a fence quickly. The student looks at a fence happily. The cat looks at a tower lazily.",
  },
  {
    locationId: "item22282",
    locationName: "item22282",
    locationAddress: "item22282",
    ratings: [
      { who: "Similar identities", rating: 2.27 },
      { who: "All perspectives", rating: 2.39 },
    ],
    lat: 51.01429651288052,
    lng: -3.6075347308533727,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4282",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " A dog runs towards a tower angrily.",
  },
  {
    locationId: "item22283",
    locationName: "item22283",
    locationAddress: "item22283",
    ratings: null,
    lat: 54.518634393698015,
    lng: -4.047110625548701,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4283",
    tags: [],
    locationDescription:
      " The man builds the horizon happily. A dog eats a book silently. The student looks at a fence quickly. The teacher looks at the horizon quickly. A woman builds a tower gracefully.",
  },
  {
    locationId: "item22284",
    locationName: "item22284",
    locationAddress: "item22284",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 3.77 },
    ],
    lat: 51.70333138970171,
    lng: -5.080951464602374,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4284",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat writes a tower angrily. A woman eats the cake happily. The student writes the cake lazily.",
  },
  {
    locationId: "item22285",
    locationName: "item22285",
    locationAddress: "item22285",
    ratings: null,
    lat: 52.528612076234985,
    lng: -3.2042735368083246,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4285",
    tags: [],
    locationDescription:
      " The teacher looks at the cake lazily. The teacher looks at the horizon lazily. The man builds the road gracefully. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item22286",
    locationName: "item22286",
    locationAddress: "item22286",
    ratings: [
      { who: "Similar identities", rating: 3.61 },
      { who: "All perspectives", rating: 1.84 },
    ],
    lat: 55.10688722784096,
    lng: -0.7332448378940706,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4286",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog builds the road happily. The cat builds the horizon angrily. A dog eats the cake silently. The man looks at the road angrily. The man jumps over the horizon quickly.",
  },
  {
    locationId: "item22287",
    locationName: "item22287",
    locationAddress: "item22287",
    ratings: null,
    lat: 53.78274815557336,
    lng: -3.008682160885747,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4287",
    tags: [],
    locationDescription:
      " The student writes the road silently. The man runs towards the cake gracefully. The man writes the horizon angrily.",
  },
  {
    locationId: "item22288",
    locationName: "item22288",
    locationAddress: "item22288",
    ratings: [
      { who: "Similar identities", rating: 0.36 },
      { who: "All perspectives", rating: 1.53 },
    ],
    lat: 59.11402728458697,
    lng: -0.1992793218022122,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4288",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man writes the road lazily. A dog runs towards a fence happily. The student runs towards a fence silently. The student jumps over a book angrily.",
  },
  {
    locationId: "item22289",
    locationName: "item22289",
    locationAddress: "item22289",
    ratings: [
      { who: "Similar identities", rating: 3.06 },
      { who: "All perspectives", rating: 3.96 },
    ],
    lat: 57.1540700847638,
    lng: -0.33077996308917434,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item4289",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats the road happily. The teacher jumps over the road lazily.",
  },
  {
    locationId: "item22290",
    locationName: "item22290",
    locationAddress: "item22290",
    ratings: [
      { who: "Similar identities", rating: 2.86 },
      { who: "All perspectives", rating: 1.16 },
    ],
    lat: 55.793251035441386,
    lng: -4.083470561207515,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4290",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher eats the cake angrily. The cat runs towards a fence quickly. The cat runs towards a fence silently.",
  },
  {
    locationId: "item22291",
    locationName: "item22291",
    locationAddress: "item22291",
    ratings: [
      { who: "Similar identities", rating: 0.36 },
      { who: "All perspectives", rating: 2.06 },
    ],
    lat: 51.04225792329751,
    lng: -8.560809342210534,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4291",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards a tower lazily. A dog eats a book quickly. A dog jumps over the cake gracefully. The cat writes the horizon angrily. The teacher runs towards a fence angrily.",
  },
  {
    locationId: "item22292",
    locationName: "item22292",
    locationAddress: "item22292",
    ratings: null,
    lat: 52.74934101256568,
    lng: -3.294196405081048,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4292",
    tags: [],
    locationDescription:
      " The student eats a fence gracefully. A dog builds the cake quickly. The student builds a fence gracefully. The teacher looks at the cake happily. The cat eats a tower angrily.",
  },
  {
    locationId: "item22293",
    locationName: "item22293",
    locationAddress: "item22293",
    ratings: null,
    lat: 53.280495454048435,
    lng: 0.6535675232880376,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4293",
    tags: [],
    locationDescription:
      " The student jumps over the horizon lazily. The cat runs towards the road gracefully.",
  },
  {
    locationId: "item22294",
    locationName: "item22294",
    locationAddress: "item22294",
    ratings: null,
    lat: 53.045111327571995,
    lng: -6.749139410626849,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4294",
    tags: [],
    locationDescription:
      " The man runs towards the cake lazily. The cat builds a fence silently.",
  },
  {
    locationId: "item22295",
    locationName: "item22295",
    locationAddress: "item22295",
    ratings: [
      { who: "Similar identities", rating: 2.81 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 58.85079580473244,
    lng: -0.9718775428599038,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4295",
    tags: [{ label: "accessible" }],
    locationDescription: " The teacher jumps over a book lazily.",
  },
  {
    locationId: "item22296",
    locationName: "item22296",
    locationAddress: "item22296",
    ratings: [
      { who: "Similar identities", rating: 3.67 },
      { who: "All perspectives", rating: 4.75 },
    ],
    lat: 56.895853894098664,
    lng: -7.307466877405603,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4296",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student eats a fence angrily. The man eats the road quickly. A woman eats the road silently. A woman builds the road angrily. A dog eats a book lazily.",
  },
  {
    locationId: "item22297",
    locationName: "item22297",
    locationAddress: "item22297",
    ratings: null,
    lat: 59.012137401879286,
    lng: -5.362555320615872,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4297",
    tags: [],
    locationDescription:
      " The teacher looks at the cake quickly. A dog builds the cake quickly. The student writes a fence lazily. The teacher runs towards the road silently. A woman writes the road quickly.",
  },
  {
    locationId: "item22298",
    locationName: "item22298",
    locationAddress: "item22298",
    ratings: [
      { who: "Similar identities", rating: 3.9 },
      { who: "All perspectives", rating: 3.09 },
    ],
    lat: 52.33196112284981,
    lng: -6.034926256785672,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4298",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student builds the horizon happily. The teacher eats the cake quickly. The man runs towards the road happily. The teacher runs towards a tower angrily.",
  },
  {
    locationId: "item22299",
    locationName: "item22299",
    locationAddress: "item22299",
    ratings: [
      { who: "Similar identities", rating: 3.66 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 50.00904816221794,
    lng: -5.56576728634531,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4299",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat eats the road gracefully. The cat eats a fence silently. The student eats the cake gracefully.",
  },
  {
    locationId: "item22300",
    locationName: "item22300",
    locationAddress: "item22300",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 4.3 },
    ],
    lat: 51.41120557437465,
    lng: -4.148025988829988,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4300",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man builds the road happily. The man runs towards the cake lazily. A dog eats the cake silently. The teacher jumps over the horizon angrily. The teacher runs towards a book silently.",
  },
  {
    locationId: "item22301",
    locationName: "item22301",
    locationAddress: "item22301",
    ratings: [
      { who: "Similar identities", rating: 4.36 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 59.74944373724999,
    lng: -3.7025420927157784,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4301",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog eats the horizon lazily. The teacher looks at the horizon silently. The teacher looks at the road gracefully.",
  },
  {
    locationId: "item22302",
    locationName: "item22302",
    locationAddress: "item22302",
    ratings: null,
    lat: 58.31310723336236,
    lng: -3.1947984007273416,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4302",
    tags: [],
    locationDescription:
      " A woman jumps over a book happily. The cat eats a fence lazily. The man eats a fence silently. The cat looks at a tower gracefully.",
  },
  {
    locationId: "item22303",
    locationName: "item22303",
    locationAddress: "item22303",
    ratings: null,
    lat: 54.051820938336235,
    lng: -2.0413764469281945,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4303",
    tags: [],
    locationDescription:
      " A woman eats a tower angrily. A dog writes the road angrily. The student builds a tower lazily. The man looks at the cake silently. The student runs towards a book happily.",
  },
  {
    locationId: "item22304",
    locationName: "item22304",
    locationAddress: "item22304",
    ratings: null,
    lat: 56.552398059832264,
    lng: -6.6351956966752805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4304",
    tags: [],
    locationDescription:
      " The teacher looks at a tower happily. A dog writes a fence happily.",
  },
  {
    locationId: "item22305",
    locationName: "item22305",
    locationAddress: "item22305",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 1.97 },
    ],
    lat: 49.93685267819701,
    lng: -2.502759685069245,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4305",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The teacher looks at a book angrily.",
  },
  {
    locationId: "item22306",
    locationName: "item22306",
    locationAddress: "item22306",
    ratings: null,
    lat: 51.32917207390159,
    lng: 0.9636177536539652,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4306",
    tags: [],
    locationDescription:
      " The student jumps over the road lazily. The cat jumps over a book happily. The teacher looks at the cake angrily. The student writes a book happily.",
  },
  {
    locationId: "item22307",
    locationName: "item22307",
    locationAddress: "item22307",
    ratings: null,
    lat: 53.50188452994451,
    lng: -8.560028219766249,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4307",
    tags: [],
    locationDescription:
      " The student writes the road angrily. The student eats a tower silently. A dog runs towards the horizon angrily. A woman builds the horizon angrily.",
  },
  {
    locationId: "item22308",
    locationName: "item22308",
    locationAddress: "item22308",
    ratings: null,
    lat: 50.04933192823837,
    lng: -3.176215254662303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4308",
    tags: [],
    locationDescription:
      " A dog looks at the road quickly. The cat builds a fence angrily. The cat looks at a fence lazily. The student eats the horizon lazily.",
  },
  {
    locationId: "item22309",
    locationName: "item22309",
    locationAddress: "item22309",
    ratings: [
      { who: "Similar identities", rating: 1.02 },
      { who: "All perspectives", rating: 1.68 },
    ],
    lat: 50.67117124152933,
    lng: -8.241292392124526,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4309",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes a fence quickly. The teacher looks at a book silently. The man jumps over a tower silently. The teacher jumps over the horizon quickly.",
  },
  {
    locationId: "item22310",
    locationName: "item22310",
    locationAddress: "item22310",
    ratings: [
      { who: "Similar identities", rating: 4.79 },
      { who: "All perspectives", rating: 3.57 },
    ],
    lat: 55.78402905673548,
    lng: -6.862650659650322,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4310",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at a fence quickly. The student runs towards the road quickly. A woman jumps over the road quickly. The student runs towards a tower lazily.",
  },
  {
    locationId: "item22311",
    locationName: "item22311",
    locationAddress: "item22311",
    ratings: null,
    lat: 54.28349823772278,
    lng: -6.134388418627445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4311",
    tags: [],
    locationDescription:
      " The man builds a tower gracefully. The student runs towards a tower gracefully. A woman eats a book lazily.",
  },
  {
    locationId: "item22312",
    locationName: "item22312",
    locationAddress: "item22312",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 0.76 },
    ],
    lat: 56.39522803697846,
    lng: 0.7305797872270627,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4312",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog runs towards a tower gracefully. A woman writes a tower silently. The teacher runs towards the cake lazily. The student eats the cake angrily. A woman builds the road gracefully.",
  },
  {
    locationId: "item22313",
    locationName: "item22313",
    locationAddress: "item22313",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 3.72 },
    ],
    lat: 60.8950075339395,
    lng: -1.121466034420675,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4313",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The student jumps over the horizon angrily.",
  },
  {
    locationId: "item22314",
    locationName: "item22314",
    locationAddress: "item22314",
    ratings: null,
    lat: 53.055041164210394,
    lng: -2.8870411869451056,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4314",
    tags: [],
    locationDescription:
      " The man eats a fence happily. A woman runs towards the horizon quickly. The man looks at the road lazily. The man writes the cake lazily. The student writes a tower angrily.",
  },
  {
    locationId: "item22315",
    locationName: "item22315",
    locationAddress: "item22315",
    ratings: null,
    lat: 55.057516199257584,
    lng: -8.259600580203271,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4315",
    tags: [],
    locationDescription:
      " A dog builds a book gracefully. A woman looks at a fence quickly. A dog jumps over a book happily. A dog looks at a fence silently.",
  },
  {
    locationId: "item22316",
    locationName: "item22316",
    locationAddress: "item22316",
    ratings: null,
    lat: 54.35577971740895,
    lng: -7.272170484231692,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4316",
    tags: [],
    locationDescription:
      " The man eats a book gracefully. The teacher builds the road angrily. The student runs towards a fence angrily. A woman eats a fence lazily. A woman looks at a fence silently.",
  },
  {
    locationId: "item22317",
    locationName: "item22317",
    locationAddress: "item22317",
    ratings: null,
    lat: 58.872613100005104,
    lng: 0.819852051116122,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4317",
    tags: [],
    locationDescription:
      " A dog jumps over a book happily. The teacher eats a book angrily. A woman jumps over a book silently. The man writes the road happily.",
  },
  {
    locationId: "item22318",
    locationName: "item22318",
    locationAddress: "item22318",
    ratings: null,
    lat: 52.610333546222066,
    lng: -5.160603500303127,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4318",
    tags: [],
    locationDescription: " The teacher eats the cake happily.",
  },
  {
    locationId: "item22319",
    locationName: "item22319",
    locationAddress: "item22319",
    ratings: [
      { who: "Similar identities", rating: 1.74 },
      { who: "All perspectives", rating: 4.21 },
    ],
    lat: 54.70105075932463,
    lng: 1.4747283669102913,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4319",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher looks at the road happily. A dog jumps over the horizon gracefully.",
  },
  {
    locationId: "item22320",
    locationName: "item22320",
    locationAddress: "item22320",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 2.18 },
    ],
    lat: 52.51884996113207,
    lng: -1.563690252404653,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4320",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher eats the horizon silently. The student looks at the cake silently. The man writes a book silently. A dog looks at the horizon quickly.",
  },
  {
    locationId: "item22321",
    locationName: "item22321",
    locationAddress: "item22321",
    ratings: [
      { who: "Similar identities", rating: 2.63 },
      { who: "All perspectives", rating: 0.33 },
    ],
    lat: 50.55331790668839,
    lng: 0.22391199213210733,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4321",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman writes the horizon quickly. A woman looks at a book happily. The cat eats a book quickly. The teacher builds a book angrily.",
  },
  {
    locationId: "item22322",
    locationName: "item22322",
    locationAddress: "item22322",
    ratings: [
      { who: "Similar identities", rating: 4.59 },
      { who: "All perspectives", rating: 4.2 },
    ],
    lat: 51.714090694877065,
    lng: 0.3701100061137428,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4322",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A woman writes a fence silently.",
  },
  {
    locationId: "item22323",
    locationName: "item22323",
    locationAddress: "item22323",
    ratings: null,
    lat: 55.21631803791832,
    lng: -6.306198874651252,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4323",
    tags: [],
    locationDescription:
      " The cat runs towards the cake angrily. The student eats the cake quickly.",
  },
  {
    locationId: "item22324",
    locationName: "item22324",
    locationAddress: "item22324",
    ratings: null,
    lat: 54.3307372296343,
    lng: 0.7874341527125619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4324",
    tags: [],
    locationDescription:
      " A woman jumps over the road happily. The man eats the horizon gracefully. A dog looks at the horizon angrily.",
  },
  {
    locationId: "item22325",
    locationName: "item22325",
    locationAddress: "item22325",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 60.28951072101368,
    lng: -1.1607869945300129,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4325",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at the horizon happily. A woman runs towards the horizon silently. The cat looks at the cake silently. A woman runs towards a tower happily. A dog jumps over the cake angrily.",
  },
  {
    locationId: "item22326",
    locationName: "item22326",
    locationAddress: "item22326",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 3.85 },
    ],
    lat: 57.312571549589954,
    lng: 0.49788055794217456,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4326",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over a book happily. A woman writes a book gracefully. The man builds a tower quickly.",
  },
  {
    locationId: "item22327",
    locationName: "item22327",
    locationAddress: "item22327",
    ratings: [
      { who: "Similar identities", rating: 4.39 },
      { who: "All perspectives", rating: 4.91 },
    ],
    lat: 50.135727128136416,
    lng: 0.20239813294367615,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4327",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher looks at the horizon silently. The student jumps over a fence silently. The teacher eats a tower silently. The man eats a book happily.",
  },
  {
    locationId: "item22328",
    locationName: "item22328",
    locationAddress: "item22328",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 1.31 },
    ],
    lat: 60.02465150457368,
    lng: -3.4569166281709363,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4328",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat builds a book happily. The student eats the road quickly. A dog builds the road happily.",
  },
  {
    locationId: "item22329",
    locationName: "item22329",
    locationAddress: "item22329",
    ratings: null,
    lat: 58.77383168045033,
    lng: -6.3398225115303415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4329",
    tags: [],
    locationDescription:
      " The teacher looks at a tower quickly. The man builds a book silently. The student builds the cake silently.",
  },
  {
    locationId: "item22330",
    locationName: "item22330",
    locationAddress: "item22330",
    ratings: null,
    lat: 58.60393035306875,
    lng: -6.285892028597926,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4330",
    tags: [],
    locationDescription:
      " The student jumps over a book silently. The student builds a fence angrily. The cat eats a fence angrily. The cat eats the horizon angrily.",
  },
  {
    locationId: "item22331",
    locationName: "item22331",
    locationAddress: "item22331",
    ratings: null,
    lat: 56.570170567592456,
    lng: -4.914269432039881,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4331",
    tags: [],
    locationDescription:
      " A dog eats the cake silently. A woman eats a fence happily.",
  },
  {
    locationId: "item22332",
    locationName: "item22332",
    locationAddress: "item22332",
    ratings: null,
    lat: 50.54737494597209,
    lng: -4.630713787246609,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4332",
    tags: [],
    locationDescription:
      " The man jumps over a tower lazily. A dog looks at a book silently. A woman writes the horizon gracefully. The cat writes a fence happily. The teacher runs towards a book gracefully.",
  },
  {
    locationId: "item22333",
    locationName: "item22333",
    locationAddress: "item22333",
    ratings: null,
    lat: 50.478176423313016,
    lng: -2.8385038433616696,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4333",
    tags: [],
    locationDescription:
      " The student jumps over the cake silently. The man eats the horizon angrily. The student jumps over a tower quickly.",
  },
  {
    locationId: "item22334",
    locationName: "item22334",
    locationAddress: "item22334",
    ratings: null,
    lat: 57.852349305184696,
    lng: -7.985623870541786,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4334",
    tags: [],
    locationDescription:
      " The teacher eats the horizon happily. The student eats the horizon gracefully. A woman jumps over a tower angrily.",
  },
  {
    locationId: "item22335",
    locationName: "item22335",
    locationAddress: "item22335",
    ratings: [
      { who: "Similar identities", rating: 2.97 },
      { who: "All perspectives", rating: 3.72 },
    ],
    lat: 55.56452359690366,
    lng: -7.994289457211208,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4335",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student eats the cake silently. The teacher runs towards the road happily. A woman builds the cake lazily. The cat runs towards a tower angrily.",
  },
  {
    locationId: "item22336",
    locationName: "item22336",
    locationAddress: "item22336",
    ratings: null,
    lat: 59.41177707568531,
    lng: -0.13649350399360927,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4336",
    tags: [],
    locationDescription:
      " The cat eats a book silently. A woman jumps over the road gracefully. A woman looks at a tower lazily. The man eats the road angrily.",
  },
  {
    locationId: "item22337",
    locationName: "item22337",
    locationAddress: "item22337",
    ratings: [
      { who: "Similar identities", rating: 1.39 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 59.32421695036828,
    lng: -0.37248721964009945,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4337",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student builds the road silently. The cat looks at a fence silently.",
  },
  {
    locationId: "item22338",
    locationName: "item22338",
    locationAddress: "item22338",
    ratings: [
      { who: "Similar identities", rating: 4.92 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 55.07673291838006,
    lng: -4.0180218575316164,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4338",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes the cake happily. The man writes a book quickly. The cat writes a fence happily. The student looks at a book happily. The cat eats the cake happily.",
  },
  {
    locationId: "item22339",
    locationName: "item22339",
    locationAddress: "item22339",
    ratings: null,
    lat: 52.12714284088204,
    lng: -4.188292255490929,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4339",
    tags: [],
    locationDescription:
      " The cat runs towards a book angrily. The teacher looks at the cake happily. The man eats a tower happily. A woman writes a book gracefully. The student looks at a fence lazily.",
  },
  {
    locationId: "item22340",
    locationName: "item22340",
    locationAddress: "item22340",
    ratings: null,
    lat: 58.0271877136608,
    lng: -3.1610545709382976,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4340",
    tags: [],
    locationDescription: " The teacher jumps over the cake happily.",
  },
  {
    locationId: "item22341",
    locationName: "item22341",
    locationAddress: "item22341",
    ratings: [
      { who: "Similar identities", rating: 0.51 },
      { who: "All perspectives", rating: 1.05 },
    ],
    lat: 59.20519157765736,
    lng: -5.35797525117998,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4341",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman builds a fence angrily. A dog eats a book silently. A dog looks at the horizon lazily.",
  },
  {
    locationId: "item22342",
    locationName: "item22342",
    locationAddress: "item22342",
    ratings: [
      { who: "Similar identities", rating: 1.29 },
      { who: "All perspectives", rating: 4.73 },
    ],
    lat: 58.39613679443171,
    lng: -2.0806573800001082,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4342",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat looks at a fence lazily. A woman jumps over a tower silently.",
  },
  {
    locationId: "item22343",
    locationName: "item22343",
    locationAddress: "item22343",
    ratings: [
      { who: "Similar identities", rating: 3.03 },
      { who: "All perspectives", rating: 4.13 },
    ],
    lat: 58.40232395393518,
    lng: -4.247609231974159,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4343",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student writes a fence silently. The student eats the road happily.",
  },
  {
    locationId: "item22344",
    locationName: "item22344",
    locationAddress: "item22344",
    ratings: [
      { who: "Similar identities", rating: 4.8 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 55.08628143074566,
    lng: -8.496141614626422,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4344",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards a fence happily. A dog builds a book quickly. A dog looks at the horizon angrily. The teacher runs towards a fence quickly.",
  },
  {
    locationId: "item22345",
    locationName: "item22345",
    locationAddress: "item22345",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 2.09 },
    ],
    lat: 55.923108585082375,
    lng: 0.9900200033553066,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4345",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student writes the cake gracefully. The teacher jumps over a fence lazily. The man jumps over the cake lazily. The man looks at the cake silently. The cat looks at the horizon happily.",
  },
  {
    locationId: "item22346",
    locationName: "item22346",
    locationAddress: "item22346",
    ratings: null,
    lat: 53.57944134325662,
    lng: -1.1251893269344277,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4346",
    tags: [],
    locationDescription: " The cat eats the cake lazily.",
  },
  {
    locationId: "item22347",
    locationName: "item22347",
    locationAddress: "item22347",
    ratings: [
      { who: "Similar identities", rating: 1.03 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 58.39376610478365,
    lng: -1.781852003673233,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4347",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at the road angrily. A dog writes a tower angrily. The student eats the horizon gracefully.",
  },
  {
    locationId: "item22348",
    locationName: "item22348",
    locationAddress: "item22348",
    ratings: [
      { who: "Similar identities", rating: 2.03 },
      { who: "All perspectives", rating: 3.9 },
    ],
    lat: 51.00865122230884,
    lng: -4.538138233427947,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4348",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a book gracefully. The student looks at a book lazily. The teacher eats the horizon angrily.",
  },
  {
    locationId: "item22349",
    locationName: "item22349",
    locationAddress: "item22349",
    ratings: null,
    lat: 57.73411546386161,
    lng: -6.228334872070184,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4349",
    tags: [],
    locationDescription:
      " The cat writes the cake angrily. A woman jumps over a fence angrily. The cat looks at the road quickly. The man runs towards the horizon silently. A woman runs towards a tower gracefully.",
  },
  {
    locationId: "item22350",
    locationName: "item22350",
    locationAddress: "item22350",
    ratings: null,
    lat: 49.93430178506848,
    lng: -5.81488196855981,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4350",
    tags: [],
    locationDescription: " The student builds the cake angrily.",
  },
  {
    locationId: "item22351",
    locationName: "item22351",
    locationAddress: "item22351",
    ratings: null,
    lat: 56.61076366371571,
    lng: 0.48504845665490137,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4351",
    tags: [],
    locationDescription:
      " The student runs towards the cake lazily. The student jumps over a fence quickly.",
  },
  {
    locationId: "item22352",
    locationName: "item22352",
    locationAddress: "item22352",
    ratings: null,
    lat: 50.843527635818575,
    lng: -0.9093357073948081,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4352",
    tags: [],
    locationDescription:
      " The student eats the road lazily. The teacher runs towards a fence gracefully. The cat jumps over a book lazily.",
  },
  {
    locationId: "item22353",
    locationName: "item22353",
    locationAddress: "item22353",
    ratings: [
      { who: "Similar identities", rating: 2.36 },
      { who: "All perspectives", rating: 3.14 },
    ],
    lat: 51.91001142029996,
    lng: -7.542477875275263,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4353",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The cat eats the road gracefully. A woman looks at the cake quickly.",
  },
  {
    locationId: "item22354",
    locationName: "item22354",
    locationAddress: "item22354",
    ratings: [
      { who: "Similar identities", rating: 0.14 },
      { who: "All perspectives", rating: 4.66 },
    ],
    lat: 51.62620802519832,
    lng: -2.6319320613010175,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4354",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A dog looks at a fence lazily.",
  },
  {
    locationId: "item22355",
    locationName: "item22355",
    locationAddress: "item22355",
    ratings: null,
    lat: 52.055539567347566,
    lng: -7.021383791008777,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4355",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon gracefully. The student jumps over the cake happily. The teacher eats a fence quickly.",
  },
  {
    locationId: "item22356",
    locationName: "item22356",
    locationAddress: "item22356",
    ratings: null,
    lat: 50.21590440483217,
    lng: -1.0833019128154628,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4356",
    tags: [],
    locationDescription: " The student jumps over a book quickly.",
  },
  {
    locationId: "item22357",
    locationName: "item22357",
    locationAddress: "item22357",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 1.7 },
    ],
    lat: 57.739104924111714,
    lng: -5.927566862943664,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4357",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man jumps over the horizon angrily.",
  },
  {
    locationId: "item22358",
    locationName: "item22358",
    locationAddress: "item22358",
    ratings: [
      { who: "Similar identities", rating: 3.97 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 57.77171720074071,
    lng: -2.519220828089204,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4358",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats a fence quickly. A dog eats a fence quickly. The man runs towards a tower silently.",
  },
  {
    locationId: "item22359",
    locationName: "item22359",
    locationAddress: "item22359",
    ratings: null,
    lat: 55.749967546208204,
    lng: -0.35088048502963787,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4359",
    tags: [],
    locationDescription:
      " The student looks at a book angrily. The student jumps over a tower gracefully. The student eats a tower happily. The man eats a tower quickly.",
  },
  {
    locationId: "item22360",
    locationName: "item22360",
    locationAddress: "item22360",
    ratings: null,
    lat: 56.778839983821875,
    lng: -1.5145396116708252,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4360",
    tags: [],
    locationDescription: " The cat runs towards a book gracefully.",
  },
  {
    locationId: "item22361",
    locationName: "item22361",
    locationAddress: "item22361",
    ratings: null,
    lat: 53.27075193375523,
    lng: -6.427918155503635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4361",
    tags: [],
    locationDescription:
      " A woman looks at a fence quickly. The man runs towards a fence happily. The cat runs towards a fence happily. A dog runs towards a tower gracefully.",
  },
  {
    locationId: "item22362",
    locationName: "item22362",
    locationAddress: "item22362",
    ratings: null,
    lat: 58.27621657110274,
    lng: -4.887720712158052,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4362",
    tags: [],
    locationDescription: " The student looks at a tower quickly.",
  },
  {
    locationId: "item22363",
    locationName: "item22363",
    locationAddress: "item22363",
    ratings: null,
    lat: 52.287032950129465,
    lng: -3.814205872770465,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4363",
    tags: [],
    locationDescription:
      " A woman writes a fence angrily. The man runs towards the road quickly. The man writes a tower happily.",
  },
  {
    locationId: "item22364",
    locationName: "item22364",
    locationAddress: "item22364",
    ratings: null,
    lat: 55.29377591619168,
    lng: -2.6235933344763396,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4364",
    tags: [],
    locationDescription:
      " The teacher writes a book quickly. The man builds a book quickly. The student writes the road angrily. The cat builds a fence angrily.",
  },
  {
    locationId: "item22365",
    locationName: "item22365",
    locationAddress: "item22365",
    ratings: [
      { who: "Similar identities", rating: 0.53 },
      { who: "All perspectives", rating: 1.88 },
    ],
    lat: 53.43856851301165,
    lng: -4.075817590143416,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4365",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man eats a book lazily. The cat looks at the road happily. The student looks at the cake lazily. A woman jumps over a book quickly. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item22366",
    locationName: "item22366",
    locationAddress: "item22366",
    ratings: null,
    lat: 57.759935583299274,
    lng: -6.962060477842718,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4366",
    tags: [],
    locationDescription:
      " The cat looks at the road lazily. The man eats the cake lazily. The man looks at the cake gracefully.",
  },
  {
    locationId: "item22367",
    locationName: "item22367",
    locationAddress: "item22367",
    ratings: null,
    lat: 56.36338203836734,
    lng: -4.1072335944044776,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4367",
    tags: [],
    locationDescription:
      " The teacher eats the road angrily. The man writes the cake angrily. The student jumps over a fence gracefully. The student eats a fence lazily.",
  },
  {
    locationId: "item22368",
    locationName: "item22368",
    locationAddress: "item22368",
    ratings: [
      { who: "Similar identities", rating: 2.72 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 55.310413997431425,
    lng: -3.9073931519034346,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4368",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " The man jumps over a fence gracefully.",
  },
  {
    locationId: "item22369",
    locationName: "item22369",
    locationAddress: "item22369",
    ratings: [
      { who: "Similar identities", rating: 4.32 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 51.532773980948,
    lng: -3.7355312201072826,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4369",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher builds the horizon silently. The man jumps over a fence lazily. The teacher builds a book happily. The man eats the horizon lazily.",
  },
  {
    locationId: "item22370",
    locationName: "item22370",
    locationAddress: "item22370",
    ratings: null,
    lat: 54.414041522695335,
    lng: -0.6560330908943213,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4370",
    tags: [],
    locationDescription: " The cat writes the cake silently.",
  },
  {
    locationId: "item22371",
    locationName: "item22371",
    locationAddress: "item22371",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 51.58257042708642,
    lng: -2.703116801730835,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4371",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher eats a fence happily. A dog runs towards a book gracefully. The cat eats a tower happily.",
  },
  {
    locationId: "item22372",
    locationName: "item22372",
    locationAddress: "item22372",
    ratings: null,
    lat: 58.6753322275808,
    lng: -5.911052423582632,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4372",
    tags: [],
    locationDescription:
      " A woman runs towards a book happily. The man eats a tower lazily. The student eats the horizon gracefully. The cat builds the horizon happily.",
  },
  {
    locationId: "item22373",
    locationName: "item22373",
    locationAddress: "item22373",
    ratings: null,
    lat: 51.971278046464704,
    lng: -1.529545178469026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4373",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon silently. The student jumps over the horizon silently. A dog jumps over a book silently. The man runs towards the horizon lazily.",
  },
  {
    locationId: "item22374",
    locationName: "item22374",
    locationAddress: "item22374",
    ratings: null,
    lat: 60.87026469780207,
    lng: -5.150576121649051,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4374",
    tags: [],
    locationDescription:
      " The cat eats the road lazily. The cat eats the road silently.",
  },
  {
    locationId: "item22375",
    locationName: "item22375",
    locationAddress: "item22375",
    ratings: null,
    lat: 52.557485827174574,
    lng: 1.035565469877012,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4375",
    tags: [],
    locationDescription:
      " A woman looks at the horizon silently. A woman runs towards a book happily. A woman eats the road angrily. A woman runs towards a book gracefully.",
  },
  {
    locationId: "item22376",
    locationName: "item22376",
    locationAddress: "item22376",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 2.86 },
    ],
    lat: 54.68008344303041,
    lng: -0.2669313068313084,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4376",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man jumps over a fence gracefully. The man runs towards a fence angrily. The cat looks at a tower silently.",
  },
  {
    locationId: "item22377",
    locationName: "item22377",
    locationAddress: "item22377",
    ratings: [
      { who: "Similar identities", rating: 2.54 },
      { who: "All perspectives", rating: 4.71 },
    ],
    lat: 60.50402603087584,
    lng: -8.025840658943203,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4377",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The teacher writes the road happily. The teacher runs towards a book happily. A dog builds the road lazily. The man looks at a book gracefully. A dog eats the cake quickly.",
  },
  {
    locationId: "item22378",
    locationName: "item22378",
    locationAddress: "item22378",
    ratings: null,
    lat: 54.06266151588824,
    lng: -1.0959398371257016,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4378",
    tags: [],
    locationDescription:
      " The teacher eats a fence angrily. A woman looks at a book gracefully. A woman runs towards the horizon gracefully.",
  },
  {
    locationId: "item22379",
    locationName: "item22379",
    locationAddress: "item22379",
    ratings: null,
    lat: 51.680142823636324,
    lng: -4.0347451829162075,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4379",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence quickly. The student jumps over a book happily. A woman looks at the horizon happily.",
  },
  {
    locationId: "item22380",
    locationName: "item22380",
    locationAddress: "item22380",
    ratings: [
      { who: "Similar identities", rating: 4.43 },
      { who: "All perspectives", rating: 4.58 },
    ],
    lat: 59.128560610431634,
    lng: -0.7891739936045559,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4380",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher builds the cake lazily. The man looks at the cake quickly. A woman builds a fence gracefully. A woman writes the road silently. The cat looks at a book lazily.",
  },
  {
    locationId: "item22381",
    locationName: "item22381",
    locationAddress: "item22381",
    ratings: [
      { who: "Similar identities", rating: 0.63 },
      { who: "All perspectives", rating: 2.67 },
    ],
    lat: 56.119914032601294,
    lng: -8.384849856172037,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4381",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats the cake lazily. The teacher writes a tower gracefully.",
  },
  {
    locationId: "item22382",
    locationName: "item22382",
    locationAddress: "item22382",
    ratings: [
      { who: "Similar identities", rating: 0.6 },
      { who: "All perspectives", rating: 3.06 },
    ],
    lat: 58.94599077422955,
    lng: -5.701145802313379,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4382",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " The cat looks at a tower lazily.",
  },
  {
    locationId: "item22383",
    locationName: "item22383",
    locationAddress: "item22383",
    ratings: [
      { who: "Similar identities", rating: 1.8 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 52.49732937428904,
    lng: -0.00042127723149221197,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4383",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a tower gracefully. The teacher jumps over the horizon lazily.",
  },
  {
    locationId: "item22384",
    locationName: "item22384",
    locationAddress: "item22384",
    ratings: [
      { who: "Similar identities", rating: 3.32 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 58.92514886414054,
    lng: -3.9747054220245017,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4384",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The student writes a fence angrily.",
  },
  {
    locationId: "item22385",
    locationName: "item22385",
    locationAddress: "item22385",
    ratings: null,
    lat: 60.47575098564187,
    lng: -5.230072069107096,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4385",
    tags: [],
    locationDescription:
      " The teacher writes the cake angrily. The cat jumps over a tower happily. The man builds a book lazily.",
  },
  {
    locationId: "item22386",
    locationName: "item22386",
    locationAddress: "item22386",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 3.88 },
    ],
    lat: 57.95689540579603,
    lng: -2.3289374296071728,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4386",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat builds the horizon silently. A woman builds the horizon lazily. The student eats the cake angrily. The teacher runs towards a tower angrily. A woman looks at the road quickly.",
  },
  {
    locationId: "item22387",
    locationName: "item22387",
    locationAddress: "item22387",
    ratings: null,
    lat: 54.52608787248923,
    lng: -4.585464677763747,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4387",
    tags: [],
    locationDescription:
      " The man eats a fence happily. The student looks at a book gracefully. A dog looks at the cake lazily. The student eats the cake angrily. The man builds the cake silently.",
  },
  {
    locationId: "item22388",
    locationName: "item22388",
    locationAddress: "item22388",
    ratings: null,
    lat: 60.385148970232784,
    lng: -4.39933390327323,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4388",
    tags: [],
    locationDescription:
      " The teacher looks at a fence quickly. The student jumps over a fence angrily. The cat looks at a tower silently.",
  },
  {
    locationId: "item22389",
    locationName: "item22389",
    locationAddress: "item22389",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 52.63945704439798,
    lng: -3.356810438849161,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4389",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The student runs towards a tower quickly. A dog writes a tower lazily. The cat builds a fence angrily. A dog builds the road silently. The student writes a tower happily.",
  },
  {
    locationId: "item22390",
    locationName: "item22390",
    locationAddress: "item22390",
    ratings: null,
    lat: 55.69461537716359,
    lng: -1.567903562585637,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4390",
    tags: [],
    locationDescription:
      " The cat runs towards a tower silently. The teacher runs towards a tower silently.",
  },
  {
    locationId: "item22391",
    locationName: "item22391",
    locationAddress: "item22391",
    ratings: null,
    lat: 60.81409956191237,
    lng: -5.582936419442802,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4391",
    tags: [],
    locationDescription:
      " The student writes the horizon angrily. The student runs towards a book happily. A dog jumps over a book silently. The man builds a book quickly.",
  },
  {
    locationId: "item22392",
    locationName: "item22392",
    locationAddress: "item22392",
    ratings: null,
    lat: 58.199310740858806,
    lng: -7.1561187762390315,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4392",
    tags: [],
    locationDescription:
      " The teacher builds a fence lazily. The student runs towards a tower lazily. A woman builds a tower gracefully. The man writes a tower lazily.",
  },
  {
    locationId: "item22393",
    locationName: "item22393",
    locationAddress: "item22393",
    ratings: [
      { who: "Similar identities", rating: 0.19 },
      { who: "All perspectives", rating: 3.31 },
    ],
    lat: 54.99431866408664,
    lng: -6.490778790862068,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4393",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog looks at the cake happily. The cat eats a fence quickly. The cat jumps over a book gracefully.",
  },
  {
    locationId: "item22394",
    locationName: "item22394",
    locationAddress: "item22394",
    ratings: null,
    lat: 51.07796182638882,
    lng: -6.422393062453996,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4394",
    tags: [],
    locationDescription:
      " The cat jumps over the cake gracefully. The man writes the cake gracefully. The man eats the road happily.",
  },
  {
    locationId: "item22395",
    locationName: "item22395",
    locationAddress: "item22395",
    ratings: [
      { who: "Similar identities", rating: 2.49 },
      { who: "All perspectives", rating: 3.13 },
    ],
    lat: 55.60242044461206,
    lng: -7.975817621647242,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4395",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher looks at the cake gracefully. The cat writes the road quickly.",
  },
  {
    locationId: "item22396",
    locationName: "item22396",
    locationAddress: "item22396",
    ratings: null,
    lat: 56.15386021420083,
    lng: -3.0515783541377486,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4396",
    tags: [],
    locationDescription:
      " The man looks at the road gracefully. A dog runs towards a fence angrily.",
  },
  {
    locationId: "item22397",
    locationName: "item22397",
    locationAddress: "item22397",
    ratings: [
      { who: "Similar identities", rating: 4.19 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 52.59060103158999,
    lng: -4.967237346473618,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4397",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man eats the horizon silently. The cat jumps over the road angrily. A dog builds a book quickly.",
  },
  {
    locationId: "item22398",
    locationName: "item22398",
    locationAddress: "item22398",
    ratings: [
      { who: "Similar identities", rating: 3.38 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 59.54087470091975,
    lng: -5.068842221340303,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4398",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A woman builds a tower happily. A woman looks at a fence angrily. A dog looks at a fence silently. A dog looks at a tower gracefully. A woman builds the road angrily.",
  },
  {
    locationId: "item22399",
    locationName: "item22399",
    locationAddress: "item22399",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 60.07214913888397,
    lng: -5.559899963466917,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4399",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog jumps over the horizon happily. The man jumps over the cake silently.",
  },
  {
    locationId: "item22400",
    locationName: "item22400",
    locationAddress: "item22400",
    ratings: [
      { who: "Similar identities", rating: 3.33 },
      { who: "All perspectives", rating: 3.04 },
    ],
    lat: 50.99493778718955,
    lng: -5.315725564091684,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4400",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " A dog builds a fence silently.",
  },
  {
    locationId: "item22401",
    locationName: "item22401",
    locationAddress: "item22401",
    ratings: [
      { who: "Similar identities", rating: 4.18 },
      { who: "All perspectives", rating: 4.61 },
    ],
    lat: 53.84192976615696,
    lng: -0.6867902204063938,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4401",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student eats the horizon silently. The cat writes a tower silently. A dog writes the horizon happily.",
  },
  {
    locationId: "item22402",
    locationName: "item22402",
    locationAddress: "item22402",
    ratings: null,
    lat: 53.434036657733955,
    lng: -3.9725880310810506,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4402",
    tags: [],
    locationDescription:
      " A woman builds a fence happily. A dog runs towards a fence lazily. The teacher jumps over a book happily. A dog eats the cake angrily. The man runs towards a book happily.",
  },
  {
    locationId: "item22403",
    locationName: "item22403",
    locationAddress: "item22403",
    ratings: null,
    lat: 57.756890800347335,
    lng: 1.6018216593070527,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4403",
    tags: [],
    locationDescription:
      " A woman looks at the road happily. The cat runs towards a book quickly.",
  },
  {
    locationId: "item22404",
    locationName: "item22404",
    locationAddress: "item22404",
    ratings: null,
    lat: 52.201688557126474,
    lng: -5.128448885664281,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4404",
    tags: [],
    locationDescription: " The cat runs towards the horizon angrily.",
  },
  {
    locationId: "item22405",
    locationName: "item22405",
    locationAddress: "item22405",
    ratings: [
      { who: "Similar identities", rating: 0.98 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 51.37098958958296,
    lng: -3.1565911886941915,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4405",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The teacher builds a fence angrily.",
  },
  {
    locationId: "item22406",
    locationName: "item22406",
    locationAddress: "item22406",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 2.52 },
    ],
    lat: 58.36477013301907,
    lng: -3.2503490124683543,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4406",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog looks at the cake lazily. A woman writes the road angrily. The teacher looks at the cake lazily.",
  },
  {
    locationId: "item22407",
    locationName: "item22407",
    locationAddress: "item22407",
    ratings: null,
    lat: 53.46671371076757,
    lng: -3.9453398893793628,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4407",
    tags: [],
    locationDescription:
      " A woman runs towards a tower gracefully. The man writes a fence lazily. The man looks at the road angrily. The cat writes a fence happily. The man looks at a book happily.",
  },
  {
    locationId: "item22408",
    locationName: "item22408",
    locationAddress: "item22408",
    ratings: [
      { who: "Similar identities", rating: 2.41 },
      { who: "All perspectives", rating: 1.67 },
    ],
    lat: 50.416169045939014,
    lng: 1.3255033947036203,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4408",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman looks at the cake silently. The cat runs towards the cake gracefully. A dog runs towards a book angrily. The student looks at a fence lazily. A dog writes the cake lazily.",
  },
  {
    locationId: "item22409",
    locationName: "item22409",
    locationAddress: "item22409",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 3.24 },
    ],
    lat: 60.236556486054155,
    lng: 1.5965018115205503,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4409",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats a fence angrily. The teacher writes a fence quickly. The cat eats a fence silently.",
  },
  {
    locationId: "item22410",
    locationName: "item22410",
    locationAddress: "item22410",
    ratings: [
      { who: "Similar identities", rating: 3.59 },
      { who: "All perspectives", rating: 1.97 },
    ],
    lat: 55.719615404610735,
    lng: -3.51761468447166,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4410",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats the cake quickly. The man jumps over the road lazily. A dog looks at the road happily. A dog writes the horizon gracefully.",
  },
  {
    locationId: "item22411",
    locationName: "item22411",
    locationAddress: "item22411",
    ratings: [
      { who: "Similar identities", rating: 1.47 },
      { who: "All perspectives", rating: 3.63 },
    ],
    lat: 54.472427030659865,
    lng: -0.8838341798213945,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4411",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat eats the horizon gracefully. A woman builds a book quickly. The teacher jumps over the horizon happily. A woman eats the road lazily.",
  },
  {
    locationId: "item22412",
    locationName: "item22412",
    locationAddress: "item22412",
    ratings: null,
    lat: 54.20570975422762,
    lng: -1.601980441888478,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4412",
    tags: [],
    locationDescription:
      " The teacher builds the horizon gracefully. The teacher runs towards a book happily. The man looks at the horizon silently. A dog builds a book angrily.",
  },
  {
    locationId: "item22413",
    locationName: "item22413",
    locationAddress: "item22413",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 3.08 },
    ],
    lat: 51.919852789743324,
    lng: 0.7748608335895053,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4413",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats a tower silently. A woman runs towards a fence silently. The teacher eats the road quickly. The teacher looks at the road angrily. The student builds the horizon quickly.",
  },
  {
    locationId: "item22414",
    locationName: "item22414",
    locationAddress: "item22414",
    ratings: null,
    lat: 53.32212507928499,
    lng: -1.4871529012659295,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4414",
    tags: [],
    locationDescription:
      " The man looks at the road angrily. The man eats the cake silently.",
  },
  {
    locationId: "item22415",
    locationName: "item22415",
    locationAddress: "item22415",
    ratings: null,
    lat: 54.85956896470953,
    lng: -7.635768123570385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4415",
    tags: [],
    locationDescription:
      " A woman builds a book happily. A dog looks at the horizon gracefully. The student eats a tower angrily. The student eats a book silently.",
  },
  {
    locationId: "item22416",
    locationName: "item22416",
    locationAddress: "item22416",
    ratings: [
      { who: "Similar identities", rating: 0.57 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 53.74292960687966,
    lng: -5.0887797326813455,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4416",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds the road silently. The student eats the horizon gracefully. A woman runs towards a tower silently. A woman jumps over a book angrily.",
  },
  {
    locationId: "item22417",
    locationName: "item22417",
    locationAddress: "item22417",
    ratings: [
      { who: "Similar identities", rating: 0.15 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 56.24562818769783,
    lng: -7.011549567276166,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4417",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman runs towards the cake angrily. A woman runs towards the horizon happily. A dog eats the horizon angrily. A dog builds a fence lazily.",
  },
  {
    locationId: "item22418",
    locationName: "item22418",
    locationAddress: "item22418",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 55.53918547520263,
    lng: -0.9019967489247369,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4418",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat jumps over a book quickly. The teacher eats a tower gracefully.",
  },
  {
    locationId: "item22419",
    locationName: "item22419",
    locationAddress: "item22419",
    ratings: null,
    lat: 55.34404169814809,
    lng: -5.30911774371782,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4419",
    tags: [],
    locationDescription: " A dog builds the road lazily.",
  },
  {
    locationId: "item22420",
    locationName: "item22420",
    locationAddress: "item22420",
    ratings: null,
    lat: 56.11056177968932,
    lng: -0.6617449174701768,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4420",
    tags: [],
    locationDescription:
      " The man writes the horizon silently. A dog eats a fence quickly. The student runs towards a book lazily. The cat writes the road quickly. A woman jumps over the cake silently.",
  },
  {
    locationId: "item22421",
    locationName: "item22421",
    locationAddress: "item22421",
    ratings: null,
    lat: 55.2062018103348,
    lng: -8.311718868864931,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4421",
    tags: [],
    locationDescription:
      " The student eats a tower silently. The cat eats a tower quickly. A woman runs towards a fence happily. The cat builds the horizon angrily. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item22422",
    locationName: "item22422",
    locationAddress: "item22422",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 60.5452365731253,
    lng: -8.485618229084805,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4422",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat jumps over a tower quickly. A woman runs towards the cake quickly.",
  },
  {
    locationId: "item22423",
    locationName: "item22423",
    locationAddress: "item22423",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 0.51 },
    ],
    lat: 55.93772783172601,
    lng: -7.276066545484258,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4423",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the horizon silently. The teacher jumps over the road gracefully.",
  },
  {
    locationId: "item22424",
    locationName: "item22424",
    locationAddress: "item22424",
    ratings: null,
    lat: 53.44253324753246,
    lng: -6.357153489779712,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4424",
    tags: [],
    locationDescription:
      " A dog jumps over a tower quickly. The cat writes a book gracefully. A woman runs towards a tower angrily. A dog builds a book lazily. The man jumps over the road silently.",
  },
  {
    locationId: "item22425",
    locationName: "item22425",
    locationAddress: "item22425",
    ratings: null,
    lat: 54.70097139911546,
    lng: -5.720889896371684,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4425",
    tags: [],
    locationDescription:
      " The student runs towards the horizon gracefully. The student builds the road gracefully. A woman builds a book silently.",
  },
  {
    locationId: "item22426",
    locationName: "item22426",
    locationAddress: "item22426",
    ratings: null,
    lat: 57.904642224831484,
    lng: -1.7761093884469847,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4426",
    tags: [],
    locationDescription:
      " The student looks at a fence silently. The cat looks at a tower quickly. The student builds the road angrily.",
  },
  {
    locationId: "item22427",
    locationName: "item22427",
    locationAddress: "item22427",
    ratings: null,
    lat: 53.13725628885803,
    lng: -2.9277457447406006,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4427",
    tags: [],
    locationDescription:
      " The teacher jumps over a tower quickly. The man jumps over the cake gracefully.",
  },
  {
    locationId: "item22428",
    locationName: "item22428",
    locationAddress: "item22428",
    ratings: [
      { who: "Similar identities", rating: 2.08 },
      { who: "All perspectives", rating: 4.44 },
    ],
    lat: 55.15526950198079,
    lng: -6.997086558625888,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4428",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The teacher looks at a book angrily.",
  },
  {
    locationId: "item22429",
    locationName: "item22429",
    locationAddress: "item22429",
    ratings: [
      { who: "Similar identities", rating: 2.95 },
      { who: "All perspectives", rating: 0.26 },
    ],
    lat: 55.6078866034342,
    lng: -8.355348347600826,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4429",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A dog eats a book lazily.",
  },
  {
    locationId: "item22430",
    locationName: "item22430",
    locationAddress: "item22430",
    ratings: [
      { who: "Similar identities", rating: 2.7 },
      { who: "All perspectives", rating: 4.14 },
    ],
    lat: 50.702919403856114,
    lng: -1.4682278543827092,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4430",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman jumps over the cake gracefully. The cat jumps over the horizon silently.",
  },
  {
    locationId: "item22431",
    locationName: "item22431",
    locationAddress: "item22431",
    ratings: null,
    lat: 52.35223209859743,
    lng: 0.37150719711928026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4431",
    tags: [],
    locationDescription: " The student jumps over the cake lazily.",
  },
  {
    locationId: "item22432",
    locationName: "item22432",
    locationAddress: "item22432",
    ratings: null,
    lat: 51.32475667610746,
    lng: 0.7268215276372612,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4432",
    tags: [],
    locationDescription:
      " The man eats a tower angrily. A dog looks at a fence quickly.",
  },
  {
    locationId: "item22433",
    locationName: "item22433",
    locationAddress: "item22433",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 51.72607974292451,
    lng: -3.966856177353397,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4433",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " The teacher eats the road happily.",
  },
  {
    locationId: "item22434",
    locationName: "item22434",
    locationAddress: "item22434",
    ratings: null,
    lat: 52.55579752392968,
    lng: -7.496470841672733,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4434",
    tags: [],
    locationDescription:
      " A woman builds a tower gracefully. The cat jumps over a fence silently. The student eats a book angrily. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item22435",
    locationName: "item22435",
    locationAddress: "item22435",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 1.58 },
    ],
    lat: 52.838124206957,
    lng: 0.4829848059448931,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4435",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " A woman jumps over a fence gracefully.",
  },
  {
    locationId: "item22436",
    locationName: "item22436",
    locationAddress: "item22436",
    ratings: null,
    lat: 52.87642480395197,
    lng: 1.7633975990409851,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4436",
    tags: [],
    locationDescription:
      " A woman eats a tower lazily. The cat jumps over the horizon silently.",
  },
  {
    locationId: "item22437",
    locationName: "item22437",
    locationAddress: "item22437",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 58.392480448490694,
    lng: -1.3544129754605274,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4437",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at the road angrily. The student builds the road happily. A woman builds the cake happily.",
  },
  {
    locationId: "item22438",
    locationName: "item22438",
    locationAddress: "item22438",
    ratings: [
      { who: "Similar identities", rating: 1.31 },
      { who: "All perspectives", rating: 0.9 },
    ],
    lat: 50.947682660985386,
    lng: -5.908259500124276,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4438",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog builds the road gracefully. The cat runs towards the road happily. A woman writes a fence happily.",
  },
  {
    locationId: "item22439",
    locationName: "item22439",
    locationAddress: "item22439",
    ratings: null,
    lat: 55.30316351389236,
    lng: -1.5132162486077982,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4439",
    tags: [],
    locationDescription:
      " The man runs towards a tower angrily. A woman looks at the road gracefully. A woman looks at the road angrily. The cat jumps over the horizon silently.",
  },
  {
    locationId: "item22440",
    locationName: "item22440",
    locationAddress: "item22440",
    ratings: null,
    lat: 54.05674635504284,
    lng: -7.857286653598571,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4440",
    tags: [],
    locationDescription: " The man eats the cake quickly.",
  },
  {
    locationId: "item22441",
    locationName: "item22441",
    locationAddress: "item22441",
    ratings: null,
    lat: 57.89572803857426,
    lng: -6.081927144757617,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4441",
    tags: [],
    locationDescription:
      " The cat runs towards the cake silently. A woman looks at a fence angrily. The teacher looks at a book gracefully. The cat runs towards the horizon angrily. The teacher eats a book quickly.",
  },
  {
    locationId: "item22442",
    locationName: "item22442",
    locationAddress: "item22442",
    ratings: null,
    lat: 52.07429945865385,
    lng: -7.245155315470042,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4442",
    tags: [],
    locationDescription: " A woman eats the cake angrily.",
  },
  {
    locationId: "item22443",
    locationName: "item22443",
    locationAddress: "item22443",
    ratings: [
      { who: "Similar identities", rating: 1.13 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 51.83218053539571,
    lng: -7.347907216618661,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4443",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student jumps over a tower lazily. The student runs towards a tower happily. The teacher jumps over a fence quickly. The cat builds the road quickly. A woman eats a book lazily.",
  },
  {
    locationId: "item22444",
    locationName: "item22444",
    locationAddress: "item22444",
    ratings: null,
    lat: 51.31364579019119,
    lng: 0.23985287340598838,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4444",
    tags: [],
    locationDescription:
      " The man looks at a tower angrily. A dog builds a fence happily. A woman jumps over the road quickly. A woman looks at the cake lazily. The cat looks at the horizon quickly.",
  },
  {
    locationId: "item22445",
    locationName: "item22445",
    locationAddress: "item22445",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 1.92 },
    ],
    lat: 55.79195739392295,
    lng: 1.7104524853982586,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4445",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The student jumps over the road silently.",
  },
  {
    locationId: "item22446",
    locationName: "item22446",
    locationAddress: "item22446",
    ratings: null,
    lat: 53.1423028219195,
    lng: -0.22416492008669486,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4446",
    tags: [],
    locationDescription: " The cat eats a fence lazily.",
  },
  {
    locationId: "item22447",
    locationName: "item22447",
    locationAddress: "item22447",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 4.34 },
    ],
    lat: 57.027117965860995,
    lng: -7.288346692396132,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4447",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher runs towards the cake gracefully. The man eats the road happily. The teacher eats the horizon happily. A woman eats a book gracefully.",
  },
  {
    locationId: "item22448",
    locationName: "item22448",
    locationAddress: "item22448",
    ratings: null,
    lat: 58.81768264929028,
    lng: -2.8938296964622134,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4448",
    tags: [],
    locationDescription:
      " The man runs towards a tower quickly. A woman writes the cake lazily. A woman builds the horizon lazily.",
  },
  {
    locationId: "item22449",
    locationName: "item22449",
    locationAddress: "item22449",
    ratings: null,
    lat: 59.13959043524363,
    lng: -6.588279422211414,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4449",
    tags: [],
    locationDescription:
      " The student writes a tower silently. The student writes the road silently.",
  },
  {
    locationId: "item22450",
    locationName: "item22450",
    locationAddress: "item22450",
    ratings: null,
    lat: 59.161900428809986,
    lng: -2.6095141806057036,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4450",
    tags: [],
    locationDescription:
      " The cat looks at the horizon angrily. The man jumps over a fence gracefully. The man runs towards the cake happily.",
  },
  {
    locationId: "item22451",
    locationName: "item22451",
    locationAddress: "item22451",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 0.33 },
    ],
    lat: 50.70570879007311,
    lng: -2.195109355524437,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4451",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards a tower lazily. A dog runs towards the road silently. A woman builds the cake quickly. The cat jumps over a fence silently.",
  },
  {
    locationId: "item22452",
    locationName: "item22452",
    locationAddress: "item22452",
    ratings: [
      { who: "Similar identities", rating: 3.92 },
      { who: "All perspectives", rating: 4.51 },
    ],
    lat: 54.46936290120673,
    lng: -6.1725123600438705,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4452",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat eats a tower quickly. A woman jumps over the cake angrily. A dog looks at a fence lazily. The teacher eats a tower angrily.",
  },
  {
    locationId: "item22453",
    locationName: "item22453",
    locationAddress: "item22453",
    ratings: [
      { who: "Similar identities", rating: 2.06 },
      { who: "All perspectives", rating: 3.8 },
    ],
    lat: 57.535841834676816,
    lng: -1.7145603783988683,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4453",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats a book silently. The student builds a tower lazily. The cat jumps over the cake angrily. A dog looks at the cake gracefully.",
  },
  {
    locationId: "item22454",
    locationName: "item22454",
    locationAddress: "item22454",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 0.7 },
    ],
    lat: 57.714079387868196,
    lng: -2.5497319459165233,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4454",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds the cake silently. The cat eats the road quickly. A dog eats a tower silently.",
  },
  {
    locationId: "item22455",
    locationName: "item22455",
    locationAddress: "item22455",
    ratings: [
      { who: "Similar identities", rating: 0.32 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 56.26809640656425,
    lng: -2.1844183877455388,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4455",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The teacher jumps over a fence gracefully.",
  },
  {
    locationId: "item22456",
    locationName: "item22456",
    locationAddress: "item22456",
    ratings: null,
    lat: 59.55289447187832,
    lng: -8.483873729587222,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4456",
    tags: [],
    locationDescription:
      " The student looks at a book quickly. The man runs towards the cake angrily. The teacher eats the road quickly. A woman builds the horizon gracefully. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item22457",
    locationName: "item22457",
    locationAddress: "item22457",
    ratings: null,
    lat: 60.29407479459255,
    lng: -4.508922479370323,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4457",
    tags: [],
    locationDescription:
      " The cat jumps over a book quickly. A dog writes a book quickly. A dog eats the horizon gracefully.",
  },
  {
    locationId: "item22458",
    locationName: "item22458",
    locationAddress: "item22458",
    ratings: null,
    lat: 52.83177948318334,
    lng: -3.9048278677467154,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4458",
    tags: [],
    locationDescription:
      " The cat looks at the road silently. A dog builds the road gracefully. The student jumps over a fence happily. The man looks at the cake happily. The cat eats the road lazily.",
  },
  {
    locationId: "item22459",
    locationName: "item22459",
    locationAddress: "item22459",
    ratings: null,
    lat: 60.24673720767516,
    lng: -3.5992736841649684,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4459",
    tags: [],
    locationDescription:
      " A woman runs towards the cake lazily. The teacher eats the road lazily. A woman eats the cake gracefully. A woman eats a fence happily.",
  },
  {
    locationId: "item22460",
    locationName: "item22460",
    locationAddress: "item22460",
    ratings: null,
    lat: 56.96107723425479,
    lng: -3.456690636528373,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4460",
    tags: [],
    locationDescription:
      " The man runs towards a fence silently. A woman builds a book gracefully.",
  },
  {
    locationId: "item22461",
    locationName: "item22461",
    locationAddress: "item22461",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 4.43 },
    ],
    lat: 51.120016292776945,
    lng: 1.5242034418020207,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4461",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog builds the horizon gracefully.",
  },
  {
    locationId: "item22462",
    locationName: "item22462",
    locationAddress: "item22462",
    ratings: [
      { who: "Similar identities", rating: 4.1 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 52.157605818860254,
    lng: -8.443597708559896,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4462",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog writes a fence lazily. The cat looks at a fence gracefully. The man builds a fence gracefully. The teacher looks at the cake lazily.",
  },
  {
    locationId: "item22463",
    locationName: "item22463",
    locationAddress: "item22463",
    ratings: null,
    lat: 58.99813419771512,
    lng: -2.1440264211011693,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4463",
    tags: [],
    locationDescription: " The cat jumps over a tower silently.",
  },
  {
    locationId: "item22464",
    locationName: "item22464",
    locationAddress: "item22464",
    ratings: [
      { who: "Similar identities", rating: 0.83 },
      { who: "All perspectives", rating: 1.55 },
    ],
    lat: 59.243847610207126,
    lng: -7.920745172121575,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4464",
    tags: [{ label: "accessible" }],
    locationDescription: " A woman jumps over the cake quickly.",
  },
  {
    locationId: "item22465",
    locationName: "item22465",
    locationAddress: "item22465",
    ratings: null,
    lat: 53.337906036806054,
    lng: -7.865370809891811,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4465",
    tags: [],
    locationDescription: " A dog eats a fence happily.",
  },
  {
    locationId: "item22466",
    locationName: "item22466",
    locationAddress: "item22466",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 3.41 },
    ],
    lat: 59.72640850567396,
    lng: -1.2083188961417637,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4466",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes a book quickly. The teacher builds the road gracefully. A dog runs towards a tower quickly.",
  },
  {
    locationId: "item22467",
    locationName: "item22467",
    locationAddress: "item22467",
    ratings: [
      { who: "Similar identities", rating: 0.11 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 56.43531668862791,
    lng: -0.10176046084944979,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4467",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat jumps over the cake gracefully. The cat writes a book gracefully.",
  },
  {
    locationId: "item22468",
    locationName: "item22468",
    locationAddress: "item22468",
    ratings: [
      { who: "Similar identities", rating: 0.57 },
      { who: "All perspectives", rating: 0.63 },
    ],
    lat: 50.48037116330726,
    lng: 0.6429002384319737,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4468",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat builds the horizon angrily. A dog jumps over a book quickly. A woman jumps over the horizon gracefully. The student jumps over the road angrily.",
  },
  {
    locationId: "item22469",
    locationName: "item22469",
    locationAddress: "item22469",
    ratings: null,
    lat: 50.70362903345667,
    lng: -8.228221839659083,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4469",
    tags: [],
    locationDescription: " The teacher looks at the road silently.",
  },
  {
    locationId: "item22470",
    locationName: "item22470",
    locationAddress: "item22470",
    ratings: null,
    lat: 57.456808178626865,
    lng: -4.444765462729462,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4470",
    tags: [],
    locationDescription:
      " The cat writes a book lazily. The cat runs towards the horizon silently. A dog looks at a fence happily. The teacher jumps over the cake gracefully. The student eats the horizon quickly.",
  },
  {
    locationId: "item22471",
    locationName: "item22471",
    locationAddress: "item22471",
    ratings: null,
    lat: 53.58532605700572,
    lng: -3.631645396949348,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4471",
    tags: [],
    locationDescription:
      " A woman eats a tower happily. A dog looks at a fence silently. The cat builds the road gracefully.",
  },
  {
    locationId: "item22472",
    locationName: "item22472",
    locationAddress: "item22472",
    ratings: null,
    lat: 52.327294391551675,
    lng: -5.1098234047126345,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4472",
    tags: [],
    locationDescription:
      " A woman builds a tower lazily. The student builds a fence silently. A dog jumps over the cake gracefully. A dog looks at a book happily. The man looks at the cake happily.",
  },
  {
    locationId: "item22473",
    locationName: "item22473",
    locationAddress: "item22473",
    ratings: [
      { who: "Similar identities", rating: 0.16 },
      { who: "All perspectives", rating: 3.17 },
    ],
    lat: 58.037495725129766,
    lng: -0.6281589171334314,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4473",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A dog builds a book happily.",
  },
  {
    locationId: "item22474",
    locationName: "item22474",
    locationAddress: "item22474",
    ratings: [
      { who: "Similar identities", rating: 4.1 },
      { who: "All perspectives", rating: 0.01 },
    ],
    lat: 59.96685054536098,
    lng: -5.9145477016914025,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4474",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats a tower gracefully. The man writes a book quickly. The man looks at a fence quickly.",
  },
  {
    locationId: "item22475",
    locationName: "item22475",
    locationAddress: "item22475",
    ratings: [
      { who: "Similar identities", rating: 4.86 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 60.02943800119107,
    lng: 1.73743693484273,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4475",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman runs towards the horizon lazily. A woman builds a book quickly.",
  },
  {
    locationId: "item22476",
    locationName: "item22476",
    locationAddress: "item22476",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 3.71 },
    ],
    lat: 56.24734389743655,
    lng: -2.6126724594949424,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4476",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The teacher runs towards a fence angrily.",
  },
  {
    locationId: "item22477",
    locationName: "item22477",
    locationAddress: "item22477",
    ratings: null,
    lat: 50.077794622782385,
    lng: -6.3368328597176,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4477",
    tags: [],
    locationDescription:
      " The cat eats a fence happily. A woman eats a fence angrily. The man writes a book quickly. The man looks at the horizon happily. The cat builds the road angrily.",
  },
  {
    locationId: "item22478",
    locationName: "item22478",
    locationAddress: "item22478",
    ratings: null,
    lat: 56.87815898423467,
    lng: -8.456471718074058,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4478",
    tags: [],
    locationDescription: " The student runs towards the horizon happily.",
  },
  {
    locationId: "item22479",
    locationName: "item22479",
    locationAddress: "item22479",
    ratings: [
      { who: "Similar identities", rating: 1.79 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 51.10438064276058,
    lng: -2.0747001417789495,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4479",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man jumps over a tower gracefully. The man eats the horizon gracefully. The teacher looks at the cake gracefully. The man jumps over the horizon quickly. The teacher looks at the cake lazily.",
  },
  {
    locationId: "item22480",
    locationName: "item22480",
    locationAddress: "item22480",
    ratings: null,
    lat: 56.79954929177298,
    lng: -7.068272673733619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4480",
    tags: [],
    locationDescription:
      " A dog builds the cake gracefully. A dog writes the road silently.",
  },
  {
    locationId: "item22481",
    locationName: "item22481",
    locationAddress: "item22481",
    ratings: [
      { who: "Similar identities", rating: 2.85 },
      { who: "All perspectives", rating: 3.6 },
    ],
    lat: 50.905949195925736,
    lng: -5.62231703504521,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4481",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman builds a tower lazily. The man looks at a fence happily. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item22482",
    locationName: "item22482",
    locationAddress: "item22482",
    ratings: [
      { who: "Similar identities", rating: 0.21 },
      { who: "All perspectives", rating: 0.84 },
    ],
    lat: 52.865822747922145,
    lng: -0.5872511954196238,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4482",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student looks at the horizon lazily. The student writes the horizon quickly. A dog runs towards a tower silently. The cat builds a book gracefully.",
  },
  {
    locationId: "item22483",
    locationName: "item22483",
    locationAddress: "item22483",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 1.4 },
    ],
    lat: 59.26658969702041,
    lng: 0.09932190602130397,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4483",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog writes a book gracefully. The cat runs towards a tower silently. The teacher jumps over a book angrily. A woman writes the horizon happily. A dog writes the cake happily.",
  },
  {
    locationId: "item22484",
    locationName: "item22484",
    locationAddress: "item22484",
    ratings: null,
    lat: 57.66727704787856,
    lng: -5.082616518758233,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4484",
    tags: [],
    locationDescription: " The teacher looks at a fence silently.",
  },
  {
    locationId: "item22485",
    locationName: "item22485",
    locationAddress: "item22485",
    ratings: [
      { who: "Similar identities", rating: 4.08 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 58.63409780208417,
    lng: -1.8253226438753964,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4485",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog jumps over a book silently. A dog builds the road quickly. A dog jumps over a fence angrily. The cat runs towards the horizon angrily.",
  },
  {
    locationId: "item22486",
    locationName: "item22486",
    locationAddress: "item22486",
    ratings: [
      { who: "Similar identities", rating: 0.77 },
      { who: "All perspectives", rating: 0.72 },
    ],
    lat: 51.26525862336196,
    lng: 0.5659904428510654,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4486",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards the road angrily. The student writes the road gracefully. The man eats the road lazily.",
  },
  {
    locationId: "item22487",
    locationName: "item22487",
    locationAddress: "item22487",
    ratings: null,
    lat: 54.11867180462788,
    lng: -0.42901228035408856,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4487",
    tags: [],
    locationDescription:
      " A dog runs towards a book lazily. The teacher looks at a fence lazily. The teacher writes the horizon lazily. The cat runs towards a fence angrily. The teacher looks at a book silently.",
  },
  {
    locationId: "item22488",
    locationName: "item22488",
    locationAddress: "item22488",
    ratings: [
      { who: "Similar identities", rating: 2.98 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 58.5363149956667,
    lng: -3.1415270177360313,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4488",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A dog eats the road happily. A dog writes the horizon silently. The teacher eats a book silently.",
  },
  {
    locationId: "item22489",
    locationName: "item22489",
    locationAddress: "item22489",
    ratings: null,
    lat: 51.78203360486264,
    lng: -1.8001108343630934,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4489",
    tags: [],
    locationDescription: " A woman jumps over the cake quickly.",
  },
  {
    locationId: "item22490",
    locationName: "item22490",
    locationAddress: "item22490",
    ratings: null,
    lat: 52.62290630128134,
    lng: -2.058403011626952,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4490",
    tags: [],
    locationDescription:
      " The man looks at the cake silently. A dog writes the cake silently. The teacher looks at a fence silently.",
  },
  {
    locationId: "item22491",
    locationName: "item22491",
    locationAddress: "item22491",
    ratings: [
      { who: "Similar identities", rating: 0.22 },
      { who: "All perspectives", rating: 4.57 },
    ],
    lat: 55.93096207506619,
    lng: 0.6311105188395381,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4491",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man eats a tower gracefully.",
  },
  {
    locationId: "item22492",
    locationName: "item22492",
    locationAddress: "item22492",
    ratings: [
      { who: "Similar identities", rating: 4.67 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 55.76654559596395,
    lng: -2.146132781530472,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4492",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog jumps over a book quickly. The teacher runs towards a fence happily. The teacher eats a tower lazily. The student eats the horizon angrily. The cat runs towards a tower gracefully.",
  },
  {
    locationId: "item22493",
    locationName: "item22493",
    locationAddress: "item22493",
    ratings: [
      { who: "Similar identities", rating: 1.05 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 56.04828451421275,
    lng: -0.6067294392094729,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4493",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat looks at the horizon lazily. A woman builds a tower lazily. A dog builds a tower quickly.",
  },
  {
    locationId: "item22494",
    locationName: "item22494",
    locationAddress: "item22494",
    ratings: null,
    lat: 60.02524581193484,
    lng: -6.794345424219968,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4494",
    tags: [],
    locationDescription:
      " The cat writes the cake happily. The student jumps over a fence angrily. A woman runs towards the horizon gracefully. A woman jumps over the horizon silently. The student jumps over a book silently.",
  },
  {
    locationId: "item22495",
    locationName: "item22495",
    locationAddress: "item22495",
    ratings: null,
    lat: 54.04954175945969,
    lng: 0.3385674834159911,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4495",
    tags: [],
    locationDescription:
      " The cat builds a book quickly. The teacher jumps over a book lazily.",
  },
  {
    locationId: "item22496",
    locationName: "item22496",
    locationAddress: "item22496",
    ratings: [
      { who: "Similar identities", rating: 4.27 },
      { who: "All perspectives", rating: 3.06 },
    ],
    lat: 58.80018353360754,
    lng: -0.8905942629613426,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4496",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The cat eats the horizon gracefully.",
  },
  {
    locationId: "item22497",
    locationName: "item22497",
    locationAddress: "item22497",
    ratings: null,
    lat: 54.051677448186474,
    lng: -6.691700718069971,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4497",
    tags: [],
    locationDescription:
      " The man writes a book gracefully. A dog builds the cake gracefully. A dog writes the horizon happily. The cat writes a tower lazily.",
  },
  {
    locationId: "item22498",
    locationName: "item22498",
    locationAddress: "item22498",
    ratings: null,
    lat: 60.226290109060216,
    lng: -8.014008653556067,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4498",
    tags: [],
    locationDescription: " The teacher looks at a tower silently.",
  },
  {
    locationId: "item22499",
    locationName: "item22499",
    locationAddress: "item22499",
    ratings: [
      { who: "Similar identities", rating: 2.91 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 58.75195720110376,
    lng: -5.866277272309743,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4499",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription: " The man jumps over the horizon happily.",
  },
  {
    locationId: "item22500",
    locationName: "item22500",
    locationAddress: "item22500",
    ratings: null,
    lat: 60.24152302080498,
    lng: -7.806419677342104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4500",
    tags: [],
    locationDescription:
      " A woman writes a fence angrily. A woman builds a book lazily. The teacher runs towards a book happily. The student runs towards a book silently. The cat looks at a fence silently.",
  },
  {
    locationId: "item22501",
    locationName: "item22501",
    locationAddress: "item22501",
    ratings: null,
    lat: 50.744867787323294,
    lng: 0.9121862896471882,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4501",
    tags: [],
    locationDescription:
      " The teacher eats a tower lazily. The student writes the cake quickly. A dog eats a tower lazily. A dog jumps over a book gracefully. A dog runs towards a book gracefully.",
  },
  {
    locationId: "item22502",
    locationName: "item22502",
    locationAddress: "item22502",
    ratings: null,
    lat: 55.89417910448237,
    lng: -5.986242558601109,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4502",
    tags: [],
    locationDescription: " The teacher builds a fence happily.",
  },
  {
    locationId: "item22503",
    locationName: "item22503",
    locationAddress: "item22503",
    ratings: null,
    lat: 52.6049213190177,
    lng: -0.6483187772478765,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4503",
    tags: [],
    locationDescription:
      " The cat eats the horizon lazily. The teacher jumps over a tower lazily. The cat runs towards a book lazily.",
  },
  {
    locationId: "item22504",
    locationName: "item22504",
    locationAddress: "item22504",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 60.100358150002506,
    lng: 0.9645425612052883,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4504",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student builds a tower angrily. A dog writes a tower angrily. The man writes a tower angrily.",
  },
  {
    locationId: "item22505",
    locationName: "item22505",
    locationAddress: "item22505",
    ratings: null,
    lat: 53.31214165514314,
    lng: -2.5830514776039735,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4505",
    tags: [],
    locationDescription:
      " The man looks at the horizon lazily. The student eats the horizon gracefully. The man eats the horizon angrily.",
  },
  {
    locationId: "item22506",
    locationName: "item22506",
    locationAddress: "item22506",
    ratings: null,
    lat: 57.219948376551415,
    lng: -2.8869138854190286,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4506",
    tags: [],
    locationDescription:
      " The student writes a fence silently. The student jumps over the horizon silently.",
  },
  {
    locationId: "item22507",
    locationName: "item22507",
    locationAddress: "item22507",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 2.71 },
    ],
    lat: 55.91209971413635,
    lng: -1.0403669404820102,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4507",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The teacher looks at the horizon gracefully.",
  },
  {
    locationId: "item22508",
    locationName: "item22508",
    locationAddress: "item22508",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 2.62 },
    ],
    lat: 55.23887900422976,
    lng: -6.773575227670685,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4508",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at the road silently. The man jumps over the cake quickly. The teacher jumps over the cake happily. The man jumps over a book angrily. The teacher looks at the horizon angrily.",
  },
  {
    locationId: "item22509",
    locationName: "item22509",
    locationAddress: "item22509",
    ratings: null,
    lat: 52.269865947080255,
    lng: -5.714846091023961,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4509",
    tags: [],
    locationDescription:
      " The cat looks at a fence gracefully. The teacher eats the cake happily. A woman writes the cake gracefully. The cat looks at a book quickly.",
  },
  {
    locationId: "item22510",
    locationName: "item22510",
    locationAddress: "item22510",
    ratings: [
      { who: "Similar identities", rating: 0.88 },
      { who: "All perspectives", rating: 3.28 },
    ],
    lat: 59.45346044487229,
    lng: -0.15260849342869065,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4510",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog writes the road gracefully. The man eats a book gracefully. A woman writes a book quickly.",
  },
  {
    locationId: "item22511",
    locationName: "item22511",
    locationAddress: "item22511",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 4.53 },
    ],
    lat: 57.51554892728994,
    lng: 1.1803987195808698,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4511",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat looks at a fence quickly. The cat builds a tower happily.",
  },
  {
    locationId: "item22512",
    locationName: "item22512",
    locationAddress: "item22512",
    ratings: null,
    lat: 50.52301834877412,
    lng: -5.472451603311322,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4512",
    tags: [],
    locationDescription: " The man jumps over a book angrily.",
  },
  {
    locationId: "item22513",
    locationName: "item22513",
    locationAddress: "item22513",
    ratings: [
      { who: "Similar identities", rating: 1.79 },
      { who: "All perspectives", rating: 3.11 },
    ],
    lat: 57.229769382383104,
    lng: -5.519556616069357,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4513",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman jumps over a book lazily. The cat eats a book lazily. The teacher eats a tower lazily.",
  },
  {
    locationId: "item22514",
    locationName: "item22514",
    locationAddress: "item22514",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 1.21 },
    ],
    lat: 57.28990364951361,
    lng: -0.7391181794614514,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4514",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a tower lazily. A dog looks at the horizon quickly. The teacher eats the road angrily. The cat eats the cake angrily. A woman looks at the cake silently.",
  },
  {
    locationId: "item22515",
    locationName: "item22515",
    locationAddress: "item22515",
    ratings: [
      { who: "Similar identities", rating: 2.19 },
      { who: "All perspectives", rating: 1.53 },
    ],
    lat: 50.32586215337884,
    lng: 0.6545049678286983,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4515",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " The cat jumps over a book silently.",
  },
  {
    locationId: "item22516",
    locationName: "item22516",
    locationAddress: "item22516",
    ratings: [
      { who: "Similar identities", rating: 4.37 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 50.83921412200763,
    lng: 1.333268440580401,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4516",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a fence lazily. A woman jumps over a book angrily.",
  },
  {
    locationId: "item22517",
    locationName: "item22517",
    locationAddress: "item22517",
    ratings: null,
    lat: 56.36216381162228,
    lng: -0.8929297634758928,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4517",
    tags: [],
    locationDescription: " A woman looks at a fence lazily.",
  },
  {
    locationId: "item22518",
    locationName: "item22518",
    locationAddress: "item22518",
    ratings: [
      { who: "Similar identities", rating: 2.6 },
      { who: "All perspectives", rating: 3.66 },
    ],
    lat: 52.19621053902801,
    lng: 1.6725731332116673,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4518",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man writes the cake happily. A dog writes the horizon quickly. The cat builds a tower gracefully.",
  },
  {
    locationId: "item22519",
    locationName: "item22519",
    locationAddress: "item22519",
    ratings: null,
    lat: 51.500712702688205,
    lng: -5.199698030926549,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4519",
    tags: [],
    locationDescription:
      " The teacher builds a book quickly. The cat builds a fence lazily. The student eats a book happily. A woman eats the cake happily. A dog jumps over a fence angrily.",
  },
  {
    locationId: "item22520",
    locationName: "item22520",
    locationAddress: "item22520",
    ratings: [
      { who: "Similar identities", rating: 3.46 },
      { who: "All perspectives", rating: 0.24 },
    ],
    lat: 51.19276069497535,
    lng: -4.753995757066917,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4520",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman eats the road silently. The student builds the cake angrily.",
  },
  {
    locationId: "item22521",
    locationName: "item22521",
    locationAddress: "item22521",
    ratings: null,
    lat: 52.03175437533551,
    lng: -4.019220053135101,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4521",
    tags: [],
    locationDescription:
      " The man looks at the cake quickly. A dog looks at the road quickly. The student builds a book lazily.",
  },
  {
    locationId: "item22522",
    locationName: "item22522",
    locationAddress: "item22522",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 58.90700161853156,
    lng: -7.760660813181103,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4522",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat jumps over a tower angrily.",
  },
  {
    locationId: "item22523",
    locationName: "item22523",
    locationAddress: "item22523",
    ratings: null,
    lat: 60.583643193491895,
    lng: -3.58236478316062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4523",
    tags: [],
    locationDescription:
      " The cat looks at a book lazily. A dog builds a book quickly. The man looks at the horizon happily. The cat builds the road quickly. The student runs towards a book gracefully.",
  },
  {
    locationId: "item22524",
    locationName: "item22524",
    locationAddress: "item22524",
    ratings: null,
    lat: 54.778828513268664,
    lng: -8.325114318067701,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4524",
    tags: [],
    locationDescription: " The student writes a book silently.",
  },
  {
    locationId: "item22525",
    locationName: "item22525",
    locationAddress: "item22525",
    ratings: [
      { who: "Similar identities", rating: 1.37 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 58.010739329812466,
    lng: -3.1171719634825257,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4525",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog builds the road silently. A dog jumps over the cake silently. The man jumps over a book quickly. The student writes the horizon lazily. The man runs towards the road silently.",
  },
  {
    locationId: "item22526",
    locationName: "item22526",
    locationAddress: "item22526",
    ratings: [
      { who: "Similar identities", rating: 2.99 },
      { who: "All perspectives", rating: 0.4 },
    ],
    lat: 60.50358062667398,
    lng: -1.2154867259583293,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4526",
    tags: [{ label: "accessible" }],
    locationDescription: " The teacher builds the cake gracefully.",
  },
  {
    locationId: "item22527",
    locationName: "item22527",
    locationAddress: "item22527",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 3.71 },
    ],
    lat: 52.44919717583305,
    lng: -3.912360155117918,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4527",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman builds the road quickly. The cat runs towards a book silently.",
  },
  {
    locationId: "item22528",
    locationName: "item22528",
    locationAddress: "item22528",
    ratings: null,
    lat: 54.32435215797895,
    lng: -7.843651364960177,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4528",
    tags: [],
    locationDescription:
      " The cat looks at the road lazily. The teacher writes the cake silently. The man jumps over the horizon silently. A woman eats a fence lazily.",
  },
  {
    locationId: "item22529",
    locationName: "item22529",
    locationAddress: "item22529",
    ratings: null,
    lat: 57.821074507456565,
    lng: 1.2470324059911402,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4529",
    tags: [],
    locationDescription:
      " A woman looks at the horizon angrily. The teacher builds a fence gracefully. The teacher eats a book lazily. A dog runs towards the horizon happily. The cat builds a fence gracefully.",
  },
  {
    locationId: "item22530",
    locationName: "item22530",
    locationAddress: "item22530",
    ratings: [
      { who: "Similar identities", rating: 0.7 },
      { who: "All perspectives", rating: 1.02 },
    ],
    lat: 55.056070016542755,
    lng: 1.3139992845695172,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4530",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at the horizon silently. A woman jumps over the cake gracefully. The student builds a fence lazily. The teacher writes the horizon silently.",
  },
  {
    locationId: "item22531",
    locationName: "item22531",
    locationAddress: "item22531",
    ratings: null,
    lat: 58.28537041284278,
    lng: -0.4722261021827734,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4531",
    tags: [],
    locationDescription:
      " A dog runs towards a tower silently. The cat runs towards a fence lazily. A dog eats a fence happily. The teacher writes a fence happily.",
  },
  {
    locationId: "item22532",
    locationName: "item22532",
    locationAddress: "item22532",
    ratings: [
      { who: "Similar identities", rating: 3.3 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 51.64157675618972,
    lng: -5.169013109382599,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4532",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats a tower gracefully. The teacher builds a fence quickly. The cat jumps over a tower happily.",
  },
  {
    locationId: "item22533",
    locationName: "item22533",
    locationAddress: "item22533",
    ratings: null,
    lat: 53.116996611004566,
    lng: 0.06917627230520118,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4533",
    tags: [],
    locationDescription: " The teacher looks at the horizon happily.",
  },
  {
    locationId: "item22534",
    locationName: "item22534",
    locationAddress: "item22534",
    ratings: [
      { who: "Similar identities", rating: 0.88 },
      { who: "All perspectives", rating: 0.54 },
    ],
    lat: 59.41133040452395,
    lng: -3.8502385105787758,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4534",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription: " The man writes the cake lazily.",
  },
  {
    locationId: "item22535",
    locationName: "item22535",
    locationAddress: "item22535",
    ratings: [
      { who: "Similar identities", rating: 2.28 },
      { who: "All perspectives", rating: 3.59 },
    ],
    lat: 58.526757693953265,
    lng: -4.144697083770126,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4535",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over the road gracefully. The cat runs towards the road happily.",
  },
  {
    locationId: "item22536",
    locationName: "item22536",
    locationAddress: "item22536",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 57.12215604018572,
    lng: -8.086406985576021,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4536",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man jumps over a fence silently. A woman looks at a tower angrily. The cat eats a tower silently. A woman writes the horizon silently. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item22537",
    locationName: "item22537",
    locationAddress: "item22537",
    ratings: null,
    lat: 57.41628599439694,
    lng: 1.5467960075291032,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4537",
    tags: [],
    locationDescription:
      " A woman runs towards the road gracefully. The teacher builds a fence quickly. The student writes the road gracefully.",
  },
  {
    locationId: "item22538",
    locationName: "item22538",
    locationAddress: "item22538",
    ratings: null,
    lat: 51.61743983545667,
    lng: -5.656913121370009,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4538",
    tags: [],
    locationDescription:
      " The student eats a fence happily. The teacher writes a fence angrily.",
  },
  {
    locationId: "item22539",
    locationName: "item22539",
    locationAddress: "item22539",
    ratings: [
      { who: "Similar identities", rating: 0.67 },
      { who: "All perspectives", rating: 4.68 },
    ],
    lat: 54.72371930154621,
    lng: 0.615569402711369,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4539",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The student looks at a tower silently. A woman runs towards a book angrily. The cat eats a tower angrily. The teacher jumps over a fence happily. The teacher builds the road silently.",
  },
  {
    locationId: "item22540",
    locationName: "item22540",
    locationAddress: "item22540",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 59.58342705607179,
    lng: -5.859424041823968,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4540",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man runs towards the road angrily. The teacher eats the cake angrily. A dog writes a fence silently.",
  },
  {
    locationId: "item22541",
    locationName: "item22541",
    locationAddress: "item22541",
    ratings: null,
    lat: 55.93143413815096,
    lng: -5.178804925679197,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4541",
    tags: [],
    locationDescription:
      " A woman writes a tower lazily. The man looks at the road gracefully. A woman writes a book angrily. The teacher writes the road gracefully.",
  },
  {
    locationId: "item22542",
    locationName: "item22542",
    locationAddress: "item22542",
    ratings: null,
    lat: 58.74051071287916,
    lng: -3.0442934685020386,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4542",
    tags: [],
    locationDescription:
      " The man eats the horizon quickly. The teacher jumps over a fence lazily.",
  },
  {
    locationId: "item22543",
    locationName: "item22543",
    locationAddress: "item22543",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 58.86158137776269,
    lng: -8.347618433965664,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item4543",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student runs towards the road lazily. The student looks at the cake happily. The student builds the horizon gracefully. The student runs towards the cake lazily. The man writes a book angrily.",
  },
  {
    locationId: "item22544",
    locationName: "item22544",
    locationAddress: "item22544",
    ratings: [
      { who: "Similar identities", rating: 2.43 },
      { who: "All perspectives", rating: 2.67 },
    ],
    lat: 54.48218279683214,
    lng: -8.552969067888368,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4544",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman writes a book lazily. The man builds the horizon happily. The man looks at the road quickly. A woman builds the horizon gracefully. The teacher runs towards the road gracefully.",
  },
  {
    locationId: "item22545",
    locationName: "item22545",
    locationAddress: "item22545",
    ratings: [
      { who: "Similar identities", rating: 1.67 },
      { who: "All perspectives", rating: 2.24 },
    ],
    lat: 51.33229332827102,
    lng: -0.9340458871495043,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4545",
    tags: [{ label: "accessible" }],
    locationDescription: " The student runs towards the road happily.",
  },
  {
    locationId: "item22546",
    locationName: "item22546",
    locationAddress: "item22546",
    ratings: [
      { who: "Similar identities", rating: 1.46 },
      { who: "All perspectives", rating: 1.17 },
    ],
    lat: 50.85393155949029,
    lng: -6.337704592944395,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4546",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at the horizon happily. A dog eats the road angrily. The student jumps over the horizon happily. A woman builds a book lazily. The man jumps over the cake happily.",
  },
  {
    locationId: "item22547",
    locationName: "item22547",
    locationAddress: "item22547",
    ratings: null,
    lat: 55.82241889934964,
    lng: -4.811421368966267,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4547",
    tags: [],
    locationDescription: " The cat eats the horizon happily.",
  },
  {
    locationId: "item22548",
    locationName: "item22548",
    locationAddress: "item22548",
    ratings: null,
    lat: 54.90339425067388,
    lng: -2.100023272537137,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4548",
    tags: [],
    locationDescription:
      " The student eats a fence gracefully. The man runs towards a tower angrily. The cat runs towards the horizon silently. The man jumps over the road quickly.",
  },
  {
    locationId: "item22549",
    locationName: "item22549",
    locationAddress: "item22549",
    ratings: [
      { who: "Similar identities", rating: 3.03 },
      { who: "All perspectives", rating: 0.53 },
    ],
    lat: 53.3085744193779,
    lng: -2.9354223813889915,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4549",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a book silently. The teacher looks at a tower quickly. The student writes the horizon silently. The teacher runs towards a book gracefully. The cat looks at the cake silently.",
  },
  {
    locationId: "item22550",
    locationName: "item22550",
    locationAddress: "item22550",
    ratings: [
      { who: "Similar identities", rating: 3.82 },
      { who: "All perspectives", rating: 2.81 },
    ],
    lat: 60.87327435568582,
    lng: -3.86905055510237,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4550",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher eats the cake lazily. A woman runs towards the horizon happily. The teacher looks at a tower silently.",
  },
  {
    locationId: "item22551",
    locationName: "item22551",
    locationAddress: "item22551",
    ratings: [
      { who: "Similar identities", rating: 1.93 },
      { who: "All perspectives", rating: 0.91 },
    ],
    lat: 60.169339069054764,
    lng: -7.74001583284326,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4551",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription: " The student runs towards the cake lazily.",
  },
  {
    locationId: "item22552",
    locationName: "item22552",
    locationAddress: "item22552",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 57.54607285008811,
    lng: -5.412539119205489,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4552",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man looks at the cake quickly. The cat runs towards the cake angrily. The man runs towards the horizon angrily. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item22553",
    locationName: "item22553",
    locationAddress: "item22553",
    ratings: [
      { who: "Similar identities", rating: 2.15 },
      { who: "All perspectives", rating: 1.87 },
    ],
    lat: 52.32618273591863,
    lng: -2.9197387675181137,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4553",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat looks at a book gracefully. The student eats the horizon lazily. A woman eats a book happily. A woman builds the cake quickly.",
  },
  {
    locationId: "item22554",
    locationName: "item22554",
    locationAddress: "item22554",
    ratings: null,
    lat: 52.19466665447454,
    lng: -7.663591553050414,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4554",
    tags: [],
    locationDescription:
      " The man looks at the road happily. A dog runs towards a tower silently. A woman runs towards a book quickly. A woman runs towards the road gracefully.",
  },
  {
    locationId: "item22555",
    locationName: "item22555",
    locationAddress: "item22555",
    ratings: [
      { who: "Similar identities", rating: 0.83 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 57.83209807704143,
    lng: -0.2761869765441958,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4555",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man runs towards the road gracefully. The man eats a book gracefully. The man eats a tower gracefully.",
  },
  {
    locationId: "item22556",
    locationName: "item22556",
    locationAddress: "item22556",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 2.11 },
    ],
    lat: 50.195547315077576,
    lng: -8.262405508780045,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4556",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student looks at a book quickly. The teacher writes a tower happily. The cat writes the road lazily.",
  },
  {
    locationId: "item22557",
    locationName: "item22557",
    locationAddress: "item22557",
    ratings: null,
    lat: 53.77021843607397,
    lng: -8.41300700251834,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4557",
    tags: [],
    locationDescription:
      " The cat builds the road lazily. The student looks at a tower angrily. The student looks at a tower happily.",
  },
  {
    locationId: "item22558",
    locationName: "item22558",
    locationAddress: "item22558",
    ratings: [
      { who: "Similar identities", rating: 1.22 },
      { who: "All perspectives", rating: 1.64 },
    ],
    lat: 57.62624822086269,
    lng: -4.510146130630935,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4558",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at the horizon angrily. The student runs towards the horizon happily. The man runs towards the road happily. The teacher runs towards a book quickly. The teacher looks at a book happily.",
  },
  {
    locationId: "item22559",
    locationName: "item22559",
    locationAddress: "item22559",
    ratings: null,
    lat: 56.94905447122098,
    lng: -0.6921717843952848,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4559",
    tags: [],
    locationDescription:
      " The student runs towards the cake happily. The teacher builds a tower quickly. The teacher writes the horizon lazily.",
  },
  {
    locationId: "item22560",
    locationName: "item22560",
    locationAddress: "item22560",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 60.45498832479686,
    lng: -0.5518828492349819,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4560",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher runs towards the road gracefully. The student jumps over the road angrily. The man jumps over the road gracefully. The student builds the cake silently.",
  },
  {
    locationId: "item22561",
    locationName: "item22561",
    locationAddress: "item22561",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 54.38910070350202,
    lng: -5.2900801759268266,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4561",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher writes the horizon quickly.",
  },
  {
    locationId: "item22562",
    locationName: "item22562",
    locationAddress: "item22562",
    ratings: null,
    lat: 57.58330099680057,
    lng: -4.106445282805688,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4562",
    tags: [],
    locationDescription: " The student runs towards the horizon silently.",
  },
  {
    locationId: "item22563",
    locationName: "item22563",
    locationAddress: "item22563",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 53.51341434687991,
    lng: -0.898670719329048,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4563",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman builds the horizon lazily. A woman writes a fence gracefully.",
  },
  {
    locationId: "item22564",
    locationName: "item22564",
    locationAddress: "item22564",
    ratings: null,
    lat: 50.34032576576593,
    lng: -1.0657068561245504,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4564",
    tags: [],
    locationDescription:
      " The student jumps over a fence gracefully. The cat builds a tower happily. A dog writes a book lazily. The teacher builds the cake happily.",
  },
  {
    locationId: "item22565",
    locationName: "item22565",
    locationAddress: "item22565",
    ratings: null,
    lat: 54.97510076806327,
    lng: 1.2966591925303117,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4565",
    tags: [],
    locationDescription:
      " A dog builds the horizon silently. The teacher runs towards the horizon gracefully. The man writes a book angrily.",
  },
  {
    locationId: "item22566",
    locationName: "item22566",
    locationAddress: "item22566",
    ratings: [
      { who: "Similar identities", rating: 3.01 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 54.87619103599535,
    lng: -6.241654356589634,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4566",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at a book gracefully. A woman builds a fence gracefully.",
  },
  {
    locationId: "item22567",
    locationName: "item22567",
    locationAddress: "item22567",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 51.66138490378373,
    lng: -6.985608970335157,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4567",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman runs towards the horizon quickly. The student builds a book gracefully. A woman jumps over a fence gracefully. The cat jumps over the horizon angrily.",
  },
  {
    locationId: "item22568",
    locationName: "item22568",
    locationAddress: "item22568",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 58.372347198952355,
    lng: -7.713569974799198,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4568",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over the horizon quickly. The cat eats the cake gracefully. The man eats a fence angrily.",
  },
  {
    locationId: "item22569",
    locationName: "item22569",
    locationAddress: "item22569",
    ratings: [
      { who: "Similar identities", rating: 0.46 },
      { who: "All perspectives", rating: 3.02 },
    ],
    lat: 52.5663052228036,
    lng: -7.051793772044877,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4569",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man runs towards the horizon happily. A dog eats the cake silently. A dog jumps over a book gracefully. The man writes a book happily.",
  },
  {
    locationId: "item22570",
    locationName: "item22570",
    locationAddress: "item22570",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 2.96 },
    ],
    lat: 54.97839852283194,
    lng: -4.269295258061431,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4570",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over the horizon angrily. A dog writes the road lazily. The student builds the cake silently. The teacher builds a fence silently.",
  },
  {
    locationId: "item22571",
    locationName: "item22571",
    locationAddress: "item22571",
    ratings: null,
    lat: 52.65621294319698,
    lng: -0.027144812828634457,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4571",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower gracefully. The cat looks at a book lazily. The man writes a tower happily. The teacher eats the horizon quickly.",
  },
  {
    locationId: "item22572",
    locationName: "item22572",
    locationAddress: "item22572",
    ratings: null,
    lat: 55.54267216179642,
    lng: -0.371632022448642,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4572",
    tags: [],
    locationDescription:
      " A dog writes the cake quickly. The man runs towards a fence gracefully. The teacher eats the horizon gracefully.",
  },
  {
    locationId: "item22573",
    locationName: "item22573",
    locationAddress: "item22573",
    ratings: [
      { who: "Similar identities", rating: 0.68 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 52.46590746409052,
    lng: -3.2354378106352923,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4573",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The student builds a book lazily.",
  },
  {
    locationId: "item22574",
    locationName: "item22574",
    locationAddress: "item22574",
    ratings: [
      { who: "Similar identities", rating: 1.98 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 55.10203219267276,
    lng: -0.30473207406385505,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4574",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog builds a tower silently. A woman runs towards a tower silently. The man looks at the horizon lazily. The cat eats a fence quickly. The teacher eats the road angrily.",
  },
  {
    locationId: "item22575",
    locationName: "item22575",
    locationAddress: "item22575",
    ratings: null,
    lat: 50.3113339080466,
    lng: -8.525427474729243,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4575",
    tags: [],
    locationDescription:
      " The man eats the road angrily. The teacher looks at a fence angrily.",
  },
  {
    locationId: "item22576",
    locationName: "item22576",
    locationAddress: "item22576",
    ratings: null,
    lat: 50.76820383661956,
    lng: -0.4254537177247588,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4576",
    tags: [],
    locationDescription: " The student jumps over the cake happily.",
  },
  {
    locationId: "item22577",
    locationName: "item22577",
    locationAddress: "item22577",
    ratings: null,
    lat: 50.66945808604982,
    lng: -3.3572106736213305,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4577",
    tags: [],
    locationDescription:
      " A woman jumps over the road gracefully. The cat builds a tower happily. A woman looks at a tower quickly.",
  },
  {
    locationId: "item22578",
    locationName: "item22578",
    locationAddress: "item22578",
    ratings: null,
    lat: 53.642772373483695,
    lng: 1.17441303906757,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4578",
    tags: [],
    locationDescription:
      " The cat builds a book lazily. The student eats a book gracefully. The teacher runs towards the horizon happily.",
  },
  {
    locationId: "item22579",
    locationName: "item22579",
    locationAddress: "item22579",
    ratings: null,
    lat: 52.59607837149905,
    lng: -2.68208590093933,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4579",
    tags: [],
    locationDescription:
      " The man writes the road gracefully. The cat jumps over the horizon angrily. A woman jumps over a fence silently.",
  },
  {
    locationId: "item22580",
    locationName: "item22580",
    locationAddress: "item22580",
    ratings: [
      { who: "Similar identities", rating: 1.54 },
      { who: "All perspectives", rating: 2.27 },
    ],
    lat: 59.877264240022285,
    lng: -0.22463573688732197,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4580",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes a fence angrily. A dog writes a fence happily. The man eats the horizon lazily. The man jumps over a book angrily.",
  },
  {
    locationId: "item22581",
    locationName: "item22581",
    locationAddress: "item22581",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 0.54 },
    ],
    lat: 52.48898439468088,
    lng: -2.0525177612450802,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4581",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman builds a fence silently. A woman eats the horizon lazily.",
  },
  {
    locationId: "item22582",
    locationName: "item22582",
    locationAddress: "item22582",
    ratings: null,
    lat: 59.09573092551451,
    lng: -6.91655769433271,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4582",
    tags: [],
    locationDescription: " A woman eats the horizon gracefully.",
  },
  {
    locationId: "item22583",
    locationName: "item22583",
    locationAddress: "item22583",
    ratings: null,
    lat: 59.21577286823386,
    lng: -1.6113503636605415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4583",
    tags: [],
    locationDescription:
      " A dog runs towards the cake quickly. The man jumps over a fence angrily. The cat eats the road happily. A woman eats the cake lazily.",
  },
  {
    locationId: "item22584",
    locationName: "item22584",
    locationAddress: "item22584",
    ratings: [
      { who: "Similar identities", rating: 2.92 },
      { who: "All perspectives", rating: 0.91 },
    ],
    lat: 59.13696293996297,
    lng: -7.790460196029344,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4584",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats the cake silently. The teacher jumps over a book angrily. The student builds the road angrily.",
  },
  {
    locationId: "item22585",
    locationName: "item22585",
    locationAddress: "item22585",
    ratings: null,
    lat: 57.2310621891813,
    lng: -0.05180558893802534,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4585",
    tags: [],
    locationDescription: " A dog eats the cake quickly.",
  },
  {
    locationId: "item22586",
    locationName: "item22586",
    locationAddress: "item22586",
    ratings: [
      { who: "Similar identities", rating: 4.29 },
      { who: "All perspectives", rating: 4.99 },
    ],
    lat: 52.24179194190281,
    lng: -3.5513849465066736,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4586",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards a tower happily. A woman runs towards the horizon gracefully. The cat eats the road lazily.",
  },
  {
    locationId: "item22587",
    locationName: "item22587",
    locationAddress: "item22587",
    ratings: [
      { who: "Similar identities", rating: 3.14 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 58.2383668456203,
    lng: -0.29248706240262656,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4587",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat writes the road happily.",
  },
  {
    locationId: "item22588",
    locationName: "item22588",
    locationAddress: "item22588",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 4.61 },
    ],
    lat: 54.80264294058131,
    lng: -2.771439290899444,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4588",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man eats a book gracefully. A woman jumps over a tower angrily. The student eats a book quickly. The student jumps over the horizon angrily. A woman runs towards the cake silently.",
  },
  {
    locationId: "item22589",
    locationName: "item22589",
    locationAddress: "item22589",
    ratings: [
      { who: "Similar identities", rating: 1.55 },
      { who: "All perspectives", rating: 1.3 },
    ],
    lat: 58.7707574825087,
    lng: 1.1987362331487237,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4589",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student builds the road gracefully. The man runs towards the cake happily. A woman runs towards the road silently.",
  },
  {
    locationId: "item22590",
    locationName: "item22590",
    locationAddress: "item22590",
    ratings: [
      { who: "Similar identities", rating: 3.74 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 51.28133881296369,
    lng: -4.588346645422629,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item4590",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat runs towards a tower silently. The teacher builds a book gracefully.",
  },
  {
    locationId: "item22591",
    locationName: "item22591",
    locationAddress: "item22591",
    ratings: [
      { who: "Similar identities", rating: 3.61 },
      { who: "All perspectives", rating: 4.01 },
    ],
    lat: 56.86706498552877,
    lng: 0.054433377532079774,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4591",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student writes the horizon silently. The teacher eats the road lazily. The student builds the cake silently. A dog runs towards the cake silently. The student jumps over a tower quickly.",
  },
  {
    locationId: "item22592",
    locationName: "item22592",
    locationAddress: "item22592",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 1.76 },
    ],
    lat: 51.556559545245285,
    lng: -0.556943573051413,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4592",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over the road silently. The teacher looks at a book lazily. The student eats a fence lazily. The cat writes the road happily. A dog eats a tower gracefully.",
  },
  {
    locationId: "item22593",
    locationName: "item22593",
    locationAddress: "item22593",
    ratings: null,
    lat: 54.63647062593267,
    lng: -4.318737989127837,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4593",
    tags: [],
    locationDescription: " The student writes a book gracefully.",
  },
  {
    locationId: "item22594",
    locationName: "item22594",
    locationAddress: "item22594",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 57.08855361255567,
    lng: 1.0363799111233902,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4594",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat jumps over a fence lazily.",
  },
  {
    locationId: "item22595",
    locationName: "item22595",
    locationAddress: "item22595",
    ratings: [
      { who: "Similar identities", rating: 1.04 },
      { who: "All perspectives", rating: 2.87 },
    ],
    lat: 51.28953555100544,
    lng: -6.254950281214592,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4595",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at the horizon gracefully. The cat eats the road gracefully. A woman looks at a fence quickly. The student writes the horizon silently.",
  },
  {
    locationId: "item22596",
    locationName: "item22596",
    locationAddress: "item22596",
    ratings: null,
    lat: 50.05941075491188,
    lng: -0.8909944476138252,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4596",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower angrily. A dog runs towards the road quickly.",
  },
  {
    locationId: "item22597",
    locationName: "item22597",
    locationAddress: "item22597",
    ratings: [
      { who: "Similar identities", rating: 3.15 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 60.17134256972797,
    lng: -5.394932511557929,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4597",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat writes the road happily. The teacher looks at the road lazily. The student runs towards the horizon quickly. The student builds the road happily.",
  },
  {
    locationId: "item22598",
    locationName: "item22598",
    locationAddress: "item22598",
    ratings: null,
    lat: 53.50513633180683,
    lng: -1.2655174484549443,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4598",
    tags: [],
    locationDescription:
      " The cat eats a book happily. The cat writes a tower quickly.",
  },
  {
    locationId: "item22599",
    locationName: "item22599",
    locationAddress: "item22599",
    ratings: null,
    lat: 54.1094933386567,
    lng: -3.1765423698465076,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4599",
    tags: [],
    locationDescription:
      " A woman looks at a tower angrily. A dog eats the road angrily. The teacher eats the road happily.",
  },
  {
    locationId: "item22600",
    locationName: "item22600",
    locationAddress: "item22600",
    ratings: null,
    lat: 56.882548970273,
    lng: -8.363214473291425,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4600",
    tags: [],
    locationDescription:
      " A dog runs towards a fence lazily. A woman writes a tower angrily. A dog writes a book silently.",
  },
  {
    locationId: "item22601",
    locationName: "item22601",
    locationAddress: "item22601",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 2.01 },
    ],
    lat: 53.094768533954976,
    lng: -4.831767397606931,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4601",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher writes a tower quickly. A dog looks at the road gracefully. The student runs towards a book silently. The cat looks at the road silently.",
  },
  {
    locationId: "item22602",
    locationName: "item22602",
    locationAddress: "item22602",
    ratings: [
      { who: "Similar identities", rating: 2.44 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 56.23114296783086,
    lng: 0.8611379623140323,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4602",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man jumps over the cake happily. The student runs towards the horizon lazily. The student builds a book gracefully.",
  },
  {
    locationId: "item22603",
    locationName: "item22603",
    locationAddress: "item22603",
    ratings: [
      { who: "Similar identities", rating: 3.21 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 52.80788429417938,
    lng: -6.442192436017607,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4603",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student runs towards a book quickly. A dog builds the road lazily. The cat runs towards a book quickly. The student builds the cake gracefully.",
  },
  {
    locationId: "item22604",
    locationName: "item22604",
    locationAddress: "item22604",
    ratings: null,
    lat: 55.42148273750364,
    lng: -0.5735897286153602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4604",
    tags: [],
    locationDescription:
      " The man jumps over the cake gracefully. The student jumps over the cake silently. A dog eats the road lazily. A dog eats a tower lazily. A woman builds a tower lazily.",
  },
  {
    locationId: "item22605",
    locationName: "item22605",
    locationAddress: "item22605",
    ratings: [
      { who: "Similar identities", rating: 1.17 },
      { who: "All perspectives", rating: 3.97 },
    ],
    lat: 54.53570302710887,
    lng: -4.96721514927072,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4605",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman eats the cake gracefully.",
  },
  {
    locationId: "item22606",
    locationName: "item22606",
    locationAddress: "item22606",
    ratings: null,
    lat: 55.40149769085327,
    lng: -1.2968330939633033,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4606",
    tags: [],
    locationDescription:
      " The cat jumps over the road silently. The teacher runs towards the cake happily. The student writes the road lazily. A dog jumps over the horizon happily.",
  },
  {
    locationId: "item22607",
    locationName: "item22607",
    locationAddress: "item22607",
    ratings: null,
    lat: 50.528399469867104,
    lng: 1.2779832431901177,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4607",
    tags: [],
    locationDescription:
      " The cat jumps over a tower silently. The teacher runs towards the horizon gracefully. The man writes the road quickly. A woman writes a book happily. The teacher writes the horizon quickly.",
  },
  {
    locationId: "item22608",
    locationName: "item22608",
    locationAddress: "item22608",
    ratings: null,
    lat: 54.19249625215379,
    lng: -3.872308549818091,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4608",
    tags: [],
    locationDescription: " The man writes the road happily.",
  },
  {
    locationId: "item22609",
    locationName: "item22609",
    locationAddress: "item22609",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 0.59 },
    ],
    lat: 55.81879127058247,
    lng: -1.3883928920439264,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4609",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds a tower gracefully. The man jumps over the horizon quickly. The man runs towards the road happily. The teacher looks at a fence lazily.",
  },
  {
    locationId: "item22610",
    locationName: "item22610",
    locationAddress: "item22610",
    ratings: null,
    lat: 54.55543833720864,
    lng: -6.772872465507139,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4610",
    tags: [],
    locationDescription: " The cat eats the cake angrily.",
  },
  {
    locationId: "item22611",
    locationName: "item22611",
    locationAddress: "item22611",
    ratings: null,
    lat: 59.306043965539864,
    lng: -6.499585425250441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4611",
    tags: [],
    locationDescription:
      " The teacher builds a fence silently. A woman jumps over a tower gracefully. The student runs towards a tower silently. The student looks at a book gracefully. The student jumps over the road quickly.",
  },
  {
    locationId: "item22612",
    locationName: "item22612",
    locationAddress: "item22612",
    ratings: [
      { who: "Similar identities", rating: 3.6 },
      { who: "All perspectives", rating: 3.75 },
    ],
    lat: 52.81789252490588,
    lng: -3.3361567295765173,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4612",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The teacher jumps over the cake quickly. The student runs towards a book quickly. The teacher builds the road happily. The man looks at a tower angrily.",
  },
  {
    locationId: "item22613",
    locationName: "item22613",
    locationAddress: "item22613",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 2.77 },
    ],
    lat: 50.407240611740846,
    lng: -3.084245650429663,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4613",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats the horizon quickly. A woman eats the cake silently. The teacher builds a book silently. A dog looks at the horizon happily. The student runs towards a fence happily.",
  },
  {
    locationId: "item22614",
    locationName: "item22614",
    locationAddress: "item22614",
    ratings: [
      { who: "Similar identities", rating: 0.76 },
      { who: "All perspectives", rating: 3.71 },
    ],
    lat: 50.30792978881999,
    lng: -5.855211301436393,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4614",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher eats a tower lazily. The cat builds a book quickly. The man builds a book angrily. A woman builds the horizon lazily.",
  },
  {
    locationId: "item22615",
    locationName: "item22615",
    locationAddress: "item22615",
    ratings: null,
    lat: 54.32170626321346,
    lng: -7.760167555816103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4615",
    tags: [],
    locationDescription: " The cat writes a fence angrily.",
  },
  {
    locationId: "item22616",
    locationName: "item22616",
    locationAddress: "item22616",
    ratings: [
      { who: "Similar identities", rating: 4.44 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 53.99319000215235,
    lng: -4.1898600755983795,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4616",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher writes a fence quickly. A woman writes the cake angrily. A dog builds a fence gracefully.",
  },
  {
    locationId: "item22617",
    locationName: "item22617",
    locationAddress: "item22617",
    ratings: null,
    lat: 56.98237519496479,
    lng: -5.073193303537712,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4617",
    tags: [],
    locationDescription:
      " The cat eats a fence happily. The man builds the horizon quickly. The cat builds a book silently. The teacher eats the road happily. A woman runs towards the horizon angrily.",
  },
  {
    locationId: "item22618",
    locationName: "item22618",
    locationAddress: "item22618",
    ratings: null,
    lat: 57.42298311618892,
    lng: -5.408472241196127,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4618",
    tags: [],
    locationDescription:
      " The cat eats the horizon quickly. The cat looks at the cake gracefully. The man runs towards the horizon gracefully. The teacher jumps over the cake quickly. A dog eats the cake angrily.",
  },
  {
    locationId: "item22619",
    locationName: "item22619",
    locationAddress: "item22619",
    ratings: null,
    lat: 58.64591882709858,
    lng: -0.15697523901396515,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4619",
    tags: [],
    locationDescription:
      " The teacher writes a fence happily. The teacher writes a fence angrily. The student builds the road gracefully. The teacher jumps over the road quickly.",
  },
  {
    locationId: "item22620",
    locationName: "item22620",
    locationAddress: "item22620",
    ratings: null,
    lat: 52.333527455761725,
    lng: -4.0306775688727345,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4620",
    tags: [],
    locationDescription:
      " A dog looks at a book quickly. The cat looks at a book quickly.",
  },
  {
    locationId: "item22621",
    locationName: "item22621",
    locationAddress: "item22621",
    ratings: null,
    lat: 57.00662771286772,
    lng: -7.208217399536727,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4621",
    tags: [],
    locationDescription:
      " The cat looks at a fence happily. A woman builds the road happily.",
  },
  {
    locationId: "item22622",
    locationName: "item22622",
    locationAddress: "item22622",
    ratings: [
      { who: "Similar identities", rating: 0.27 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 57.22073391091481,
    lng: 0.37538734803789175,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4622",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man jumps over the cake happily. The student jumps over a fence happily.",
  },
  {
    locationId: "item22623",
    locationName: "item22623",
    locationAddress: "item22623",
    ratings: [
      { who: "Similar identities", rating: 3.1 },
      { who: "All perspectives", rating: 0.08 },
    ],
    lat: 53.86516903977028,
    lng: -5.005661276203927,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4623",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats the road quickly. A woman writes the cake quickly.",
  },
  {
    locationId: "item22624",
    locationName: "item22624",
    locationAddress: "item22624",
    ratings: [
      { who: "Similar identities", rating: 1.61 },
      { who: "All perspectives", rating: 3.94 },
    ],
    lat: 57.88764452811892,
    lng: -7.162753081034831,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4624",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat looks at a book gracefully. A woman writes the cake silently.",
  },
  {
    locationId: "item22625",
    locationName: "item22625",
    locationAddress: "item22625",
    ratings: null,
    lat: 52.89038206831196,
    lng: -1.8785379972819625,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4625",
    tags: [],
    locationDescription:
      " The student builds a fence angrily. The student eats the road silently. A dog jumps over a tower happily. A woman eats a book angrily. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item22626",
    locationName: "item22626",
    locationAddress: "item22626",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 4.74 },
    ],
    lat: 52.144981014713466,
    lng: -6.050611340154674,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4626",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a fence happily. A woman jumps over a book gracefully.",
  },
  {
    locationId: "item22627",
    locationName: "item22627",
    locationAddress: "item22627",
    ratings: null,
    lat: 59.33325027406411,
    lng: -4.737882692856605,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4627",
    tags: [],
    locationDescription:
      " A woman jumps over a fence silently. The teacher eats the road angrily. The man runs towards the road angrily. The teacher jumps over the horizon gracefully. The cat jumps over the cake gracefully.",
  },
  {
    locationId: "item22628",
    locationName: "item22628",
    locationAddress: "item22628",
    ratings: null,
    lat: 60.18629467417185,
    lng: -4.948051651092824,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4628",
    tags: [],
    locationDescription:
      " A woman runs towards a book quickly. A dog writes a fence angrily.",
  },
  {
    locationId: "item22629",
    locationName: "item22629",
    locationAddress: "item22629",
    ratings: [
      { who: "Similar identities", rating: 0.8 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 59.56983431253714,
    lng: -7.3716385590939195,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4629",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The student eats a book happily.",
  },
  {
    locationId: "item22630",
    locationName: "item22630",
    locationAddress: "item22630",
    ratings: [
      { who: "Similar identities", rating: 3.71 },
      { who: "All perspectives", rating: 1.96 },
    ],
    lat: 58.212411832698095,
    lng: -7.912359063036275,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4630",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man looks at a tower angrily. A dog builds the cake happily.",
  },
  {
    locationId: "item22631",
    locationName: "item22631",
    locationAddress: "item22631",
    ratings: null,
    lat: 57.381827079963685,
    lng: -4.366287721925275,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4631",
    tags: [],
    locationDescription:
      " The student looks at a book happily. A dog builds the horizon silently. A dog builds a tower lazily.",
  },
  {
    locationId: "item22632",
    locationName: "item22632",
    locationAddress: "item22632",
    ratings: null,
    lat: 50.565865124497556,
    lng: -4.3799843181702,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4632",
    tags: [],
    locationDescription:
      " A woman writes the horizon silently. A dog jumps over the road lazily.",
  },
  {
    locationId: "item22633",
    locationName: "item22633",
    locationAddress: "item22633",
    ratings: [
      { who: "Similar identities", rating: 4.57 },
      { who: "All perspectives", rating: 2.19 },
    ],
    lat: 56.321535995132294,
    lng: -0.20423198824793332,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4633",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman jumps over a book angrily.",
  },
  {
    locationId: "item22634",
    locationName: "item22634",
    locationAddress: "item22634",
    ratings: [
      { who: "Similar identities", rating: 3.39 },
      { who: "All perspectives", rating: 0.23 },
    ],
    lat: 60.032685413944,
    lng: 0.6931870314663975,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4634",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man writes a fence lazily. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item22635",
    locationName: "item22635",
    locationAddress: "item22635",
    ratings: null,
    lat: 55.680438173907795,
    lng: -5.455502169579731,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4635",
    tags: [],
    locationDescription: " The cat eats the road lazily.",
  },
  {
    locationId: "item22636",
    locationName: "item22636",
    locationAddress: "item22636",
    ratings: [
      { who: "Similar identities", rating: 2.89 },
      { who: "All perspectives", rating: 2.43 },
    ],
    lat: 50.80282726573273,
    lng: -8.000791228283516,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4636",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards a book quickly. The man looks at a tower silently.",
  },
  {
    locationId: "item22637",
    locationName: "item22637",
    locationAddress: "item22637",
    ratings: [
      { who: "Similar identities", rating: 4.56 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 55.16220083932936,
    lng: -2.5465901767102634,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4637",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards the horizon lazily. A dog writes a book happily. The student builds the cake angrily. A dog runs towards the horizon silently. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item22638",
    locationName: "item22638",
    locationAddress: "item22638",
    ratings: [
      { who: "Similar identities", rating: 1.38 },
      { who: "All perspectives", rating: 3.03 },
    ],
    lat: 49.98088326375344,
    lng: -6.698950119813241,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4638",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man jumps over the horizon lazily. The teacher writes the horizon silently. The man jumps over the cake angrily. The student eats a book happily. A woman runs towards a book gracefully.",
  },
  {
    locationId: "item22639",
    locationName: "item22639",
    locationAddress: "item22639",
    ratings: [
      { who: "Similar identities", rating: 1.66 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 57.32022144196892,
    lng: -3.7491607275081194,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item4639",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes the horizon happily. The cat writes a fence gracefully. The man looks at a fence silently. The man eats a tower silently.",
  },
  {
    locationId: "item22640",
    locationName: "item22640",
    locationAddress: "item22640",
    ratings: [
      { who: "Similar identities", rating: 1.15 },
      { who: "All perspectives", rating: 0.52 },
    ],
    lat: 51.42901283131909,
    lng: -8.214828733454075,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4640",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man writes a tower lazily. The teacher jumps over a tower silently.",
  },
  {
    locationId: "item22641",
    locationName: "item22641",
    locationAddress: "item22641",
    ratings: [
      { who: "Similar identities", rating: 1.69 },
      { who: "All perspectives", rating: 4.48 },
    ],
    lat: 54.887173291414456,
    lng: 0.13860206746807435,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4641",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher eats the horizon happily.",
  },
  {
    locationId: "item22642",
    locationName: "item22642",
    locationAddress: "item22642",
    ratings: null,
    lat: 53.25359263440971,
    lng: -5.838238168766863,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4642",
    tags: [],
    locationDescription:
      " The cat eats a book happily. A dog jumps over a tower gracefully. The man eats the road angrily. The man eats the road lazily.",
  },
  {
    locationId: "item22643",
    locationName: "item22643",
    locationAddress: "item22643",
    ratings: [
      { who: "Similar identities", rating: 1.86 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 58.890387325447904,
    lng: -0.4762172746628064,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4643",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher writes a book silently. The man runs towards the road lazily. The teacher runs towards a tower quickly. A dog builds a fence happily.",
  },
  {
    locationId: "item22644",
    locationName: "item22644",
    locationAddress: "item22644",
    ratings: [
      { who: "Similar identities", rating: 2.05 },
      { who: "All perspectives", rating: 0.06 },
    ],
    lat: 57.4557668414001,
    lng: -0.4690075414457837,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4644",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student jumps over the horizon happily. The teacher builds the cake gracefully. The cat jumps over a fence quickly. The student builds the cake angrily.",
  },
  {
    locationId: "item22645",
    locationName: "item22645",
    locationAddress: "item22645",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 3.59 },
    ],
    lat: 58.77050866742176,
    lng: 0.7648897549718647,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4645",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds the road lazily. The cat eats the cake happily. The teacher writes a tower quickly. A dog looks at a tower lazily.",
  },
  {
    locationId: "item22646",
    locationName: "item22646",
    locationAddress: "item22646",
    ratings: null,
    lat: 60.533729359985195,
    lng: -2.5244749561889277,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4646",
    tags: [],
    locationDescription:
      " The student jumps over a tower angrily. The cat writes the cake quickly. The man builds a tower lazily. The man jumps over a fence lazily. The student runs towards the road gracefully.",
  },
  {
    locationId: "item22647",
    locationName: "item22647",
    locationAddress: "item22647",
    ratings: null,
    lat: 58.44200934172696,
    lng: -3.4790850149833634,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4647",
    tags: [],
    locationDescription:
      " The student writes the horizon gracefully. A woman runs towards the cake gracefully. A woman builds the horizon happily.",
  },
  {
    locationId: "item22648",
    locationName: "item22648",
    locationAddress: "item22648",
    ratings: null,
    lat: 59.67210764633914,
    lng: -5.032271034699532,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4648",
    tags: [],
    locationDescription: " The man eats a fence happily.",
  },
  {
    locationId: "item22649",
    locationName: "item22649",
    locationAddress: "item22649",
    ratings: null,
    lat: 49.96085342411069,
    lng: -7.683402064199647,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4649",
    tags: [],
    locationDescription:
      " The man jumps over the horizon angrily. The teacher eats the horizon silently. A woman runs towards a tower gracefully.",
  },
  {
    locationId: "item22650",
    locationName: "item22650",
    locationAddress: "item22650",
    ratings: null,
    lat: 55.532279473317615,
    lng: -8.215886053201547,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4650",
    tags: [],
    locationDescription:
      " A woman writes the horizon silently. The man builds the cake happily. The student looks at the road happily. The student builds a book gracefully. The student builds a tower silently.",
  },
  {
    locationId: "item22651",
    locationName: "item22651",
    locationAddress: "item22651",
    ratings: null,
    lat: 52.860636231763756,
    lng: -4.1641074735160375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4651",
    tags: [],
    locationDescription:
      " A woman builds the horizon silently. A dog eats the cake gracefully. The student eats the cake lazily.",
  },
  {
    locationId: "item22652",
    locationName: "item22652",
    locationAddress: "item22652",
    ratings: null,
    lat: 55.04645344024715,
    lng: -1.1065275525539722,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4652",
    tags: [],
    locationDescription:
      " The cat jumps over the road lazily. A dog writes the horizon quickly.",
  },
  {
    locationId: "item22653",
    locationName: "item22653",
    locationAddress: "item22653",
    ratings: null,
    lat: 58.95543725337313,
    lng: -1.4801979286526388,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4653",
    tags: [],
    locationDescription:
      " The man runs towards a book lazily. The teacher eats a tower quickly. The man looks at a book lazily. A woman jumps over a tower happily.",
  },
  {
    locationId: "item22654",
    locationName: "item22654",
    locationAddress: "item22654",
    ratings: [
      { who: "Similar identities", rating: 2.95 },
      { who: "All perspectives", rating: 3.79 },
    ],
    lat: 59.730526719018656,
    lng: -5.045150481435373,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4654",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription: " The student looks at a tower lazily.",
  },
  {
    locationId: "item22655",
    locationName: "item22655",
    locationAddress: "item22655",
    ratings: null,
    lat: 52.15698469903407,
    lng: -2.0172046764384914,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4655",
    tags: [],
    locationDescription:
      " A woman writes the road gracefully. The teacher jumps over the horizon lazily.",
  },
  {
    locationId: "item22656",
    locationName: "item22656",
    locationAddress: "item22656",
    ratings: null,
    lat: 56.10559460733685,
    lng: -5.414492504500068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4656",
    tags: [],
    locationDescription:
      " The man looks at the horizon angrily. The teacher builds the road lazily. The student jumps over a book gracefully. A woman builds the cake silently. A dog eats a book gracefully.",
  },
  {
    locationId: "item22657",
    locationName: "item22657",
    locationAddress: "item22657",
    ratings: null,
    lat: 57.168728195016485,
    lng: 1.304316636557969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4657",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon quickly. The teacher writes a tower happily.",
  },
  {
    locationId: "item22658",
    locationName: "item22658",
    locationAddress: "item22658",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 1.39 },
    ],
    lat: 50.31976386146125,
    lng: -1.0987573851999066,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4658",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " A woman builds a fence lazily.",
  },
  {
    locationId: "item22659",
    locationName: "item22659",
    locationAddress: "item22659",
    ratings: null,
    lat: 51.04842379901114,
    lng: -3.559250716549619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4659",
    tags: [],
    locationDescription: " The student eats the horizon quickly.",
  },
  {
    locationId: "item22660",
    locationName: "item22660",
    locationAddress: "item22660",
    ratings: null,
    lat: 54.68555707854616,
    lng: -4.89227691458211,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4660",
    tags: [],
    locationDescription:
      " The man looks at a book quickly. The cat jumps over the horizon silently. The cat eats a tower silently. A dog looks at the road lazily.",
  },
  {
    locationId: "item22661",
    locationName: "item22661",
    locationAddress: "item22661",
    ratings: [
      { who: "Similar identities", rating: 3.73 },
      { who: "All perspectives", rating: 4.3 },
    ],
    lat: 51.69414596463087,
    lng: -4.346162793208206,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4661",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over the road lazily. The cat runs towards the horizon lazily. The cat builds the road lazily.",
  },
  {
    locationId: "item22662",
    locationName: "item22662",
    locationAddress: "item22662",
    ratings: null,
    lat: 57.00872289881073,
    lng: -1.937060161728568,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4662",
    tags: [],
    locationDescription:
      " A dog jumps over a book lazily. The cat jumps over the cake lazily.",
  },
  {
    locationId: "item22663",
    locationName: "item22663",
    locationAddress: "item22663",
    ratings: [
      { who: "Similar identities", rating: 3.25 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 57.68456524520231,
    lng: -7.620684854881384,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4663",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The cat eats a fence gracefully. A woman looks at the horizon silently. The teacher builds a book silently. The cat jumps over a fence silently. A dog builds a book happily.",
  },
  {
    locationId: "item22664",
    locationName: "item22664",
    locationAddress: "item22664",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 53.6096322029659,
    lng: 0.6660911338149216,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4664",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman eats the cake lazily. The teacher eats a book gracefully. The cat builds the cake gracefully.",
  },
  {
    locationId: "item22665",
    locationName: "item22665",
    locationAddress: "item22665",
    ratings: [
      { who: "Similar identities", rating: 1.77 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 54.87510148159573,
    lng: -2.856056311071841,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4665",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " The cat builds a book angrily.",
  },
  {
    locationId: "item22666",
    locationName: "item22666",
    locationAddress: "item22666",
    ratings: null,
    lat: 49.97526168664396,
    lng: -7.337646871747633,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4666",
    tags: [],
    locationDescription:
      " A dog builds a book happily. The student jumps over the horizon angrily. The teacher runs towards a book lazily. The cat writes the horizon happily. A dog eats a fence angrily.",
  },
  {
    locationId: "item22667",
    locationName: "item22667",
    locationAddress: "item22667",
    ratings: [
      { who: "Similar identities", rating: 1.67 },
      { who: "All perspectives", rating: 0.41 },
    ],
    lat: 57.4844401400589,
    lng: -0.361968910770857,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4667",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a fence lazily. The teacher eats a tower lazily. The man builds a tower lazily.",
  },
  {
    locationId: "item22668",
    locationName: "item22668",
    locationAddress: "item22668",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 1.5 },
    ],
    lat: 59.89658837543106,
    lng: -2.3225114645735605,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4668",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog writes a fence angrily. The student runs towards the road angrily.",
  },
  {
    locationId: "item22669",
    locationName: "item22669",
    locationAddress: "item22669",
    ratings: null,
    lat: 54.116821025454975,
    lng: 0.0022238480639327207,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4669",
    tags: [],
    locationDescription:
      " The cat jumps over the road gracefully. The teacher eats a book silently. A woman looks at the road happily. The man builds the cake angrily.",
  },
  {
    locationId: "item22670",
    locationName: "item22670",
    locationAddress: "item22670",
    ratings: null,
    lat: 53.49586498766632,
    lng: 0.08237568941166273,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4670",
    tags: [],
    locationDescription:
      " The teacher runs towards a book silently. The cat eats the horizon quickly. The teacher runs towards the cake happily. The man writes a tower quickly.",
  },
  {
    locationId: "item22671",
    locationName: "item22671",
    locationAddress: "item22671",
    ratings: null,
    lat: 53.181604530373754,
    lng: -7.0839000963384,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4671",
    tags: [],
    locationDescription:
      " A dog jumps over a fence gracefully. The teacher writes a fence silently.",
  },
  {
    locationId: "item22672",
    locationName: "item22672",
    locationAddress: "item22672",
    ratings: null,
    lat: 59.19142160560437,
    lng: -1.1506193080475784,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4672",
    tags: [],
    locationDescription:
      " A woman jumps over a book angrily. The student builds a tower silently. A woman looks at the horizon angrily. The man runs towards the cake happily.",
  },
  {
    locationId: "item22673",
    locationName: "item22673",
    locationAddress: "item22673",
    ratings: null,
    lat: 53.481543957318166,
    lng: -6.824632735744937,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4673",
    tags: [],
    locationDescription:
      " The student builds the road lazily. A woman runs towards the cake happily.",
  },
  {
    locationId: "item22674",
    locationName: "item22674",
    locationAddress: "item22674",
    ratings: null,
    lat: 51.82159012516716,
    lng: -8.430361762668229,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4674",
    tags: [],
    locationDescription:
      " The man runs towards the horizon angrily. A dog builds a tower silently. The teacher writes the cake silently. A dog writes a fence happily. The teacher looks at the road silently.",
  },
  {
    locationId: "item22675",
    locationName: "item22675",
    locationAddress: "item22675",
    ratings: null,
    lat: 52.12102793962804,
    lng: -0.8591850974799735,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4675",
    tags: [],
    locationDescription:
      " A dog looks at the cake angrily. The cat writes the horizon angrily.",
  },
  {
    locationId: "item22676",
    locationName: "item22676",
    locationAddress: "item22676",
    ratings: [
      { who: "Similar identities", rating: 2.26 },
      { who: "All perspectives", rating: 3.9 },
    ],
    lat: 53.00466474594637,
    lng: 1.3557053948402356,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4676",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog runs towards a fence gracefully. The cat writes the road gracefully. The teacher writes a tower lazily. The teacher writes a book gracefully.",
  },
  {
    locationId: "item22677",
    locationName: "item22677",
    locationAddress: "item22677",
    ratings: null,
    lat: 59.76901952094037,
    lng: 0.4599927321166817,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4677",
    tags: [],
    locationDescription: " A dog runs towards a fence gracefully.",
  },
  {
    locationId: "item22678",
    locationName: "item22678",
    locationAddress: "item22678",
    ratings: null,
    lat: 51.23562049496886,
    lng: -0.619911569824227,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4678",
    tags: [],
    locationDescription:
      " The man eats the road quickly. A woman writes the road gracefully.",
  },
  {
    locationId: "item22679",
    locationName: "item22679",
    locationAddress: "item22679",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 3.24 },
    ],
    lat: 59.4392496377841,
    lng: -0.4690817936625873,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4679",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman runs towards the cake quickly. The teacher looks at the cake silently. The student jumps over the cake gracefully.",
  },
  {
    locationId: "item22680",
    locationName: "item22680",
    locationAddress: "item22680",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 51.33961932832946,
    lng: -8.57216147756605,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4680",
    tags: [{ label: "child friendly" }],
    locationDescription: " The cat builds the road angrily.",
  },
  {
    locationId: "item22681",
    locationName: "item22681",
    locationAddress: "item22681",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 4.53 },
    ],
    lat: 53.11918828501754,
    lng: -7.377074732274698,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4681",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat builds the road lazily. The teacher looks at a tower angrily.",
  },
  {
    locationId: "item22682",
    locationName: "item22682",
    locationAddress: "item22682",
    ratings: [
      { who: "Similar identities", rating: 3.39 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 50.59103543476993,
    lng: -7.177340925185614,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4682",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student looks at a tower happily. A woman writes the cake happily. The teacher jumps over a book silently. A dog builds a tower quickly. A woman looks at a fence silently.",
  },
  {
    locationId: "item22683",
    locationName: "item22683",
    locationAddress: "item22683",
    ratings: [
      { who: "Similar identities", rating: 4.5 },
      { who: "All perspectives", rating: 3.62 },
    ],
    lat: 55.612196955550395,
    lng: -3.6344384658050624,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4683",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student jumps over the cake quickly. The student runs towards the horizon silently. A dog runs towards a fence happily. A dog builds the horizon gracefully. A woman builds the cake happily.",
  },
  {
    locationId: "item22684",
    locationName: "item22684",
    locationAddress: "item22684",
    ratings: [
      { who: "Similar identities", rating: 1.39 },
      { who: "All perspectives", rating: 2.43 },
    ],
    lat: 53.010117984093505,
    lng: 0.43088129686165466,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4684",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at the road happily. The cat runs towards the road lazily. The cat jumps over the road quickly. A woman eats a book gracefully.",
  },
  {
    locationId: "item22685",
    locationName: "item22685",
    locationAddress: "item22685",
    ratings: [
      { who: "Similar identities", rating: 0.73 },
      { who: "All perspectives", rating: 2.2 },
    ],
    lat: 58.308976517230484,
    lng: -5.44007791649522,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4685",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man builds the road quickly. A dog looks at a tower happily.",
  },
  {
    locationId: "item22686",
    locationName: "item22686",
    locationAddress: "item22686",
    ratings: null,
    lat: 51.604935154628016,
    lng: -0.47656567494984614,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4686",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon quickly. The man looks at a tower gracefully. A woman runs towards a book quickly.",
  },
  {
    locationId: "item22687",
    locationName: "item22687",
    locationAddress: "item22687",
    ratings: [
      { who: "Similar identities", rating: 2.07 },
      { who: "All perspectives", rating: 4.51 },
    ],
    lat: 53.707246764464124,
    lng: -0.7038056955145358,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4687",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man jumps over the horizon gracefully.",
  },
  {
    locationId: "item22688",
    locationName: "item22688",
    locationAddress: "item22688",
    ratings: [
      { who: "Similar identities", rating: 4.55 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 55.7234530037027,
    lng: -3.0528894061324072,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4688",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man runs towards the horizon quickly. A dog writes a tower quickly. The cat jumps over a fence angrily. The man jumps over a tower gracefully. A dog writes the horizon silently.",
  },
  {
    locationId: "item22689",
    locationName: "item22689",
    locationAddress: "item22689",
    ratings: [
      { who: "Similar identities", rating: 4.42 },
      { who: "All perspectives", rating: 3.09 },
    ],
    lat: 58.476431166433734,
    lng: -8.552688008586157,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4689",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes the cake gracefully. A dog writes the road silently. A woman jumps over a fence lazily. The student eats a book quickly.",
  },
  {
    locationId: "item22690",
    locationName: "item22690",
    locationAddress: "item22690",
    ratings: [
      { who: "Similar identities", rating: 4.17 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 53.326813338654404,
    lng: -3.0500829015479596,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4690",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student jumps over the horizon gracefully. The man builds a fence quickly. A dog looks at the cake happily. The man jumps over a tower quickly.",
  },
  {
    locationId: "item22691",
    locationName: "item22691",
    locationAddress: "item22691",
    ratings: [
      { who: "Similar identities", rating: 3.38 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 57.49546763734567,
    lng: 0.42125904760341726,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4691",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman writes the cake quickly. A dog jumps over a fence happily.",
  },
  {
    locationId: "item22692",
    locationName: "item22692",
    locationAddress: "item22692",
    ratings: [
      { who: "Similar identities", rating: 4.94 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 50.31746403073071,
    lng: -6.073466828401765,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4692",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The student jumps over a book happily.",
  },
  {
    locationId: "item22693",
    locationName: "item22693",
    locationAddress: "item22693",
    ratings: null,
    lat: 50.89500114485352,
    lng: -2.4033485113079385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4693",
    tags: [],
    locationDescription:
      " The teacher looks at a book silently. The cat jumps over the cake silently. The student jumps over a fence angrily. The cat eats a book quickly.",
  },
  {
    locationId: "item22694",
    locationName: "item22694",
    locationAddress: "item22694",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 0.89 },
    ],
    lat: 51.024728613842974,
    lng: -5.129295315072573,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4694",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " A woman runs towards the road lazily.",
  },
  {
    locationId: "item22695",
    locationName: "item22695",
    locationAddress: "item22695",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 60.28585971691199,
    lng: -2.124171723822325,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4695",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the cake angrily. The cat eats the road lazily. The student looks at the road happily. The student runs towards the horizon lazily. A dog jumps over the horizon lazily.",
  },
  {
    locationId: "item22696",
    locationName: "item22696",
    locationAddress: "item22696",
    ratings: null,
    lat: 57.63365972832233,
    lng: 0.6633165512076342,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4696",
    tags: [],
    locationDescription: " The cat writes the road silently.",
  },
  {
    locationId: "item22697",
    locationName: "item22697",
    locationAddress: "item22697",
    ratings: null,
    lat: 56.24969478265641,
    lng: 1.4161044153220814,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4697",
    tags: [],
    locationDescription:
      " The cat builds a book happily. The cat jumps over a book happily. A woman writes a tower angrily.",
  },
  {
    locationId: "item22698",
    locationName: "item22698",
    locationAddress: "item22698",
    ratings: [
      { who: "Similar identities", rating: 1.85 },
      { who: "All perspectives", rating: 2.08 },
    ],
    lat: 52.586613581336614,
    lng: -6.71087631794505,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4698",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards the cake lazily. A dog jumps over the cake lazily. The student builds a tower lazily. The man writes a book happily.",
  },
  {
    locationId: "item22699",
    locationName: "item22699",
    locationAddress: "item22699",
    ratings: [
      { who: "Similar identities", rating: 1.13 },
      { who: "All perspectives", rating: 1.47 },
    ],
    lat: 53.18443192450776,
    lng: -7.324509151930611,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4699",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a book angrily. The student writes a book happily. The student looks at a fence quickly.",
  },
  {
    locationId: "item22700",
    locationName: "item22700",
    locationAddress: "item22700",
    ratings: null,
    lat: 54.075329887003996,
    lng: -5.083635489388289,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4700",
    tags: [],
    locationDescription:
      " The cat looks at a tower lazily. A woman eats the road happily. A dog eats the cake lazily.",
  },
  {
    locationId: "item22701",
    locationName: "item22701",
    locationAddress: "item22701",
    ratings: null,
    lat: 55.81537180299046,
    lng: 0.8805816566998477,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4701",
    tags: [],
    locationDescription: " A dog runs towards the cake quickly.",
  },
  {
    locationId: "item22702",
    locationName: "item22702",
    locationAddress: "item22702",
    ratings: [
      { who: "Similar identities", rating: 4.08 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 50.31724402250496,
    lng: -8.299632169901596,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4702",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat jumps over the road happily. The cat looks at the road gracefully. The student jumps over a tower lazily. The student writes a book quickly.",
  },
  {
    locationId: "item22703",
    locationName: "item22703",
    locationAddress: "item22703",
    ratings: null,
    lat: 57.40609652481071,
    lng: 1.5364393649423853,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4703",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon quickly. The cat builds a book silently. The teacher jumps over the cake angrily.",
  },
  {
    locationId: "item22704",
    locationName: "item22704",
    locationAddress: "item22704",
    ratings: null,
    lat: 54.03742124046447,
    lng: -3.905811314540653,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4704",
    tags: [],
    locationDescription: " The student eats a tower quickly.",
  },
  {
    locationId: "item22705",
    locationName: "item22705",
    locationAddress: "item22705",
    ratings: null,
    lat: 59.672113366041785,
    lng: -2.8386850523923988,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4705",
    tags: [],
    locationDescription:
      " The cat looks at a tower lazily. The man jumps over the cake angrily. The cat jumps over the horizon happily. The cat eats the horizon happily.",
  },
  {
    locationId: "item22706",
    locationName: "item22706",
    locationAddress: "item22706",
    ratings: null,
    lat: 53.64695985879525,
    lng: -3.7805983127374327,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4706",
    tags: [],
    locationDescription:
      " The man eats the cake happily. The cat runs towards a fence gracefully. The student builds a book quickly. A woman looks at a book quickly. The man builds the cake gracefully.",
  },
  {
    locationId: "item22707",
    locationName: "item22707",
    locationAddress: "item22707",
    ratings: null,
    lat: 57.36167145948352,
    lng: -5.556607935228875,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4707",
    tags: [],
    locationDescription:
      " The man jumps over the cake lazily. A dog looks at the road gracefully. The student looks at the horizon quickly. A woman looks at a fence quickly. The teacher jumps over the horizon happily.",
  },
  {
    locationId: "item22708",
    locationName: "item22708",
    locationAddress: "item22708",
    ratings: [
      { who: "Similar identities", rating: 4.44 },
      { who: "All perspectives", rating: 3.08 },
    ],
    lat: 51.53946853990847,
    lng: -6.76844677319056,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4708",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over the cake silently. The man eats a tower angrily. The student runs towards the cake happily. A woman looks at the road angrily. A dog writes the road happily.",
  },
  {
    locationId: "item22709",
    locationName: "item22709",
    locationAddress: "item22709",
    ratings: [
      { who: "Similar identities", rating: 0.69 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 56.54725605718538,
    lng: -6.826589824008455,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4709",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A dog eats the horizon gracefully.",
  },
  {
    locationId: "item22710",
    locationName: "item22710",
    locationAddress: "item22710",
    ratings: null,
    lat: 51.40255219926564,
    lng: -4.3543269781726535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4710",
    tags: [],
    locationDescription: " The teacher writes a fence lazily.",
  },
  {
    locationId: "item22711",
    locationName: "item22711",
    locationAddress: "item22711",
    ratings: [
      { who: "Similar identities", rating: 3.77 },
      { who: "All perspectives", rating: 3.81 },
    ],
    lat: 60.5828504814463,
    lng: -8.497625391186288,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4711",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student looks at the cake gracefully. The teacher eats a fence gracefully. The cat jumps over the road angrily.",
  },
  {
    locationId: "item22712",
    locationName: "item22712",
    locationAddress: "item22712",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 0.42 },
    ],
    lat: 59.85696897054148,
    lng: -5.346897853205668,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4712",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat builds a fence quickly. The cat writes a tower happily. The teacher looks at a tower angrily. The cat jumps over a book quickly.",
  },
  {
    locationId: "item22713",
    locationName: "item22713",
    locationAddress: "item22713",
    ratings: [
      { who: "Similar identities", rating: 3.82 },
      { who: "All perspectives", rating: 4.44 },
    ],
    lat: 59.40631079961295,
    lng: -0.5995573929730593,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4713",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man runs towards the cake lazily.",
  },
  {
    locationId: "item22714",
    locationName: "item22714",
    locationAddress: "item22714",
    ratings: null,
    lat: 55.90633467909322,
    lng: -7.469871643298375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4714",
    tags: [],
    locationDescription: " A woman builds the horizon gracefully.",
  },
  {
    locationId: "item22715",
    locationName: "item22715",
    locationAddress: "item22715",
    ratings: null,
    lat: 59.60441159738297,
    lng: -4.312239176893345,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4715",
    tags: [],
    locationDescription:
      " The cat eats a fence silently. A woman looks at a tower silently. A dog writes a book gracefully. The man writes the road happily. The student writes a tower lazily.",
  },
  {
    locationId: "item22716",
    locationName: "item22716",
    locationAddress: "item22716",
    ratings: [
      { who: "Similar identities", rating: 4.32 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 53.40764438865595,
    lng: -2.61571889450435,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4716",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher eats a fence gracefully. The cat runs towards a fence lazily. The teacher runs towards the cake quickly.",
  },
  {
    locationId: "item22717",
    locationName: "item22717",
    locationAddress: "item22717",
    ratings: [
      { who: "Similar identities", rating: 2.1 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 50.83021173161738,
    lng: -7.996823597106611,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4717",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog writes a fence gracefully. The cat looks at a tower happily. The man looks at the horizon quickly. The teacher eats the horizon lazily. The student eats the cake lazily.",
  },
  {
    locationId: "item22718",
    locationName: "item22718",
    locationAddress: "item22718",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 3.16 },
    ],
    lat: 50.832244025442236,
    lng: -0.13115075881258598,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4718",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over a book happily. The teacher runs towards the cake lazily. The man looks at a tower silently. The teacher eats a book silently. The student builds a fence lazily.",
  },
  {
    locationId: "item22719",
    locationName: "item22719",
    locationAddress: "item22719",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 49.911847266374885,
    lng: -2.405088009933091,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4719",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes a tower gracefully. A woman looks at the cake angrily. The man jumps over a book happily. A dog eats the cake quickly.",
  },
  {
    locationId: "item22720",
    locationName: "item22720",
    locationAddress: "item22720",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 3.03 },
    ],
    lat: 53.13419661063873,
    lng: -1.6111594001883756,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4720",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman looks at a book happily. A dog builds a book lazily.",
  },
  {
    locationId: "item22721",
    locationName: "item22721",
    locationAddress: "item22721",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 1.32 },
    ],
    lat: 55.11207892461982,
    lng: 1.7895282637586707,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4721",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The man jumps over a book quickly. A dog eats the cake happily. A woman runs towards the road silently.",
  },
  {
    locationId: "item22722",
    locationName: "item22722",
    locationAddress: "item22722",
    ratings: [
      { who: "Similar identities", rating: 0.2 },
      { who: "All perspectives", rating: 4.64 },
    ],
    lat: 51.52697586518158,
    lng: -4.223768305753918,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4722",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog jumps over a fence happily. The student jumps over a tower gracefully.",
  },
  {
    locationId: "item22723",
    locationName: "item22723",
    locationAddress: "item22723",
    ratings: null,
    lat: 51.33167707113723,
    lng: -1.105832068833008,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4723",
    tags: [],
    locationDescription:
      " The student eats a tower gracefully. The cat builds the road quickly. The student builds the road lazily.",
  },
  {
    locationId: "item22724",
    locationName: "item22724",
    locationAddress: "item22724",
    ratings: null,
    lat: 56.13309860357322,
    lng: -2.8319886393649263,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4724",
    tags: [],
    locationDescription:
      " The student looks at a fence lazily. A dog runs towards the horizon angrily. The cat builds a tower silently. The teacher writes a tower angrily. The student writes a tower angrily.",
  },
  {
    locationId: "item22725",
    locationName: "item22725",
    locationAddress: "item22725",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 55.036314282916805,
    lng: -5.117717386952389,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4725",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards a tower angrily. The cat writes a fence angrily. A dog runs towards the horizon silently. The student builds the horizon angrily.",
  },
  {
    locationId: "item22726",
    locationName: "item22726",
    locationAddress: "item22726",
    ratings: null,
    lat: 55.989049363343845,
    lng: 1.2061220046082557,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4726",
    tags: [],
    locationDescription: " The student eats a book happily.",
  },
  {
    locationId: "item22727",
    locationName: "item22727",
    locationAddress: "item22727",
    ratings: [
      { who: "Similar identities", rating: 4.07 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 58.744719641390645,
    lng: -3.572631001371792,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4727",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man looks at a fence lazily. The student jumps over a fence silently. The man eats the horizon angrily. The cat eats the road happily. The man runs towards a fence silently.",
  },
  {
    locationId: "item22728",
    locationName: "item22728",
    locationAddress: "item22728",
    ratings: [
      { who: "Similar identities", rating: 1.77 },
      { who: "All perspectives", rating: 4.41 },
    ],
    lat: 54.19922235015654,
    lng: -5.1086150862623105,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4728",
    tags: [{ label: "accessible" }],
    locationDescription: " A dog eats the horizon happily.",
  },
  {
    locationId: "item22729",
    locationName: "item22729",
    locationAddress: "item22729",
    ratings: null,
    lat: 52.089326818602274,
    lng: -7.416818550715013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4729",
    tags: [],
    locationDescription:
      " A woman writes the horizon quickly. The teacher jumps over a fence angrily. A dog runs towards a book silently. The student eats a book gracefully.",
  },
  {
    locationId: "item22730",
    locationName: "item22730",
    locationAddress: "item22730",
    ratings: null,
    lat: 54.48257410345371,
    lng: 0.21501650478278655,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4730",
    tags: [],
    locationDescription:
      " The man builds a tower silently. The cat eats the road angrily. The teacher builds the cake gracefully. A woman builds a fence quickly. The cat eats the road lazily.",
  },
  {
    locationId: "item22731",
    locationName: "item22731",
    locationAddress: "item22731",
    ratings: null,
    lat: 58.95918259535869,
    lng: -6.685165458136363,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4731",
    tags: [],
    locationDescription:
      " A dog eats a tower silently. The student runs towards the cake happily.",
  },
  {
    locationId: "item22732",
    locationName: "item22732",
    locationAddress: "item22732",
    ratings: [
      { who: "Similar identities", rating: 1.85 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 60.504474244854194,
    lng: -6.809068891594694,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4732",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes a fence lazily. The cat looks at a tower happily. The man runs towards a fence lazily. The cat eats a tower quickly.",
  },
  {
    locationId: "item22733",
    locationName: "item22733",
    locationAddress: "item22733",
    ratings: null,
    lat: 55.26651213084068,
    lng: 1.5039073933627964,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4733",
    tags: [],
    locationDescription:
      " The cat builds a book happily. A woman builds a book silently. A woman writes a fence silently. A dog writes a fence happily.",
  },
  {
    locationId: "item22734",
    locationName: "item22734",
    locationAddress: "item22734",
    ratings: [
      { who: "Similar identities", rating: 2.31 },
      { who: "All perspectives", rating: 1.4 },
    ],
    lat: 51.227966779471956,
    lng: -8.230237602420232,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4734",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A dog eats a tower gracefully. A woman writes a fence lazily. The man jumps over the horizon angrily. A dog builds the cake silently. A dog writes a book lazily.",
  },
  {
    locationId: "item22735",
    locationName: "item22735",
    locationAddress: "item22735",
    ratings: null,
    lat: 59.50746120314097,
    lng: -3.2663923082944875,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4735",
    tags: [],
    locationDescription:
      " The student builds the road happily. The cat eats a book silently. The man jumps over the road lazily.",
  },
  {
    locationId: "item22736",
    locationName: "item22736",
    locationAddress: "item22736",
    ratings: [
      { who: "Similar identities", rating: 4.99 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 58.74117914411473,
    lng: -6.905448023097761,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4736",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog builds the horizon quickly. The man runs towards the cake quickly. The man writes the road gracefully. The man looks at a book lazily.",
  },
  {
    locationId: "item22737",
    locationName: "item22737",
    locationAddress: "item22737",
    ratings: [
      { who: "Similar identities", rating: 2.99 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 50.17355839179411,
    lng: -5.484207483582551,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4737",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at a fence silently. The teacher writes the cake silently. The cat runs towards a fence quickly.",
  },
  {
    locationId: "item22738",
    locationName: "item22738",
    locationAddress: "item22738",
    ratings: [
      { who: "Similar identities", rating: 0.12 },
      { who: "All perspectives", rating: 4.1 },
    ],
    lat: 55.22474778798026,
    lng: 0.334533130074508,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4738",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman jumps over the horizon lazily. The man builds the cake silently. The student writes a tower gracefully.",
  },
  {
    locationId: "item22739",
    locationName: "item22739",
    locationAddress: "item22739",
    ratings: [
      { who: "Similar identities", rating: 0.54 },
      { who: "All perspectives", rating: 0.99 },
    ],
    lat: 59.03986610011679,
    lng: -1.3493462405290853,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4739",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over a fence gracefully. The teacher runs towards a book happily.",
  },
  {
    locationId: "item22740",
    locationName: "item22740",
    locationAddress: "item22740",
    ratings: [
      { who: "Similar identities", rating: 3.54 },
      { who: "All perspectives", rating: 1.27 },
    ],
    lat: 50.8614277256065,
    lng: -8.379693328573634,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4740",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a tower gracefully. A woman builds a book happily. The teacher runs towards the horizon quickly. A woman eats the road lazily.",
  },
  {
    locationId: "item22741",
    locationName: "item22741",
    locationAddress: "item22741",
    ratings: null,
    lat: 52.64191621688675,
    lng: 0.7240982641499034,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4741",
    tags: [],
    locationDescription:
      " The student runs towards a tower angrily. The student writes a tower happily.",
  },
  {
    locationId: "item22742",
    locationName: "item22742",
    locationAddress: "item22742",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 1.2 },
    ],
    lat: 60.07197873483574,
    lng: -4.610807593404978,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4742",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards the cake quickly. A woman runs towards a tower gracefully. The cat runs towards the road happily. A dog jumps over the cake gracefully. A dog runs towards the horizon angrily.",
  },
  {
    locationId: "item22743",
    locationName: "item22743",
    locationAddress: "item22743",
    ratings: null,
    lat: 58.018313149654524,
    lng: -6.405456062330746,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4743",
    tags: [],
    locationDescription:
      " The man looks at the road silently. The teacher builds the road lazily. The student jumps over a book angrily. A dog eats a book silently.",
  },
  {
    locationId: "item22744",
    locationName: "item22744",
    locationAddress: "item22744",
    ratings: [
      { who: "Similar identities", rating: 1.54 },
      { who: "All perspectives", rating: 1.65 },
    ],
    lat: 58.103708565525736,
    lng: -2.1284288620063503,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4744",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog looks at a tower angrily. The man runs towards the cake silently. A dog eats a fence angrily. The man jumps over the road silently.",
  },
  {
    locationId: "item22745",
    locationName: "item22745",
    locationAddress: "item22745",
    ratings: null,
    lat: 55.79740725037264,
    lng: -6.57040650427988,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4745",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon lazily. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item22746",
    locationName: "item22746",
    locationAddress: "item22746",
    ratings: [
      { who: "Similar identities", rating: 2.13 },
      { who: "All perspectives", rating: 3.12 },
    ],
    lat: 58.97338234522253,
    lng: -4.6539236463044364,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4746",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at the road lazily. A woman eats the cake gracefully. A dog writes the cake quickly. The man looks at a book lazily. The teacher writes the road gracefully.",
  },
  {
    locationId: "item22747",
    locationName: "item22747",
    locationAddress: "item22747",
    ratings: null,
    lat: 54.363427576694036,
    lng: -6.114383737225641,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4747",
    tags: [],
    locationDescription: " A dog looks at the horizon quickly.",
  },
  {
    locationId: "item22748",
    locationName: "item22748",
    locationAddress: "item22748",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 2.03 },
    ],
    lat: 50.09448375481317,
    lng: -0.6006523444640655,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4748",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman eats a book angrily. The man runs towards a tower gracefully. A woman writes the cake angrily.",
  },
  {
    locationId: "item22749",
    locationName: "item22749",
    locationAddress: "item22749",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 2.5 },
    ],
    lat: 52.28330525425662,
    lng: 0.692934486054245,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4749",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog looks at the cake happily.",
  },
  {
    locationId: "item22750",
    locationName: "item22750",
    locationAddress: "item22750",
    ratings: [
      { who: "Similar identities", rating: 2.82 },
      { who: "All perspectives", rating: 1.59 },
    ],
    lat: 58.72841165102915,
    lng: -5.2488256463289655,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4750",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " The cat eats the road gracefully.",
  },
  {
    locationId: "item22751",
    locationName: "item22751",
    locationAddress: "item22751",
    ratings: null,
    lat: 57.11429935437067,
    lng: -7.1236112489344885,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4751",
    tags: [],
    locationDescription: " A woman builds the cake lazily.",
  },
  {
    locationId: "item22752",
    locationName: "item22752",
    locationAddress: "item22752",
    ratings: [
      { who: "Similar identities", rating: 0.68 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 51.85818633814898,
    lng: -4.085074835875314,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4752",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat looks at the road lazily. The student jumps over a fence angrily. The teacher runs towards the cake quickly. The cat runs towards the horizon gracefully.",
  },
  {
    locationId: "item22753",
    locationName: "item22753",
    locationAddress: "item22753",
    ratings: [
      { who: "Similar identities", rating: 0.43 },
      { who: "All perspectives", rating: 1.69 },
    ],
    lat: 60.35476502606255,
    lng: -2.207365693477196,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4753",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman eats the road happily. The cat runs towards a tower quickly. The cat eats a tower happily. The man looks at a fence silently. The student builds a fence happily.",
  },
  {
    locationId: "item22754",
    locationName: "item22754",
    locationAddress: "item22754",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 52.761885090453085,
    lng: -1.2218219991881893,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4754",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student runs towards a book happily. The teacher jumps over the horizon lazily.",
  },
  {
    locationId: "item22755",
    locationName: "item22755",
    locationAddress: "item22755",
    ratings: [
      { who: "Similar identities", rating: 4.35 },
      { who: "All perspectives", rating: 0.67 },
    ],
    lat: 59.661565320404,
    lng: -7.227470075361102,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4755",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog looks at the horizon happily.",
  },
  {
    locationId: "item22756",
    locationName: "item22756",
    locationAddress: "item22756",
    ratings: null,
    lat: 55.45426968094882,
    lng: 0.6399950596601212,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4756",
    tags: [],
    locationDescription:
      " A dog writes the cake angrily. A woman jumps over a book quickly.",
  },
  {
    locationId: "item22757",
    locationName: "item22757",
    locationAddress: "item22757",
    ratings: null,
    lat: 50.89264914567375,
    lng: -1.6463333542889806,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4757",
    tags: [],
    locationDescription: " A woman runs towards a tower silently.",
  },
  {
    locationId: "item22758",
    locationName: "item22758",
    locationAddress: "item22758",
    ratings: [
      { who: "Similar identities", rating: 0.56 },
      { who: "All perspectives", rating: 2.51 },
    ],
    lat: 55.06368583189462,
    lng: -5.5633118933569286,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4758",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man writes a book silently.",
  },
  {
    locationId: "item22759",
    locationName: "item22759",
    locationAddress: "item22759",
    ratings: null,
    lat: 53.6822538851501,
    lng: 1.131355679320512,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4759",
    tags: [],
    locationDescription: " The cat runs towards a tower silently.",
  },
  {
    locationId: "item22760",
    locationName: "item22760",
    locationAddress: "item22760",
    ratings: null,
    lat: 57.90200772233476,
    lng: -6.723839772889585,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4760",
    tags: [],
    locationDescription:
      " A woman runs towards the cake angrily. A woman looks at the horizon angrily. A woman writes a tower quickly. A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item22761",
    locationName: "item22761",
    locationAddress: "item22761",
    ratings: null,
    lat: 59.58969368018459,
    lng: -5.198198951563128,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4761",
    tags: [],
    locationDescription: " A woman runs towards a tower silently.",
  },
  {
    locationId: "item22762",
    locationName: "item22762",
    locationAddress: "item22762",
    ratings: null,
    lat: 58.13166256338373,
    lng: -1.1123793211742399,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4762",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon angrily. The student jumps over the horizon lazily. The student looks at a fence lazily.",
  },
  {
    locationId: "item22763",
    locationName: "item22763",
    locationAddress: "item22763",
    ratings: [
      { who: "Similar identities", rating: 1.71 },
      { who: "All perspectives", rating: 2.24 },
    ],
    lat: 59.474481878144985,
    lng: -3.2923638136898665,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4763",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman writes the cake happily. The teacher jumps over a tower silently. The student looks at the road quickly. The man writes a tower gracefully. The teacher eats the cake gracefully.",
  },
  {
    locationId: "item22764",
    locationName: "item22764",
    locationAddress: "item22764",
    ratings: [
      { who: "Similar identities", rating: 2.31 },
      { who: "All perspectives", rating: 4.33 },
    ],
    lat: 56.13022393946782,
    lng: -4.142428803807232,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4764",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat runs towards a book gracefully. The student eats a tower lazily.",
  },
  {
    locationId: "item22765",
    locationName: "item22765",
    locationAddress: "item22765",
    ratings: [
      { who: "Similar identities", rating: 3.63 },
      { who: "All perspectives", rating: 1.84 },
    ],
    lat: 58.540013316027355,
    lng: -3.067926654524454,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4765",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes a tower silently. A woman runs towards the road lazily.",
  },
  {
    locationId: "item22766",
    locationName: "item22766",
    locationAddress: "item22766",
    ratings: [
      { who: "Similar identities", rating: 4.95 },
      { who: "All perspectives", rating: 1.95 },
    ],
    lat: 59.687743871334796,
    lng: -4.629232393455528,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4766",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards a tower angrily. A dog eats a fence angrily. A dog runs towards the road lazily.",
  },
  {
    locationId: "item22767",
    locationName: "item22767",
    locationAddress: "item22767",
    ratings: null,
    lat: 52.59932455463381,
    lng: -4.817353489305816,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4767",
    tags: [],
    locationDescription: " A dog writes the road silently.",
  },
  {
    locationId: "item22768",
    locationName: "item22768",
    locationAddress: "item22768",
    ratings: [
      { who: "Similar identities", rating: 3.37 },
      { who: "All perspectives", rating: 3.8 },
    ],
    lat: 50.639716870572826,
    lng: -6.028394924515508,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4768",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman writes the cake gracefully. A dog builds a fence happily. The teacher looks at a book quickly. A woman looks at a fence quickly.",
  },
  {
    locationId: "item22769",
    locationName: "item22769",
    locationAddress: "item22769",
    ratings: null,
    lat: 59.53456349594549,
    lng: -2.2282169399885996,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4769",
    tags: [],
    locationDescription:
      " A dog looks at a book angrily. The cat jumps over the cake silently. The cat looks at the road angrily. The teacher writes the horizon happily.",
  },
  {
    locationId: "item22770",
    locationName: "item22770",
    locationAddress: "item22770",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 0.27 },
    ],
    lat: 51.51988369924753,
    lng: -7.427097103899161,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4770",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog eats the horizon quickly. A dog builds a tower quickly. The student jumps over the road lazily. The cat builds the road happily. The teacher runs towards the horizon silently.",
  },
  {
    locationId: "item22771",
    locationName: "item22771",
    locationAddress: "item22771",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 0.59 },
    ],
    lat: 50.05434023805908,
    lng: 0.12155598181061045,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4771",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student writes a tower happily. A woman eats a fence lazily. A dog runs towards a fence gracefully.",
  },
  {
    locationId: "item22772",
    locationName: "item22772",
    locationAddress: "item22772",
    ratings: null,
    lat: 54.26342624903729,
    lng: -1.3899902583909878,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4772",
    tags: [],
    locationDescription: " The cat looks at the road angrily.",
  },
  {
    locationId: "item22773",
    locationName: "item22773",
    locationAddress: "item22773",
    ratings: null,
    lat: 55.58597685632497,
    lng: -6.882617784312507,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4773",
    tags: [],
    locationDescription:
      " The student eats the cake happily. The teacher runs towards the road gracefully. The teacher eats a book gracefully.",
  },
  {
    locationId: "item22774",
    locationName: "item22774",
    locationAddress: "item22774",
    ratings: null,
    lat: 50.65742425926627,
    lng: -8.579041550105963,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4774",
    tags: [],
    locationDescription:
      " The student eats the cake quickly. The man writes the road happily. The student jumps over a fence silently. The teacher looks at a tower angrily. A dog looks at a fence happily.",
  },
  {
    locationId: "item22775",
    locationName: "item22775",
    locationAddress: "item22775",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 54.21908026744099,
    lng: -3.815857396777112,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4775",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher runs towards a tower angrily. The man runs towards the cake gracefully. A dog looks at a tower silently. The cat jumps over the road silently.",
  },
  {
    locationId: "item22776",
    locationName: "item22776",
    locationAddress: "item22776",
    ratings: [
      { who: "Similar identities", rating: 0.58 },
      { who: "All perspectives", rating: 2.01 },
    ],
    lat: 60.56499787301142,
    lng: -4.032143449613308,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4776",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student writes a book silently. A woman runs towards the road silently.",
  },
  {
    locationId: "item22777",
    locationName: "item22777",
    locationAddress: "item22777",
    ratings: [
      { who: "Similar identities", rating: 0.44 },
      { who: "All perspectives", rating: 4.99 },
    ],
    lat: 60.25951327581455,
    lng: -8.506240718838638,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4777",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog runs towards the cake angrily. The man runs towards a book gracefully. The student jumps over the horizon lazily. A woman writes a tower happily.",
  },
  {
    locationId: "item22778",
    locationName: "item22778",
    locationAddress: "item22778",
    ratings: null,
    lat: 58.57419464927092,
    lng: -3.4559624998314202,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4778",
    tags: [],
    locationDescription:
      " A woman writes a book gracefully. A woman looks at the road silently.",
  },
  {
    locationId: "item22779",
    locationName: "item22779",
    locationAddress: "item22779",
    ratings: [
      { who: "Similar identities", rating: 1.46 },
      { who: "All perspectives", rating: 3.06 },
    ],
    lat: 53.885356753020154,
    lng: -4.828166571917972,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4779",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student looks at the cake angrily. The teacher eats a book angrily.",
  },
  {
    locationId: "item22780",
    locationName: "item22780",
    locationAddress: "item22780",
    ratings: null,
    lat: 58.01757730113431,
    lng: -2.981625676360986,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4780",
    tags: [],
    locationDescription:
      " The teacher builds the cake lazily. A woman builds the cake happily. The man looks at the horizon lazily. The man looks at the cake lazily.",
  },
  {
    locationId: "item22781",
    locationName: "item22781",
    locationAddress: "item22781",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 1.55 },
    ],
    lat: 59.935178534026186,
    lng: -5.818552268561952,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4781",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat eats a book quickly. The student looks at a tower lazily. The teacher looks at a book silently. The man eats the cake gracefully. The man jumps over a fence lazily.",
  },
  {
    locationId: "item22782",
    locationName: "item22782",
    locationAddress: "item22782",
    ratings: null,
    lat: 58.351763138910556,
    lng: -1.5125954553397483,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4782",
    tags: [],
    locationDescription:
      " The student runs towards the horizon lazily. A dog builds a book quickly. A woman runs towards the horizon happily. A dog eats the cake happily. The man looks at a book happily.",
  },
  {
    locationId: "item22783",
    locationName: "item22783",
    locationAddress: "item22783",
    ratings: null,
    lat: 55.133055295869575,
    lng: -5.134568836303439,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4783",
    tags: [],
    locationDescription:
      " The man eats the road silently. The teacher looks at the cake angrily. The man jumps over the horizon quickly. The man eats the road happily.",
  },
  {
    locationId: "item22784",
    locationName: "item22784",
    locationAddress: "item22784",
    ratings: [
      { who: "Similar identities", rating: 3.03 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 51.03001356061655,
    lng: -5.002922400000919,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4784",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman writes the horizon gracefully. The student runs towards a book gracefully.",
  },
  {
    locationId: "item22785",
    locationName: "item22785",
    locationAddress: "item22785",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 4.09 },
    ],
    lat: 57.09074460303721,
    lng: -8.2221226844519,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4785",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog runs towards a tower gracefully. The man eats the cake angrily. A woman runs towards a book happily. A woman writes a fence gracefully.",
  },
  {
    locationId: "item22786",
    locationName: "item22786",
    locationAddress: "item22786",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 1.67 },
    ],
    lat: 54.54481890194564,
    lng: -3.6728068150478927,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4786",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The student runs towards the road quickly.",
  },
  {
    locationId: "item22787",
    locationName: "item22787",
    locationAddress: "item22787",
    ratings: [
      { who: "Similar identities", rating: 3.38 },
      { who: "All perspectives", rating: 1.85 },
    ],
    lat: 55.394985854261236,
    lng: -4.299988734310532,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4787",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat eats the road quickly.",
  },
  {
    locationId: "item22788",
    locationName: "item22788",
    locationAddress: "item22788",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 2.2 },
    ],
    lat: 53.1068913559249,
    lng: -6.380232449517878,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4788",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman jumps over a fence quickly.",
  },
  {
    locationId: "item22789",
    locationName: "item22789",
    locationAddress: "item22789",
    ratings: null,
    lat: 51.17418957559321,
    lng: -4.411932719348778,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4789",
    tags: [],
    locationDescription: " A dog looks at a tower gracefully.",
  },
  {
    locationId: "item22790",
    locationName: "item22790",
    locationAddress: "item22790",
    ratings: [
      { who: "Similar identities", rating: 0.79 },
      { who: "All perspectives", rating: 4.07 },
    ],
    lat: 49.939174971423604,
    lng: -7.28767390290256,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4790",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student jumps over a book silently. A dog jumps over a tower silently. The student runs towards a fence quickly. The teacher writes the cake lazily. The man runs towards a tower gracefully.",
  },
  {
    locationId: "item22791",
    locationName: "item22791",
    locationAddress: "item22791",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 3.23 },
    ],
    lat: 60.16547743920117,
    lng: -6.0391279071731745,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4791",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher writes a book silently. The cat runs towards the horizon happily.",
  },
  {
    locationId: "item22792",
    locationName: "item22792",
    locationAddress: "item22792",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 2.46 },
    ],
    lat: 57.568070773614664,
    lng: -3.1847761039825286,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4792",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats the horizon angrily. The teacher eats a book angrily.",
  },
  {
    locationId: "item22793",
    locationName: "item22793",
    locationAddress: "item22793",
    ratings: null,
    lat: 56.1448344894826,
    lng: -0.4620875089488763,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4793",
    tags: [],
    locationDescription:
      " The teacher writes the horizon gracefully. The man jumps over a tower gracefully. The teacher jumps over the horizon lazily.",
  },
  {
    locationId: "item22794",
    locationName: "item22794",
    locationAddress: "item22794",
    ratings: null,
    lat: 60.125528338351224,
    lng: -2.863848682435658,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4794",
    tags: [],
    locationDescription:
      " The man jumps over a tower angrily. A dog writes the road lazily. A woman eats a tower angrily.",
  },
  {
    locationId: "item22795",
    locationName: "item22795",
    locationAddress: "item22795",
    ratings: [
      { who: "Similar identities", rating: 2.01 },
      { who: "All perspectives", rating: 2.25 },
    ],
    lat: 57.23616868564091,
    lng: -0.10996891026309719,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4795",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student writes a fence quickly. The teacher writes the cake lazily. The cat builds a book angrily. The teacher jumps over a fence happily. The teacher builds the cake silently.",
  },
  {
    locationId: "item22796",
    locationName: "item22796",
    locationAddress: "item22796",
    ratings: null,
    lat: 60.093415045039116,
    lng: -1.140271186626462,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4796",
    tags: [],
    locationDescription:
      " A dog builds a fence gracefully. A woman eats a book quickly. A dog eats a book quickly.",
  },
  {
    locationId: "item22797",
    locationName: "item22797",
    locationAddress: "item22797",
    ratings: null,
    lat: 53.69703564455931,
    lng: -2.0371090437029054,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4797",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence angrily. The man jumps over a tower angrily.",
  },
  {
    locationId: "item22798",
    locationName: "item22798",
    locationAddress: "item22798",
    ratings: null,
    lat: 53.30667133960657,
    lng: -4.541440655368247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4798",
    tags: [],
    locationDescription:
      " The man eats a fence gracefully. A woman eats a book lazily. The man writes a book lazily.",
  },
  {
    locationId: "item22799",
    locationName: "item22799",
    locationAddress: "item22799",
    ratings: null,
    lat: 51.39923842622207,
    lng: 0.43960341477379217,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4799",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower angrily. The man jumps over the horizon angrily.",
  },
  {
    locationId: "item22800",
    locationName: "item22800",
    locationAddress: "item22800",
    ratings: [
      { who: "Similar identities", rating: 4.03 },
      { who: "All perspectives", rating: 4.44 },
    ],
    lat: 52.393173271043835,
    lng: -1.4269742176742533,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4800",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man runs towards the cake quickly. The student looks at the cake happily.",
  },
  {
    locationId: "item22801",
    locationName: "item22801",
    locationAddress: "item22801",
    ratings: [
      { who: "Similar identities", rating: 0.48 },
      { who: "All perspectives", rating: 3.41 },
    ],
    lat: 53.613797060954944,
    lng: -2.4988560338516415,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4801",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " A dog eats the road happily. A dog writes the cake gracefully.",
  },
  {
    locationId: "item22802",
    locationName: "item22802",
    locationAddress: "item22802",
    ratings: [
      { who: "Similar identities", rating: 3.06 },
      { who: "All perspectives", rating: 2.81 },
    ],
    lat: 58.38306907105552,
    lng: -5.139880186843953,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4802",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at the cake angrily. The student builds a tower quickly. A dog writes a book angrily. The man builds the road angrily. A woman jumps over a fence lazily.",
  },
  {
    locationId: "item22803",
    locationName: "item22803",
    locationAddress: "item22803",
    ratings: [
      { who: "Similar identities", rating: 0.0 },
      { who: "All perspectives", rating: 4.2 },
    ],
    lat: 51.59476895698188,
    lng: 1.4582540983750967,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4803",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The student jumps over a tower happily.",
  },
  {
    locationId: "item22804",
    locationName: "item22804",
    locationAddress: "item22804",
    ratings: [
      { who: "Similar identities", rating: 3.87 },
      { who: "All perspectives", rating: 0.72 },
    ],
    lat: 60.66683947910148,
    lng: 0.034768142221654585,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4804",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog builds a tower silently. The teacher jumps over a tower lazily. The student jumps over a fence gracefully.",
  },
  {
    locationId: "item22805",
    locationName: "item22805",
    locationAddress: "item22805",
    ratings: [
      { who: "Similar identities", rating: 2.52 },
      { who: "All perspectives", rating: 2.06 },
    ],
    lat: 52.390492047990854,
    lng: -1.8607668318157593,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4805",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman eats a tower happily.",
  },
  {
    locationId: "item22806",
    locationName: "item22806",
    locationAddress: "item22806",
    ratings: null,
    lat: 53.21455990534979,
    lng: -4.841130203048106,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4806",
    tags: [],
    locationDescription:
      " A woman writes the cake lazily. The man looks at a tower quickly. The teacher jumps over the cake lazily.",
  },
  {
    locationId: "item22807",
    locationName: "item22807",
    locationAddress: "item22807",
    ratings: [
      { who: "Similar identities", rating: 0.44 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 52.24143529467709,
    lng: -3.725014689234799,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4807",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The teacher looks at a book lazily.",
  },
  {
    locationId: "item22808",
    locationName: "item22808",
    locationAddress: "item22808",
    ratings: [
      { who: "Similar identities", rating: 4.49 },
      { who: "All perspectives", rating: 2.94 },
    ],
    lat: 58.4733375828695,
    lng: -1.5728410415709568,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4808",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A dog eats the horizon lazily. The student writes a tower silently. The teacher eats the cake angrily. The student writes a fence happily. The teacher looks at a tower silently.",
  },
  {
    locationId: "item22809",
    locationName: "item22809",
    locationAddress: "item22809",
    ratings: null,
    lat: 53.82082996749988,
    lng: -6.644762328592738,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4809",
    tags: [],
    locationDescription:
      " A woman builds a fence silently. The cat runs towards a fence silently. The cat eats a fence gracefully.",
  },
  {
    locationId: "item22810",
    locationName: "item22810",
    locationAddress: "item22810",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 3.31 },
    ],
    lat: 60.39870123025544,
    lng: -6.828305113958886,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4810",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman looks at the cake angrily. The teacher builds a tower happily.",
  },
  {
    locationId: "item22811",
    locationName: "item22811",
    locationAddress: "item22811",
    ratings: [
      { who: "Similar identities", rating: 2.53 },
      { who: "All perspectives", rating: 2.09 },
    ],
    lat: 52.71965800112215,
    lng: -2.968941796031837,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4811",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man builds the cake quickly. The student writes a book silently. The student jumps over the cake gracefully.",
  },
  {
    locationId: "item22812",
    locationName: "item22812",
    locationAddress: "item22812",
    ratings: null,
    lat: 53.928973765001686,
    lng: -2.2693255939139405,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4812",
    tags: [],
    locationDescription:
      " A dog writes the cake quickly. The student looks at the road silently. The cat writes a book gracefully. The man writes the road quickly. The man looks at the horizon lazily.",
  },
  {
    locationId: "item22813",
    locationName: "item22813",
    locationAddress: "item22813",
    ratings: null,
    lat: 56.54549635841896,
    lng: -4.026590065873752,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4813",
    tags: [],
    locationDescription:
      " The man jumps over the road gracefully. The teacher runs towards the cake quickly.",
  },
  {
    locationId: "item22814",
    locationName: "item22814",
    locationAddress: "item22814",
    ratings: null,
    lat: 50.687175222645436,
    lng: -0.17812428629627775,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4814",
    tags: [],
    locationDescription:
      " The man eats a book happily. The teacher writes a fence lazily. A dog writes the cake angrily. A dog jumps over a tower gracefully. A woman builds the road gracefully.",
  },
  {
    locationId: "item22815",
    locationName: "item22815",
    locationAddress: "item22815",
    ratings: null,
    lat: 52.8932041051352,
    lng: 1.501369868228604,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4815",
    tags: [],
    locationDescription: " A dog runs towards a book lazily.",
  },
  {
    locationId: "item22816",
    locationName: "item22816",
    locationAddress: "item22816",
    ratings: [
      { who: "Similar identities", rating: 3.88 },
      { who: "All perspectives", rating: 2.23 },
    ],
    lat: 55.380296550508604,
    lng: -2.088429977894262,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4816",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The teacher writes the road quickly. The student builds a fence angrily. A woman eats a tower angrily.",
  },
  {
    locationId: "item22817",
    locationName: "item22817",
    locationAddress: "item22817",
    ratings: null,
    lat: 54.65310178781977,
    lng: 0.11373859565880551,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4817",
    tags: [],
    locationDescription: " The student writes a fence angrily.",
  },
  {
    locationId: "item22818",
    locationName: "item22818",
    locationAddress: "item22818",
    ratings: null,
    lat: 60.09276867999438,
    lng: -7.080641852539866,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4818",
    tags: [],
    locationDescription: " The teacher writes a fence gracefully.",
  },
  {
    locationId: "item22819",
    locationName: "item22819",
    locationAddress: "item22819",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 4.51 },
    ],
    lat: 54.161552356183336,
    lng: -2.7253070513196196,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4819",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over a tower lazily. The man jumps over a fence happily. The student looks at a tower gracefully.",
  },
  {
    locationId: "item22820",
    locationName: "item22820",
    locationAddress: "item22820",
    ratings: null,
    lat: 60.44102490256438,
    lng: -2.9398169188968497,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4820",
    tags: [],
    locationDescription:
      " The student eats the cake quickly. A dog builds a fence lazily. The teacher looks at a fence quickly. A dog builds the road happily.",
  },
  {
    locationId: "item22821",
    locationName: "item22821",
    locationAddress: "item22821",
    ratings: null,
    lat: 50.94110248923186,
    lng: -4.890571400687004,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4821",
    tags: [],
    locationDescription: " The man looks at the horizon lazily.",
  },
  {
    locationId: "item22822",
    locationName: "item22822",
    locationAddress: "item22822",
    ratings: [
      { who: "Similar identities", rating: 1.11 },
      { who: "All perspectives", rating: 2.09 },
    ],
    lat: 51.366322124306194,
    lng: -1.4516694665287915,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4822",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at a fence silently. The man writes a tower silently. The cat looks at a tower lazily. A woman runs towards a fence happily. A dog looks at the horizon silently.",
  },
  {
    locationId: "item22823",
    locationName: "item22823",
    locationAddress: "item22823",
    ratings: null,
    lat: 55.24998235679929,
    lng: -7.151865976566955,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4823",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon quickly. The teacher runs towards the horizon silently. A dog looks at the horizon quickly.",
  },
  {
    locationId: "item22824",
    locationName: "item22824",
    locationAddress: "item22824",
    ratings: [
      { who: "Similar identities", rating: 1.7 },
      { who: "All perspectives", rating: 2.9 },
    ],
    lat: 55.106452841527826,
    lng: -7.286574920760588,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4824",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher runs towards a tower silently. The man runs towards the road lazily.",
  },
  {
    locationId: "item22825",
    locationName: "item22825",
    locationAddress: "item22825",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 53.088108326304855,
    lng: -4.623853799137395,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4825",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman writes the horizon happily. The man writes the horizon gracefully. The cat runs towards the cake gracefully. The teacher looks at the cake angrily.",
  },
  {
    locationId: "item22826",
    locationName: "item22826",
    locationAddress: "item22826",
    ratings: [
      { who: "Similar identities", rating: 0.29 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 57.133749129812244,
    lng: -2.3259631225579387,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4826",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes the road silently. The teacher writes a fence silently.",
  },
  {
    locationId: "item22827",
    locationName: "item22827",
    locationAddress: "item22827",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 3.85 },
    ],
    lat: 57.4941233309394,
    lng: -4.127572841660904,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4827",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman looks at a fence lazily. A dog looks at the road quickly. The man eats the cake angrily. A woman jumps over a fence lazily.",
  },
  {
    locationId: "item22828",
    locationName: "item22828",
    locationAddress: "item22828",
    ratings: [
      { who: "Similar identities", rating: 0.32 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 56.44706454507753,
    lng: -7.92801888506813,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4828",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes a fence lazily. The student builds a tower happily. A woman looks at the road angrily.",
  },
  {
    locationId: "item22829",
    locationName: "item22829",
    locationAddress: "item22829",
    ratings: [
      { who: "Similar identities", rating: 4.13 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 54.909097211143276,
    lng: -0.03981276023018587,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4829",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher jumps over a fence silently. The man eats a tower gracefully. The teacher eats a tower angrily. The teacher eats a book angrily.",
  },
  {
    locationId: "item22830",
    locationName: "item22830",
    locationAddress: "item22830",
    ratings: [
      { who: "Similar identities", rating: 3.37 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 53.76193711940774,
    lng: -0.9784369210889832,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4830",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The teacher builds a fence quickly.",
  },
  {
    locationId: "item22831",
    locationName: "item22831",
    locationAddress: "item22831",
    ratings: null,
    lat: 55.66041266821003,
    lng: 1.405178281987105,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4831",
    tags: [],
    locationDescription:
      " The cat jumps over the cake silently. The cat eats the horizon angrily. The teacher builds the horizon quickly.",
  },
  {
    locationId: "item22832",
    locationName: "item22832",
    locationAddress: "item22832",
    ratings: null,
    lat: 50.878943376669575,
    lng: -0.14360226254777508,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4832",
    tags: [],
    locationDescription:
      " A woman looks at the horizon gracefully. The teacher builds a fence quickly.",
  },
  {
    locationId: "item22833",
    locationName: "item22833",
    locationAddress: "item22833",
    ratings: null,
    lat: 53.16377716427317,
    lng: -0.39661640173207324,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4833",
    tags: [],
    locationDescription:
      " The cat builds a book happily. The cat eats the horizon angrily. A woman jumps over a book quickly.",
  },
  {
    locationId: "item22834",
    locationName: "item22834",
    locationAddress: "item22834",
    ratings: null,
    lat: 55.52866589928671,
    lng: -0.6750694569059874,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4834",
    tags: [],
    locationDescription: " A dog looks at a book gracefully.",
  },
  {
    locationId: "item22835",
    locationName: "item22835",
    locationAddress: "item22835",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 4.18 },
    ],
    lat: 54.03171171140131,
    lng: -0.9519914167482524,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4835",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog eats the cake lazily. The man eats a book angrily. A dog looks at the horizon silently. A woman eats a tower happily.",
  },
  {
    locationId: "item22836",
    locationName: "item22836",
    locationAddress: "item22836",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 56.26109828875598,
    lng: -3.2342578827938766,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4836",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A woman looks at a book gracefully.",
  },
  {
    locationId: "item22837",
    locationName: "item22837",
    locationAddress: "item22837",
    ratings: null,
    lat: 58.37198367186032,
    lng: -1.5797849658173932,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4837",
    tags: [],
    locationDescription: " The teacher jumps over a fence happily.",
  },
  {
    locationId: "item22838",
    locationName: "item22838",
    locationAddress: "item22838",
    ratings: [
      { who: "Similar identities", rating: 4.69 },
      { who: "All perspectives", rating: 4.62 },
    ],
    lat: 58.66326830907305,
    lng: -0.15940852521066518,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4838",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat runs towards the road silently. The cat eats the cake lazily. The teacher jumps over the cake lazily. The student looks at the horizon gracefully.",
  },
  {
    locationId: "item22839",
    locationName: "item22839",
    locationAddress: "item22839",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 2.39 },
    ],
    lat: 51.27697112238476,
    lng: -1.4909707950571205,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4839",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat writes a book happily. The man writes the road silently.",
  },
  {
    locationId: "item22840",
    locationName: "item22840",
    locationAddress: "item22840",
    ratings: null,
    lat: 54.0264814555859,
    lng: -8.27478384970356,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4840",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence quickly. The student looks at a fence silently. A woman writes the horizon happily.",
  },
  {
    locationId: "item22841",
    locationName: "item22841",
    locationAddress: "item22841",
    ratings: [
      { who: "Similar identities", rating: 1.22 },
      { who: "All perspectives", rating: 1.86 },
    ],
    lat: 55.05701578854935,
    lng: 1.7394713495728595,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4841",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man jumps over the horizon quickly. A dog jumps over a book quickly. A woman eats a tower gracefully. The teacher eats a book angrily. A woman eats the road quickly.",
  },
  {
    locationId: "item22842",
    locationName: "item22842",
    locationAddress: "item22842",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 4.68 },
    ],
    lat: 58.813461216335284,
    lng: -6.767025264381343,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4842",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher builds a book happily. The student eats a fence angrily. The student looks at a fence quickly. A woman runs towards a book silently. A dog eats a fence silently.",
  },
  {
    locationId: "item22843",
    locationName: "item22843",
    locationAddress: "item22843",
    ratings: null,
    lat: 59.90277111047064,
    lng: 0.15994501953169404,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4843",
    tags: [],
    locationDescription:
      " The man builds the road quickly. The student builds a book quickly. A dog eats a book lazily.",
  },
  {
    locationId: "item22844",
    locationName: "item22844",
    locationAddress: "item22844",
    ratings: [
      { who: "Similar identities", rating: 1.58 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 55.371966100622,
    lng: -4.129720455908687,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4844",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards the road angrily. The teacher writes the horizon gracefully.",
  },
  {
    locationId: "item22845",
    locationName: "item22845",
    locationAddress: "item22845",
    ratings: null,
    lat: 50.96537208834747,
    lng: -4.672699105269727,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4845",
    tags: [],
    locationDescription:
      " The teacher looks at a tower angrily. The student looks at the road happily. The cat runs towards the horizon lazily. The cat eats the road happily.",
  },
  {
    locationId: "item22846",
    locationName: "item22846",
    locationAddress: "item22846",
    ratings: [
      { who: "Similar identities", rating: 3.16 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 51.88086945148594,
    lng: 0.7171954320808549,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4846",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A woman builds the cake quickly.",
  },
  {
    locationId: "item22847",
    locationName: "item22847",
    locationAddress: "item22847",
    ratings: null,
    lat: 59.118470406712454,
    lng: -5.864652109909003,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4847",
    tags: [],
    locationDescription:
      " The student eats the horizon lazily. The teacher writes a book lazily. The cat looks at a book angrily. A dog looks at a tower angrily. A dog builds a fence happily.",
  },
  {
    locationId: "item22848",
    locationName: "item22848",
    locationAddress: "item22848",
    ratings: null,
    lat: 53.6738878194703,
    lng: -5.251164907827064,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4848",
    tags: [],
    locationDescription:
      " The man eats the horizon happily. The cat writes the horizon lazily.",
  },
  {
    locationId: "item22849",
    locationName: "item22849",
    locationAddress: "item22849",
    ratings: [
      { who: "Similar identities", rating: 2.67 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 51.31551590644829,
    lng: -0.9057040963064384,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4849",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat writes the horizon happily. The man looks at the road gracefully. The cat builds a fence lazily. A dog jumps over the horizon angrily.",
  },
  {
    locationId: "item22850",
    locationName: "item22850",
    locationAddress: "item22850",
    ratings: null,
    lat: 55.57819079154075,
    lng: -4.596000545339245,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4850",
    tags: [],
    locationDescription:
      " The teacher builds the horizon silently. The student jumps over the road gracefully. The student runs towards a tower lazily. The cat builds a fence happily.",
  },
  {
    locationId: "item22851",
    locationName: "item22851",
    locationAddress: "item22851",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 2.76 },
    ],
    lat: 52.918590344276936,
    lng: -3.369730440942635,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4851",
    tags: [{ label: "child friendly" }],
    locationDescription: " The teacher writes the road lazily.",
  },
  {
    locationId: "item22852",
    locationName: "item22852",
    locationAddress: "item22852",
    ratings: null,
    lat: 55.168812526983,
    lng: 1.6405370432129818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4852",
    tags: [],
    locationDescription:
      " The student builds a fence gracefully. The student jumps over a book happily. The student jumps over a tower gracefully.",
  },
  {
    locationId: "item22853",
    locationName: "item22853",
    locationAddress: "item22853",
    ratings: null,
    lat: 59.62626723804409,
    lng: -4.095168062807317,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4853",
    tags: [],
    locationDescription: " A dog runs towards a fence happily.",
  },
  {
    locationId: "item22854",
    locationName: "item22854",
    locationAddress: "item22854",
    ratings: null,
    lat: 55.961781026233346,
    lng: -8.407240932312176,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4854",
    tags: [],
    locationDescription: " The man eats a tower gracefully.",
  },
  {
    locationId: "item22855",
    locationName: "item22855",
    locationAddress: "item22855",
    ratings: null,
    lat: 51.20060242111331,
    lng: -6.708561078585513,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4855",
    tags: [],
    locationDescription: " The student writes a tower quickly.",
  },
  {
    locationId: "item22856",
    locationName: "item22856",
    locationAddress: "item22856",
    ratings: [
      { who: "Similar identities", rating: 1.08 },
      { who: "All perspectives", rating: 3.27 },
    ],
    lat: 54.313259850349446,
    lng: -1.7977543607391517,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4856",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman builds a tower silently. A dog writes a tower happily. The student eats the horizon lazily. The man builds a fence angrily.",
  },
  {
    locationId: "item22857",
    locationName: "item22857",
    locationAddress: "item22857",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 2.92 },
    ],
    lat: 54.52611717279842,
    lng: -7.5544456063315835,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4857",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes a tower silently. The teacher runs towards a fence happily. A woman looks at the road lazily.",
  },
  {
    locationId: "item22858",
    locationName: "item22858",
    locationAddress: "item22858",
    ratings: null,
    lat: 58.658092894357715,
    lng: -7.486185440106341,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4858",
    tags: [],
    locationDescription:
      " The cat eats a book angrily. The cat builds the road happily. The man runs towards a tower silently. The cat runs towards the road lazily. A dog writes the horizon happily.",
  },
  {
    locationId: "item22859",
    locationName: "item22859",
    locationAddress: "item22859",
    ratings: null,
    lat: 58.42836349407478,
    lng: 0.10082957386700464,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4859",
    tags: [],
    locationDescription:
      " The teacher writes the horizon happily. A dog looks at a fence lazily.",
  },
  {
    locationId: "item22860",
    locationName: "item22860",
    locationAddress: "item22860",
    ratings: [
      { who: "Similar identities", rating: 2.04 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 58.19633127566327,
    lng: -0.5776780985344541,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4860",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman jumps over a book silently. A dog eats a fence lazily. The cat jumps over a fence angrily. A woman runs towards a book happily. A dog eats the horizon lazily.",
  },
  {
    locationId: "item22861",
    locationName: "item22861",
    locationAddress: "item22861",
    ratings: [
      { who: "Similar identities", rating: 4.24 },
      { who: "All perspectives", rating: 0.61 },
    ],
    lat: 55.464024967125006,
    lng: 1.7981575430364423,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4861",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog writes the road quickly.",
  },
  {
    locationId: "item22862",
    locationName: "item22862",
    locationAddress: "item22862",
    ratings: null,
    lat: 60.169949863121836,
    lng: -6.742660887991138,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4862",
    tags: [],
    locationDescription:
      " The man runs towards a book silently. The student jumps over a fence gracefully. A woman looks at a tower gracefully. A woman looks at the horizon gracefully.",
  },
  {
    locationId: "item22863",
    locationName: "item22863",
    locationAddress: "item22863",
    ratings: [
      { who: "Similar identities", rating: 4.09 },
      { who: "All perspectives", rating: 4.79 },
    ],
    lat: 55.16396896875175,
    lng: -1.2313643827016314,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4863",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman jumps over the cake quickly. A woman jumps over a tower lazily. The cat runs towards a tower silently.",
  },
  {
    locationId: "item22864",
    locationName: "item22864",
    locationAddress: "item22864",
    ratings: null,
    lat: 56.660631532032255,
    lng: -6.384739867706049,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4864",
    tags: [],
    locationDescription:
      " The teacher looks at the cake happily. The man looks at a fence happily. The student runs towards the horizon silently.",
  },
  {
    locationId: "item22865",
    locationName: "item22865",
    locationAddress: "item22865",
    ratings: [
      { who: "Similar identities", rating: 3.45 },
      { who: "All perspectives", rating: 3.95 },
    ],
    lat: 58.54202584689055,
    lng: -5.52806019928274,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4865",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over the road angrily. A woman eats the cake happily.",
  },
  {
    locationId: "item22866",
    locationName: "item22866",
    locationAddress: "item22866",
    ratings: null,
    lat: 58.25045214362247,
    lng: -7.999801013709504,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4866",
    tags: [],
    locationDescription:
      " A woman looks at a tower happily. A woman builds the cake happily.",
  },
  {
    locationId: "item22867",
    locationName: "item22867",
    locationAddress: "item22867",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 51.495797899644984,
    lng: -8.581614584080175,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4867",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The man eats a fence happily.",
  },
  {
    locationId: "item22868",
    locationName: "item22868",
    locationAddress: "item22868",
    ratings: null,
    lat: 52.590825012989086,
    lng: -6.558543226247883,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4868",
    tags: [],
    locationDescription: " The teacher writes a tower happily.",
  },
  {
    locationId: "item22869",
    locationName: "item22869",
    locationAddress: "item22869",
    ratings: null,
    lat: 58.35297610892284,
    lng: -0.06147133957381712,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4869",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. The teacher writes a tower lazily. The man looks at the cake lazily. A woman runs towards the horizon angrily. The student looks at a fence quickly.",
  },
  {
    locationId: "item22870",
    locationName: "item22870",
    locationAddress: "item22870",
    ratings: [
      { who: "Similar identities", rating: 2.95 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 57.688519122109795,
    lng: -3.2047589962557916,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4870",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student runs towards a tower gracefully. A woman runs towards a book lazily. The man eats a fence silently.",
  },
  {
    locationId: "item22871",
    locationName: "item22871",
    locationAddress: "item22871",
    ratings: null,
    lat: 59.65129195475393,
    lng: -3.51134582546094,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4871",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon silently. The teacher runs towards a book angrily. The cat writes a book silently.",
  },
  {
    locationId: "item22872",
    locationName: "item22872",
    locationAddress: "item22872",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 4.84 },
    ],
    lat: 51.93824736015076,
    lng: 1.5209929649862222,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4872",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the road gracefully. The man jumps over the horizon happily. A woman jumps over a fence gracefully.",
  },
  {
    locationId: "item22873",
    locationName: "item22873",
    locationAddress: "item22873",
    ratings: [
      { who: "Similar identities", rating: 2.54 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 55.33711278707332,
    lng: -4.439750067716,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4873",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman eats the road lazily. The man eats a tower quickly. The teacher looks at the cake happily. The cat eats the cake silently. The man writes the cake angrily.",
  },
  {
    locationId: "item22874",
    locationName: "item22874",
    locationAddress: "item22874",
    ratings: [
      { who: "Similar identities", rating: 3.68 },
      { who: "All perspectives", rating: 2.76 },
    ],
    lat: 55.86536859752377,
    lng: -8.213950520044268,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4874",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher looks at a tower gracefully. The man jumps over a book lazily. The teacher runs towards a book happily. The teacher looks at the cake silently. The teacher eats a fence lazily.",
  },
  {
    locationId: "item22875",
    locationName: "item22875",
    locationAddress: "item22875",
    ratings: null,
    lat: 58.46571361039568,
    lng: -4.712973394049802,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4875",
    tags: [],
    locationDescription:
      " The cat eats the cake lazily. The student writes a fence angrily. The teacher runs towards a book lazily. A woman builds a fence happily. The cat builds the cake quickly.",
  },
  {
    locationId: "item22876",
    locationName: "item22876",
    locationAddress: "item22876",
    ratings: null,
    lat: 52.813761598941085,
    lng: -1.8456091106621981,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4876",
    tags: [],
    locationDescription:
      " The teacher eats the cake angrily. The cat eats the horizon gracefully.",
  },
  {
    locationId: "item22877",
    locationName: "item22877",
    locationAddress: "item22877",
    ratings: null,
    lat: 59.44857698018505,
    lng: -6.426100070881869,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4877",
    tags: [],
    locationDescription: " A woman builds a fence happily.",
  },
  {
    locationId: "item22878",
    locationName: "item22878",
    locationAddress: "item22878",
    ratings: null,
    lat: 55.50380211959386,
    lng: -2.9607811261805574,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4878",
    tags: [],
    locationDescription:
      " The student jumps over a fence quickly. The cat builds the horizon angrily. The man jumps over a book gracefully. The student jumps over a tower gracefully. The student eats the horizon lazily.",
  },
  {
    locationId: "item22879",
    locationName: "item22879",
    locationAddress: "item22879",
    ratings: null,
    lat: 56.49115258559033,
    lng: -4.3298829052196055,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4879",
    tags: [],
    locationDescription:
      " The student builds the road lazily. A woman writes the cake silently. The student looks at a book gracefully. The cat builds a book lazily. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item22880",
    locationName: "item22880",
    locationAddress: "item22880",
    ratings: null,
    lat: 60.288657862917084,
    lng: -6.227088181252456,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4880",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon lazily. A woman builds a book gracefully. A dog jumps over a tower gracefully. The teacher looks at the cake silently.",
  },
  {
    locationId: "item22881",
    locationName: "item22881",
    locationAddress: "item22881",
    ratings: null,
    lat: 50.719029341419336,
    lng: 1.2742769176826059,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4881",
    tags: [],
    locationDescription:
      " A dog writes the horizon quickly. A dog looks at the cake happily.",
  },
  {
    locationId: "item22882",
    locationName: "item22882",
    locationAddress: "item22882",
    ratings: [
      { who: "Similar identities", rating: 1.47 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 58.0266006287967,
    lng: -4.310371498329665,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4882",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog builds the cake happily. The teacher builds a tower silently. A dog jumps over the horizon happily.",
  },
  {
    locationId: "item22883",
    locationName: "item22883",
    locationAddress: "item22883",
    ratings: null,
    lat: 56.453679589956906,
    lng: 0.47879484516687576,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4883",
    tags: [],
    locationDescription:
      " A dog writes a tower angrily. The student looks at a book angrily. A woman writes the cake quickly. The cat writes the horizon silently. The cat jumps over a tower angrily.",
  },
  {
    locationId: "item22884",
    locationName: "item22884",
    locationAddress: "item22884",
    ratings: [
      { who: "Similar identities", rating: 4.34 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 53.41009327708849,
    lng: 0.5707098382865006,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4884",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The man builds a tower gracefully.",
  },
  {
    locationId: "item22885",
    locationName: "item22885",
    locationAddress: "item22885",
    ratings: [
      { who: "Similar identities", rating: 2.68 },
      { who: "All perspectives", rating: 0.88 },
    ],
    lat: 51.153361598636785,
    lng: -8.10793508526323,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4885",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat eats the cake happily. The teacher builds the horizon gracefully. A woman runs towards the horizon gracefully. A dog jumps over a book happily. A dog jumps over the road quickly.",
  },
  {
    locationId: "item22886",
    locationName: "item22886",
    locationAddress: "item22886",
    ratings: [
      { who: "Similar identities", rating: 4.63 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 54.26997951490574,
    lng: -7.003161691877385,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4886",
    tags: [{ label: "child friendly" }],
    locationDescription: " The cat runs towards the cake angrily.",
  },
  {
    locationId: "item22887",
    locationName: "item22887",
    locationAddress: "item22887",
    ratings: [
      { who: "Similar identities", rating: 2.76 },
      { who: "All perspectives", rating: 0.09 },
    ],
    lat: 52.02955697862228,
    lng: -5.62677194081482,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4887",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher jumps over a tower happily. The man eats the road silently. A woman writes the cake gracefully.",
  },
  {
    locationId: "item22888",
    locationName: "item22888",
    locationAddress: "item22888",
    ratings: [
      { who: "Similar identities", rating: 1.0 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 52.07828234084061,
    lng: -1.7028211510840467,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4888",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at a tower happily. The student builds a fence silently. A dog builds a fence lazily.",
  },
  {
    locationId: "item22889",
    locationName: "item22889",
    locationAddress: "item22889",
    ratings: [
      { who: "Similar identities", rating: 4.67 },
      { who: "All perspectives", rating: 1.81 },
    ],
    lat: 52.0891391441489,
    lng: -4.648112833209575,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4889",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at the horizon silently. A dog runs towards a book happily.",
  },
  {
    locationId: "item22890",
    locationName: "item22890",
    locationAddress: "item22890",
    ratings: null,
    lat: 52.49908732840956,
    lng: 1.1028177443324978,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4890",
    tags: [],
    locationDescription: " A dog runs towards the cake lazily.",
  },
  {
    locationId: "item22891",
    locationName: "item22891",
    locationAddress: "item22891",
    ratings: null,
    lat: 54.263031205985,
    lng: -8.292298673344511,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4891",
    tags: [],
    locationDescription:
      " A woman eats a book gracefully. The teacher eats the road happily. A woman builds a fence gracefully. A dog writes a tower gracefully.",
  },
  {
    locationId: "item22892",
    locationName: "item22892",
    locationAddress: "item22892",
    ratings: [
      { who: "Similar identities", rating: 4.21 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 60.07549609560568,
    lng: -4.914338438654678,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4892",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " The man runs towards a fence gracefully.",
  },
  {
    locationId: "item22893",
    locationName: "item22893",
    locationAddress: "item22893",
    ratings: null,
    lat: 59.212355576165564,
    lng: -7.903461687209271,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4893",
    tags: [],
    locationDescription: " A dog eats the cake quickly.",
  },
  {
    locationId: "item22894",
    locationName: "item22894",
    locationAddress: "item22894",
    ratings: [
      { who: "Similar identities", rating: 1.16 },
      { who: "All perspectives", rating: 2.07 },
    ],
    lat: 54.44999328810303,
    lng: -3.7377616949640426,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4894",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student runs towards the cake quickly. A dog builds a book happily. A dog looks at the horizon gracefully. A dog runs towards the cake angrily.",
  },
  {
    locationId: "item22895",
    locationName: "item22895",
    locationAddress: "item22895",
    ratings: [
      { who: "Similar identities", rating: 4.06 },
      { who: "All perspectives", rating: 3.75 },
    ],
    lat: 60.43755437160422,
    lng: -3.1978433382559084,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4895",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds a tower lazily. A dog writes the cake angrily.",
  },
  {
    locationId: "item22896",
    locationName: "item22896",
    locationAddress: "item22896",
    ratings: null,
    lat: 54.213683753909216,
    lng: 0.8606497972927301,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4896",
    tags: [],
    locationDescription:
      " A dog looks at a fence silently. A dog runs towards the horizon lazily.",
  },
  {
    locationId: "item22897",
    locationName: "item22897",
    locationAddress: "item22897",
    ratings: [
      { who: "Similar identities", rating: 2.13 },
      { who: "All perspectives", rating: 0.3 },
    ],
    lat: 56.35794723673531,
    lng: -2.883993109555112,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4897",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds the road quickly. The student builds a fence quickly. The man writes a fence lazily.",
  },
  {
    locationId: "item22898",
    locationName: "item22898",
    locationAddress: "item22898",
    ratings: null,
    lat: 60.477611006728885,
    lng: 1.6902848789753868,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4898",
    tags: [],
    locationDescription: " The teacher jumps over a tower silently.",
  },
  {
    locationId: "item22899",
    locationName: "item22899",
    locationAddress: "item22899",
    ratings: null,
    lat: 55.79843665452642,
    lng: -3.0494484289904564,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4899",
    tags: [],
    locationDescription:
      " The student eats a book happily. A woman runs towards the horizon angrily. A dog builds the road quickly. The student writes a fence gracefully.",
  },
  {
    locationId: "item22900",
    locationName: "item22900",
    locationAddress: "item22900",
    ratings: [
      { who: "Similar identities", rating: 0.78 },
      { who: "All perspectives", rating: 0.68 },
    ],
    lat: 55.934321270159,
    lng: -7.810131891693311,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4900",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher runs towards the cake quickly. The teacher jumps over a tower gracefully. The man runs towards the road silently.",
  },
  {
    locationId: "item22901",
    locationName: "item22901",
    locationAddress: "item22901",
    ratings: null,
    lat: 53.161117177486275,
    lng: -1.689535689193833,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4901",
    tags: [],
    locationDescription:
      " The cat builds the cake silently. A woman looks at the horizon happily. The man jumps over the horizon lazily. A dog runs towards a tower silently.",
  },
  {
    locationId: "item22902",
    locationName: "item22902",
    locationAddress: "item22902",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 4.34 },
    ],
    lat: 55.33340292800982,
    lng: -8.029736917841413,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4902",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man looks at the cake quickly. The man builds the horizon happily.",
  },
  {
    locationId: "item22903",
    locationName: "item22903",
    locationAddress: "item22903",
    ratings: null,
    lat: 59.203664804059876,
    lng: -5.693468017531471,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4903",
    tags: [],
    locationDescription:
      " The man eats the horizon quickly. A dog eats a tower quickly.",
  },
  {
    locationId: "item22904",
    locationName: "item22904",
    locationAddress: "item22904",
    ratings: [
      { who: "Similar identities", rating: 3.99 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 56.44933411902171,
    lng: -7.198435120824299,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4904",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The cat jumps over the horizon angrily. A woman builds a book lazily. The man jumps over a book angrily.",
  },
  {
    locationId: "item22905",
    locationName: "item22905",
    locationAddress: "item22905",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 4.44 },
    ],
    lat: 57.35752399414187,
    lng: -0.5977629093416859,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4905",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog runs towards a tower gracefully. The student writes the cake gracefully. The teacher runs towards the horizon silently. The student runs towards the cake silently. A dog looks at a fence silently.",
  },
  {
    locationId: "item22906",
    locationName: "item22906",
    locationAddress: "item22906",
    ratings: null,
    lat: 57.9534811241635,
    lng: -4.053928354948948,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4906",
    tags: [],
    locationDescription:
      " The man looks at a fence happily. A woman jumps over the cake lazily. A dog runs towards a tower angrily. The cat eats the road silently. The student jumps over a book quickly.",
  },
  {
    locationId: "item22907",
    locationName: "item22907",
    locationAddress: "item22907",
    ratings: [
      { who: "Similar identities", rating: 2.11 },
      { who: "All perspectives", rating: 1.34 },
    ],
    lat: 53.31931896023638,
    lng: -4.245443206164737,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4907",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man builds the road lazily. A woman looks at the horizon happily. A dog builds a tower gracefully.",
  },
  {
    locationId: "item22908",
    locationName: "item22908",
    locationAddress: "item22908",
    ratings: null,
    lat: 57.83564906981556,
    lng: -7.764986969221735,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4908",
    tags: [],
    locationDescription:
      " The teacher writes a book lazily. The cat writes a tower quickly. A dog runs towards a tower happily. The teacher builds the road angrily.",
  },
  {
    locationId: "item22909",
    locationName: "item22909",
    locationAddress: "item22909",
    ratings: [
      { who: "Similar identities", rating: 1.0 },
      { who: "All perspectives", rating: 2.96 },
    ],
    lat: 53.056817874926566,
    lng: -8.12763429707228,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4909",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog eats the road angrily. The man looks at a book lazily. A dog runs towards a fence silently. A woman looks at the horizon angrily. The man runs towards the cake quickly.",
  },
  {
    locationId: "item22910",
    locationName: "item22910",
    locationAddress: "item22910",
    ratings: [
      { who: "Similar identities", rating: 3.15 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 57.79693800013933,
    lng: 0.6720812030982781,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4910",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog writes a tower gracefully. The man jumps over a tower quickly. A woman builds the horizon happily. The man writes the horizon gracefully.",
  },
  {
    locationId: "item22911",
    locationName: "item22911",
    locationAddress: "item22911",
    ratings: [
      { who: "Similar identities", rating: 3.56 },
      { who: "All perspectives", rating: 3.77 },
    ],
    lat: 52.10200851922288,
    lng: -3.314177965459071,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4911",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a fence silently. A dog runs towards the road lazily. The cat builds the cake quickly.",
  },
  {
    locationId: "item22912",
    locationName: "item22912",
    locationAddress: "item22912",
    ratings: [
      { who: "Similar identities", rating: 0.73 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 52.994489541413216,
    lng: 1.0420715941523948,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4912",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds a tower gracefully. The man looks at the road gracefully. The student eats a tower silently. The teacher writes the horizon angrily.",
  },
  {
    locationId: "item22913",
    locationName: "item22913",
    locationAddress: "item22913",
    ratings: null,
    lat: 55.43686644260276,
    lng: -5.6972331069860545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4913",
    tags: [],
    locationDescription:
      " A woman jumps over the road happily. The man builds the cake silently. The teacher builds the road happily. The student builds the horizon happily.",
  },
  {
    locationId: "item22914",
    locationName: "item22914",
    locationAddress: "item22914",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 1.09 },
    ],
    lat: 57.17868834357123,
    lng: 1.4009198893818944,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4914",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher jumps over the cake angrily.",
  },
  {
    locationId: "item22915",
    locationName: "item22915",
    locationAddress: "item22915",
    ratings: null,
    lat: 56.33730904384927,
    lng: -6.746201949292877,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4915",
    tags: [],
    locationDescription:
      " A dog runs towards the road quickly. The cat runs towards the horizon gracefully. The cat writes a fence quickly.",
  },
  {
    locationId: "item22916",
    locationName: "item22916",
    locationAddress: "item22916",
    ratings: null,
    lat: 55.51760128006434,
    lng: -8.466436993493643,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4916",
    tags: [],
    locationDescription: " A dog eats the road lazily.",
  },
  {
    locationId: "item22917",
    locationName: "item22917",
    locationAddress: "item22917",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 54.006989932443425,
    lng: -7.408912908725016,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4917",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog jumps over a tower quickly. A dog eats a tower angrily.",
  },
  {
    locationId: "item22918",
    locationName: "item22918",
    locationAddress: "item22918",
    ratings: [
      { who: "Similar identities", rating: 3.82 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 59.72326990388049,
    lng: -6.617733141684137,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4918",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " The teacher writes the horizon gracefully.",
  },
  {
    locationId: "item22919",
    locationName: "item22919",
    locationAddress: "item22919",
    ratings: [
      { who: "Similar identities", rating: 0.47 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 56.608465318974595,
    lng: -1.9458699223844604,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4919",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog builds a fence quickly. The cat jumps over the horizon happily.",
  },
  {
    locationId: "item22920",
    locationName: "item22920",
    locationAddress: "item22920",
    ratings: [
      { who: "Similar identities", rating: 3.59 },
      { who: "All perspectives", rating: 1.23 },
    ],
    lat: 57.768602659140996,
    lng: -7.4039531668839595,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4920",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog runs towards the horizon gracefully. A woman looks at the horizon angrily.",
  },
  {
    locationId: "item22921",
    locationName: "item22921",
    locationAddress: "item22921",
    ratings: null,
    lat: 56.016908105304374,
    lng: -6.903800817790952,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4921",
    tags: [],
    locationDescription:
      " A woman runs towards a book quickly. The student jumps over the road lazily. The man writes a tower gracefully. A woman jumps over the road silently. The man looks at a book silently.",
  },
  {
    locationId: "item22922",
    locationName: "item22922",
    locationAddress: "item22922",
    ratings: [
      { who: "Similar identities", rating: 0.59 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 53.39742013593537,
    lng: -0.9667964783853691,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4922",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog writes a fence lazily. The cat eats a tower quickly. A woman eats a fence gracefully.",
  },
  {
    locationId: "item22923",
    locationName: "item22923",
    locationAddress: "item22923",
    ratings: null,
    lat: 50.08842705464694,
    lng: -8.208664621781441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4923",
    tags: [],
    locationDescription:
      " A dog runs towards a book happily. The cat eats a book quickly.",
  },
  {
    locationId: "item22924",
    locationName: "item22924",
    locationAddress: "item22924",
    ratings: null,
    lat: 53.08254022269026,
    lng: -7.728444575455191,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4924",
    tags: [],
    locationDescription:
      " The teacher jumps over a tower happily. The man eats a book silently.",
  },
  {
    locationId: "item22925",
    locationName: "item22925",
    locationAddress: "item22925",
    ratings: [
      { who: "Similar identities", rating: 4.56 },
      { who: "All perspectives", rating: 0.39 },
    ],
    lat: 54.104392316461364,
    lng: -4.620842413266844,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4925",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher jumps over the cake lazily. The teacher runs towards a book happily. The cat looks at the road lazily. The student builds a tower gracefully.",
  },
  {
    locationId: "item22926",
    locationName: "item22926",
    locationAddress: "item22926",
    ratings: null,
    lat: 60.3076454531042,
    lng: 1.1309874577879615,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4926",
    tags: [],
    locationDescription:
      " The teacher builds a tower lazily. The man builds the horizon silently. The man looks at the road happily.",
  },
  {
    locationId: "item22927",
    locationName: "item22927",
    locationAddress: "item22927",
    ratings: [
      { who: "Similar identities", rating: 3.92 },
      { who: "All perspectives", rating: 2.98 },
    ],
    lat: 60.48401721837413,
    lng: -4.97829631459593,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4927",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The cat looks at a fence lazily. A dog eats the road gracefully. A dog looks at a book quickly. A dog builds the cake silently.",
  },
  {
    locationId: "item22928",
    locationName: "item22928",
    locationAddress: "item22928",
    ratings: [
      { who: "Similar identities", rating: 1.12 },
      { who: "All perspectives", rating: 1.59 },
    ],
    lat: 51.96238310677085,
    lng: 1.4233033395115626,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4928",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog looks at a fence silently. A dog eats a tower gracefully. The man builds a tower silently. The student eats a book lazily. The man eats a tower silently.",
  },
  {
    locationId: "item22929",
    locationName: "item22929",
    locationAddress: "item22929",
    ratings: null,
    lat: 50.61911512124217,
    lng: -3.9838303402096713,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4929",
    tags: [],
    locationDescription:
      " The teacher writes the horizon happily. The cat writes a tower silently. A woman runs towards a book quickly. A woman writes the horizon angrily.",
  },
  {
    locationId: "item22930",
    locationName: "item22930",
    locationAddress: "item22930",
    ratings: null,
    lat: 56.193407427166235,
    lng: 0.9666319059260697,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4930",
    tags: [],
    locationDescription: " The student runs towards a book angrily.",
  },
  {
    locationId: "item22931",
    locationName: "item22931",
    locationAddress: "item22931",
    ratings: null,
    lat: 56.71023443780652,
    lng: -4.663435747666259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4931",
    tags: [],
    locationDescription: " A woman eats a book silently.",
  },
  {
    locationId: "item22932",
    locationName: "item22932",
    locationAddress: "item22932",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 4.23 },
    ],
    lat: 58.01947848239668,
    lng: -1.5273647094631873,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item4932",
    tags: [{ label: "child friendly" }],
    locationDescription: " The teacher builds a fence silently.",
  },
  {
    locationId: "item22933",
    locationName: "item22933",
    locationAddress: "item22933",
    ratings: [
      { who: "Similar identities", rating: 3.21 },
      { who: "All perspectives", rating: 1.91 },
    ],
    lat: 50.542466252044754,
    lng: -4.869076422155877,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4933",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog looks at a book quickly. The student builds the road angrily. A woman writes a fence happily.",
  },
  {
    locationId: "item22934",
    locationName: "item22934",
    locationAddress: "item22934",
    ratings: [
      { who: "Similar identities", rating: 0.68 },
      { who: "All perspectives", rating: 4.32 },
    ],
    lat: 56.02549272215236,
    lng: 0.861517250727097,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item4934",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man runs towards a fence angrily. A woman writes a fence silently. A woman runs towards the cake gracefully. The man jumps over the horizon angrily. A woman writes the cake happily.",
  },
  {
    locationId: "item22935",
    locationName: "item22935",
    locationAddress: "item22935",
    ratings: null,
    lat: 52.14006877862931,
    lng: -0.4540204722597867,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4935",
    tags: [],
    locationDescription:
      " A woman jumps over a tower gracefully. A dog looks at the cake angrily. A woman looks at a tower lazily.",
  },
  {
    locationId: "item22936",
    locationName: "item22936",
    locationAddress: "item22936",
    ratings: null,
    lat: 56.522086337575665,
    lng: -3.630419039690958,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4936",
    tags: [],
    locationDescription:
      " A dog builds the cake quickly. The teacher looks at the cake lazily. The student jumps over a fence lazily. The student jumps over the horizon silently.",
  },
  {
    locationId: "item22937",
    locationName: "item22937",
    locationAddress: "item22937",
    ratings: [
      { who: "Similar identities", rating: 3.88 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 55.26535255044579,
    lng: 1.1587654551153186,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4937",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat runs towards a tower gracefully. The student eats a book silently. The man builds a book lazily. A dog eats the cake gracefully.",
  },
  {
    locationId: "item22938",
    locationName: "item22938",
    locationAddress: "item22938",
    ratings: [
      { who: "Similar identities", rating: 1.73 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 54.85236625302757,
    lng: -0.6707567710923206,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4938",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes the cake quickly. The teacher eats the horizon lazily. A dog writes a tower quickly. The student looks at a tower gracefully. The teacher writes the horizon silently.",
  },
  {
    locationId: "item22939",
    locationName: "item22939",
    locationAddress: "item22939",
    ratings: null,
    lat: 60.32685342102432,
    lng: 1.562105730578482,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4939",
    tags: [],
    locationDescription: " The man jumps over the road silently.",
  },
  {
    locationId: "item22940",
    locationName: "item22940",
    locationAddress: "item22940",
    ratings: [
      { who: "Similar identities", rating: 0.3 },
      { who: "All perspectives", rating: 1.9 },
    ],
    lat: 58.285575661522685,
    lng: 0.9789592775750577,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4940",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The student writes a book lazily.",
  },
  {
    locationId: "item22941",
    locationName: "item22941",
    locationAddress: "item22941",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 59.752850970781964,
    lng: -0.46506179035960216,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item4941",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog eats a fence gracefully. The teacher eats a tower lazily. The man jumps over a fence happily. The student writes a tower angrily.",
  },
  {
    locationId: "item22942",
    locationName: "item22942",
    locationAddress: "item22942",
    ratings: [
      { who: "Similar identities", rating: 3.84 },
      { who: "All perspectives", rating: 4.33 },
    ],
    lat: 51.02020066170455,
    lng: -8.287953925401176,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4942",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes a fence quickly. The cat builds a tower happily. The cat eats the horizon lazily. The man runs towards the road angrily. The man runs towards a fence silently.",
  },
  {
    locationId: "item22943",
    locationName: "item22943",
    locationAddress: "item22943",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 0.84 },
    ],
    lat: 57.45831119866337,
    lng: -4.201258178758087,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4943",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat runs towards a fence lazily. A dog looks at a book happily. A woman writes the cake happily. A woman writes the road gracefully. The teacher jumps over the horizon happily.",
  },
  {
    locationId: "item22944",
    locationName: "item22944",
    locationAddress: "item22944",
    ratings: null,
    lat: 55.970854150969515,
    lng: -0.14890500996525446,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4944",
    tags: [],
    locationDescription:
      " A woman jumps over the cake silently. The cat runs towards the horizon silently. The student writes the road quickly. The teacher looks at the horizon quickly. The man writes the road happily.",
  },
  {
    locationId: "item22945",
    locationName: "item22945",
    locationAddress: "item22945",
    ratings: null,
    lat: 59.14305512703253,
    lng: 0.116613227815618,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4945",
    tags: [],
    locationDescription:
      " The student eats a book lazily. A woman looks at a fence quickly.",
  },
  {
    locationId: "item22946",
    locationName: "item22946",
    locationAddress: "item22946",
    ratings: [
      { who: "Similar identities", rating: 4.12 },
      { who: "All perspectives", rating: 1.39 },
    ],
    lat: 53.104297205277966,
    lng: -7.55854458633424,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4946",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman builds a fence gracefully. A woman writes the cake quickly. A dog eats a tower lazily. The cat jumps over a fence lazily.",
  },
  {
    locationId: "item22947",
    locationName: "item22947",
    locationAddress: "item22947",
    ratings: null,
    lat: 57.9372162624627,
    lng: -5.145214403937764,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4947",
    tags: [],
    locationDescription: " The student runs towards a fence lazily.",
  },
  {
    locationId: "item22948",
    locationName: "item22948",
    locationAddress: "item22948",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 55.31367220633632,
    lng: 0.8006181000010955,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4948",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man eats a tower happily. The man jumps over a tower lazily. A woman runs towards a tower gracefully.",
  },
  {
    locationId: "item22949",
    locationName: "item22949",
    locationAddress: "item22949",
    ratings: null,
    lat: 50.79644327319289,
    lng: -8.229369310304623,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4949",
    tags: [],
    locationDescription:
      " A woman builds a book lazily. The cat builds a book angrily. The student jumps over the horizon gracefully. A dog eats the cake quickly. The cat looks at a fence lazily.",
  },
  {
    locationId: "item22950",
    locationName: "item22950",
    locationAddress: "item22950",
    ratings: [
      { who: "Similar identities", rating: 1.16 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 56.29972082615187,
    lng: -5.1412949985208645,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4950",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher eats the horizon quickly. The cat eats the cake silently. The teacher jumps over a fence quickly. The man looks at a tower silently.",
  },
  {
    locationId: "item22951",
    locationName: "item22951",
    locationAddress: "item22951",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 1.0 },
    ],
    lat: 60.58211317015338,
    lng: -3.8586729349288325,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4951",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man looks at a tower silently. The man runs towards the road happily.",
  },
  {
    locationId: "item22952",
    locationName: "item22952",
    locationAddress: "item22952",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 54.514116867755746,
    lng: -4.424859077663914,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4952",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " The student looks at the cake angrily.",
  },
  {
    locationId: "item22953",
    locationName: "item22953",
    locationAddress: "item22953",
    ratings: [
      { who: "Similar identities", rating: 1.17 },
      { who: "All perspectives", rating: 3.56 },
    ],
    lat: 59.31724061855395,
    lng: -2.9464493901488273,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4953",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man eats the cake lazily. The teacher looks at the road quickly. The cat jumps over the horizon lazily. A woman writes the horizon lazily.",
  },
  {
    locationId: "item22954",
    locationName: "item22954",
    locationAddress: "item22954",
    ratings: [
      { who: "Similar identities", rating: 4.13 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 49.910780561638035,
    lng: 1.3919651873655,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4954",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at a book happily. The student writes a book angrily. The cat builds the cake quickly. The man writes a fence lazily. The student jumps over a fence angrily.",
  },
  {
    locationId: "item22955",
    locationName: "item22955",
    locationAddress: "item22955",
    ratings: [
      { who: "Similar identities", rating: 1.65 },
      { who: "All perspectives", rating: 1.8 },
    ],
    lat: 54.42436522217401,
    lng: -3.252110053765704,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4955",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat builds a book gracefully. The teacher writes a tower silently. A woman writes a book gracefully. A woman runs towards the cake lazily. The cat builds a book silently.",
  },
  {
    locationId: "item22956",
    locationName: "item22956",
    locationAddress: "item22956",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 2.77 },
    ],
    lat: 56.58253422399185,
    lng: -6.734105862591701,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4956",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man builds the horizon happily. A woman looks at the horizon happily.",
  },
  {
    locationId: "item22957",
    locationName: "item22957",
    locationAddress: "item22957",
    ratings: null,
    lat: 51.65702454737054,
    lng: -7.636767640089767,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4957",
    tags: [],
    locationDescription:
      " The student writes the horizon gracefully. The man writes the road happily.",
  },
  {
    locationId: "item22958",
    locationName: "item22958",
    locationAddress: "item22958",
    ratings: [
      { who: "Similar identities", rating: 1.73 },
      { who: "All perspectives", rating: 3.3 },
    ],
    lat: 53.71543165477051,
    lng: -8.190698611526532,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4958",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards the road happily. The student writes the road gracefully.",
  },
  {
    locationId: "item22959",
    locationName: "item22959",
    locationAddress: "item22959",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 1.1 },
    ],
    lat: 55.95679541266542,
    lng: 0.48063273334516765,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4959",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman looks at a book happily. A dog runs towards the horizon lazily. The cat writes a book silently. The student jumps over a tower quickly. A woman runs towards the cake angrily.",
  },
  {
    locationId: "item22960",
    locationName: "item22960",
    locationAddress: "item22960",
    ratings: null,
    lat: 55.182705583798985,
    lng: -3.739718193592595,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item4960",
    tags: [],
    locationDescription:
      " The student eats the horizon quickly. The man builds the road gracefully.",
  },
  {
    locationId: "item22961",
    locationName: "item22961",
    locationAddress: "item22961",
    ratings: [
      { who: "Similar identities", rating: 1.73 },
      { who: "All perspectives", rating: 4.91 },
    ],
    lat: 50.51023487809439,
    lng: -7.962714572770331,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item4961",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " A woman writes the horizon happily. The teacher writes a book happily.",
  },
  {
    locationId: "item22962",
    locationName: "item22962",
    locationAddress: "item22962",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 2.21 },
    ],
    lat: 58.774928929969505,
    lng: -4.887892126887139,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4962",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher looks at a fence gracefully. The student runs towards a book gracefully. The student runs towards a tower quickly.",
  },
  {
    locationId: "item22963",
    locationName: "item22963",
    locationAddress: "item22963",
    ratings: [
      { who: "Similar identities", rating: 0.74 },
      { who: "All perspectives", rating: 0.52 },
    ],
    lat: 52.61014688259277,
    lng: -0.6763627160504653,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item4963",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat eats the horizon silently. A dog builds the cake happily.",
  },
  {
    locationId: "item22964",
    locationName: "item22964",
    locationAddress: "item22964",
    ratings: null,
    lat: 60.134774377870436,
    lng: -4.138950861645309,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4964",
    tags: [],
    locationDescription:
      " The man runs towards a fence quickly. A woman looks at a tower happily. A woman looks at the cake lazily.",
  },
  {
    locationId: "item22965",
    locationName: "item22965",
    locationAddress: "item22965",
    ratings: null,
    lat: 56.93856978506231,
    lng: -4.773794582510227,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4965",
    tags: [],
    locationDescription:
      " A woman writes a book gracefully. The teacher eats the road happily. The student builds the cake angrily.",
  },
  {
    locationId: "item22966",
    locationName: "item22966",
    locationAddress: "item22966",
    ratings: null,
    lat: 52.169392652045666,
    lng: 1.536200932835877,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4966",
    tags: [],
    locationDescription:
      " The teacher eats a book angrily. The cat runs towards the road happily. The student writes a fence quickly. A woman eats the cake lazily. The man jumps over a book happily.",
  },
  {
    locationId: "item22967",
    locationName: "item22967",
    locationAddress: "item22967",
    ratings: [
      { who: "Similar identities", rating: 1.24 },
      { who: "All perspectives", rating: 3.56 },
    ],
    lat: 54.96223552953213,
    lng: -8.011245774389293,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4967",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a book quickly. The man eats a fence lazily. The cat runs towards the cake angrily. The man eats a book gracefully. The man looks at the horizon quickly.",
  },
  {
    locationId: "item22968",
    locationName: "item22968",
    locationAddress: "item22968",
    ratings: null,
    lat: 51.525865917439035,
    lng: -8.292973987180535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4968",
    tags: [],
    locationDescription:
      " The cat builds the road silently. The student looks at the cake happily.",
  },
  {
    locationId: "item22969",
    locationName: "item22969",
    locationAddress: "item22969",
    ratings: null,
    lat: 53.42073516069429,
    lng: -8.486031307987366,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item4969",
    tags: [],
    locationDescription:
      " A woman writes the road quickly. The teacher eats a tower lazily. The teacher builds a fence quickly. The cat runs towards a fence silently. The student writes the cake gracefully.",
  },
  {
    locationId: "item22970",
    locationName: "item22970",
    locationAddress: "item22970",
    ratings: [
      { who: "Similar identities", rating: 2.46 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 51.45361301594655,
    lng: 0.9754749056457435,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4970",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the cake happily. The man eats the road gracefully.",
  },
  {
    locationId: "item22971",
    locationName: "item22971",
    locationAddress: "item22971",
    ratings: null,
    lat: 53.58239391379409,
    lng: 1.6930520410864744,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4971",
    tags: [],
    locationDescription: " The student runs towards a fence lazily.",
  },
  {
    locationId: "item22972",
    locationName: "item22972",
    locationAddress: "item22972",
    ratings: null,
    lat: 56.575828005779236,
    lng: 0.15811557068182225,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4972",
    tags: [],
    locationDescription:
      " The man eats a book lazily. The student looks at a book lazily. The cat jumps over a tower angrily. The teacher jumps over the horizon angrily.",
  },
  {
    locationId: "item22973",
    locationName: "item22973",
    locationAddress: "item22973",
    ratings: [
      { who: "Similar identities", rating: 2.51 },
      { who: "All perspectives", rating: 1.01 },
    ],
    lat: 54.48892757412378,
    lng: -6.770359536970048,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4973",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes a book silently. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item22974",
    locationName: "item22974",
    locationAddress: "item22974",
    ratings: [
      { who: "Similar identities", rating: 1.11 },
      { who: "All perspectives", rating: 3.13 },
    ],
    lat: 53.137583734970775,
    lng: 0.3892464806882483,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4974",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over a tower gracefully. A woman writes a book angrily. The man writes a tower gracefully.",
  },
  {
    locationId: "item22975",
    locationName: "item22975",
    locationAddress: "item22975",
    ratings: null,
    lat: 53.554893331122614,
    lng: 0.18589193074509502,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4975",
    tags: [],
    locationDescription:
      " The man jumps over the road angrily. The teacher jumps over the horizon quickly. A woman eats a book lazily. The student eats the horizon happily.",
  },
  {
    locationId: "item22976",
    locationName: "item22976",
    locationAddress: "item22976",
    ratings: [
      { who: "Similar identities", rating: 4.84 },
      { who: "All perspectives", rating: 2.13 },
    ],
    lat: 53.15744511784747,
    lng: -0.15705685218790855,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4976",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog looks at the road silently. The teacher builds the cake gracefully. The teacher builds a fence silently. The cat jumps over a tower lazily.",
  },
  {
    locationId: "item22977",
    locationName: "item22977",
    locationAddress: "item22977",
    ratings: null,
    lat: 58.598264587946,
    lng: -4.363394264562318,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4977",
    tags: [],
    locationDescription:
      " The man eats a fence quickly. A dog runs towards a fence quickly. The cat writes the road gracefully. The cat jumps over a fence angrily.",
  },
  {
    locationId: "item22978",
    locationName: "item22978",
    locationAddress: "item22978",
    ratings: null,
    lat: 59.571859254694495,
    lng: -2.041573848704169,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item4978",
    tags: [],
    locationDescription:
      " The student writes the horizon quickly. The man eats the cake happily.",
  },
  {
    locationId: "item22979",
    locationName: "item22979",
    locationAddress: "item22979",
    ratings: null,
    lat: 53.70474796502394,
    lng: -1.6549740098332677,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4979",
    tags: [],
    locationDescription:
      " The cat writes a tower angrily. The student builds the road silently.",
  },
  {
    locationId: "item22980",
    locationName: "item22980",
    locationAddress: "item22980",
    ratings: [
      { who: "Similar identities", rating: 0.57 },
      { who: "All perspectives", rating: 1.95 },
    ],
    lat: 52.50865063031998,
    lng: -8.379651314187967,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item4980",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student writes the cake angrily. The teacher jumps over the road silently.",
  },
  {
    locationId: "item22981",
    locationName: "item22981",
    locationAddress: "item22981",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 3.02 },
    ],
    lat: 50.42165388997288,
    lng: -6.574696195726887,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item4981",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man runs towards the road quickly.",
  },
  {
    locationId: "item22982",
    locationName: "item22982",
    locationAddress: "item22982",
    ratings: null,
    lat: 57.14342963779037,
    lng: -3.4688678026868303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item4982",
    tags: [],
    locationDescription:
      " A dog writes the horizon happily. A dog writes the road angrily. The student jumps over the road silently. A dog builds a tower lazily.",
  },
  {
    locationId: "item22983",
    locationName: "item22983",
    locationAddress: "item22983",
    ratings: [
      { who: "Similar identities", rating: 0.67 },
      { who: "All perspectives", rating: 0.61 },
    ],
    lat: 55.68268268109496,
    lng: -3.2712718887922776,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item4983",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards a fence silently. A woman writes a tower silently. The student runs towards a fence gracefully. The cat writes the road silently. A dog jumps over a book gracefully.",
  },
  {
    locationId: "item22984",
    locationName: "item22984",
    locationAddress: "item22984",
    ratings: [
      { who: "Similar identities", rating: 4.68 },
      { who: "All perspectives", rating: 0.7 },
    ],
    lat: 60.43035312443472,
    lng: 0.9542266936547588,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item4984",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at a fence silently. The teacher builds the road happily.",
  },
  {
    locationId: "item22985",
    locationName: "item22985",
    locationAddress: "item22985",
    ratings: null,
    lat: 52.64125243275554,
    lng: -2.424223917097539,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item4985",
    tags: [],
    locationDescription:
      " A woman builds a fence quickly. A dog eats a fence angrily. The student jumps over the road lazily. The man jumps over a fence lazily.",
  },
  {
    locationId: "item22986",
    locationName: "item22986",
    locationAddress: "item22986",
    ratings: null,
    lat: 57.74913297365769,
    lng: -1.1112625408827181,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4986",
    tags: [],
    locationDescription:
      " The cat jumps over the cake silently. The man runs towards the road lazily.",
  },
  {
    locationId: "item22987",
    locationName: "item22987",
    locationAddress: "item22987",
    ratings: null,
    lat: 59.02047158818067,
    lng: 1.3511338805225854,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item4987",
    tags: [],
    locationDescription:
      " The student builds a book gracefully. The man jumps over the road angrily. A woman builds the horizon silently. A dog eats the horizon happily.",
  },
  {
    locationId: "item22988",
    locationName: "item22988",
    locationAddress: "item22988",
    ratings: null,
    lat: 57.60558045102219,
    lng: -6.843066667996009,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4988",
    tags: [],
    locationDescription: " A dog runs towards a book gracefully.",
  },
  {
    locationId: "item22989",
    locationName: "item22989",
    locationAddress: "item22989",
    ratings: [
      { who: "Similar identities", rating: 1.33 },
      { who: "All perspectives", rating: 1.45 },
    ],
    lat: 60.04327577491571,
    lng: -6.8332821335523555,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4989",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog looks at the cake gracefully.",
  },
  {
    locationId: "item22990",
    locationName: "item22990",
    locationAddress: "item22990",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 53.3235637041724,
    lng: -7.24293717825002,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4990",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The man eats a fence happily.",
  },
  {
    locationId: "item22991",
    locationName: "item22991",
    locationAddress: "item22991",
    ratings: null,
    lat: 59.67066319781742,
    lng: -4.797685816332875,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4991",
    tags: [],
    locationDescription:
      " A dog writes the horizon happily. The teacher runs towards a tower gracefully. The man jumps over a tower silently. The student runs towards a book quickly. The teacher builds a tower happily.",
  },
  {
    locationId: "item22992",
    locationName: "item22992",
    locationAddress: "item22992",
    ratings: null,
    lat: 58.19720106669752,
    lng: -3.364740913156714,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item4992",
    tags: [],
    locationDescription: " A dog jumps over the horizon gracefully.",
  },
  {
    locationId: "item22993",
    locationName: "item22993",
    locationAddress: "item22993",
    ratings: null,
    lat: 59.30063903969033,
    lng: -4.096622499322091,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4993",
    tags: [],
    locationDescription:
      " The student runs towards a tower happily. A dog jumps over the cake lazily. A woman looks at the horizon lazily.",
  },
  {
    locationId: "item22994",
    locationName: "item22994",
    locationAddress: "item22994",
    ratings: [
      { who: "Similar identities", rating: 2.0 },
      { who: "All perspectives", rating: 3.12 },
    ],
    lat: 50.658558295501486,
    lng: 0.276390040777434,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4994",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog eats a tower happily. The cat writes the horizon lazily. A dog looks at the cake angrily. The cat builds a book gracefully. A woman eats a book gracefully.",
  },
  {
    locationId: "item22995",
    locationName: "item22995",
    locationAddress: "item22995",
    ratings: [
      { who: "Similar identities", rating: 2.54 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 50.96547819139084,
    lng: -8.48943000207673,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4995",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man writes the cake silently. The student runs towards a fence happily. A woman builds the cake quickly.",
  },
  {
    locationId: "item22996",
    locationName: "item22996",
    locationAddress: "item22996",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 0.41 },
    ],
    lat: 51.069132148191315,
    lng: -7.722128341808648,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4996",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription: " A woman eats a book lazily.",
  },
  {
    locationId: "item22997",
    locationName: "item22997",
    locationAddress: "item22997",
    ratings: [
      { who: "Similar identities", rating: 2.01 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 51.29293924092175,
    lng: -3.0995965620881085,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item4997",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat runs towards a book happily. The man writes a book angrily. The teacher jumps over a tower silently. The man looks at the road quickly.",
  },
  {
    locationId: "item22998",
    locationName: "item22998",
    locationAddress: "item22998",
    ratings: null,
    lat: 59.13269553838303,
    lng: -7.518835478675619,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item4998",
    tags: [],
    locationDescription:
      " A woman eats a fence gracefully. A woman writes the cake quickly.",
  },
  {
    locationId: "item22999",
    locationName: "item22999",
    locationAddress: "item22999",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 51.0738666738156,
    lng: -1.4444931902454892,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item4999",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards the cake angrily. The cat builds the cake angrily. The teacher looks at a tower quickly.",
  },
  {
    locationId: "item23000",
    locationName: "item23000",
    locationAddress: "item23000",
    ratings: null,
    lat: 50.94228196754149,
    lng: -2.2801980716885284,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5000",
    tags: [],
    locationDescription:
      " A woman writes the horizon angrily. A dog builds a book lazily.",
  },
  {
    locationId: "item23001",
    locationName: "item23001",
    locationAddress: "item23001",
    ratings: [
      { who: "Similar identities", rating: 1.16 },
      { who: "All perspectives", rating: 4.78 },
    ],
    lat: 58.867990973783996,
    lng: -2.026348239112151,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5001",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at the horizon gracefully. The teacher eats the cake quickly. A woman jumps over a book happily.",
  },
  {
    locationId: "item23002",
    locationName: "item23002",
    locationAddress: "item23002",
    ratings: null,
    lat: 57.05729819339014,
    lng: -2.247206914220609,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5002",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon gracefully. A dog looks at a book silently. The man eats the road silently. The cat jumps over a tower gracefully.",
  },
  {
    locationId: "item23003",
    locationName: "item23003",
    locationAddress: "item23003",
    ratings: null,
    lat: 49.96857761774233,
    lng: -0.8431597716162331,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5003",
    tags: [],
    locationDescription:
      " The man writes a fence angrily. The student runs towards a book gracefully. The man eats a book angrily. A woman builds the road happily.",
  },
  {
    locationId: "item23004",
    locationName: "item23004",
    locationAddress: "item23004",
    ratings: null,
    lat: 53.76268840342709,
    lng: -7.809150506088959,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5004",
    tags: [],
    locationDescription:
      " A dog builds the road angrily. The student writes a fence gracefully. The cat builds a book quickly. The teacher jumps over a tower angrily. The cat builds a fence silently.",
  },
  {
    locationId: "item23005",
    locationName: "item23005",
    locationAddress: "item23005",
    ratings: [
      { who: "Similar identities", rating: 3.07 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 59.700397139164,
    lng: -3.9476430522515997,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5005",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man writes the road silently. The student looks at a tower silently.",
  },
  {
    locationId: "item23006",
    locationName: "item23006",
    locationAddress: "item23006",
    ratings: [
      { who: "Similar identities", rating: 1.63 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 56.854308270309836,
    lng: -2.0049388846094063,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5006",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman builds a tower angrily. The teacher jumps over a fence gracefully. The man jumps over a tower happily. The cat eats the cake silently. The cat eats a tower quickly.",
  },
  {
    locationId: "item23007",
    locationName: "item23007",
    locationAddress: "item23007",
    ratings: null,
    lat: 51.114414388704645,
    lng: 1.5995247322161905,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5007",
    tags: [],
    locationDescription: " The man builds the horizon gracefully.",
  },
  {
    locationId: "item23008",
    locationName: "item23008",
    locationAddress: "item23008",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 60.753054881239365,
    lng: -2.1920151069773866,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5008",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat writes a fence happily. The teacher writes a fence quickly. The student jumps over a book silently. The student runs towards a tower angrily. The student eats a fence gracefully.",
  },
  {
    locationId: "item23009",
    locationName: "item23009",
    locationAddress: "item23009",
    ratings: [
      { who: "Similar identities", rating: 4.49 },
      { who: "All perspectives", rating: 1.54 },
    ],
    lat: 57.3570608611664,
    lng: -1.6445866948273222,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5009",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at the cake quickly. The man eats a tower silently. The man looks at the cake gracefully. A dog jumps over the horizon silently.",
  },
  {
    locationId: "item23010",
    locationName: "item23010",
    locationAddress: "item23010",
    ratings: [
      { who: "Similar identities", rating: 0.74 },
      { who: "All perspectives", rating: 3.81 },
    ],
    lat: 50.677739521611215,
    lng: -7.148765376439093,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5010",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The cat jumps over a book lazily. A dog builds a fence angrily. A woman builds the road lazily. The teacher writes the cake silently. The man eats the horizon silently.",
  },
  {
    locationId: "item23011",
    locationName: "item23011",
    locationAddress: "item23011",
    ratings: null,
    lat: 53.8330939937775,
    lng: -7.656849733420303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5011",
    tags: [],
    locationDescription:
      " The man runs towards the cake happily. The man builds a book happily. A woman eats the road happily.",
  },
  {
    locationId: "item23012",
    locationName: "item23012",
    locationAddress: "item23012",
    ratings: null,
    lat: 51.2937581293127,
    lng: -1.2220002243812687,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5012",
    tags: [],
    locationDescription:
      " The cat jumps over a tower lazily. The teacher looks at a fence happily. A dog jumps over a fence lazily.",
  },
  {
    locationId: "item23013",
    locationName: "item23013",
    locationAddress: "item23013",
    ratings: null,
    lat: 52.37919185471809,
    lng: 1.0291688569479636,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5013",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon lazily. A woman writes a tower angrily. A dog builds a tower angrily. The cat writes a tower happily. The man runs towards the road quickly.",
  },
  {
    locationId: "item23014",
    locationName: "item23014",
    locationAddress: "item23014",
    ratings: [
      { who: "Similar identities", rating: 3.24 },
      { who: "All perspectives", rating: 1.37 },
    ],
    lat: 50.4601636227257,
    lng: -2.400403877113627,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5014",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the horizon quickly. A dog writes the cake quickly. The cat writes a fence angrily. A dog jumps over a tower gracefully. The student eats the horizon gracefully.",
  },
  {
    locationId: "item23015",
    locationName: "item23015",
    locationAddress: "item23015",
    ratings: null,
    lat: 52.91139527678815,
    lng: -4.092735128162844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5015",
    tags: [],
    locationDescription:
      " A dog looks at a book lazily. The teacher eats a book happily. The student runs towards a tower gracefully.",
  },
  {
    locationId: "item23016",
    locationName: "item23016",
    locationAddress: "item23016",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 3.46 },
    ],
    lat: 53.85572543925995,
    lng: -6.661426871556451,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5016",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman jumps over a tower gracefully. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item23017",
    locationName: "item23017",
    locationAddress: "item23017",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 0.19 },
    ],
    lat: 59.868660030931935,
    lng: -0.833806787729781,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5017",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog runs towards a book silently. The cat eats the horizon silently. A woman looks at a fence quickly.",
  },
  {
    locationId: "item23018",
    locationName: "item23018",
    locationAddress: "item23018",
    ratings: [
      { who: "Similar identities", rating: 1.41 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 58.691224622848345,
    lng: 1.5431890545225713,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5018",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat eats a tower lazily. A dog writes the cake silently. The cat jumps over a tower quickly.",
  },
  {
    locationId: "item23019",
    locationName: "item23019",
    locationAddress: "item23019",
    ratings: [
      { who: "Similar identities", rating: 4.56 },
      { who: "All perspectives", rating: 4.87 },
    ],
    lat: 57.310324474998836,
    lng: -0.29234596717963157,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5019",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat eats a fence angrily. The teacher eats the road happily.",
  },
  {
    locationId: "item23020",
    locationName: "item23020",
    locationAddress: "item23020",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 1.09 },
    ],
    lat: 60.8573385769946,
    lng: -0.031059899333561347,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5020",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man builds a book angrily. The teacher jumps over a book quickly.",
  },
  {
    locationId: "item23021",
    locationName: "item23021",
    locationAddress: "item23021",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 2.7 },
    ],
    lat: 57.164233021479816,
    lng: -2.8164320568289263,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5021",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat eats a tower quickly. The student jumps over the road happily. The cat eats the cake angrily. The man looks at a book angrily.",
  },
  {
    locationId: "item23022",
    locationName: "item23022",
    locationAddress: "item23022",
    ratings: null,
    lat: 51.80387350487329,
    lng: 1.4519734794665968,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5022",
    tags: [],
    locationDescription:
      " A dog runs towards a fence angrily. The man eats a book quickly. The teacher jumps over the road angrily.",
  },
  {
    locationId: "item23023",
    locationName: "item23023",
    locationAddress: "item23023",
    ratings: null,
    lat: 54.33498435162172,
    lng: -4.829497544490082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5023",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence lazily. The student runs towards a tower gracefully. The student builds a tower quickly. The cat looks at the cake silently.",
  },
  {
    locationId: "item23024",
    locationName: "item23024",
    locationAddress: "item23024",
    ratings: null,
    lat: 53.32950378114946,
    lng: -1.7074044701233762,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5024",
    tags: [],
    locationDescription:
      " The man eats a fence happily. The student jumps over a fence gracefully. The student looks at a book quickly. The man builds the road silently. A woman writes a book lazily.",
  },
  {
    locationId: "item23025",
    locationName: "item23025",
    locationAddress: "item23025",
    ratings: [
      { who: "Similar identities", rating: 3.97 },
      { who: "All perspectives", rating: 0.05 },
    ],
    lat: 51.26434098262703,
    lng: -8.041556086769742,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5025",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A woman jumps over a book lazily. The student jumps over the horizon angrily. The cat looks at a tower gracefully.",
  },
  {
    locationId: "item23026",
    locationName: "item23026",
    locationAddress: "item23026",
    ratings: null,
    lat: 55.9919097018257,
    lng: -1.4106864055555288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5026",
    tags: [],
    locationDescription:
      " A dog runs towards the road gracefully. A woman runs towards a fence lazily. The cat builds a tower angrily. The student runs towards a fence quickly. A dog eats the cake lazily.",
  },
  {
    locationId: "item23027",
    locationName: "item23027",
    locationAddress: "item23027",
    ratings: [
      { who: "Similar identities", rating: 4.43 },
      { who: "All perspectives", rating: 1.94 },
    ],
    lat: 57.78493855745087,
    lng: -8.131900312109131,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5027",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher runs towards the cake quickly. A woman jumps over the road gracefully. The teacher looks at a fence angrily. The student eats the cake happily.",
  },
  {
    locationId: "item23028",
    locationName: "item23028",
    locationAddress: "item23028",
    ratings: null,
    lat: 50.36148828222875,
    lng: -3.406403189902993,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5028",
    tags: [],
    locationDescription:
      " The teacher writes a fence silently. A dog eats the horizon lazily. A woman looks at the cake silently.",
  },
  {
    locationId: "item23029",
    locationName: "item23029",
    locationAddress: "item23029",
    ratings: null,
    lat: 52.40818330987031,
    lng: -0.5184469525900699,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5029",
    tags: [],
    locationDescription:
      " A woman builds a tower lazily. The cat eats the horizon silently. The teacher eats a fence angrily.",
  },
  {
    locationId: "item23030",
    locationName: "item23030",
    locationAddress: "item23030",
    ratings: [
      { who: "Similar identities", rating: 1.66 },
      { who: "All perspectives", rating: 1.34 },
    ],
    lat: 59.99464190060621,
    lng: 0.014612423459562152,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5030",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat builds a tower quickly. The man eats a tower angrily.",
  },
  {
    locationId: "item23031",
    locationName: "item23031",
    locationAddress: "item23031",
    ratings: [
      { who: "Similar identities", rating: 1.91 },
      { who: "All perspectives", rating: 3.02 },
    ],
    lat: 56.49978522538396,
    lng: -4.548411386635112,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5031",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat jumps over the cake angrily. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item23032",
    locationName: "item23032",
    locationAddress: "item23032",
    ratings: null,
    lat: 51.42180109163393,
    lng: -7.291074409536862,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5032",
    tags: [],
    locationDescription:
      " The man looks at the road gracefully. The cat looks at the horizon gracefully. The cat runs towards the cake lazily. A woman runs towards a tower silently.",
  },
  {
    locationId: "item23033",
    locationName: "item23033",
    locationAddress: "item23033",
    ratings: null,
    lat: 55.616045741078466,
    lng: -6.04705856239347,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5033",
    tags: [],
    locationDescription:
      " The cat eats a tower quickly. The man builds the horizon angrily. The cat builds the road gracefully. A woman looks at the horizon quickly. The cat looks at a book angrily.",
  },
  {
    locationId: "item23034",
    locationName: "item23034",
    locationAddress: "item23034",
    ratings: null,
    lat: 54.485613982097036,
    lng: -3.6011934678425064,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5034",
    tags: [],
    locationDescription:
      " A dog eats the road happily. A dog looks at a tower angrily. The cat builds the cake angrily. A dog looks at the road angrily. A woman jumps over the horizon angrily.",
  },
  {
    locationId: "item23035",
    locationName: "item23035",
    locationAddress: "item23035",
    ratings: null,
    lat: 56.407761060484866,
    lng: -1.6783403818866107,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5035",
    tags: [],
    locationDescription:
      " The student runs towards a tower happily. The cat writes a tower gracefully. The cat looks at a book lazily. The man jumps over the cake lazily. A dog builds the road angrily.",
  },
  {
    locationId: "item23036",
    locationName: "item23036",
    locationAddress: "item23036",
    ratings: [
      { who: "Similar identities", rating: 0.4 },
      { who: "All perspectives", rating: 0.01 },
    ],
    lat: 53.588579370703556,
    lng: 1.7215150582957577,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5036",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes a book angrily. A dog jumps over a fence quickly. The student looks at the cake angrily.",
  },
  {
    locationId: "item23037",
    locationName: "item23037",
    locationAddress: "item23037",
    ratings: null,
    lat: 60.083032451917354,
    lng: -2.3954287926165962,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5037",
    tags: [],
    locationDescription:
      " A dog writes a tower lazily. A woman builds a tower angrily. A woman runs towards a fence silently. A dog builds a fence happily.",
  },
  {
    locationId: "item23038",
    locationName: "item23038",
    locationAddress: "item23038",
    ratings: [
      { who: "Similar identities", rating: 2.76 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 55.24170243098013,
    lng: -5.076472639641881,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5038",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The man jumps over the horizon quickly. The teacher looks at a tower lazily. The cat jumps over the road lazily. The teacher runs towards a book angrily.",
  },
  {
    locationId: "item23039",
    locationName: "item23039",
    locationAddress: "item23039",
    ratings: null,
    lat: 52.56957644074315,
    lng: -2.153478185756648,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5039",
    tags: [],
    locationDescription:
      " A woman jumps over the cake gracefully. The teacher builds a fence happily. The teacher eats the road happily. The man jumps over a tower angrily. The teacher looks at a book lazily.",
  },
  {
    locationId: "item23040",
    locationName: "item23040",
    locationAddress: "item23040",
    ratings: null,
    lat: 50.01030971473041,
    lng: -3.5077779371025475,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5040",
    tags: [],
    locationDescription:
      " The student looks at the horizon gracefully. The man jumps over the road lazily. The student jumps over the cake happily. The cat looks at the horizon happily. The cat writes a fence lazily.",
  },
  {
    locationId: "item23041",
    locationName: "item23041",
    locationAddress: "item23041",
    ratings: null,
    lat: 59.06772287999774,
    lng: -1.0876146479663307,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5041",
    tags: [],
    locationDescription:
      " A woman writes the horizon angrily. The teacher jumps over the cake angrily. A dog jumps over the cake happily.",
  },
  {
    locationId: "item23042",
    locationName: "item23042",
    locationAddress: "item23042",
    ratings: null,
    lat: 52.68727316288599,
    lng: -4.750568228245076,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5042",
    tags: [],
    locationDescription:
      " A woman builds a book lazily. A dog jumps over the horizon lazily. A woman builds a tower angrily. A woman eats the horizon happily. A dog looks at the road happily.",
  },
  {
    locationId: "item23043",
    locationName: "item23043",
    locationAddress: "item23043",
    ratings: null,
    lat: 53.96716283641555,
    lng: -2.6126335860249386,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5043",
    tags: [],
    locationDescription:
      " The cat eats a book lazily. The man looks at a fence happily. The student builds the horizon angrily. The teacher looks at the road angrily. The man eats the road angrily.",
  },
  {
    locationId: "item23044",
    locationName: "item23044",
    locationAddress: "item23044",
    ratings: null,
    lat: 57.17874934537912,
    lng: -4.8803070113512295,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5044",
    tags: [],
    locationDescription:
      " The cat eats the road angrily. A dog builds a book angrily. A woman runs towards the horizon gracefully. A woman jumps over a fence quickly. A dog builds a fence gracefully.",
  },
  {
    locationId: "item23045",
    locationName: "item23045",
    locationAddress: "item23045",
    ratings: null,
    lat: 53.44807137317119,
    lng: 0.4203802573225577,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5045",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon lazily. A woman eats a book lazily. The man writes the cake angrily. The man writes a book silently. The teacher eats the cake lazily.",
  },
  {
    locationId: "item23046",
    locationName: "item23046",
    locationAddress: "item23046",
    ratings: [
      { who: "Similar identities", rating: 1.32 },
      { who: "All perspectives", rating: 4.12 },
    ],
    lat: 54.461929363009446,
    lng: -6.192836096930751,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5046",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards a fence quickly. A dog writes a fence quickly. The student looks at a tower lazily. The cat jumps over a tower angrily. The cat eats a fence lazily.",
  },
  {
    locationId: "item23047",
    locationName: "item23047",
    locationAddress: "item23047",
    ratings: null,
    lat: 51.850688849720434,
    lng: -3.5970268044036384,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5047",
    tags: [],
    locationDescription:
      " A dog looks at the horizon silently. The cat looks at the cake lazily. The cat looks at a book gracefully. The teacher eats a book quickly. A woman writes the road quickly.",
  },
  {
    locationId: "item23048",
    locationName: "item23048",
    locationAddress: "item23048",
    ratings: null,
    lat: 55.209232508995264,
    lng: -2.7164240845436316,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5048",
    tags: [],
    locationDescription:
      " The cat writes a tower gracefully. The student looks at a fence quickly. The cat looks at a tower silently.",
  },
  {
    locationId: "item23049",
    locationName: "item23049",
    locationAddress: "item23049",
    ratings: null,
    lat: 52.4941404254204,
    lng: -7.345291708441354,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5049",
    tags: [],
    locationDescription:
      " The student runs towards the horizon gracefully. The student looks at the horizon silently. A woman jumps over a book lazily. The student builds the road quickly. The teacher builds a book gracefully.",
  },
  {
    locationId: "item23050",
    locationName: "item23050",
    locationAddress: "item23050",
    ratings: null,
    lat: 52.08283792122574,
    lng: -5.451382851894657,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5050",
    tags: [],
    locationDescription:
      " The cat builds the cake gracefully. The student builds a fence gracefully. The man runs towards a fence quickly. The student looks at a fence angrily.",
  },
  {
    locationId: "item23051",
    locationName: "item23051",
    locationAddress: "item23051",
    ratings: [
      { who: "Similar identities", rating: 2.05 },
      { who: "All perspectives", rating: 4.18 },
    ],
    lat: 49.93410628687654,
    lng: 0.3851120804041148,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5051",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher eats the road happily. A woman runs towards a book silently.",
  },
  {
    locationId: "item23052",
    locationName: "item23052",
    locationAddress: "item23052",
    ratings: null,
    lat: 55.56687792717592,
    lng: -5.964160277387419,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5052",
    tags: [],
    locationDescription:
      " The man jumps over the cake quickly. The man looks at a tower silently. The student looks at the horizon silently. The cat eats the cake gracefully. The cat writes a fence happily.",
  },
  {
    locationId: "item23053",
    locationName: "item23053",
    locationAddress: "item23053",
    ratings: null,
    lat: 56.9835688586634,
    lng: -3.0920305470430822,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5053",
    tags: [],
    locationDescription: " A woman looks at the road lazily.",
  },
  {
    locationId: "item23054",
    locationName: "item23054",
    locationAddress: "item23054",
    ratings: null,
    lat: 52.26145163777693,
    lng: -2.7623393972282155,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5054",
    tags: [],
    locationDescription: " The student builds a fence lazily.",
  },
  {
    locationId: "item23055",
    locationName: "item23055",
    locationAddress: "item23055",
    ratings: null,
    lat: 51.83736651663113,
    lng: -3.5680435294123463,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5055",
    tags: [],
    locationDescription:
      " A dog jumps over the road lazily. A dog writes the road quickly. The cat jumps over a tower gracefully. The teacher writes the road happily.",
  },
  {
    locationId: "item23056",
    locationName: "item23056",
    locationAddress: "item23056",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 53.69398301341586,
    lng: -5.249751065130067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5056",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat writes the horizon angrily. The teacher jumps over a tower gracefully. The cat builds a tower silently.",
  },
  {
    locationId: "item23057",
    locationName: "item23057",
    locationAddress: "item23057",
    ratings: [
      { who: "Similar identities", rating: 3.95 },
      { who: "All perspectives", rating: 3.24 },
    ],
    lat: 54.69083501187548,
    lng: 0.9130244907201437,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5057",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a tower quickly. The man looks at the horizon lazily. The teacher eats a book lazily. The man eats a fence happily. The teacher eats a book happily.",
  },
  {
    locationId: "item23058",
    locationName: "item23058",
    locationAddress: "item23058",
    ratings: null,
    lat: 55.909526466220065,
    lng: -5.275877155786633,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5058",
    tags: [],
    locationDescription:
      " A woman eats a fence lazily. The student runs towards a book happily. The man runs towards a book lazily.",
  },
  {
    locationId: "item23059",
    locationName: "item23059",
    locationAddress: "item23059",
    ratings: [
      { who: "Similar identities", rating: 1.84 },
      { who: "All perspectives", rating: 1.74 },
    ],
    lat: 51.20251974442146,
    lng: -1.1638251537068083,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5059",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher writes the horizon happily. A woman runs towards a fence gracefully. The cat jumps over a fence lazily. The student runs towards a book gracefully. A dog writes the road gracefully.",
  },
  {
    locationId: "item23060",
    locationName: "item23060",
    locationAddress: "item23060",
    ratings: null,
    lat: 59.41141335432414,
    lng: 0.9082989900151954,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5060",
    tags: [],
    locationDescription: " The student looks at a fence gracefully.",
  },
  {
    locationId: "item23061",
    locationName: "item23061",
    locationAddress: "item23061",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 52.71667793290332,
    lng: -0.8821731201886367,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5061",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds the road angrily. A dog jumps over a book quickly. The teacher builds a book silently. A dog eats a fence happily.",
  },
  {
    locationId: "item23062",
    locationName: "item23062",
    locationAddress: "item23062",
    ratings: null,
    lat: 52.61856092449065,
    lng: 0.08242241923129079,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5062",
    tags: [],
    locationDescription:
      " A woman runs towards a tower silently. A woman jumps over the cake quickly.",
  },
  {
    locationId: "item23063",
    locationName: "item23063",
    locationAddress: "item23063",
    ratings: [
      { who: "Similar identities", rating: 2.24 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 57.15417652091738,
    lng: -5.132042034988688,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5063",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over the horizon lazily. The teacher eats the cake gracefully. The man jumps over the road gracefully. The teacher eats a book silently.",
  },
  {
    locationId: "item23064",
    locationName: "item23064",
    locationAddress: "item23064",
    ratings: null,
    lat: 60.56754437125032,
    lng: -1.6145800768483385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5064",
    tags: [],
    locationDescription:
      " The teacher jumps over the road silently. The man looks at the road angrily. A dog builds the horizon gracefully. The student eats a fence happily.",
  },
  {
    locationId: "item23065",
    locationName: "item23065",
    locationAddress: "item23065",
    ratings: null,
    lat: 54.20588694981308,
    lng: -0.09481804536287441,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5065",
    tags: [],
    locationDescription:
      " The student runs towards a tower angrily. The teacher jumps over the cake lazily. The student builds the cake gracefully.",
  },
  {
    locationId: "item23066",
    locationName: "item23066",
    locationAddress: "item23066",
    ratings: null,
    lat: 51.649599107900436,
    lng: -8.271490923663919,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5066",
    tags: [],
    locationDescription:
      " A dog writes a tower gracefully. A dog writes a tower lazily. The teacher builds the cake silently. The teacher builds the horizon lazily.",
  },
  {
    locationId: "item23067",
    locationName: "item23067",
    locationAddress: "item23067",
    ratings: null,
    lat: 59.41506770475266,
    lng: -3.3909720300531303,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5067",
    tags: [],
    locationDescription:
      " A dog writes a tower happily. A woman builds a fence angrily. The teacher eats the cake quickly. The cat eats a fence quickly. The teacher looks at the road lazily.",
  },
  {
    locationId: "item23068",
    locationName: "item23068",
    locationAddress: "item23068",
    ratings: null,
    lat: 59.05685679334795,
    lng: -1.79569855649323,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5068",
    tags: [],
    locationDescription:
      " The cat looks at the road quickly. The man eats the cake lazily. A woman eats a book happily. A dog jumps over the cake angrily.",
  },
  {
    locationId: "item23069",
    locationName: "item23069",
    locationAddress: "item23069",
    ratings: null,
    lat: 58.71526492838052,
    lng: 0.05234513977887545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5069",
    tags: [],
    locationDescription:
      " The cat runs towards a tower gracefully. The student jumps over a fence gracefully. The cat eats a fence gracefully. The teacher eats the road gracefully.",
  },
  {
    locationId: "item23070",
    locationName: "item23070",
    locationAddress: "item23070",
    ratings: null,
    lat: 60.732655268269035,
    lng: -4.655924909349835,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5070",
    tags: [],
    locationDescription: " A dog looks at the road lazily.",
  },
  {
    locationId: "item23071",
    locationName: "item23071",
    locationAddress: "item23071",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 3.14 },
    ],
    lat: 52.3407522197092,
    lng: -2.065376445807562,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5071",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher writes a fence gracefully. The man builds the road quickly. The man eats the road lazily. The student jumps over the horizon angrily. The teacher runs towards a fence quickly.",
  },
  {
    locationId: "item23072",
    locationName: "item23072",
    locationAddress: "item23072",
    ratings: null,
    lat: 58.54666996147043,
    lng: 1.0448932183368118,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5072",
    tags: [],
    locationDescription:
      " A dog jumps over a book lazily. A dog looks at the cake lazily.",
  },
  {
    locationId: "item23073",
    locationName: "item23073",
    locationAddress: "item23073",
    ratings: null,
    lat: 50.771805311316996,
    lng: -1.1028444574365803,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5073",
    tags: [],
    locationDescription:
      " The cat eats the horizon quickly. The teacher writes the horizon silently. The cat eats the horizon angrily. The teacher writes the cake gracefully.",
  },
  {
    locationId: "item23074",
    locationName: "item23074",
    locationAddress: "item23074",
    ratings: null,
    lat: 50.665929946335176,
    lng: 0.8058077431375512,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5074",
    tags: [],
    locationDescription:
      " A woman eats a book quickly. A dog jumps over the cake angrily. The teacher looks at the cake silently. The teacher builds the road angrily. A woman eats the road happily.",
  },
  {
    locationId: "item23075",
    locationName: "item23075",
    locationAddress: "item23075",
    ratings: null,
    lat: 60.882565959852144,
    lng: -1.021574123418313,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5075",
    tags: [],
    locationDescription:
      " A woman writes a tower happily. A woman writes a tower angrily.",
  },
  {
    locationId: "item23076",
    locationName: "item23076",
    locationAddress: "item23076",
    ratings: [
      { who: "Similar identities", rating: 1.96 },
      { who: "All perspectives", rating: 2.27 },
    ],
    lat: 60.4668286207838,
    lng: -1.9928064604123712,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5076",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man writes the cake angrily. A woman eats the road gracefully. The teacher jumps over the road quickly.",
  },
  {
    locationId: "item23077",
    locationName: "item23077",
    locationAddress: "item23077",
    ratings: [
      { who: "Similar identities", rating: 4.78 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 60.72001757456507,
    lng: -6.327216778148452,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5077",
    tags: [{ label: "accessible" }],
    locationDescription: " The teacher runs towards a fence gracefully.",
  },
  {
    locationId: "item23078",
    locationName: "item23078",
    locationAddress: "item23078",
    ratings: null,
    lat: 59.94686061250217,
    lng: -0.4750139334895582,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5078",
    tags: [],
    locationDescription:
      " A dog builds a tower gracefully. The teacher eats the cake lazily. The man looks at the road angrily. A dog jumps over a tower happily.",
  },
  {
    locationId: "item23079",
    locationName: "item23079",
    locationAddress: "item23079",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 51.546531848084186,
    lng: -4.3541587924153795,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5079",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards a book happily. The student writes the horizon quickly. A woman eats a fence quickly. The cat jumps over a fence quickly.",
  },
  {
    locationId: "item23080",
    locationName: "item23080",
    locationAddress: "item23080",
    ratings: [
      { who: "Similar identities", rating: 4.54 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 55.08577915362012,
    lng: 1.3118232460985322,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5080",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes the cake angrily. The man looks at the horizon quickly. A dog eats the cake quickly. The cat looks at a fence gracefully.",
  },
  {
    locationId: "item23081",
    locationName: "item23081",
    locationAddress: "item23081",
    ratings: [
      { who: "Similar identities", rating: 1.97 },
      { who: "All perspectives", rating: 4.41 },
    ],
    lat: 60.504937236725596,
    lng: -5.483900905115074,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5081",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " The teacher jumps over a fence silently. The student eats the road angrily.",
  },
  {
    locationId: "item23082",
    locationName: "item23082",
    locationAddress: "item23082",
    ratings: [
      { who: "Similar identities", rating: 3.26 },
      { who: "All perspectives", rating: 1.45 },
    ],
    lat: 57.49093154010295,
    lng: -3.0465499143737276,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5082",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman writes a book quickly. The teacher writes a fence angrily. The cat eats a fence quickly. The teacher writes a tower happily.",
  },
  {
    locationId: "item23083",
    locationName: "item23083",
    locationAddress: "item23083",
    ratings: null,
    lat: 51.819812079110584,
    lng: -7.440437750620028,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5083",
    tags: [],
    locationDescription:
      " The man looks at the cake happily. A dog jumps over a tower happily. The man builds the road gracefully. The cat builds the cake quickly.",
  },
  {
    locationId: "item23084",
    locationName: "item23084",
    locationAddress: "item23084",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 3.85 },
    ],
    lat: 55.6814999995737,
    lng: -7.581689312000291,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5084",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man writes a tower lazily. The student jumps over the cake lazily. The teacher jumps over a fence quickly.",
  },
  {
    locationId: "item23085",
    locationName: "item23085",
    locationAddress: "item23085",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 4.57 },
    ],
    lat: 50.68167107406345,
    lng: -3.949833815091506,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5085",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The teacher runs towards the road lazily. The student builds a book quickly.",
  },
  {
    locationId: "item23086",
    locationName: "item23086",
    locationAddress: "item23086",
    ratings: null,
    lat: 60.411521142661215,
    lng: -3.4772374929452843,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5086",
    tags: [],
    locationDescription:
      " The student jumps over the road happily. A dog writes a tower gracefully. A woman jumps over a tower angrily. The cat jumps over a fence quickly. The man runs towards a fence lazily.",
  },
  {
    locationId: "item23087",
    locationName: "item23087",
    locationAddress: "item23087",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 1.16 },
    ],
    lat: 57.9795034382918,
    lng: -4.44046303376821,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5087",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man builds the horizon angrily. A woman looks at a fence angrily. The cat looks at the road gracefully. A dog writes the cake lazily.",
  },
  {
    locationId: "item23088",
    locationName: "item23088",
    locationAddress: "item23088",
    ratings: null,
    lat: 58.91895630132888,
    lng: -8.320186873710355,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5088",
    tags: [],
    locationDescription: " The cat eats a fence lazily.",
  },
  {
    locationId: "item23089",
    locationName: "item23089",
    locationAddress: "item23089",
    ratings: null,
    lat: 51.831276538245845,
    lng: -6.979547055208096,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5089",
    tags: [],
    locationDescription:
      " The teacher eats a tower silently. The teacher jumps over a tower happily. A dog eats the horizon quickly. The cat runs towards the cake gracefully. The student builds a tower silently.",
  },
  {
    locationId: "item23090",
    locationName: "item23090",
    locationAddress: "item23090",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 4.31 },
    ],
    lat: 57.21372843616367,
    lng: 0.8802681340295067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5090",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog runs towards a fence gracefully.",
  },
  {
    locationId: "item23091",
    locationName: "item23091",
    locationAddress: "item23091",
    ratings: [
      { who: "Similar identities", rating: 1.37 },
      { who: "All perspectives", rating: 4.23 },
    ],
    lat: 58.38453107541147,
    lng: -5.744432981258781,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5091",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher writes a tower gracefully. The man runs towards a fence quickly.",
  },
  {
    locationId: "item23092",
    locationName: "item23092",
    locationAddress: "item23092",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 3.52 },
    ],
    lat: 51.036407461333546,
    lng: -5.9449125204641415,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5092",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The man builds the cake lazily. The cat runs towards a fence angrily. The student looks at a tower gracefully. The man runs towards the road silently.",
  },
  {
    locationId: "item23093",
    locationName: "item23093",
    locationAddress: "item23093",
    ratings: [
      { who: "Similar identities", rating: 4.3 },
      { who: "All perspectives", rating: 3.65 },
    ],
    lat: 59.930804944884834,
    lng: -7.702504613672077,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5093",
    tags: [{ label: "child friendly" }],
    locationDescription: " The teacher jumps over a book gracefully.",
  },
  {
    locationId: "item23094",
    locationName: "item23094",
    locationAddress: "item23094",
    ratings: null,
    lat: 53.621537186431375,
    lng: -2.9714595445957874,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5094",
    tags: [],
    locationDescription:
      " A woman jumps over a book gracefully. The man jumps over the horizon happily. The teacher runs towards a fence happily.",
  },
  {
    locationId: "item23095",
    locationName: "item23095",
    locationAddress: "item23095",
    ratings: [
      { who: "Similar identities", rating: 1.14 },
      { who: "All perspectives", rating: 0.59 },
    ],
    lat: 50.54465540441516,
    lng: 0.831582808030694,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5095",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat looks at the road angrily. The student runs towards the cake lazily.",
  },
  {
    locationId: "item23096",
    locationName: "item23096",
    locationAddress: "item23096",
    ratings: null,
    lat: 55.103423289390186,
    lng: -5.124498190078615,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5096",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake gracefully. A woman looks at the cake lazily. The man builds the cake silently. The man jumps over a fence lazily. A dog looks at a fence silently.",
  },
  {
    locationId: "item23097",
    locationName: "item23097",
    locationAddress: "item23097",
    ratings: null,
    lat: 54.20998616247492,
    lng: -7.544977862905856,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5097",
    tags: [],
    locationDescription:
      " A woman runs towards the road quickly. The cat jumps over a fence happily. The teacher runs towards a book silently. The man builds a fence gracefully. A dog writes a tower gracefully.",
  },
  {
    locationId: "item23098",
    locationName: "item23098",
    locationAddress: "item23098",
    ratings: null,
    lat: 51.57383604003563,
    lng: -5.43564000831053,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5098",
    tags: [],
    locationDescription:
      " The student writes the cake silently. The teacher builds a fence gracefully. A woman writes the cake lazily.",
  },
  {
    locationId: "item23099",
    locationName: "item23099",
    locationAddress: "item23099",
    ratings: null,
    lat: 53.875631225707224,
    lng: 1.2877336242216106,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5099",
    tags: [],
    locationDescription:
      " A dog eats the cake lazily. A woman runs towards the road gracefully. The student jumps over a fence quickly. A dog writes a fence silently. The student builds the cake lazily.",
  },
  {
    locationId: "item23100",
    locationName: "item23100",
    locationAddress: "item23100",
    ratings: [
      { who: "Similar identities", rating: 2.0 },
      { who: "All perspectives", rating: 3.17 },
    ],
    lat: 54.99572762105831,
    lng: 0.7951781234423692,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5100",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog looks at a fence happily. The man jumps over a fence silently. The man builds a book quickly. The student eats a tower angrily.",
  },
  {
    locationId: "item23101",
    locationName: "item23101",
    locationAddress: "item23101",
    ratings: null,
    lat: 55.01504097684369,
    lng: -1.2194154208751717,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5101",
    tags: [],
    locationDescription:
      " The student eats the cake happily. The student writes the cake happily. A dog builds a fence lazily.",
  },
  {
    locationId: "item23102",
    locationName: "item23102",
    locationAddress: "item23102",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 0.77 },
    ],
    lat: 58.171011282059325,
    lng: -5.823758196501346,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5102",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The student eats the cake silently.",
  },
  {
    locationId: "item23103",
    locationName: "item23103",
    locationAddress: "item23103",
    ratings: null,
    lat: 53.74769912686231,
    lng: -7.6703369595839535,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5103",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. A dog eats a fence quickly. The cat looks at the road gracefully. The teacher runs towards a book quickly. The man runs towards the horizon quickly.",
  },
  {
    locationId: "item23104",
    locationName: "item23104",
    locationAddress: "item23104",
    ratings: null,
    lat: 59.197244336923454,
    lng: -7.702721671879209,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5104",
    tags: [],
    locationDescription:
      " The teacher eats the cake happily. The student runs towards a fence silently.",
  },
  {
    locationId: "item23105",
    locationName: "item23105",
    locationAddress: "item23105",
    ratings: null,
    lat: 56.24417053406044,
    lng: -6.334334591896473,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5105",
    tags: [],
    locationDescription:
      " A dog builds a tower quickly. The student writes a book happily. The student jumps over the horizon lazily.",
  },
  {
    locationId: "item23106",
    locationName: "item23106",
    locationAddress: "item23106",
    ratings: [
      { who: "Similar identities", rating: 0.16 },
      { who: "All perspectives", rating: 3.45 },
    ],
    lat: 58.85628571757588,
    lng: -8.522112114522864,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5106",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog jumps over the horizon silently. A woman eats the road quickly. The teacher writes the horizon gracefully. The student writes a tower angrily.",
  },
  {
    locationId: "item23107",
    locationName: "item23107",
    locationAddress: "item23107",
    ratings: [
      { who: "Similar identities", rating: 2.02 },
      { who: "All perspectives", rating: 0.87 },
    ],
    lat: 51.68387035734309,
    lng: 1.4753034465757526,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5107",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription: " The teacher builds a book silently.",
  },
  {
    locationId: "item23108",
    locationName: "item23108",
    locationAddress: "item23108",
    ratings: [
      { who: "Similar identities", rating: 4.76 },
      { who: "All perspectives", rating: 4.03 },
    ],
    lat: 56.97764194363507,
    lng: -0.9143105449473232,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5108",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman eats the cake quickly. The man builds the cake quickly. A woman looks at the cake gracefully. The man builds the road happily. The cat eats a fence happily.",
  },
  {
    locationId: "item23109",
    locationName: "item23109",
    locationAddress: "item23109",
    ratings: [
      { who: "Similar identities", rating: 3.49 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 55.147880506115015,
    lng: -3.172667620406828,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5109",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman runs towards a book happily. The cat writes a book lazily. The teacher looks at the road quickly. A woman runs towards the road angrily. The student jumps over a book quickly.",
  },
  {
    locationId: "item23110",
    locationName: "item23110",
    locationAddress: "item23110",
    ratings: null,
    lat: 54.4366849691601,
    lng: -4.19580014738684,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5110",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence lazily. The cat jumps over a fence gracefully.",
  },
  {
    locationId: "item23111",
    locationName: "item23111",
    locationAddress: "item23111",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 59.18352442687935,
    lng: -6.523154965969391,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5111",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat eats a tower quickly. The cat runs towards a tower angrily. The student eats a fence happily.",
  },
  {
    locationId: "item23112",
    locationName: "item23112",
    locationAddress: "item23112",
    ratings: [
      { who: "Similar identities", rating: 1.59 },
      { who: "All perspectives", rating: 0.37 },
    ],
    lat: 56.06847876930168,
    lng: -7.260476768639858,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5112",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog looks at the cake happily. A woman builds a tower gracefully. A dog jumps over the road gracefully. A woman runs towards the road quickly. The student builds the road gracefully.",
  },
  {
    locationId: "item23113",
    locationName: "item23113",
    locationAddress: "item23113",
    ratings: [
      { who: "Similar identities", rating: 1.99 },
      { who: "All perspectives", rating: 0.18 },
    ],
    lat: 59.67118656469232,
    lng: -8.325687420217426,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5113",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription: " The student runs towards the horizon lazily.",
  },
  {
    locationId: "item23114",
    locationName: "item23114",
    locationAddress: "item23114",
    ratings: null,
    lat: 56.18086310811609,
    lng: -2.025557390973786,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5114",
    tags: [],
    locationDescription: " A woman looks at the horizon gracefully.",
  },
  {
    locationId: "item23115",
    locationName: "item23115",
    locationAddress: "item23115",
    ratings: [
      { who: "Similar identities", rating: 2.94 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 54.868502758030715,
    lng: 0.8480632667703301,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5115",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A dog builds a book gracefully. The student looks at the road happily. A woman builds the road silently.",
  },
  {
    locationId: "item23116",
    locationName: "item23116",
    locationAddress: "item23116",
    ratings: [
      { who: "Similar identities", rating: 0.98 },
      { who: "All perspectives", rating: 1.64 },
    ],
    lat: 51.43328508639014,
    lng: -6.130134256431067,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5116",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " A dog looks at the cake gracefully. The teacher runs towards a book silently. A woman builds the road quickly. The student writes the horizon silently. A woman jumps over the cake happily.",
  },
  {
    locationId: "item23117",
    locationName: "item23117",
    locationAddress: "item23117",
    ratings: [
      { who: "Similar identities", rating: 0.84 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 58.66727444521894,
    lng: -8.013286307338797,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5117",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher runs towards the horizon silently.",
  },
  {
    locationId: "item23118",
    locationName: "item23118",
    locationAddress: "item23118",
    ratings: null,
    lat: 58.764650769266765,
    lng: -1.376810855238574,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5118",
    tags: [],
    locationDescription:
      " The student jumps over a tower lazily. A dog jumps over the cake quickly.",
  },
  {
    locationId: "item23119",
    locationName: "item23119",
    locationAddress: "item23119",
    ratings: null,
    lat: 58.36611034046526,
    lng: -7.800514731132364,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5119",
    tags: [],
    locationDescription:
      " A woman builds the road angrily. The cat builds the cake lazily. The student jumps over the horizon angrily. The man jumps over the horizon quickly. A woman looks at a fence lazily.",
  },
  {
    locationId: "item23120",
    locationName: "item23120",
    locationAddress: "item23120",
    ratings: [
      { who: "Similar identities", rating: 2.85 },
      { who: "All perspectives", rating: 3.37 },
    ],
    lat: 60.41917015296466,
    lng: 1.3504084999277381,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5120",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher builds a tower angrily. The student looks at the road happily. The teacher writes the cake gracefully. A woman runs towards the horizon lazily.",
  },
  {
    locationId: "item23121",
    locationName: "item23121",
    locationAddress: "item23121",
    ratings: [
      { who: "Similar identities", rating: 4.55 },
      { who: "All perspectives", rating: 1.08 },
    ],
    lat: 60.67908715352845,
    lng: -6.939749913177043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5121",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats the road quickly. The man builds the cake angrily. A dog builds a fence quickly. The student builds the cake angrily. The cat looks at the road gracefully.",
  },
  {
    locationId: "item23122",
    locationName: "item23122",
    locationAddress: "item23122",
    ratings: null,
    lat: 60.01458267418694,
    lng: -6.288205607914203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5122",
    tags: [],
    locationDescription:
      " A dog jumps over a book angrily. A woman builds the road gracefully. The student eats a book lazily. The student looks at the cake silently. A dog builds a tower silently.",
  },
  {
    locationId: "item23123",
    locationName: "item23123",
    locationAddress: "item23123",
    ratings: null,
    lat: 51.2763788622638,
    lng: -4.235694805827247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5123",
    tags: [],
    locationDescription: " The teacher jumps over the cake quickly.",
  },
  {
    locationId: "item23124",
    locationName: "item23124",
    locationAddress: "item23124",
    ratings: null,
    lat: 60.08514637518712,
    lng: -3.934798297464467,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5124",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon lazily. A dog eats a tower happily. The cat builds a fence lazily. The man builds the road quickly.",
  },
  {
    locationId: "item23125",
    locationName: "item23125",
    locationAddress: "item23125",
    ratings: null,
    lat: 50.6286643949108,
    lng: -0.2661063918588926,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5125",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon gracefully. The teacher builds a book silently. A woman jumps over the cake lazily. The cat jumps over the road angrily. The teacher looks at a fence gracefully.",
  },
  {
    locationId: "item23126",
    locationName: "item23126",
    locationAddress: "item23126",
    ratings: null,
    lat: 59.86838030549556,
    lng: 0.9054013757939838,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5126",
    tags: [],
    locationDescription: " The teacher eats a tower happily.",
  },
  {
    locationId: "item23127",
    locationName: "item23127",
    locationAddress: "item23127",
    ratings: [
      { who: "Similar identities", rating: 2.1 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 58.06975310424227,
    lng: -5.0856135472124,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5127",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " The student builds the cake angrily.",
  },
  {
    locationId: "item23128",
    locationName: "item23128",
    locationAddress: "item23128",
    ratings: [
      { who: "Similar identities", rating: 2.89 },
      { who: "All perspectives", rating: 0.64 },
    ],
    lat: 52.0996411105853,
    lng: -1.1079319803602026,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5128",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a book gracefully. The teacher looks at the cake gracefully. The teacher eats the horizon quickly. The cat writes a tower angrily.",
  },
  {
    locationId: "item23129",
    locationName: "item23129",
    locationAddress: "item23129",
    ratings: null,
    lat: 55.22636845978547,
    lng: -4.013881623528452,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5129",
    tags: [],
    locationDescription:
      " A dog runs towards the cake gracefully. A woman builds a fence silently. The man writes the horizon gracefully.",
  },
  {
    locationId: "item23130",
    locationName: "item23130",
    locationAddress: "item23130",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 4.97 },
    ],
    lat: 53.94868939860999,
    lng: -8.118489168181123,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5130",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student builds a tower quickly. A dog jumps over the horizon lazily. The cat builds the cake angrily.",
  },
  {
    locationId: "item23131",
    locationName: "item23131",
    locationAddress: "item23131",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 50.181792612373265,
    lng: 0.139519136466161,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5131",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats the horizon quickly. The man eats a tower quickly. The teacher writes a fence lazily.",
  },
  {
    locationId: "item23132",
    locationName: "item23132",
    locationAddress: "item23132",
    ratings: null,
    lat: 51.68598519728106,
    lng: -4.4003037670447025,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5132",
    tags: [],
    locationDescription:
      " The teacher runs towards the road silently. The man looks at the road angrily. The cat writes a tower angrily. A dog runs towards a book gracefully.",
  },
  {
    locationId: "item23133",
    locationName: "item23133",
    locationAddress: "item23133",
    ratings: null,
    lat: 56.45261821731336,
    lng: -3.8432718693195724,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5133",
    tags: [],
    locationDescription:
      " A dog eats a fence gracefully. A dog runs towards the road lazily.",
  },
  {
    locationId: "item23134",
    locationName: "item23134",
    locationAddress: "item23134",
    ratings: [
      { who: "Similar identities", rating: 3.0 },
      { who: "All perspectives", rating: 0.02 },
    ],
    lat: 56.301863707741184,
    lng: -3.4803809123068206,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5134",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog builds a fence happily. The man eats a book happily. The student jumps over the road angrily. The man writes a tower gracefully.",
  },
  {
    locationId: "item23135",
    locationName: "item23135",
    locationAddress: "item23135",
    ratings: null,
    lat: 60.22144318409485,
    lng: -4.166136711203023,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5135",
    tags: [],
    locationDescription:
      " The cat writes a fence angrily. The student runs towards a book happily. The teacher writes a book happily.",
  },
  {
    locationId: "item23136",
    locationName: "item23136",
    locationAddress: "item23136",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 55.32079459621477,
    lng: -8.307994849070765,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5136",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats a fence lazily. A dog eats the cake silently. The teacher eats the cake quickly. The student builds a book angrily. The student eats a tower silently.",
  },
  {
    locationId: "item23137",
    locationName: "item23137",
    locationAddress: "item23137",
    ratings: [
      { who: "Similar identities", rating: 3.41 },
      { who: "All perspectives", rating: 1.2 },
    ],
    lat: 51.30662241404739,
    lng: -6.029137403132278,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5137",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog looks at the cake quickly. A dog writes a fence silently. The man jumps over the horizon quickly. The teacher writes a fence happily. A dog builds a fence silently.",
  },
  {
    locationId: "item23138",
    locationName: "item23138",
    locationAddress: "item23138",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 52.74707329304532,
    lng: -6.48327674356231,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5138",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at a fence silently. A woman looks at the road lazily. The teacher builds a fence quickly.",
  },
  {
    locationId: "item23139",
    locationName: "item23139",
    locationAddress: "item23139",
    ratings: null,
    lat: 53.86961314035783,
    lng: 1.5248243428916002,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5139",
    tags: [],
    locationDescription: " The man writes the road quickly.",
  },
  {
    locationId: "item23140",
    locationName: "item23140",
    locationAddress: "item23140",
    ratings: null,
    lat: 58.1741052596615,
    lng: -6.068836968779967,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5140",
    tags: [],
    locationDescription:
      " The man looks at the cake angrily. The teacher looks at the horizon silently.",
  },
  {
    locationId: "item23141",
    locationName: "item23141",
    locationAddress: "item23141",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 4.99 },
    ],
    lat: 60.46797481809864,
    lng: 0.9551003323715452,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5141",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman looks at a fence quickly.",
  },
  {
    locationId: "item23142",
    locationName: "item23142",
    locationAddress: "item23142",
    ratings: null,
    lat: 60.53249228832597,
    lng: -4.478954489563041,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5142",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. The teacher eats the road happily. A dog jumps over a tower silently.",
  },
  {
    locationId: "item23143",
    locationName: "item23143",
    locationAddress: "item23143",
    ratings: [
      { who: "Similar identities", rating: 0.19 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 52.09174515674825,
    lng: 1.5067267549980201,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5143",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The man looks at the cake happily. A dog runs towards the cake quickly. The cat writes the road happily.",
  },
  {
    locationId: "item23144",
    locationName: "item23144",
    locationAddress: "item23144",
    ratings: null,
    lat: 57.55249861892798,
    lng: -7.742743245673521,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5144",
    tags: [],
    locationDescription:
      " The teacher builds a tower angrily. The cat builds a book lazily.",
  },
  {
    locationId: "item23145",
    locationName: "item23145",
    locationAddress: "item23145",
    ratings: [
      { who: "Similar identities", rating: 0.23 },
      { who: "All perspectives", rating: 2.37 },
    ],
    lat: 55.53134584202594,
    lng: -5.683125679338184,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5145",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " A dog eats the horizon gracefully.",
  },
  {
    locationId: "item23146",
    locationName: "item23146",
    locationAddress: "item23146",
    ratings: null,
    lat: 54.58794902185625,
    lng: -1.9686395889006292,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5146",
    tags: [],
    locationDescription:
      " The cat writes a fence happily. A dog writes a fence gracefully. A dog builds the cake angrily.",
  },
  {
    locationId: "item23147",
    locationName: "item23147",
    locationAddress: "item23147",
    ratings: null,
    lat: 58.69197605623957,
    lng: 1.514831149013519,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5147",
    tags: [],
    locationDescription: " The cat eats a tower silently.",
  },
  {
    locationId: "item23148",
    locationName: "item23148",
    locationAddress: "item23148",
    ratings: null,
    lat: 49.910420396618285,
    lng: -0.7769497679182926,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5148",
    tags: [],
    locationDescription:
      " A dog writes the road lazily. The student looks at a book angrily. The student jumps over the road lazily. A woman jumps over a tower lazily. The man looks at the horizon gracefully.",
  },
  {
    locationId: "item23149",
    locationName: "item23149",
    locationAddress: "item23149",
    ratings: [
      { who: "Similar identities", rating: 0.55 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 58.041620497602956,
    lng: -0.20227743077336946,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5149",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards the road lazily. The man jumps over the road lazily. The cat writes the cake angrily.",
  },
  {
    locationId: "item23150",
    locationName: "item23150",
    locationAddress: "item23150",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 4.01 },
    ],
    lat: 55.71014640322141,
    lng: 1.3344841500466202,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5150",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman eats the cake silently. The teacher runs towards the horizon angrily. The student eats the horizon lazily. The man builds the road silently.",
  },
  {
    locationId: "item23151",
    locationName: "item23151",
    locationAddress: "item23151",
    ratings: null,
    lat: 52.7197548289002,
    lng: -1.4207385318878671,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5151",
    tags: [],
    locationDescription:
      " The cat runs towards a book angrily. The man runs towards a book lazily. The cat eats a book gracefully. The man runs towards the horizon happily. The student builds a fence lazily.",
  },
  {
    locationId: "item23152",
    locationName: "item23152",
    locationAddress: "item23152",
    ratings: [
      { who: "Similar identities", rating: 1.38 },
      { who: "All perspectives", rating: 0.66 },
    ],
    lat: 56.296660144145136,
    lng: -4.15051288161965,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5152",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats a tower silently. The man builds the road happily. A dog writes the road angrily. The man writes the horizon quickly.",
  },
  {
    locationId: "item23153",
    locationName: "item23153",
    locationAddress: "item23153",
    ratings: null,
    lat: 60.031248310820715,
    lng: -3.1947217128822567,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5153",
    tags: [],
    locationDescription: " The student builds a book happily.",
  },
  {
    locationId: "item23154",
    locationName: "item23154",
    locationAddress: "item23154",
    ratings: null,
    lat: 50.45317377661778,
    lng: -1.62936279005205,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5154",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower lazily. The cat runs towards a tower gracefully. A woman runs towards the road lazily. The teacher looks at a fence angrily.",
  },
  {
    locationId: "item23155",
    locationName: "item23155",
    locationAddress: "item23155",
    ratings: [
      { who: "Similar identities", rating: 4.11 },
      { who: "All perspectives", rating: 1.12 },
    ],
    lat: 52.92977644351625,
    lng: -6.533534537769878,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5155",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " A dog builds a tower silently.",
  },
  {
    locationId: "item23156",
    locationName: "item23156",
    locationAddress: "item23156",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 53.87089203252205,
    lng: 0.34230557828656494,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5156",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The man eats a fence gracefully.",
  },
  {
    locationId: "item23157",
    locationName: "item23157",
    locationAddress: "item23157",
    ratings: [
      { who: "Similar identities", rating: 2.53 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 56.72547675006709,
    lng: -8.23278188087142,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5157",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman looks at the cake quickly. The cat eats a tower angrily. The man builds a tower quickly. The man writes a fence gracefully.",
  },
  {
    locationId: "item23158",
    locationName: "item23158",
    locationAddress: "item23158",
    ratings: [
      { who: "Similar identities", rating: 0.56 },
      { who: "All perspectives", rating: 0.13 },
    ],
    lat: 57.104506421330235,
    lng: -1.2438286703131336,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5158",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards the horizon silently. The student eats a fence gracefully. A dog builds a fence lazily. The cat builds a fence lazily.",
  },
  {
    locationId: "item23159",
    locationName: "item23159",
    locationAddress: "item23159",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 3.45 },
    ],
    lat: 51.80957473807368,
    lng: -2.9136684482150192,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5159",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over a tower gracefully. The teacher eats the cake quickly. A dog runs towards a fence happily. The man looks at a fence quickly. The man builds the horizon silently.",
  },
  {
    locationId: "item23160",
    locationName: "item23160",
    locationAddress: "item23160",
    ratings: null,
    lat: 56.11596090615588,
    lng: -0.14134709771709986,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5160",
    tags: [],
    locationDescription:
      " The student writes a book quickly. The student looks at the horizon angrily. The man builds the cake angrily.",
  },
  {
    locationId: "item23161",
    locationName: "item23161",
    locationAddress: "item23161",
    ratings: [
      { who: "Similar identities", rating: 0.77 },
      { who: "All perspectives", rating: 0.9 },
    ],
    lat: 59.07622762180649,
    lng: 0.30705101355456677,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5161",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog builds the road lazily. A dog builds the horizon angrily. The teacher writes the cake quickly. The man jumps over the horizon silently. A woman eats a book gracefully.",
  },
  {
    locationId: "item23162",
    locationName: "item23162",
    locationAddress: "item23162",
    ratings: [
      { who: "Similar identities", rating: 1.52 },
      { who: "All perspectives", rating: 3.87 },
    ],
    lat: 51.805791873049486,
    lng: -7.767045313162863,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5162",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat builds the horizon happily. A dog builds the cake happily. The student looks at a tower happily. The man eats a book lazily. The student eats the cake gracefully.",
  },
  {
    locationId: "item23163",
    locationName: "item23163",
    locationAddress: "item23163",
    ratings: null,
    lat: 53.745944087863556,
    lng: -7.723767346615879,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5163",
    tags: [],
    locationDescription: " The teacher writes a book angrily.",
  },
  {
    locationId: "item23164",
    locationName: "item23164",
    locationAddress: "item23164",
    ratings: null,
    lat: 57.354133749681196,
    lng: -5.927068967140082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5164",
    tags: [],
    locationDescription:
      " The teacher eats the cake happily. A dog looks at the road gracefully. A dog eats the road lazily. A woman writes the cake happily. A dog eats a tower gracefully.",
  },
  {
    locationId: "item23165",
    locationName: "item23165",
    locationAddress: "item23165",
    ratings: null,
    lat: 55.10793931221962,
    lng: -6.835309308400273,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5165",
    tags: [],
    locationDescription:
      " A dog looks at the road gracefully. The teacher eats the road lazily. The student builds a book lazily. The cat jumps over the road silently. A woman writes the cake angrily.",
  },
  {
    locationId: "item23166",
    locationName: "item23166",
    locationAddress: "item23166",
    ratings: [
      { who: "Similar identities", rating: 0.95 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 59.11748755615325,
    lng: -0.3069500055876997,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5166",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student writes the road gracefully. A woman looks at the horizon quickly. A woman writes a fence gracefully.",
  },
  {
    locationId: "item23167",
    locationName: "item23167",
    locationAddress: "item23167",
    ratings: null,
    lat: 51.73427251816193,
    lng: 0.13687359167562185,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5167",
    tags: [],
    locationDescription:
      " The teacher builds a book happily. A woman runs towards a book happily.",
  },
  {
    locationId: "item23168",
    locationName: "item23168",
    locationAddress: "item23168",
    ratings: [
      { who: "Similar identities", rating: 0.43 },
      { who: "All perspectives", rating: 0.85 },
    ],
    lat: 52.63215405939799,
    lng: -8.424754246621175,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5168",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student eats the cake lazily. A woman jumps over a book happily.",
  },
  {
    locationId: "item23169",
    locationName: "item23169",
    locationAddress: "item23169",
    ratings: null,
    lat: 50.8347911004031,
    lng: -0.6129719847026118,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5169",
    tags: [],
    locationDescription:
      " The teacher writes a fence silently. A woman jumps over a tower gracefully.",
  },
  {
    locationId: "item23170",
    locationName: "item23170",
    locationAddress: "item23170",
    ratings: null,
    lat: 50.89809485531706,
    lng: -7.0658423485496975,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5170",
    tags: [],
    locationDescription:
      " The student jumps over a fence lazily. The man runs towards a book angrily. A dog runs towards a fence happily. A woman jumps over the road quickly.",
  },
  {
    locationId: "item23171",
    locationName: "item23171",
    locationAddress: "item23171",
    ratings: [
      { who: "Similar identities", rating: 2.83 },
      { who: "All perspectives", rating: 3.99 },
    ],
    lat: 55.882316005477975,
    lng: -4.602069737771419,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5171",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats the cake lazily. A woman looks at a book happily. The man eats the road lazily.",
  },
  {
    locationId: "item23172",
    locationName: "item23172",
    locationAddress: "item23172",
    ratings: [
      { who: "Similar identities", rating: 3.6 },
      { who: "All perspectives", rating: 2.95 },
    ],
    lat: 55.70869035495895,
    lng: -4.171164521219009,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5172",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher jumps over the horizon angrily. A woman jumps over the road happily. The teacher looks at a tower silently. A dog jumps over the cake silently. The teacher eats a book happily.",
  },
  {
    locationId: "item23173",
    locationName: "item23173",
    locationAddress: "item23173",
    ratings: null,
    lat: 50.92268257638879,
    lng: -7.511256557111398,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5173",
    tags: [],
    locationDescription:
      " A woman builds the cake gracefully. The student runs towards the horizon gracefully. A woman looks at a tower gracefully.",
  },
  {
    locationId: "item23174",
    locationName: "item23174",
    locationAddress: "item23174",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 57.75379793810401,
    lng: -0.6966594666742143,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5174",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at the road gracefully. The cat looks at the cake lazily.",
  },
  {
    locationId: "item23175",
    locationName: "item23175",
    locationAddress: "item23175",
    ratings: null,
    lat: 60.76236583030776,
    lng: -3.0586880762451587,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5175",
    tags: [],
    locationDescription:
      " The man jumps over a fence lazily. A woman runs towards a book happily. The teacher jumps over the road gracefully. A woman builds the cake silently.",
  },
  {
    locationId: "item23176",
    locationName: "item23176",
    locationAddress: "item23176",
    ratings: [
      { who: "Similar identities", rating: 0.37 },
      { who: "All perspectives", rating: 2.94 },
    ],
    lat: 56.4006326393324,
    lng: -8.124597223233204,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5176",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman jumps over a fence lazily. The teacher runs towards the cake angrily. The man builds a book quickly. The man builds the cake silently. The student writes the road angrily.",
  },
  {
    locationId: "item23177",
    locationName: "item23177",
    locationAddress: "item23177",
    ratings: null,
    lat: 57.22410343397263,
    lng: -0.2286935148629894,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5177",
    tags: [],
    locationDescription: " A dog writes a fence angrily.",
  },
  {
    locationId: "item23178",
    locationName: "item23178",
    locationAddress: "item23178",
    ratings: [
      { who: "Similar identities", rating: 0.85 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 60.46951166485967,
    lng: 0.068492429903662,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5178",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat eats a fence quickly. The student jumps over the road quickly. The cat looks at a book quickly. The student builds a fence lazily. The man jumps over a book happily.",
  },
  {
    locationId: "item23179",
    locationName: "item23179",
    locationAddress: "item23179",
    ratings: [
      { who: "Similar identities", rating: 0.48 },
      { who: "All perspectives", rating: 2.63 },
    ],
    lat: 60.12395062079745,
    lng: -6.493578480880537,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5179",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student looks at a tower lazily. The teacher jumps over a book quickly. The student writes a book gracefully.",
  },
  {
    locationId: "item23180",
    locationName: "item23180",
    locationAddress: "item23180",
    ratings: [
      { who: "Similar identities", rating: 2.4 },
      { who: "All perspectives", rating: 4.21 },
    ],
    lat: 58.83356162015277,
    lng: 1.7236486322344717,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5180",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog jumps over the cake gracefully. A dog runs towards a fence angrily. A dog writes the cake quickly. The man writes a fence angrily. A woman looks at the cake happily.",
  },
  {
    locationId: "item23181",
    locationName: "item23181",
    locationAddress: "item23181",
    ratings: [
      { who: "Similar identities", rating: 3.83 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 50.654834012204994,
    lng: -0.13427815667339438,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5181",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes a book angrily. The student runs towards the horizon quickly. The cat looks at the cake gracefully. The man looks at the road silently.",
  },
  {
    locationId: "item23182",
    locationName: "item23182",
    locationAddress: "item23182",
    ratings: [
      { who: "Similar identities", rating: 1.92 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 50.29004416928659,
    lng: -6.409497867045012,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5182",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat looks at a fence gracefully. The student writes a tower angrily. A dog runs towards a fence lazily. The man jumps over a tower angrily.",
  },
  {
    locationId: "item23183",
    locationName: "item23183",
    locationAddress: "item23183",
    ratings: [
      { who: "Similar identities", rating: 2.92 },
      { who: "All perspectives", rating: 4.78 },
    ],
    lat: 53.31098856499321,
    lng: -3.9533682698617483,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5183",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman eats a book happily. A woman eats a tower angrily. The student eats the horizon silently. The student looks at the road gracefully. The student eats the horizon angrily.",
  },
  {
    locationId: "item23184",
    locationName: "item23184",
    locationAddress: "item23184",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 2.08 },
    ],
    lat: 58.46859356498339,
    lng: -4.8104759529469145,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5184",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A dog runs towards the cake angrily.",
  },
  {
    locationId: "item23185",
    locationName: "item23185",
    locationAddress: "item23185",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 3.36 },
    ],
    lat: 52.99682148992306,
    lng: -1.6787580871839722,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5185",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog writes the horizon gracefully. The student eats the cake lazily.",
  },
  {
    locationId: "item23186",
    locationName: "item23186",
    locationAddress: "item23186",
    ratings: null,
    lat: 55.83331473574999,
    lng: -0.2754326536383491,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5186",
    tags: [],
    locationDescription:
      " The cat builds a fence gracefully. The teacher looks at the horizon silently. The man looks at a fence lazily. A dog looks at the road quickly.",
  },
  {
    locationId: "item23187",
    locationName: "item23187",
    locationAddress: "item23187",
    ratings: null,
    lat: 54.666009563866766,
    lng: 0.45912533304433545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5187",
    tags: [],
    locationDescription:
      " The cat eats a book gracefully. The cat writes a tower lazily. The student jumps over a book happily. The man writes a fence gracefully. The man runs towards a fence lazily.",
  },
  {
    locationId: "item23188",
    locationName: "item23188",
    locationAddress: "item23188",
    ratings: null,
    lat: 55.59564874821483,
    lng: 0.06024191390312694,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5188",
    tags: [],
    locationDescription:
      " The man runs towards the horizon silently. A dog runs towards the cake happily. The teacher runs towards a fence quickly. The man looks at a book lazily.",
  },
  {
    locationId: "item23189",
    locationName: "item23189",
    locationAddress: "item23189",
    ratings: null,
    lat: 56.615052890629315,
    lng: -4.872685128642875,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5189",
    tags: [],
    locationDescription:
      " A woman runs towards the road happily. A dog jumps over a fence quickly. The student writes a fence lazily.",
  },
  {
    locationId: "item23190",
    locationName: "item23190",
    locationAddress: "item23190",
    ratings: null,
    lat: 50.591177339717795,
    lng: -3.3324544517891166,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5190",
    tags: [],
    locationDescription:
      " The cat jumps over the road angrily. A woman builds the cake silently. A dog runs towards a fence angrily. The cat jumps over a book happily. A woman writes the road happily.",
  },
  {
    locationId: "item23191",
    locationName: "item23191",
    locationAddress: "item23191",
    ratings: [
      { who: "Similar identities", rating: 4.08 },
      { who: "All perspectives", rating: 4.1 },
    ],
    lat: 52.60836935667977,
    lng: -2.3514780122494994,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5191",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student jumps over a book happily. The man jumps over the cake angrily. A woman jumps over a tower lazily. The man eats a tower lazily.",
  },
  {
    locationId: "item23192",
    locationName: "item23192",
    locationAddress: "item23192",
    ratings: [
      { who: "Similar identities", rating: 2.32 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 51.67817406972764,
    lng: -6.333413899785123,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5192",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " A dog eats a tower quickly.",
  },
  {
    locationId: "item23193",
    locationName: "item23193",
    locationAddress: "item23193",
    ratings: [
      { who: "Similar identities", rating: 0.93 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 60.809926541285975,
    lng: 1.0228718718475474,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5193",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student eats a tower happily. A woman eats a tower silently. A woman builds a tower lazily.",
  },
  {
    locationId: "item23194",
    locationName: "item23194",
    locationAddress: "item23194",
    ratings: null,
    lat: 51.327433263383355,
    lng: -4.832517927985699,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5194",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence gracefully. The student writes a book quickly.",
  },
  {
    locationId: "item23195",
    locationName: "item23195",
    locationAddress: "item23195",
    ratings: [
      { who: "Similar identities", rating: 0.82 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 52.57929462173816,
    lng: -5.492381322562714,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5195",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " The teacher writes a fence angrily.",
  },
  {
    locationId: "item23196",
    locationName: "item23196",
    locationAddress: "item23196",
    ratings: null,
    lat: 54.7840924793957,
    lng: -4.812616095431402,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5196",
    tags: [],
    locationDescription:
      " The man jumps over the horizon silently. The cat runs towards the road angrily.",
  },
  {
    locationId: "item23197",
    locationName: "item23197",
    locationAddress: "item23197",
    ratings: [
      { who: "Similar identities", rating: 4.71 },
      { who: "All perspectives", rating: 2.72 },
    ],
    lat: 58.596738368875265,
    lng: -3.80243710136575,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5197",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " A woman builds a fence lazily. The teacher eats a book silently.",
  },
  {
    locationId: "item23198",
    locationName: "item23198",
    locationAddress: "item23198",
    ratings: null,
    lat: 60.00593433206204,
    lng: -6.317713672094078,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5198",
    tags: [],
    locationDescription:
      " The cat eats a book lazily. The cat builds a book lazily. The cat looks at the horizon gracefully. A woman jumps over a tower gracefully. The man jumps over a fence happily.",
  },
  {
    locationId: "item23199",
    locationName: "item23199",
    locationAddress: "item23199",
    ratings: null,
    lat: 54.79779293986091,
    lng: -6.4996572432060225,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5199",
    tags: [],
    locationDescription:
      " The man looks at a fence silently. A dog jumps over a tower quickly.",
  },
  {
    locationId: "item23200",
    locationName: "item23200",
    locationAddress: "item23200",
    ratings: null,
    lat: 55.313726580072945,
    lng: -4.466995184310176,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5200",
    tags: [],
    locationDescription: " The cat jumps over the horizon lazily.",
  },
  {
    locationId: "item23201",
    locationName: "item23201",
    locationAddress: "item23201",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 2.31 },
    ],
    lat: 50.154087898409905,
    lng: -6.581012972603636,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5201",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription: " The teacher runs towards the road angrily.",
  },
  {
    locationId: "item23202",
    locationName: "item23202",
    locationAddress: "item23202",
    ratings: null,
    lat: 53.02231370559189,
    lng: -3.29589860568192,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5202",
    tags: [],
    locationDescription:
      " The man writes the road happily. The man runs towards the road quickly. The cat builds the horizon lazily.",
  },
  {
    locationId: "item23203",
    locationName: "item23203",
    locationAddress: "item23203",
    ratings: null,
    lat: 57.669299150322416,
    lng: -3.70459851920229,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5203",
    tags: [],
    locationDescription:
      " A dog runs towards the horizon happily. The cat jumps over a fence lazily. The cat writes a fence happily. The man looks at the horizon quickly.",
  },
  {
    locationId: "item23204",
    locationName: "item23204",
    locationAddress: "item23204",
    ratings: null,
    lat: 54.68205487831233,
    lng: 0.910635054574584,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5204",
    tags: [],
    locationDescription:
      " The cat builds the cake silently. The cat writes a book gracefully. The teacher looks at a fence lazily.",
  },
  {
    locationId: "item23205",
    locationName: "item23205",
    locationAddress: "item23205",
    ratings: [
      { who: "Similar identities", rating: 3.06 },
      { who: "All perspectives", rating: 4.19 },
    ],
    lat: 57.53961868452414,
    lng: -8.096031916215763,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5205",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The cat looks at a fence silently. The cat jumps over the horizon angrily. The man writes a book silently. The teacher writes a book quickly. A woman builds the horizon lazily.",
  },
  {
    locationId: "item23206",
    locationName: "item23206",
    locationAddress: "item23206",
    ratings: [
      { who: "Similar identities", rating: 0.92 },
      { who: "All perspectives", rating: 0.95 },
    ],
    lat: 50.63720513273525,
    lng: -0.36005351600487145,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5206",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat runs towards a tower angrily. A woman builds the horizon angrily. The man jumps over a fence quickly.",
  },
  {
    locationId: "item23207",
    locationName: "item23207",
    locationAddress: "item23207",
    ratings: null,
    lat: 57.25069966042376,
    lng: -7.447976746412117,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5207",
    tags: [],
    locationDescription:
      " A woman runs towards the road quickly. The man eats a book silently. A woman writes the road quickly.",
  },
  {
    locationId: "item23208",
    locationName: "item23208",
    locationAddress: "item23208",
    ratings: [
      { who: "Similar identities", rating: 0.01 },
      { who: "All perspectives", rating: 2.11 },
    ],
    lat: 52.0864551899749,
    lng: -7.44223620715956,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5208",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat looks at the horizon quickly. A woman runs towards a book happily. The cat writes a book angrily.",
  },
  {
    locationId: "item23209",
    locationName: "item23209",
    locationAddress: "item23209",
    ratings: null,
    lat: 60.50826379595213,
    lng: -2.4579213139053024,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5209",
    tags: [],
    locationDescription:
      " The man eats a book silently. The man runs towards the cake angrily.",
  },
  {
    locationId: "item23210",
    locationName: "item23210",
    locationAddress: "item23210",
    ratings: [
      { who: "Similar identities", rating: 0.37 },
      { who: "All perspectives", rating: 3.19 },
    ],
    lat: 60.0781882727501,
    lng: -2.7981883010276203,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5210",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man looks at a fence quickly. The man jumps over the cake quickly. The teacher jumps over the road silently. The man writes a fence happily.",
  },
  {
    locationId: "item23211",
    locationName: "item23211",
    locationAddress: "item23211",
    ratings: null,
    lat: 50.26154113930193,
    lng: -2.059894463039191,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5211",
    tags: [],
    locationDescription:
      " The teacher writes a book gracefully. The man jumps over a book gracefully. The teacher jumps over the road happily. A dog runs towards a book quickly.",
  },
  {
    locationId: "item23212",
    locationName: "item23212",
    locationAddress: "item23212",
    ratings: null,
    lat: 54.805108876810884,
    lng: -7.171386396075545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5212",
    tags: [],
    locationDescription:
      " The cat jumps over the road gracefully. The man looks at the horizon lazily. The cat jumps over a book gracefully. A dog looks at the horizon lazily. The cat writes a fence angrily.",
  },
  {
    locationId: "item23213",
    locationName: "item23213",
    locationAddress: "item23213",
    ratings: [
      { who: "Similar identities", rating: 1.53 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 57.454654447354216,
    lng: -4.02769404361054,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5213",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman jumps over the road quickly. A dog looks at the horizon gracefully. The teacher jumps over a book angrily.",
  },
  {
    locationId: "item23214",
    locationName: "item23214",
    locationAddress: "item23214",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 51.40679925666549,
    lng: -5.329214889098319,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5214",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man runs towards a tower angrily. A woman runs towards the cake angrily. A woman builds the horizon angrily. The student writes a fence quickly. The cat eats a tower gracefully.",
  },
  {
    locationId: "item23215",
    locationName: "item23215",
    locationAddress: "item23215",
    ratings: null,
    lat: 54.46015466756532,
    lng: -5.77537962426721,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5215",
    tags: [],
    locationDescription:
      " A woman builds the cake lazily. The cat looks at a book silently.",
  },
  {
    locationId: "item23216",
    locationName: "item23216",
    locationAddress: "item23216",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 3.93 },
    ],
    lat: 52.19373176687202,
    lng: 1.2285517680179403,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5216",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman writes the horizon happily. A dog jumps over a fence lazily. A dog writes a fence lazily. A woman builds a tower angrily.",
  },
  {
    locationId: "item23217",
    locationName: "item23217",
    locationAddress: "item23217",
    ratings: [
      { who: "Similar identities", rating: 4.87 },
      { who: "All perspectives", rating: 2.94 },
    ],
    lat: 60.716391846761056,
    lng: -6.3715372617135495,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5217",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher jumps over the horizon angrily. A woman runs towards a book angrily. A woman runs towards a tower quickly.",
  },
  {
    locationId: "item23218",
    locationName: "item23218",
    locationAddress: "item23218",
    ratings: null,
    lat: 59.124318369382955,
    lng: -3.7858313522513294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5218",
    tags: [],
    locationDescription:
      " The cat looks at the road silently. The teacher looks at the cake gracefully. The teacher jumps over a book silently.",
  },
  {
    locationId: "item23219",
    locationName: "item23219",
    locationAddress: "item23219",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 4.53 },
    ],
    lat: 58.67428264068883,
    lng: -2.9013655193736945,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5219",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog builds a fence quickly. A dog looks at a tower happily. The student writes a book quickly.",
  },
  {
    locationId: "item23220",
    locationName: "item23220",
    locationAddress: "item23220",
    ratings: [
      { who: "Similar identities", rating: 3.33 },
      { who: "All perspectives", rating: 3.79 },
    ],
    lat: 60.19989154959743,
    lng: -2.4223094058353043,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5220",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over a tower angrily. The cat writes a fence gracefully. A dog eats a fence quickly. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item23221",
    locationName: "item23221",
    locationAddress: "item23221",
    ratings: [
      { who: "Similar identities", rating: 1.99 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 59.95037166912591,
    lng: -4.012611167356043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5221",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The teacher runs towards the cake angrily.",
  },
  {
    locationId: "item23222",
    locationName: "item23222",
    locationAddress: "item23222",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 4.02 },
    ],
    lat: 54.70977351986848,
    lng: -5.101757028468606,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5222",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The teacher runs towards the road lazily. The teacher writes the road happily. The student writes the road gracefully. The man jumps over the horizon silently.",
  },
  {
    locationId: "item23223",
    locationName: "item23223",
    locationAddress: "item23223",
    ratings: [
      { who: "Similar identities", rating: 4.51 },
      { who: "All perspectives", rating: 1.64 },
    ],
    lat: 55.98962781473993,
    lng: 0.45907250420048307,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5223",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher builds a fence happily. The teacher looks at the horizon silently. A woman builds the road lazily. The student eats a fence silently.",
  },
  {
    locationId: "item23224",
    locationName: "item23224",
    locationAddress: "item23224",
    ratings: null,
    lat: 53.96714268751364,
    lng: -1.4919408475219829,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5224",
    tags: [],
    locationDescription:
      " A woman builds a fence happily. A dog builds a book quickly.",
  },
  {
    locationId: "item23225",
    locationName: "item23225",
    locationAddress: "item23225",
    ratings: null,
    lat: 60.1616275369116,
    lng: -0.24219889669374162,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5225",
    tags: [],
    locationDescription:
      " The man jumps over the road happily. The cat jumps over the horizon happily. The cat looks at the cake lazily.",
  },
  {
    locationId: "item23226",
    locationName: "item23226",
    locationAddress: "item23226",
    ratings: null,
    lat: 50.00216491733647,
    lng: 0.9217249874487301,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5226",
    tags: [],
    locationDescription:
      " The student runs towards the horizon lazily. The man jumps over the horizon quickly. The teacher builds the cake quickly.",
  },
  {
    locationId: "item23227",
    locationName: "item23227",
    locationAddress: "item23227",
    ratings: null,
    lat: 57.47718389866259,
    lng: -8.116871477767338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5227",
    tags: [],
    locationDescription:
      " The student looks at the road gracefully. A woman jumps over a fence lazily. The teacher builds a tower happily.",
  },
  {
    locationId: "item23228",
    locationName: "item23228",
    locationAddress: "item23228",
    ratings: null,
    lat: 54.11174546813893,
    lng: -8.373612469005948,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5228",
    tags: [],
    locationDescription:
      " The teacher looks at the road lazily. The student writes the horizon silently. A woman jumps over a book happily.",
  },
  {
    locationId: "item23229",
    locationName: "item23229",
    locationAddress: "item23229",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 0.94 },
    ],
    lat: 57.693493519246125,
    lng: 1.528697060463001,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5229",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at a book silently. A woman builds a book gracefully. A woman jumps over the road gracefully. The man builds the road silently. A dog eats a fence quickly.",
  },
  {
    locationId: "item23230",
    locationName: "item23230",
    locationAddress: "item23230",
    ratings: null,
    lat: 60.09044964929345,
    lng: -3.5951053488986915,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5230",
    tags: [],
    locationDescription:
      " A woman looks at a fence lazily. The teacher looks at the cake gracefully. A woman builds the road angrily. The student eats the road happily. A dog looks at the road happily.",
  },
  {
    locationId: "item23231",
    locationName: "item23231",
    locationAddress: "item23231",
    ratings: null,
    lat: 54.55503606426141,
    lng: -4.4257316048263595,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5231",
    tags: [],
    locationDescription:
      " The student jumps over the cake quickly. The student builds the road gracefully. The teacher runs towards a fence lazily. The student builds the cake lazily.",
  },
  {
    locationId: "item23232",
    locationName: "item23232",
    locationAddress: "item23232",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 3.33 },
    ],
    lat: 56.86264547172814,
    lng: -2.6873495976530712,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5232",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman runs towards the road happily. The student jumps over the cake happily. The student runs towards the road lazily. A dog writes a tower gracefully. A dog eats a fence quickly.",
  },
  {
    locationId: "item23233",
    locationName: "item23233",
    locationAddress: "item23233",
    ratings: [
      { who: "Similar identities", rating: 3.29 },
      { who: "All perspectives", rating: 4.1 },
    ],
    lat: 58.24678829796402,
    lng: -2.224341562542902,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5233",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The teacher jumps over the road happily. The student jumps over the road happily. The cat writes the road quickly.",
  },
  {
    locationId: "item23234",
    locationName: "item23234",
    locationAddress: "item23234",
    ratings: null,
    lat: 54.12734799372107,
    lng: -6.88352883827233,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5234",
    tags: [],
    locationDescription:
      " The cat builds a fence happily. A dog builds the cake angrily. A dog jumps over a tower happily. The man runs towards a fence silently. A woman runs towards a tower lazily.",
  },
  {
    locationId: "item23235",
    locationName: "item23235",
    locationAddress: "item23235",
    ratings: [
      { who: "Similar identities", rating: 3.17 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 56.46199535059029,
    lng: 1.5846956357247368,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5235",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription: " The man writes a book quickly.",
  },
  {
    locationId: "item23236",
    locationName: "item23236",
    locationAddress: "item23236",
    ratings: null,
    lat: 50.20893509584004,
    lng: -8.104763850199642,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5236",
    tags: [],
    locationDescription:
      " The student jumps over a tower lazily. The student writes the road lazily. A dog looks at a book silently.",
  },
  {
    locationId: "item23237",
    locationName: "item23237",
    locationAddress: "item23237",
    ratings: null,
    lat: 50.95219180962891,
    lng: -0.9324642420096554,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5237",
    tags: [],
    locationDescription: " The cat writes a fence happily.",
  },
  {
    locationId: "item23238",
    locationName: "item23238",
    locationAddress: "item23238",
    ratings: null,
    lat: 54.25305649487032,
    lng: -8.115821035738767,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5238",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon silently. The student runs towards a fence lazily. The teacher runs towards the cake gracefully. The student eats a fence lazily. A woman eats a fence silently.",
  },
  {
    locationId: "item23239",
    locationName: "item23239",
    locationAddress: "item23239",
    ratings: [
      { who: "Similar identities", rating: 5.0 },
      { who: "All perspectives", rating: 2.1 },
    ],
    lat: 51.46563314522857,
    lng: 1.3304583617934362,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5239",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man eats the horizon happily. The man jumps over a book angrily. The cat builds a tower lazily. The cat eats the road lazily.",
  },
  {
    locationId: "item23240",
    locationName: "item23240",
    locationAddress: "item23240",
    ratings: null,
    lat: 57.519865613010786,
    lng: -4.616810303024221,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5240",
    tags: [],
    locationDescription:
      " A dog eats a tower happily. The man looks at a tower quickly. The man jumps over the road silently. The teacher runs towards a book gracefully.",
  },
  {
    locationId: "item23241",
    locationName: "item23241",
    locationAddress: "item23241",
    ratings: null,
    lat: 52.536932707086905,
    lng: 1.1419706895875894,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5241",
    tags: [],
    locationDescription:
      " A dog eats the cake angrily. The student writes a fence silently. The teacher writes a book angrily. The man builds a fence lazily.",
  },
  {
    locationId: "item23242",
    locationName: "item23242",
    locationAddress: "item23242",
    ratings: [
      { who: "Similar identities", rating: 0.13 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 50.830095453058625,
    lng: -6.775278852885347,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5242",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog builds a fence gracefully. The cat builds the road happily. The man runs towards a fence quickly. The student jumps over a tower silently. The man builds the horizon happily.",
  },
  {
    locationId: "item23243",
    locationName: "item23243",
    locationAddress: "item23243",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 3.61 },
    ],
    lat: 60.88953044066927,
    lng: -6.273045195576354,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5243",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog runs towards the road quickly. The teacher runs towards a book silently. A dog eats the cake quickly. The student runs towards the horizon lazily. The student builds a book quickly.",
  },
  {
    locationId: "item23244",
    locationName: "item23244",
    locationAddress: "item23244",
    ratings: null,
    lat: 56.92353824800881,
    lng: -5.455461438008516,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5244",
    tags: [],
    locationDescription: " The man looks at the horizon angrily.",
  },
  {
    locationId: "item23245",
    locationName: "item23245",
    locationAddress: "item23245",
    ratings: null,
    lat: 51.703603850386095,
    lng: -7.021670261685774,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5245",
    tags: [],
    locationDescription:
      " The cat looks at the road quickly. The teacher writes the cake quickly. The teacher eats the horizon gracefully.",
  },
  {
    locationId: "item23246",
    locationName: "item23246",
    locationAddress: "item23246",
    ratings: null,
    lat: 53.20573070579914,
    lng: -1.3302706951647014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5246",
    tags: [],
    locationDescription:
      " The teacher eats the horizon silently. The teacher jumps over the horizon silently. A woman jumps over a book angrily. The man builds a book angrily. A dog builds the horizon happily.",
  },
  {
    locationId: "item23247",
    locationName: "item23247",
    locationAddress: "item23247",
    ratings: null,
    lat: 51.63922362988184,
    lng: -4.77471370492321,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5247",
    tags: [],
    locationDescription:
      " A dog runs towards a tower quickly. The student runs towards a tower gracefully.",
  },
  {
    locationId: "item23248",
    locationName: "item23248",
    locationAddress: "item23248",
    ratings: null,
    lat: 53.69162603919194,
    lng: -3.968821231445194,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5248",
    tags: [],
    locationDescription:
      " A woman jumps over the road quickly. A dog jumps over a book silently. The man writes a fence angrily. The student writes a book gracefully. The student looks at the road silently.",
  },
  {
    locationId: "item23249",
    locationName: "item23249",
    locationAddress: "item23249",
    ratings: [
      { who: "Similar identities", rating: 4.62 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 57.346818584468686,
    lng: -4.208292447936508,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5249",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a tower silently. A woman looks at a book quickly.",
  },
  {
    locationId: "item23250",
    locationName: "item23250",
    locationAddress: "item23250",
    ratings: [
      { who: "Similar identities", rating: 0.31 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 52.21604635824455,
    lng: -8.225527554859363,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5250",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher eats a book silently. A dog jumps over a fence angrily. A dog writes a tower gracefully. A dog builds the road quickly. A woman writes a book quickly.",
  },
  {
    locationId: "item23251",
    locationName: "item23251",
    locationAddress: "item23251",
    ratings: [
      { who: "Similar identities", rating: 4.0 },
      { who: "All perspectives", rating: 2.13 },
    ],
    lat: 60.76453382951802,
    lng: -0.6015180455987688,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5251",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student writes a fence happily. A dog looks at the road angrily.",
  },
  {
    locationId: "item23252",
    locationName: "item23252",
    locationAddress: "item23252",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 2.46 },
    ],
    lat: 54.74208521527498,
    lng: -0.12508499005859797,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5252",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher writes a fence gracefully. A dog builds a book gracefully.",
  },
  {
    locationId: "item23253",
    locationName: "item23253",
    locationAddress: "item23253",
    ratings: null,
    lat: 53.63877721282451,
    lng: -1.9753224686804653,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5253",
    tags: [],
    locationDescription:
      " The student runs towards a fence gracefully. A dog writes a fence silently. The student builds a tower gracefully. A woman writes a book silently. The student looks at the road gracefully.",
  },
  {
    locationId: "item23254",
    locationName: "item23254",
    locationAddress: "item23254",
    ratings: null,
    lat: 50.05699318521225,
    lng: -2.1885670458224817,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5254",
    tags: [],
    locationDescription:
      " The cat writes the road happily. The cat writes a tower happily. The cat builds a tower quickly.",
  },
  {
    locationId: "item23255",
    locationName: "item23255",
    locationAddress: "item23255",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 2.57 },
    ],
    lat: 60.20058010663424,
    lng: -2.8985797913454814,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5255",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats a fence gracefully. The teacher jumps over the road gracefully.",
  },
  {
    locationId: "item23256",
    locationName: "item23256",
    locationAddress: "item23256",
    ratings: null,
    lat: 57.54162685419627,
    lng: -5.202141916245591,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5256",
    tags: [],
    locationDescription:
      " The man looks at the road silently. A dog looks at the horizon angrily. A woman writes a book quickly. The cat builds the road lazily. The teacher runs towards a book happily.",
  },
  {
    locationId: "item23257",
    locationName: "item23257",
    locationAddress: "item23257",
    ratings: null,
    lat: 51.16190095861755,
    lng: -7.148874592242359,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5257",
    tags: [],
    locationDescription:
      " The teacher writes a fence quickly. The teacher looks at a fence gracefully. A dog eats a fence quickly.",
  },
  {
    locationId: "item23258",
    locationName: "item23258",
    locationAddress: "item23258",
    ratings: null,
    lat: 50.50353952780813,
    lng: -2.5658206100438408,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5258",
    tags: [],
    locationDescription:
      " The cat builds the horizon silently. The cat writes the horizon gracefully.",
  },
  {
    locationId: "item23259",
    locationName: "item23259",
    locationAddress: "item23259",
    ratings: [
      { who: "Similar identities", rating: 1.29 },
      { who: "All perspectives", rating: 4.92 },
    ],
    lat: 54.61782487708355,
    lng: -1.8048988580513852,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5259",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman jumps over a tower happily. The man eats the road happily.",
  },
  {
    locationId: "item23260",
    locationName: "item23260",
    locationAddress: "item23260",
    ratings: [
      { who: "Similar identities", rating: 3.13 },
      { who: "All perspectives", rating: 1.04 },
    ],
    lat: 59.33239756149196,
    lng: -6.725474981354857,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5260",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man builds a book lazily. The man runs towards the road silently. A woman writes a fence gracefully.",
  },
  {
    locationId: "item23261",
    locationName: "item23261",
    locationAddress: "item23261",
    ratings: null,
    lat: 55.66713711741297,
    lng: 0.802613491146527,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5261",
    tags: [],
    locationDescription:
      " A dog eats the road silently. The student eats a tower happily. The student writes a tower angrily.",
  },
  {
    locationId: "item23262",
    locationName: "item23262",
    locationAddress: "item23262",
    ratings: null,
    lat: 51.97005718518772,
    lng: 1.6705658810332,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5262",
    tags: [],
    locationDescription:
      " The man jumps over a book gracefully. The man eats a fence lazily. The teacher eats the cake quickly. The man builds a fence happily. The student jumps over a tower angrily.",
  },
  {
    locationId: "item23263",
    locationName: "item23263",
    locationAddress: "item23263",
    ratings: [
      { who: "Similar identities", rating: 2.99 },
      { who: "All perspectives", rating: 4.1 },
    ],
    lat: 54.04352478906817,
    lng: -1.3755178440347562,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5263",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at the horizon gracefully. The teacher looks at the cake happily. A dog builds the horizon happily. The student runs towards a fence silently.",
  },
  {
    locationId: "item23264",
    locationName: "item23264",
    locationAddress: "item23264",
    ratings: null,
    lat: 58.88883186499054,
    lng: 0.9718931796964476,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5264",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon quickly. The teacher runs towards the road angrily. The teacher jumps over the cake lazily. The student jumps over a tower angrily.",
  },
  {
    locationId: "item23265",
    locationName: "item23265",
    locationAddress: "item23265",
    ratings: [
      { who: "Similar identities", rating: 4.06 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 59.086327412553274,
    lng: -3.899424490082599,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5265",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher builds a book lazily. A dog writes a tower lazily. The student looks at a tower gracefully.",
  },
  {
    locationId: "item23266",
    locationName: "item23266",
    locationAddress: "item23266",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 2.06 },
    ],
    lat: 58.45265703553814,
    lng: -6.2519416024149095,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5266",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog builds the horizon silently. A dog jumps over a fence happily.",
  },
  {
    locationId: "item23267",
    locationName: "item23267",
    locationAddress: "item23267",
    ratings: null,
    lat: 59.28360702145244,
    lng: -3.4993215239460715,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5267",
    tags: [],
    locationDescription:
      " The student runs towards the cake lazily. A dog eats the horizon gracefully. The student looks at the horizon gracefully. A dog eats a book silently. The student builds a tower angrily.",
  },
  {
    locationId: "item23268",
    locationName: "item23268",
    locationAddress: "item23268",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 4.25 },
    ],
    lat: 58.21501184383027,
    lng: -4.1455786426142796,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5268",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student eats the horizon gracefully. The cat jumps over a fence silently. The student builds a fence gracefully. The man looks at a fence gracefully. The man runs towards a book lazily.",
  },
  {
    locationId: "item23269",
    locationName: "item23269",
    locationAddress: "item23269",
    ratings: [
      { who: "Similar identities", rating: 4.06 },
      { who: "All perspectives", rating: 0.93 },
    ],
    lat: 54.30030299083754,
    lng: -1.2113895287878638,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5269",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man jumps over a book quickly. The teacher builds a fence lazily. A dog runs towards a book lazily. The student jumps over a fence lazily.",
  },
  {
    locationId: "item23270",
    locationName: "item23270",
    locationAddress: "item23270",
    ratings: null,
    lat: 53.79927404583624,
    lng: -6.717251137745536,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5270",
    tags: [],
    locationDescription: " The student eats a fence happily.",
  },
  {
    locationId: "item23271",
    locationName: "item23271",
    locationAddress: "item23271",
    ratings: [
      { who: "Similar identities", rating: 2.89 },
      { who: "All perspectives", rating: 0.68 },
    ],
    lat: 54.1270861207031,
    lng: 0.12443644314543789,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5271",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student looks at the cake happily. A dog runs towards the cake gracefully.",
  },
  {
    locationId: "item23272",
    locationName: "item23272",
    locationAddress: "item23272",
    ratings: null,
    lat: 58.31607823147341,
    lng: 1.0002345627233602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5272",
    tags: [],
    locationDescription: " A woman eats a book angrily.",
  },
  {
    locationId: "item23273",
    locationName: "item23273",
    locationAddress: "item23273",
    ratings: [
      { who: "Similar identities", rating: 3.03 },
      { who: "All perspectives", rating: 2.5 },
    ],
    lat: 58.857947197293655,
    lng: -1.2392916526392632,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5273",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription: " The student writes a fence happily.",
  },
  {
    locationId: "item23274",
    locationName: "item23274",
    locationAddress: "item23274",
    ratings: null,
    lat: 60.137489392261415,
    lng: -2.135210617793895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5274",
    tags: [],
    locationDescription:
      " The student runs towards a book angrily. The teacher runs towards the cake angrily. A dog builds the cake quickly. The cat looks at a fence lazily. A woman eats the road happily.",
  },
  {
    locationId: "item23275",
    locationName: "item23275",
    locationAddress: "item23275",
    ratings: [
      { who: "Similar identities", rating: 4.33 },
      { who: "All perspectives", rating: 2.77 },
    ],
    lat: 57.395798581244094,
    lng: -3.4485646037908797,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5275",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat writes the cake quickly. The teacher looks at the road quickly.",
  },
  {
    locationId: "item23276",
    locationName: "item23276",
    locationAddress: "item23276",
    ratings: null,
    lat: 52.84421747520675,
    lng: -1.9084197825374805,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5276",
    tags: [],
    locationDescription:
      " The man looks at a book silently. A woman eats a fence angrily. A dog eats the cake lazily.",
  },
  {
    locationId: "item23277",
    locationName: "item23277",
    locationAddress: "item23277",
    ratings: null,
    lat: 59.86621732834623,
    lng: -0.8487058380764898,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5277",
    tags: [],
    locationDescription:
      " A woman eats the road quickly. The cat writes a fence silently. The student builds a tower lazily. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item23278",
    locationName: "item23278",
    locationAddress: "item23278",
    ratings: null,
    lat: 59.73952071009164,
    lng: 1.1899741156598367,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5278",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon gracefully. A dog builds the cake gracefully.",
  },
  {
    locationId: "item23279",
    locationName: "item23279",
    locationAddress: "item23279",
    ratings: null,
    lat: 56.60065006389729,
    lng: -1.2800839772790136,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5279",
    tags: [],
    locationDescription:
      " The student jumps over a tower quickly. The student builds the road quickly.",
  },
  {
    locationId: "item23280",
    locationName: "item23280",
    locationAddress: "item23280",
    ratings: null,
    lat: 59.49559217832578,
    lng: -5.440673063722601,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5280",
    tags: [],
    locationDescription:
      " The man jumps over a book quickly. The student writes a tower lazily.",
  },
  {
    locationId: "item23281",
    locationName: "item23281",
    locationAddress: "item23281",
    ratings: null,
    lat: 60.275973980351225,
    lng: -8.341209523856321,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5281",
    tags: [],
    locationDescription:
      " The cat writes the cake happily. The student runs towards the road gracefully. The teacher writes the cake angrily. A dog runs towards the road silently.",
  },
  {
    locationId: "item23282",
    locationName: "item23282",
    locationAddress: "item23282",
    ratings: null,
    lat: 51.18439207112003,
    lng: -7.330997848182753,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5282",
    tags: [],
    locationDescription:
      " A woman looks at the horizon happily. The cat jumps over the road happily. The student builds the horizon quickly.",
  },
  {
    locationId: "item23283",
    locationName: "item23283",
    locationAddress: "item23283",
    ratings: null,
    lat: 59.904571239779415,
    lng: -2.6772299180119026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5283",
    tags: [],
    locationDescription:
      " A woman eats the cake silently. A dog writes the road angrily. A woman writes a tower happily.",
  },
  {
    locationId: "item23284",
    locationName: "item23284",
    locationAddress: "item23284",
    ratings: null,
    lat: 50.10043618396799,
    lng: 0.43956504285258013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5284",
    tags: [],
    locationDescription: " The man looks at a book happily.",
  },
  {
    locationId: "item23285",
    locationName: "item23285",
    locationAddress: "item23285",
    ratings: null,
    lat: 59.84231446349746,
    lng: -0.6836913394653896,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5285",
    tags: [],
    locationDescription:
      " The teacher writes the cake happily. The man runs towards the road angrily.",
  },
  {
    locationId: "item23286",
    locationName: "item23286",
    locationAddress: "item23286",
    ratings: null,
    lat: 53.16315420510258,
    lng: -2.5240522358816655,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5286",
    tags: [],
    locationDescription:
      " The man eats the road gracefully. The student jumps over a tower angrily.",
  },
  {
    locationId: "item23287",
    locationName: "item23287",
    locationAddress: "item23287",
    ratings: [
      { who: "Similar identities", rating: 2.01 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 54.87355401286683,
    lng: -7.68189011880718,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5287",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription: " A woman runs towards a book silently.",
  },
  {
    locationId: "item23288",
    locationName: "item23288",
    locationAddress: "item23288",
    ratings: null,
    lat: 53.97658007899865,
    lng: 1.7485985681517686,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5288",
    tags: [],
    locationDescription:
      " The cat builds the cake gracefully. The student eats the road happily.",
  },
  {
    locationId: "item23289",
    locationName: "item23289",
    locationAddress: "item23289",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 58.267800271492376,
    lng: -4.118611735267164,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5289",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man runs towards the cake quickly. A woman builds the horizon angrily. The man jumps over a fence silently.",
  },
  {
    locationId: "item23290",
    locationName: "item23290",
    locationAddress: "item23290",
    ratings: null,
    lat: 59.59692503036661,
    lng: 0.7308271452694886,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5290",
    tags: [],
    locationDescription:
      " A woman writes the cake quickly. A dog builds a fence angrily. A woman runs towards the road angrily. The teacher runs towards a fence lazily. The cat runs towards the cake silently.",
  },
  {
    locationId: "item23291",
    locationName: "item23291",
    locationAddress: "item23291",
    ratings: null,
    lat: 58.83736264101355,
    lng: -8.547130322920214,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5291",
    tags: [],
    locationDescription:
      " A dog eats the cake happily. A woman eats the cake gracefully. A woman jumps over the cake gracefully.",
  },
  {
    locationId: "item23292",
    locationName: "item23292",
    locationAddress: "item23292",
    ratings: null,
    lat: 51.74081773752681,
    lng: -7.475212933690644,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5292",
    tags: [],
    locationDescription:
      " A woman looks at the cake lazily. The student jumps over the horizon gracefully. A woman jumps over the road silently.",
  },
  {
    locationId: "item23293",
    locationName: "item23293",
    locationAddress: "item23293",
    ratings: [
      { who: "Similar identities", rating: 1.09 },
      { who: "All perspectives", rating: 3.94 },
    ],
    lat: 52.64357350591718,
    lng: -4.626793863739153,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5293",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " A woman builds the cake angrily.",
  },
  {
    locationId: "item23294",
    locationName: "item23294",
    locationAddress: "item23294",
    ratings: null,
    lat: 60.075005708891446,
    lng: -6.652906900713347,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5294",
    tags: [],
    locationDescription:
      " The teacher writes the cake lazily. The man runs towards the horizon angrily. The student looks at a book silently. A woman looks at a tower happily.",
  },
  {
    locationId: "item23295",
    locationName: "item23295",
    locationAddress: "item23295",
    ratings: null,
    lat: 56.280486361093956,
    lng: -0.03419394493105621,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5295",
    tags: [],
    locationDescription:
      " The teacher jumps over the horizon quickly. The man writes a fence happily. The cat writes a book gracefully. A woman jumps over a fence happily. The student eats the horizon silently.",
  },
  {
    locationId: "item23296",
    locationName: "item23296",
    locationAddress: "item23296",
    ratings: null,
    lat: 51.55983938811198,
    lng: -2.8264383008490723,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5296",
    tags: [],
    locationDescription: " A woman jumps over a book silently.",
  },
  {
    locationId: "item23297",
    locationName: "item23297",
    locationAddress: "item23297",
    ratings: [
      { who: "Similar identities", rating: 2.55 },
      { who: "All perspectives", rating: 0.63 },
    ],
    lat: 59.90446152775803,
    lng: -8.173445877826863,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5297",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student builds the road gracefully. The man eats a tower quickly. The man eats a tower gracefully. The man looks at a tower gracefully.",
  },
  {
    locationId: "item23298",
    locationName: "item23298",
    locationAddress: "item23298",
    ratings: null,
    lat: 57.65617326444317,
    lng: -4.79420362418036,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5298",
    tags: [],
    locationDescription:
      " The man looks at a fence quickly. The man writes a tower happily. A woman looks at a book silently. A dog looks at the horizon gracefully. The man looks at the road silently.",
  },
  {
    locationId: "item23299",
    locationName: "item23299",
    locationAddress: "item23299",
    ratings: null,
    lat: 52.77510355747294,
    lng: -2.626625298580506,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5299",
    tags: [],
    locationDescription:
      " The teacher looks at the road angrily. A woman builds a tower angrily. The student runs towards the cake happily. A woman writes the cake silently. A dog runs towards the cake quickly.",
  },
  {
    locationId: "item23300",
    locationName: "item23300",
    locationAddress: "item23300",
    ratings: null,
    lat: 56.538299284450915,
    lng: -0.7797109850187658,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5300",
    tags: [],
    locationDescription:
      " The student writes a book lazily. A woman writes a tower gracefully. A dog jumps over the horizon angrily.",
  },
  {
    locationId: "item23301",
    locationName: "item23301",
    locationAddress: "item23301",
    ratings: null,
    lat: 60.87128778210875,
    lng: -8.452593002934863,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5301",
    tags: [],
    locationDescription:
      " The student looks at the road angrily. The student builds a tower angrily. The cat eats a tower lazily.",
  },
  {
    locationId: "item23302",
    locationName: "item23302",
    locationAddress: "item23302",
    ratings: null,
    lat: 60.30141734149608,
    lng: 1.3063391386574068,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5302",
    tags: [],
    locationDescription:
      " A dog builds a book angrily. A dog eats the road happily. The student looks at a tower happily.",
  },
  {
    locationId: "item23303",
    locationName: "item23303",
    locationAddress: "item23303",
    ratings: null,
    lat: 56.98173321539626,
    lng: -5.368916264108799,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5303",
    tags: [],
    locationDescription:
      " A dog eats a book silently. The student runs towards the cake gracefully. The teacher jumps over the horizon quickly. The man builds the cake silently.",
  },
  {
    locationId: "item23304",
    locationName: "item23304",
    locationAddress: "item23304",
    ratings: null,
    lat: 59.06740975910614,
    lng: -1.8384873646194055,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5304",
    tags: [],
    locationDescription:
      " A woman writes the horizon silently. The cat looks at a book angrily. A woman jumps over the road lazily. The cat eats a fence happily. The cat runs towards the horizon silently.",
  },
  {
    locationId: "item23305",
    locationName: "item23305",
    locationAddress: "item23305",
    ratings: null,
    lat: 53.95411064252238,
    lng: 0.9164629094398968,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5305",
    tags: [],
    locationDescription:
      " The cat writes a tower lazily. The man writes a fence silently. The student runs towards the cake lazily.",
  },
  {
    locationId: "item23306",
    locationName: "item23306",
    locationAddress: "item23306",
    ratings: null,
    lat: 50.01451278587413,
    lng: -6.205781459691224,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5306",
    tags: [],
    locationDescription:
      " A woman writes a tower happily. The teacher looks at the cake angrily. A woman runs towards the road lazily.",
  },
  {
    locationId: "item23307",
    locationName: "item23307",
    locationAddress: "item23307",
    ratings: [
      { who: "Similar identities", rating: 2.94 },
      { who: "All perspectives", rating: 4.26 },
    ],
    lat: 57.18331177675894,
    lng: -1.587441130310344,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5307",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat looks at the road angrily. The teacher looks at the cake angrily.",
  },
  {
    locationId: "item23308",
    locationName: "item23308",
    locationAddress: "item23308",
    ratings: [
      { who: "Similar identities", rating: 0.53 },
      { who: "All perspectives", rating: 2.49 },
    ],
    lat: 51.139138858568955,
    lng: -2.51403922995084,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5308",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man runs towards a fence lazily. A woman eats a book silently. The student eats the road gracefully. The cat jumps over the horizon quickly.",
  },
  {
    locationId: "item23309",
    locationName: "item23309",
    locationAddress: "item23309",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 1.64 },
    ],
    lat: 57.52830862504897,
    lng: -4.705339156782479,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5309",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student builds the road silently. A dog eats the cake quickly. A woman builds a tower angrily.",
  },
  {
    locationId: "item23310",
    locationName: "item23310",
    locationAddress: "item23310",
    ratings: [
      { who: "Similar identities", rating: 3.7 },
      { who: "All perspectives", rating: 2.11 },
    ],
    lat: 59.22115347495975,
    lng: 1.255472317625955,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5310",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher looks at the road happily. The cat eats a tower happily. A dog writes the horizon gracefully.",
  },
  {
    locationId: "item23311",
    locationName: "item23311",
    locationAddress: "item23311",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 1.96 },
    ],
    lat: 57.14212376129562,
    lng: -3.6460062336082064,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5311",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The cat eats a book angrily.",
  },
  {
    locationId: "item23312",
    locationName: "item23312",
    locationAddress: "item23312",
    ratings: null,
    lat: 60.81162674973166,
    lng: -5.987405667594309,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5312",
    tags: [],
    locationDescription:
      " A woman jumps over a book silently. The student eats the cake silently. A woman builds the cake gracefully. The student writes a fence silently.",
  },
  {
    locationId: "item23313",
    locationName: "item23313",
    locationAddress: "item23313",
    ratings: null,
    lat: 58.64707631858506,
    lng: -4.507347114716704,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5313",
    tags: [],
    locationDescription:
      " The man runs towards a tower lazily. A dog builds a book quickly. The student eats the cake quickly. The student jumps over a tower lazily.",
  },
  {
    locationId: "item23314",
    locationName: "item23314",
    locationAddress: "item23314",
    ratings: null,
    lat: 56.43587596229438,
    lng: -5.043845392872024,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5314",
    tags: [],
    locationDescription:
      " The man eats a tower happily. The man eats the road lazily. The cat writes a book happily. The teacher looks at the horizon quickly.",
  },
  {
    locationId: "item23315",
    locationName: "item23315",
    locationAddress: "item23315",
    ratings: [
      { who: "Similar identities", rating: 3.42 },
      { who: "All perspectives", rating: 1.56 },
    ],
    lat: 55.564723600409756,
    lng: 1.2125060001572692,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5315",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat builds a fence quickly. The teacher writes a tower gracefully.",
  },
  {
    locationId: "item23316",
    locationName: "item23316",
    locationAddress: "item23316",
    ratings: [
      { who: "Similar identities", rating: 1.68 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 53.631938705991885,
    lng: -0.4303722485020387,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5316",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student eats the horizon gracefully. The man jumps over a fence happily. The student looks at a fence angrily.",
  },
  {
    locationId: "item23317",
    locationName: "item23317",
    locationAddress: "item23317",
    ratings: null,
    lat: 56.39804270884451,
    lng: 1.1448503840496063,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5317",
    tags: [],
    locationDescription:
      " The man writes the cake lazily. The teacher jumps over the cake lazily. The student runs towards the cake quickly. A woman jumps over a fence happily. A dog eats a book quickly.",
  },
  {
    locationId: "item23318",
    locationName: "item23318",
    locationAddress: "item23318",
    ratings: null,
    lat: 59.6786348447335,
    lng: -7.392403577305488,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5318",
    tags: [],
    locationDescription:
      " The cat eats the cake quickly. The man writes a fence angrily. The man jumps over a tower lazily. A woman looks at a tower silently.",
  },
  {
    locationId: "item23319",
    locationName: "item23319",
    locationAddress: "item23319",
    ratings: null,
    lat: 54.050456509475815,
    lng: -3.3477985358685203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5319",
    tags: [],
    locationDescription: " A woman looks at the horizon gracefully.",
  },
  {
    locationId: "item23320",
    locationName: "item23320",
    locationAddress: "item23320",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 4.25 },
    ],
    lat: 60.13962887119251,
    lng: -3.432951840742297,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5320",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The cat looks at the cake silently.",
  },
  {
    locationId: "item23321",
    locationName: "item23321",
    locationAddress: "item23321",
    ratings: null,
    lat: 57.628350616007346,
    lng: -4.701757150834742,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5321",
    tags: [],
    locationDescription: " The teacher looks at a fence quickly.",
  },
  {
    locationId: "item23322",
    locationName: "item23322",
    locationAddress: "item23322",
    ratings: null,
    lat: 52.7390759135858,
    lng: -5.280334101384645,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5322",
    tags: [],
    locationDescription:
      " The man jumps over the horizon happily. A dog jumps over a fence happily. The cat eats the horizon silently. The student eats a fence angrily. The student builds the horizon gracefully.",
  },
  {
    locationId: "item23323",
    locationName: "item23323",
    locationAddress: "item23323",
    ratings: [
      { who: "Similar identities", rating: 1.2 },
      { who: "All perspectives", rating: 2.14 },
    ],
    lat: 52.32894664896769,
    lng: -8.060943963048048,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5323",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student jumps over a fence quickly. The cat runs towards the horizon lazily. The man looks at the cake happily. The man writes a book gracefully. The student builds a book lazily.",
  },
  {
    locationId: "item23324",
    locationName: "item23324",
    locationAddress: "item23324",
    ratings: [
      { who: "Similar identities", rating: 1.08 },
      { who: "All perspectives", rating: 1.14 },
    ],
    lat: 53.43203104360323,
    lng: -0.49326752310540734,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5324",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The cat jumps over a fence angrily.",
  },
  {
    locationId: "item23325",
    locationName: "item23325",
    locationAddress: "item23325",
    ratings: null,
    lat: 54.486575525527186,
    lng: -3.8585038192585843,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5325",
    tags: [],
    locationDescription:
      " A woman runs towards a tower silently. The teacher writes the horizon angrily. The student builds the road happily. The cat runs towards the cake happily.",
  },
  {
    locationId: "item23326",
    locationName: "item23326",
    locationAddress: "item23326",
    ratings: null,
    lat: 50.2824714864507,
    lng: -1.444752903755445,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5326",
    tags: [],
    locationDescription: " The cat looks at a book angrily.",
  },
  {
    locationId: "item23327",
    locationName: "item23327",
    locationAddress: "item23327",
    ratings: null,
    lat: 60.13351353894403,
    lng: -7.472973567418704,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5327",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence quickly. A woman writes a tower angrily. The cat runs towards the cake gracefully.",
  },
  {
    locationId: "item23328",
    locationName: "item23328",
    locationAddress: "item23328",
    ratings: null,
    lat: 59.97630509068725,
    lng: -4.079558550960214,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5328",
    tags: [],
    locationDescription:
      " The man eats the road lazily. A woman runs towards the road lazily. The teacher jumps over the cake lazily. The cat writes a tower silently. The man eats a tower lazily.",
  },
  {
    locationId: "item23329",
    locationName: "item23329",
    locationAddress: "item23329",
    ratings: [
      { who: "Similar identities", rating: 0.42 },
      { who: "All perspectives", rating: 3.15 },
    ],
    lat: 50.92584829242323,
    lng: -0.46671201318846833,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5329",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog writes the horizon quickly. A dog looks at a book silently. A dog writes a fence gracefully.",
  },
  {
    locationId: "item23330",
    locationName: "item23330",
    locationAddress: "item23330",
    ratings: [
      { who: "Similar identities", rating: 2.93 },
      { who: "All perspectives", rating: 0.81 },
    ],
    lat: 59.8040570815913,
    lng: 1.4685323300712412,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5330",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription: " A dog writes a book silently.",
  },
  {
    locationId: "item23331",
    locationName: "item23331",
    locationAddress: "item23331",
    ratings: null,
    lat: 54.742591219099985,
    lng: -4.5110270361332026,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5331",
    tags: [],
    locationDescription:
      " The cat looks at a tower quickly. A woman eats a tower quickly. A dog runs towards a book silently. The cat writes a book happily.",
  },
  {
    locationId: "item23332",
    locationName: "item23332",
    locationAddress: "item23332",
    ratings: null,
    lat: 51.50832030185913,
    lng: -1.1990039845551959,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5332",
    tags: [],
    locationDescription: " The teacher eats the horizon angrily.",
  },
  {
    locationId: "item23333",
    locationName: "item23333",
    locationAddress: "item23333",
    ratings: [
      { who: "Similar identities", rating: 3.96 },
      { who: "All perspectives", rating: 3.68 },
    ],
    lat: 50.20254602140797,
    lng: -7.311548228232009,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5333",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man runs towards the horizon lazily.",
  },
  {
    locationId: "item23334",
    locationName: "item23334",
    locationAddress: "item23334",
    ratings: [
      { who: "Similar identities", rating: 2.42 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 59.66175100770656,
    lng: -2.5426169671396917,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5334",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat runs towards the horizon quickly. The student eats a fence gracefully. The student looks at a tower angrily.",
  },
  {
    locationId: "item23335",
    locationName: "item23335",
    locationAddress: "item23335",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 51.85679618406496,
    lng: -0.10454884836297573,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5335",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man writes the cake gracefully. The student writes the cake quickly. The teacher looks at the cake lazily. The student runs towards the horizon happily.",
  },
  {
    locationId: "item23336",
    locationName: "item23336",
    locationAddress: "item23336",
    ratings: [
      { who: "Similar identities", rating: 1.93 },
      { who: "All perspectives", rating: 2.48 },
    ],
    lat: 54.21152169984002,
    lng: 0.9972492695611219,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5336",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The cat eats a tower silently. The student writes a fence angrily.",
  },
  {
    locationId: "item23337",
    locationName: "item23337",
    locationAddress: "item23337",
    ratings: [
      { who: "Similar identities", rating: 3.25 },
      { who: "All perspectives", rating: 3.17 },
    ],
    lat: 54.389064459596426,
    lng: -6.931722476576931,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5337",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man builds a book happily. The teacher looks at a book happily. The man builds a tower lazily. A woman looks at the road quickly.",
  },
  {
    locationId: "item23338",
    locationName: "item23338",
    locationAddress: "item23338",
    ratings: null,
    lat: 51.39328147070998,
    lng: 0.037208072638007295,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5338",
    tags: [],
    locationDescription:
      " The teacher jumps over the road quickly. The teacher builds a book happily.",
  },
  {
    locationId: "item23339",
    locationName: "item23339",
    locationAddress: "item23339",
    ratings: null,
    lat: 51.88932493772531,
    lng: -2.9726634676235797,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5339",
    tags: [],
    locationDescription:
      " The teacher looks at a tower quickly. The cat jumps over the cake silently. The student writes the cake happily.",
  },
  {
    locationId: "item23340",
    locationName: "item23340",
    locationAddress: "item23340",
    ratings: [
      { who: "Similar identities", rating: 0.52 },
      { who: "All perspectives", rating: 2.03 },
    ],
    lat: 50.86970016844691,
    lng: -0.29345823663174464,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5340",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The man eats the road happily. The cat writes the horizon happily. The student looks at the cake lazily.",
  },
  {
    locationId: "item23341",
    locationName: "item23341",
    locationAddress: "item23341",
    ratings: null,
    lat: 56.8115092200682,
    lng: 0.6847120723789555,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5341",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake angrily. A woman writes a fence lazily. A woman writes a fence happily.",
  },
  {
    locationId: "item23342",
    locationName: "item23342",
    locationAddress: "item23342",
    ratings: null,
    lat: 59.6287977439092,
    lng: -2.000891554753985,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5342",
    tags: [],
    locationDescription:
      " The teacher eats a fence angrily. The teacher builds a tower angrily. The teacher jumps over a fence angrily. The man builds the road angrily. The student runs towards the horizon gracefully.",
  },
  {
    locationId: "item23343",
    locationName: "item23343",
    locationAddress: "item23343",
    ratings: null,
    lat: 54.930009905698775,
    lng: 0.874619229250202,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5343",
    tags: [],
    locationDescription:
      " The student jumps over the horizon quickly. The man builds a tower gracefully. A dog jumps over a fence happily.",
  },
  {
    locationId: "item23344",
    locationName: "item23344",
    locationAddress: "item23344",
    ratings: null,
    lat: 60.15534570076797,
    lng: -1.3456966715103338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5344",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon angrily. The cat builds a book gracefully. A woman runs towards the horizon silently. The teacher eats a book quickly. The cat builds the road gracefully.",
  },
  {
    locationId: "item23345",
    locationName: "item23345",
    locationAddress: "item23345",
    ratings: [
      { who: "Similar identities", rating: 2.0 },
      { who: "All perspectives", rating: 1.47 },
    ],
    lat: 55.695810643580856,
    lng: -1.5900682548113547,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5345",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at the horizon silently. The teacher writes the horizon happily. The student eats a tower quickly.",
  },
  {
    locationId: "item23346",
    locationName: "item23346",
    locationAddress: "item23346",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 56.060936664298026,
    lng: -1.4087911282646752,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5346",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog runs towards a tower angrily. The man looks at a tower angrily. The student runs towards a tower gracefully. The cat jumps over the road silently.",
  },
  {
    locationId: "item23347",
    locationName: "item23347",
    locationAddress: "item23347",
    ratings: [
      { who: "Similar identities", rating: 3.98 },
      { who: "All perspectives", rating: 1.23 },
    ],
    lat: 55.102537437579976,
    lng: -7.003032153966996,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5347",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog runs towards the cake gracefully. The man jumps over a tower silently. A dog writes a book gracefully. The student looks at the horizon angrily. The student builds the cake angrily.",
  },
  {
    locationId: "item23348",
    locationName: "item23348",
    locationAddress: "item23348",
    ratings: [
      { who: "Similar identities", rating: 2.04 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 56.08761243421616,
    lng: -3.4331504907153425,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5348",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student writes a fence silently. The student eats a tower angrily. A dog eats the road gracefully. A dog builds the cake lazily.",
  },
  {
    locationId: "item23349",
    locationName: "item23349",
    locationAddress: "item23349",
    ratings: null,
    lat: 57.40897287636933,
    lng: -2.3448434013825423,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5349",
    tags: [],
    locationDescription: " The cat jumps over the road gracefully.",
  },
  {
    locationId: "item23350",
    locationName: "item23350",
    locationAddress: "item23350",
    ratings: null,
    lat: 57.12255585925264,
    lng: -3.1014246525087357,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5350",
    tags: [],
    locationDescription:
      " A dog eats the road silently. The teacher writes a fence silently. The cat writes the road lazily. The teacher writes the horizon angrily.",
  },
  {
    locationId: "item23351",
    locationName: "item23351",
    locationAddress: "item23351",
    ratings: null,
    lat: 56.22493709542651,
    lng: -6.807934822801348,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5351",
    tags: [],
    locationDescription: " The man builds a fence quickly.",
  },
  {
    locationId: "item23352",
    locationName: "item23352",
    locationAddress: "item23352",
    ratings: [
      { who: "Similar identities", rating: 3.41 },
      { who: "All perspectives", rating: 3.64 },
    ],
    lat: 51.17729881946684,
    lng: -0.5235132949741548,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5352",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student runs towards the horizon lazily. A dog writes a tower gracefully. The teacher jumps over a tower gracefully. The man eats the cake happily.",
  },
  {
    locationId: "item23353",
    locationName: "item23353",
    locationAddress: "item23353",
    ratings: [
      { who: "Similar identities", rating: 4.96 },
      { who: "All perspectives", rating: 3.25 },
    ],
    lat: 56.92488427045134,
    lng: -8.242707590455009,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5353",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat runs towards a fence angrily.",
  },
  {
    locationId: "item23354",
    locationName: "item23354",
    locationAddress: "item23354",
    ratings: null,
    lat: 54.82712319960118,
    lng: -0.9083937184621886,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5354",
    tags: [],
    locationDescription:
      " The man runs towards the cake angrily. A dog builds the horizon gracefully.",
  },
  {
    locationId: "item23355",
    locationName: "item23355",
    locationAddress: "item23355",
    ratings: null,
    lat: 54.611481518816916,
    lng: -5.7525971579986415,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5355",
    tags: [],
    locationDescription: " A woman runs towards the horizon silently.",
  },
  {
    locationId: "item23356",
    locationName: "item23356",
    locationAddress: "item23356",
    ratings: null,
    lat: 52.82344147680473,
    lng: -3.468389798475533,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5356",
    tags: [],
    locationDescription:
      " The cat jumps over the horizon happily. The student writes the road lazily. The teacher builds a fence happily. The man builds the road lazily. A woman eats a fence lazily.",
  },
  {
    locationId: "item23357",
    locationName: "item23357",
    locationAddress: "item23357",
    ratings: [
      { who: "Similar identities", rating: 2.63 },
      { who: "All perspectives", rating: 0.06 },
    ],
    lat: 54.36237578221955,
    lng: -1.1398832678989361,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5357",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man writes the road quickly. The student looks at the road happily. A woman writes a tower gracefully. The student eats a fence quickly.",
  },
  {
    locationId: "item23358",
    locationName: "item23358",
    locationAddress: "item23358",
    ratings: [
      { who: "Similar identities", rating: 0.22 },
      { who: "All perspectives", rating: 2.1 },
    ],
    lat: 57.23299559166105,
    lng: 1.48611548499529,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5358",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards the horizon quickly. The teacher looks at the horizon lazily. A dog jumps over the horizon gracefully. A dog runs towards a tower quickly.",
  },
  {
    locationId: "item23359",
    locationName: "item23359",
    locationAddress: "item23359",
    ratings: null,
    lat: 53.05654679513607,
    lng: -1.259648025757377,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5359",
    tags: [],
    locationDescription:
      " The teacher jumps over the road quickly. The student builds the horizon quickly. A dog runs towards a book happily. The teacher runs towards a fence gracefully.",
  },
  {
    locationId: "item23360",
    locationName: "item23360",
    locationAddress: "item23360",
    ratings: null,
    lat: 54.024579620206296,
    lng: -2.184246173196361,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5360",
    tags: [],
    locationDescription:
      " A dog runs towards the cake silently. The student eats a tower silently.",
  },
  {
    locationId: "item23361",
    locationName: "item23361",
    locationAddress: "item23361",
    ratings: [
      { who: "Similar identities", rating: 3.97 },
      { who: "All perspectives", rating: 3.54 },
    ],
    lat: 51.37455958356251,
    lng: -2.4556603786080897,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5361",
    tags: [{ label: "child friendly" }, { label: "trans-inclusive" }],
    locationDescription: " A dog runs towards the horizon quickly.",
  },
  {
    locationId: "item23362",
    locationName: "item23362",
    locationAddress: "item23362",
    ratings: [
      { who: "Similar identities", rating: 2.89 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 54.3310617223497,
    lng: 1.6790431585485521,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5362",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher runs towards the horizon lazily.",
  },
  {
    locationId: "item23363",
    locationName: "item23363",
    locationAddress: "item23363",
    ratings: null,
    lat: 57.07550057633829,
    lng: -3.588998011631446,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5363",
    tags: [],
    locationDescription:
      " The student writes the cake lazily. The cat writes a book angrily.",
  },
  {
    locationId: "item23364",
    locationName: "item23364",
    locationAddress: "item23364",
    ratings: null,
    lat: 54.48320638416703,
    lng: -7.1213955402925935,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5364",
    tags: [],
    locationDescription:
      " A woman runs towards the horizon silently. The teacher jumps over the cake gracefully. The cat looks at a book lazily. The cat runs towards a tower quickly. The cat jumps over the road lazily.",
  },
  {
    locationId: "item23365",
    locationName: "item23365",
    locationAddress: "item23365",
    ratings: [
      { who: "Similar identities", rating: 2.33 },
      { who: "All perspectives", rating: 4.73 },
    ],
    lat: 55.356906095384375,
    lng: -5.459576955486501,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5365",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher looks at the road quickly.",
  },
  {
    locationId: "item23366",
    locationName: "item23366",
    locationAddress: "item23366",
    ratings: null,
    lat: 59.17089520002613,
    lng: -0.22969780341742307,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5366",
    tags: [],
    locationDescription: " The cat builds a fence gracefully.",
  },
  {
    locationId: "item23367",
    locationName: "item23367",
    locationAddress: "item23367",
    ratings: null,
    lat: 57.484852034000845,
    lng: -1.4595320183449711,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5367",
    tags: [],
    locationDescription:
      " The man looks at the horizon happily. A dog looks at the road angrily. The man runs towards a book happily. The student runs towards the cake gracefully.",
  },
  {
    locationId: "item23368",
    locationName: "item23368",
    locationAddress: "item23368",
    ratings: [
      { who: "Similar identities", rating: 4.64 },
      { who: "All perspectives", rating: 4.88 },
    ],
    lat: 55.366874855839335,
    lng: -4.363471469075092,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5368",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman runs towards the road quickly. The teacher jumps over a tower quickly. The cat eats a tower angrily. The man writes a tower silently. The cat builds a fence silently.",
  },
  {
    locationId: "item23369",
    locationName: "item23369",
    locationAddress: "item23369",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 1.09 },
    ],
    lat: 56.76718869935495,
    lng: -6.751715539329631,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5369",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A dog eats the road quickly. The cat eats a book happily.",
  },
  {
    locationId: "item23370",
    locationName: "item23370",
    locationAddress: "item23370",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 2.84 },
    ],
    lat: 50.617387666001406,
    lng: -2.9080741354429183,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5370",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription: " The man builds a tower silently.",
  },
  {
    locationId: "item23371",
    locationName: "item23371",
    locationAddress: "item23371",
    ratings: null,
    lat: 52.83671304796695,
    lng: -7.54648156348423,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5371",
    tags: [],
    locationDescription:
      " A woman runs towards a tower angrily. The man builds the cake silently. A dog eats a fence quickly. A woman writes a tower lazily.",
  },
  {
    locationId: "item23372",
    locationName: "item23372",
    locationAddress: "item23372",
    ratings: [
      { who: "Similar identities", rating: 2.95 },
      { who: "All perspectives", rating: 3.63 },
    ],
    lat: 52.207820871988595,
    lng: -3.9231229426073186,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5372",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A woman eats the horizon angrily. The teacher runs towards a book silently.",
  },
  {
    locationId: "item23373",
    locationName: "item23373",
    locationAddress: "item23373",
    ratings: null,
    lat: 52.91422951044507,
    lng: -4.219592979032911,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5373",
    tags: [],
    locationDescription:
      " A woman writes a fence angrily. A woman writes the road gracefully. A dog writes a book gracefully. The teacher writes the road quickly. The student jumps over the road silently.",
  },
  {
    locationId: "item23374",
    locationName: "item23374",
    locationAddress: "item23374",
    ratings: [
      { who: "Similar identities", rating: 3.79 },
      { who: "All perspectives", rating: 1.43 },
    ],
    lat: 54.2451787287053,
    lng: 0.5538089032593589,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5374",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher eats a book silently. The man runs towards a book angrily.",
  },
  {
    locationId: "item23375",
    locationName: "item23375",
    locationAddress: "item23375",
    ratings: null,
    lat: 56.34580316536056,
    lng: -4.605623408208579,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5375",
    tags: [],
    locationDescription: " The cat runs towards a fence happily.",
  },
  {
    locationId: "item23376",
    locationName: "item23376",
    locationAddress: "item23376",
    ratings: null,
    lat: 55.72243342097678,
    lng: -7.230240125942201,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5376",
    tags: [],
    locationDescription:
      " The man writes the cake happily. The cat jumps over a book angrily. The teacher builds a tower quickly. A dog runs towards a book silently.",
  },
  {
    locationId: "item23377",
    locationName: "item23377",
    locationAddress: "item23377",
    ratings: null,
    lat: 50.70516819170031,
    lng: -6.204803142362142,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5377",
    tags: [],
    locationDescription:
      " A dog writes the road happily. A dog runs towards a book gracefully.",
  },
  {
    locationId: "item23378",
    locationName: "item23378",
    locationAddress: "item23378",
    ratings: null,
    lat: 59.901437744714315,
    lng: -6.40701387655372,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5378",
    tags: [],
    locationDescription:
      " A woman writes the horizon angrily. The student eats a fence quickly. The student jumps over the road happily. The cat builds the cake silently. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item23379",
    locationName: "item23379",
    locationAddress: "item23379",
    ratings: [
      { who: "Similar identities", rating: 0.87 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 58.5349753847139,
    lng: -7.032190657918748,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5379",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog looks at a fence quickly. The teacher runs towards a tower gracefully.",
  },
  {
    locationId: "item23380",
    locationName: "item23380",
    locationAddress: "item23380",
    ratings: [
      { who: "Similar identities", rating: 2.25 },
      { who: "All perspectives", rating: 0.25 },
    ],
    lat: 59.72932979614107,
    lng: -1.7686953738041478,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5380",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription: " A dog runs towards the horizon lazily.",
  },
  {
    locationId: "item23381",
    locationName: "item23381",
    locationAddress: "item23381",
    ratings: null,
    lat: 56.08752196203046,
    lng: -8.371152799629037,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5381",
    tags: [],
    locationDescription:
      " A woman runs towards a tower happily. A dog builds a tower lazily. The teacher builds a book gracefully. The cat eats the horizon angrily.",
  },
  {
    locationId: "item23382",
    locationName: "item23382",
    locationAddress: "item23382",
    ratings: null,
    lat: 57.47064661429645,
    lng: -0.11711912004453318,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5382",
    tags: [],
    locationDescription:
      " A woman builds the cake gracefully. The student builds the horizon happily.",
  },
  {
    locationId: "item23383",
    locationName: "item23383",
    locationAddress: "item23383",
    ratings: null,
    lat: 55.356981809775206,
    lng: -0.2486478888506234,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5383",
    tags: [],
    locationDescription: " The man jumps over the road lazily.",
  },
  {
    locationId: "item23384",
    locationName: "item23384",
    locationAddress: "item23384",
    ratings: [
      { who: "Similar identities", rating: 1.93 },
      { who: "All perspectives", rating: 0.46 },
    ],
    lat: 52.958787846059025,
    lng: -2.8707265423930153,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5384",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student builds the cake silently. The man builds a book silently. The teacher builds a book angrily. The teacher jumps over a fence gracefully. The man eats the road happily.",
  },
  {
    locationId: "item23385",
    locationName: "item23385",
    locationAddress: "item23385",
    ratings: null,
    lat: 53.74564480452729,
    lng: -6.655553776179217,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5385",
    tags: [],
    locationDescription:
      " The cat runs towards the horizon angrily. The teacher writes the horizon happily. A dog eats the cake gracefully. The man looks at a tower silently.",
  },
  {
    locationId: "item23386",
    locationName: "item23386",
    locationAddress: "item23386",
    ratings: [
      { who: "Similar identities", rating: 0.48 },
      { who: "All perspectives", rating: 0.35 },
    ],
    lat: 51.94942713589768,
    lng: -2.105692419427986,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5386",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " A dog builds a fence gracefully.",
  },
  {
    locationId: "item23387",
    locationName: "item23387",
    locationAddress: "item23387",
    ratings: [
      { who: "Similar identities", rating: 2.93 },
      { who: "All perspectives", rating: 1.36 },
    ],
    lat: 53.43740983519186,
    lng: -0.9478812758448791,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5387",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds the cake silently. The student runs towards the road lazily. The cat runs towards a book quickly.",
  },
  {
    locationId: "item23388",
    locationName: "item23388",
    locationAddress: "item23388",
    ratings: [
      { who: "Similar identities", rating: 4.05 },
      { who: "All perspectives", rating: 1.68 },
    ],
    lat: 56.103535192811655,
    lng: -8.426249054960914,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5388",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student builds a book quickly. A dog eats the horizon angrily. The cat runs towards the horizon happily. A dog looks at a tower happily.",
  },
  {
    locationId: "item23389",
    locationName: "item23389",
    locationAddress: "item23389",
    ratings: null,
    lat: 53.2567709566198,
    lng: -7.936075595127512,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5389",
    tags: [],
    locationDescription: " The man builds a fence happily.",
  },
  {
    locationId: "item23390",
    locationName: "item23390",
    locationAddress: "item23390",
    ratings: null,
    lat: 59.85433982484631,
    lng: -6.220190950996499,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5390",
    tags: [],
    locationDescription: " A woman builds the road angrily.",
  },
  {
    locationId: "item23391",
    locationName: "item23391",
    locationAddress: "item23391",
    ratings: [
      { who: "Similar identities", rating: 4.03 },
      { who: "All perspectives", rating: 0.14 },
    ],
    lat: 58.7488623039305,
    lng: 0.19199620324798872,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5391",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man jumps over the cake lazily. A woman builds a fence happily.",
  },
  {
    locationId: "item23392",
    locationName: "item23392",
    locationAddress: "item23392",
    ratings: [
      { who: "Similar identities", rating: 1.3 },
      { who: "All perspectives", rating: 1.46 },
    ],
    lat: 57.72272187152585,
    lng: -2.256096314970846,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5392",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher looks at a book happily. A dog writes a book silently. A woman writes a fence happily. The student runs towards a fence angrily.",
  },
  {
    locationId: "item23393",
    locationName: "item23393",
    locationAddress: "item23393",
    ratings: [
      { who: "Similar identities", rating: 3.44 },
      { who: "All perspectives", rating: 1.49 },
    ],
    lat: 54.54184921609488,
    lng: -0.24886601578450218,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5393",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student eats the horizon happily. The man looks at the road happily. The cat looks at the road happily. The man builds the horizon quickly.",
  },
  {
    locationId: "item23394",
    locationName: "item23394",
    locationAddress: "item23394",
    ratings: null,
    lat: 50.74522339804103,
    lng: -3.1976067451248085,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5394",
    tags: [],
    locationDescription:
      " The cat jumps over a fence quickly. A woman runs towards a book lazily.",
  },
  {
    locationId: "item23395",
    locationName: "item23395",
    locationAddress: "item23395",
    ratings: [
      { who: "Similar identities", rating: 2.8 },
      { who: "All perspectives", rating: 2.91 },
    ],
    lat: 52.226827479553194,
    lng: -3.201872380671218,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5395",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " The teacher looks at the horizon happily.",
  },
  {
    locationId: "item23396",
    locationName: "item23396",
    locationAddress: "item23396",
    ratings: null,
    lat: 50.31910546887506,
    lng: 0.2602810274286771,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5396",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake silently. The man builds a book lazily. The cat jumps over a book happily. The man runs towards the cake happily. A dog runs towards the road quickly.",
  },
  {
    locationId: "item23397",
    locationName: "item23397",
    locationAddress: "item23397",
    ratings: [
      { who: "Similar identities", rating: 1.26 },
      { who: "All perspectives", rating: 3.23 },
    ],
    lat: 55.12785946918037,
    lng: -4.791206204369633,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5397",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student builds the horizon happily. A dog jumps over the road silently. The man builds the cake happily. The man runs towards the cake happily.",
  },
  {
    locationId: "item23398",
    locationName: "item23398",
    locationAddress: "item23398",
    ratings: null,
    lat: 59.71716541767947,
    lng: 1.5992848027065367,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5398",
    tags: [],
    locationDescription:
      " A dog eats the horizon happily. The teacher eats a book angrily.",
  },
  {
    locationId: "item23399",
    locationName: "item23399",
    locationAddress: "item23399",
    ratings: null,
    lat: 54.44312517074863,
    lng: 1.0406139063992903,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5399",
    tags: [],
    locationDescription:
      " A dog jumps over a book angrily. A woman jumps over the horizon happily. The teacher looks at the cake gracefully. The student eats the road lazily. The man writes the road gracefully.",
  },
  {
    locationId: "item23400",
    locationName: "item23400",
    locationAddress: "item23400",
    ratings: [
      { who: "Similar identities", rating: 2.46 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 51.55719089401998,
    lng: -8.236871680511983,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5400",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man runs towards a tower happily.",
  },
  {
    locationId: "item23401",
    locationName: "item23401",
    locationAddress: "item23401",
    ratings: [
      { who: "Similar identities", rating: 3.72 },
      { who: "All perspectives", rating: 0.29 },
    ],
    lat: 52.830694704998166,
    lng: -5.593191475578439,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5401",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The student jumps over the cake silently.",
  },
  {
    locationId: "item23402",
    locationName: "item23402",
    locationAddress: "item23402",
    ratings: null,
    lat: 52.904497131416406,
    lng: -8.30477589768973,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5402",
    tags: [],
    locationDescription:
      " The man writes the horizon silently. The student jumps over the horizon angrily. The student runs towards a fence gracefully. The teacher eats a fence lazily.",
  },
  {
    locationId: "item23403",
    locationName: "item23403",
    locationAddress: "item23403",
    ratings: null,
    lat: 54.788231929154335,
    lng: -5.453444108678703,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5403",
    tags: [],
    locationDescription:
      " The man runs towards a tower gracefully. The student jumps over a tower angrily. The man runs towards the horizon happily. The man jumps over a fence silently.",
  },
  {
    locationId: "item23404",
    locationName: "item23404",
    locationAddress: "item23404",
    ratings: null,
    lat: 54.188477668264476,
    lng: -7.315151465909922,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5404",
    tags: [],
    locationDescription:
      " A dog jumps over a book quickly. A dog writes a fence happily. A woman runs towards a tower quickly.",
  },
  {
    locationId: "item23405",
    locationName: "item23405",
    locationAddress: "item23405",
    ratings: null,
    lat: 50.420259155799975,
    lng: -2.647875468696599,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5405",
    tags: [],
    locationDescription: " A dog jumps over a tower quickly.",
  },
  {
    locationId: "item23406",
    locationName: "item23406",
    locationAddress: "item23406",
    ratings: null,
    lat: 54.644316887069685,
    lng: -4.5324517319755016,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5406",
    tags: [],
    locationDescription:
      " The cat looks at the road angrily. A dog jumps over a tower happily. The cat eats the cake lazily. The student runs towards a tower gracefully.",
  },
  {
    locationId: "item23407",
    locationName: "item23407",
    locationAddress: "item23407",
    ratings: null,
    lat: 50.68696043624979,
    lng: -0.3106255005183449,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5407",
    tags: [],
    locationDescription:
      " The cat builds a fence angrily. A dog looks at the horizon happily.",
  },
  {
    locationId: "item23408",
    locationName: "item23408",
    locationAddress: "item23408",
    ratings: [
      { who: "Similar identities", rating: 3.43 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 59.71664757262119,
    lng: -5.369891907963304,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5408",
    tags: [{ label: "accessible" }],
    locationDescription: " The cat writes a fence quickly.",
  },
  {
    locationId: "item23409",
    locationName: "item23409",
    locationAddress: "item23409",
    ratings: null,
    lat: 50.823955912828424,
    lng: 1.5009205993327353,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5409",
    tags: [],
    locationDescription:
      " The man writes the cake angrily. The teacher jumps over the road gracefully. The cat eats a tower angrily. The teacher jumps over the cake happily.",
  },
  {
    locationId: "item23410",
    locationName: "item23410",
    locationAddress: "item23410",
    ratings: [
      { who: "Similar identities", rating: 1.34 },
      { who: "All perspectives", rating: 0.43 },
    ],
    lat: 57.17135996568826,
    lng: -4.066353650526503,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5410",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman eats the horizon happily. The cat writes the horizon lazily. The teacher eats the road lazily. A dog writes the cake silently. The cat builds a tower happily.",
  },
  {
    locationId: "item23411",
    locationName: "item23411",
    locationAddress: "item23411",
    ratings: [
      { who: "Similar identities", rating: 3.64 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 53.581004806183735,
    lng: -0.3454434501420298,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5411",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over a book gracefully. The man builds a book lazily.",
  },
  {
    locationId: "item23412",
    locationName: "item23412",
    locationAddress: "item23412",
    ratings: [
      { who: "Similar identities", rating: 0.08 },
      { who: "All perspectives", rating: 1.17 },
    ],
    lat: 50.08279488927752,
    lng: -2.5661210708192463,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5412",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat jumps over a fence gracefully. The teacher eats a tower lazily. A dog builds the road lazily. The student builds a tower quickly. The cat jumps over the horizon gracefully.",
  },
  {
    locationId: "item23413",
    locationName: "item23413",
    locationAddress: "item23413",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 4.77 },
    ],
    lat: 57.27014036608739,
    lng: -3.083971968152568,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5413",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman builds a book gracefully. The cat writes the horizon silently. A woman writes a fence silently.",
  },
  {
    locationId: "item23414",
    locationName: "item23414",
    locationAddress: "item23414",
    ratings: null,
    lat: 56.42184359750898,
    lng: -1.5402893433694498,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5414",
    tags: [],
    locationDescription: " The man eats the road quickly.",
  },
  {
    locationId: "item23415",
    locationName: "item23415",
    locationAddress: "item23415",
    ratings: null,
    lat: 51.550218243613216,
    lng: 1.4434819705652977,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5415",
    tags: [],
    locationDescription:
      " The student jumps over a fence angrily. The man builds a tower quickly. The cat writes the cake lazily. A dog looks at a tower quickly.",
  },
  {
    locationId: "item23416",
    locationName: "item23416",
    locationAddress: "item23416",
    ratings: null,
    lat: 57.79697737674893,
    lng: -0.20346039526114978,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5416",
    tags: [],
    locationDescription: " The teacher builds a fence happily.",
  },
  {
    locationId: "item23417",
    locationName: "item23417",
    locationAddress: "item23417",
    ratings: null,
    lat: 54.46234417967419,
    lng: -0.5574937888394338,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5417",
    tags: [],
    locationDescription:
      " The cat writes a book silently. The teacher eats the cake angrily.",
  },
  {
    locationId: "item23418",
    locationName: "item23418",
    locationAddress: "item23418",
    ratings: null,
    lat: 58.59756612732378,
    lng: 0.7854687170606667,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5418",
    tags: [],
    locationDescription:
      " A woman writes a tower gracefully. A woman builds a tower gracefully. A woman eats the cake angrily.",
  },
  {
    locationId: "item23419",
    locationName: "item23419",
    locationAddress: "item23419",
    ratings: [
      { who: "Similar identities", rating: 0.92 },
      { who: "All perspectives", rating: 2.71 },
    ],
    lat: 60.35642898991121,
    lng: -7.088286971147351,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5419",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman writes a book angrily. The man looks at a fence gracefully. The student builds a tower quickly. The student runs towards the road happily.",
  },
  {
    locationId: "item23420",
    locationName: "item23420",
    locationAddress: "item23420",
    ratings: null,
    lat: 54.21297811244181,
    lng: 0.7852097009960541,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5420",
    tags: [],
    locationDescription:
      " The man writes a tower happily. The student jumps over the cake silently.",
  },
  {
    locationId: "item23421",
    locationName: "item23421",
    locationAddress: "item23421",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 1.51 },
    ],
    lat: 58.71365497481396,
    lng: -2.0674709297843723,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5421",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man jumps over the cake gracefully. The teacher writes a fence lazily. The student eats a tower quickly. A dog runs towards the cake lazily.",
  },
  {
    locationId: "item23422",
    locationName: "item23422",
    locationAddress: "item23422",
    ratings: [
      { who: "Similar identities", rating: 0.18 },
      { who: "All perspectives", rating: 3.92 },
    ],
    lat: 56.601430537597736,
    lng: -5.85902148002727,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5422",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student looks at the cake happily. The teacher looks at the cake quickly. The man writes a tower silently. The cat looks at the horizon quickly.",
  },
  {
    locationId: "item23423",
    locationName: "item23423",
    locationAddress: "item23423",
    ratings: null,
    lat: 57.128128565527405,
    lng: -1.917833258600293,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5423",
    tags: [],
    locationDescription:
      " The man eats the horizon quickly. A dog jumps over the cake lazily.",
  },
  {
    locationId: "item23424",
    locationName: "item23424",
    locationAddress: "item23424",
    ratings: null,
    lat: 54.469740144664314,
    lng: -2.41511511014051,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5424",
    tags: [],
    locationDescription:
      " The man writes the horizon silently. The student runs towards the horizon lazily. The student runs towards a tower lazily. The teacher jumps over the horizon happily.",
  },
  {
    locationId: "item23425",
    locationName: "item23425",
    locationAddress: "item23425",
    ratings: null,
    lat: 54.936398573179304,
    lng: -2.0562825256148978,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5425",
    tags: [],
    locationDescription:
      " The cat eats the road happily. The man jumps over a tower lazily. The teacher writes a tower lazily. The teacher runs towards the horizon gracefully.",
  },
  {
    locationId: "item23426",
    locationName: "item23426",
    locationAddress: "item23426",
    ratings: [
      { who: "Similar identities", rating: 4.93 },
      { who: "All perspectives", rating: 2.65 },
    ],
    lat: 57.65138771224002,
    lng: -4.679007798984738,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5426",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats the horizon happily. The student jumps over a book quickly. A woman writes a book lazily. The student runs towards the road quickly.",
  },
  {
    locationId: "item23427",
    locationName: "item23427",
    locationAddress: "item23427",
    ratings: null,
    lat: 52.83481501955571,
    lng: -1.0612477128927589,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5427",
    tags: [],
    locationDescription: " A woman writes the road happily.",
  },
  {
    locationId: "item23428",
    locationName: "item23428",
    locationAddress: "item23428",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 52.230644481960205,
    lng: -5.179350221198694,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5428",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog looks at a tower gracefully.",
  },
  {
    locationId: "item23429",
    locationName: "item23429",
    locationAddress: "item23429",
    ratings: [
      { who: "Similar identities", rating: 1.76 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 53.281694231845314,
    lng: -2.2194811569411277,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5429",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The teacher jumps over the road silently. The student jumps over a fence lazily.",
  },
  {
    locationId: "item23430",
    locationName: "item23430",
    locationAddress: "item23430",
    ratings: null,
    lat: 53.071901948745534,
    lng: -1.6230319416307113,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5430",
    tags: [],
    locationDescription:
      " A woman builds the horizon lazily. A dog writes a fence gracefully. The man eats the road gracefully. The student runs towards the horizon angrily.",
  },
  {
    locationId: "item23431",
    locationName: "item23431",
    locationAddress: "item23431",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 50.981876067089765,
    lng: -4.043616438337161,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5431",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards a tower lazily. The teacher looks at the road lazily. A woman writes the cake quickly. The man looks at the horizon quickly. The cat jumps over a book angrily.",
  },
  {
    locationId: "item23432",
    locationName: "item23432",
    locationAddress: "item23432",
    ratings: null,
    lat: 51.5734155922346,
    lng: -6.357362284897546,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5432",
    tags: [],
    locationDescription:
      " The cat builds the cake quickly. The teacher eats the cake gracefully. A woman builds a book silently. The teacher writes the road quickly.",
  },
  {
    locationId: "item23433",
    locationName: "item23433",
    locationAddress: "item23433",
    ratings: [
      { who: "Similar identities", rating: 3.23 },
      { who: "All perspectives", rating: 1.36 },
    ],
    lat: 51.057701971502155,
    lng: 0.4698043367955478,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5433",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The teacher jumps over the cake angrily. The student runs towards a fence silently. A dog builds the horizon angrily.",
  },
  {
    locationId: "item23434",
    locationName: "item23434",
    locationAddress: "item23434",
    ratings: [
      { who: "Similar identities", rating: 4.88 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 60.51545110125969,
    lng: -7.515074081317312,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5434",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The teacher runs towards a book angrily.",
  },
  {
    locationId: "item23435",
    locationName: "item23435",
    locationAddress: "item23435",
    ratings: [
      { who: "Similar identities", rating: 0.56 },
      { who: "All perspectives", rating: 3.2 },
    ],
    lat: 58.11113278450691,
    lng: 1.0861727603238798,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5435",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman jumps over the horizon angrily. A woman builds the road happily. The man jumps over a book angrily. The cat jumps over a fence silently.",
  },
  {
    locationId: "item23436",
    locationName: "item23436",
    locationAddress: "item23436",
    ratings: [
      { who: "Similar identities", rating: 3.47 },
      { who: "All perspectives", rating: 1.72 },
    ],
    lat: 55.57459056759225,
    lng: -8.562619166451062,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5436",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman jumps over the cake quickly. The teacher looks at the cake happily. The man runs towards the road lazily.",
  },
  {
    locationId: "item23437",
    locationName: "item23437",
    locationAddress: "item23437",
    ratings: [
      { who: "Similar identities", rating: 0.23 },
      { who: "All perspectives", rating: 4.74 },
    ],
    lat: 53.78118560218852,
    lng: -5.887126763456857,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5437",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat builds a fence angrily. The teacher writes a tower silently. The cat eats the road happily.",
  },
  {
    locationId: "item23438",
    locationName: "item23438",
    locationAddress: "item23438",
    ratings: null,
    lat: 49.94640780464025,
    lng: -1.0814877864525405,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5438",
    tags: [],
    locationDescription:
      " A dog jumps over the horizon silently. The teacher writes a book lazily. The cat looks at a book gracefully.",
  },
  {
    locationId: "item23439",
    locationName: "item23439",
    locationAddress: "item23439",
    ratings: [
      { who: "Similar identities", rating: 3.04 },
      { who: "All perspectives", rating: 2.4 },
    ],
    lat: 60.53156372263675,
    lng: 0.4135811852411937,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5439",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " A dog runs towards a book angrily.",
  },
  {
    locationId: "item23440",
    locationName: "item23440",
    locationAddress: "item23440",
    ratings: null,
    lat: 52.967213088165714,
    lng: -0.027311984233659103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5440",
    tags: [],
    locationDescription:
      " The student jumps over a fence quickly. A dog eats the road lazily. The cat eats the cake gracefully. A dog builds a tower angrily.",
  },
  {
    locationId: "item23441",
    locationName: "item23441",
    locationAddress: "item23441",
    ratings: [
      { who: "Similar identities", rating: 3.1 },
      { who: "All perspectives", rating: 1.56 },
    ],
    lat: 56.66472144630031,
    lng: -2.969253139765952,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5441",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student builds a book silently. The man looks at a fence angrily. The man jumps over a book silently. The teacher builds the horizon angrily.",
  },
  {
    locationId: "item23442",
    locationName: "item23442",
    locationAddress: "item23442",
    ratings: null,
    lat: 51.144613455162116,
    lng: -7.45144743170456,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5442",
    tags: [],
    locationDescription:
      " The man runs towards a tower angrily. A woman builds a tower quickly. A woman builds the horizon lazily. The teacher looks at the cake quickly. The cat looks at the cake quickly.",
  },
  {
    locationId: "item23443",
    locationName: "item23443",
    locationAddress: "item23443",
    ratings: null,
    lat: 50.52500923887656,
    lng: 1.5523467318319657,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5443",
    tags: [],
    locationDescription: " A dog builds a tower angrily.",
  },
  {
    locationId: "item23444",
    locationName: "item23444",
    locationAddress: "item23444",
    ratings: [
      { who: "Similar identities", rating: 3.06 },
      { who: "All perspectives", rating: 3.32 },
    ],
    lat: 58.74676007316363,
    lng: -1.9655373246774284,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5444",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " The student writes a book gracefully.",
  },
  {
    locationId: "item23445",
    locationName: "item23445",
    locationAddress: "item23445",
    ratings: [
      { who: "Similar identities", rating: 2.35 },
      { who: "All perspectives", rating: 0.46 },
    ],
    lat: 56.59317457238939,
    lng: -2.2491016091827793,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5445",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats the cake angrily. A dog jumps over the road quickly. A woman eats a fence lazily.",
  },
  {
    locationId: "item23446",
    locationName: "item23446",
    locationAddress: "item23446",
    ratings: null,
    lat: 60.372278187553626,
    lng: -7.850090693592199,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5446",
    tags: [],
    locationDescription: " A woman runs towards the cake quickly.",
  },
  {
    locationId: "item23447",
    locationName: "item23447",
    locationAddress: "item23447",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 1.39 },
    ],
    lat: 57.93870183315989,
    lng: -3.789429665236458,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5447",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The man builds the horizon quickly.",
  },
  {
    locationId: "item23448",
    locationName: "item23448",
    locationAddress: "item23448",
    ratings: null,
    lat: 58.671189327712526,
    lng: -1.580283630958279,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5448",
    tags: [],
    locationDescription: " A dog writes the cake happily.",
  },
  {
    locationId: "item23449",
    locationName: "item23449",
    locationAddress: "item23449",
    ratings: null,
    lat: 52.89099794331802,
    lng: -0.3670582308757062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5449",
    tags: [],
    locationDescription:
      " The cat builds a tower angrily. A woman jumps over the horizon happily.",
  },
  {
    locationId: "item23450",
    locationName: "item23450",
    locationAddress: "item23450",
    ratings: null,
    lat: 54.44050205649671,
    lng: 0.30290684606281104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5450",
    tags: [],
    locationDescription: " The student writes the cake quickly.",
  },
  {
    locationId: "item23451",
    locationName: "item23451",
    locationAddress: "item23451",
    ratings: [
      { who: "Similar identities", rating: 1.95 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 52.63632342182928,
    lng: -1.8771496100891536,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5451",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at a book silently. The teacher looks at the road silently. The student writes the road happily. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item23452",
    locationName: "item23452",
    locationAddress: "item23452",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 60.568855171733624,
    lng: -1.5504411949433043,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5452",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The student looks at a book happily.",
  },
  {
    locationId: "item23453",
    locationName: "item23453",
    locationAddress: "item23453",
    ratings: null,
    lat: 51.32558404787119,
    lng: -1.5050254531299103,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5453",
    tags: [],
    locationDescription:
      " The teacher writes the cake angrily. A dog writes a tower quickly. The cat writes the horizon quickly. A dog jumps over a tower silently. The man writes a tower silently.",
  },
  {
    locationId: "item23454",
    locationName: "item23454",
    locationAddress: "item23454",
    ratings: [
      { who: "Similar identities", rating: 4.7 },
      { who: "All perspectives", rating: 4.17 },
    ],
    lat: 57.4405035489176,
    lng: -0.3988015949667165,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5454",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher writes a book happily. The cat looks at the cake lazily.",
  },
  {
    locationId: "item23455",
    locationName: "item23455",
    locationAddress: "item23455",
    ratings: null,
    lat: 56.1701541381539,
    lng: -5.044563995775358,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5455",
    tags: [],
    locationDescription:
      " The man builds a tower lazily. The man jumps over a book gracefully. A woman writes a tower silently.",
  },
  {
    locationId: "item23456",
    locationName: "item23456",
    locationAddress: "item23456",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 4.25 },
    ],
    lat: 52.20316663509748,
    lng: -6.989711167009359,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5456",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student looks at a tower quickly. The teacher looks at the cake silently. A dog runs towards a book happily.",
  },
  {
    locationId: "item23457",
    locationName: "item23457",
    locationAddress: "item23457",
    ratings: null,
    lat: 57.58085815597467,
    lng: -0.5622990645936419,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5457",
    tags: [],
    locationDescription:
      " The student runs towards the cake quickly. The cat runs towards a book angrily. The teacher runs towards a book happily.",
  },
  {
    locationId: "item23458",
    locationName: "item23458",
    locationAddress: "item23458",
    ratings: null,
    lat: 56.65983226545028,
    lng: -2.771896688637625,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5458",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower silently. A dog jumps over the cake angrily. A woman jumps over a fence lazily.",
  },
  {
    locationId: "item23459",
    locationName: "item23459",
    locationAddress: "item23459",
    ratings: [
      { who: "Similar identities", rating: 0.76 },
      { who: "All perspectives", rating: 4.31 },
    ],
    lat: 56.70418274080106,
    lng: -2.879876857428158,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5459",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher looks at the road quickly. The student builds a fence gracefully. A woman runs towards a fence quickly. The man builds a tower angrily. A dog runs towards a book quickly.",
  },
  {
    locationId: "item23460",
    locationName: "item23460",
    locationAddress: "item23460",
    ratings: null,
    lat: 55.85331774405355,
    lng: 0.6407794219749494,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5460",
    tags: [],
    locationDescription:
      " A woman looks at the horizon lazily. A woman eats the road quickly.",
  },
  {
    locationId: "item23461",
    locationName: "item23461",
    locationAddress: "item23461",
    ratings: null,
    lat: 59.47418521986987,
    lng: -1.3051120368487554,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5461",
    tags: [],
    locationDescription:
      " A dog jumps over the cake gracefully. A dog looks at the horizon lazily. The cat builds the road gracefully. A woman writes the horizon lazily.",
  },
  {
    locationId: "item23462",
    locationName: "item23462",
    locationAddress: "item23462",
    ratings: null,
    lat: 50.601611388063006,
    lng: -5.191083973057291,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5462",
    tags: [],
    locationDescription:
      " A woman builds a tower gracefully. The man builds the cake lazily.",
  },
  {
    locationId: "item23463",
    locationName: "item23463",
    locationAddress: "item23463",
    ratings: null,
    lat: 53.33460954252981,
    lng: 1.6834951396676914,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5463",
    tags: [],
    locationDescription: " A woman looks at a book gracefully.",
  },
  {
    locationId: "item23464",
    locationName: "item23464",
    locationAddress: "item23464",
    ratings: null,
    lat: 55.48082083987878,
    lng: -0.4177959598221346,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5464",
    tags: [],
    locationDescription:
      " The teacher looks at the cake lazily. The man eats the cake gracefully. The man jumps over a tower quickly. A woman builds the road gracefully.",
  },
  {
    locationId: "item23465",
    locationName: "item23465",
    locationAddress: "item23465",
    ratings: [
      { who: "Similar identities", rating: 4.94 },
      { who: "All perspectives", rating: 4.73 },
    ],
    lat: 54.70534454346415,
    lng: -1.205514175613989,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5465",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student looks at a tower lazily. A dog jumps over a fence gracefully.",
  },
  {
    locationId: "item23466",
    locationName: "item23466",
    locationAddress: "item23466",
    ratings: null,
    lat: 53.02008390137383,
    lng: -3.003379811222194,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5466",
    tags: [],
    locationDescription:
      " The student writes the road silently. The cat builds the road silently. The man writes a book angrily.",
  },
  {
    locationId: "item23467",
    locationName: "item23467",
    locationAddress: "item23467",
    ratings: null,
    lat: 58.49544630027124,
    lng: 0.9665284474666969,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5467",
    tags: [],
    locationDescription:
      " A woman eats the cake quickly. A dog runs towards the cake quickly.",
  },
  {
    locationId: "item23468",
    locationName: "item23468",
    locationAddress: "item23468",
    ratings: null,
    lat: 50.737315824795765,
    lng: 1.096879619428524,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5468",
    tags: [],
    locationDescription:
      " A dog looks at the road angrily. The man runs towards a book lazily. The man builds the cake quickly. A dog jumps over a fence happily.",
  },
  {
    locationId: "item23469",
    locationName: "item23469",
    locationAddress: "item23469",
    ratings: [
      { who: "Similar identities", rating: 0.45 },
      { who: "All perspectives", rating: 0.18 },
    ],
    lat: 55.636572643099,
    lng: -3.2456208615854676,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5469",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The man writes a fence lazily. The student eats a book lazily. The teacher builds the cake lazily. The teacher builds the road gracefully.",
  },
  {
    locationId: "item23470",
    locationName: "item23470",
    locationAddress: "item23470",
    ratings: null,
    lat: 54.957522715016864,
    lng: -7.878531745077375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5470",
    tags: [],
    locationDescription:
      " A dog runs towards a fence angrily. The teacher looks at a fence lazily. The teacher eats the road lazily. The man jumps over the road quickly.",
  },
  {
    locationId: "item23471",
    locationName: "item23471",
    locationAddress: "item23471",
    ratings: null,
    lat: 60.707520236761205,
    lng: -6.460822359181231,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5471",
    tags: [],
    locationDescription:
      " A woman jumps over the road quickly. A woman runs towards the cake lazily. A dog looks at the road angrily. A woman jumps over the cake silently.",
  },
  {
    locationId: "item23472",
    locationName: "item23472",
    locationAddress: "item23472",
    ratings: [
      { who: "Similar identities", rating: 3.39 },
      { who: "All perspectives", rating: 3.11 },
    ],
    lat: 58.14258372178769,
    lng: -6.994282044466134,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5472",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat writes a fence quickly.",
  },
  {
    locationId: "item23473",
    locationName: "item23473",
    locationAddress: "item23473",
    ratings: [
      { who: "Similar identities", rating: 2.8 },
      { who: "All perspectives", rating: 3.93 },
    ],
    lat: 50.64700152244385,
    lng: -2.723948731338167,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5473",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats a tower happily. The cat eats a fence happily. A dog runs towards the road angrily.",
  },
  {
    locationId: "item23474",
    locationName: "item23474",
    locationAddress: "item23474",
    ratings: null,
    lat: 52.34395464225587,
    lng: -1.5142281701115872,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5474",
    tags: [],
    locationDescription:
      " The man writes a fence happily. The teacher writes a book quickly. The cat writes a fence lazily. The cat writes a fence quickly.",
  },
  {
    locationId: "item23475",
    locationName: "item23475",
    locationAddress: "item23475",
    ratings: null,
    lat: 56.611440187493635,
    lng: -6.926668278995871,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5475",
    tags: [],
    locationDescription:
      " The cat runs towards the cake happily. The student builds the horizon angrily. The student builds the road gracefully. The man runs towards a book quickly. The student eats the cake quickly.",
  },
  {
    locationId: "item23476",
    locationName: "item23476",
    locationAddress: "item23476",
    ratings: [
      { who: "Similar identities", rating: 3.78 },
      { who: "All perspectives", rating: 3.48 },
    ],
    lat: 60.07832854252678,
    lng: -2.3649850693317918,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5476",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards a tower happily. The teacher eats the horizon lazily. A dog writes a tower angrily. The man looks at the horizon silently. A woman runs towards a book gracefully.",
  },
  {
    locationId: "item23477",
    locationName: "item23477",
    locationAddress: "item23477",
    ratings: [
      { who: "Similar identities", rating: 1.24 },
      { who: "All perspectives", rating: 4.38 },
    ],
    lat: 53.082642592475906,
    lng: -7.987510394840747,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5477",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher eats the road angrily. The teacher eats the road angrily. The cat looks at the horizon silently.",
  },
  {
    locationId: "item23478",
    locationName: "item23478",
    locationAddress: "item23478",
    ratings: null,
    lat: 51.1036154070939,
    lng: -7.166541826132622,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5478",
    tags: [],
    locationDescription:
      " The teacher eats the road gracefully. A woman jumps over the cake silently. A woman looks at a book angrily. A woman builds the cake angrily.",
  },
  {
    locationId: "item23479",
    locationName: "item23479",
    locationAddress: "item23479",
    ratings: null,
    lat: 51.61223079324941,
    lng: 1.1597959746317397,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5479",
    tags: [],
    locationDescription: " The teacher jumps over a tower lazily.",
  },
  {
    locationId: "item23480",
    locationName: "item23480",
    locationAddress: "item23480",
    ratings: [
      { who: "Similar identities", rating: 2.78 },
      { who: "All perspectives", rating: 1.26 },
    ],
    lat: 51.48436177430735,
    lng: -1.4781305635861104,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5480",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription: " A woman jumps over a tower quickly.",
  },
  {
    locationId: "item23481",
    locationName: "item23481",
    locationAddress: "item23481",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 55.042965649109235,
    lng: -8.549602249372441,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5481",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher jumps over the cake silently. A woman looks at a book happily. The student builds a tower quickly. The man jumps over the cake quickly.",
  },
  {
    locationId: "item23482",
    locationName: "item23482",
    locationAddress: "item23482",
    ratings: null,
    lat: 56.44546599849429,
    lng: 0.26317177176619033,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5482",
    tags: [],
    locationDescription:
      " The student eats the horizon quickly. The student builds the cake angrily. A woman jumps over a tower silently.",
  },
  {
    locationId: "item23483",
    locationName: "item23483",
    locationAddress: "item23483",
    ratings: [
      { who: "Similar identities", rating: 1.42 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 59.49435435606999,
    lng: -8.347144721341804,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5483",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The man runs towards the cake angrily.",
  },
  {
    locationId: "item23484",
    locationName: "item23484",
    locationAddress: "item23484",
    ratings: null,
    lat: 53.9628752404896,
    lng: -5.731371528519315,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5484",
    tags: [],
    locationDescription:
      " The cat jumps over a book angrily. The cat eats a book silently. The student eats a fence quickly.",
  },
  {
    locationId: "item23485",
    locationName: "item23485",
    locationAddress: "item23485",
    ratings: [
      { who: "Similar identities", rating: 4.25 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 52.96000496589909,
    lng: -2.579736718843657,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5485",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog builds a fence silently. A woman runs towards a book lazily. A dog jumps over the horizon angrily. A woman eats a tower silently.",
  },
  {
    locationId: "item23486",
    locationName: "item23486",
    locationAddress: "item23486",
    ratings: null,
    lat: 54.29453962365711,
    lng: -0.4797092066195887,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5486",
    tags: [],
    locationDescription:
      " A dog runs towards a tower gracefully. The student jumps over the road angrily. The cat writes the horizon quickly. The cat eats a tower silently. A woman eats a fence lazily.",
  },
  {
    locationId: "item23487",
    locationName: "item23487",
    locationAddress: "item23487",
    ratings: [
      { who: "Similar identities", rating: 3.85 },
      { who: "All perspectives", rating: 0.59 },
    ],
    lat: 50.18803522514037,
    lng: -5.986573960045791,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5487",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The man jumps over a tower lazily.",
  },
  {
    locationId: "item23488",
    locationName: "item23488",
    locationAddress: "item23488",
    ratings: null,
    lat: 59.44805507755688,
    lng: -2.1079462271846374,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5488",
    tags: [],
    locationDescription:
      " A woman runs towards a fence quickly. The teacher looks at the road happily. The teacher jumps over a tower lazily.",
  },
  {
    locationId: "item23489",
    locationName: "item23489",
    locationAddress: "item23489",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 2.68 },
    ],
    lat: 57.637862177853684,
    lng: -3.658690118789771,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5489",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher looks at the cake silently. The teacher eats a tower angrily.",
  },
  {
    locationId: "item23490",
    locationName: "item23490",
    locationAddress: "item23490",
    ratings: null,
    lat: 53.15153209514622,
    lng: -7.998690920282502,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5490",
    tags: [],
    locationDescription:
      " The student runs towards the horizon quickly. The student eats the horizon happily. A dog runs towards the horizon gracefully.",
  },
  {
    locationId: "item23491",
    locationName: "item23491",
    locationAddress: "item23491",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 2.02 },
    ],
    lat: 50.1419160439153,
    lng: -5.979280454513544,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5491",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The teacher looks at a book quickly.",
  },
  {
    locationId: "item23492",
    locationName: "item23492",
    locationAddress: "item23492",
    ratings: null,
    lat: 58.18376112118666,
    lng: -1.7633023555077294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5492",
    tags: [],
    locationDescription:
      " A woman looks at a tower gracefully. The student runs towards the cake lazily.",
  },
  {
    locationId: "item23493",
    locationName: "item23493",
    locationAddress: "item23493",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 56.84024917260378,
    lng: -3.8350611837000717,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5493",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The student writes a fence happily.",
  },
  {
    locationId: "item23494",
    locationName: "item23494",
    locationAddress: "item23494",
    ratings: null,
    lat: 53.02008377532696,
    lng: -8.186896053334769,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5494",
    tags: [],
    locationDescription:
      " A dog jumps over a fence quickly. The student writes a tower silently. A dog eats the cake silently.",
  },
  {
    locationId: "item23495",
    locationName: "item23495",
    locationAddress: "item23495",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 57.81851414346301,
    lng: -0.932379147176051,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5495",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The teacher writes the horizon angrily.",
  },
  {
    locationId: "item23496",
    locationName: "item23496",
    locationAddress: "item23496",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 0.82 },
    ],
    lat: 50.541838130732735,
    lng: -7.528942329125005,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5496",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A woman jumps over a book happily. The student writes the cake happily. The cat jumps over a book silently. The cat jumps over the horizon gracefully.",
  },
  {
    locationId: "item23497",
    locationName: "item23497",
    locationAddress: "item23497",
    ratings: null,
    lat: 57.86955629480808,
    lng: -8.573075183728486,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5497",
    tags: [],
    locationDescription:
      " The student eats a book silently. A dog runs towards the horizon silently. The cat writes the horizon lazily. A woman writes a tower quickly. The man builds a tower happily.",
  },
  {
    locationId: "item23498",
    locationName: "item23498",
    locationAddress: "item23498",
    ratings: null,
    lat: 57.688514165734524,
    lng: -6.681215886390702,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5498",
    tags: [],
    locationDescription:
      " A dog looks at a fence happily. A dog jumps over a fence happily. A woman looks at the horizon angrily.",
  },
  {
    locationId: "item23499",
    locationName: "item23499",
    locationAddress: "item23499",
    ratings: null,
    lat: 51.48501045068419,
    lng: -0.6424898863831574,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5499",
    tags: [],
    locationDescription: " The man writes a tower lazily.",
  },
  {
    locationId: "item23500",
    locationName: "item23500",
    locationAddress: "item23500",
    ratings: null,
    lat: 51.10671382674911,
    lng: -8.06687890158874,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5500",
    tags: [],
    locationDescription:
      " The cat builds the cake quickly. A woman eats the road lazily. The teacher runs towards a book happily.",
  },
  {
    locationId: "item23501",
    locationName: "item23501",
    locationAddress: "item23501",
    ratings: [
      { who: "Similar identities", rating: 0.26 },
      { who: "All perspectives", rating: 3.63 },
    ],
    lat: 58.044079637761,
    lng: -4.432901221828218,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5501",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The teacher runs towards a book gracefully.",
  },
  {
    locationId: "item23502",
    locationName: "item23502",
    locationAddress: "item23502",
    ratings: null,
    lat: 59.731382010741434,
    lng: -2.92386352417014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5502",
    tags: [],
    locationDescription:
      " The teacher jumps over a fence happily. The man looks at a fence quickly. The teacher looks at a book happily.",
  },
  {
    locationId: "item23503",
    locationName: "item23503",
    locationAddress: "item23503",
    ratings: null,
    lat: 52.946909788875885,
    lng: -4.750603590309099,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5503",
    tags: [],
    locationDescription:
      " The student looks at a book angrily. The teacher writes the horizon quickly. The teacher writes the road quickly. The cat runs towards the cake lazily. A woman jumps over a book quickly.",
  },
  {
    locationId: "item23504",
    locationName: "item23504",
    locationAddress: "item23504",
    ratings: null,
    lat: 52.09308750603932,
    lng: -8.280333419480357,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5504",
    tags: [],
    locationDescription:
      " The man writes the horizon lazily. The student writes a book happily.",
  },
  {
    locationId: "item23505",
    locationName: "item23505",
    locationAddress: "item23505",
    ratings: null,
    lat: 55.90338713032645,
    lng: -5.66537515101723,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5505",
    tags: [],
    locationDescription:
      " A dog runs towards the cake gracefully. The student runs towards the road gracefully. A dog writes the horizon angrily. A dog looks at the cake lazily. The cat eats the horizon angrily.",
  },
  {
    locationId: "item23506",
    locationName: "item23506",
    locationAddress: "item23506",
    ratings: [
      { who: "Similar identities", rating: 1.94 },
      { who: "All perspectives", rating: 2.92 },
    ],
    lat: 51.78074393697074,
    lng: 0.5360554722219888,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5506",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " The student runs towards the cake silently.",
  },
  {
    locationId: "item23507",
    locationName: "item23507",
    locationAddress: "item23507",
    ratings: null,
    lat: 51.558539928935915,
    lng: -8.43272014216893,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5507",
    tags: [],
    locationDescription:
      " A woman eats a fence silently. The teacher writes a tower quickly. The teacher looks at the road happily. The man writes the horizon silently. The student eats the horizon happily.",
  },
  {
    locationId: "item23508",
    locationName: "item23508",
    locationAddress: "item23508",
    ratings: null,
    lat: 51.380578003828724,
    lng: -8.41199800287245,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5508",
    tags: [],
    locationDescription: " A dog looks at a fence gracefully.",
  },
  {
    locationId: "item23509",
    locationName: "item23509",
    locationAddress: "item23509",
    ratings: null,
    lat: 58.874051980679965,
    lng: -3.349447471094461,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5509",
    tags: [],
    locationDescription:
      " The cat builds the horizon quickly. A woman writes a fence happily.",
  },
  {
    locationId: "item23510",
    locationName: "item23510",
    locationAddress: "item23510",
    ratings: null,
    lat: 51.08969067357859,
    lng: -4.8585714275744785,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5510",
    tags: [],
    locationDescription:
      " The cat eats the cake silently. The man builds the cake angrily.",
  },
  {
    locationId: "item23511",
    locationName: "item23511",
    locationAddress: "item23511",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 2.18 },
    ],
    lat: 57.69168040747499,
    lng: -6.93832014831354,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5511",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription: " The cat writes the horizon quickly.",
  },
  {
    locationId: "item23512",
    locationName: "item23512",
    locationAddress: "item23512",
    ratings: null,
    lat: 59.955788089741084,
    lng: 0.20150669508278796,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5512",
    tags: [],
    locationDescription:
      " The man runs towards a fence gracefully. The student looks at a fence angrily. The man eats a book quickly.",
  },
  {
    locationId: "item23513",
    locationName: "item23513",
    locationAddress: "item23513",
    ratings: null,
    lat: 54.58468355095171,
    lng: 1.222272616306011,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5513",
    tags: [],
    locationDescription: " A woman eats a book happily.",
  },
  {
    locationId: "item23514",
    locationName: "item23514",
    locationAddress: "item23514",
    ratings: null,
    lat: 57.57045660249067,
    lng: -4.100242977774296,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5514",
    tags: [],
    locationDescription:
      " The student looks at a tower silently. The student looks at a tower lazily. The teacher runs towards the road gracefully. The teacher runs towards the cake happily.",
  },
  {
    locationId: "item23515",
    locationName: "item23515",
    locationAddress: "item23515",
    ratings: [
      { who: "Similar identities", rating: 2.36 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 59.22279312509812,
    lng: -2.5820105363896344,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5515",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats the horizon lazily. The teacher looks at the horizon quickly. A woman writes a fence quickly. A woman writes the horizon angrily.",
  },
  {
    locationId: "item23516",
    locationName: "item23516",
    locationAddress: "item23516",
    ratings: [
      { who: "Similar identities", rating: 0.64 },
      { who: "All perspectives", rating: 5.0 },
    ],
    lat: 55.22856831303574,
    lng: -7.979234900616344,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5516",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher builds the road happily. The student builds the road quickly. A woman writes the road quickly.",
  },
  {
    locationId: "item23517",
    locationName: "item23517",
    locationAddress: "item23517",
    ratings: null,
    lat: 52.00269584936669,
    lng: -8.418859313678283,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5517",
    tags: [],
    locationDescription:
      " The student looks at the road gracefully. The man eats a fence silently. The cat eats a tower lazily. A woman writes a tower gracefully.",
  },
  {
    locationId: "item23518",
    locationName: "item23518",
    locationAddress: "item23518",
    ratings: [
      { who: "Similar identities", rating: 3.47 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 51.52097945182345,
    lng: -4.936754618605429,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5518",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " The teacher runs towards a book silently.",
  },
  {
    locationId: "item23519",
    locationName: "item23519",
    locationAddress: "item23519",
    ratings: null,
    lat: 52.427473423761434,
    lng: -3.9134376907534874,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5519",
    tags: [],
    locationDescription:
      " The teacher builds the road silently. A woman eats a tower lazily. A woman writes a tower happily. The teacher jumps over the cake quickly. The student looks at a book happily.",
  },
  {
    locationId: "item23520",
    locationName: "item23520",
    locationAddress: "item23520",
    ratings: null,
    lat: 53.88841094064666,
    lng: -1.2379000900257946,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5520",
    tags: [],
    locationDescription:
      " The man looks at a tower angrily. The student builds a fence lazily. The student runs towards the cake angrily. The man eats a fence silently.",
  },
  {
    locationId: "item23521",
    locationName: "item23521",
    locationAddress: "item23521",
    ratings: null,
    lat: 52.86768758503725,
    lng: -1.1385030045068545,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5521",
    tags: [],
    locationDescription:
      " A woman builds a tower lazily. A woman jumps over the road quickly. A dog writes the cake gracefully.",
  },
  {
    locationId: "item23522",
    locationName: "item23522",
    locationAddress: "item23522",
    ratings: null,
    lat: 58.347386209090466,
    lng: -5.537684337883499,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5522",
    tags: [],
    locationDescription:
      " A woman jumps over the horizon lazily. The student looks at the horizon angrily. The teacher builds a tower gracefully. The teacher writes the horizon lazily.",
  },
  {
    locationId: "item23523",
    locationName: "item23523",
    locationAddress: "item23523",
    ratings: [
      { who: "Similar identities", rating: 0.47 },
      { who: "All perspectives", rating: 0.05 },
    ],
    lat: 53.14928360894959,
    lng: -7.192733753728448,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5523",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The student looks at a fence silently. The teacher looks at the road happily. The cat looks at the horizon angrily.",
  },
  {
    locationId: "item23524",
    locationName: "item23524",
    locationAddress: "item23524",
    ratings: [
      { who: "Similar identities", rating: 0.72 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 58.132982891984675,
    lng: -0.6502345975168078,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5524",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog writes a tower quickly. The student eats the cake gracefully. A woman runs towards the cake angrily. A woman runs towards a fence silently.",
  },
  {
    locationId: "item23525",
    locationName: "item23525",
    locationAddress: "item23525",
    ratings: null,
    lat: 54.57992328147055,
    lng: -0.8082945539747204,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5525",
    tags: [],
    locationDescription:
      " The man looks at a book quickly. The teacher writes the road angrily. A dog builds the cake lazily. The cat looks at the road silently.",
  },
  {
    locationId: "item23526",
    locationName: "item23526",
    locationAddress: "item23526",
    ratings: [
      { who: "Similar identities", rating: 1.41 },
      { who: "All perspectives", rating: 4.51 },
    ],
    lat: 55.96118873326212,
    lng: -2.026008157688513,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5526",
    tags: [{ label: "lgbtq+ led" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man builds a fence angrily. The teacher writes a fence happily. The student builds a tower angrily.",
  },
  {
    locationId: "item23527",
    locationName: "item23527",
    locationAddress: "item23527",
    ratings: null,
    lat: 57.823641298867166,
    lng: -4.082777151013671,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5527",
    tags: [],
    locationDescription:
      " A dog writes the horizon angrily. A woman builds the horizon angrily. The cat writes the road silently.",
  },
  {
    locationId: "item23528",
    locationName: "item23528",
    locationAddress: "item23528",
    ratings: [
      { who: "Similar identities", rating: 0.12 },
      { who: "All perspectives", rating: 0.1 },
    ],
    lat: 57.692598013085714,
    lng: -3.6967923147801702,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5528",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat runs towards a tower gracefully. The student eats a tower angrily. The student runs towards a tower silently. A woman writes the cake silently.",
  },
  {
    locationId: "item23529",
    locationName: "item23529",
    locationAddress: "item23529",
    ratings: [
      { who: "Similar identities", rating: 2.56 },
      { who: "All perspectives", rating: 2.63 },
    ],
    lat: 53.62028950250745,
    lng: -4.22964723651947,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5529",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man looks at a book silently. The teacher writes a fence quickly. A dog eats a tower silently. A woman jumps over the horizon quickly. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item23530",
    locationName: "item23530",
    locationAddress: "item23530",
    ratings: null,
    lat: 58.841745538558676,
    lng: -2.521033435086574,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5530",
    tags: [],
    locationDescription:
      " The man runs towards a fence happily. The teacher builds a tower happily. The teacher builds a book gracefully. The teacher eats the horizon quickly.",
  },
  {
    locationId: "item23531",
    locationName: "item23531",
    locationAddress: "item23531",
    ratings: [
      { who: "Similar identities", rating: 2.93 },
      { who: "All perspectives", rating: 4.7 },
    ],
    lat: 54.68680442863052,
    lng: -1.5233947704433177,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5531",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student eats a fence silently. The teacher builds the horizon quickly. A dog jumps over the cake quickly. The cat writes the cake gracefully.",
  },
  {
    locationId: "item23532",
    locationName: "item23532",
    locationAddress: "item23532",
    ratings: null,
    lat: 58.543159034475046,
    lng: -2.1729300540224132,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5532",
    tags: [],
    locationDescription: " The man eats the road silently.",
  },
  {
    locationId: "item23533",
    locationName: "item23533",
    locationAddress: "item23533",
    ratings: null,
    lat: 54.365176761423754,
    lng: 1.2518057026258642,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5533",
    tags: [],
    locationDescription:
      " The teacher eats a book silently. The teacher eats the road quickly. The man writes a tower quickly.",
  },
  {
    locationId: "item23534",
    locationName: "item23534",
    locationAddress: "item23534",
    ratings: null,
    lat: 58.044706671359535,
    lng: -7.860997565415863,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5534",
    tags: [],
    locationDescription:
      " A woman writes a tower silently. The cat eats a fence quickly. A dog eats the road silently.",
  },
  {
    locationId: "item23535",
    locationName: "item23535",
    locationAddress: "item23535",
    ratings: null,
    lat: 51.1526766756071,
    lng: -7.367533005368421,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5535",
    tags: [],
    locationDescription:
      " The student runs towards the road happily. A dog builds a tower gracefully. A woman jumps over a book angrily.",
  },
  {
    locationId: "item23536",
    locationName: "item23536",
    locationAddress: "item23536",
    ratings: [
      { who: "Similar identities", rating: 2.52 },
      { who: "All perspectives", rating: 3.93 },
    ],
    lat: 55.59336283650639,
    lng: -6.96897598506508,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5536",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student looks at a fence silently. The cat jumps over a tower happily. A dog writes the road happily. A dog eats a tower lazily.",
  },
  {
    locationId: "item23537",
    locationName: "item23537",
    locationAddress: "item23537",
    ratings: null,
    lat: 59.88725486886623,
    lng: -5.5359980619833635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5537",
    tags: [],
    locationDescription:
      " The teacher looks at the cake happily. A woman writes the cake lazily. The teacher runs towards the horizon lazily. The student eats a tower lazily. The teacher eats the horizon lazily.",
  },
  {
    locationId: "item23538",
    locationName: "item23538",
    locationAddress: "item23538",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 4.04 },
    ],
    lat: 51.33052597707339,
    lng: -1.2102989710721221,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5538",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman runs towards a tower silently. The teacher writes the horizon gracefully. A dog runs towards a book quickly. The man looks at a fence silently.",
  },
  {
    locationId: "item23539",
    locationName: "item23539",
    locationAddress: "item23539",
    ratings: null,
    lat: 58.43799733328353,
    lng: -4.724505897942749,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5539",
    tags: [],
    locationDescription:
      " A woman eats the road silently. A dog builds the road lazily. A woman runs towards the cake gracefully. A woman writes a fence happily.",
  },
  {
    locationId: "item23540",
    locationName: "item23540",
    locationAddress: "item23540",
    ratings: null,
    lat: 51.95335283397935,
    lng: -4.103645068974826,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5540",
    tags: [],
    locationDescription: " The student builds a fence angrily.",
  },
  {
    locationId: "item23541",
    locationName: "item23541",
    locationAddress: "item23541",
    ratings: [
      { who: "Similar identities", rating: 3.07 },
      { who: "All perspectives", rating: 2.61 },
    ],
    lat: 50.59215455252212,
    lng: -4.755644625117603,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5541",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat builds the road silently. The teacher writes the cake silently. The cat builds the cake lazily. A dog looks at the cake angrily. The student looks at the road quickly.",
  },
  {
    locationId: "item23542",
    locationName: "item23542",
    locationAddress: "item23542",
    ratings: null,
    lat: 60.66432075634329,
    lng: -8.439618513663952,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5542",
    tags: [],
    locationDescription:
      " The cat eats the horizon lazily. A woman eats the road angrily.",
  },
  {
    locationId: "item23543",
    locationName: "item23543",
    locationAddress: "item23543",
    ratings: [
      { who: "Similar identities", rating: 4.45 },
      { who: "All perspectives", rating: 0.27 },
    ],
    lat: 59.13559517740635,
    lng: -5.659004540830471,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5543",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The student eats a fence angrily. The man eats a book gracefully. The teacher runs towards a book gracefully. A dog builds a fence lazily.",
  },
  {
    locationId: "item23544",
    locationName: "item23544",
    locationAddress: "item23544",
    ratings: [
      { who: "Similar identities", rating: 1.82 },
      { who: "All perspectives", rating: 1.35 },
    ],
    lat: 55.61217071359157,
    lng: -3.8171527101222527,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5544",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog looks at a fence angrily. The teacher jumps over the horizon lazily.",
  },
  {
    locationId: "item23545",
    locationName: "item23545",
    locationAddress: "item23545",
    ratings: null,
    lat: 56.43327273640117,
    lng: -8.559495831000104,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5545",
    tags: [],
    locationDescription:
      " The student looks at a tower silently. The cat eats the cake gracefully.",
  },
  {
    locationId: "item23546",
    locationName: "item23546",
    locationAddress: "item23546",
    ratings: [
      { who: "Similar identities", rating: 2.97 },
      { who: "All perspectives", rating: 0.55 },
    ],
    lat: 56.04278081528513,
    lng: -2.786457376143508,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5546",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man eats the cake happily. A woman jumps over the horizon gracefully.",
  },
  {
    locationId: "item23547",
    locationName: "item23547",
    locationAddress: "item23547",
    ratings: [
      { who: "Similar identities", rating: 0.27 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 51.03424302040273,
    lng: -7.802907265277358,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5547",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man jumps over the horizon lazily. The man jumps over the cake silently. The man jumps over the horizon lazily. A dog builds a fence gracefully. A dog looks at a book gracefully.",
  },
  {
    locationId: "item23548",
    locationName: "item23548",
    locationAddress: "item23548",
    ratings: null,
    lat: 60.1556897326853,
    lng: -7.544055957376987,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5548",
    tags: [],
    locationDescription:
      " A dog looks at the cake angrily. The teacher eats the horizon angrily. A woman runs towards the cake lazily.",
  },
  {
    locationId: "item23549",
    locationName: "item23549",
    locationAddress: "item23549",
    ratings: null,
    lat: 57.096084217549,
    lng: -1.0318507410625637,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5549",
    tags: [],
    locationDescription:
      " The teacher builds the road angrily. The teacher eats the horizon silently. A woman jumps over the road silently. A dog jumps over a tower lazily.",
  },
  {
    locationId: "item23550",
    locationName: "item23550",
    locationAddress: "item23550",
    ratings: [
      { who: "Similar identities", rating: 2.6 },
      { who: "All perspectives", rating: 1.25 },
    ],
    lat: 58.50099373664344,
    lng: -3.2636757104180445,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5550",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A dog looks at a tower angrily.",
  },
  {
    locationId: "item23551",
    locationName: "item23551",
    locationAddress: "item23551",
    ratings: [
      { who: "Similar identities", rating: 0.94 },
      { who: "All perspectives", rating: 2.88 },
    ],
    lat: 59.889321481225444,
    lng: -7.796752452660788,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5551",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The student looks at a tower lazily.",
  },
  {
    locationId: "item23552",
    locationName: "item23552",
    locationAddress: "item23552",
    ratings: null,
    lat: 51.199024385890674,
    lng: -8.067599585112696,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5552",
    tags: [],
    locationDescription:
      " A dog writes a fence quickly. The student jumps over the horizon happily. A dog writes the horizon gracefully. A woman runs towards the horizon happily.",
  },
  {
    locationId: "item23553",
    locationName: "item23553",
    locationAddress: "item23553",
    ratings: [
      { who: "Similar identities", rating: 1.64 },
      { who: "All perspectives", rating: 1.74 },
    ],
    lat: 57.82422361705907,
    lng: -3.7669231682935056,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5553",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student writes the road silently. The man looks at a fence silently. The man runs towards the road quickly. The teacher jumps over the horizon happily.",
  },
  {
    locationId: "item23554",
    locationName: "item23554",
    locationAddress: "item23554",
    ratings: null,
    lat: 59.68893387476103,
    lng: -5.79299819250347,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5554",
    tags: [],
    locationDescription:
      " The teacher writes the road lazily. The teacher looks at the road gracefully. The cat looks at the cake lazily. The cat looks at a fence angrily.",
  },
  {
    locationId: "item23555",
    locationName: "item23555",
    locationAddress: "item23555",
    ratings: null,
    lat: 55.66535623191025,
    lng: 0.8988826631438105,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5555",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower quickly. The teacher runs towards a fence happily. The student runs towards the road silently.",
  },
  {
    locationId: "item23556",
    locationName: "item23556",
    locationAddress: "item23556",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 0.38 },
    ],
    lat: 56.18484288274184,
    lng: -3.0336792110298276,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5556",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog jumps over a tower silently. The cat jumps over a fence silently.",
  },
  {
    locationId: "item23557",
    locationName: "item23557",
    locationAddress: "item23557",
    ratings: null,
    lat: 53.224294750520635,
    lng: -2.71557508003127,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5557",
    tags: [],
    locationDescription:
      " The teacher runs towards the cake quickly. The student writes the cake gracefully. The student jumps over a fence quickly. The student jumps over the road angrily. The cat builds a fence lazily.",
  },
  {
    locationId: "item23558",
    locationName: "item23558",
    locationAddress: "item23558",
    ratings: [
      { who: "Similar identities", rating: 1.75 },
      { who: "All perspectives", rating: 2.61 },
    ],
    lat: 58.00655352825413,
    lng: -1.9377740739549587,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5558",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog looks at the road quickly. The student jumps over the horizon gracefully.",
  },
  {
    locationId: "item23559",
    locationName: "item23559",
    locationAddress: "item23559",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 52.711841847341475,
    lng: -4.000161667969089,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5559",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student looks at the horizon happily. The teacher jumps over the cake angrily.",
  },
  {
    locationId: "item23560",
    locationName: "item23560",
    locationAddress: "item23560",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 4.76 },
    ],
    lat: 50.432812881807806,
    lng: 1.2211963000279145,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5560",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " A woman runs towards a fence silently.",
  },
  {
    locationId: "item23561",
    locationName: "item23561",
    locationAddress: "item23561",
    ratings: null,
    lat: 51.65128684844328,
    lng: 1.6124322220845944,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5561",
    tags: [],
    locationDescription:
      " A woman jumps over the cake lazily. The man jumps over a book silently. A woman jumps over a tower gracefully.",
  },
  {
    locationId: "item23562",
    locationName: "item23562",
    locationAddress: "item23562",
    ratings: [
      { who: "Similar identities", rating: 0.38 },
      { who: "All perspectives", rating: 1.59 },
    ],
    lat: 54.00157127951988,
    lng: 0.6060287703075566,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5562",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student eats a tower angrily. The teacher jumps over the cake angrily.",
  },
  {
    locationId: "item23563",
    locationName: "item23563",
    locationAddress: "item23563",
    ratings: null,
    lat: 57.97843279203021,
    lng: -1.5955718561210643,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5563",
    tags: [],
    locationDescription:
      " The student writes the horizon lazily. The man eats a tower lazily. The cat runs towards the cake angrily. The man builds a fence silently. The cat eats the cake gracefully.",
  },
  {
    locationId: "item23564",
    locationName: "item23564",
    locationAddress: "item23564",
    ratings: null,
    lat: 51.19877992749193,
    lng: -7.546111444005101,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5564",
    tags: [],
    locationDescription:
      " A woman eats the cake silently. A woman writes a tower silently. A dog runs towards the road gracefully.",
  },
  {
    locationId: "item23565",
    locationName: "item23565",
    locationAddress: "item23565",
    ratings: null,
    lat: 52.411271112547034,
    lng: -6.416970127838082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5565",
    tags: [],
    locationDescription: " The man jumps over a fence quickly.",
  },
  {
    locationId: "item23566",
    locationName: "item23566",
    locationAddress: "item23566",
    ratings: [
      { who: "Similar identities", rating: 3.38 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 60.74472968443311,
    lng: 0.7448259882999313,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5566",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat jumps over a tower happily. The cat looks at the cake quickly. A dog eats a fence silently. A dog eats a fence silently.",
  },
  {
    locationId: "item23567",
    locationName: "item23567",
    locationAddress: "item23567",
    ratings: [
      { who: "Similar identities", rating: 4.74 },
      { who: "All perspectives", rating: 1.31 },
    ],
    lat: 58.770686418774474,
    lng: 0.1985179736279914,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5567",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog eats a fence angrily. A dog writes the road lazily.",
  },
  {
    locationId: "item23568",
    locationName: "item23568",
    locationAddress: "item23568",
    ratings: [
      { who: "Similar identities", rating: 3.96 },
      { who: "All perspectives", rating: 0.57 },
    ],
    lat: 50.52119256993047,
    lng: -5.874106952750287,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5568",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds a fence silently. The man jumps over a book silently. The student writes the cake lazily.",
  },
  {
    locationId: "item23569",
    locationName: "item23569",
    locationAddress: "item23569",
    ratings: null,
    lat: 51.74280994079889,
    lng: -3.8854890678488925,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5569",
    tags: [],
    locationDescription:
      " The teacher eats a fence lazily. The student writes the horizon lazily. The teacher jumps over a book lazily. A woman looks at the road angrily. The man eats a book gracefully.",
  },
  {
    locationId: "item23570",
    locationName: "item23570",
    locationAddress: "item23570",
    ratings: [
      { who: "Similar identities", rating: 1.85 },
      { who: "All perspectives", rating: 4.14 },
    ],
    lat: 50.30851025127172,
    lng: -5.601639292294741,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5570",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog writes the horizon silently. The cat looks at the road quickly.",
  },
  {
    locationId: "item23571",
    locationName: "item23571",
    locationAddress: "item23571",
    ratings: null,
    lat: 50.76784039572127,
    lng: -6.193545759924479,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5571",
    tags: [],
    locationDescription:
      " A woman looks at the cake lazily. A dog writes a book angrily. A dog looks at a fence gracefully.",
  },
  {
    locationId: "item23572",
    locationName: "item23572",
    locationAddress: "item23572",
    ratings: null,
    lat: 58.071822400474744,
    lng: -6.847678954894356,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5572",
    tags: [],
    locationDescription:
      " The man looks at the cake quickly. A dog runs towards a tower angrily.",
  },
  {
    locationId: "item23573",
    locationName: "item23573",
    locationAddress: "item23573",
    ratings: [
      { who: "Similar identities", rating: 1.67 },
      { who: "All perspectives", rating: 2.99 },
    ],
    lat: 56.17371137861838,
    lng: -2.5950763723002064,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5573",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog writes the horizon gracefully.",
  },
  {
    locationId: "item23574",
    locationName: "item23574",
    locationAddress: "item23574",
    ratings: null,
    lat: 56.24880500132776,
    lng: -4.367416389074345,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5574",
    tags: [],
    locationDescription:
      " The student eats a book quickly. A dog looks at the cake silently. The man runs towards the horizon happily. The student jumps over a book angrily. The cat runs towards a fence silently.",
  },
  {
    locationId: "item23575",
    locationName: "item23575",
    locationAddress: "item23575",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 2.97 },
    ],
    lat: 57.54469849711737,
    lng: -7.6933520642371045,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item5575",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription: " A woman jumps over the cake lazily.",
  },
  {
    locationId: "item23576",
    locationName: "item23576",
    locationAddress: "item23576",
    ratings: null,
    lat: 55.71240847977009,
    lng: -7.635975862183658,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5576",
    tags: [],
    locationDescription: " The teacher writes the horizon gracefully.",
  },
  {
    locationId: "item23577",
    locationName: "item23577",
    locationAddress: "item23577",
    ratings: null,
    lat: 60.727753915227105,
    lng: -5.8663395276298385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5577",
    tags: [],
    locationDescription:
      " The man builds the horizon angrily. The teacher runs towards a book gracefully.",
  },
  {
    locationId: "item23578",
    locationName: "item23578",
    locationAddress: "item23578",
    ratings: null,
    lat: 53.811222885612494,
    lng: -3.423327545009986,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5578",
    tags: [],
    locationDescription:
      " The student writes a fence quickly. The student jumps over a tower gracefully. A dog eats the cake quickly. The man eats the horizon happily.",
  },
  {
    locationId: "item23579",
    locationName: "item23579",
    locationAddress: "item23579",
    ratings: null,
    lat: 53.55976847842577,
    lng: -0.7219799642212559,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5579",
    tags: [],
    locationDescription:
      " The cat runs towards a fence lazily. The man writes the cake quickly. The cat looks at the cake angrily.",
  },
  {
    locationId: "item23580",
    locationName: "item23580",
    locationAddress: "item23580",
    ratings: null,
    lat: 55.49338239476194,
    lng: -0.4291574632359776,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5580",
    tags: [],
    locationDescription:
      " The teacher runs towards a fence angrily. The man runs towards a book silently. The man runs towards the cake silently. The man builds a book silently. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item23581",
    locationName: "item23581",
    locationAddress: "item23581",
    ratings: [
      { who: "Similar identities", rating: 0.05 },
      { who: "All perspectives", rating: 0.95 },
    ],
    lat: 56.82430729680369,
    lng: -3.5954363139840133,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5581",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog jumps over a fence silently. The teacher builds a book angrily. The man writes the horizon angrily.",
  },
  {
    locationId: "item23582",
    locationName: "item23582",
    locationAddress: "item23582",
    ratings: null,
    lat: 52.29227817694056,
    lng: -5.65882443511437,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5582",
    tags: [],
    locationDescription: " A dog eats a tower silently.",
  },
  {
    locationId: "item23583",
    locationName: "item23583",
    locationAddress: "item23583",
    ratings: [
      { who: "Similar identities", rating: 0.28 },
      { who: "All perspectives", rating: 0.17 },
    ],
    lat: 54.0597011953693,
    lng: -8.049330288884565,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5583",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man eats the cake lazily. The cat runs towards the cake silently.",
  },
  {
    locationId: "item23584",
    locationName: "item23584",
    locationAddress: "item23584",
    ratings: [
      { who: "Similar identities", rating: 0.93 },
      { who: "All perspectives", rating: 0.11 },
    ],
    lat: 53.24812502670574,
    lng: -7.077515006482775,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5584",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog writes a tower gracefully. The student runs towards the cake gracefully.",
  },
  {
    locationId: "item23585",
    locationName: "item23585",
    locationAddress: "item23585",
    ratings: null,
    lat: 58.85292954587421,
    lng: -2.7989296036385873,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5585",
    tags: [],
    locationDescription: " The teacher runs towards the road silently.",
  },
  {
    locationId: "item23586",
    locationName: "item23586",
    locationAddress: "item23586",
    ratings: null,
    lat: 59.29229735387062,
    lng: -2.4986522027214892,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5586",
    tags: [],
    locationDescription:
      " The cat jumps over a book quickly. The man writes the road silently.",
  },
  {
    locationId: "item23587",
    locationName: "item23587",
    locationAddress: "item23587",
    ratings: null,
    lat: 58.608371806289675,
    lng: -7.290941022516551,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5587",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon angrily. A woman eats a tower gracefully. The teacher jumps over a fence gracefully. The teacher jumps over the horizon gracefully. The man writes the cake silently.",
  },
  {
    locationId: "item23588",
    locationName: "item23588",
    locationAddress: "item23588",
    ratings: [
      { who: "Similar identities", rating: 2.16 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 58.518105228660815,
    lng: 0.26385241974275964,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5588",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog eats the horizon angrily. A woman runs towards a fence happily.",
  },
  {
    locationId: "item23589",
    locationName: "item23589",
    locationAddress: "item23589",
    ratings: null,
    lat: 51.520772000998434,
    lng: -3.4673714074338715,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5589",
    tags: [],
    locationDescription: " The man builds a fence lazily.",
  },
  {
    locationId: "item23590",
    locationName: "item23590",
    locationAddress: "item23590",
    ratings: null,
    lat: 52.330687783706736,
    lng: -1.197775184255086,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5590",
    tags: [],
    locationDescription: " The man jumps over the horizon happily.",
  },
  {
    locationId: "item23591",
    locationName: "item23591",
    locationAddress: "item23591",
    ratings: null,
    lat: 56.82639540556567,
    lng: -1.9866095940897814,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5591",
    tags: [],
    locationDescription:
      " A woman eats a book angrily. The man eats the horizon angrily. A dog jumps over a book lazily. The teacher runs towards a tower happily. The teacher writes the horizon gracefully.",
  },
  {
    locationId: "item23592",
    locationName: "item23592",
    locationAddress: "item23592",
    ratings: [
      { who: "Similar identities", rating: 0.33 },
      { who: "All perspectives", rating: 1.23 },
    ],
    lat: 56.02859000300347,
    lng: -3.1693590252532227,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5592",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman writes the cake lazily. The cat writes a fence gracefully. The cat looks at the road gracefully. The student jumps over a fence lazily.",
  },
  {
    locationId: "item23593",
    locationName: "item23593",
    locationAddress: "item23593",
    ratings: [
      { who: "Similar identities", rating: 3.34 },
      { who: "All perspectives", rating: 3.83 },
    ],
    lat: 57.632892044537655,
    lng: -2.5911620753011926,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5593",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " A woman eats the cake happily. The man jumps over a book angrily. The cat runs towards the road silently. A dog builds a fence angrily. A dog looks at a tower silently.",
  },
  {
    locationId: "item23594",
    locationName: "item23594",
    locationAddress: "item23594",
    ratings: [
      { who: "Similar identities", rating: 0.77 },
      { who: "All perspectives", rating: 1.4 },
    ],
    lat: 60.54063277319922,
    lng: -0.14382054773144226,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item5594",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " A dog builds a fence happily. A dog writes the road angrily. The man runs towards the horizon gracefully.",
  },
  {
    locationId: "item23595",
    locationName: "item23595",
    locationAddress: "item23595",
    ratings: [
      { who: "Similar identities", rating: 1.55 },
      { who: "All perspectives", rating: 3.97 },
    ],
    lat: 58.19215611789541,
    lng: -2.7729342325420143,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5595",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student writes the horizon angrily. The cat looks at the road gracefully. A dog builds the road angrily. The student eats the road happily.",
  },
  {
    locationId: "item23596",
    locationName: "item23596",
    locationAddress: "item23596",
    ratings: null,
    lat: 56.3259767034241,
    lng: -1.1945547323080454,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5596",
    tags: [],
    locationDescription:
      " The cat looks at the cake lazily. A woman jumps over the horizon gracefully. The man looks at the road gracefully. The cat jumps over the road angrily.",
  },
  {
    locationId: "item23597",
    locationName: "item23597",
    locationAddress: "item23597",
    ratings: null,
    lat: 53.62496148073131,
    lng: -0.516326619216354,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5597",
    tags: [],
    locationDescription:
      " The cat eats the cake silently. The student writes the road silently. The cat looks at the horizon gracefully.",
  },
  {
    locationId: "item23598",
    locationName: "item23598",
    locationAddress: "item23598",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 55.721150753856136,
    lng: -4.274477732286494,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5598",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The student writes the cake lazily. The cat builds the cake happily.",
  },
  {
    locationId: "item23599",
    locationName: "item23599",
    locationAddress: "item23599",
    ratings: null,
    lat: 57.50652157207349,
    lng: -1.1544172241008823,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5599",
    tags: [],
    locationDescription:
      " A dog writes a fence lazily. The man runs towards a book lazily.",
  },
  {
    locationId: "item23600",
    locationName: "item23600",
    locationAddress: "item23600",
    ratings: null,
    lat: 58.48550571395466,
    lng: -6.891392701453963,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5600",
    tags: [],
    locationDescription:
      " The cat jumps over a fence gracefully. A dog looks at a tower angrily.",
  },
  {
    locationId: "item23601",
    locationName: "item23601",
    locationAddress: "item23601",
    ratings: null,
    lat: 56.40149801055584,
    lng: -8.380727753912502,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5601",
    tags: [],
    locationDescription:
      " The man jumps over a fence angrily. A woman looks at the road silently. The student looks at a fence quickly.",
  },
  {
    locationId: "item23602",
    locationName: "item23602",
    locationAddress: "item23602",
    ratings: null,
    lat: 52.75187637651247,
    lng: -3.5614182680269737,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5602",
    tags: [],
    locationDescription:
      " A dog jumps over the cake quickly. The cat eats a tower happily. The cat builds a fence happily. The cat runs towards a fence quickly.",
  },
  {
    locationId: "item23603",
    locationName: "item23603",
    locationAddress: "item23603",
    ratings: [
      { who: "Similar identities", rating: 3.63 },
      { who: "All perspectives", rating: 0.02 },
    ],
    lat: 54.74495763133229,
    lng: -0.25019208240571444,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5603",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The cat builds the road happily. The teacher writes a fence angrily. The teacher jumps over a book happily.",
  },
  {
    locationId: "item23604",
    locationName: "item23604",
    locationAddress: "item23604",
    ratings: null,
    lat: 50.57781895876135,
    lng: -2.1165703188547447,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5604",
    tags: [],
    locationDescription:
      " The cat jumps over the cake happily. The cat eats a fence happily. The cat writes a tower lazily. The teacher looks at the horizon lazily.",
  },
  {
    locationId: "item23605",
    locationName: "item23605",
    locationAddress: "item23605",
    ratings: null,
    lat: 55.24643794806039,
    lng: -8.392524611329554,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5605",
    tags: [],
    locationDescription:
      " The teacher builds the cake gracefully. The cat eats the horizon lazily.",
  },
  {
    locationId: "item23606",
    locationName: "item23606",
    locationAddress: "item23606",
    ratings: null,
    lat: 60.430605585745376,
    lng: 0.2848256357326626,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5606",
    tags: [],
    locationDescription: " The teacher jumps over the horizon quickly.",
  },
  {
    locationId: "item23607",
    locationName: "item23607",
    locationAddress: "item23607",
    ratings: null,
    lat: 59.72505696786399,
    lng: -5.320161592380899,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5607",
    tags: [],
    locationDescription:
      " The man builds a tower angrily. The student runs towards the road gracefully.",
  },
  {
    locationId: "item23608",
    locationName: "item23608",
    locationAddress: "item23608",
    ratings: [
      { who: "Similar identities", rating: 4.63 },
      { who: "All perspectives", rating: 1.11 },
    ],
    lat: 56.525246414009786,
    lng: -8.256185430110097,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5608",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The man eats a tower happily. The student looks at the horizon gracefully. A dog looks at a fence quickly.",
  },
  {
    locationId: "item23609",
    locationName: "item23609",
    locationAddress: "item23609",
    ratings: [
      { who: "Similar identities", rating: 4.75 },
      { who: "All perspectives", rating: 1.73 },
    ],
    lat: 58.873416974808,
    lng: 0.9401854120577511,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5609",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student writes the horizon silently. The man runs towards a book angrily. The cat runs towards the road angrily. The cat looks at the cake angrily.",
  },
  {
    locationId: "item23610",
    locationName: "item23610",
    locationAddress: "item23610",
    ratings: null,
    lat: 56.46174239828301,
    lng: -2.3064457436130406,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5610",
    tags: [],
    locationDescription:
      " The cat runs towards a tower happily. The teacher runs towards the cake happily. A woman writes the cake happily. A dog looks at a tower lazily.",
  },
  {
    locationId: "item23611",
    locationName: "item23611",
    locationAddress: "item23611",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 59.427572738002496,
    lng: -1.1358289027633708,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5611",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The cat writes the horizon silently. A woman looks at the cake lazily. A dog jumps over the road silently. A dog looks at a book angrily.",
  },
  {
    locationId: "item23612",
    locationName: "item23612",
    locationAddress: "item23612",
    ratings: [
      { who: "Similar identities", rating: 0.54 },
      { who: "All perspectives", rating: 4.91 },
    ],
    lat: 57.69915405988336,
    lng: -1.3311942209705538,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5612",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds the cake silently. The man writes the horizon gracefully. The man writes the road quickly. The cat jumps over the horizon silently. A woman jumps over the horizon lazily.",
  },
  {
    locationId: "item23613",
    locationName: "item23613",
    locationAddress: "item23613",
    ratings: [
      { who: "Similar identities", rating: 3.36 },
      { who: "All perspectives", rating: 3.98 },
    ],
    lat: 57.31922308352179,
    lng: -2.0786185190289403,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5613",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman builds the cake quickly.",
  },
  {
    locationId: "item23614",
    locationName: "item23614",
    locationAddress: "item23614",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 58.437089038360696,
    lng: -3.386814576902057,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5614",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog eats a book angrily. The man writes the cake gracefully. A dog looks at the horizon silently.",
  },
  {
    locationId: "item23615",
    locationName: "item23615",
    locationAddress: "item23615",
    ratings: [
      { who: "Similar identities", rating: 1.93 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 56.44678572704687,
    lng: -3.1338562344650933,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5615",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher jumps over a fence quickly. A dog runs towards the road gracefully. The teacher looks at a tower quickly. A woman builds the horizon happily.",
  },
  {
    locationId: "item23616",
    locationName: "item23616",
    locationAddress: "item23616",
    ratings: null,
    lat: 56.869706976958945,
    lng: -1.2050750217269481,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5616",
    tags: [],
    locationDescription: " The cat jumps over a fence quickly.",
  },
  {
    locationId: "item23617",
    locationName: "item23617",
    locationAddress: "item23617",
    ratings: [
      { who: "Similar identities", rating: 0.49 },
      { who: "All perspectives", rating: 4.99 },
    ],
    lat: 55.240195002830596,
    lng: -4.723623402551873,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5617",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man eats the cake quickly. A woman writes a tower gracefully. A dog runs towards a tower quickly. A dog runs towards the horizon silently.",
  },
  {
    locationId: "item23618",
    locationName: "item23618",
    locationAddress: "item23618",
    ratings: [
      { who: "Similar identities", rating: 3.92 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 56.67817318469869,
    lng: 0.7944549686238211,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5618",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription: " A dog eats a tower happily.",
  },
  {
    locationId: "item23619",
    locationName: "item23619",
    locationAddress: "item23619",
    ratings: [
      { who: "Similar identities", rating: 4.52 },
      { who: "All perspectives", rating: 3.44 },
    ],
    lat: 59.87333934513157,
    lng: 0.7770012770667005,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5619",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats a book quickly. The cat eats a fence angrily. A dog writes a book silently. A woman writes the road quickly. The man builds a fence gracefully.",
  },
  {
    locationId: "item23620",
    locationName: "item23620",
    locationAddress: "item23620",
    ratings: null,
    lat: 60.28184612288997,
    lng: -5.585136092168856,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5620",
    tags: [],
    locationDescription:
      " The man runs towards a tower angrily. A dog jumps over a fence gracefully. The teacher builds the road angrily. The cat looks at the cake angrily. The teacher jumps over the road silently.",
  },
  {
    locationId: "item23621",
    locationName: "item23621",
    locationAddress: "item23621",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 57.01518396229872,
    lng: 1.1962248189378961,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5621",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The teacher looks at the horizon silently.",
  },
  {
    locationId: "item23622",
    locationName: "item23622",
    locationAddress: "item23622",
    ratings: null,
    lat: 57.51210220828992,
    lng: -2.915988270744399,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5622",
    tags: [],
    locationDescription: " The cat runs towards a fence angrily.",
  },
  {
    locationId: "item23623",
    locationName: "item23623",
    locationAddress: "item23623",
    ratings: null,
    lat: 50.48347515524705,
    lng: 1.746729931320905,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5623",
    tags: [],
    locationDescription:
      " The cat eats a tower quickly. The cat builds the cake quickly. The cat eats the road quickly. The man builds a tower silently. The cat looks at the horizon gracefully.",
  },
  {
    locationId: "item23624",
    locationName: "item23624",
    locationAddress: "item23624",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 0.23 },
    ],
    lat: 55.002740193845256,
    lng: -8.434872946318267,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5624",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The student runs towards a fence lazily. A woman writes the horizon lazily. The teacher jumps over a tower happily.",
  },
  {
    locationId: "item23625",
    locationName: "item23625",
    locationAddress: "item23625",
    ratings: null,
    lat: 54.64506927829408,
    lng: -7.857317240223893,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5625",
    tags: [],
    locationDescription:
      " The cat looks at a tower silently. The cat eats the cake gracefully. The teacher looks at a fence silently.",
  },
  {
    locationId: "item23626",
    locationName: "item23626",
    locationAddress: "item23626",
    ratings: [
      { who: "Similar identities", rating: 0.75 },
      { who: "All perspectives", rating: 1.18 },
    ],
    lat: 56.93993502050161,
    lng: -7.679195264821013,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5626",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher eats a tower gracefully. The student looks at a fence silently. The cat writes the cake quickly. The teacher eats a book happily.",
  },
  {
    locationId: "item23627",
    locationName: "item23627",
    locationAddress: "item23627",
    ratings: null,
    lat: 53.772229945156326,
    lng: -6.826094858747172,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5627",
    tags: [],
    locationDescription:
      " A woman looks at the horizon happily. The cat builds a book happily.",
  },
  {
    locationId: "item23628",
    locationName: "item23628",
    locationAddress: "item23628",
    ratings: null,
    lat: 52.60691683960139,
    lng: -1.9477534817629198,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5628",
    tags: [],
    locationDescription: " A woman jumps over the road angrily.",
  },
  {
    locationId: "item23629",
    locationName: "item23629",
    locationAddress: "item23629",
    ratings: null,
    lat: 57.810001927365384,
    lng: -7.075485807907028,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5629",
    tags: [],
    locationDescription:
      " The student looks at the cake lazily. A woman builds the horizon gracefully.",
  },
  {
    locationId: "item23630",
    locationName: "item23630",
    locationAddress: "item23630",
    ratings: null,
    lat: 53.23769162304312,
    lng: -3.710884254498298,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5630",
    tags: [],
    locationDescription:
      " A dog builds the horizon silently. The student runs towards the cake angrily. The man eats a fence silently. The teacher eats a book happily. The student eats the horizon gracefully.",
  },
  {
    locationId: "item23631",
    locationName: "item23631",
    locationAddress: "item23631",
    ratings: [
      { who: "Similar identities", rating: 3.88 },
      { who: "All perspectives", rating: 4.26 },
    ],
    lat: 59.05920198333542,
    lng: -5.751584029675958,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5631",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The teacher runs towards a book silently. A dog runs towards the road silently. The cat builds a book happily. The student runs towards a tower quickly. A dog eats a fence lazily.",
  },
  {
    locationId: "item23632",
    locationName: "item23632",
    locationAddress: "item23632",
    ratings: null,
    lat: 54.00649414442279,
    lng: -8.113416969173967,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5632",
    tags: [],
    locationDescription:
      " The man runs towards the horizon lazily. The cat looks at a fence angrily. A dog eats the horizon gracefully. The student runs towards the horizon lazily. The man builds the road happily.",
  },
  {
    locationId: "item23633",
    locationName: "item23633",
    locationAddress: "item23633",
    ratings: null,
    lat: 53.71907253394735,
    lng: -2.5114222376249167,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5633",
    tags: [],
    locationDescription: " The teacher jumps over a tower gracefully.",
  },
  {
    locationId: "item23634",
    locationName: "item23634",
    locationAddress: "item23634",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 0.36 },
    ],
    lat: 49.93987864490438,
    lng: -3.9191789577093985,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5634",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man builds a book happily. The cat looks at a tower gracefully.",
  },
  {
    locationId: "item23635",
    locationName: "item23635",
    locationAddress: "item23635",
    ratings: null,
    lat: 55.73905027191099,
    lng: -6.769840473403475,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5635",
    tags: [],
    locationDescription: " The cat builds the road silently.",
  },
  {
    locationId: "item23636",
    locationName: "item23636",
    locationAddress: "item23636",
    ratings: [
      { who: "Similar identities", rating: 3.89 },
      { who: "All perspectives", rating: 1.08 },
    ],
    lat: 54.048477589924154,
    lng: 0.14605635911961734,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5636",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " A dog writes the horizon gracefully. The man jumps over the cake silently. The teacher eats a tower lazily.",
  },
  {
    locationId: "item23637",
    locationName: "item23637",
    locationAddress: "item23637",
    ratings: null,
    lat: 52.11555155119056,
    lng: -7.346884316548595,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5637",
    tags: [],
    locationDescription:
      " The man jumps over a book happily. The teacher writes the cake quickly. The man looks at the horizon angrily.",
  },
  {
    locationId: "item23638",
    locationName: "item23638",
    locationAddress: "item23638",
    ratings: null,
    lat: 52.37053659994117,
    lng: -1.37253066599588,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5638",
    tags: [],
    locationDescription: " The man eats the horizon silently.",
  },
  {
    locationId: "item23639",
    locationName: "item23639",
    locationAddress: "item23639",
    ratings: [
      { who: "Similar identities", rating: 0.93 },
      { who: "All perspectives", rating: 1.63 },
    ],
    lat: 54.05926867569764,
    lng: 0.29091845229039315,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5639",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription: " The student looks at a tower angrily.",
  },
  {
    locationId: "item23640",
    locationName: "item23640",
    locationAddress: "item23640",
    ratings: [
      { who: "Similar identities", rating: 1.71 },
      { who: "All perspectives", rating: 3.25 },
    ],
    lat: 55.14185564228875,
    lng: -5.97276499240499,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5640",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " A woman eats a fence lazily. The teacher looks at a fence angrily.",
  },
  {
    locationId: "item23641",
    locationName: "item23641",
    locationAddress: "item23641",
    ratings: null,
    lat: 60.81778298261163,
    lng: -3.0800539472295743,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5641",
    tags: [],
    locationDescription:
      " The student eats a tower lazily. The cat eats a book angrily.",
  },
  {
    locationId: "item23642",
    locationName: "item23642",
    locationAddress: "item23642",
    ratings: null,
    lat: 56.11545893676698,
    lng: 0.19502136933034464,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5642",
    tags: [],
    locationDescription:
      " The man jumps over a fence lazily. The cat eats the cake angrily. The student eats the horizon happily.",
  },
  {
    locationId: "item23643",
    locationName: "item23643",
    locationAddress: "item23643",
    ratings: null,
    lat: 54.26246222191494,
    lng: -6.400197062798288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5643",
    tags: [],
    locationDescription:
      " The man writes the cake happily. The cat builds the horizon angrily. The man jumps over the road happily. The cat eats a tower happily.",
  },
  {
    locationId: "item23644",
    locationName: "item23644",
    locationAddress: "item23644",
    ratings: null,
    lat: 50.55433534042755,
    lng: -0.24193122169268833,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5644",
    tags: [],
    locationDescription:
      " The teacher eats a tower lazily. The man looks at a tower silently.",
  },
  {
    locationId: "item23645",
    locationName: "item23645",
    locationAddress: "item23645",
    ratings: null,
    lat: 57.04732790928957,
    lng: -7.873407196590907,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5645",
    tags: [],
    locationDescription:
      " A dog writes a tower lazily. A woman eats a book quickly.",
  },
  {
    locationId: "item23646",
    locationName: "item23646",
    locationAddress: "item23646",
    ratings: [
      { who: "Similar identities", rating: 0.69 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 50.32409282332544,
    lng: -6.529573085510226,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5646",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher looks at the cake lazily. A woman runs towards the horizon silently. A dog builds the cake lazily. The man runs towards the cake silently.",
  },
  {
    locationId: "item23647",
    locationName: "item23647",
    locationAddress: "item23647",
    ratings: [
      { who: "Similar identities", rating: 0.86 },
      { who: "All perspectives", rating: 2.33 },
    ],
    lat: 51.95897082563306,
    lng: -1.221172530367272,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5647",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog writes the cake angrily.",
  },
  {
    locationId: "item23648",
    locationName: "item23648",
    locationAddress: "item23648",
    ratings: [
      { who: "Similar identities", rating: 2.1 },
      { who: "All perspectives", rating: 3.18 },
    ],
    lat: 53.748993224487954,
    lng: -2.2081717470760367,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5648",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog eats a fence silently. The teacher eats the cake gracefully. The cat writes a book angrily. A woman writes the cake lazily. The student jumps over a book happily.",
  },
  {
    locationId: "item23649",
    locationName: "item23649",
    locationAddress: "item23649",
    ratings: null,
    lat: 52.181713913397545,
    lng: -2.5495884881598396,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5649",
    tags: [],
    locationDescription:
      " The student writes the horizon silently. A woman runs towards a fence silently. The teacher eats a tower happily. A woman writes a tower angrily. A woman runs towards the horizon gracefully.",
  },
  {
    locationId: "item23650",
    locationName: "item23650",
    locationAddress: "item23650",
    ratings: [
      { who: "Similar identities", rating: 3.28 },
      { who: "All perspectives", rating: 3.8 },
    ],
    lat: 55.719037503754386,
    lng: -5.1386673831029706,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5650",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat builds the horizon angrily. The student jumps over the cake quickly.",
  },
  {
    locationId: "item23651",
    locationName: "item23651",
    locationAddress: "item23651",
    ratings: null,
    lat: 51.4931756459269,
    lng: -4.276897660160082,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5651",
    tags: [],
    locationDescription:
      " The student looks at the horizon angrily. The man looks at a tower quickly. The cat writes the road happily. The cat eats the cake quickly.",
  },
  {
    locationId: "item23652",
    locationName: "item23652",
    locationAddress: "item23652",
    ratings: null,
    lat: 54.9631121415357,
    lng: -6.026026192140174,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5652",
    tags: [],
    locationDescription:
      " The student jumps over a book gracefully. The teacher jumps over a fence quickly. A dog looks at a tower happily. A dog runs towards the horizon happily.",
  },
  {
    locationId: "item23653",
    locationName: "item23653",
    locationAddress: "item23653",
    ratings: [
      { who: "Similar identities", rating: 0.44 },
      { who: "All perspectives", rating: 0.01 },
    ],
    lat: 58.03729569767934,
    lng: 1.2274833615000276,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5653",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription: " A dog writes the road gracefully.",
  },
  {
    locationId: "item23654",
    locationName: "item23654",
    locationAddress: "item23654",
    ratings: [
      { who: "Similar identities", rating: 4.8 },
      { who: "All perspectives", rating: 4.04 },
    ],
    lat: 60.477392873500705,
    lng: -3.608998947629102,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5654",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat eats the road quickly. A dog jumps over the cake lazily. A dog eats the road gracefully. The cat builds a tower happily. A dog writes a tower happily.",
  },
  {
    locationId: "item23655",
    locationName: "item23655",
    locationAddress: "item23655",
    ratings: [
      { who: "Similar identities", rating: 0.91 },
      { who: "All perspectives", rating: 1.55 },
    ],
    lat: 58.03365423760632,
    lng: -0.628257311747265,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5655",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat jumps over a tower quickly. The cat eats the road quickly. The student builds a fence angrily.",
  },
  {
    locationId: "item23656",
    locationName: "item23656",
    locationAddress: "item23656",
    ratings: null,
    lat: 56.8525569488065,
    lng: -3.9392513922028094,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5656",
    tags: [],
    locationDescription:
      " The cat looks at a tower gracefully. The man writes a fence lazily.",
  },
  {
    locationId: "item23657",
    locationName: "item23657",
    locationAddress: "item23657",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 4.6 },
    ],
    lat: 50.155567442266744,
    lng: -4.827134892884599,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5657",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman looks at a book gracefully. A dog builds a fence lazily. The teacher runs towards a book gracefully. The teacher runs towards a tower lazily. The teacher builds a tower quickly.",
  },
  {
    locationId: "item23658",
    locationName: "item23658",
    locationAddress: "item23658",
    ratings: [
      { who: "Similar identities", rating: 2.66 },
      { who: "All perspectives", rating: 4.95 },
    ],
    lat: 58.205196302596214,
    lng: -3.77835956288121,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5658",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The cat writes the road silently. The student writes a fence lazily. The man eats a book angrily. The teacher writes a fence silently.",
  },
  {
    locationId: "item23659",
    locationName: "item23659",
    locationAddress: "item23659",
    ratings: null,
    lat: 53.28258055436872,
    lng: -2.9920342094398773,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5659",
    tags: [],
    locationDescription:
      " The student looks at the cake gracefully. A dog builds the road lazily.",
  },
  {
    locationId: "item23660",
    locationName: "item23660",
    locationAddress: "item23660",
    ratings: null,
    lat: 60.40393460602084,
    lng: -3.958897941870834,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5660",
    tags: [],
    locationDescription: " The student writes a book lazily.",
  },
  {
    locationId: "item23661",
    locationName: "item23661",
    locationAddress: "item23661",
    ratings: null,
    lat: 57.80567272013088,
    lng: -4.049195097997274,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5661",
    tags: [],
    locationDescription:
      " The teacher jumps over the cake angrily. A woman writes the cake lazily. The cat looks at the road angrily.",
  },
  {
    locationId: "item23662",
    locationName: "item23662",
    locationAddress: "item23662",
    ratings: [
      { who: "Similar identities", rating: 1.22 },
      { who: "All perspectives", rating: 3.07 },
    ],
    lat: 54.10413666902127,
    lng: -3.223628364863959,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5662",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat runs towards the road happily. A woman builds the road angrily. A woman jumps over a book lazily. The teacher looks at a fence lazily.",
  },
  {
    locationId: "item23663",
    locationName: "item23663",
    locationAddress: "item23663",
    ratings: [
      { who: "Similar identities", rating: 3.69 },
      { who: "All perspectives", rating: 3.38 },
    ],
    lat: 58.32736628238047,
    lng: -1.6953725441764913,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5663",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog eats the road gracefully. A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item23664",
    locationName: "item23664",
    locationAddress: "item23664",
    ratings: [
      { who: "Similar identities", rating: 3.66 },
      { who: "All perspectives", rating: 4.7 },
    ],
    lat: 51.54776051100513,
    lng: -1.5318115905985916,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5664",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A dog jumps over a tower silently. A woman writes the horizon gracefully.",
  },
  {
    locationId: "item23665",
    locationName: "item23665",
    locationAddress: "item23665",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 3.64 },
    ],
    lat: 52.01299995629688,
    lng: -2.506635080708647,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5665",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " A woman writes a fence lazily. The man runs towards a fence lazily. A dog jumps over a book angrily. A dog writes the cake angrily.",
  },
  {
    locationId: "item23666",
    locationName: "item23666",
    locationAddress: "item23666",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 1.66 },
    ],
    lat: 50.344626739925154,
    lng: -0.33986898268744703,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5666",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The student builds a tower quickly. The teacher runs towards a tower silently.",
  },
  {
    locationId: "item23667",
    locationName: "item23667",
    locationAddress: "item23667",
    ratings: null,
    lat: 53.90199985684309,
    lng: -0.4680712944843126,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5667",
    tags: [],
    locationDescription:
      " The teacher runs towards a tower happily. The cat builds a book happily. The man builds a book happily.",
  },
  {
    locationId: "item23668",
    locationName: "item23668",
    locationAddress: "item23668",
    ratings: null,
    lat: 50.41525975438504,
    lng: 0.02279617255299371,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5668",
    tags: [],
    locationDescription:
      " The man builds a fence gracefully. A woman writes a fence happily.",
  },
  {
    locationId: "item23669",
    locationName: "item23669",
    locationAddress: "item23669",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 0.79 },
    ],
    lat: 57.08764490200133,
    lng: -4.016955634990159,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5669",
    tags: [{ label: "child friendly" }],
    locationDescription: " The teacher looks at a tower silently.",
  },
  {
    locationId: "item23670",
    locationName: "item23670",
    locationAddress: "item23670",
    ratings: null,
    lat: 57.54339794522458,
    lng: 1.4871814117354294,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5670",
    tags: [],
    locationDescription:
      " A dog eats the road quickly. The man looks at a fence happily. The teacher jumps over the road lazily. The teacher jumps over the road happily.",
  },
  {
    locationId: "item23671",
    locationName: "item23671",
    locationAddress: "item23671",
    ratings: [
      { who: "Similar identities", rating: 1.11 },
      { who: "All perspectives", rating: 3.4 },
    ],
    lat: 56.69965760593298,
    lng: -5.780605021196848,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5671",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " The man looks at the road gracefully.",
  },
  {
    locationId: "item23672",
    locationName: "item23672",
    locationAddress: "item23672",
    ratings: null,
    lat: 55.586561119435615,
    lng: -4.727444591069311,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5672",
    tags: [],
    locationDescription:
      " The man builds the road happily. The man jumps over a tower lazily.",
  },
  {
    locationId: "item23673",
    locationName: "item23673",
    locationAddress: "item23673",
    ratings: [
      { who: "Similar identities", rating: 2.75 },
      { who: "All perspectives", rating: 3.38 },
    ],
    lat: 54.64640241664365,
    lng: 0.751170444434198,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5673",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher builds a book lazily. The man runs towards a tower quickly. The man writes a book gracefully. The teacher writes a fence quickly.",
  },
  {
    locationId: "item23674",
    locationName: "item23674",
    locationAddress: "item23674",
    ratings: [
      { who: "Similar identities", rating: 0.99 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 52.07490061802728,
    lng: -3.8401537077603276,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5674",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over a tower angrily. A dog looks at the cake gracefully. The student runs towards the horizon lazily.",
  },
  {
    locationId: "item23675",
    locationName: "item23675",
    locationAddress: "item23675",
    ratings: null,
    lat: 54.19894662817837,
    lng: -3.0307281903369088,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5675",
    tags: [],
    locationDescription:
      " A woman writes a fence gracefully. The teacher looks at a tower silently. A dog eats a tower silently. The man runs towards the cake gracefully.",
  },
  {
    locationId: "item23676",
    locationName: "item23676",
    locationAddress: "item23676",
    ratings: [
      { who: "Similar identities", rating: 2.82 },
      { who: "All perspectives", rating: 2.8 },
    ],
    lat: 55.061008172192714,
    lng: -7.436751504077449,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5676",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man writes a tower happily. The cat builds a book happily. The cat builds a tower lazily.",
  },
  {
    locationId: "item23677",
    locationName: "item23677",
    locationAddress: "item23677",
    ratings: [
      { who: "Similar identities", rating: 2.49 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 56.919385553554804,
    lng: -1.9199336203908084,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5677",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The cat jumps over the road angrily. The cat jumps over the cake quickly. The student looks at a fence gracefully. The cat looks at the road quickly.",
  },
  {
    locationId: "item23678",
    locationName: "item23678",
    locationAddress: "item23678",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 2.3 },
    ],
    lat: 58.68858590788852,
    lng: -5.170776150358311,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5678",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat writes the road silently.",
  },
  {
    locationId: "item23679",
    locationName: "item23679",
    locationAddress: "item23679",
    ratings: [
      { who: "Similar identities", rating: 1.33 },
      { who: "All perspectives", rating: 2.29 },
    ],
    lat: 53.05914433055608,
    lng: 1.0834395795987195,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5679",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The cat looks at the cake angrily. The teacher writes the horizon lazily. The cat jumps over the road quickly.",
  },
  {
    locationId: "item23680",
    locationName: "item23680",
    locationAddress: "item23680",
    ratings: [
      { who: "Similar identities", rating: 0.66 },
      { who: "All perspectives", rating: 1.53 },
    ],
    lat: 50.399824905514954,
    lng: -8.020883177571891,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5680",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " A dog writes the cake quickly.",
  },
  {
    locationId: "item23681",
    locationName: "item23681",
    locationAddress: "item23681",
    ratings: null,
    lat: 54.52622926527742,
    lng: -5.071794415834717,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5681",
    tags: [],
    locationDescription:
      " A woman writes a book angrily. The teacher builds the horizon lazily.",
  },
  {
    locationId: "item23682",
    locationName: "item23682",
    locationAddress: "item23682",
    ratings: null,
    lat: 53.612176864271284,
    lng: -7.476247306066974,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5682",
    tags: [],
    locationDescription: " A woman writes a tower angrily.",
  },
  {
    locationId: "item23683",
    locationName: "item23683",
    locationAddress: "item23683",
    ratings: null,
    lat: 59.7995237099656,
    lng: -6.46290529468749,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5683",
    tags: [],
    locationDescription:
      " A dog runs towards a book quickly. A woman writes the cake gracefully. The student eats a tower silently.",
  },
  {
    locationId: "item23684",
    locationName: "item23684",
    locationAddress: "item23684",
    ratings: [
      { who: "Similar identities", rating: 4.65 },
      { who: "All perspectives", rating: 4.38 },
    ],
    lat: 53.70271688005965,
    lng: -6.416306097160332,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5684",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat jumps over a fence angrily. A woman writes the road angrily.",
  },
  {
    locationId: "item23685",
    locationName: "item23685",
    locationAddress: "item23685",
    ratings: null,
    lat: 54.23867438830202,
    lng: -6.129437901340013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5685",
    tags: [],
    locationDescription:
      " The man looks at the cake quickly. A woman writes the horizon angrily.",
  },
  {
    locationId: "item23686",
    locationName: "item23686",
    locationAddress: "item23686",
    ratings: [
      { who: "Similar identities", rating: 4.43 },
      { who: "All perspectives", rating: 3.62 },
    ],
    lat: 57.56466928742991,
    lng: -5.263232178031167,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5686",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat eats the cake gracefully. The cat writes the horizon happily. The man eats the horizon lazily.",
  },
  {
    locationId: "item23687",
    locationName: "item23687",
    locationAddress: "item23687",
    ratings: [
      { who: "Similar identities", rating: 0.11 },
      { who: "All perspectives", rating: 3.96 },
    ],
    lat: 60.5891508858966,
    lng: -6.0553064817258395,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5687",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The cat builds the road angrily.",
  },
  {
    locationId: "item23688",
    locationName: "item23688",
    locationAddress: "item23688",
    ratings: [
      { who: "Similar identities", rating: 4.76 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 60.3133940816551,
    lng: 0.3463395592676992,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5688",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " A dog eats a fence quickly.",
  },
  {
    locationId: "item23689",
    locationName: "item23689",
    locationAddress: "item23689",
    ratings: null,
    lat: 54.290917055243085,
    lng: -3.4176239449234247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5689",
    tags: [],
    locationDescription:
      " A dog jumps over a tower happily. The student runs towards the cake quickly. The cat eats the road quickly.",
  },
  {
    locationId: "item23690",
    locationName: "item23690",
    locationAddress: "item23690",
    ratings: [
      { who: "Similar identities", rating: 2.49 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 60.461619411258376,
    lng: -1.1173197048712096,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5690",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription: " The teacher eats a book lazily.",
  },
  {
    locationId: "item23691",
    locationName: "item23691",
    locationAddress: "item23691",
    ratings: null,
    lat: 53.4230382924029,
    lng: -4.730565951830912,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5691",
    tags: [],
    locationDescription: " A dog builds the horizon lazily.",
  },
  {
    locationId: "item23692",
    locationName: "item23692",
    locationAddress: "item23692",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 2.62 },
    ],
    lat: 58.92461761604395,
    lng: -2.434806098172106,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5692",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman builds a book quickly.",
  },
  {
    locationId: "item23693",
    locationName: "item23693",
    locationAddress: "item23693",
    ratings: null,
    lat: 57.55537135853914,
    lng: -1.6533779671561675,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5693",
    tags: [],
    locationDescription:
      " A dog eats the horizon silently. A woman writes the cake gracefully. A woman jumps over a fence lazily. A woman eats the road angrily. The man runs towards the cake lazily.",
  },
  {
    locationId: "item23694",
    locationName: "item23694",
    locationAddress: "item23694",
    ratings: [
      { who: "Similar identities", rating: 0.52 },
      { who: "All perspectives", rating: 4.12 },
    ],
    lat: 55.3613257856081,
    lng: 0.8205334187627127,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5694",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman looks at the road lazily. The student looks at a fence angrily. The student builds the cake angrily. The man looks at a tower happily. The student builds a fence lazily.",
  },
  {
    locationId: "item23695",
    locationName: "item23695",
    locationAddress: "item23695",
    ratings: [
      { who: "Similar identities", rating: 4.28 },
      { who: "All perspectives", rating: 3.94 },
    ],
    lat: 50.340844558178226,
    lng: -5.376843694953819,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5695",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The teacher runs towards a fence happily. The student runs towards the cake quickly. The man looks at a book gracefully. The student writes the horizon happily.",
  },
  {
    locationId: "item23696",
    locationName: "item23696",
    locationAddress: "item23696",
    ratings: null,
    lat: 59.28327557802097,
    lng: -1.0943202919001171,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5696",
    tags: [],
    locationDescription: " The man writes the road gracefully.",
  },
  {
    locationId: "item23697",
    locationName: "item23697",
    locationAddress: "item23697",
    ratings: [
      { who: "Similar identities", rating: 0.09 },
      { who: "All perspectives", rating: 4.53 },
    ],
    lat: 57.324251670851524,
    lng: -3.861987242245263,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5697",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman jumps over the road quickly. The man jumps over the cake silently. The cat looks at the horizon happily.",
  },
  {
    locationId: "item23698",
    locationName: "item23698",
    locationAddress: "item23698",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 0.88 },
    ],
    lat: 56.68021904448201,
    lng: -4.893801448293276,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5698",
    tags: [{ label: "accessible" }, { label: "trans-inclusive" }],
    locationDescription:
      " The student builds a book happily. The cat looks at the road happily.",
  },
  {
    locationId: "item23699",
    locationName: "item23699",
    locationAddress: "item23699",
    ratings: null,
    lat: 56.09880325410584,
    lng: -7.014910105684915,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5699",
    tags: [],
    locationDescription:
      " The teacher jumps over a tower lazily. The teacher looks at a fence lazily. A woman jumps over a tower quickly.",
  },
  {
    locationId: "item23700",
    locationName: "item23700",
    locationAddress: "item23700",
    ratings: null,
    lat: 52.680864791939214,
    lng: -7.035738410827625,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5700",
    tags: [],
    locationDescription:
      " A woman builds the cake silently. The man writes the road gracefully. The student looks at the horizon quickly. A woman builds the cake gracefully.",
  },
  {
    locationId: "item23701",
    locationName: "item23701",
    locationAddress: "item23701",
    ratings: [
      { who: "Similar identities", rating: 0.49 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 55.224466640019244,
    lng: -5.115468021374403,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5701",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The teacher eats a fence gracefully.",
  },
  {
    locationId: "item23702",
    locationName: "item23702",
    locationAddress: "item23702",
    ratings: null,
    lat: 53.04313547007177,
    lng: -2.753306584339386,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5702",
    tags: [],
    locationDescription: " A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item23703",
    locationName: "item23703",
    locationAddress: "item23703",
    ratings: null,
    lat: 52.18589050043139,
    lng: -7.140621462598518,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5703",
    tags: [],
    locationDescription: " The cat writes the road angrily.",
  },
  {
    locationId: "item23704",
    locationName: "item23704",
    locationAddress: "item23704",
    ratings: null,
    lat: 50.10779301135383,
    lng: -1.6050422064442715,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5704",
    tags: [],
    locationDescription:
      " A woman writes a book happily. The teacher jumps over the cake silently. The cat eats a book silently. A dog jumps over a book silently. The teacher looks at the road quickly.",
  },
  {
    locationId: "item23705",
    locationName: "item23705",
    locationAddress: "item23705",
    ratings: null,
    lat: 53.731169398533225,
    lng: 0.0323743647242285,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5705",
    tags: [],
    locationDescription:
      " The student writes a fence quickly. The teacher eats a book silently. A dog runs towards the road happily. The man looks at the cake quickly. The teacher writes the horizon angrily.",
  },
  {
    locationId: "item23706",
    locationName: "item23706",
    locationAddress: "item23706",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 2.66 },
    ],
    lat: 57.62955515519304,
    lng: -6.098815431270399,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5706",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " A woman looks at the road quickly.",
  },
  {
    locationId: "item23707",
    locationName: "item23707",
    locationAddress: "item23707",
    ratings: null,
    lat: 52.02264520110129,
    lng: 1.798696937591295,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5707",
    tags: [],
    locationDescription:
      " The teacher jumps over a book quickly. The cat jumps over a tower happily. The teacher writes the horizon gracefully. A dog eats a tower angrily. The teacher eats a book lazily.",
  },
  {
    locationId: "item23708",
    locationName: "item23708",
    locationAddress: "item23708",
    ratings: [
      { who: "Similar identities", rating: 0.52 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 53.08522179350527,
    lng: -0.2496587382960591,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5708",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher runs towards the road quickly. A woman looks at the horizon quickly.",
  },
  {
    locationId: "item23709",
    locationName: "item23709",
    locationAddress: "item23709",
    ratings: null,
    lat: 57.47328320554247,
    lng: -7.10306112768845,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5709",
    tags: [],
    locationDescription: " The cat looks at the road quickly.",
  },
  {
    locationId: "item23710",
    locationName: "item23710",
    locationAddress: "item23710",
    ratings: [
      { who: "Similar identities", rating: 2.58 },
      { who: "All perspectives", rating: 1.56 },
    ],
    lat: 57.36494334970715,
    lng: -6.407021501783129,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5710",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man builds the road happily. The student eats a book quickly. The student looks at the horizon lazily. A woman writes the road silently.",
  },
  {
    locationId: "item23711",
    locationName: "item23711",
    locationAddress: "item23711",
    ratings: [
      { who: "Similar identities", rating: 0.25 },
      { who: "All perspectives", rating: 1.86 },
    ],
    lat: 58.160409262550104,
    lng: -4.840592798417198,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5711",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards a book lazily. The cat builds a book quickly. The teacher builds the road angrily. The student looks at the cake gracefully. A woman eats a tower quickly.",
  },
  {
    locationId: "item23712",
    locationName: "item23712",
    locationAddress: "item23712",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 1.22 },
    ],
    lat: 50.388086122917265,
    lng: -3.661330997600291,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5712",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A dog builds the cake happily.",
  },
  {
    locationId: "item23713",
    locationName: "item23713",
    locationAddress: "item23713",
    ratings: null,
    lat: 58.01830636295943,
    lng: -5.776266188585478,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5713",
    tags: [],
    locationDescription:
      " The teacher eats the horizon quickly. The student runs towards a book quickly. A woman jumps over the road quickly. A woman writes a tower silently. The student writes the horizon quickly.",
  },
  {
    locationId: "item23714",
    locationName: "item23714",
    locationAddress: "item23714",
    ratings: null,
    lat: 52.129123613808645,
    lng: -2.0332048645446337,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5714",
    tags: [],
    locationDescription: " A woman writes the horizon gracefully.",
  },
  {
    locationId: "item23715",
    locationName: "item23715",
    locationAddress: "item23715",
    ratings: null,
    lat: 51.63854337610004,
    lng: -2.182221615123556,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5715",
    tags: [],
    locationDescription:
      " The man looks at a tower lazily. A woman eats a book angrily. The man writes a fence quickly.",
  },
  {
    locationId: "item23716",
    locationName: "item23716",
    locationAddress: "item23716",
    ratings: null,
    lat: 51.86930159247437,
    lng: 1.648768745931612,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5716",
    tags: [],
    locationDescription:
      " The man builds the cake silently. A woman jumps over a book gracefully. The teacher builds a book quickly.",
  },
  {
    locationId: "item23717",
    locationName: "item23717",
    locationAddress: "item23717",
    ratings: [
      { who: "Similar identities", rating: 1.76 },
      { who: "All perspectives", rating: 4.67 },
    ],
    lat: 59.63994208785501,
    lng: -3.182211419694254,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5717",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman runs towards the horizon lazily.",
  },
  {
    locationId: "item23718",
    locationName: "item23718",
    locationAddress: "item23718",
    ratings: null,
    lat: 60.435187943631185,
    lng: -4.8858874129765635,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5718",
    tags: [],
    locationDescription:
      " The teacher looks at a book happily. A woman looks at the cake quickly. The student eats the cake lazily. The teacher jumps over the road quickly. The cat writes a book lazily.",
  },
  {
    locationId: "item23719",
    locationName: "item23719",
    locationAddress: "item23719",
    ratings: null,
    lat: 55.75694680585453,
    lng: -6.672820835524036,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5719",
    tags: [],
    locationDescription:
      " A woman builds the horizon gracefully. The teacher eats the horizon gracefully. The student writes the road gracefully.",
  },
  {
    locationId: "item23720",
    locationName: "item23720",
    locationAddress: "item23720",
    ratings: [
      { who: "Similar identities", rating: 3.6 },
      { who: "All perspectives", rating: 1.35 },
    ],
    lat: 58.013589256729816,
    lng: -5.94163482851128,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5720",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription: " The student jumps over a fence angrily.",
  },
  {
    locationId: "item23721",
    locationName: "item23721",
    locationAddress: "item23721",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 2.38 },
    ],
    lat: 56.842844082172306,
    lng: -0.7508940796967014,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5721",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student eats the cake lazily. The man builds the horizon gracefully.",
  },
  {
    locationId: "item23722",
    locationName: "item23722",
    locationAddress: "item23722",
    ratings: [
      { who: "Similar identities", rating: 1.05 },
      { who: "All perspectives", rating: 2.43 },
    ],
    lat: 50.8286293114485,
    lng: -4.951796028247788,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5722",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " A woman builds the cake silently.",
  },
  {
    locationId: "item23723",
    locationName: "item23723",
    locationAddress: "item23723",
    ratings: [
      { who: "Similar identities", rating: 3.62 },
      { who: "All perspectives", rating: 4.59 },
    ],
    lat: 53.764187288189575,
    lng: -5.735722536805056,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5723",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man runs towards the cake silently. A dog eats the cake happily. The man writes the cake happily. A dog looks at the cake lazily. A dog runs towards the horizon happily.",
  },
  {
    locationId: "item23724",
    locationName: "item23724",
    locationAddress: "item23724",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 0.34 },
    ],
    lat: 57.501353216600386,
    lng: -5.97375007710597,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5724",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription: " The cat builds a tower happily.",
  },
  {
    locationId: "item23725",
    locationName: "item23725",
    locationAddress: "item23725",
    ratings: null,
    lat: 55.6353567053297,
    lng: -4.191278532139898,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5725",
    tags: [],
    locationDescription:
      " The teacher jumps over the road gracefully. A dog eats a tower gracefully. A dog builds the road angrily. A woman writes a tower silently. The cat runs towards a book lazily.",
  },
  {
    locationId: "item23726",
    locationName: "item23726",
    locationAddress: "item23726",
    ratings: null,
    lat: 58.430869202026,
    lng: -1.7240029993582402,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5726",
    tags: [],
    locationDescription:
      " The man eats the horizon lazily. A woman builds a book happily. The cat jumps over a book happily.",
  },
  {
    locationId: "item23727",
    locationName: "item23727",
    locationAddress: "item23727",
    ratings: [
      { who: "Similar identities", rating: 2.7 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 53.95714917672745,
    lng: 0.8439080427541583,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5727",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman builds the road angrily. The student runs towards a book angrily. The man eats the road gracefully. The student looks at the road quickly. The man jumps over a fence gracefully.",
  },
  {
    locationId: "item23728",
    locationName: "item23728",
    locationAddress: "item23728",
    ratings: null,
    lat: 59.50191657457561,
    lng: 0.5937987550206305,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5728",
    tags: [],
    locationDescription: " The student eats the cake lazily.",
  },
  {
    locationId: "item23729",
    locationName: "item23729",
    locationAddress: "item23729",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 1.24 },
    ],
    lat: 54.48454686028242,
    lng: -4.771113303238855,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5729",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher looks at the horizon gracefully. The man looks at the cake quickly. A woman eats a book silently. The teacher looks at the road silently. A dog runs towards the horizon silently.",
  },
  {
    locationId: "item23730",
    locationName: "item23730",
    locationAddress: "item23730",
    ratings: [
      { who: "Similar identities", rating: 1.29 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 53.275552588143825,
    lng: -7.618673499619626,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5730",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription: " The man runs towards a fence quickly.",
  },
  {
    locationId: "item23731",
    locationName: "item23731",
    locationAddress: "item23731",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 3.9 },
    ],
    lat: 56.81380495754103,
    lng: -4.630758425339096,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5731",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The student runs towards a book angrily. The cat runs towards the cake lazily.",
  },
  {
    locationId: "item23732",
    locationName: "item23732",
    locationAddress: "item23732",
    ratings: [
      { who: "Similar identities", rating: 0.42 },
      { who: "All perspectives", rating: 3.39 },
    ],
    lat: 59.3056848411604,
    lng: -4.094843451800096,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5732",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A woman looks at a book silently. A dog jumps over a fence gracefully. The cat looks at the road gracefully.",
  },
  {
    locationId: "item23733",
    locationName: "item23733",
    locationAddress: "item23733",
    ratings: [
      { who: "Similar identities", rating: 2.37 },
      { who: "All perspectives", rating: 4.21 },
    ],
    lat: 56.038272055248285,
    lng: -3.9296532062942617,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5733",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman eats a book silently. The teacher jumps over the road silently. The man runs towards a tower gracefully. The student eats the cake happily.",
  },
  {
    locationId: "item23734",
    locationName: "item23734",
    locationAddress: "item23734",
    ratings: null,
    lat: 54.533703593330515,
    lng: 0.6517495569138259,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5734",
    tags: [],
    locationDescription:
      " The student jumps over a book gracefully. The teacher looks at the horizon silently.",
  },
  {
    locationId: "item23735",
    locationName: "item23735",
    locationAddress: "item23735",
    ratings: [
      { who: "Similar identities", rating: 4.59 },
      { who: "All perspectives", rating: 3.39 },
    ],
    lat: 55.5623677619884,
    lng: -3.448674812688524,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5735",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student eats the horizon silently. A dog writes the road silently. A dog builds a book silently.",
  },
  {
    locationId: "item23736",
    locationName: "item23736",
    locationAddress: "item23736",
    ratings: null,
    lat: 54.63612566857828,
    lng: -3.9844286586389472,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5736",
    tags: [],
    locationDescription:
      " A woman writes the horizon happily. The student runs towards the horizon gracefully. The man runs towards a fence angrily. A dog writes the road angrily. The teacher runs towards the cake lazily.",
  },
  {
    locationId: "item23737",
    locationName: "item23737",
    locationAddress: "item23737",
    ratings: null,
    lat: 60.21806997905973,
    lng: -7.873386047773237,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5737",
    tags: [],
    locationDescription:
      " The student writes the cake happily. A woman eats a fence lazily. The cat looks at the horizon quickly.",
  },
  {
    locationId: "item23738",
    locationName: "item23738",
    locationAddress: "item23738",
    ratings: null,
    lat: 55.16924029814289,
    lng: -4.132388163195272,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5738",
    tags: [],
    locationDescription:
      " The teacher builds the cake quickly. The student jumps over the cake gracefully. A woman looks at a fence angrily. A dog jumps over a book gracefully.",
  },
  {
    locationId: "item23739",
    locationName: "item23739",
    locationAddress: "item23739",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 4.45 },
    ],
    lat: 51.75462416465952,
    lng: 1.660300309219899,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5739",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student writes a fence happily. The man builds a fence lazily. The student eats a tower angrily. A dog looks at the road happily.",
  },
  {
    locationId: "item23740",
    locationName: "item23740",
    locationAddress: "item23740",
    ratings: [
      { who: "Similar identities", rating: 4.77 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 57.40822391375485,
    lng: -3.084990384231797,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5740",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at a book lazily. The cat writes the road happily. A dog runs towards the cake silently.",
  },
  {
    locationId: "item23741",
    locationName: "item23741",
    locationAddress: "item23741",
    ratings: [
      { who: "Similar identities", rating: 0.55 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 59.53078575609906,
    lng: -2.4806667368676223,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5741",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat looks at the road quickly. The teacher builds a fence angrily. The man jumps over a tower happily. The student looks at a tower gracefully.",
  },
  {
    locationId: "item23742",
    locationName: "item23742",
    locationAddress: "item23742",
    ratings: null,
    lat: 55.94346221146774,
    lng: -4.567522035062678,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5742",
    tags: [],
    locationDescription:
      " The man builds a book gracefully. The cat looks at the horizon angrily. The student jumps over the road happily. The student eats the cake gracefully.",
  },
  {
    locationId: "item23743",
    locationName: "item23743",
    locationAddress: "item23743",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 55.032394112658864,
    lng: -8.576922827218363,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5743",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student runs towards the cake quickly. The teacher eats a tower gracefully. The teacher runs towards a book lazily.",
  },
  {
    locationId: "item23744",
    locationName: "item23744",
    locationAddress: "item23744",
    ratings: null,
    lat: 52.31023267598249,
    lng: -8.491337783505118,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5744",
    tags: [],
    locationDescription:
      " The teacher jumps over the road angrily. A woman looks at the road silently. The cat jumps over the road angrily. A dog writes a fence silently.",
  },
  {
    locationId: "item23745",
    locationName: "item23745",
    locationAddress: "item23745",
    ratings: null,
    lat: 53.25551177348268,
    lng: -3.177320633028863,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5745",
    tags: [],
    locationDescription:
      " The man builds the cake lazily. The cat builds the horizon happily. The man eats a fence angrily.",
  },
  {
    locationId: "item23746",
    locationName: "item23746",
    locationAddress: "item23746",
    ratings: [
      { who: "Similar identities", rating: 3.98 },
      { who: "All perspectives", rating: 0.97 },
    ],
    lat: 54.95036416969834,
    lng: -6.344592431007786,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5746",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The teacher jumps over the horizon happily.",
  },
  {
    locationId: "item23747",
    locationName: "item23747",
    locationAddress: "item23747",
    ratings: [
      { who: "Similar identities", rating: 2.97 },
      { who: "All perspectives", rating: 1.26 },
    ],
    lat: 55.48494596659913,
    lng: -5.750103461742855,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5747",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    locationDescription:
      " The man jumps over a tower silently. A woman builds a fence lazily. The teacher builds the road quickly. The man builds the road quickly. The student eats a fence happily.",
  },
  {
    locationId: "item23748",
    locationName: "item23748",
    locationAddress: "item23748",
    ratings: [
      { who: "Similar identities", rating: 0.79 },
      { who: "All perspectives", rating: 0.47 },
    ],
    lat: 58.02092265953902,
    lng: -6.672015666292502,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5748",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat eats a fence happily. The teacher looks at a book gracefully. A woman jumps over a tower lazily. The cat runs towards a tower quickly.",
  },
  {
    locationId: "item23749",
    locationName: "item23749",
    locationAddress: "item23749",
    ratings: [
      { who: "Similar identities", rating: 0.17 },
      { who: "All perspectives", rating: 3.22 },
    ],
    lat: 60.211404302337264,
    lng: -8.49894460870696,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5749",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman writes a fence quickly. A woman builds the cake silently. The cat eats the road lazily. A woman eats the horizon quickly. The teacher writes a tower gracefully.",
  },
  {
    locationId: "item23750",
    locationName: "item23750",
    locationAddress: "item23750",
    ratings: [
      { who: "Similar identities", rating: 1.7 },
      { who: "All perspectives", rating: 4.37 },
    ],
    lat: 51.17106615504692,
    lng: -5.568889764181918,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5750",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes a fence lazily. A dog runs towards a tower happily. The teacher writes a fence angrily. A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item23751",
    locationName: "item23751",
    locationAddress: "item23751",
    ratings: [
      { who: "Similar identities", rating: 2.57 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 49.95850199808231,
    lng: -1.2197524668614488,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5751",
    tags: [
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man looks at a tower happily.",
  },
  {
    locationId: "item23752",
    locationName: "item23752",
    locationAddress: "item23752",
    ratings: [
      { who: "Similar identities", rating: 2.45 },
      { who: "All perspectives", rating: 2.19 },
    ],
    lat: 58.51515019613262,
    lng: -0.46159721566404066,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5752",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at the road quickly. The student builds the horizon silently. A woman writes a fence happily. A woman eats the road gracefully. A dog writes the cake angrily.",
  },
  {
    locationId: "item23753",
    locationName: "item23753",
    locationAddress: "item23753",
    ratings: [
      { who: "Similar identities", rating: 4.93 },
      { who: "All perspectives", rating: 0.06 },
    ],
    lat: 56.74750337911576,
    lng: -6.191575401753103,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5753",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman writes a fence gracefully. A woman runs towards a tower lazily. A dog eats a tower lazily. The teacher eats a tower gracefully. A dog writes the road lazily.",
  },
  {
    locationId: "item23754",
    locationName: "item23754",
    locationAddress: "item23754",
    ratings: null,
    lat: 50.43427178561738,
    lng: -6.7233455867682785,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5754",
    tags: [],
    locationDescription:
      " A dog looks at a fence happily. A woman writes a fence happily. The teacher jumps over a fence gracefully. A woman jumps over a tower happily.",
  },
  {
    locationId: "item23755",
    locationName: "item23755",
    locationAddress: "item23755",
    ratings: [
      { who: "Similar identities", rating: 4.66 },
      { who: "All perspectives", rating: 4.08 },
    ],
    lat: 55.82217483412187,
    lng: -2.131554741529654,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5755",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " A dog looks at the horizon happily.",
  },
  {
    locationId: "item23756",
    locationName: "item23756",
    locationAddress: "item23756",
    ratings: null,
    lat: 55.918709984091834,
    lng: -2.9401731933749113,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5756",
    tags: [],
    locationDescription:
      " The teacher runs towards a book happily. The student runs towards a book silently. A dog jumps over the cake angrily. The cat jumps over a tower silently.",
  },
  {
    locationId: "item23757",
    locationName: "item23757",
    locationAddress: "item23757",
    ratings: [
      { who: "Similar identities", rating: 3.21 },
      { who: "All perspectives", rating: 2.74 },
    ],
    lat: 59.74175681101355,
    lng: -3.15715716236431,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5757",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat runs towards a tower happily. The student looks at a fence angrily. The teacher builds a tower lazily. The cat runs towards a book gracefully. The teacher runs towards a book quickly.",
  },
  {
    locationId: "item23758",
    locationName: "item23758",
    locationAddress: "item23758",
    ratings: [
      { who: "Similar identities", rating: 4.86 },
      { who: "All perspectives", rating: 4.74 },
    ],
    lat: 52.5103843164563,
    lng: -8.406624495035103,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5758",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The student jumps over a fence happily.",
  },
  {
    locationId: "item23759",
    locationName: "item23759",
    locationAddress: "item23759",
    ratings: [
      { who: "Similar identities", rating: 4.95 },
      { who: "All perspectives", rating: 2.63 },
    ],
    lat: 60.08779820004743,
    lng: -7.648634875086504,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5759",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman eats a fence silently. A dog eats a fence lazily. The cat looks at a fence lazily. A dog writes the horizon gracefully.",
  },
  {
    locationId: "item23760",
    locationName: "item23760",
    locationAddress: "item23760",
    ratings: null,
    lat: 52.9105911501826,
    lng: 0.6365056501108146,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5760",
    tags: [],
    locationDescription:
      " The cat writes a book lazily. A woman eats the horizon quickly. The student eats a book quickly.",
  },
  {
    locationId: "item23761",
    locationName: "item23761",
    locationAddress: "item23761",
    ratings: null,
    lat: 54.09970832983849,
    lng: -3.7047842414020247,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5761",
    tags: [],
    locationDescription:
      " A dog jumps over the cake angrily. The teacher writes a fence quickly. A woman builds a book quickly. A woman runs towards a tower silently. The teacher eats a fence happily.",
  },
  {
    locationId: "item23762",
    locationName: "item23762",
    locationAddress: "item23762",
    ratings: [
      { who: "Similar identities", rating: 2.84 },
      { who: "All perspectives", rating: 3.43 },
    ],
    lat: 50.62133983948587,
    lng: -8.367443120436421,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5762",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher builds a book silently. A dog eats a fence silently. The man builds the cake happily.",
  },
  {
    locationId: "item23763",
    locationName: "item23763",
    locationAddress: "item23763",
    ratings: null,
    lat: 51.66884072549471,
    lng: -8.268040139243062,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5763",
    tags: [],
    locationDescription: " The teacher builds a fence happily.",
  },
  {
    locationId: "item23764",
    locationName: "item23764",
    locationAddress: "item23764",
    ratings: [
      { who: "Similar identities", rating: 3.56 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 53.80122928094488,
    lng: -6.039754686056014,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5764",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The man writes the cake lazily. A woman looks at a fence lazily. The teacher runs towards the road silently. The cat builds the horizon quickly.",
  },
  {
    locationId: "item23765",
    locationName: "item23765",
    locationAddress: "item23765",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 3.89 },
    ],
    lat: 57.89628655792737,
    lng: -3.184569480556516,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5765",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher writes a tower angrily. A dog eats a book happily.",
  },
  {
    locationId: "item23766",
    locationName: "item23766",
    locationAddress: "item23766",
    ratings: [
      { who: "Similar identities", rating: 1.58 },
      { who: "All perspectives", rating: 3.76 },
    ],
    lat: 50.32068519894787,
    lng: -2.1384752631707657,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5766",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over a book gracefully. The student jumps over a book quickly.",
  },
  {
    locationId: "item23767",
    locationName: "item23767",
    locationAddress: "item23767",
    ratings: null,
    lat: 54.060562020943664,
    lng: -2.8439521501502876,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5767",
    tags: [],
    locationDescription:
      " A dog writes a fence happily. The student runs towards a fence quickly. A dog jumps over the horizon silently. The teacher builds the cake quickly.",
  },
  {
    locationId: "item23768",
    locationName: "item23768",
    locationAddress: "item23768",
    ratings: null,
    lat: 55.85791273461692,
    lng: 1.7852217603358085,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5768",
    tags: [],
    locationDescription: " The teacher runs towards a fence angrily.",
  },
  {
    locationId: "item23769",
    locationName: "item23769",
    locationAddress: "item23769",
    ratings: null,
    lat: 51.1814027552324,
    lng: -2.973922132257332,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5769",
    tags: [],
    locationDescription:
      " The cat eats the horizon lazily. A dog eats the horizon silently. A woman writes the cake angrily. A dog eats the road gracefully. A woman builds the horizon lazily.",
  },
  {
    locationId: "item23770",
    locationName: "item23770",
    locationAddress: "item23770",
    ratings: null,
    lat: 60.4289341861171,
    lng: -3.698853833681749,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5770",
    tags: [],
    locationDescription:
      " The man looks at the road angrily. The student looks at a book happily. A dog looks at the road lazily. The student runs towards the road angrily.",
  },
  {
    locationId: "item23771",
    locationName: "item23771",
    locationAddress: "item23771",
    ratings: null,
    lat: 51.38551030527551,
    lng: -4.9096683975923385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5771",
    tags: [],
    locationDescription: " The cat jumps over the cake angrily.",
  },
  {
    locationId: "item23772",
    locationName: "item23772",
    locationAddress: "item23772",
    ratings: [
      { who: "Similar identities", rating: 0.79 },
      { who: "All perspectives", rating: 0.78 },
    ],
    lat: 50.69158944348419,
    lng: 0.9049589229245036,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5772",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student runs towards the cake lazily. The teacher jumps over the horizon lazily. The student writes a tower gracefully.",
  },
  {
    locationId: "item23773",
    locationName: "item23773",
    locationAddress: "item23773",
    ratings: null,
    lat: 51.42724034960779,
    lng: -2.9240952309300363,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5773",
    tags: [],
    locationDescription: " The teacher builds a fence lazily.",
  },
  {
    locationId: "item23774",
    locationName: "item23774",
    locationAddress: "item23774",
    ratings: null,
    lat: 58.753292544409256,
    lng: -4.560577224510767,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5774",
    tags: [],
    locationDescription:
      " The cat eats the road gracefully. The man looks at the cake lazily.",
  },
  {
    locationId: "item23775",
    locationName: "item23775",
    locationAddress: "item23775",
    ratings: null,
    lat: 59.23369216072795,
    lng: -8.290169977915225,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5775",
    tags: [],
    locationDescription:
      " The student runs towards a tower angrily. The student builds the cake quickly. The cat writes a tower quickly. A dog runs towards a book happily.",
  },
  {
    locationId: "item23776",
    locationName: "item23776",
    locationAddress: "item23776",
    ratings: [
      { who: "Similar identities", rating: 4.26 },
      { who: "All perspectives", rating: 3.27 },
    ],
    lat: 51.0338740943262,
    lng: 0.2940226804857282,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5776",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat looks at the cake quickly. The man eats the road lazily. The man runs towards a tower happily.",
  },
  {
    locationId: "item23777",
    locationName: "item23777",
    locationAddress: "item23777",
    ratings: [
      { who: "Similar identities", rating: 4.07 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 50.57865836835609,
    lng: -5.218869553921573,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5777",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat eats a book quickly. A dog jumps over the cake angrily.",
  },
  {
    locationId: "item23778",
    locationName: "item23778",
    locationAddress: "item23778",
    ratings: [
      { who: "Similar identities", rating: 4.14 },
      { who: "All perspectives", rating: 4.15 },
    ],
    lat: 49.949941970761934,
    lng: -6.0065722256851295,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5778",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student writes the horizon angrily. The cat writes a tower gracefully. The man builds the horizon silently.",
  },
  {
    locationId: "item23779",
    locationName: "item23779",
    locationAddress: "item23779",
    ratings: [
      { who: "Similar identities", rating: 4.72 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 49.99925997062876,
    lng: -6.36344154212963,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5779",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A dog looks at a book lazily. The cat looks at a fence quickly.",
  },
  {
    locationId: "item23780",
    locationName: "item23780",
    locationAddress: "item23780",
    ratings: [
      { who: "Similar identities", rating: 2.34 },
      { who: "All perspectives", rating: 1.99 },
    ],
    lat: 50.51126359713606,
    lng: -3.8332188932811064,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5780",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription:
      " The man eats a fence gracefully. The man writes a fence gracefully. A dog looks at the cake angrily. The cat writes the horizon gracefully. The student writes the road silently.",
  },
  {
    locationId: "item23781",
    locationName: "item23781",
    locationAddress: "item23781",
    ratings: [
      { who: "Similar identities", rating: 1.09 },
      { who: "All perspectives", rating: 1.84 },
    ],
    lat: 52.77865736057288,
    lng: -8.153027586506607,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5781",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man looks at the horizon lazily. A dog looks at the road gracefully. The student builds a book gracefully. The student builds the road silently. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item23782",
    locationName: "item23782",
    locationAddress: "item23782",
    ratings: [
      { who: "Similar identities", rating: 0.38 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 60.14832413214526,
    lng: -5.261617054195744,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5782",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog eats the road happily.",
  },
  {
    locationId: "item23783",
    locationName: "item23783",
    locationAddress: "item23783",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 1.57 },
    ],
    lat: 54.417727499148135,
    lng: 0.7633978092458023,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5783",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman eats the horizon silently. A dog looks at the horizon happily. A dog eats a tower happily. The teacher builds a book angrily. A dog eats the road silently.",
  },
  {
    locationId: "item23784",
    locationName: "item23784",
    locationAddress: "item23784",
    ratings: [
      { who: "Similar identities", rating: 0.37 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 51.25789466905243,
    lng: -7.884076489387051,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5784",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat looks at a book happily. A woman writes the horizon angrily. The cat builds the road happily.",
  },
  {
    locationId: "item23785",
    locationName: "item23785",
    locationAddress: "item23785",
    ratings: [
      { who: "Similar identities", rating: 4.81 },
      { who: "All perspectives", rating: 0.58 },
    ],
    lat: 57.13079721560413,
    lng: -6.969233090901689,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5785",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher eats a fence angrily. The teacher runs towards a book silently.",
  },
  {
    locationId: "item23786",
    locationName: "item23786",
    locationAddress: "item23786",
    ratings: null,
    lat: 50.626896990174934,
    lng: 1.7812294793919818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5786",
    tags: [],
    locationDescription:
      " The cat jumps over a fence silently. The man runs towards a book silently. The man jumps over a book gracefully. A dog writes the horizon gracefully. A dog looks at the road lazily.",
  },
  {
    locationId: "item23787",
    locationName: "item23787",
    locationAddress: "item23787",
    ratings: null,
    lat: 59.157672335138564,
    lng: -0.22289017258291288,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5787",
    tags: [],
    locationDescription:
      " A dog writes a tower silently. A woman writes the road happily. A woman builds the road quickly. The student eats the horizon quickly. The student writes a tower happily.",
  },
  {
    locationId: "item23788",
    locationName: "item23788",
    locationAddress: "item23788",
    ratings: null,
    lat: 53.19628542150952,
    lng: -0.46671123993355046,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5788",
    tags: [],
    locationDescription:
      " A woman looks at a tower happily. The cat eats the road quickly. The cat eats a tower silently. A woman looks at the horizon gracefully. A dog looks at a book silently.",
  },
  {
    locationId: "item23789",
    locationName: "item23789",
    locationAddress: "item23789",
    ratings: [
      { who: "Similar identities", rating: 4.92 },
      { who: "All perspectives", rating: 2.56 },
    ],
    lat: 56.121206392938134,
    lng: 1.6460908324762862,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5789",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription:
      " The cat jumps over the cake happily. A dog writes a tower quickly.",
  },
  {
    locationId: "item23790",
    locationName: "item23790",
    locationAddress: "item23790",
    ratings: null,
    lat: 53.99102690540272,
    lng: -0.4422049100630261,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5790",
    tags: [],
    locationDescription:
      " A dog writes a book quickly. The cat builds the horizon gracefully.",
  },
  {
    locationId: "item23791",
    locationName: "item23791",
    locationAddress: "item23791",
    ratings: null,
    lat: 54.87401506047215,
    lng: -4.41204918052203,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5791",
    tags: [],
    locationDescription:
      " The teacher looks at a book angrily. The student eats the cake quickly. A dog eats a fence lazily.",
  },
  {
    locationId: "item23792",
    locationName: "item23792",
    locationAddress: "item23792",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 4.16 },
    ],
    lat: 58.593971233273436,
    lng: -6.334657370776949,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5792",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man looks at a tower happily. The student eats a fence silently. The man jumps over a fence silently. The student eats the horizon angrily.",
  },
  {
    locationId: "item23793",
    locationName: "item23793",
    locationAddress: "item23793",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 0.32 },
    ],
    lat: 59.85233910608541,
    lng: -8.073937414440422,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5793",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " The man writes a tower silently.",
  },
  {
    locationId: "item23794",
    locationName: "item23794",
    locationAddress: "item23794",
    ratings: null,
    lat: 53.55483931119596,
    lng: -4.806020308881605,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5794",
    tags: [],
    locationDescription:
      " The man looks at a fence lazily. The teacher jumps over a tower happily. The cat jumps over a tower lazily. A woman writes the horizon happily.",
  },
  {
    locationId: "item23795",
    locationName: "item23795",
    locationAddress: "item23795",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 4.47 },
    ],
    lat: 50.435065580365745,
    lng: -2.7836968586318642,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5795",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A woman looks at the cake gracefully.",
  },
  {
    locationId: "item23796",
    locationName: "item23796",
    locationAddress: "item23796",
    ratings: null,
    lat: 50.072695024258934,
    lng: -6.1015209539455615,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5796",
    tags: [],
    locationDescription: " The teacher looks at a book silently.",
  },
  {
    locationId: "item23797",
    locationName: "item23797",
    locationAddress: "item23797",
    ratings: [
      { who: "Similar identities", rating: 3.65 },
      { who: "All perspectives", rating: 4.0 },
    ],
    lat: 54.15237979107327,
    lng: -6.666710503308565,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5797",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman looks at the cake gracefully. A dog builds a book happily. The man builds a fence angrily. The student writes a fence happily.",
  },
  {
    locationId: "item23798",
    locationName: "item23798",
    locationAddress: "item23798",
    ratings: [
      { who: "Similar identities", rating: 0.51 },
      { who: "All perspectives", rating: 0.84 },
    ],
    lat: 51.347459696670306,
    lng: -4.709492730165072,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5798",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat eats the horizon happily. A dog writes a tower gracefully. A dog jumps over a fence quickly.",
  },
  {
    locationId: "item23799",
    locationName: "item23799",
    locationAddress: "item23799",
    ratings: null,
    lat: 52.85843404406395,
    lng: -7.425846860519281,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5799",
    tags: [],
    locationDescription:
      " The cat builds the road silently. The man writes a fence quickly. A dog jumps over the horizon happily. The man writes the road angrily. The student looks at the cake lazily.",
  },
  {
    locationId: "item23800",
    locationName: "item23800",
    locationAddress: "item23800",
    ratings: null,
    lat: 52.42813453432691,
    lng: -4.275466618625895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5800",
    tags: [],
    locationDescription:
      " The student writes the horizon angrily. A dog writes a book angrily.",
  },
  {
    locationId: "item23801",
    locationName: "item23801",
    locationAddress: "item23801",
    ratings: null,
    lat: 56.84206311555411,
    lng: -1.3053079513113444,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5801",
    tags: [],
    locationDescription:
      " The student eats a tower gracefully. A dog writes the cake gracefully.",
  },
  {
    locationId: "item23802",
    locationName: "item23802",
    locationAddress: "item23802",
    ratings: [
      { who: "Similar identities", rating: 3.16 },
      { who: "All perspectives", rating: 2.68 },
    ],
    lat: 58.04379985332534,
    lng: -0.9385467419943554,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5802",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards a tower gracefully. The man writes the road silently.",
  },
  {
    locationId: "item23803",
    locationName: "item23803",
    locationAddress: "item23803",
    ratings: [
      { who: "Similar identities", rating: 3.4 },
      { who: "All perspectives", rating: 3.82 },
    ],
    lat: 59.961341074539725,
    lng: -4.227375304945205,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5803",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman writes the horizon silently. A dog writes a fence quickly. A woman builds the horizon lazily.",
  },
  {
    locationId: "item23804",
    locationName: "item23804",
    locationAddress: "item23804",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 0.3 },
    ],
    lat: 52.727426578957456,
    lng: -1.3891259155501476,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5804",
    tags: [{ label: "lgbtq+ led" }, { label: "accessible" }],
    locationDescription:
      " The man jumps over a fence angrily. The student builds a fence silently.",
  },
  {
    locationId: "item23805",
    locationName: "item23805",
    locationAddress: "item23805",
    ratings: null,
    lat: 57.39180273175227,
    lng: -6.285962524893019,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5805",
    tags: [],
    locationDescription:
      " The student writes a fence quickly. The teacher writes a book quickly. A woman writes a book lazily.",
  },
  {
    locationId: "item23806",
    locationName: "item23806",
    locationAddress: "item23806",
    ratings: [
      { who: "Similar identities", rating: 1.32 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 59.573629919646244,
    lng: -1.337136159982152,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5806",
    tags: [{ label: "accessible" }, { label: "lgbtq+ led" }],
    locationDescription:
      " A woman builds the cake quickly. The teacher eats a tower gracefully. A dog runs towards a tower silently.",
  },
  {
    locationId: "item23807",
    locationName: "item23807",
    locationAddress: "item23807",
    ratings: null,
    lat: 58.235851708670474,
    lng: -1.5574822187701631,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5807",
    tags: [],
    locationDescription:
      " The cat eats the road silently. The teacher builds the cake quickly.",
  },
  {
    locationId: "item23808",
    locationName: "item23808",
    locationAddress: "item23808",
    ratings: null,
    lat: 51.93749049737133,
    lng: -7.934741058524906,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5808",
    tags: [],
    locationDescription: " The teacher looks at the road happily.",
  },
  {
    locationId: "item23809",
    locationName: "item23809",
    locationAddress: "item23809",
    ratings: [
      { who: "Similar identities", rating: 4.82 },
      { who: "All perspectives", rating: 4.11 },
    ],
    lat: 54.69198027101714,
    lng: -7.929741753704243,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5809",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog runs towards the road lazily. A dog builds a book silently. The cat writes the horizon silently. The man jumps over a fence gracefully.",
  },
  {
    locationId: "item23810",
    locationName: "item23810",
    locationAddress: "item23810",
    ratings: null,
    lat: 60.286469610559664,
    lng: -3.5955738278013722,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5810",
    tags: [],
    locationDescription: " A dog builds a book angrily.",
  },
  {
    locationId: "item23811",
    locationName: "item23811",
    locationAddress: "item23811",
    ratings: null,
    lat: 51.12842324947155,
    lng: -3.1771194258307744,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5811",
    tags: [],
    locationDescription:
      " The cat eats the road gracefully. A woman runs towards the road happily.",
  },
  {
    locationId: "item23812",
    locationName: "item23812",
    locationAddress: "item23812",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 55.91149461685242,
    lng: -4.792608654380185,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5812",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher writes the horizon angrily. A woman writes a tower lazily. A woman builds a tower angrily. The man eats the cake lazily. The teacher eats the road gracefully.",
  },
  {
    locationId: "item23813",
    locationName: "item23813",
    locationAddress: "item23813",
    ratings: [
      { who: "Similar identities", rating: 2.75 },
      { who: "All perspectives", rating: 3.55 },
    ],
    lat: 50.20340969079822,
    lng: -6.940594276901121,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5813",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The man jumps over a fence quickly. The cat runs towards a fence silently.",
  },
  {
    locationId: "item23814",
    locationName: "item23814",
    locationAddress: "item23814",
    ratings: [
      { who: "Similar identities", rating: 2.9 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 59.873715346583424,
    lng: -6.175031889099566,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5814",
    tags: [{ label: "accessible" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats the cake happily. The teacher builds the cake happily. A woman eats a tower angrily.",
  },
  {
    locationId: "item23815",
    locationName: "item23815",
    locationAddress: "item23815",
    ratings: [
      { who: "Similar identities", rating: 1.39 },
      { who: "All perspectives", rating: 3.97 },
    ],
    lat: 57.24345696019384,
    lng: -3.5938471530894356,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5815",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription: " The student looks at a tower quickly.",
  },
  {
    locationId: "item23816",
    locationName: "item23816",
    locationAddress: "item23816",
    ratings: [
      { who: "Similar identities", rating: 1.28 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 51.24555980598542,
    lng: 0.4108693351377628,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5816",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student runs towards the road silently. The man eats the cake quickly. The cat jumps over the road angrily. The cat writes a fence lazily. A dog builds the road gracefully.",
  },
  {
    locationId: "item23817",
    locationName: "item23817",
    locationAddress: "item23817",
    ratings: null,
    lat: 56.157719367647054,
    lng: -4.035187230201627,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5817",
    tags: [],
    locationDescription:
      " A dog eats a book angrily. The teacher eats a fence angrily. The man writes the road silently. The man writes a tower silently. The cat runs towards a fence quickly.",
  },
  {
    locationId: "item23818",
    locationName: "item23818",
    locationAddress: "item23818",
    ratings: [
      { who: "Similar identities", rating: 2.47 },
      { who: "All perspectives", rating: 0.89 },
    ],
    lat: 60.35862632548757,
    lng: -3.889914627405192,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5818",
    tags: [{ label: "trans-inclusive" }],
    locationDescription: " The teacher eats the horizon quickly.",
  },
  {
    locationId: "item23819",
    locationName: "item23819",
    locationAddress: "item23819",
    ratings: [
      { who: "Similar identities", rating: 3.99 },
      { who: "All perspectives", rating: 4.04 },
    ],
    lat: 56.71570467105802,
    lng: -0.9344150760503638,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5819",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The man builds the horizon gracefully. The man writes a fence lazily. The teacher builds the horizon gracefully.",
  },
  {
    locationId: "item23820",
    locationName: "item23820",
    locationAddress: "item23820",
    ratings: null,
    lat: 55.79153311603843,
    lng: -5.612464318875414,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5820",
    tags: [],
    locationDescription:
      " The cat writes the horizon quickly. The man writes the cake quickly. The cat writes the cake silently. The man looks at the road quickly.",
  },
  {
    locationId: "item23821",
    locationName: "item23821",
    locationAddress: "item23821",
    ratings: null,
    lat: 52.35763642674004,
    lng: -4.968634521306843,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5821",
    tags: [],
    locationDescription:
      " The man builds the road quickly. The man runs towards the road angrily. A dog builds the cake happily.",
  },
  {
    locationId: "item23822",
    locationName: "item23822",
    locationAddress: "item23822",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 3.3 },
    ],
    lat: 56.86284490496427,
    lng: -2.6316695600500015,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5822",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman runs towards the road lazily. The cat eats a tower angrily.",
  },
  {
    locationId: "item23823",
    locationName: "item23823",
    locationAddress: "item23823",
    ratings: [
      { who: "Similar identities", rating: 4.3 },
      { who: "All perspectives", rating: 0.65 },
    ],
    lat: 59.743350563218414,
    lng: -7.467460650513378,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5823",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman runs towards a fence silently. A woman runs towards a book quickly. The cat writes the horizon lazily. The student writes the road lazily. The student runs towards a tower lazily.",
  },
  {
    locationId: "item23824",
    locationName: "item23824",
    locationAddress: "item23824",
    ratings: [
      { who: "Similar identities", rating: 4.04 },
      { who: "All perspectives", rating: 4.84 },
    ],
    lat: 58.92319605406907,
    lng: -0.8711225260401374,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item5824",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The teacher jumps over a tower silently. The teacher jumps over a book quickly. A woman writes a fence lazily.",
  },
  {
    locationId: "item23825",
    locationName: "item23825",
    locationAddress: "item23825",
    ratings: null,
    lat: 50.44788993225945,
    lng: -4.841223617141958,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5825",
    tags: [],
    locationDescription: " The student looks at the road happily.",
  },
  {
    locationId: "item23826",
    locationName: "item23826",
    locationAddress: "item23826",
    ratings: [
      { who: "Similar identities", rating: 2.86 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 57.44697666742424,
    lng: -0.9967025251008543,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5826",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The teacher looks at the cake quickly. The teacher looks at a tower angrily. The student writes a book happily.",
  },
  {
    locationId: "item23827",
    locationName: "item23827",
    locationAddress: "item23827",
    ratings: null,
    lat: 51.58608398677791,
    lng: -6.062229565464113,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5827",
    tags: [],
    locationDescription:
      " The student looks at a tower gracefully. A dog builds a fence happily.",
  },
  {
    locationId: "item23828",
    locationName: "item23828",
    locationAddress: "item23828",
    ratings: null,
    lat: 58.97084040327584,
    lng: -3.5260415971170094,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5828",
    tags: [],
    locationDescription:
      " The teacher runs towards the horizon lazily. A woman jumps over the cake silently.",
  },
  {
    locationId: "item23829",
    locationName: "item23829",
    locationAddress: "item23829",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 4.42 },
    ],
    lat: 58.88130422243541,
    lng: -4.398366864317611,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5829",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The teacher writes the road lazily.",
  },
  {
    locationId: "item23830",
    locationName: "item23830",
    locationAddress: "item23830",
    ratings: [
      { who: "Similar identities", rating: 2.44 },
      { who: "All perspectives", rating: 4.85 },
    ],
    lat: 60.726270083815386,
    lng: 0.5779221450782348,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5830",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The cat jumps over the cake happily. The cat writes a tower gracefully. A woman builds a book lazily.",
  },
  {
    locationId: "item23831",
    locationName: "item23831",
    locationAddress: "item23831",
    ratings: null,
    lat: 60.49393211595141,
    lng: -2.800241050777853,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5831",
    tags: [],
    locationDescription:
      " The teacher looks at a book gracefully. The man runs towards the horizon angrily.",
  },
  {
    locationId: "item23832",
    locationName: "item23832",
    locationAddress: "item23832",
    ratings: null,
    lat: 51.358703783577184,
    lng: -6.688795092440278,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5832",
    tags: [],
    locationDescription: " The teacher looks at a fence angrily.",
  },
  {
    locationId: "item23833",
    locationName: "item23833",
    locationAddress: "item23833",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 52.122116818285164,
    lng: -2.791162589485525,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5833",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " The student writes a fence lazily. The man looks at a tower lazily. The man jumps over the horizon lazily.",
  },
  {
    locationId: "item23834",
    locationName: "item23834",
    locationAddress: "item23834",
    ratings: [
      { who: "Similar identities", rating: 0.32 },
      { who: "All perspectives", rating: 2.85 },
    ],
    lat: 54.5075480455865,
    lng: -4.067199122744683,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5834",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student builds a book silently. The teacher runs towards the road lazily. The man writes a fence angrily. A woman jumps over a tower gracefully. The student runs towards the cake lazily.",
  },
  {
    locationId: "item23835",
    locationName: "item23835",
    locationAddress: "item23835",
    ratings: [
      { who: "Similar identities", rating: 1.7 },
      { who: "All perspectives", rating: 2.6 },
    ],
    lat: 60.116714515091125,
    lng: -3.2276424876442613,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5835",
    tags: [
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The student eats a book angrily. A woman writes a book happily. The student runs towards a fence happily. The cat jumps over the horizon lazily. The cat looks at a book gracefully.",
  },
  {
    locationId: "item23836",
    locationName: "item23836",
    locationAddress: "item23836",
    ratings: null,
    lat: 55.16928779211282,
    lng: -0.2597865768161558,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5836",
    tags: [],
    locationDescription:
      " The student jumps over a book gracefully. The student writes a book quickly. The student runs towards a book quickly.",
  },
  {
    locationId: "item23837",
    locationName: "item23837",
    locationAddress: "item23837",
    ratings: [
      { who: "Similar identities", rating: 3.18 },
      { who: "All perspectives", rating: 4.11 },
    ],
    lat: 55.25797246584481,
    lng: -1.3613041666610046,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5837",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat eats the cake lazily. A woman runs towards a fence quickly. A dog eats the cake gracefully.",
  },
  {
    locationId: "item23838",
    locationName: "item23838",
    locationAddress: "item23838",
    ratings: null,
    lat: 50.103466966800006,
    lng: -4.663502594994549,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5838",
    tags: [],
    locationDescription: " The student builds the horizon gracefully.",
  },
  {
    locationId: "item23839",
    locationName: "item23839",
    locationAddress: "item23839",
    ratings: null,
    lat: 57.076076763659124,
    lng: -1.9002317142431968,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5839",
    tags: [],
    locationDescription:
      " The student writes the road happily. A dog runs towards a tower silently. A woman writes the cake angrily. The man runs towards the cake silently. The teacher runs towards the road lazily.",
  },
  {
    locationId: "item23840",
    locationName: "item23840",
    locationAddress: "item23840",
    ratings: [
      { who: "Similar identities", rating: 2.09 },
      { who: "All perspectives", rating: 3.94 },
    ],
    lat: 52.680613531279526,
    lng: -6.141191665405048,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5840",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A woman jumps over a tower quickly. The teacher jumps over a fence happily. The man builds a book happily.",
  },
  {
    locationId: "item23841",
    locationName: "item23841",
    locationAddress: "item23841",
    ratings: [
      { who: "Similar identities", rating: 4.34 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 58.276176117316915,
    lng: 1.5582675180896945,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5841",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription: " The cat looks at a fence lazily.",
  },
  {
    locationId: "item23842",
    locationName: "item23842",
    locationAddress: "item23842",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 4.06 },
    ],
    lat: 58.996420172625186,
    lng: -8.380012116329869,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5842",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards the road lazily. A dog builds a fence quickly. The cat eats the horizon gracefully. The man runs towards a book quickly. The man builds the road quickly.",
  },
  {
    locationId: "item23843",
    locationName: "item23843",
    locationAddress: "item23843",
    ratings: null,
    lat: 52.329512846588656,
    lng: -4.2811733041190605,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5843",
    tags: [],
    locationDescription: " The teacher builds the road gracefully.",
  },
  {
    locationId: "item23844",
    locationName: "item23844",
    locationAddress: "item23844",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 2.4 },
    ],
    lat: 51.39240468114402,
    lng: -2.653809132311302,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5844",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The teacher eats the cake gracefully. A dog jumps over a book silently. The man runs towards a tower gracefully.",
  },
  {
    locationId: "item23845",
    locationName: "item23845",
    locationAddress: "item23845",
    ratings: [
      { who: "Similar identities", rating: 3.37 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 53.84107185311812,
    lng: -3.621501382407046,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5845",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A dog looks at a book lazily. A woman jumps over the cake lazily.",
  },
  {
    locationId: "item23846",
    locationName: "item23846",
    locationAddress: "item23846",
    ratings: null,
    lat: 50.99475166484316,
    lng: 1.4655540672161411,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5846",
    tags: [],
    locationDescription:
      " A woman builds a tower lazily. The student jumps over the cake happily.",
  },
  {
    locationId: "item23847",
    locationName: "item23847",
    locationAddress: "item23847",
    ratings: null,
    lat: 59.67874567387888,
    lng: -8.099430763210178,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5847",
    tags: [],
    locationDescription: " The student eats a fence angrily.",
  },
  {
    locationId: "item23848",
    locationName: "item23848",
    locationAddress: "item23848",
    ratings: [
      { who: "Similar identities", rating: 3.36 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 58.928831053173475,
    lng: -3.24797549690968,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5848",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student looks at a tower quickly. A dog writes a book gracefully.",
  },
  {
    locationId: "item23849",
    locationName: "item23849",
    locationAddress: "item23849",
    ratings: [
      { who: "Similar identities", rating: 4.0 },
      { who: "All perspectives", rating: 2.83 },
    ],
    lat: 52.65591929290499,
    lng: -0.06766287298803775,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5849",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A woman writes the horizon gracefully. A woman looks at a tower angrily. The cat looks at the road lazily.",
  },
  {
    locationId: "item23850",
    locationName: "item23850",
    locationAddress: "item23850",
    ratings: null,
    lat: 60.843382767442556,
    lng: -3.269573714754169,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5850",
    tags: [],
    locationDescription:
      " The man jumps over the horizon silently. A woman looks at a fence gracefully. A woman jumps over the cake silently. The man eats the cake quickly. The student builds a tower quickly.",
  },
  {
    locationId: "item23851",
    locationName: "item23851",
    locationAddress: "item23851",
    ratings: null,
    lat: 54.795069434538775,
    lng: -7.744664461585807,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5851",
    tags: [],
    locationDescription: " A dog writes a tower angrily.",
  },
  {
    locationId: "item23852",
    locationName: "item23852",
    locationAddress: "item23852",
    ratings: null,
    lat: 58.327674261437686,
    lng: -2.501040178304393,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5852",
    tags: [],
    locationDescription:
      " A woman runs towards a tower quickly. A dog builds a book angrily.",
  },
  {
    locationId: "item23853",
    locationName: "item23853",
    locationAddress: "item23853",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 4.14 },
    ],
    lat: 59.98009729498462,
    lng: 1.3424378799767887,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5853",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat jumps over a book lazily. The student writes a book gracefully.",
  },
  {
    locationId: "item23854",
    locationName: "item23854",
    locationAddress: "item23854",
    ratings: null,
    lat: 60.202430598263504,
    lng: -3.6110804357766186,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5854",
    tags: [],
    locationDescription: " A woman runs towards the horizon lazily.",
  },
  {
    locationId: "item23855",
    locationName: "item23855",
    locationAddress: "item23855",
    ratings: [
      { who: "Similar identities", rating: 0.2 },
      { who: "All perspectives", rating: 4.76 },
    ],
    lat: 60.74948995330623,
    lng: -0.15661013485980746,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5855",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman runs towards the horizon happily.",
  },
  {
    locationId: "item23856",
    locationName: "item23856",
    locationAddress: "item23856",
    ratings: null,
    lat: 53.48276677405166,
    lng: -3.526319278601129,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5856",
    tags: [],
    locationDescription:
      " A dog builds a tower angrily. The cat builds the cake angrily.",
  },
  {
    locationId: "item23857",
    locationName: "item23857",
    locationAddress: "item23857",
    ratings: null,
    lat: 58.6786582580775,
    lng: -2.592505103945152,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5857",
    tags: [],
    locationDescription:
      " The cat looks at the horizon gracefully. A woman looks at a tower lazily. A woman eats a tower lazily.",
  },
  {
    locationId: "item23858",
    locationName: "item23858",
    locationAddress: "item23858",
    ratings: [
      { who: "Similar identities", rating: 3.35 },
      { who: "All perspectives", rating: 3.0 },
    ],
    lat: 57.91693130860989,
    lng: -6.653581205907735,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5858",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat builds a fence angrily. The teacher builds a fence happily.",
  },
  {
    locationId: "item23859",
    locationName: "item23859",
    locationAddress: "item23859",
    ratings: null,
    lat: 60.80554824495099,
    lng: -3.1231292758103253,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5859",
    tags: [],
    locationDescription: " A woman builds a tower gracefully.",
  },
  {
    locationId: "item23860",
    locationName: "item23860",
    locationAddress: "item23860",
    ratings: null,
    lat: 54.34475437603694,
    lng: -2.411598911361291,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5860",
    tags: [],
    locationDescription:
      " The student runs towards the horizon quickly. The student looks at a book gracefully.",
  },
  {
    locationId: "item23861",
    locationName: "item23861",
    locationAddress: "item23861",
    ratings: [
      { who: "Similar identities", rating: 2.3 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 60.23538914480609,
    lng: -8.395484096334396,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5861",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The man writes a fence happily. The student jumps over a tower silently. The teacher looks at the horizon quickly. The man eats the horizon quickly.",
  },
  {
    locationId: "item23862",
    locationName: "item23862",
    locationAddress: "item23862",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 1.86 },
    ],
    lat: 58.03432181137843,
    lng: -6.75268003165903,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5862",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription: " The teacher eats the cake lazily.",
  },
  {
    locationId: "item23863",
    locationName: "item23863",
    locationAddress: "item23863",
    ratings: null,
    lat: 51.54545380140684,
    lng: -0.5808913713383141,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5863",
    tags: [],
    locationDescription: " The man writes a tower gracefully.",
  },
  {
    locationId: "item23864",
    locationName: "item23864",
    locationAddress: "item23864",
    ratings: [
      { who: "Similar identities", rating: 1.98 },
      { who: "All perspectives", rating: 3.01 },
    ],
    lat: 57.94284003833376,
    lng: -0.44166183574297513,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5864",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " The man builds the horizon happily.",
  },
  {
    locationId: "item23865",
    locationName: "item23865",
    locationAddress: "item23865",
    ratings: [
      { who: "Similar identities", rating: 5.0 },
      { who: "All perspectives", rating: 1.83 },
    ],
    lat: 57.87962301042039,
    lng: -5.3228999640484425,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5865",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The cat looks at a fence angrily. A dog eats a tower angrily. The student jumps over the horizon angrily. The man runs towards the cake quickly.",
  },
  {
    locationId: "item23866",
    locationName: "item23866",
    locationAddress: "item23866",
    ratings: [
      { who: "Similar identities", rating: 2.67 },
      { who: "All perspectives", rating: 2.48 },
    ],
    lat: 58.0745035730688,
    lng: -8.175854530089056,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5866",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over the road happily. The student builds a fence gracefully.",
  },
  {
    locationId: "item23867",
    locationName: "item23867",
    locationAddress: "item23867",
    ratings: null,
    lat: 57.73260592416382,
    lng: -3.2455452875105903,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5867",
    tags: [],
    locationDescription:
      " The cat looks at the horizon silently. The student runs towards the horizon lazily. A woman runs towards the horizon silently. The cat looks at a book happily. A dog builds the road happily.",
  },
  {
    locationId: "item23868",
    locationName: "item23868",
    locationAddress: "item23868",
    ratings: null,
    lat: 53.89641083088921,
    lng: -6.3563175971568375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5868",
    tags: [],
    locationDescription:
      " The man eats a tower happily. The teacher looks at a book gracefully. The man eats a book angrily. The cat builds the horizon silently.",
  },
  {
    locationId: "item23869",
    locationName: "item23869",
    locationAddress: "item23869",
    ratings: [
      { who: "Similar identities", rating: 1.25 },
      { who: "All perspectives", rating: 4.4 },
    ],
    lat: 51.4422543324546,
    lng: -1.480667148408057,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5869",
    tags: [
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog runs towards a fence lazily. The student jumps over the cake angrily. The cat looks at the road quickly.",
  },
  {
    locationId: "item23870",
    locationName: "item23870",
    locationAddress: "item23870",
    ratings: null,
    lat: 53.17345045064622,
    lng: -5.1665473505274555,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5870",
    tags: [],
    locationDescription:
      " The student runs towards the road quickly. The teacher jumps over a fence happily. The cat writes the horizon angrily. The teacher looks at the horizon lazily.",
  },
  {
    locationId: "item23871",
    locationName: "item23871",
    locationAddress: "item23871",
    ratings: [
      { who: "Similar identities", rating: 1.56 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 54.46283411866993,
    lng: -0.7450053841658626,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5871",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The student builds the cake quickly. A dog writes the horizon angrily. The cat jumps over a fence lazily.",
  },
  {
    locationId: "item23872",
    locationName: "item23872",
    locationAddress: "item23872",
    ratings: null,
    lat: 51.68764943647827,
    lng: -6.1009351549877895,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5872",
    tags: [],
    locationDescription: " The student looks at the horizon lazily.",
  },
  {
    locationId: "item23873",
    locationName: "item23873",
    locationAddress: "item23873",
    ratings: null,
    lat: 55.96647304900846,
    lng: -8.387470487164014,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5873",
    tags: [],
    locationDescription:
      " A woman runs towards the cake silently. The student looks at a tower happily.",
  },
  {
    locationId: "item23874",
    locationName: "item23874",
    locationAddress: "item23874",
    ratings: null,
    lat: 55.223659441680816,
    lng: -7.05438307792818,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5874",
    tags: [],
    locationDescription: " The student looks at a fence angrily.",
  },
  {
    locationId: "item23875",
    locationName: "item23875",
    locationAddress: "item23875",
    ratings: [
      { who: "Similar identities", rating: 4.35 },
      { who: "All perspectives", rating: 4.49 },
    ],
    lat: 51.12970496678402,
    lng: -0.8216765322111268,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5875",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at the cake lazily. A woman builds a book silently. The cat eats the cake angrily. The cat eats a fence lazily.",
  },
  {
    locationId: "item23876",
    locationName: "item23876",
    locationAddress: "item23876",
    ratings: [
      { who: "Similar identities", rating: 1.23 },
      { who: "All perspectives", rating: 0.03 },
    ],
    lat: 53.62015182619909,
    lng: -4.481920251709487,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5876",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman jumps over the horizon silently.",
  },
  {
    locationId: "item23877",
    locationName: "item23877",
    locationAddress: "item23877",
    ratings: null,
    lat: 57.7361724379919,
    lng: -1.5574022050604723,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5877",
    tags: [],
    locationDescription:
      " A woman eats a tower silently. The student writes a fence silently.",
  },
  {
    locationId: "item23878",
    locationName: "item23878",
    locationAddress: "item23878",
    ratings: null,
    lat: 55.16220815472393,
    lng: 0.602706226680926,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5878",
    tags: [],
    locationDescription: " A dog writes the cake lazily.",
  },
  {
    locationId: "item23879",
    locationName: "item23879",
    locationAddress: "item23879",
    ratings: [
      { who: "Similar identities", rating: 0.38 },
      { who: "All perspectives", rating: 1.84 },
    ],
    lat: 53.43710287898597,
    lng: -4.271268939145812,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5879",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " A dog jumps over the cake angrily.",
  },
  {
    locationId: "item23880",
    locationName: "item23880",
    locationAddress: "item23880",
    ratings: [
      { who: "Similar identities", rating: 0.68 },
      { who: "All perspectives", rating: 3.39 },
    ],
    lat: 51.956751143528926,
    lng: -0.6782533087883964,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5880",
    tags: [{ label: "child friendly" }, { label: "accessible" }],
    locationDescription:
      " A woman jumps over a book angrily. A woman looks at the horizon gracefully. A woman looks at the cake silently. The man eats a book quickly. The student jumps over the cake angrily.",
  },
  {
    locationId: "item23881",
    locationName: "item23881",
    locationAddress: "item23881",
    ratings: null,
    lat: 58.14475168399081,
    lng: 0.9707532037809035,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5881",
    tags: [],
    locationDescription:
      " The cat builds the cake lazily. The cat writes the cake angrily. The teacher builds a tower lazily.",
  },
  {
    locationId: "item23882",
    locationName: "item23882",
    locationAddress: "item23882",
    ratings: [
      { who: "Similar identities", rating: 0.86 },
      { who: "All perspectives", rating: 1.44 },
    ],
    lat: 55.91767752184057,
    lng: -3.3667902347684944,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item5882",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The cat looks at a fence happily. The student writes the cake lazily.",
  },
  {
    locationId: "item23883",
    locationName: "item23883",
    locationAddress: "item23883",
    ratings: null,
    lat: 50.46724944299144,
    lng: -8.587343590655234,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5883",
    tags: [],
    locationDescription: " The cat writes the road happily.",
  },
  {
    locationId: "item23884",
    locationName: "item23884",
    locationAddress: "item23884",
    ratings: [
      { who: "Similar identities", rating: 4.02 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 55.12346281102845,
    lng: -3.662218274413963,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5884",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog runs towards a tower gracefully. The teacher jumps over the horizon angrily. A dog runs towards a book quickly. A dog looks at the road lazily. A woman eats the cake quickly.",
  },
  {
    locationId: "item23885",
    locationName: "item23885",
    locationAddress: "item23885",
    ratings: [
      { who: "Similar identities", rating: 0.29 },
      { who: "All perspectives", rating: 2.4 },
    ],
    lat: 58.49582583942038,
    lng: -7.550470821431728,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5885",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The cat jumps over the horizon happily. A woman builds a book lazily.",
  },
  {
    locationId: "item23886",
    locationName: "item23886",
    locationAddress: "item23886",
    ratings: null,
    lat: 52.07617271486768,
    lng: -7.123211108414215,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5886",
    tags: [],
    locationDescription:
      " The cat writes a fence lazily. The student builds a book angrily. The teacher runs towards the cake lazily. The man runs towards the road silently. The man eats a tower angrily.",
  },
  {
    locationId: "item23887",
    locationName: "item23887",
    locationAddress: "item23887",
    ratings: null,
    lat: 53.03430791154576,
    lng: -0.8243512018061852,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5887",
    tags: [],
    locationDescription: " The man runs towards the horizon gracefully.",
  },
  {
    locationId: "item23888",
    locationName: "item23888",
    locationAddress: "item23888",
    ratings: [
      { who: "Similar identities", rating: 4.91 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 54.71517889538984,
    lng: -0.6068614600674529,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5888",
    tags: [{ label: "child friendly" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher looks at the cake silently. A woman eats the road angrily. The cat eats the horizon gracefully.",
  },
  {
    locationId: "item23889",
    locationName: "item23889",
    locationAddress: "item23889",
    ratings: [
      { who: "Similar identities", rating: 1.48 },
      { who: "All perspectives", rating: 0.21 },
    ],
    lat: 55.57129370401607,
    lng: 0.9598959781386895,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5889",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher jumps over the road happily. A dog jumps over the road lazily. The cat runs towards the cake silently.",
  },
  {
    locationId: "item23890",
    locationName: "item23890",
    locationAddress: "item23890",
    ratings: null,
    lat: 51.995482039134814,
    lng: 1.1632019328174774,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5890",
    tags: [],
    locationDescription:
      " A woman looks at the horizon happily. The teacher writes a book silently. The man runs towards a fence lazily. The student writes the cake gracefully. The teacher looks at a fence quickly.",
  },
  {
    locationId: "item23891",
    locationName: "item23891",
    locationAddress: "item23891",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 1.85 },
    ],
    lat: 56.64364897851307,
    lng: 1.0029613294915762,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5891",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog jumps over the horizon angrily. The teacher writes the cake lazily. The cat writes a tower angrily.",
  },
  {
    locationId: "item23892",
    locationName: "item23892",
    locationAddress: "item23892",
    ratings: null,
    lat: 55.764002770997266,
    lng: 1.2857486769686766,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5892",
    tags: [],
    locationDescription:
      " The man looks at the cake silently. The teacher eats the cake quickly. The student looks at the road happily. A dog builds the horizon gracefully.",
  },
  {
    locationId: "item23893",
    locationName: "item23893",
    locationAddress: "item23893",
    ratings: [
      { who: "Similar identities", rating: 4.09 },
      { who: "All perspectives", rating: 4.2 },
    ],
    lat: 55.135335133967416,
    lng: -8.291599646219506,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5893",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog jumps over a fence quickly. The teacher writes the horizon lazily. The student writes the cake happily.",
  },
  {
    locationId: "item23894",
    locationName: "item23894",
    locationAddress: "item23894",
    ratings: null,
    lat: 50.820826416517804,
    lng: -1.535370783304777,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5894",
    tags: [],
    locationDescription: " The teacher eats the horizon lazily.",
  },
  {
    locationId: "item23895",
    locationName: "item23895",
    locationAddress: "item23895",
    ratings: [
      { who: "Similar identities", rating: 3.57 },
      { who: "All perspectives", rating: 1.18 },
    ],
    lat: 60.30230015903498,
    lng: -0.3927452226960906,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5895",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " The cat eats the road lazily. A dog builds the cake angrily. The man runs towards the road happily. The man eats a book angrily. The cat builds the horizon angrily.",
  },
  {
    locationId: "item23896",
    locationName: "item23896",
    locationAddress: "item23896",
    ratings: [
      { who: "Similar identities", rating: 3.19 },
      { who: "All perspectives", rating: 4.48 },
    ],
    lat: 56.46060329686599,
    lng: -0.14249019076128455,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5896",
    tags: [{ label: "trans-inclusive" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat runs towards the cake quickly. The man eats the cake gracefully. A dog eats the road quickly.",
  },
  {
    locationId: "item23897",
    locationName: "item23897",
    locationAddress: "item23897",
    ratings: null,
    lat: 53.683057902184416,
    lng: -5.451588524187228,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5897",
    tags: [],
    locationDescription:
      " The teacher builds a tower lazily. The teacher builds the cake gracefully. The man builds the road quickly. The man writes the road happily. The teacher jumps over the horizon silently.",
  },
  {
    locationId: "item23898",
    locationName: "item23898",
    locationAddress: "item23898",
    ratings: [
      { who: "Similar identities", rating: 0.38 },
      { who: "All perspectives", rating: 1.33 },
    ],
    lat: 54.77578442443772,
    lng: -6.923432007710195,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5898",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The man writes the road angrily. A woman runs towards the cake angrily. A woman runs towards a book gracefully. The man runs towards a book happily. The student builds a book gracefully.",
  },
  {
    locationId: "item23899",
    locationName: "item23899",
    locationAddress: "item23899",
    ratings: null,
    lat: 58.14213277675596,
    lng: -1.9744543611076049,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5899",
    tags: [],
    locationDescription:
      " The teacher jumps over a book quickly. The teacher runs towards a book quickly. A woman builds a tower lazily. The cat eats the road happily.",
  },
  {
    locationId: "item23900",
    locationName: "item23900",
    locationAddress: "item23900",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 2.01 },
    ],
    lat: 55.11184677071658,
    lng: -6.8042079508269175,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5900",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The cat runs towards the horizon lazily.",
  },
  {
    locationId: "item23901",
    locationName: "item23901",
    locationAddress: "item23901",
    ratings: [
      { who: "Similar identities", rating: 0.79 },
      { who: "All perspectives", rating: 3.27 },
    ],
    lat: 60.79623937512591,
    lng: -3.152646632890243,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5901",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student looks at a tower happily. The teacher jumps over the road lazily. The student looks at the cake happily. The cat builds a book lazily. The teacher jumps over a fence silently.",
  },
  {
    locationId: "item23902",
    locationName: "item23902",
    locationAddress: "item23902",
    ratings: [
      { who: "Similar identities", rating: 1.13 },
      { who: "All perspectives", rating: 4.83 },
    ],
    lat: 58.19749382554897,
    lng: -6.238537449169244,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5902",
    tags: [{ label: "accessible" }],
    locationDescription:
      " The student builds a book angrily. The man jumps over a book lazily. The teacher writes a fence happily.",
  },
  {
    locationId: "item23903",
    locationName: "item23903",
    locationAddress: "item23903",
    ratings: null,
    lat: 59.191472744068406,
    lng: -0.29610790060001513,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5903",
    tags: [],
    locationDescription:
      " A woman looks at a fence quickly. A dog eats a fence angrily.",
  },
  {
    locationId: "item23904",
    locationName: "item23904",
    locationAddress: "item23904",
    ratings: null,
    lat: 59.90412367850083,
    lng: -4.773742699723632,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5904",
    tags: [],
    locationDescription:
      " A woman looks at a fence silently. The cat eats the horizon quickly. A dog builds the road quickly. A woman builds a fence lazily. The man eats a tower happily.",
  },
  {
    locationId: "item23905",
    locationName: "item23905",
    locationAddress: "item23905",
    ratings: [
      { who: "Similar identities", rating: 1.87 },
      { who: "All perspectives", rating: 1.68 },
    ],
    lat: 54.734462863113826,
    lng: -7.329273254268407,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5905",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription: " A woman jumps over a tower quickly.",
  },
  {
    locationId: "item23906",
    locationName: "item23906",
    locationAddress: "item23906",
    ratings: [
      { who: "Similar identities", rating: 2.86 },
      { who: "All perspectives", rating: 4.63 },
    ],
    lat: 52.650910887433454,
    lng: -3.3785469048114543,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5906",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student looks at the horizon gracefully. The man builds a book happily. The cat writes the cake lazily. A dog looks at a fence lazily.",
  },
  {
    locationId: "item23907",
    locationName: "item23907",
    locationAddress: "item23907",
    ratings: null,
    lat: 55.397114168291864,
    lng: -3.61555713274375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5907",
    tags: [],
    locationDescription:
      " A woman jumps over a book gracefully. The cat builds a tower silently. The man runs towards the cake silently. A woman looks at the road silently. The cat builds the horizon happily.",
  },
  {
    locationId: "item23908",
    locationName: "item23908",
    locationAddress: "item23908",
    ratings: [
      { who: "Similar identities", rating: 1.07 },
      { who: "All perspectives", rating: 3.66 },
    ],
    lat: 54.60033151963392,
    lng: -3.7476476859312946,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5908",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A dog eats a book lazily. A dog jumps over the cake silently. The student jumps over the road angrily. The man writes the horizon angrily. The cat looks at a fence happily.",
  },
  {
    locationId: "item23909",
    locationName: "item23909",
    locationAddress: "item23909",
    ratings: [
      { who: "Similar identities", rating: 2.08 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 49.9648069972991,
    lng: 1.6114243620275879,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5909",
    tags: [{ label: "lgbtq+ led" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The cat looks at the cake happily. The student runs towards a fence angrily.",
  },
  {
    locationId: "item23910",
    locationName: "item23910",
    locationAddress: "item23910",
    ratings: null,
    lat: 54.01178661406118,
    lng: -2.770204940512886,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5910",
    tags: [],
    locationDescription: " A dog jumps over a fence quickly.",
  },
  {
    locationId: "item23911",
    locationName: "item23911",
    locationAddress: "item23911",
    ratings: null,
    lat: 58.482271750513945,
    lng: -4.735310764191505,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5911",
    tags: [],
    locationDescription: " The cat eats a tower silently.",
  },
  {
    locationId: "item23912",
    locationName: "item23912",
    locationAddress: "item23912",
    ratings: null,
    lat: 57.010573688163234,
    lng: -1.1025478209175201,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5912",
    tags: [],
    locationDescription: " A woman eats the cake happily.",
  },
  {
    locationId: "item23913",
    locationName: "item23913",
    locationAddress: "item23913",
    ratings: [
      { who: "Similar identities", rating: 3.51 },
      { who: "All perspectives", rating: 3.1 },
    ],
    lat: 57.74133062953864,
    lng: -3.3737807426492648,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5913",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The man builds a fence quickly. The teacher runs towards the cake lazily.",
  },
  {
    locationId: "item23914",
    locationName: "item23914",
    locationAddress: "item23914",
    ratings: null,
    lat: 53.47837261063154,
    lng: -7.917949629401013,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5914",
    tags: [],
    locationDescription:
      " A woman writes the cake silently. The man looks at the horizon lazily. The student builds the cake lazily. The man jumps over a fence angrily. The student builds the road happily.",
  },
  {
    locationId: "item23915",
    locationName: "item23915",
    locationAddress: "item23915",
    ratings: null,
    lat: 59.33284059456578,
    lng: -5.62104455632568,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5915",
    tags: [],
    locationDescription:
      " The cat builds the horizon lazily. The cat jumps over a book angrily. A woman looks at the road quickly. The cat writes the cake angrily. A woman eats the horizon lazily.",
  },
  {
    locationId: "item23916",
    locationName: "item23916",
    locationAddress: "item23916",
    ratings: [
      { who: "Similar identities", rating: 2.13 },
      { who: "All perspectives", rating: 2.87 },
    ],
    lat: 56.59512163760053,
    lng: -0.05463233797819811,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5916",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The cat eats the cake quickly.",
  },
  {
    locationId: "item23917",
    locationName: "item23917",
    locationAddress: "item23917",
    ratings: null,
    lat: 59.40418613769803,
    lng: -4.117352590083787,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5917",
    tags: [],
    locationDescription:
      " A woman looks at the horizon angrily. The student builds the horizon lazily. A dog runs towards a tower gracefully. The teacher writes the cake gracefully. The teacher builds a tower silently.",
  },
  {
    locationId: "item23918",
    locationName: "item23918",
    locationAddress: "item23918",
    ratings: [
      { who: "Similar identities", rating: 4.8 },
      { who: "All perspectives", rating: 4.63 },
    ],
    lat: 59.92708556032918,
    lng: -2.7743415266750775,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5918",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher runs towards the horizon gracefully. A dog writes a tower quickly. The man builds the horizon silently. The student builds the road quickly.",
  },
  {
    locationId: "item23919",
    locationName: "item23919",
    locationAddress: "item23919",
    ratings: [
      { who: "Similar identities", rating: 0.99 },
      { who: "All perspectives", rating: 2.04 },
    ],
    lat: 59.243706364087934,
    lng: 1.09600030181182,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5919",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " A dog writes a book angrily. A dog eats a tower angrily.",
  },
  {
    locationId: "item23920",
    locationName: "item23920",
    locationAddress: "item23920",
    ratings: [
      { who: "Similar identities", rating: 2.48 },
      { who: "All perspectives", rating: 0.68 },
    ],
    lat: 51.509371991545564,
    lng: -3.836383313833073,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5920",
    tags: [{ label: "lgbtq+ led" }, { label: "child friendly" }],
    locationDescription:
      " The student looks at a tower happily. A dog jumps over the cake silently. A dog looks at the road angrily. A dog builds a book quickly.",
  },
  {
    locationId: "item23921",
    locationName: "item23921",
    locationAddress: "item23921",
    ratings: [
      { who: "Similar identities", rating: 0.41 },
      { who: "All perspectives", rating: 1.29 },
    ],
    lat: 55.30164442304496,
    lng: -2.919017454506,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5921",
    tags: [{ label: "accessible" }, { label: "child friendly" }],
    locationDescription:
      " A woman eats the horizon quickly. A woman builds the road quickly. The cat eats the road gracefully. The teacher runs towards the horizon angrily.",
  },
  {
    locationId: "item23922",
    locationName: "item23922",
    locationAddress: "item23922",
    ratings: null,
    lat: 50.206942350380466,
    lng: -7.9839294956852385,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5922",
    tags: [],
    locationDescription:
      " The teacher runs towards the road angrily. The man runs towards a fence silently. The man looks at a fence happily. The cat writes a book silently. The student writes the cake silently.",
  },
  {
    locationId: "item23923",
    locationName: "item23923",
    locationAddress: "item23923",
    ratings: [
      { who: "Similar identities", rating: 1.88 },
      { who: "All perspectives", rating: 2.6 },
    ],
    lat: 59.31232868578116,
    lng: -0.9035993775140021,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5923",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " The man writes a fence gracefully. The teacher jumps over the cake quickly.",
  },
  {
    locationId: "item23924",
    locationName: "item23924",
    locationAddress: "item23924",
    ratings: [
      { who: "Similar identities", rating: 2.85 },
      { who: "All perspectives", rating: 2.75 },
    ],
    lat: 55.987440512186694,
    lng: -5.967066226968183,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5924",
    tags: [
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription: " A woman eats the horizon happily.",
  },
  {
    locationId: "item23925",
    locationName: "item23925",
    locationAddress: "item23925",
    ratings: [
      { who: "Similar identities", rating: 3.59 },
      { who: "All perspectives", rating: 2.53 },
    ],
    lat: 59.87231489102105,
    lng: -6.749780919730773,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5925",
    tags: [{ label: "trans-inclusive" }, { label: "lgbtq+ led" }],
    locationDescription:
      " The teacher writes a fence silently. A dog runs towards a tower gracefully. A woman jumps over the road lazily.",
  },
  {
    locationId: "item23926",
    locationName: "item23926",
    locationAddress: "item23926",
    ratings: [
      { who: "Similar identities", rating: 3.12 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 56.522997052159084,
    lng: -8.503818967204825,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5926",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription: " The student eats a book quickly.",
  },
  {
    locationId: "item23927",
    locationName: "item23927",
    locationAddress: "item23927",
    ratings: [
      { who: "Similar identities", rating: 4.68 },
      { who: "All perspectives", rating: 3.97 },
    ],
    lat: 55.821875588270046,
    lng: -5.072699439553347,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5927",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The cat builds the cake lazily. A woman builds a fence happily. The student eats the horizon happily. The man builds a book quickly. The cat builds the road gracefully.",
  },
  {
    locationId: "item23928",
    locationName: "item23928",
    locationAddress: "item23928",
    ratings: [
      { who: "Similar identities", rating: 0.07 },
      { who: "All perspectives", rating: 3.53 },
    ],
    lat: 56.63304378636116,
    lng: 1.186581892124888,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5928",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The cat runs towards the cake happily.",
  },
  {
    locationId: "item23929",
    locationName: "item23929",
    locationAddress: "item23929",
    ratings: [
      { who: "Similar identities", rating: 4.5 },
      { who: "All perspectives", rating: 2.12 },
    ],
    lat: 59.540528904684194,
    lng: -2.080304170140111,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5929",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The teacher jumps over the horizon lazily. The student eats a book quickly. The man runs towards a book silently.",
  },
  {
    locationId: "item23930",
    locationName: "item23930",
    locationAddress: "item23930",
    ratings: null,
    lat: 54.2880466795676,
    lng: -5.827247463036871,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5930",
    tags: [],
    locationDescription: " A woman eats the horizon quickly.",
  },
  {
    locationId: "item23931",
    locationName: "item23931",
    locationAddress: "item23931",
    ratings: [
      { who: "Similar identities", rating: 0.86 },
      { who: "All perspectives", rating: 2.85 },
    ],
    lat: 51.832578927615934,
    lng: -1.0902423629801286,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5931",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription: " A woman jumps over the cake gracefully.",
  },
  {
    locationId: "item23932",
    locationName: "item23932",
    locationAddress: "item23932",
    ratings: [
      { who: "Similar identities", rating: 1.4 },
      { who: "All perspectives", rating: 0.28 },
    ],
    lat: 54.36368488127593,
    lng: -2.535845994409601,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5932",
    tags: [
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    locationDescription: " The man writes the horizon angrily.",
  },
  {
    locationId: "item23933",
    locationName: "item23933",
    locationAddress: "item23933",
    ratings: null,
    lat: 52.604532736614125,
    lng: -4.566702025893587,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5933",
    tags: [],
    locationDescription: " The man eats a book angrily.",
  },
  {
    locationId: "item23934",
    locationName: "item23934",
    locationAddress: "item23934",
    ratings: [
      { who: "Similar identities", rating: 2.14 },
      { who: "All perspectives", rating: 4.84 },
    ],
    lat: 55.184691710580935,
    lng: -6.37333980147663,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5934",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The student eats a book silently. The cat builds a book gracefully.",
  },
  {
    locationId: "item23935",
    locationName: "item23935",
    locationAddress: "item23935",
    ratings: [
      { who: "Similar identities", rating: 2.56 },
      { who: "All perspectives", rating: 2.47 },
    ],
    lat: 58.29210189635661,
    lng: -8.303830990668558,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5935",
    tags: [{ label: "child friendly" }],
    locationDescription:
      " The teacher eats the cake lazily. A dog writes the cake happily. A woman builds the road happily. A dog builds the horizon angrily. A woman jumps over a fence gracefully.",
  },
  {
    locationId: "item23936",
    locationName: "item23936",
    locationAddress: "item23936",
    ratings: [
      { who: "Similar identities", rating: 0.45 },
      { who: "All perspectives", rating: 0.54 },
    ],
    lat: 51.41441050292851,
    lng: -6.468825662406429,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5936",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " The teacher builds the road gracefully. The cat jumps over the horizon quickly.",
  },
  {
    locationId: "item23937",
    locationName: "item23937",
    locationAddress: "item23937",
    ratings: null,
    lat: 52.805468119216144,
    lng: -2.052897868400988,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5937",
    tags: [],
    locationDescription:
      " The cat eats a book happily. The cat runs towards the horizon happily. The cat writes the road lazily. The cat jumps over the road happily. The man looks at the road quickly.",
  },
  {
    locationId: "item23938",
    locationName: "item23938",
    locationAddress: "item23938",
    ratings: null,
    lat: 51.56361357555775,
    lng: -5.091928505896998,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5938",
    tags: [],
    locationDescription: " The student runs towards a fence happily.",
  },
  {
    locationId: "item23939",
    locationName: "item23939",
    locationAddress: "item23939",
    ratings: [
      { who: "Similar identities", rating: 2.43 },
      { who: "All perspectives", rating: 2.16 },
    ],
    lat: 51.33941363335895,
    lng: -3.4885375525858207,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5939",
    tags: [
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman looks at a book quickly. A dog builds a book silently. A woman jumps over a book gracefully.",
  },
  {
    locationId: "item23940",
    locationName: "item23940",
    locationAddress: "item23940",
    ratings: null,
    lat: 52.687316191424785,
    lng: -1.281754540299083,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5940",
    tags: [],
    locationDescription:
      " The cat eats the cake gracefully. The student jumps over the horizon happily. The student jumps over the road lazily.",
  },
  {
    locationId: "item23941",
    locationName: "item23941",
    locationAddress: "item23941",
    ratings: null,
    lat: 59.993530379463024,
    lng: -2.0755079486606602,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5941",
    tags: [],
    locationDescription:
      " A woman eats the road quickly. The student eats the road angrily. The cat builds the road quickly. A woman builds a book gracefully. The cat runs towards a tower lazily.",
  },
  {
    locationId: "item23942",
    locationName: "item23942",
    locationAddress: "item23942",
    ratings: [
      { who: "Similar identities", rating: 2.65 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 51.4505312567333,
    lng: -7.721127719741933,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5942",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The teacher builds the cake silently. A dog writes a fence lazily.",
  },
  {
    locationId: "item23943",
    locationName: "item23943",
    locationAddress: "item23943",
    ratings: [
      { who: "Similar identities", rating: 0.28 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 51.40198674942136,
    lng: -0.05999333085145331,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5943",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " A woman looks at a fence silently. A woman eats the road happily. The cat runs towards the cake quickly.",
  },
  {
    locationId: "item23944",
    locationName: "item23944",
    locationAddress: "item23944",
    ratings: [
      { who: "Similar identities", rating: 3.56 },
      { who: "All perspectives", rating: 2.49 },
    ],
    lat: 59.810726579777935,
    lng: -7.109664405192595,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5944",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " The cat writes the horizon silently. The man builds the road lazily.",
  },
  {
    locationId: "item23945",
    locationName: "item23945",
    locationAddress: "item23945",
    ratings: null,
    lat: 58.27835015210438,
    lng: -4.165481944346083,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5945",
    tags: [],
    locationDescription:
      " The man jumps over a book lazily. A dog runs towards a fence silently. A woman looks at a tower silently.",
  },
  {
    locationId: "item23946",
    locationName: "item23946",
    locationAddress: "item23946",
    ratings: null,
    lat: 54.23601464631136,
    lng: 0.7553297654082218,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5946",
    tags: [],
    locationDescription:
      " The teacher builds the road lazily. A dog runs towards a fence silently. A woman looks at the road silently.",
  },
  {
    locationId: "item23947",
    locationName: "item23947",
    locationAddress: "item23947",
    ratings: [
      { who: "Similar identities", rating: 4.01 },
      { who: "All perspectives", rating: 0.56 },
    ],
    lat: 59.06256756054344,
    lng: -1.7739658128933966,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item5947",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " The student looks at a tower angrily. The student eats the road gracefully. The student eats a tower angrily. The teacher eats a fence lazily.",
  },
  {
    locationId: "item23948",
    locationName: "item23948",
    locationAddress: "item23948",
    ratings: [
      { who: "Similar identities", rating: 2.28 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 53.090258752327664,
    lng: 0.8759409519932166,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5948",
    tags: [{ label: "trans-inclusive" }, { label: "child friendly" }],
    locationDescription:
      " A dog eats a fence angrily. The teacher runs towards a book happily. The teacher writes a book happily.",
  },
  {
    locationId: "item23949",
    locationName: "item23949",
    locationAddress: "item23949",
    ratings: [
      { who: "Similar identities", rating: 3.22 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 51.80897402995923,
    lng: 0.771114120823146,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5949",
    tags: [
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    locationDescription:
      " A woman eats a book gracefully. The man eats the cake quickly. The cat looks at a book silently. The cat writes a fence quickly. The student looks at a tower angrily.",
  },
  {
    locationId: "item23950",
    locationName: "item23950",
    locationAddress: "item23950",
    ratings: [
      { who: "Similar identities", rating: 0.02 },
      { who: "All perspectives", rating: 1.81 },
    ],
    lat: 54.72178699879102,
    lng: -4.753309498611612,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5950",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription: " The cat eats a tower quickly.",
  },
  {
    locationId: "item23951",
    locationName: "item23951",
    locationAddress: "item23951",
    ratings: null,
    lat: 53.57441904988963,
    lng: -5.081165876664375,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5951",
    tags: [],
    locationDescription:
      " A dog looks at the cake lazily. The teacher builds the cake gracefully.",
  },
  {
    locationId: "item23952",
    locationName: "item23952",
    locationAddress: "item23952",
    ratings: [
      { who: "Similar identities", rating: 0.01 },
      { who: "All perspectives", rating: 0.36 },
    ],
    lat: 54.85353371945294,
    lng: -6.964159924838422,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5952",
    tags: [{ label: "child friendly" }, { label: "gender-inclusive toilets" }],
    locationDescription:
      " The student eats the horizon silently. The student jumps over a book silently. The teacher writes a tower angrily.",
  },
  {
    locationId: "item23953",
    locationName: "item23953",
    locationAddress: "item23953",
    ratings: null,
    lat: 54.176355535979106,
    lng: -6.94748370803132,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5953",
    tags: [],
    locationDescription: " A woman jumps over a fence angrily.",
  },
  {
    locationId: "item23954",
    locationName: "item23954",
    locationAddress: "item23954",
    ratings: null,
    lat: 59.909348015236006,
    lng: -2.276798924927177,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5954",
    tags: [],
    locationDescription:
      " The man eats the horizon happily. The teacher eats the road quickly. The cat runs towards the horizon lazily. The cat jumps over a tower angrily.",
  },
  {
    locationId: "item23955",
    locationName: "item23955",
    locationAddress: "item23955",
    ratings: null,
    lat: 59.68408863264255,
    lng: -3.8050039536088764,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5955",
    tags: [],
    locationDescription:
      " A woman looks at the road angrily. The cat looks at a fence quickly. The cat writes the road angrily.",
  },
  {
    locationId: "item23956",
    locationName: "item23956",
    locationAddress: "item23956",
    ratings: [
      { who: "Similar identities", rating: 1.33 },
      { who: "All perspectives", rating: 2.36 },
    ],
    lat: 56.55495091351485,
    lng: -0.7211701771272825,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5956",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman jumps over a tower silently. The teacher looks at the cake lazily. A dog jumps over the cake silently. A woman writes the road silently. A woman builds a book gracefully.",
  },
  {
    locationId: "item23957",
    locationName: "item23957",
    locationAddress: "item23957",
    ratings: null,
    lat: 59.713275589596336,
    lng: -1.3931343304164168,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5957",
    tags: [],
    locationDescription:
      " A woman jumps over the road happily. The student builds a tower quickly. A dog builds a fence gracefully. The cat looks at the cake silently. The student runs towards the cake lazily.",
  },
  {
    locationId: "item23958",
    locationName: "item23958",
    locationAddress: "item23958",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 1.48 },
    ],
    lat: 59.30844836344953,
    lng: 1.0665927732382343,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5958",
    tags: [{ label: "lgbtq+ led" }],
    locationDescription:
      " The man looks at a fence gracefully. The cat jumps over a fence happily.",
  },
  {
    locationId: "item23959",
    locationName: "item23959",
    locationAddress: "item23959",
    ratings: null,
    lat: 59.98423102310795,
    lng: -1.3405916131367732,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5959",
    tags: [],
    locationDescription:
      " The cat looks at the road gracefully. The cat looks at a fence angrily. A dog looks at the cake happily. A woman jumps over a book gracefully.",
  },
  {
    locationId: "item23960",
    locationName: "item23960",
    locationAddress: "item23960",
    ratings: [
      { who: "Similar identities", rating: 0.71 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 60.10327584945537,
    lng: -8.386730080944469,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item5960",
    tags: [{ label: "accessible" }],
    locationDescription:
      " A woman eats the road silently. The man looks at the road silently. The teacher eats the horizon silently. A woman writes the cake gracefully.",
  },
  {
    locationId: "item23961",
    locationName: "item23961",
    locationAddress: "item23961",
    ratings: null,
    lat: 51.35195513972204,
    lng: 0.8423152269667007,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5961",
    tags: [],
    locationDescription:
      " A dog runs towards a tower angrily. A dog runs towards the horizon angrily. A dog builds the horizon quickly. The teacher writes the cake silently. The man eats a fence lazily.",
  },
  {
    locationId: "item23962",
    locationName: "item23962",
    locationAddress: "item23962",
    ratings: [
      { who: "Similar identities", rating: 1.85 },
      { who: "All perspectives", rating: 2.61 },
    ],
    lat: 49.9357495045273,
    lng: -2.6835543098584207,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5962",
    tags: [
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "accessible" },
    ],
    locationDescription:
      " The student jumps over a fence gracefully. A dog writes the road happily. A dog looks at the road gracefully. The man looks at the road quickly.",
  },
  {
    locationId: "item23963",
    locationName: "item23963",
    locationAddress: "item23963",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 0.67 },
    ],
    lat: 60.82284053796471,
    lng: -5.919874189873189,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5963",
    tags: [
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher builds the road lazily. A dog builds a fence lazily.",
  },
  {
    locationId: "item23964",
    locationName: "item23964",
    locationAddress: "item23964",
    ratings: [
      { who: "Similar identities", rating: 4.38 },
      { who: "All perspectives", rating: 1.52 },
    ],
    lat: 50.31903123080315,
    lng: -1.9583283555503916,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5964",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A dog writes the road lazily. The student looks at a book happily. The teacher writes a fence happily.",
  },
  {
    locationId: "item23965",
    locationName: "item23965",
    locationAddress: "item23965",
    ratings: null,
    lat: 59.55133835705179,
    lng: -1.5082762157468448,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5965",
    tags: [],
    locationDescription: " The teacher jumps over the road happily.",
  },
  {
    locationId: "item23966",
    locationName: "item23966",
    locationAddress: "item23966",
    ratings: null,
    lat: 54.81759994644483,
    lng: -7.453476292808476,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5966",
    tags: [],
    locationDescription:
      " A dog builds a book angrily. A woman eats the cake angrily. The student writes the road gracefully. A dog jumps over the road angrily.",
  },
  {
    locationId: "item23967",
    locationName: "item23967",
    locationAddress: "item23967",
    ratings: null,
    lat: 58.075185569425216,
    lng: -5.942176279555044,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5967",
    tags: [],
    locationDescription:
      " The cat writes a book happily. A woman eats the road quickly. A dog eats a fence lazily. A woman looks at a tower lazily.",
  },
  {
    locationId: "item23968",
    locationName: "item23968",
    locationAddress: "item23968",
    ratings: [
      { who: "Similar identities", rating: 0.03 },
      { who: "All perspectives", rating: 4.46 },
    ],
    lat: 54.638015352578925,
    lng: -5.432434702928765,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5968",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    locationDescription:
      " The man looks at the road lazily. The cat runs towards a book gracefully.",
  },
  {
    locationId: "item23969",
    locationName: "item23969",
    locationAddress: "item23969",
    ratings: null,
    lat: 51.953833934470936,
    lng: -5.978749038118618,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5969",
    tags: [],
    locationDescription:
      " The teacher writes a tower lazily. The teacher jumps over the road gracefully.",
  },
  {
    locationId: "item23970",
    locationName: "item23970",
    locationAddress: "item23970",
    ratings: null,
    lat: 50.77653825039013,
    lng: -4.338333099845212,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5970",
    tags: [],
    locationDescription:
      " The man eats a tower angrily. A woman runs towards the road angrily. The cat writes the cake silently.",
  },
  {
    locationId: "item23971",
    locationName: "item23971",
    locationAddress: "item23971",
    ratings: null,
    lat: 57.97083387144491,
    lng: -4.43110517347308,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5971",
    tags: [],
    locationDescription:
      " The man looks at a tower lazily. The student builds the road quickly. A dog runs towards the road happily. The teacher looks at a fence angrily. A dog writes the horizon quickly.",
  },
  {
    locationId: "item23972",
    locationName: "item23972",
    locationAddress: "item23972",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 0.07 },
    ],
    lat: 54.53389790937906,
    lng: -7.473256638977142,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5972",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    locationDescription:
      " A dog looks at a fence angrily. The student jumps over the road angrily. The cat writes a fence silently. The student eats a fence lazily.",
  },
  {
    locationId: "item23973",
    locationName: "item23973",
    locationAddress: "item23973",
    ratings: null,
    lat: 53.74159923916449,
    lng: 0.27877156994864016,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5973",
    tags: [],
    locationDescription:
      " The teacher looks at the horizon gracefully. A dog looks at a fence angrily. A woman writes the road silently. The teacher runs towards the horizon angrily. A dog jumps over a fence angrily.",
  },
  {
    locationId: "item23974",
    locationName: "item23974",
    locationAddress: "item23974",
    ratings: [
      { who: "Similar identities", rating: 4.89 },
      { who: "All perspectives", rating: 2.65 },
    ],
    lat: 51.34722067519242,
    lng: -3.534093066705098,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5974",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " A woman writes the cake angrily. A woman eats a tower quickly. A woman writes a tower lazily.",
  },
  {
    locationId: "item23975",
    locationName: "item23975",
    locationAddress: "item23975",
    ratings: null,
    lat: 49.961021217990734,
    lng: -0.44835893029039653,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item5975",
    tags: [],
    locationDescription:
      " A woman writes the horizon silently. A woman builds the horizon quickly.",
  },
  {
    locationId: "item23976",
    locationName: "item23976",
    locationAddress: "item23976",
    ratings: [
      { who: "Similar identities", rating: 0.32 },
      { who: "All perspectives", rating: 3.51 },
    ],
    lat: 60.43531205703965,
    lng: -4.7588771236273,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5976",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    locationDescription: " The student jumps over the cake angrily.",
  },
  {
    locationId: "item23977",
    locationName: "item23977",
    locationAddress: "item23977",
    ratings: [
      { who: "Similar identities", rating: 0.81 },
      { who: "All perspectives", rating: 1.38 },
    ],
    lat: 50.059302743219895,
    lng: -1.5895908869718962,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5977",
    tags: [
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The teacher jumps over a book quickly. The teacher builds the road quickly.",
  },
  {
    locationId: "item23978",
    locationName: "item23978",
    locationAddress: "item23978",
    ratings: [
      { who: "Similar identities", rating: 4.61 },
      { who: "All perspectives", rating: 4.24 },
    ],
    lat: 50.81094400119745,
    lng: -3.5766546083314044,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item5978",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    locationDescription:
      " A woman looks at a book gracefully. A dog builds a tower silently. The cat runs towards a fence lazily.",
  },
  {
    locationId: "item23979",
    locationName: "item23979",
    locationAddress: "item23979",
    ratings: null,
    lat: 60.16920838511311,
    lng: -7.693114592915297,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5979",
    tags: [],
    locationDescription:
      " A woman looks at a tower quickly. A dog eats a book gracefully. The student runs towards the horizon quickly. A woman runs towards a tower angrily.",
  },
  {
    locationId: "item23980",
    locationName: "item23980",
    locationAddress: "item23980",
    ratings: null,
    lat: 56.64514285646816,
    lng: -7.113151131952373,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5980",
    tags: [],
    locationDescription:
      " The teacher looks at the road quickly. The man eats a book silently. The cat jumps over a fence angrily. A dog builds a tower lazily. A woman builds a book lazily.",
  },
  {
    locationId: "item23981",
    locationName: "item23981",
    locationAddress: "item23981",
    ratings: [
      { who: "Similar identities", rating: 0.04 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 59.771103428173454,
    lng: 0.27871742349657325,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item5981",
    tags: [
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The cat looks at the cake gracefully. The student looks at the cake gracefully.",
  },
  {
    locationId: "item23982",
    locationName: "item23982",
    locationAddress: "item23982",
    ratings: null,
    lat: 58.355151193885845,
    lng: -5.754194524877043,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item5982",
    tags: [],
    locationDescription:
      " The cat looks at a fence gracefully. A dog runs towards the cake lazily. A woman writes a tower silently. A woman looks at the cake quickly. A woman looks at the horizon silently.",
  },
  {
    locationId: "item23983",
    locationName: "item23983",
    locationAddress: "item23983",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 0.52 },
    ],
    lat: 53.741525037369186,
    lng: 1.090361870547099,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5983",
    tags: [{ label: "trans-inclusive" }],
    locationDescription:
      " A woman runs towards the horizon lazily. The cat jumps over a fence silently. The man eats a tower quickly.",
  },
  {
    locationId: "item23984",
    locationName: "item23984",
    locationAddress: "item23984",
    ratings: [
      { who: "Similar identities", rating: 0.23 },
      { who: "All perspectives", rating: 2.52 },
    ],
    lat: 51.949832156459976,
    lng: -1.4450146149993524,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5984",
    tags: [
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " A dog jumps over the horizon gracefully. The teacher runs towards a book angrily.",
  },
  {
    locationId: "item23985",
    locationName: "item23985",
    locationAddress: "item23985",
    ratings: null,
    lat: 59.162476021026144,
    lng: -2.9795257828679844,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5985",
    tags: [],
    locationDescription:
      " A woman builds a tower lazily. The cat looks at a fence lazily.",
  },
  {
    locationId: "item23986",
    locationName: "item23986",
    locationAddress: "item23986",
    ratings: [
      { who: "Similar identities", rating: 4.61 },
      { who: "All perspectives", rating: 4.89 },
    ],
    lat: 56.847799907985404,
    lng: 1.1188282976791033,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5986",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " A dog writes the horizon gracefully. The cat writes the road happily.",
  },
  {
    locationId: "item23987",
    locationName: "item23987",
    locationAddress: "item23987",
    ratings: null,
    lat: 57.87404726972095,
    lng: -1.366525129783886,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item5987",
    tags: [],
    locationDescription:
      " A dog builds the cake lazily. The student runs towards the road quickly. A woman eats a tower angrily.",
  },
  {
    locationId: "item23988",
    locationName: "item23988",
    locationAddress: "item23988",
    ratings: [
      { who: "Similar identities", rating: 0.14 },
      { who: "All perspectives", rating: 0.91 },
    ],
    lat: 54.95827705417296,
    lng: -7.255014767143523,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item5988",
    tags: [{ label: "trans-inclusive" }, { label: "accessible" }],
    locationDescription: " A dog jumps over the horizon quickly.",
  },
  {
    locationId: "item23989",
    locationName: "item23989",
    locationAddress: "item23989",
    ratings: null,
    lat: 59.30932821790942,
    lng: -4.340751354505922,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item5989",
    tags: [],
    locationDescription:
      " The teacher looks at the cake lazily. The cat runs towards a fence quickly. The cat runs towards the road quickly.",
  },
  {
    locationId: "item23990",
    locationName: "item23990",
    locationAddress: "item23990",
    ratings: [
      { who: "Similar identities", rating: 3.01 },
      { who: "All perspectives", rating: 1.5 },
    ],
    lat: 53.83821183691416,
    lng: 1.5519476393688336,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item5990",
    tags: [{ label: "gender-inclusive toilets" }],
    locationDescription:
      " The student jumps over the road lazily. A woman runs towards a book quickly. A woman runs towards the cake angrily. The student eats a tower angrily. The student runs towards the horizon silently.",
  },
  {
    locationId: "item23991",
    locationName: "item23991",
    locationAddress: "item23991",
    ratings: null,
    lat: 53.59166923295113,
    lng: -4.34916155655301,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5991",
    tags: [],
    locationDescription:
      " The man writes the cake lazily. The cat writes the road silently. The teacher jumps over a tower happily. The teacher eats the cake silently. The student runs towards a fence gracefully.",
  },
  {
    locationId: "item23992",
    locationName: "item23992",
    locationAddress: "item23992",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 2.13 },
    ],
    lat: 56.44405484098268,
    lng: -7.221338252500198,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item5992",
    tags: [{ label: "accessible" }],
    locationDescription: " A woman runs towards the horizon quickly.",
  },
  {
    locationId: "item23993",
    locationName: "item23993",
    locationAddress: "item23993",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 55.57473210618448,
    lng: -4.527014643500171,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item5993",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "gender-inclusive toilets" },
    ],
    locationDescription:
      " The man runs towards the road lazily. The man jumps over the horizon silently. The student builds the road quickly.",
  },
  {
    locationId: "item23994",
    locationName: "item23994",
    locationAddress: "item23994",
    ratings: null,
    lat: 59.59190216531018,
    lng: -0.5482773432131065,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item5994",
    tags: [],
    locationDescription: " The cat eats the road quickly.",
  },
  {
    locationId: "item23995",
    locationName: "item23995",
    locationAddress: "item23995",
    ratings: [
      { who: "Similar identities", rating: 4.29 },
      { who: "All perspectives", rating: 2.0 },
    ],
    lat: 51.0794245933963,
    lng: 1.1839778588786753,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item5995",
    tags: [
      { label: "accessible" },
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The teacher jumps over a book angrily. The student looks at a fence lazily. The student looks at the cake lazily. The cat runs towards a fence happily.",
  },
  {
    locationId: "item23996",
    locationName: "item23996",
    locationAddress: "item23996",
    ratings: [
      { who: "Similar identities", rating: 2.52 },
      { who: "All perspectives", rating: 4.84 },
    ],
    lat: 50.47892436883802,
    lng: -7.495050750090802,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item5996",
    tags: [
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    locationDescription:
      " The student jumps over the horizon gracefully. The teacher looks at a book gracefully.",
  },
  {
    locationId: "item23997",
    locationName: "item23997",
    locationAddress: "item23997",
    ratings: null,
    lat: 51.08452976931115,
    lng: -0.7207194731455582,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5997",
    tags: [],
    locationDescription:
      " The cat writes the cake lazily. The teacher eats a book quickly. The cat jumps over the horizon quickly.",
  },
  {
    locationId: "item23998",
    locationName: "item23998",
    locationAddress: "item23998",
    ratings: [
      { who: "Similar identities", rating: 4.2 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 54.77975891113335,
    lng: -3.8407012307578636,
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item5998",
    tags: [
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The cat jumps over the road happily. A woman looks at a fence happily. The man eats a tower lazily. The teacher jumps over the horizon angrily.",
  },
  {
    locationId: "item23999",
    locationName: "item23999",
    locationAddress: "item23999",
    ratings: [
      { who: "Similar identities", rating: 0.28 },
      { who: "All perspectives", rating: 4.98 },
    ],
    lat: 50.54640189474284,
    lng: -3.626719225752238,
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item5999",
    tags: [
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    locationDescription:
      " The man eats a tower silently. A dog runs towards a book silently. The cat runs towards the horizon angrily. A woman runs towards the horizon silently. The student builds a fence angrily.",
  },
  {
    locationId: "item24000",
    locationName: "item24000",
    locationAddress: "item24000",
    ratings: null,
    lat: 52.50985770555877,
    lng: 0.9767243303782145,
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item6000",
    tags: [],
    locationDescription: " The cat jumps over a fence silently.",
  },
];

export const dummyBathroomData = [
  {
    locationId: "item2001",
    locationName: "Gender-inclusive bathroom 2001",
    locationAddress: "item2001",
    ratings: [
      { who: "Similar identities", rating: 3.62 },
      { who: "All perspectives", rating: 1.15 },
    ],
    lat: 53.47160015141009,
    lng: -2.4437175025975693,
    color: "orange",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2001",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2002",
    locationName: "Gender-inclusive bathroom 2002",
    locationAddress: "item2002",
    ratings: null,
    lat: 53.4180905400456,
    lng: -2.448089729301972,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2003",
    locationName: "Gender-inclusive bathroom 2003",
    locationAddress: "item2003",
    ratings: [
      { who: "Similar identities", rating: 1.98 },
      { who: "All perspectives", rating: 0.83 },
    ],
    lat: 53.46551016394913,
    lng: -2.3842930025843905,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2003",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2004",
    locationName: "Gender-inclusive bathroom 2004",
    locationAddress: "item2004",
    ratings: [
      { who: "Similar identities", rating: 1.52 },
      { who: "All perspectives", rating: 3.16 },
    ],
    lat: 53.40530072891661,
    lng: -2.457550751298372,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2004",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2005",
    locationName: "Gender-inclusive bathroom 2005",
    locationAddress: "item2005",
    ratings: null,
    lat: 53.34459028266137,
    lng: -2.4302423255323644,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "accessible" },
      { label: "unisex" },
      { label: "has-changing-table" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2006",
    locationName: "Gender-inclusive bathroom 2006",
    locationAddress: "item2006",
    ratings: [
      { who: "Similar identities", rating: 0.62 },
      { who: "All perspectives", rating: 3.36 },
    ],
    lat: 53.34745133688948,
    lng: -2.4485366068494465,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2006",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2007",
    locationName: "Gender-inclusive bathroom 2007",
    locationAddress: "item2007",
    ratings: [
      { who: "Similar identities", rating: 0.53 },
      { who: "All perspectives", rating: 0.49 },
    ],
    lat: 53.461963177012734,
    lng: -2.41182480785832,
    color: "orange",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2007",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2008",
    locationName: "Gender-inclusive bathroom 2008",
    locationAddress: "item2008",
    ratings: null,
    lat: 53.39911564747541,
    lng: -2.4512702479432207,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2009",
    locationName: "Gender-inclusive bathroom 2009",
    locationAddress: "item2009",
    ratings: null,
    lat: 53.45451278102835,
    lng: -2.3149605549101278,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2010",
    locationName: "Gender-inclusive bathroom 2010",
    locationAddress: "item2010",
    ratings: [
      { who: "Similar identities", rating: 0.2 },
      { who: "All perspectives", rating: 1.99 },
    ],
    lat: 53.344283129191595,
    lng: -2.3874098481731134,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2010",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2011",
    locationName: "Gender-inclusive bathroom 2011",
    locationAddress: "item2011",
    ratings: null,
    lat: 53.4760186635613,
    lng: -2.419749436562655,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2012",
    locationName: "Gender-inclusive bathroom 2012",
    locationAddress: "item2012",
    ratings: null,
    lat: 53.4499607677143,
    lng: -2.4314985577963117,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2013",
    locationName: "Gender-inclusive bathroom 2013",
    locationAddress: "item2013",
    ratings: null,
    lat: 53.34443467637967,
    lng: -2.3280886081377004,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2014",
    locationName: "Gender-inclusive bathroom 2014",
    locationAddress: "item2014",
    ratings: [
      { who: "Similar identities", rating: 4.53 },
      { who: "All perspectives", rating: 4.93 },
    ],
    lat: 53.427510930319265,
    lng: -2.3356779384732915,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2014",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2015",
    locationName: "Gender-inclusive bathroom 2015",
    locationAddress: "item2015",
    ratings: null,
    lat: 53.40755001345639,
    lng: -2.418028332474776,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2016",
    locationName: "Gender-inclusive bathroom 2016",
    locationAddress: "item2016",
    ratings: null,
    lat: 53.349410645235366,
    lng: -2.4179933760908185,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2017",
    locationName: "Gender-inclusive bathroom 2017",
    locationAddress: "item2017",
    ratings: null,
    lat: 53.406895661064866,
    lng: -2.445665161923408,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2018",
    locationName: "Gender-inclusive bathroom 2018",
    locationAddress: "item2018",
    ratings: null,
    lat: 53.39190280408599,
    lng: -2.320143103515029,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2019",
    locationName: "Gender-inclusive bathroom 2019",
    locationAddress: "item2019",
    ratings: null,
    lat: 53.40444115182368,
    lng: -2.326978425565991,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2020",
    locationName: "Gender-inclusive bathroom 2020",
    locationAddress: "item2020",
    ratings: [
      { who: "Similar identities", rating: 4.35 },
      { who: "All perspectives", rating: 3.21 },
    ],
    lat: 53.468386908496655,
    lng: -2.3314893984446003,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2020",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2021",
    locationName: "Gender-inclusive bathroom 2021",
    locationAddress: "item2021",
    ratings: null,
    lat: 53.34471482459704,
    lng: -2.4305910385831586,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2022",
    locationName: "Gender-inclusive bathroom 2022",
    locationAddress: "item2022",
    ratings: [
      { who: "Similar identities", rating: 0.7 },
      { who: "All perspectives", rating: 3.26 },
    ],
    lat: 53.41183957918913,
    lng: -2.4249694739700622,
    color: "brown",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2022",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2023",
    locationName: "Gender-inclusive bathroom 2023",
    locationAddress: "item2023",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 53.352371430795024,
    lng: -2.383787139420781,
    color: "orange",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2023",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2024",
    locationName: "Gender-inclusive bathroom 2024",
    locationAddress: "item2024",
    ratings: [
      { who: "Similar identities", rating: 3.84 },
      { who: "All perspectives", rating: 2.04 },
    ],
    lat: 53.42901831923634,
    lng: -2.3148988184190387,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2024",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2025",
    locationName: "Gender-inclusive bathroom 2025",
    locationAddress: "item2025",
    ratings: [
      { who: "Similar identities", rating: 1.27 },
      { who: "All perspectives", rating: 2.28 },
    ],
    lat: 53.475575155830484,
    lng: -2.46006288671509,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2025",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2026",
    locationName: "Gender-inclusive bathroom 2026",
    locationAddress: "item2026",
    ratings: [
      { who: "Similar identities", rating: 4.63 },
      { who: "All perspectives", rating: 3.5 },
    ],
    lat: 53.34818454072113,
    lng: -2.389093908829805,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2026",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2027",
    locationName: "Gender-inclusive bathroom 2027",
    locationAddress: "item2027",
    ratings: [
      { who: "Similar identities", rating: 4.9 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 53.489795096373584,
    lng: -2.4669366690436645,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2027",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2028",
    locationName: "Gender-inclusive bathroom 2028",
    locationAddress: "item2028",
    ratings: null,
    lat: 53.37440340396455,
    lng: -2.3418996282236924,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2029",
    locationName: "Gender-inclusive bathroom 2029",
    locationAddress: "item2029",
    ratings: [
      { who: "Similar identities", rating: 4.57 },
      { who: "All perspectives", rating: 4.36 },
    ],
    lat: 53.381841596166126,
    lng: -2.4584859492824864,
    color: "blue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2029",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2030",
    locationName: "Gender-inclusive bathroom 2030",
    locationAddress: "item2030",
    ratings: null,
    lat: 53.336769741163806,
    lng: -2.35208464644555,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2031",
    locationName: "Gender-inclusive bathroom 2031",
    locationAddress: "item2031",
    ratings: [
      { who: "Similar identities", rating: 4.73 },
      { who: "All perspectives", rating: 3.99 },
    ],
    lat: 53.42908441030684,
    lng: -2.3199883669309838,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2031",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2032",
    locationName: "Gender-inclusive bathroom 2032",
    locationAddress: "item2032",
    ratings: [
      { who: "Similar identities", rating: 4.47 },
      { who: "All perspectives", rating: 2.05 },
    ],
    lat: 53.381389548569786,
    lng: -2.3743920310435613,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2032",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2033",
    locationName: "Gender-inclusive bathroom 2033",
    locationAddress: "item2033",
    ratings: [
      { who: "Similar identities", rating: 1.78 },
      { who: "All perspectives", rating: 0.8 },
    ],
    lat: 53.47872601056514,
    lng: -2.3890171346203997,
    color: "purple",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2033",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2034",
    locationName: "Gender-inclusive bathroom 2034",
    locationAddress: "item2034",
    ratings: null,
    lat: 53.39009942561656,
    lng: -2.3849955610265616,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2035",
    locationName: "Gender-inclusive bathroom 2035",
    locationAddress: "item2035",
    ratings: null,
    lat: 53.48385017975336,
    lng: -2.467315345909749,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "accessible" },
      { label: "has-changing-table" },
      { label: "unisex" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2036",
    locationName: "Gender-inclusive bathroom 2036",
    locationAddress: "item2036",
    ratings: null,
    lat: 53.40320703651191,
    lng: -2.445462500345814,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2037",
    locationName: "Gender-inclusive bathroom 2037",
    locationAddress: "item2037",
    ratings: [
      { who: "Similar identities", rating: 4.61 },
      { who: "All perspectives", rating: 0.16 },
    ],
    lat: 53.39848725804828,
    lng: -2.3315008944969353,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Performance Venues",
    mapboxId: "item2037",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2038",
    locationName: "Gender-inclusive bathroom 2038",
    locationAddress: "item2038",
    ratings: [
      { who: "Similar identities", rating: 2.22 },
      { who: "All perspectives", rating: 1.06 },
    ],
    lat: 53.35209371183496,
    lng: -2.3213308564925095,
    color: "orange",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2038",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2039",
    locationName: "Gender-inclusive bathroom 2039",
    locationAddress: "item2039",
    ratings: [
      { who: "Similar identities", rating: 3.44 },
      { who: "All perspectives", rating: 1.97 },
    ],
    lat: 53.46069433932589,
    lng: -2.3161217625950643,
    color: "red",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2039",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2040",
    locationName: "Gender-inclusive bathroom 2040",
    locationAddress: "item2040",
    ratings: null,
    lat: 53.36580196240465,
    lng: -2.368692267143722,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "accessible" },
      { label: "has-changing-table" },
      { label: "unisex" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2041",
    locationName: "Gender-inclusive bathroom 2041",
    locationAddress: "item2041",
    ratings: null,
    lat: 53.418586790060694,
    lng: -2.414078373439308,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2042",
    locationName: "Gender-inclusive bathroom 2042",
    locationAddress: "item2042",
    ratings: [
      { who: "Similar identities", rating: 3.27 },
      { who: "All perspectives", rating: 0.57 },
    ],
    lat: 53.480802044379026,
    lng: -2.3532297855474638,
    color: "blue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Food Services",
    mapboxId: "item2042",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2043",
    locationName: "Gender-inclusive bathroom 2043",
    locationAddress: "item2043",
    ratings: null,
    lat: 53.40257340541034,
    lng: -2.4123298093069727,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2044",
    locationName: "Gender-inclusive bathroom 2044",
    locationAddress: "item2044",
    ratings: null,
    lat: 53.40301961860043,
    lng: -2.4410009468223937,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "unisex" },
      { label: "has-changing-table" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2045",
    locationName: "Gender-inclusive bathroom 2045",
    locationAddress: "item2045",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 3.76 },
    ],
    lat: 53.44146176926745,
    lng: -2.4113289645724674,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2045",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2046",
    locationName: "Gender-inclusive bathroom 2046",
    locationAddress: "item2046",
    ratings: [
      { who: "Similar identities", rating: 4.84 },
      { who: "All perspectives", rating: 2.32 },
    ],
    lat: 53.34190032619234,
    lng: -2.343879025756285,
    color: "red",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2046",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2047",
    locationName: "Gender-inclusive bathroom 2047",
    locationAddress: "item2047",
    ratings: null,
    lat: 53.43293387341448,
    lng: -2.4085270151440996,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2048",
    locationName: "Gender-inclusive bathroom 2048",
    locationAddress: "item2048",
    ratings: null,
    lat: 53.427471749881136,
    lng: -2.447893804994759,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2049",
    locationName: "Gender-inclusive bathroom 2049",
    locationAddress: "item2049",
    ratings: null,
    lat: 53.431469651152575,
    lng: -2.4066285932095983,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2050",
    locationName: "Gender-inclusive bathroom 2050",
    locationAddress: "item2050",
    ratings: null,
    lat: 53.36229005543788,
    lng: -2.3403856336134066,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2051",
    locationName: "Gender-inclusive bathroom 2051",
    locationAddress: "item2051",
    ratings: null,
    lat: 53.37653521923354,
    lng: -2.4644458701072027,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2052",
    locationName: "Gender-inclusive bathroom 2052",
    locationAddress: "item2052",
    ratings: [
      { who: "Similar identities", rating: 4.71 },
      { who: "All perspectives", rating: 0.05 },
    ],
    lat: 53.40344168152495,
    lng: -2.3230557591733154,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2052",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2053",
    locationName: "Gender-inclusive bathroom 2053",
    locationAddress: "item2053",
    ratings: [
      { who: "Similar identities", rating: 1.72 },
      { who: "All perspectives", rating: 0.02 },
    ],
    lat: 53.4395575515695,
    lng: -2.4143301742091565,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2053",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2054",
    locationName: "Gender-inclusive bathroom 2054",
    locationAddress: "item2054",
    ratings: null,
    lat: 53.46533931310325,
    lng: -2.3892534929725047,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2055",
    locationName: "Gender-inclusive bathroom 2055",
    locationAddress: "item2055",
    ratings: [
      { who: "Similar identities", rating: 1.85 },
      { who: "All perspectives", rating: 1.03 },
    ],
    lat: 53.40510883666904,
    lng: -2.39445756170249,
    color: "black",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2055",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2056",
    locationName: "Gender-inclusive bathroom 2056",
    locationAddress: "item2056",
    ratings: null,
    lat: 53.417165441379026,
    lng: -2.4450605822941376,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2057",
    locationName: "Gender-inclusive bathroom 2057",
    locationAddress: "item2057",
    ratings: null,
    lat: 53.377532105919514,
    lng: -2.335179690668476,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2058",
    locationName: "Gender-inclusive bathroom 2058",
    locationAddress: "item2058",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 4.69 },
    ],
    lat: 53.39795935781886,
    lng: -2.334957884872597,
    color: "orange",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2058",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2059",
    locationName: "Gender-inclusive bathroom 2059",
    locationAddress: "item2059",
    ratings: [
      { who: "Similar identities", rating: 4.31 },
      { who: "All perspectives", rating: 2.6 },
    ],
    lat: 53.33528630267593,
    lng: -2.3419346014956206,
    color: "blue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2059",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2060",
    locationName: "Gender-inclusive bathroom 2060",
    locationAddress: "item2060",
    ratings: [
      { who: "Similar identities", rating: 1.49 },
      { who: "All perspectives", rating: 2.12 },
    ],
    lat: 53.43553435026879,
    lng: -2.404999091109789,
    color: "pink",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2060",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2061",
    locationName: "Gender-inclusive bathroom 2061",
    locationAddress: "item2061",
    ratings: null,
    lat: 53.38488937979583,
    lng: -2.3423470713805297,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2062",
    locationName: "Gender-inclusive bathroom 2062",
    locationAddress: "item2062",
    ratings: null,
    lat: 53.37991578466185,
    lng: -2.3145804778963326,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "has-changing-table" },
      { label: "unisex" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2063",
    locationName: "Gender-inclusive bathroom 2063",
    locationAddress: "item2063",
    ratings: null,
    lat: 53.48848810125241,
    lng: -2.400628370334444,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2064",
    locationName: "Gender-inclusive bathroom 2064",
    locationAddress: "item2064",
    ratings: null,
    lat: 53.430005397855865,
    lng: -2.4502796893361096,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2065",
    locationName: "Gender-inclusive bathroom 2065",
    locationAddress: "item2065",
    ratings: [
      { who: "Similar identities", rating: 3.69 },
      { who: "All perspectives", rating: 3.73 },
    ],
    lat: 53.33811388345229,
    lng: -2.320578796603928,
    color: "lightblue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2065",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2066",
    locationName: "Gender-inclusive bathroom 2066",
    locationAddress: "item2066",
    ratings: null,
    lat: 53.34176380745521,
    lng: -2.454022132309682,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2067",
    locationName: "Gender-inclusive bathroom 2067",
    locationAddress: "item2067",
    ratings: null,
    lat: 53.46070548363733,
    lng: -2.379222838321555,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2068",
    locationName: "Gender-inclusive bathroom 2068",
    locationAddress: "item2068",
    ratings: [
      { who: "Similar identities", rating: 0.28 },
      { who: "All perspectives", rating: 1.62 },
    ],
    lat: 53.445672020524185,
    lng: -2.4168648422474095,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2068",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2069",
    locationName: "Gender-inclusive bathroom 2069",
    locationAddress: "item2069",
    ratings: [
      { who: "Similar identities", rating: 2.2 },
      { who: "All perspectives", rating: 0.1 },
    ],
    lat: 53.3654222062774,
    lng: -2.421724740548415,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2069",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2070",
    locationName: "Gender-inclusive bathroom 2070",
    locationAddress: "item2070",
    ratings: null,
    lat: 53.47472308392664,
    lng: -2.4469354280920914,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2071",
    locationName: "Gender-inclusive bathroom 2071",
    locationAddress: "item2071",
    ratings: null,
    lat: 53.39924110267432,
    lng: -2.411249058896095,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2072",
    locationName: "Gender-inclusive bathroom 2072",
    locationAddress: "item2072",
    ratings: null,
    lat: 53.48925518004173,
    lng: -2.329581032310513,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2073",
    locationName: "Gender-inclusive bathroom 2073",
    locationAddress: "item2073",
    ratings: null,
    lat: 53.390159592853585,
    lng: -2.320201899132782,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2074",
    locationName: "Gender-inclusive bathroom 2074",
    locationAddress: "item2074",
    ratings: [
      { who: "Similar identities", rating: 1.69 },
      { who: "All perspectives", rating: 1.53 },
    ],
    lat: 53.35057656861002,
    lng: -2.4179248700892773,
    color: "red",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2074",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2075",
    locationName: "Gender-inclusive bathroom 2075",
    locationAddress: "item2075",
    ratings: null,
    lat: 53.45440740502773,
    lng: -2.397271458649798,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2076",
    locationName: "Gender-inclusive bathroom 2076",
    locationAddress: "item2076",
    ratings: [
      { who: "Similar identities", rating: 3.1 },
      { who: "All perspectives", rating: 3.78 },
    ],
    lat: 53.35469726815051,
    lng: -2.3772104714277305,
    color: "orange",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2076",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2077",
    locationName: "Gender-inclusive bathroom 2077",
    locationAddress: "item2077",
    ratings: null,
    lat: 53.420657108141434,
    lng: -2.3493472834873543,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "has-changing-table" },
      { label: "unisex" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2078",
    locationName: "Gender-inclusive bathroom 2078",
    locationAddress: "item2078",
    ratings: null,
    lat: 53.40533570144356,
    lng: -2.4334367217487083,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2079",
    locationName: "Gender-inclusive bathroom 2079",
    locationAddress: "item2079",
    ratings: null,
    lat: 53.36463543821791,
    lng: -2.3126429146994494,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2080",
    locationName: "Gender-inclusive bathroom 2080",
    locationAddress: "item2080",
    ratings: [
      { who: "Similar identities", rating: 3.53 },
      { who: "All perspectives", rating: 1.42 },
    ],
    lat: 53.473590422667854,
    lng: -2.4106164961935015,
    color: "red",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2080",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2081",
    locationName: "Gender-inclusive bathroom 2081",
    locationAddress: "item2081",
    ratings: null,
    lat: 53.34847241086058,
    lng: -2.4133881858186137,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2082",
    locationName: "Gender-inclusive bathroom 2082",
    locationAddress: "item2082",
    ratings: [
      { who: "Similar identities", rating: 3.5 },
      { who: "All perspectives", rating: 4.8 },
    ],
    lat: 53.37036057250726,
    lng: -2.319902178125159,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2082",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2083",
    locationName: "Gender-inclusive bathroom 2083",
    locationAddress: "item2083",
    ratings: null,
    lat: 53.35674268705951,
    lng: -2.360567985201066,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2084",
    locationName: "Gender-inclusive bathroom 2084",
    locationAddress: "item2084",
    ratings: [
      { who: "Similar identities", rating: 4.68 },
      { who: "All perspectives", rating: 1.34 },
    ],
    lat: 53.478292295035914,
    lng: -2.3458015389991345,
    color: "red",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2084",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2085",
    locationName: "Gender-inclusive bathroom 2085",
    locationAddress: "item2085",
    ratings: [
      { who: "Similar identities", rating: 2.12 },
      { who: "All perspectives", rating: 2.02 },
    ],
    lat: 53.46438548173868,
    lng: -2.4370333795048835,
    color: "pink",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Festivals & Events",
    mapboxId: "item2085",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2086",
    locationName: "Gender-inclusive bathroom 2086",
    locationAddress: "item2086",
    ratings: null,
    lat: 53.43793768201807,
    lng: -2.340534556791666,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2087",
    locationName: "Gender-inclusive bathroom 2087",
    locationAddress: "item2087",
    ratings: [
      { who: "Similar identities", rating: 2.74 },
      { who: "All perspectives", rating: 2.27 },
    ],
    lat: 53.35416359507867,
    lng: -2.313118632134547,
    color: "black",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2087",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2088",
    locationName: "Gender-inclusive bathroom 2088",
    locationAddress: "item2088",
    ratings: null,
    lat: 53.41402388131221,
    lng: -2.3476273035015214,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2089",
    locationName: "Gender-inclusive bathroom 2089",
    locationAddress: "item2089",
    ratings: null,
    lat: 53.38999209390398,
    lng: -2.4342054646347386,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2090",
    locationName: "Gender-inclusive bathroom 2090",
    locationAddress: "item2090",
    ratings: [
      { who: "Similar identities", rating: 0.88 },
      { who: "All perspectives", rating: 0.92 },
    ],
    lat: 53.37600521860737,
    lng: -2.383925549388843,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2090",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2091",
    locationName: "Gender-inclusive bathroom 2091",
    locationAddress: "item2091",
    ratings: null,
    lat: 53.37998717109471,
    lng: -2.3619787796587732,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2092",
    locationName: "Gender-inclusive bathroom 2092",
    locationAddress: "item2092",
    ratings: [
      { who: "Similar identities", rating: 1.43 },
      { who: "All perspectives", rating: 1.13 },
    ],
    lat: 53.46871425071187,
    lng: -2.4547780128415195,
    color: "orange",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2092",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2093",
    locationName: "Gender-inclusive bathroom 2093",
    locationAddress: "item2093",
    ratings: null,
    lat: 53.369765224628395,
    lng: -2.3463550793187475,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2094",
    locationName: "Gender-inclusive bathroom 2094",
    locationAddress: "item2094",
    ratings: [
      { who: "Similar identities", rating: 1.75 },
      { who: "All perspectives", rating: 2.92 },
    ],
    lat: 53.34847777527214,
    lng: -2.39804641234098,
    color: "orange",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2094",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2095",
    locationName: "Gender-inclusive bathroom 2095",
    locationAddress: "item2095",
    ratings: [
      { who: "Similar identities", rating: 4.77 },
      { who: "All perspectives", rating: 2.93 },
    ],
    lat: 53.42682472194061,
    lng: -2.3229625675610954,
    color: "black",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Online Entertainment",
    mapboxId: "item2095",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2096",
    locationName: "Gender-inclusive bathroom 2096",
    locationAddress: "item2096",
    ratings: null,
    lat: 53.484644405000125,
    lng: -2.417983840715192,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "has-changing-table" },
      { label: "accessible" },
      { label: "unisex" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2097",
    locationName: "Gender-inclusive bathroom 2097",
    locationAddress: "item2097",
    ratings: null,
    lat: 53.38756882969874,
    lng: -2.3213813219326314,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2098",
    locationName: "Gender-inclusive bathroom 2098",
    locationAddress: "item2098",
    ratings: [
      { who: "Similar identities", rating: 0.44 },
      { who: "All perspectives", rating: 3.44 },
    ],
    lat: 53.34422369907971,
    lng: -2.317120300439218,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2098",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2099",
    locationName: "Gender-inclusive bathroom 2099",
    locationAddress: "item2099",
    ratings: null,
    lat: 53.457696788368835,
    lng: -2.3847446522082794,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2100",
    locationName: "Gender-inclusive bathroom 2100",
    locationAddress: "item2100",
    ratings: [
      { who: "Similar identities", rating: 3.24 },
      { who: "All perspectives", rating: 3.74 },
    ],
    lat: 53.368616466649215,
    lng: -2.4344947902459,
    color: "red",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2100",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2101",
    locationName: "Gender-inclusive bathroom 2101",
    locationAddress: "item2101",
    ratings: [
      { who: "Similar identities", rating: 3.48 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 53.374864881749154,
    lng: -2.4326306370124753,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2101",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2102",
    locationName: "Gender-inclusive bathroom 2102",
    locationAddress: "item2102",
    ratings: [
      { who: "Similar identities", rating: 0.53 },
      { who: "All perspectives", rating: 0.97 },
    ],
    lat: 53.388678185093355,
    lng: -2.4062319746035534,
    color: "purple",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2102",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2103",
    locationName: "Gender-inclusive bathroom 2103",
    locationAddress: "item2103",
    ratings: null,
    lat: 53.364009735174825,
    lng: -2.399622268342496,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2104",
    locationName: "Gender-inclusive bathroom 2104",
    locationAddress: "item2104",
    ratings: [
      { who: "Similar identities", rating: 1.08 },
      { who: "All perspectives", rating: 3.59 },
    ],
    lat: 53.420027908162226,
    lng: -2.3839331960604326,
    color: "black",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2104",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2105",
    locationName: "Gender-inclusive bathroom 2105",
    locationAddress: "item2105",
    ratings: null,
    lat: 53.44584283742034,
    lng: -2.3848179395340465,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2106",
    locationName: "Gender-inclusive bathroom 2106",
    locationAddress: "item2106",
    ratings: null,
    lat: 53.42683224509224,
    lng: -2.4511479657119337,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2107",
    locationName: "Gender-inclusive bathroom 2107",
    locationAddress: "item2107",
    ratings: null,
    lat: 53.341101845659644,
    lng: -2.4386721096160398,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2108",
    locationName: "Gender-inclusive bathroom 2108",
    locationAddress: "item2108",
    ratings: null,
    lat: 53.38652769242078,
    lng: -2.328239493461154,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2109",
    locationName: "Gender-inclusive bathroom 2109",
    locationAddress: "item2109",
    ratings: null,
    lat: 53.37463062143744,
    lng: -2.389738210553947,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "has-changing-table" },
      { label: "accessible" },
      { label: "unisex" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2110",
    locationName: "Gender-inclusive bathroom 2110",
    locationAddress: "item2110",
    ratings: null,
    lat: 53.413645124751746,
    lng: -2.460245369555966,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2111",
    locationName: "Gender-inclusive bathroom 2111",
    locationAddress: "item2111",
    ratings: [
      { who: "Similar identities", rating: 4.06 },
      { who: "All perspectives", rating: 0.15 },
    ],
    lat: 53.408040058014954,
    lng: -2.346387443459473,
    color: "blue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2111",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2112",
    locationName: "Gender-inclusive bathroom 2112",
    locationAddress: "item2112",
    ratings: [
      { who: "Similar identities", rating: 3.2 },
      { who: "All perspectives", rating: 2.14 },
    ],
    lat: 53.33699367576621,
    lng: -2.3233360903659044,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2112",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2113",
    locationName: "Gender-inclusive bathroom 2113",
    locationAddress: "item2113",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 1.76 },
    ],
    lat: 53.43721122165214,
    lng: -2.3272303241517003,
    color: "red",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2113",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2114",
    locationName: "Gender-inclusive bathroom 2114",
    locationAddress: "item2114",
    ratings: [
      { who: "Similar identities", rating: 2.59 },
      { who: "All perspectives", rating: 4.59 },
    ],
    lat: 53.351506114863184,
    lng: -2.416209790499458,
    color: "blue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2114",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2115",
    locationName: "Gender-inclusive bathroom 2115",
    locationAddress: "item2115",
    ratings: null,
    lat: 53.341576625647605,
    lng: -2.433381640913516,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2116",
    locationName: "Gender-inclusive bathroom 2116",
    locationAddress: "item2116",
    ratings: [
      { who: "Similar identities", rating: 1.83 },
      { who: "All perspectives", rating: 0.62 },
    ],
    lat: 53.38108188282381,
    lng: -2.444853091646746,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2116",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2117",
    locationName: "Gender-inclusive bathroom 2117",
    locationAddress: "item2117",
    ratings: null,
    lat: 53.34407438498792,
    lng: -2.4580394546362405,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2118",
    locationName: "Gender-inclusive bathroom 2118",
    locationAddress: "item2118",
    ratings: null,
    lat: 53.458920186209504,
    lng: -2.4392192857177037,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2119",
    locationName: "Gender-inclusive bathroom 2119",
    locationAddress: "item2119",
    ratings: [
      { who: "Similar identities", rating: 2.38 },
      { who: "All perspectives", rating: 3.23 },
    ],
    lat: 53.33768700621381,
    lng: -2.3962993658641625,
    color: "purple",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Performance Venues",
    mapboxId: "item2119",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2120",
    locationName: "Gender-inclusive bathroom 2120",
    locationAddress: "item2120",
    ratings: [
      { who: "Similar identities", rating: 0.38 },
      { who: "All perspectives", rating: 1.75 },
    ],
    lat: 53.363176151057885,
    lng: -2.3393017545184436,
    color: "orange",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2120",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2121",
    locationName: "Gender-inclusive bathroom 2121",
    locationAddress: "item2121",
    ratings: null,
    lat: 53.41445325162077,
    lng: -2.4220975830544798,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2122",
    locationName: "Gender-inclusive bathroom 2122",
    locationAddress: "item2122",
    ratings: [
      { who: "Similar identities", rating: 4.22 },
      { who: "All perspectives", rating: 3.8 },
    ],
    lat: 53.374388691968576,
    lng: -2.3356184021843105,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2122",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2123",
    locationName: "Gender-inclusive bathroom 2123",
    locationAddress: "item2123",
    ratings: null,
    lat: 53.36538262306448,
    lng: -2.443386823732725,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2124",
    locationName: "Gender-inclusive bathroom 2124",
    locationAddress: "item2124",
    ratings: null,
    lat: 53.36527474088686,
    lng: -2.3585530364243636,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2125",
    locationName: "Gender-inclusive bathroom 2125",
    locationAddress: "item2125",
    ratings: null,
    lat: 53.385327570071475,
    lng: -2.396849326778415,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2126",
    locationName: "Gender-inclusive bathroom 2126",
    locationAddress: "item2126",
    ratings: [
      { who: "Similar identities", rating: 3.81 },
      { who: "All perspectives", rating: 4.62 },
    ],
    lat: 53.432103670790696,
    lng: -2.426700072385163,
    color: "pink",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2126",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2127",
    locationName: "Gender-inclusive bathroom 2127",
    locationAddress: "item2127",
    ratings: [
      { who: "Similar identities", rating: 3.86 },
      { who: "All perspectives", rating: 2.79 },
    ],
    lat: 53.431663440918186,
    lng: -2.3454859031218853,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2127",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2128",
    locationName: "Gender-inclusive bathroom 2128",
    locationAddress: "item2128",
    ratings: null,
    lat: 53.41034983598851,
    lng: -2.4056618139117,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2129",
    locationName: "Gender-inclusive bathroom 2129",
    locationAddress: "item2129",
    ratings: [
      { who: "Similar identities", rating: 3.55 },
      { who: "All perspectives", rating: 4.14 },
    ],
    lat: 53.439539993832284,
    lng: -2.3707019820954707,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Entertainment",
    mapboxId: "item2129",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2130",
    locationName: "Gender-inclusive bathroom 2130",
    locationAddress: "item2130",
    ratings: null,
    lat: 53.43363104696026,
    lng: -2.404022190914947,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2131",
    locationName: "Gender-inclusive bathroom 2131",
    locationAddress: "item2131",
    ratings: null,
    lat: 53.469222702453486,
    lng: -2.3774452254962917,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2132",
    locationName: "Gender-inclusive bathroom 2132",
    locationAddress: "item2132",
    ratings: [
      { who: "Similar identities", rating: 1.21 },
      { who: "All perspectives", rating: 1.68 },
    ],
    lat: 53.463268217015,
    lng: -2.3372786133071464,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Museums & Art Galleries",
    mapboxId: "item2132",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2133",
    locationName: "Gender-inclusive bathroom 2133",
    locationAddress: "item2133",
    ratings: null,
    lat: 53.47730091381043,
    lng: -2.415791291532752,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2134",
    locationName: "Gender-inclusive bathroom 2134",
    locationAddress: "item2134",
    ratings: [
      { who: "Similar identities", rating: 0.74 },
      { who: "All perspectives", rating: 4.56 },
    ],
    lat: 53.487912479131715,
    lng: -2.378301445097182,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2134",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2135",
    locationName: "Gender-inclusive bathroom 2135",
    locationAddress: "item2135",
    ratings: [
      { who: "Similar identities", rating: 4.98 },
      { who: "All perspectives", rating: 2.27 },
    ],
    lat: 53.435634583202216,
    lng: -2.3177441902611307,
    color: "black",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2135",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2136",
    locationName: "Gender-inclusive bathroom 2136",
    locationAddress: "item2136",
    ratings: [
      { who: "Similar identities", rating: 2.96 },
      { who: "All perspectives", rating: 1.93 },
    ],
    lat: 53.466155005790206,
    lng: -2.4361250418786287,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Hotels, Hostels, B&Bs",
    mapboxId: "item2136",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2137",
    locationName: "Gender-inclusive bathroom 2137",
    locationAddress: "item2137",
    ratings: [
      { who: "Similar identities", rating: 3.08 },
      { who: "All perspectives", rating: 2.42 },
    ],
    lat: 53.37367804190701,
    lng: -2.422914985894074,
    color: "orange",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2137",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2138",
    locationName: "Gender-inclusive bathroom 2138",
    locationAddress: "item2138",
    ratings: null,
    lat: 53.45752274842349,
    lng: -2.4673279629496414,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2139",
    locationName: "Gender-inclusive bathroom 2139",
    locationAddress: "item2139",
    ratings: [
      { who: "Similar identities", rating: 2.73 },
      { who: "All perspectives", rating: 0.44 },
    ],
    lat: 53.348588814009425,
    lng: -2.3774906404844875,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2139",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2140",
    locationName: "Gender-inclusive bathroom 2140",
    locationAddress: "item2140",
    ratings: null,
    lat: 53.34904968265714,
    lng: -2.369226488601707,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2141",
    locationName: "Gender-inclusive bathroom 2141",
    locationAddress: "item2141",
    ratings: null,
    lat: 53.49058391169917,
    lng: -2.4191294470543827,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2142",
    locationName: "Gender-inclusive bathroom 2142",
    locationAddress: "item2142",
    ratings: null,
    lat: 53.427269484933085,
    lng: -2.336791160623422,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2143",
    locationName: "Gender-inclusive bathroom 2143",
    locationAddress: "item2143",
    ratings: [
      { who: "Similar identities", rating: 2.69 },
      { who: "All perspectives", rating: 4.22 },
    ],
    lat: 53.38833059828369,
    lng: -2.438729244112383,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Online Food Services",
    mapboxId: "item2143",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2144",
    locationName: "Gender-inclusive bathroom 2144",
    locationAddress: "item2144",
    ratings: null,
    lat: 53.365219876696074,
    lng: -2.3150527239559904,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2145",
    locationName: "Gender-inclusive bathroom 2145",
    locationAddress: "item2145",
    ratings: null,
    lat: 53.4875090043498,
    lng: -2.3292391649983015,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2146",
    locationName: "Gender-inclusive bathroom 2146",
    locationAddress: "item2146",
    ratings: [
      { who: "Similar identities", rating: 2.77 },
      { who: "All perspectives", rating: 0.69 },
    ],
    lat: 53.47469522705398,
    lng: -2.4178428762259694,
    color: "blue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2146",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2147",
    locationName: "Gender-inclusive bathroom 2147",
    locationAddress: "item2147",
    ratings: null,
    lat: 53.343333191825295,
    lng: -2.399405884366784,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2148",
    locationName: "Gender-inclusive bathroom 2148",
    locationAddress: "item2148",
    ratings: [
      { who: "Similar identities", rating: 3.31 },
      { who: "All perspectives", rating: 1.74 },
    ],
    lat: 53.350925021889324,
    lng: -2.381533521752894,
    color: "black",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Festivals & Events",
    mapboxId: "item2148",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2149",
    locationName: "Gender-inclusive bathroom 2149",
    locationAddress: "item2149",
    ratings: null,
    lat: 53.42289610451162,
    lng: -2.440038258772899,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2150",
    locationName: "Gender-inclusive bathroom 2150",
    locationAddress: "item2150",
    ratings: null,
    lat: 53.37842379136843,
    lng: -2.4620346826483734,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2151",
    locationName: "Gender-inclusive bathroom 2151",
    locationAddress: "item2151",
    ratings: [
      { who: "Similar identities", rating: 3.8 },
      { who: "All perspectives", rating: 1.81 },
    ],
    lat: 53.4175466991651,
    lng: -2.42022564273144,
    color: "purple",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2151",
    tags: [{ label: "gender-inclusive toilets" }, { label: "lgbtq+ led" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2152",
    locationName: "Gender-inclusive bathroom 2152",
    locationAddress: "item2152",
    ratings: [
      { who: "Similar identities", rating: 4.1 },
      { who: "All perspectives", rating: 1.28 },
    ],
    lat: 53.381736495859336,
    lng: -2.456355790293469,
    color: "purple",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2152",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2153",
    locationName: "Gender-inclusive bathroom 2153",
    locationAddress: "item2153",
    ratings: [
      { who: "Similar identities", rating: 0.36 },
      { who: "All perspectives", rating: 2.45 },
    ],
    lat: 53.47077532198199,
    lng: -2.386306859549898,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Breweries & Wineries",
    mapboxId: "item2153",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2154",
    locationName: "Gender-inclusive bathroom 2154",
    locationAddress: "item2154",
    ratings: null,
    lat: 53.370841190187924,
    lng: -2.416857555281909,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2155",
    locationName: "Gender-inclusive bathroom 2155",
    locationAddress: "item2155",
    ratings: null,
    lat: 53.35433263537833,
    lng: -2.3156988198650645,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2156",
    locationName: "Gender-inclusive bathroom 2156",
    locationAddress: "item2156",
    ratings: null,
    lat: 53.48308515899207,
    lng: -2.3312180635312,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2157",
    locationName: "Gender-inclusive bathroom 2157",
    locationAddress: "item2157",
    ratings: [
      { who: "Similar identities", rating: 2.03 },
      { who: "All perspectives", rating: 3.44 },
    ],
    lat: 53.392071152773994,
    lng: -2.4305765283479643,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2157",
    tags: [{ label: "gender-inclusive toilets" }, { label: "trans-inclusive" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2158",
    locationName: "Gender-inclusive bathroom 2158",
    locationAddress: "item2158",
    ratings: null,
    lat: 53.486702431239976,
    lng: -2.3248308675656144,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2159",
    locationName: "Gender-inclusive bathroom 2159",
    locationAddress: "item2159",
    ratings: [
      { who: "Similar identities", rating: 4.52 },
      { who: "All perspectives", rating: 1.74 },
    ],
    lat: 53.48020790904669,
    lng: -2.342400044370106,
    color: "green",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Artists",
    mapboxId: "item2159",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "accessible" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2160",
    locationName: "Gender-inclusive bathroom 2160",
    locationAddress: "item2160",
    ratings: [
      { who: "Similar identities", rating: 1.06 },
      { who: "All perspectives", rating: 4.3 },
    ],
    lat: 53.46515725397653,
    lng: -2.4328701306075105,
    color: "brown",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2160",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2161",
    locationName: "Gender-inclusive bathroom 2161",
    locationAddress: "item2161",
    ratings: [
      { who: "Similar identities", rating: 1.12 },
      { who: "All perspectives", rating: 3.29 },
    ],
    lat: 53.447471709840194,
    lng: -2.3653569424227134,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2161",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2162",
    locationName: "Gender-inclusive bathroom 2162",
    locationAddress: "item2162",
    ratings: [
      { who: "Similar identities", rating: 0.89 },
      { who: "All perspectives", rating: 0.77 },
    ],
    lat: 53.369886144852515,
    lng: -2.313072630587679,
    color: "green",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Artists",
    mapboxId: "item2162",
    tags: [{ label: "gender-inclusive toilets" }, { label: "child friendly" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2163",
    locationName: "Gender-inclusive bathroom 2163",
    locationAddress: "item2163",
    ratings: [
      { who: "Similar identities", rating: 0.86 },
      { who: "All perspectives", rating: 4.68 },
    ],
    lat: 53.448027991449706,
    lng: -2.4343810873535694,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2163",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2164",
    locationName: "Gender-inclusive bathroom 2164",
    locationAddress: "item2164",
    ratings: [
      { who: "Similar identities", rating: 0.39 },
      { who: "All perspectives", rating: 2.73 },
    ],
    lat: 53.36815315874543,
    lng: -2.4476583476421037,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Attractions",
    mapboxId: "item2164",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2165",
    locationName: "Gender-inclusive bathroom 2165",
    locationAddress: "item2165",
    ratings: null,
    lat: 53.443016408047654,
    lng: -2.463541314839109,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2166",
    locationName: "Gender-inclusive bathroom 2166",
    locationAddress: "item2166",
    ratings: null,
    lat: 53.37856910584642,
    lng: -2.41276307977902,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2167",
    locationName: "Gender-inclusive bathroom 2167",
    locationAddress: "item2167",
    ratings: [
      { who: "Similar identities", rating: 1.97 },
      { who: "All perspectives", rating: 0.5 },
    ],
    lat: 53.38756964477702,
    lng: -2.4164976112635106,
    color: "black",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bakeries & Food Stores",
    mapboxId: "item2167",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2168",
    locationName: "Gender-inclusive bathroom 2168",
    locationAddress: "item2168",
    ratings: null,
    lat: 53.42301365800589,
    lng: -2.409753887758866,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2169",
    locationName: "Gender-inclusive bathroom 2169",
    locationAddress: "item2169",
    ratings: null,
    lat: 53.372408590138804,
    lng: -2.3757692169190343,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2170",
    locationName: "Gender-inclusive bathroom 2170",
    locationAddress: "item2170",
    ratings: null,
    lat: 53.36633132445345,
    lng: -2.4052855913300566,
    color: "pink",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2171",
    locationName: "Gender-inclusive bathroom 2171",
    locationAddress: "item2171",
    ratings: null,
    lat: 53.41777775062355,
    lng: -2.459824779061015,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2172",
    locationName: "Gender-inclusive bathroom 2172",
    locationAddress: "item2172",
    ratings: null,
    lat: 53.37017170927031,
    lng: -2.3279440628184416,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2173",
    locationName: "Gender-inclusive bathroom 2173",
    locationAddress: "item2173",
    ratings: null,
    lat: 53.34585627586563,
    lng: -2.4608076936406174,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2174",
    locationName: "Gender-inclusive bathroom 2174",
    locationAddress: "item2174",
    ratings: [
      { who: "Similar identities", rating: 3.6 },
      { who: "All perspectives", rating: 1.92 },
    ],
    lat: 53.36474937291044,
    lng: -2.34430186869956,
    color: "red",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Bars & Nightclubs",
    mapboxId: "item2174",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "accessible" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2175",
    locationName: "Gender-inclusive bathroom 2175",
    locationAddress: "item2175",
    ratings: null,
    lat: 53.391094302870556,
    lng: -2.367258335636466,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2176",
    locationName: "Gender-inclusive bathroom 2176",
    locationAddress: "item2176",
    ratings: null,
    lat: 53.49077400423072,
    lng: -2.4193868341118194,
    color: "orange",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2177",
    locationName: "Gender-inclusive bathroom 2177",
    locationAddress: "item2177",
    ratings: null,
    lat: 53.4061616035312,
    lng: -2.4436245520424804,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2178",
    locationName: "Gender-inclusive bathroom 2178",
    locationAddress: "item2178",
    ratings: null,
    lat: 53.339198433729266,
    lng: -2.39712860409842,
    color: "blue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2179",
    locationName: "Gender-inclusive bathroom 2179",
    locationAddress: "item2179",
    ratings: null,
    lat: 53.4692201535918,
    lng: -2.3531596656157325,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [
      { label: "has-changing-table" },
      { label: "accessible" },
      { label: "unisex" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2180",
    locationName: "Gender-inclusive bathroom 2180",
    locationAddress: "item2180",
    ratings: null,
    lat: 53.39932349747631,
    lng: -2.401582617004702,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2181",
    locationName: "Gender-inclusive bathroom 2181",
    locationAddress: "item2181",
    ratings: [
      { who: "Similar identities", rating: 3.71 },
      { who: "All perspectives", rating: 3.34 },
    ],
    lat: 53.44741951391574,
    lng: -2.360826411593179,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2181",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2182",
    locationName: "Gender-inclusive bathroom 2182",
    locationAddress: "item2182",
    ratings: null,
    lat: 53.400479102865944,
    lng: -2.452811885765835,
    color: "purple",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2183",
    locationName: "Gender-inclusive bathroom 2183",
    locationAddress: "item2183",
    ratings: [
      { who: "Similar identities", rating: 2.04 },
      { who: "All perspectives", rating: 1.98 },
    ],
    lat: 53.34898429662936,
    lng: -2.359311990064998,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2183",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
      { label: "trans-inclusive" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2184",
    locationName: "Gender-inclusive bathroom 2184",
    locationAddress: "item2184",
    ratings: [
      { who: "Similar identities", rating: 1.77 },
      { who: "All perspectives", rating: 4.82 },
    ],
    lat: 53.3742341993537,
    lng: -2.343753199818959,
    color: "lightblue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Attractions",
    mapboxId: "item2184",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2185",
    locationName: "Gender-inclusive bathroom 2185",
    locationAddress: "item2185",
    ratings: null,
    lat: 53.356554859125865,
    lng: -2.381815081132037,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2186",
    locationName: "Gender-inclusive bathroom 2186",
    locationAddress: "item2186",
    ratings: null,
    lat: 53.43403911936866,
    lng: -2.41043517460348,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2187",
    locationName: "Gender-inclusive bathroom 2187",
    locationAddress: "item2187",
    ratings: [
      { who: "Similar identities", rating: 1.58 },
      { who: "All perspectives", rating: 0.82 },
    ],
    lat: 53.35160469934176,
    lng: -2.389516714661289,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Parks & Recreation Areas",
    mapboxId: "item2187",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2188",
    locationName: "Gender-inclusive bathroom 2188",
    locationAddress: "item2188",
    ratings: [
      { who: "Similar identities", rating: 1.44 },
      { who: "All perspectives", rating: 4.07 },
    ],
    lat: 53.43094291375618,
    lng: -2.4078967683485364,
    color: "brown",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2188",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "lgbtq+ led" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2189",
    locationName: "Gender-inclusive bathroom 2189",
    locationAddress: "item2189",
    ratings: [
      { who: "Similar identities", rating: 0.37 },
      { who: "All perspectives", rating: 2.89 },
    ],
    lat: 53.40578401793627,
    lng: -2.399450143245039,
    color: "lightblue",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Gaming & Arcades",
    mapboxId: "item2189",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "trans-inclusive" },
      { label: "child friendly" },
      { label: "lgbtq+ led" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2190",
    locationName: "Gender-inclusive bathroom 2190",
    locationAddress: "item2190",
    ratings: null,
    lat: 53.33638086239984,
    lng: -2.3225407585173214,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2191",
    locationName: "Gender-inclusive bathroom 2191",
    locationAddress: "item2191",
    ratings: null,
    lat: 53.37641556755358,
    lng: -2.415005166865704,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2192",
    locationName: "Gender-inclusive bathroom 2192",
    locationAddress: "item2192",
    ratings: [
      { who: "Similar identities", rating: 3.92 },
      { who: "All perspectives", rating: 1.64 },
    ],
    lat: 53.38615093432455,
    lng: -2.4623724269237512,
    color: "pink",
    isCertified: false,
    isShaneLocation: true,
    isPromoted: false,
    locationCategory: "Sports & Clubs",
    mapboxId: "item2192",
    tags: [{ label: "gender-inclusive toilets" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2193",
    locationName: "Gender-inclusive bathroom 2193",
    locationAddress: "item2193",
    ratings: null,
    lat: 53.4113497615662,
    lng: -2.3246103808644616,
    color: "lightblue",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2194",
    locationName: "Gender-inclusive bathroom 2194",
    locationAddress: "item2194",
    ratings: null,
    lat: 53.45712397031245,
    lng: -2.3193127790434627,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2195",
    locationName: "Gender-inclusive bathroom 2195",
    locationAddress: "item2195",
    ratings: null,
    lat: 53.34449611309177,
    lng: -2.3173832452905283,
    color: "red",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2196",
    locationName: "Gender-inclusive bathroom 2196",
    locationAddress: "item2196",
    ratings: null,
    lat: 53.34953702558644,
    lng: -2.467460939477312,
    color: "green",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "unisex" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2197",
    locationName: "Gender-inclusive bathroom 2197",
    locationAddress: "item2197",
    ratings: null,
    lat: 53.43688103475521,
    lng: -2.4247994434753917,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "accessible" }, { label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2198",
    locationName: "Gender-inclusive bathroom 2198",
    locationAddress: "item2198",
    ratings: [
      { who: "Similar identities", rating: 2.8 },
      { who: "All perspectives", rating: 3.41 },
    ],
    lat: 53.40456237872225,
    lng: -2.328571581203049,
    color: "purple",
    isCertified: true,
    isShaneLocation: true,
    isPromoted: true,
    locationCategory: "Restaurants & Coffee Shops",
    mapboxId: "item2198",
    tags: [
      { label: "gender-inclusive toilets" },
      { label: "child friendly" },
      { label: "accessible" },
    ],
    notes: "Position: behind till\nComments: for paying customers",
    source: null,
  },
  {
    locationId: "item2199",
    locationName: "Gender-inclusive bathroom 2199",
    locationAddress: "item2199",
    ratings: null,
    lat: 53.344061983458765,
    lng: -2.3703554076606483,
    color: "black",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
  {
    locationId: "item2200",
    locationName: "Gender-inclusive bathroom 2200",
    locationAddress: "item2200",
    ratings: null,
    lat: 53.33749911222273,
    lng: -2.3288712433466383,
    color: "brown",
    isCertified: false,
    isShaneLocation: false,
    isPromoted: false,
    locationCategory: "Gender-Inclusive Toilets",
    mapboxId: "",
    tags: [{ label: "has-changing-table" }, { label: "accessible" }],
    notes: "Position: behind till\nComments: for paying customers",
    source: {
      name: "Refuge Restrooms",
      url: "https://www.refugerestrooms.org/",
      dataCategory: "Bathroom",
    },
  },
];
